/*!
 * jodit-pro - PRO Version of Jodit Editor
 * Author: Chupurnov Valeriy <chupurnov@gmail.com>
 * Version: v4.6.9
 * Url: https://xdsoft.net/jodit/pro/
 * License(s): SEE LICENSE IN LICENSE.md
 */
	
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, function() {
return /******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DI: function() { return /* binding */ getAllTypes; },
/* harmony export */   PU: function() { return /* binding */ askInsertTypeDialog; },
/* harmony export */   sX: function() { return /* binding */ pasteInsertHtml; }
/* harmony export */ });
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27613);
/* harmony import */ var _core_ui_button_button_button_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10830);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



/**
 * Remove special HTML comments
 * @private
 */ function removeExtraFragments(html) {
    html = html.replace(/<meta[^>]+?>/g, '');
    const start = html.search(/<!--StartFragment-->/i);
    if (start !== -1) {
        html = html.substring(start + 20);
    }
    const end = html.search(/<!--EndFragment-->/i);
    if (end !== -1) {
        html = html.substring(0, end);
    }
    return html;
}
/**
 * @private
 */ function isDragEvent(e) {
    return Boolean(e && e.type === 'drop');
}
/**
 * One insert point for clipboard plugins
 * @private
 */ function pasteInsertHtml(e, editor, html) {
    if (editor.isInDestruct) {
        return;
    }
    if (isDragEvent(e)) {
        editor.s.insertCursorAtPoint(e.clientX, e.clientY);
    }
    const result = editor.e.fire('beforePasteInsert', html);
    if (!(0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isVoid */ .Rd)(result) && ((0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .Kg)(result) || (0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNumber */ .Et)(result) || _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isNode(result))) {
        html = result;
    }
    if ((0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .Kg)(html)) {
        html = removeExtraFragments(html);
    }
    editor.s.insertHTML(html);
}
/**
 * Return all available data types in event
 * @private
 */ function getAllTypes(dt) {
    const types = dt.types;
    let types_str = '';
    if ((0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isArray */ .cy)(types) || ({}).toString.call(types) === '[object DOMStringList]') {
        for(let i = 0; i < types.length; i += 1){
            types_str += types[i] + ';';
        }
    } else {
        types_str = (types || _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.TEXT_PLAIN).toString() + ';';
    }
    return types_str;
}
/**
 * Make command dialog
 * @private
 */ function askInsertTypeDialog(jodit, msg, title, callback, buttonList) {
    if (jodit.e.fire('beforeOpenPasteDialog', msg, title, callback, buttonList) === false) {
        return;
    }
    const dialog = jodit.confirm(`<div style="word-break: normal; white-space: normal">${jodit.i18n(msg)}</div>`, jodit.i18n(title));
    const buttons = buttonList.map(({ text, value })=>(0,_core_ui_button_button_button_js__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .$n)(jodit, {
            text,
            name: text.toLowerCase(),
            tabIndex: 0
        }).onAction(()=>{
            dialog.close();
            callback(value);
        }));
    dialog.e.one(dialog, 'afterClose', ()=>{
        if (!jodit.s.isFocused()) {
            jodit.s.focus();
        }
    });
    const cancel = (0,_core_ui_button_button_button_js__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .$n)(jodit, {
        text: 'Cancel',
        tabIndex: 0
    }).onAction(()=>{
        dialog.close();
    });
    dialog.setFooter([
        ...buttons,
        cancel
    ]);
    buttons[0].focus();
    buttons[0].state.variant = 'primary';
    jodit.e.fire('afterOpenPasteDialog', dialog, msg, title, callback, buttonList);
    return dialog;
}


/***/ }),

/***/ 159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   u: function() { return /* binding */ FileBrowserItem; }
/* harmony export */ });
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21537);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
class FileBrowserItem {
    static create(data) {
        if (data instanceof FileBrowserItem) {
            return data;
        }
        return new FileBrowserItem(data);
    }
    get path() {
        return (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.normalizePath)(this.data.source.path ? this.data.source.path + '/' : '/');
    }
    get imageURL() {
        const timestamp = this.time || new Date().getTime().toString(), { thumbIsAbsolute, source, thumb, file } = this.data, path = thumb || file;
        return thumbIsAbsolute && path ? path : (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.normalizeUrl)(source.baseurl, source.path, path || '') + '?_tmst=' + encodeURIComponent(timestamp);
    }
    get fileURL() {
        let { name } = this.data;
        const { file, fileIsAbsolute, source } = this.data;
        if (file !== undefined) {
            name = file;
        }
        return fileIsAbsolute && name ? name : (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.normalizeUrl)(source.baseurl, source.path, name || '');
    }
    get time() {
        const { changed } = this.data;
        return changed && (typeof changed === 'number' ? new Date(changed).toLocaleString() : changed) || '';
    }
    get uniqueHashKey() {
        const data = this.data;
        let key = [
            data.sourceName,
            data.name,
            data.file,
            this.time,
            data.thumb
        ].join('_');
        key = key.toLowerCase().replace(/[^0-9a-z\-.]/g, '-');
        return key;
    }
    toJSON() {
        return this.data;
    }
    constructor(data){
        this.data = data;
        // TODO Check with Object.assign
        Object.keys(data).forEach((key)=>{
            this[key] = data[key];
        });
    }
}


/***/ }),

/***/ 302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   i: function() { return /* binding */ getKey; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/indent
 */ 
/**
 * Get style rule key for current direction
 * @internal
 */ const getKey = (direction, box)=>`${_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isCell(box) ? 'padding' : 'margin'}${direction === 'rtl' ? 'Right' : 'Left'}`;


/***/ }),

/***/ 384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   L: function() { return /* binding */ sanitizeAttributes; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21537);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/**
 * @private
 */ function sanitizeAttributes(jodit, nodeElm, hadEffect) {
    if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isElement(nodeElm) && (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.sanitizeHTMLElement)(nodeElm, {
        safeJavaScriptLink: jodit.options.cleanHTML.safeJavaScriptLink,
        removeOnError: jodit.options.cleanHTML.removeOnError
    })) {
        return true;
    }
    return hadEffect;
}


/***/ }),

/***/ 445:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1280q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1536q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1536q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1152q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1152q26 0 45 19t19 45z\"/> </svg> ");


/***/ }),

/***/ 575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export enter */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2748);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_checker_is_boolean_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87612);
/* harmony import */ var _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20356);
/* harmony import */ var _helpers_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35399);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








/**
 * One of most important core plugins. It is responsible for all the browsers to have the same effect when the Enter
 * button is pressed. By default, it should insert the <p>
 */ class enter extends _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_4__/* .Plugin */ .k {
    /** @override */ afterInit(editor) {
        // use 'enter' option if no set
        const defaultTag = editor.o.enter.toLowerCase();
        const brMode = defaultTag === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.BR.toLowerCase();
        if (!editor.o.enterBlock) {
            editor.o.enterBlock = brMode ? _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.PARAGRAPH : defaultTag;
        }
        editor.registerCommand('enter', (command, value, event = {})=>this.onEnter(event));
    }
    onEnterKeyDown(event) {
        if (event.key === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_ENTER) {
            const editor = this.j;
            const beforeEnter = editor.e.fire('beforeEnter', event);
            if (beforeEnter !== undefined) {
                return beforeEnter;
            }
            if (!editor.s.isCollapsed()) {
                editor.execCommand('Delete');
            }
            editor.s.focus();
            this.onEnter(event);
            editor.e.fire('afterEnter', event);
            editor.synchronizeValues(); // fire change
            return false;
        }
    }
    onEnter(event) {
        const { jodit } = this;
        const fake = jodit.createInside.fake();
        try {
            _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeInsertNode(jodit.s.range, fake);
            (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__/* .moveCursorOutFromSpecialTags */ .Mt)(jodit, fake, [
                'a'
            ]);
            let block = (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__/* .getBlockWrapper */ .Dk)(fake, jodit);
            const isLi = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isLeaf(block);
            // if use <br> defaultTag for break line or when was entered SHIFt key or in <td> or <th> or <blockquote>
            if ((!isLi || (event === null || event === void 0 ? void 0 : event.shiftKey)) && (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__/* .checkBR */ .lN)(fake, jodit, event === null || event === void 0 ? void 0 : event.shiftKey)) {
                return false;
            }
            // wrap no wrapped element
            if (!block && !(0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__/* .hasPreviousBlock */ .tX)(fake, jodit)) {
                block = (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__/* .wrapText */ .C1)(fake, jodit);
            }
            if (!block) {
                (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__/* .insertParagraph */ .yh)(fake, jodit, isLi ? 'li' : jodit.o.enter);
                return false;
            }
            if (!(0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__/* .checkUnsplittableBox */ .bD)(fake, jodit, block)) {
                return false;
            }
            if (isLi && this.__isEmptyListLeaf(block)) {
                (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__/* .processEmptyLILeaf */ .cf)(fake, jodit, block);
                return false;
            }
            (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__/* .splitFragment */ .HS)(fake, jodit, block);
        } finally{
            fake.isConnected && jodit.s.setCursorBefore(fake);
            _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(fake);
        }
    }
    __isEmptyListLeaf(li) {
        const result = this.j.e.fire('enterIsEmptyListLeaf', li);
        return (0,_core_helpers_checker_is_boolean_js__WEBPACK_IMPORTED_MODULE_6__/* .isBoolean */ .L)(result) ? result : _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isEmpty(li);
    }
    /** @override */ beforeDestruct(editor) {
        editor.e.off('keydown.enter');
    }
}
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)(':keydown.enter')
], enter.prototype, "onEnterKeyDown", null);
_core_global_js__WEBPACK_IMPORTED_MODULE_3__/* .pluginSystem */ .fg.add('enter', enter);


/***/ }),

/***/ 580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   JW: function() { return /* binding */ extendLang; },
/* harmony export */   My: function() { return /* binding */ getContainer; },
/* harmony export */   RR: function() { return /* binding */ eventEmitter; },
/* harmony export */   VF: function() { return /* binding */ instances; },
/* harmony export */   av: function() { return /* binding */ modules; },
/* harmony export */   ef: function() { return /* binding */ getPopupViewRoot; },
/* harmony export */   fg: function() { return /* binding */ pluginSystem; },
/* harmony export */   w9: function() { return /* binding */ uniqueUid; }
/* harmony export */ });
/* harmony import */ var _helpers_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21537);
/* harmony import */ var _helpers_checker_is_jodit_object_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19306);
/* harmony import */ var _helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70799);
/* harmony import */ var _helpers_checker_is_view_object_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39955);
/* harmony import */ var _helpers_string_kebab_case_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12475);
/* harmony import */ var _helpers_utils_get_class_name_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80568);
/* harmony import */ var _plugin_plugin_system_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41876);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82758);
/* harmony import */ var _dom_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22732);
/* harmony import */ var _event_emitter_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3827);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 









const instances = {};
let counter = 1;
const uuids = new Set();
/**
 * Generate global unique uid
 */ function uniqueUid() {
    function gen() {
        counter += 10 * (Math.random() + 1);
        return Math.round(counter).toString(16);
    }
    let uid = gen();
    while(uuids.has(uid)){
        uid = gen();
    }
    uuids.add(uid);
    return uid;
}
const pluginSystem = new _plugin_plugin_system_js__WEBPACK_IMPORTED_MODULE_2__/* .PluginSystem */ .$();
const modules = {};
const extendLang = (langs)=>{
    Object.keys(langs).forEach((key)=>{
        if (_constants_js__WEBPACK_IMPORTED_MODULE_3__.lang[key]) {
            Object.assign(_constants_js__WEBPACK_IMPORTED_MODULE_3__.lang[key], langs[key]);
        } else {
            _constants_js__WEBPACK_IMPORTED_MODULE_3__.lang[key] = langs[key];
        }
    });
};
const boxes = new WeakMap();
/**
 * Create unique box(HTMLCotainer) and remove it after destroy
 */ function getContainer(jodit, classFunc, tag = 'div', createInsideEditor = false) {
    const name = (0,_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_6__/* .isString */ .K)(classFunc) ? classFunc : classFunc ? (0,_helpers_utils_get_class_name_js__WEBPACK_IMPORTED_MODULE_1__/* .getClassName */ .u)(classFunc.prototype) : 'jodit-utils';
    const data = boxes.get(jodit) || {}, key = name + tag;
    const view = (0,_helpers_checker_is_view_object_js__WEBPACK_IMPORTED_MODULE_7__/* .isViewObject */ .h)(jodit) ? jodit : jodit.j;
    let body = null;
    if (!data[key]) {
        let c = view.c;
        body = getPopupViewRoot(view.o, view.container, jodit.od.body);
        if (createInsideEditor && (0,_helpers_checker_is_jodit_object_js__WEBPACK_IMPORTED_MODULE_8__/* .isJoditObject */ .y)(jodit) && jodit.od !== jodit.ed) {
            c = jodit.createInside;
            const place = tag === 'style' ? jodit.ed.head : jodit.ed.body;
            body = (0,_helpers_checker_is_jodit_object_js__WEBPACK_IMPORTED_MODULE_8__/* .isJoditObject */ .y)(jodit) && jodit.o.shadowRoot ? jodit.o.shadowRoot : place;
        }
        const box = c.element(tag, {
            className: `jodit jodit-${(0,_helpers_string_kebab_case_js__WEBPACK_IMPORTED_MODULE_9__/* .kebabCase */ .k)(name)}-container jodit-box`
        });
        box.classList.add(`jodit_theme_${view.o.theme || 'default'}`);
        body.appendChild(box);
        data[key] = box;
        jodit.hookStatus('beforeDestruct', ()=>{
            view.events.off(box);
            _dom_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Dom */ .J.safeRemove(box);
            delete data[key];
            if (Object.keys(data).length) {
                boxes.delete(jodit);
            }
        });
        boxes.set(jodit, data);
        view.events.fire('getContainer', box);
    }
    data[key].classList.remove('jodit_theme_default', 'jodit_theme_dark');
    data[key].classList.add(`jodit_theme_${view.o.theme || 'default'}`);
    return data[key];
}
/**
 * Get root element for view
 * @internal
 */ function getPopupViewRoot(o, container, defaultRoot) {
    var _a, _b, _c;
    return (_c = (_b = (_a = o.popupRoot) !== null && _a !== void 0 ? _a : o.shadowRoot) !== null && _b !== void 0 ? _b : _dom_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Dom */ .J.closest(container, (parentElement)=>_dom_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Dom */ .J.isHTMLElement(parentElement) && (_dom_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Dom */ .J.isTag(parentElement, 'dialog') || [
            'fixed',
            'absolute'
        ].includes((0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.css)(parentElement, 'position'))), defaultRoot)) !== null && _c !== void 0 ? _c : defaultRoot;
}
/**
 * Global event emitter
 */ const eventEmitter = new _event_emitter_index_js__WEBPACK_IMPORTED_MODULE_5__/* .EventEmitter */ .bk();


/***/ }),

/***/ 638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Fc: function() { return /* reexport safe */ _alert_js__WEBPACK_IMPORTED_MODULE_0__.F; },
/* harmony export */   XG: function() { return /* reexport safe */ _prompt_js__WEBPACK_IMPORTED_MODULE_3__.X; },
/* harmony export */   lG: function() { return /* reexport safe */ _dialog_js__WEBPACK_IMPORTED_MODULE_2__.l; },
/* harmony export */   pT: function() { return /* reexport safe */ _confirm_js__WEBPACK_IMPORTED_MODULE_1__.p; }
/* harmony export */ });
/* harmony import */ var _alert_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71568);
/* harmony import */ var _confirm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26866);
/* harmony import */ var _dialog_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78584);
/* harmony import */ var _prompt_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36806);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * [[include:modules/dialog/README.md]]
 * @packageDocumentation
 * @module modules/dialog
 */ 





/***/ }),

/***/ 757:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/media
 */ 
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.mediaFakeTag = 'jodit-media';
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.mediaInFakeBlock = true;
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.mediaBlocks = [
    'video',
    'audio'
];


/***/ }),

/***/ 767:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50911);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66288);
/* harmony import */ var _cases_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47686);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






class tab extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Plugin */ .k {
    afterInit(jodit) {}
    __onTab(event) {
        if (event.key === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_TAB && this.__onShift(event.shiftKey)) {
            return false;
        }
    }
    __onCommand(command) {
        if ((command === 'indent' || command === 'outdent') && this.__onShift(command === 'outdent')) {
            return false;
        }
    }
    __onShift(shift) {
        const res = (0,_cases_index_js__WEBPACK_IMPORTED_MODULE_5__/* .onTabInsideLi */ .O)(this.j, shift);
        if (res) {
            this.j.e.fire('afterTab', shift);
        }
        return res;
    }
    beforeDestruct(jodit) {}
}
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)(':keydown.tab')
], tab.prototype, "__onTab", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)(':beforeCommand.tab')
], tab.prototype, "__onCommand", null);
_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .pluginSystem */ .fg.add('tab', tab);


/***/ }),

/***/ 820:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M747 1521q74 32 140 32 376 0 376-335 0-114-41-180-27-44-61.5-74t-67.5-46.5-80.5-25-84-10.5-94.5-2q-73 0-101 10 0 53-.5 159t-.5 158q0 8-1 67.5t-.5 96.5 4.5 83.5 12 66.5zm-14-746q42 7 109 7 82 0 143-13t110-44.5 74.5-89.5 25.5-142q0-70-29-122.5t-79-82-108-43.5-124-14q-50 0-130 13 0 50 4 151t4 152q0 27-.5 80t-.5 79q0 46 1 69zm-541 889l2-94q15-4 85-16t106-27q7-12 12.5-27t8.5-33.5 5.5-32.5 3-37.5.5-34v-65.5q0-982-22-1025-4-8-22-14.5t-44.5-11-49.5-7-48.5-4.5-30.5-3l-4-83q98-2 340-11.5t373-9.5q23 0 68.5.5t67.5.5q70 0 136.5 13t128.5 42 108 71 74 104.5 28 137.5q0 52-16.5 95.5t-39 72-64.5 57.5-73 45-84 40q154 35 256.5 134t102.5 248q0 100-35 179.5t-93.5 130.5-138 85.5-163.5 48.5-176 14q-44 0-132-3t-132-3q-106 0-307 11t-231 12z\"/> </svg> ");


/***/ }),

/***/ 1115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    'Speech Recognize': 'Puheentunnistus',
    newline: 'uusi rivi',
    delete: 'poistaa',
    space: 'tilaa',
    Sound: 'Ääni',
    'Interim Results': 'Välitulokset'
});


/***/ }),

/***/ 1172:
/***/ (function(__unused_webpack_module, __webpack_exports__) {


/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'copy-format': '复制格式'
});


/***/ }),

/***/ 1255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export dragAndDropElement */
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22732);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21537);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50911);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44586);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var DragState;
(function(DragState) {
    DragState[DragState["IDLE"] = 0] = "IDLE";
    DragState[DragState["WAIT_DRAGGING"] = 1] = "WAIT_DRAGGING";
    DragState[DragState["DRAGGING"] = 2] = "DRAGGING";
})(DragState || (DragState = {}));
/**
 * Process drag and drop image or another element inside the editor
 */ class dragAndDropElement extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Plugin */ .k {
    /** @override */ afterInit() {
        this.dragList = this.j.o.draggableTags ? (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.splitArray)(this.j.o.draggableTags).filter(Boolean).map((item)=>item.toLowerCase()) : [];
        if (!this.dragList.length) {
            return;
        }
        this.j.e.on('mousedown dragstart', this.onDragStart);
    }
    /**
     * Drag start handler
     */ onDragStart(event) {
        if (event.type === 'dragstart' && this.draggable) {
            return false;
        }
        if (this.state > DragState.IDLE) {
            return;
        }
        const target = event.target;
        if (!this.dragList.length || !target) {
            return;
        }
        const matched = (node)=>Boolean(node && this.dragList.includes(node.nodeName.toLowerCase()));
        let lastTarget = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.furthest(target, matched, this.j.editor) || (matched(target) ? target : null);
        if (!lastTarget) {
            return;
        }
        if (_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(lastTarget.parentElement, 'a') && lastTarget.parentElement.firstChild === lastTarget && lastTarget.parentElement.lastChild === lastTarget) {
            lastTarget = lastTarget.parentElement;
        }
        this.startX = event.clientX;
        this.startY = event.clientY;
        this.isCopyMode = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.ctrlKey)(event); // we can move only element from editor
        this.draggable = lastTarget.cloneNode(true);
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.dataBind)(this.draggable, 'target', lastTarget);
        this.state = DragState.WAIT_DRAGGING;
        this.addDragListeners();
    }
    /**
     * Mouse move handler handler
     */ onDrag(event) {
        var _a, _b;
        if (!this.draggable || this.state === DragState.IDLE) {
            return;
        }
        const x = event.clientX, y = event.clientY;
        if (this.state === DragState.WAIT_DRAGGING && Math.sqrt(Math.pow(x - this.startX, 2) + Math.pow(y - this.startY, 2)) < this.diffStep) {
            return;
        }
        if (this.state === DragState.WAIT_DRAGGING) {
            this.j.lock('drag-and-drop-element');
            this.state = DragState.DRAGGING;
        }
        this.j.e.fire('hidePopup hideResizer');
        if (!this.draggable.parentNode) {
            const target = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.dataBind)(this.draggable, 'target');
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(this.draggable, {
                zIndex: 10000000000000,
                pointerEvents: 'none',
                pointer: 'drag',
                position: 'fixed',
                opacity: 0.7,
                display: 'inline-block',
                left: event.clientX,
                top: event.clientY,
                width: (_a = target === null || target === void 0 ? void 0 : target.offsetWidth) !== null && _a !== void 0 ? _a : 100,
                height: (_b = target === null || target === void 0 ? void 0 : target.offsetHeight) !== null && _b !== void 0 ? _b : 100
            });
            (0,_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .getContainer */ .My)(this.j, dragAndDropElement).appendChild(this.draggable);
        }
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(this.draggable, {
            left: event.clientX,
            top: event.clientY
        });
        this.j.s.insertCursorAtPoint(event.clientX, event.clientY);
    }
    /**
     * Mouseup handler in any place
     */ onDragEnd() {
        if (this.isInDestruct) {
            return;
        }
        this.removeDragListeners();
        this.j.unlock();
        this.state = DragState.IDLE;
        if (this.draggable) {
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(this.draggable);
            this.draggable = null;
        }
    }
    /**
     * Mouseup handler inside editor
     */ onDrop() {
        if (!this.draggable || this.state < DragState.DRAGGING) {
            this.onDragEnd();
            return;
        }
        let fragment = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.dataBind)(this.draggable, 'target');
        this.onDragEnd();
        if (this.isCopyMode) {
            fragment = fragment.cloneNode(true);
        }
        const { parentElement } = fragment;
        this.j.s.insertNode(fragment, true, false);
        if (parentElement && _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isEmpty(parentElement) && !_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isCell(parentElement)) {
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(parentElement);
        }
        if (_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(fragment, 'img') && this.j.e) {
            this.j.e.fire('afterInsertImage', fragment);
        }
        this.j.e.fire('synchro');
    }
    /**
     * Add global event listener after drag start
     */ addDragListeners() {
        this.j.e.on(this.j.editor, 'mousemove', this.onDrag).on('mouseup', this.onDrop).on([
            this.j.ew,
            this.ow
        ], 'mouseup', this.onDragEnd);
    }
    /**
     * Remove global event listener after drag start
     */ removeDragListeners() {
        this.j.e.off(this.j.editor, 'mousemove', this.onDrag).off('mouseup', this.onDrop).off([
            this.j.ew,
            this.ow
        ], 'mouseup', this.onDragEnd);
    }
    /** @override */ beforeDestruct() {
        this.onDragEnd();
        this.j.e.off('mousedown dragstart', this.onDragStart);
        this.removeDragListeners();
    }
    constructor(){
        super(...arguments);
        this.dragList = [];
        this.draggable = null;
        this.isCopyMode = false;
        /**
         * Shift in pixels after which we consider that the transfer of the element has begun
         */ this.diffStep = 10;
        this.startX = 0;
        this.startY = 0;
        this.state = DragState.IDLE;
    }
}
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], dragAndDropElement.prototype, "onDragStart", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.throttle)((ctx)=>ctx.defaultTimeout / 10)
], dragAndDropElement.prototype, "onDrag", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], dragAndDropElement.prototype, "onDragEnd", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], dragAndDropElement.prototype, "onDrop", null);
_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .pluginSystem */ .fg.add('dragAndDropElement', dragAndDropElement);


/***/ }),

/***/ 1322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    Spellcheck: 'Stavekontroll'
});


/***/ }),

/***/ 1596:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var jodit_esm_plugins_all__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25187);
/* harmony import */ var jodit_pro_plugins_paste_from_word_paste_from_word__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7087);
/* harmony import */ var jodit_pro_plugins_license_license__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12275);
/* harmony import */ var jodit_pro_plugins_autocomplete_autocomplete__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89377);
/* harmony import */ var jodit_esm_plugins_speech_recognize_speech_recognize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3115);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/esm/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/esm/pro/
 */







/***/ }),

/***/ 1808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   N: function() { return /* binding */ UIMessages; }
/* harmony export */ });
/* harmony import */ var _core_decorators_component_component_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87325);
/* harmony import */ var _core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41180);
/* harmony import */ var _core_ui_group_group_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62405);
/* harmony import */ var _message_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68389);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




/**
 * Plugin display pop-up messages in the lower right corner of the editor
 */ let UIMessages = class UIMessages extends _core_ui_group_group_js__WEBPACK_IMPORTED_MODULE_0__/* .UIGroup */ .U {
    className() {
        return 'UIMessages';
    }
    /**
     * Show popup info message in the lower right corner of the container
     * ```js
     * const jodit = Jodit.make('#editor');
     * jodit.info('Hello world', 3000);
     * ```
     */ info(text, timeout) {
        this.__message(text, 'info', timeout);
    }
    /**
     * Show popup success message in the lower right corner of the container
     * ```js
     * const jodit = Jodit.make('#editor');
     * jodit.success('Hello world', 3000);
     * ```
     */ success(text, timeout) {
        this.__message(text, 'success', timeout);
    }
    /**
     * Show popup error message in the lower right corner of the container
     * ```js
     * const jodit = Jodit.make('#editor');
     * jodit.error('Hello world', 3000);
     * ```
     */ error(text, timeout) {
        this.__message(text, 'error', timeout);
    }
    /**
     * Show popup message in the lower right corner of the container
     * ```js
     * const jodit = Jodit.make('#editor');
     * jodit.message('Hello world', 'info', 3000);
     * ```
     */ message(text, variant, timeout) {
        this.__message(text, variant, timeout);
    }
    __message(text, variant = 'info', timeout) {
        const key = text + ':' + variant;
        if (this.__messages.has(key)) {
            this.async.updateTimeout(key, timeout || this.options.defaultTimeout);
            return;
        }
        if (!this.__box) {
            throw new Error('Container is not defined: ' + key);
        }
        this.__box.appendChild(this.container);
        const msg = new _message_js__WEBPACK_IMPORTED_MODULE_1__/* .UIMessage */ .C(this.j, {
            text,
            variant
        });
        this.append(msg);
        this.__calcOffsets();
        this.__messages.add(key);
        const remove = this.__getRemoveCallback(msg, key);
        this.j.e.on(msg.container, 'pointerdown', remove);
        this.async.setTimeout(remove, {
            label: key,
            timeout: timeout || this.options.defaultTimeout
        });
    }
    __getRemoveCallback(msg, key) {
        const remove = (e)=>{
            e && e.preventDefault();
            if (msg.isInDestruct) {
                return;
            }
            this.async.clearTimeout(key);
            this.j.e.off(msg.container, 'pointerdown', remove);
            this.__messages.delete(key);
            msg.setMod('active', false);
            this.async.setTimeout(()=>{
                this.remove(msg);
                msg.destruct();
                this.__calcOffsets();
            }, 300);
        };
        return remove;
    }
    __calcOffsets() {
        let height = 5;
        this.elements.forEach((elm)=>{
            (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_2__/* .css */ .A)(elm.container, 'bottom', height + 'px');
            height += elm.container.offsetHeight + this.options.defaultOffset;
        });
    }
    constructor(jodit, __box, options = {
        defaultTimeout: 3000,
        defaultOffset: 5
    }){
        super(jodit);
        this.__box = __box;
        this.options = options;
        this.__messages = new Set();
    }
};
UIMessages = __decorate([
    _core_decorators_component_component_js__WEBPACK_IMPORTED_MODULE_3__/* .component */ .s
], UIMessages);



/***/ }),

/***/ 1830:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'Type something': 'Start writing...',
    pencil: 'Edit',
    Quadrate: 'Square'
});


/***/ }),

/***/ 1879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    Spellcheck: 'Spellingcontrole'
});


/***/ }),

/***/ 2169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export fullsize */
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_checker_is_jodit_object_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19306);
/* harmony import */ var _core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41180);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99823);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



const fullsizeStack = new Set();
/**
 * Process `toggleFullSize` event, and behavior - set/unset fullsize mode
 */ function fullsize(editor) {
    editor.registerButton({
        name: 'fullsize'
    });
    let isEnabled = false, oldHeight = 0, oldWidth = 0, wasToggled = false;
    const resize = ()=>{
        const { container, events } = editor;
        if (!events) {
            return;
        }
        if (isEnabled) {
            oldHeight = (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_2__/* .css */ .A)(container, 'height', true);
            oldWidth = (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_2__/* .css */ .A)(container, 'width', true);
            (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_2__/* .css */ .A)(container, {
                height: editor.ow.innerHeight,
                width: editor.ow.innerWidth
            });
            wasToggled = true;
        } else if (wasToggled) {
            (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_2__/* .css */ .A)(container, {
                height: oldHeight || 'auto',
                width: oldWidth || 'auto'
            });
        }
    }, /**
     * Change editor's state between FullSize and normal
     */ toggle = (enable)=>{
        var _a;
        const { container, events } = editor;
        if (!container) {
            return;
        }
        if (enable === undefined) {
            enable = !container.classList.contains('jodit_fullsize');
        }
        editor.setMod('fullsize', enable);
        editor.o.fullsize = enable;
        isEnabled = enable;
        container.classList.toggle('jodit_fullsize', enable);
        if (editor.toolbar) {
            (0,_core_helpers_checker_is_jodit_object_js__WEBPACK_IMPORTED_MODULE_3__/* .isJoditObject */ .y)(editor) && ((_a = editor.toolbarContainer) === null || _a === void 0 ? void 0 : _a.appendChild(editor.toolbar.container));
            (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_2__/* .css */ .A)(editor.toolbar.container, 'width', 'auto');
        }
        enable ? fullsizeStack.add(container) : fullsizeStack.delete(container);
        const shouldToggleGlobalFullsize = editor.o.globalFullSize && (fullsizeStack.size === 1 && enable || fullsizeStack.size === 0 && !enable);
        if (shouldToggleGlobalFullsize) {
            let node = container.parentNode;
            while(node && node.nodeType !== Node.DOCUMENT_NODE && node.nodeType !== Node.DOCUMENT_FRAGMENT_NODE){
                node.classList.toggle('jodit_fullsize-box_true', enable);
                node = node.parentNode;
            }
            resize();
        }
        events.fire('afterResize');
    };
    if (editor.o.globalFullSize) {
        editor.e.on(editor.ow, 'resize', resize);
    }
    editor.e.on('afterInit afterOpen', ()=>{
        var _a;
        editor.toggleFullSize((_a = editor === null || editor === void 0 ? void 0 : editor.options) === null || _a === void 0 ? void 0 : _a.fullsize);
    }).on('toggleFullSize', toggle).on('beforeDestruct', ()=>{
        isEnabled && toggle(false);
    }).on('beforeDestruct', ()=>{
        editor.events && editor.e.off(editor.ow, 'resize', resize);
    });
}
_core_global_js__WEBPACK_IMPORTED_MODULE_0__/* .pluginSystem */ .fg.add('fullsize', fullsize);


/***/ }),

/***/ 2303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   x: function() { return /* binding */ Jodit; }
/* harmony export */ });
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21537);
/* harmony import */ var _core_request_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41601);
/* harmony import */ var _core_traits_dlgs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70231);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6441);
/* harmony import */ var _modules_index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41409);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Jodit_1;









const __defaultStyleDisplayKey = 'data-jodit-default-style-display';
const __defaultClassesKey = 'data-jodit-default-classes';
let Jodit = Jodit_1 = class Jodit extends _modules_index_js__WEBPACK_IMPORTED_MODULE_7__.ViewWithToolbar {
    /** @override */ className() {
        return 'Jodit';
    }
    /**
     * Return promise for ready actions
     * @example
     * ```js
     * const jodit = Jodit.make('#editor');
     * await jodit.waitForReady();
     * jodit.e.fire('someAsyncLoadedPluginEvent', (test) => {
     *   alert(test);
     * });
     * ```
     */ waitForReady() {
        if (this.isReady) {
            return Promise.resolve(this);
        }
        return this.async.promise((resolve)=>{
            this.hookStatus('ready', ()=>resolve(this));
        });
    }
    /**
     * @deprecated I don't know why I wrote itp
     */ static get ready() {
        return new Promise((resolve)=>{
            _core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .eventEmitter */ .RR.on('joditready', resolve);
        });
    }
    /**
     * Plain text editor's value
     */ get text() {
        if (this.editor) {
            return this.editor.innerText || '';
        }
        const div = this.createInside.div();
        div.innerHTML = this.getElementValue();
        return div.innerText || '';
    }
    /**
     * Return a default timeout period in milliseconds for some debounce or throttle functions.
     * By default, `{history.timeout}` options
     */ get defaultTimeout() {
        return (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isNumber)(this.o.defaultTimeout) ? this.o.defaultTimeout : _config_js__WEBPACK_IMPORTED_MODULE_6__/* .Config */ .T.defaultOptions.defaultTimeout;
    }
    /**
     * Method wrap usual object in Object helper for prevent deep object merging in options*
     * ```js
     * const editor = Jodit.make('#editor', {
     * 	controls: {
     * 		fontsize: {
     * 			list: Jodit.atom([8, 9, 10])
     * 		}
     * 	}
     * });
     * ```
     * In this case, the array [8, 9, 10] will not be combined with other arrays, but will replace them
     */ static atom(object) {
        return (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.markAsAtomic)(object);
    }
    /**
     * Factory for creating Jodit instance
     */ static make(element, options) {
        return new this(element, options);
    }
    /**
     * Checks if the element has already been initialized when for Jodit
     */ static isJoditAssigned(element) {
        return element && (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isJoditObject)(element.component) && !element.component.isInDestruct;
    }
    /**
     * Default settings
     */ static get defaultOptions() {
        return _config_js__WEBPACK_IMPORTED_MODULE_6__/* .Config */ .T.defaultOptions;
    }
    get createInside() {
        return new _modules_index_js__WEBPACK_IMPORTED_MODULE_7__.Create(()=>this.ed, this.o.createAttributes);
    }
    __setPlaceField(field, value) {
        if (!this.currentPlace) {
            this.currentPlace = {};
            this.places = [
                this.currentPlace
            ];
        }
        this.currentPlace[field] = value;
    }
    /**
     * element It contains source element
     */ get element() {
        return this.currentPlace.element;
    }
    /**
     * editor It contains the root element editor
     */ get editor() {
        return this.currentPlace.editor;
    }
    set editor(editor) {
        this.__setPlaceField('editor', editor);
    }
    /**
     * Container for all staff
     */ get container() {
        return this.currentPlace.container;
    }
    set container(container) {
        this.__setPlaceField('container', container);
    }
    /**
     * workplace It contains source and wysiwyg editors
     */ get workplace() {
        return this.currentPlace.workplace;
    }
    get message() {
        return this.getMessageModule(this.workplace);
    }
    /**
     * Statusbar module
     */ get statusbar() {
        return this.currentPlace.statusbar;
    }
    /**
     * iframe Iframe for iframe mode
     */ get iframe() {
        return this.currentPlace.iframe;
    }
    set iframe(iframe) {
        this.__setPlaceField('iframe', iframe);
    }
    get history() {
        return this.currentPlace.history;
    }
    /**
     * In iframe mode editor's window can be different by owner
     */ get editorWindow() {
        return this.currentPlace.editorWindow;
    }
    set editorWindow(win) {
        this.__setPlaceField('editorWindow', win);
    }
    /**
     * Alias for this.ew
     */ get ew() {
        return this.editorWindow;
    }
    /**
     * In iframe mode editor's window can be different by owner
     */ get editorDocument() {
        return this.currentPlace.editorWindow.document;
    }
    /**
     * Alias for this.ew
     */ get ed() {
        return this.editorDocument;
    }
    /**
     * options All Jodit settings default + second arguments of constructor
     */ get options() {
        return this.currentPlace.options;
    }
    set options(opt) {
        this.__setPlaceField('options', opt);
    }
    /**
     * Alias for this.selection
     */ get s() {
        return this.selection;
    }
    get uploader() {
        return this.getInstance('Uploader', this.o.uploader);
    }
    get filebrowser() {
        const jodit = this;
        const options = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.ConfigProto)({
            defaultTimeout: jodit.defaultTimeout,
            uploader: jodit.o.uploader,
            language: jodit.o.language,
            license: jodit.o.license,
            theme: jodit.o.theme,
            shadowRoot: jodit.o.shadowRoot,
            defaultCallback (data) {
                if (data.files && data.files.length) {
                    data.files.forEach((file, i)=>{
                        const url = data.baseurl + file;
                        const isImage = data.isImages ? data.isImages[i] : false;
                        if (isImage) {
                            jodit.s.insertImage(url, null, jodit.o.imageDefaultWidth);
                        } else {
                            jodit.s.insertNode(jodit.createInside.fromHTML(`<a href='${url}' title='${url}'>${url}</a>`));
                        }
                    });
                }
            }
        }, this.o.filebrowser);
        return jodit.getInstance('FileBrowser', options);
    }
    /**
     * Editor's mode
     */ get mode() {
        return this.__mode;
    }
    set mode(mode) {
        this.setMode(mode);
    }
    /**
     * Return real HTML value from WYSIWYG editor.
     * @internal
     */ getNativeEditorValue() {
        const value = this.e.fire('beforeGetNativeEditorValue');
        if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isString)(value)) {
            return value;
        }
        if (this.editor) {
            return this.editor.innerHTML;
        }
        return this.getElementValue();
    }
    /**
     * Set value to native editor
     */ setNativeEditorValue(value) {
        const data = {
            value
        };
        if (this.e.fire('beforeSetNativeEditorValue', data)) {
            return;
        }
        if (this.editor) {
            this.editor.innerHTML = data.value;
        }
    }
    /**
     * HTML value
     */ get value() {
        return this.getEditorValue();
    }
    set value(html) {
        this.setEditorValue(html);
        // @ts-ignore Internal method
        this.history.__processChanges();
    }
    synchronizeValues() {
        this.__imdSynchronizeValues();
    }
    /**
     * This is an internal method, do not use it in your applications.
     * @private
     * @internal
     */ __imdSynchronizeValues() {
        this.setEditorValue();
    }
    /**
     * Return editor value
     */ getEditorValue(removeSelectionMarkers = true, consumer) {
        /**
         * Triggered before getEditorValue executed.
         * If returned not undefined, getEditorValue will return this value
         * @example
         * ```javascript
         * var editor = Jodit.make("#redactor");
         * editor.e.on('beforeGetValueFromEditor', function () {
         *     return editor.editor.innerHTML.replace(/a/g, 'b');
         * });
         * ```
         */ let value;
        value = this.e.fire('beforeGetValueFromEditor', consumer);
        if (value !== undefined) {
            return value;
        }
        value = this.getNativeEditorValue().replace(_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE_REG_EXP(), '');
        if (removeSelectionMarkers) {
            value = value.replace(/<span[^>]+id="jodit-selection_marker_[^>]+><\/span>/g, '');
        }
        if (value === '<br>') {
            value = '';
        }
        /**
         * Triggered after getEditorValue got value from wysiwyg.
         * It can change new_value.value
         *
         * @example
         * ```javascript
         * var editor = Jodit.make("#redactor");
         * editor.e.on('afterGetValueFromEditor', function (new_value) {
         *     new_value.value = new_value.value.replace('a', 'b');
         * });
         * ```
         */ const new_value = {
            value
        };
        this.e.fire('afterGetValueFromEditor', new_value, consumer);
        return new_value.value;
    }
    /**
     * Set editor html value and if set sync fill source element value
     * When method was called without arguments - it is a simple way to synchronize editor to element
     */ setEditorValue(value) {
        /**
         * Triggered before getEditorValue set value to wysiwyg.
         * @example
         * ```javascript
         * var editor = Jodit.make("#redactor");
         * editor.e.on('beforeSetValueToEditor', function (old_value) {
         *     return old_value.value.replace('a', 'b');
         * });
         * editor.e.on('beforeSetValueToEditor', function () {
         *     return false; // disable setEditorValue method
         * });
         * ```
         */ const newValue = this.e.fire('beforeSetValueToEditor', value);
        if (newValue === false) {
            return;
        }
        if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isString)(newValue)) {
            value = newValue;
        }
        if (!this.editor) {
            if (value !== undefined) {
                this.__setElementValue(value);
            }
            return; // try change value before init or after destruct
        }
        if (!(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isString)(value) && !(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isVoid)(value)) {
            throw (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.error)('value must be string');
        }
        if (!(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isVoid)(value) && this.getNativeEditorValue() !== value) {
            this.setNativeEditorValue(value);
        }
        this.e.fire('postProcessSetEditorValue');
        const old_value = this.getElementValue(), new_value = this.getEditorValue();
        if (!this.__isSilentChange && old_value !== new_value && this.__callChangeCount < _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.SAFE_COUNT_CHANGE_CALL) {
            this.__setElementValue(new_value);
            this.__callChangeCount += 1;
            if (!_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD && this.__callChangeCount > 4) {
                console.warn('Too many recursive changes', new_value, old_value);
            }
            try {
                // @ts-ignore Internal method
                this.history.__upTick();
                this.e.fire('change', new_value, old_value);
                this.e.fire(this.history, 'change', new_value, old_value);
            } finally{
                this.__callChangeCount = 0;
            }
        }
    }
    /**
     * If some plugin changes the DOM directly, then you need to update the content of the original element
     */ updateElementValue() {
        this.__setElementValue(this.getEditorValue());
    }
    /**
     * Return source element value
     */ getElementValue() {
        return this.element.value !== undefined ? this.element.value : this.element.innerHTML;
    }
    __setElementValue(value) {
        if (!(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isString)(value)) {
            throw (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.error)('value must be string');
        }
        if (this.element !== this.container && value !== this.getElementValue()) {
            const data = {
                value
            };
            const res = this.e.fire('beforeSetElementValue', data);
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.callPromise)(res, ()=>{
                if (this.element.value !== undefined) {
                    this.element.value = data.value;
                } else {
                    this.element.innerHTML = data.value;
                }
                this.e.fire('afterSetElementValue', data);
            });
        }
    }
    /**
     * Register custom handler for command
     *
     * @example
     * ```javascript
     * var jodit = Jodit.make('#editor);
     *
     * jodit.setEditorValue('test test test');
     *
     * jodit.registerCommand('replaceString', function (command, needle, replace) {
     *      var value = this.getEditorValue();
     *      this.setEditorValue(value.replace(needle, replace));
     *      return false; // stop execute native command
     * });
     *
     * jodit.execCommand('replaceString', 'test', 'stop');
     *
     * console.log(jodit.value); // stop test
     *
     * // and you can add hotkeys for command
     * jodit.registerCommand('replaceString', {
     *    hotkeys: 'ctrl+r',
     *    exec: function (command, needle, replace) {
     *     var value = this.getEditorValue();
     *     this.setEditorValue(value.replace(needle, replace));
     *    }
     * });
     *
     * ```
     */ registerCommand(commandNameOriginal, command, options) {
        const commandName = commandNameOriginal.toLowerCase();
        let commands = this.commands.get(commandName);
        if (commands === undefined) {
            commands = [];
            this.commands.set(commandName, commands);
        }
        commands.push(command);
        if (!(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isFunction)(command)) {
            const hotkeys = this.o.commandToHotkeys[commandName] || this.o.commandToHotkeys[commandNameOriginal] || command.hotkeys;
            if (hotkeys) {
                this.registerHotkeyToCommand(hotkeys, commandName, options === null || options === void 0 ? void 0 : options.stopPropagation);
            }
        }
        return this;
    }
    /**
     * Register hotkey for command
     */ registerHotkeyToCommand(hotkeys, commandName, shouldStop = true) {
        const shortcuts = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.asArray)(hotkeys).map(_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.normalizeKeyAliases).map((hotkey)=>hotkey + '.hotkey').join(' ');
        this.e.off(shortcuts).on(shortcuts, (type, stop)=>{
            if (stop) {
                stop.shouldStop = shouldStop !== null && shouldStop !== void 0 ? shouldStop : true;
            }
            return this.execCommand(commandName); // because need `beforeCommand`
        });
    }
    /**
     * Execute command editor
     *
     * @param command - command. It supports all the
     * @see https://developer.mozilla.org/ru/docs/Web/API/Document/execCommand#commands and a number of its own
     * for example applyStyleProperty. Comand fontSize receives the second parameter px,
     * formatBlock and can take several options
     * @example
     * ```javascript
     * this.execCommand('fontSize', 12); // sets the size of 12 px
     * this.execCommand('underline');
     * this.execCommand('formatBlock', 'p'); // will be inserted paragraph
     * ```
     */ execCommand(command, showUI, value, ...args) {
        if (!this.s.isFocused()) {
            this.s.focus();
        }
        if (this.o.readonly && !this.o.allowCommandsInReadOnly.includes(command)) {
            return;
        }
        let result;
        command = command.toLowerCase();
        /**
         * Called before any command
         * @param command - Command name in lowercase
         * @param second - The second parameter for the command
         * @param third - The third option is for the team
         * @example
         * ```javascript
         * parent.e.on('beforeCommand', function (command) {
         *  if (command === 'justifyCenter') {
         *      var p = parent.c.element('p')
         *      parent.s.insertNode(p)
         *      parent.s.setCursorIn(p);
         *      p.style.textAlign = 'justyfy';
         *      return false; // break executes native command
         *  }
         * })
         * ```
         */ result = this.e.fire(`beforeCommand${(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.ucfirst)(command)}`, showUI, value, ...args);
        if (result !== false) {
            result = this.e.fire('beforeCommand', command, showUI, value, ...args);
        }
        if (result !== false) {
            result = this.__execCustomCommands(command, showUI, value, ...args);
        }
        if (result !== false) {
            this.s.focus();
            try {
                result = this.nativeExecCommand(command, showUI, value);
            } catch (e) {
                if (!_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD) {
                    throw e;
                }
            }
        }
        /**
         * It called after any command
         * @param command - name command
         * @param second - The second parameter for the command
         * @param third - The third option is for the team
         */ this.e.fire('afterCommand', command, showUI, value);
        this.__imdSynchronizeValues(); // synchrony
        return result;
    }
    /**
     * Exec native command
     */ nativeExecCommand(command, showUI, value) {
        this.__isSilentChange = true;
        try {
            return this.ed.execCommand(command, showUI, value);
        } finally{
            this.__isSilentChange = false;
        }
    }
    __execCustomCommands(commandName, second, third, ...args) {
        commandName = commandName.toLowerCase();
        const commands = this.commands.get(commandName);
        if (commands !== undefined) {
            let result;
            commands.forEach((command)=>{
                let callback;
                if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isFunction)(command)) {
                    callback = command;
                } else {
                    callback = command.exec;
                }
                const resultCurrent = callback.call(this, commandName, second, third, ...args);
                if (resultCurrent !== undefined) {
                    result = resultCurrent;
                }
            });
            return result;
        }
    }
    /**
     * Disable selecting
     */ lock(name = 'any') {
        if (super.lock(name)) {
            this.__selectionLocked = this.s.save();
            this.s.clear();
            this.editor.classList.add('jodit_lock');
            this.e.fire('lock', true);
            return true;
        }
        return false;
    }
    /**
     * Enable selecting
     */ unlock() {
        if (super.unlock()) {
            this.editor.classList.remove('jodit_lock');
            if (this.__selectionLocked) {
                this.s.restore();
            }
            this.e.fire('lock', false);
            return true;
        }
        return false;
    }
    /**
     * Return current editor mode: Jodit.MODE_WYSIWYG, Jodit.MODE_SOURCE or Jodit.MODE_SPLIT
     */ getMode() {
        return this.mode;
    }
    isEditorMode() {
        return this.getRealMode() === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_WYSIWYG;
    }
    /**
     * Return current real work mode. When editor in MODE_SOURCE or MODE_WYSIWYG it will
     * return them, but then editor in MODE_SPLIT it will return MODE_SOURCE if
     * Textarea(CodeMirror) focused or MODE_WYSIWYG otherwise
     *
     * @example
     * ```javascript
     * var editor = Jodit.make('#editor');
     * console.log(editor.getRealMode());
     * ```
     */ getRealMode() {
        if (this.getMode() !== _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_SPLIT) {
            return this.getMode();
        }
        const active = this.od.activeElement;
        if (active && (active === this.iframe || _modules_index_js__WEBPACK_IMPORTED_MODULE_7__.Dom.isOrContains(this.editor, active) || _modules_index_js__WEBPACK_IMPORTED_MODULE_7__.Dom.isOrContains(this.toolbar.container, active))) {
            return _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_WYSIWYG;
        }
        return _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_SOURCE;
    }
    /**
     * Set current mode
     */ setMode(mode) {
        const oldMode = this.getMode();
        const data = {
            mode: parseInt(mode.toString(), 10)
        }, modeClasses = [
            'jodit-wysiwyg_mode',
            'jodit-source__mode',
            'jodit_split_mode'
        ];
        /**
         * Triggered before setMode executed. If returned false method stopped
         * @param data - PlainObject `{mode: {string}}` In handler you can change data.mode
         * @example
         * ```javascript
         * var editor = Jodit.make("#redactor");
         * editor.e.on('beforeSetMode', function (data) {
         *     data.mode = Jodit.MODE_SOURCE; // not respond to the mode change. Always make the source code mode
         * });
         * ```
         */ if (this.e.fire('beforeSetMode', data) === false) {
            return;
        }
        this.__mode = [
            _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_SOURCE,
            _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_WYSIWYG,
            _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_SPLIT
        ].includes(data.mode) ? data.mode : _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_WYSIWYG;
        if (this.o.saveModeInStorage) {
            this.storage.set('jodit_default_mode', this.mode);
        }
        modeClasses.forEach((className)=>{
            this.container.classList.remove(className);
        });
        this.container.classList.add(modeClasses[this.mode - 1]);
        /**
         * Triggered after setMode executed
         * @example
         * ```javascript
         * var editor = Jodit.make("#redactor");
         * editor.e.on('afterSetMode', function () {
         *     editor.setEditorValue(''); // clear editor's value after change mode
         * });
         * ```
         */ if (oldMode !== this.getMode()) {
            this.e.fire('afterSetMode');
        }
    }
    /**
     * Toggle editor mode WYSIWYG to TEXTAREA(CodeMirror) to SPLIT(WYSIWYG and TEXTAREA) to again WYSIWYG
     *
     * @example
     * ```javascript
     * var editor = Jodit.make('#editor');
     * editor.toggleMode();
     * ```
     */ toggleMode() {
        let mode = this.getMode();
        if ([
            _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_SOURCE,
            _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_WYSIWYG,
            this.o.useSplitMode ? _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_SPLIT : 9
        ].includes(mode + 1)) {
            mode += 1;
        } else {
            mode = _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_WYSIWYG;
        }
        this.setMode(mode);
    }
    /**
     * Switch on/off the editor into the disabled state.
     * When disabled, the user is not able to change the editor content
     * This function firing the `disabled` event.
     */ setDisabled(isDisabled) {
        this.o.disabled = isDisabled;
        const readOnly = this.__wasReadOnly;
        this.setReadOnly(isDisabled || readOnly);
        this.__wasReadOnly = readOnly;
        if (this.editor) {
            this.editor.setAttribute('aria-disabled', isDisabled.toString());
            this.container.classList.toggle('jodit_disabled', isDisabled);
            this.e.fire('disabled', isDisabled);
        }
    }
    /**
     * Return true if editor in disabled mode
     */ getDisabled() {
        return this.o.disabled;
    }
    /**
     * Switch on/off the editor into the read-only state.
     * When in readonly, the user is not able to change the editor content, but can still
     * use some editor functions (show source code, print content, or seach).
     * This function firing the `readonly` event.
     */ setReadOnly(isReadOnly) {
        if (this.__wasReadOnly === isReadOnly) {
            return;
        }
        this.__wasReadOnly = isReadOnly;
        this.o.readonly = isReadOnly;
        if (isReadOnly) {
            this.editor && this.editor.removeAttribute('contenteditable');
        } else {
            this.editor && this.editor.setAttribute('contenteditable', 'true');
        }
        this.e && this.e.fire('readonly', isReadOnly);
    }
    /**
     * Return true if editor in read-only mode
     */ getReadOnly() {
        return this.o.readonly;
    }
    focus() {
        if (this.getMode() !== _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_SOURCE) {
            this.s.focus();
        }
    }
    get isFocused() {
        return this.s.isFocused();
    }
    /**
     * Hook before init
     */ beforeInitHook() {
    // do nothing
    }
    /**
     * Hook after init
     */ afterInitHook() {
    // do nothing
    }
    /** @override **/ initOptions(options) {
        this.options = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.ConfigProto)(options || {}, _config_js__WEBPACK_IMPORTED_MODULE_6__/* .Config */ .T.defaultOptions);
    }
    /** @override **/ initOwners() {
        // in iframe, it can be changed
        this.editorWindow = this.o.ownerWindow;
        this.ownerWindow = this.o.ownerWindow;
    }
    /**
     * Create and init current editable place
     */ addPlace(source, options) {
        const element = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.resolveElement)(source, this.o.shadowRoot || this.od);
        this.attachEvents(options);
        if (element.attributes) {
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.toArray)(element.attributes).forEach((attr)=>{
                const name = attr.name;
                let value = attr.value;
                if (_config_js__WEBPACK_IMPORTED_MODULE_6__/* .Config */ .T.defaultOptions[name] !== undefined && (!options || options[name] === undefined)) {
                    if ([
                        'readonly',
                        'disabled'
                    ].indexOf(name) !== -1) {
                        value = value === '' || value === 'true';
                    }
                    if (/^[0-9]+(\.)?([0-9]+)?$/.test(value.toString())) {
                        value = Number(value);
                    }
                    this.options[name] = value;
                }
            });
        }
        let container = this.c.div('jodit-container');
        container.classList.add('jodit');
        container.classList.add('jodit-container');
        container.classList.add(`jodit_theme_${this.o.theme || 'default'}`);
        addClassNames(this.o.className, container);
        if (this.o.containerStyle) {
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(container, this.o.containerStyle);
        }
        const { styleValues } = this.o;
        Object.keys(styleValues).forEach((key)=>{
            const property = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.kebabCase)(key);
            container.style.setProperty(`--jd-${property}`, styleValues[key]);
        });
        container.setAttribute('contenteditable', 'false');
        let buffer = null;
        if (this.o.inline) {
            if ([
                'TEXTAREA',
                'INPUT'
            ].indexOf(element.nodeName) === -1) {
                container = element;
                element.setAttribute(__defaultClassesKey, element.className.toString());
                buffer = container.innerHTML;
                container.innerHTML = '';
            }
            container.classList.add('jodit_inline');
            container.classList.add('jodit-container');
        }
        // actual for inline mode
        if (element !== container) {
            // hide source element
            if (element.style.display) {
                element.setAttribute(__defaultStyleDisplayKey, element.style.display);
            }
            element.style.display = 'none';
        }
        const workplace = this.c.div('jodit-workplace', {
            contenteditable: false
        });
        container.appendChild(workplace);
        if (element.parentNode && element !== container) {
            element.parentNode.insertBefore(container, element);
        }
        Object.defineProperty(element, 'component', {
            enumerable: false,
            configurable: true,
            value: this
        });
        const editor = this.c.div('jodit-wysiwyg', {
            contenteditable: true,
            'aria-disabled': false,
            tabindex: this.o.tabIndex
        });
        workplace.appendChild(editor);
        const currentPlace = {
            editor,
            element,
            container,
            workplace,
            statusbar: new _modules_index_js__WEBPACK_IMPORTED_MODULE_7__.StatusBar(this, container),
            options: this.isReady ? (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.ConfigProto)(options || {}, _config_js__WEBPACK_IMPORTED_MODULE_6__/* .Config */ .T.defaultOptions) : this.options,
            history: new _modules_index_js__WEBPACK_IMPORTED_MODULE_7__.History(this),
            editorWindow: this.ow
        };
        this.__elementToPlace.set(editor, currentPlace);
        this.setCurrentPlace(currentPlace);
        this.places.push(currentPlace);
        this.setNativeEditorValue(this.getElementValue()); // Init value
        const initResult = this.__initEditor(buffer);
        const opt = this.options;
        const init = ()=>{
            if (opt.enableDragAndDropFileToEditor && opt.uploader && (opt.uploader.url || opt.uploader.insertImageAsBase64URI)) {
                this.uploader.bind(this.editor);
            }
            // in initEditor - the editor could change
            if (!this.__elementToPlace.get(this.editor)) {
                this.__elementToPlace.set(this.editor, currentPlace);
            }
            this.e.fire('afterAddPlace', currentPlace);
        };
        return (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.callPromise)(initResult, init);
    }
    addDisclaimer(elm) {
        this.workplace.appendChild(elm);
    }
    /**
     * Set current place object
     */ setCurrentPlace(place) {
        if (this.currentPlace === place) {
            return;
        }
        if (!this.isEditorMode()) {
            this.setMode(_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_WYSIWYG);
        }
        this.currentPlace = place;
        this.buildToolbar();
        if (this.isReady) {
            this.e.fire('changePlace', place);
        }
    }
    __initEditor(buffer) {
        const result = this.__createEditor();
        return (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.callPromise)(result, ()=>{
            if (this.isInDestruct) {
                return;
            }
            // syncro
            if (this.element !== this.container) {
                const value = this.getElementValue();
                if (value !== this.getEditorValue()) {
                    this.setEditorValue(value);
                }
            } else {
                buffer != null && this.setEditorValue(buffer); // inline mode
            }
            let mode = this.o.defaultMode;
            if (this.o.saveModeInStorage) {
                const localMode = this.storage.get('jodit_default_mode');
                if (typeof localMode === 'string') {
                    mode = parseInt(localMode, 10);
                }
            }
            this.setMode(mode);
            if (this.o.readonly) {
                this.__wasReadOnly = false;
                this.setReadOnly(true);
            }
            if (this.o.disabled) {
                this.setDisabled(true);
            }
            // if enter plugin isn't installed
            try {
                this.ed.execCommand('defaultParagraphSeparator', false, this.o.enter.toLowerCase());
            } catch (_a) {}
        });
    }
    /**
     * Create main DIV element and replace source textarea
     */ __createEditor() {
        const defaultEditorArea = this.editor;
        const stayDefault = this.e.fire('createEditor', this);
        return (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.callPromise)(stayDefault, ()=>{
            if (this.isInDestruct) {
                return;
            }
            if (stayDefault === false || (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isPromise)(stayDefault)) {
                _modules_index_js__WEBPACK_IMPORTED_MODULE_7__.Dom.safeRemove(defaultEditorArea);
            }
            addClassNames(this.o.editorClassName, this.editor);
            if (this.o.style) {
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(this.editor, this.o.style);
            }
            this.e.on('synchro', ()=>{
                this.setEditorValue();
            }).on('focus', ()=>{
                this.editorIsActive = true;
            }).on('blur', ()=>this.editorIsActive = false);
            this.__prepareWYSIWYGEditor();
            if (this.o.triggerChangeEvent) {
                this.e.on('change', this.async.debounce(()=>{
                    this.e && this.e.fire(this.element, 'change');
                }, this.defaultTimeout));
            }
        });
    }
    /**
     * Attach some native event listeners
     */ __prepareWYSIWYGEditor() {
        const { editor } = this;
        // direction
        if (this.o.direction) {
            const direction = this.o.direction.toLowerCase() === 'rtl' ? 'rtl' : 'ltr';
            this.editor.style.direction = direction;
            this.editor.setAttribute('dir', direction);
            this.container.style.direction = direction;
            this.container.setAttribute('dir', direction);
            this.toolbar.setDirection(direction);
        }
        // proxy events
        this.e.on(editor, 'mousedown touchstart focus', ()=>{
            const place = this.__elementToPlace.get(editor);
            if (place) {
                this.setCurrentPlace(place);
            }
        }).on(editor, 'compositionend', this.synchronizeValues).on(editor, 'selectionchange selectionstart keydown keyup input keypress dblclick mousedown mouseup ' + 'click copy cut dragstart drop dragover paste resize touchstart touchend focus blur', (event)=>{
            if (this.o.readonly || this.__isSilentChange) {
                return;
            }
            const w = this.ew;
            if (event instanceof w.KeyboardEvent && event.isComposing) {
                return;
            }
            if (this.e && this.e.fire) {
                if (this.e.fire(event.type, event) === false) {
                    return false;
                }
                this.synchronizeValues();
            }
        });
    }
    fetch(url, options) {
        const ajax = new _core_request_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Ajax */ .d({
            url,
            ...options
        }, this.o.defaultAjaxOptions);
        const destroy = ()=>{
            this.e.off('beforeDestruct', destroy);
            this.progressbar.progress(100).hide();
            ajax.destruct();
        };
        this.e.one('beforeDestruct', destroy);
        this.progressbar.show().progress(30);
        const promise = ajax.send();
        promise.finally(destroy).catch(()=>null);
        return promise;
    }
    /**
     * Jodit's Destructor. Remove editor, and return source input
     */ destruct() {
        var _a, _b;
        if (this.isInDestruct) {
            return;
        }
        this.setStatus(_modules_index_js__WEBPACK_IMPORTED_MODULE_7__.STATUSES.beforeDestruct);
        this.__elementToPlace.clear();
        (_a = (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.cached)(this, 'storage')) === null || _a === void 0 ? void 0 : _a.clear();
        (_b = (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.cached)(this, 'buffer')) === null || _b === void 0 ? void 0 : _b.clear();
        this.commands.clear();
        this.__selectionLocked = null;
        this.e.off(this.ow, 'resize');
        this.e.off(this.ow);
        this.e.off(this.od);
        this.e.off(this.od.body);
        const tmpValue = this.editor ? this.getEditorValue() : '';
        this.places.forEach(({ container, workplace, statusbar, element, iframe, editor, history })=>{
            if (!element) {
                return;
            }
            if (element !== container) {
                if (element.hasAttribute(__defaultStyleDisplayKey)) {
                    const display = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(element, __defaultStyleDisplayKey);
                    if (display) {
                        element.style.display = display;
                        element.removeAttribute(__defaultStyleDisplayKey);
                    }
                } else {
                    element.style.display = '';
                }
            } else {
                if (element.hasAttribute(__defaultClassesKey)) {
                    element.className = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(element, __defaultClassesKey) || '';
                    element.removeAttribute(__defaultClassesKey);
                }
            }
            if (element.hasAttribute('style') && !(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(element, 'style')) {
                element.removeAttribute('style');
            }
            statusbar.destruct();
            this.e.off(container);
            this.e.off(element);
            this.e.off(editor);
            _modules_index_js__WEBPACK_IMPORTED_MODULE_7__.Dom.safeRemove(workplace);
            _modules_index_js__WEBPACK_IMPORTED_MODULE_7__.Dom.safeRemove(editor);
            if (container !== element) {
                _modules_index_js__WEBPACK_IMPORTED_MODULE_7__.Dom.safeRemove(container);
            }
            Object.defineProperty(element, 'component', {
                enumerable: false,
                configurable: true,
                value: null
            });
            _modules_index_js__WEBPACK_IMPORTED_MODULE_7__.Dom.safeRemove(iframe);
            // inline mode
            if (container === element) {
                element.innerHTML = tmpValue;
            }
            history.destruct();
        });
        this.places.length = 0;
        this.currentPlace = {};
        delete _core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .instances */ .VF[this.id];
        super.destruct();
    }
    /**
     * Create instance of Jodit
     *
     * @param element - Selector or HTMLElement
     * @param options - Editor's options
     */ constructor(element, options){
        super(options, true);
        /**
         * Define if object is Jodit
         */ this.isJodit = true;
        this.commands = new Map();
        this.__selectionLocked = null;
        this.__wasReadOnly = false;
        /**
         * Editor has focus in this time
         */ this.editorIsActive = false;
        this.__mode = _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_WYSIWYG;
        this.__callChangeCount = 0;
        /**
         * Don't raise a change event
         */ this.__isSilentChange = false;
        this.__elementToPlace = new Map();
        try {
            const elementSource = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.resolveElement)(element, this.o.shadowRoot || this.od);
            if (Jodit_1.isJoditAssigned(elementSource)) {
                // @ts-ignore
                return elementSource.component;
            }
        } catch (e) {
            if (!_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD) {
                throw e;
            }
            this.destruct();
            throw e;
        }
        this.setStatus(_modules_index_js__WEBPACK_IMPORTED_MODULE_7__.STATUSES.beforeInit);
        this.id = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.resolveElement)(element, this.o.shadowRoot || this.od), 'id') || new Date().getTime().toString();
        _core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .instances */ .VF[this.id] = this;
        this.attachEvents(options);
        this.e.on(this.ow, 'resize', ()=>{
            if (this.e) {
                this.e.fire('resize');
            }
        });
        this.e.on('prepareWYSIWYGEditor', this.__prepareWYSIWYGEditor);
        this.selection = new _modules_index_js__WEBPACK_IMPORTED_MODULE_7__.Selection(this);
        const beforeInitHookResult = this.beforeInitHook();
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.callPromise)(beforeInitHookResult, ()=>{
            if (this.isInDestruct) {
                return;
            }
            this.e.fire('beforeInit', this);
            _core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .pluginSystem */ .fg.__init(this);
            this.e.fire('afterPluginSystemInit', this);
            this.e.on('changePlace', ()=>{
                this.setReadOnly(this.o.readonly);
                this.setDisabled(this.o.disabled);
            });
            this.places.length = 0;
            const addPlaceResult = this.addPlace(element, options);
            _core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .instances */ .VF[this.id] = this;
            const init = ()=>{
                if (this.isInDestruct) {
                    return;
                }
                if (this.e) {
                    this.e.fire('afterInit', this);
                }
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.callPromise)(this.afterInitHook());
                this.setStatus(_modules_index_js__WEBPACK_IMPORTED_MODULE_7__.STATUSES.ready);
                this.e.fire('afterConstructor', this);
            };
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.callPromise)(addPlaceResult, init);
        });
    }
};
Jodit.fatMode = _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.FAT_MODE;
Jodit.plugins = _core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .pluginSystem */ .fg;
Jodit.modules = _core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .modules */ .av;
Jodit.ns = _core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .modules */ .av;
Jodit.decorators = {};
Jodit.constants = _core_constants_js__WEBPACK_IMPORTED_MODULE_0__;
Jodit.instances = _core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .instances */ .VF;
Jodit.lang = _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.lang;
Jodit.core = {
    Plugin: _modules_index_js__WEBPACK_IMPORTED_MODULE_7__.Plugin
};
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.cache
], Jodit.prototype, "createInside", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.cache
], Jodit.prototype, "message", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.cache
], Jodit.prototype, "s", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.cache
], Jodit.prototype, "uploader", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.cache
], Jodit.prototype, "filebrowser", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.throttle)()
], Jodit.prototype, "synchronizeValues", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)(':internalChange')
], Jodit.prototype, "updateElementValue", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], Jodit.prototype, "__prepareWYSIWYGEditor", null);
Jodit = Jodit_1 = __decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.derive)(_core_traits_dlgs_js__WEBPACK_IMPORTED_MODULE_5__/* .Dlgs */ .z)
], Jodit);

function addClassNames(className, elm) {
    if (className) {
        className.split(/\s+/).forEach((cn)=>elm.classList.add(cn));
    }
}


/***/ }),

/***/ 2525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $6: function() { return /* reexport safe */ _inputs_index_js__WEBPACK_IMPORTED_MODULE_2__.$6; },
/* harmony export */   F0: function() { return /* reexport safe */ _inputs_index_js__WEBPACK_IMPORTED_MODULE_2__.F0; },
/* harmony export */   XV: function() { return /* reexport safe */ _form_js__WEBPACK_IMPORTED_MODULE_1__.X; },
/* harmony export */   Yh: function() { return /* reexport safe */ _block_block_js__WEBPACK_IMPORTED_MODULE_0__.Y; },
/* harmony export */   cY: function() { return /* reexport safe */ _inputs_index_js__WEBPACK_IMPORTED_MODULE_2__.cY; },
/* harmony export */   nE: function() { return /* reexport safe */ _inputs_index_js__WEBPACK_IMPORTED_MODULE_2__.nE; },
/* harmony export */   tS: function() { return /* reexport safe */ _inputs_index_js__WEBPACK_IMPORTED_MODULE_2__.tS; }
/* harmony export */ });
/* harmony import */ var _block_block_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19070);
/* harmony import */ var _form_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86327);
/* harmony import */ var _inputs_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8959);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module ui/form
 */ 




/***/ }),

/***/ 2536:
/***/ (function(__unused_webpack_module, __webpack_exports__) {


/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'copy-format': 'Copiar formato'
});


/***/ }),

/***/ 2748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   J: function() { return /* binding */ Dom; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _helpers_array_to_array_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4510);
/* harmony import */ var _helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27613);
/* harmony import */ var _helpers_string_trim_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49055);
/* harmony import */ var _helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43555);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 





/**
 * Module for working with DOM
 */ class Dom {
    /**
     * Remove all content from element
     */ static detach(node) {
        while(node && node.firstChild){
            node.removeChild(node.firstChild);
        }
    }
    /**
     * Wrap all inline next siblings
     */ static wrapNextInline(current, tag, editor) {
        let tmp;
        const first = current;
        let last = current;
        editor.s.save();
        let needFindNext = false;
        do {
            needFindNext = false;
            tmp = last.nextSibling;
            if (tmp && !Dom.isBlock(tmp) && !Dom.isTag(tmp, 'br')) {
                needFindNext = true;
                last = tmp;
            }
        }while (needFindNext)
        return Dom.__wrapElements(tag, editor, first, last);
    }
    static __wrapElements(tag, editor, first, last) {
        const wrapper = (0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .Kg)(tag) ? editor.createInside.element(tag) : tag;
        if (first.parentNode) {
            first.parentNode.insertBefore(wrapper, first);
        }
        let next = first;
        while(next){
            next = first.nextSibling;
            wrapper.appendChild(first);
            if (first === last || !next) {
                break;
            }
            first = next;
        }
        editor.s.restore();
        return wrapper;
    }
    /**
     * Wrap all inline siblings
     */ static wrapInline(current, tag, editor) {
        let tmp;
        let first = current;
        let last = current;
        editor.s.save();
        let needFindNext = false;
        do {
            needFindNext = false;
            tmp = first.previousSibling;
            if (tmp && !Dom.isBlock(tmp)) {
                needFindNext = true;
                first = tmp;
            }
        }while (needFindNext)
        do {
            needFindNext = false;
            tmp = last.nextSibling;
            if (tmp && !Dom.isBlock(tmp)) {
                needFindNext = true;
                last = tmp;
            }
        }while (needFindNext)
        return Dom.__wrapElements(tag, editor, first, last);
    }
    /**
     * Wrap node inside another node
     */ static wrap(current, tag, create) {
        const wrapper = (0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .Kg)(tag) ? create.element(tag) : tag;
        if (Dom.isNode(current)) {
            if (!current.parentNode) {
                throw (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_4__/* .error */ .z3)('Element should be in DOM');
            }
            current.parentNode.insertBefore(wrapper, current);
            wrapper.appendChild(current);
        } else {
            const fragment = current.extractContents();
            current.insertNode(wrapper);
            wrapper.appendChild(fragment);
        }
        return wrapper;
    }
    /**
     * Remove parent of node and insert this node instead that parent
     */ static unwrap(node) {
        const parent = node.parentNode;
        if (parent) {
            while(node.firstChild){
                parent.insertBefore(node.firstChild, node);
            }
            Dom.safeRemove(node);
        }
    }
    /**
     * Call functions for all nodes between `start` and `end`
     */ static between(start, end, callback) {
        let next = start;
        while(next && next !== end){
            if (start !== next && callback(next)) {
                break;
            }
            let step = next.firstChild || next.nextSibling;
            if (!step) {
                while(next && !next.nextSibling){
                    next = next.parentNode;
                }
                step = next === null || next === void 0 ? void 0 : next.nextSibling;
            }
            next = step;
        }
    }
    static replace(elm, newTagName, create, withAttributes = false, notMoveContent = false) {
        if ((0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isHTML */ .AH)(newTagName)) {
            (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_4__/* .assert */ .vA)(create, 'Need create instance for new tag');
            newTagName = create.fromHTML(newTagName);
        }
        let tag;
        if ((0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .Kg)(newTagName)) {
            (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_4__/* .assert */ .vA)(create, 'Need create instance for new tag');
            tag = create.element(newTagName);
        } else {
            tag = newTagName;
        }
        if (!notMoveContent) {
            while(elm.firstChild){
                tag.appendChild(elm.firstChild);
            }
        }
        if (withAttributes && Dom.isElement(elm) && Dom.isElement(tag)) {
            (0,_helpers_array_to_array_js__WEBPACK_IMPORTED_MODULE_1__/* .toArray */ .$)(elm.attributes).forEach((attr)=>{
                tag.setAttribute(attr.name, attr.value);
            });
        }
        if (elm.parentNode) {
            elm.parentNode.replaceChild(tag, elm);
        }
        return tag;
    }
    /**
     * Checks whether the Node text and blank (in this case it may contain invisible auxiliary characters ,
     * it is also empty )
     *
     * @param node - The element of wood to be checked
     */ static isEmptyTextNode(node) {
        return Dom.isText(node) && (!node.nodeValue || node.nodeValue.replace(_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE_REG_EXP(), '').trim().length === 0);
    }
    static isEmptyContent(node) {
        return Dom.each(node, (elm)=>Dom.isEmptyTextNode(elm));
    }
    /**
     * The node is editable
     */ static isContentEditable(node, root) {
        return Dom.isNode(node) && !Dom.closest(node, (elm)=>Dom.isElement(elm) && elm.getAttribute('contenteditable') === 'false', root);
    }
    static isEmpty(node, condNoEmptyElement = _constants_js__WEBPACK_IMPORTED_MODULE_0__.NO_EMPTY_TAGS) {
        if (!node) {
            return true;
        }
        let cond;
        if (!(0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isFunction */ .Tn)(condNoEmptyElement)) {
            cond = (elm)=>condNoEmptyElement.has(elm.nodeName.toLowerCase());
        } else {
            cond = condNoEmptyElement;
        }
        const emptyText = (node)=>node.nodeValue == null || (0,_helpers_string_trim_js__WEBPACK_IMPORTED_MODULE_3__/* .trim */ .Bq)(node.nodeValue).length === 0;
        if (Dom.isText(node)) {
            return emptyText(node);
        }
        return !(Dom.isElement(node) && cond(node)) && Dom.each(node, (elm)=>{
            if (Dom.isText(elm) && !emptyText(elm) || Dom.isElement(elm) && cond(elm)) {
                return false;
            }
        });
    }
    /**
     * Returns true if it is a DOM node
     */ static isNode(object) {
        // Duck-typing
        return Boolean(object && (0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .Kg)(object.nodeName) && typeof object.nodeType === 'number' && object.childNodes && (0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isFunction */ .Tn)(object.appendChild));
    }
    /**
     *  Check if element is table cell
     */ static isCell(elm) {
        return Dom.isNode(elm) && (elm.nodeName === 'TD' || elm.nodeName === 'TH');
    }
    /**
     * Check if element is a list	element UL or OL
     */ static isList(elm) {
        return Dom.isTag(elm, _constants_js__WEBPACK_IMPORTED_MODULE_0__.LIST_TAGS);
    }
    /**
     * Check if element is a part of list	element LI
     */ static isLeaf(elm) {
        return Dom.isTag(elm, 'li');
    }
    /**
     * Check is element is Image element
     */ static isImage(elm) {
        return Dom.isNode(elm) && /^(img|svg|picture|canvas)$/i.test(elm.nodeName);
    }
    /**
     * Check the `node` is a block element
     * @param node - Object to check
     */ static isBlock(node) {
        return !(0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isVoid */ .Rd)(node) && typeof node === 'object' && Dom.isNode(node) && _constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_BLOCK.test(node.nodeName);
    }
    /**
     * Check if element is text node
     */ static isText(node) {
        return Boolean(node && node.nodeType === Node.TEXT_NODE);
    }
    /**
     * Check if element is comment node
     */ static isComment(node) {
        return Boolean(node && node.nodeType === Node.COMMENT_NODE);
    }
    /**
     * Check if element is element node
     */ static isElement(node) {
        var _a;
        if (!Dom.isNode(node)) {
            return false;
        }
        const win = (_a = node.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
        return Boolean(win && node.nodeType === Node.ELEMENT_NODE);
    }
    /**
     * Check if element is document fragment
     */ static isFragment(node) {
        var _a;
        if (!Dom.isNode(node)) {
            return false;
        }
        const win = (_a = node.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
        return Boolean(win && node.nodeType === Node.DOCUMENT_FRAGMENT_NODE);
    }
    /**
     * Check if element is HTMLElement node
     */ static isHTMLElement(node) {
        var _a;
        if (!Dom.isNode(node)) {
            return false;
        }
        const win = (_a = node.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
        return Boolean(win && node instanceof win.HTMLElement);
    }
    /**
     * Check element is inline block
     */ static isInlineBlock(node) {
        return Dom.isElement(node) && !/^(BR|HR)$/i.test(node.tagName) && [
            'inline',
            'inline-block'
        ].indexOf((0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_4__/* .css */ .AH)(node, 'display').toString()) !== -1;
    }
    /**
     * It's block and it can be split
     */ static canSplitBlock(node) {
        return !(0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isVoid */ .Rd)(node) && Dom.isHTMLElement(node) && Dom.isBlock(node) && !/^(TD|TH|CAPTION|FORM)$/.test(node.nodeName) && node.style !== undefined && !/^(fixed|absolute)/i.test(node.style.position);
    }
    /**
     * Get last matched node inside root
     */ static last(root, condition) {
        let last = root === null || root === void 0 ? void 0 : root.lastChild;
        if (!last) {
            return null;
        }
        do {
            if (condition(last)) {
                return last;
            }
            let next = last.lastChild;
            if (!next) {
                next = last.previousSibling;
            }
            if (!next && last.parentNode !== root) {
                do {
                    last = last.parentNode;
                }while (last && !(last === null || last === void 0 ? void 0 : last.previousSibling) && last.parentNode !== root)
                next = last === null || last === void 0 ? void 0 : last.previousSibling;
            }
            last = next;
        }while (last)
        return null;
    }
    /**
     * Find previous node
     */ static prev(node, condition, root, withChild = true) {
        return Dom.find(node, condition, root, false, withChild);
    }
    /**
     * Find next node what `condition(next) === true`
     */ static next(node, condition, root, withChild = true) {
        return Dom.find(node, condition, root, true, withChild);
    }
    static prevWithClass(node, className) {
        return Dom.prev(node, (node)=>{
            return Dom.isElement(node) && node.classList.contains(className);
        }, node.parentNode);
    }
    static nextWithClass(node, className) {
        return Dom.next(node, (elm)=>Dom.isElement(elm) && elm.classList.contains(className), node.parentNode);
    }
    /**
     * Find next/prev node what `condition(next) === true`
     */ static find(node, condition, root, leftToRight = true, withChild = true) {
        const gen = this.nextGen(node, root, leftToRight, withChild);
        let item = gen.next();
        while(!item.done){
            if (condition(item.value)) {
                return item.value;
            }
            item = gen.next();
        }
        return null;
    }
    /**
     * Find next/prev node what `condition(next) === true`
     */ static *nextGen(start, root, leftToRight = true, withChild = true) {
        const stack = [];
        let currentNode = start;
        do {
            let next = leftToRight ? currentNode.nextSibling : currentNode.previousSibling;
            while(next){
                stack.unshift(next);
                next = leftToRight ? next.nextSibling : next.previousSibling;
            }
            yield* this.runInStack(start, stack, leftToRight, withChild);
            currentNode = currentNode.parentNode;
        }while (currentNode && currentNode !== root)
        return null;
    }
    /**
     * It goes through all the internal elements of the node, causing a callback function
     *
     * @param elm - the element whose children and descendants you want to iterate over
     * @param callback - It called for each item found
     * @example
     * ```javascript
     * Jodit.modules.Dom.each(editor.s.current(), function (node) {
     *  if (node.nodeType === Node.TEXT_NODE) {
     *      node.nodeValue = node.nodeValue.replace(Jodit.INVISIBLE_SPACE_REG_EX, '') // remove all of the text element codes invisible character
     *  }
     * });
     * ```
     */ static each(elm, callback, leftToRight = true) {
        const gen = this.eachGen(elm, leftToRight);
        let item = gen.next();
        while(!item.done){
            if (callback(item.value) === false) {
                return false;
            }
            item = gen.next();
        }
        return true;
    }
    static eachGen(root, leftToRight = true) {
        return this.runInStack(root, [
            root
        ], leftToRight);
    }
    static *runInStack(start, stack, leftToRight, withChild = true) {
        while(stack.length){
            const item = stack.pop();
            if (withChild) {
                let child = leftToRight ? item.lastChild : item.firstChild;
                while(child){
                    stack.push(child);
                    child = leftToRight ? child.previousSibling : child.nextSibling;
                }
            }
            if (start !== item) {
                yield item;
            }
        }
    }
    /**
     * Find next/prev node what `condition(next) === true`
     */ static findWithCurrent(node, condition, root, sibling = 'nextSibling', child = 'firstChild') {
        let next = node;
        do {
            if (condition(next)) {
                return next || null;
            }
            if (child && next && next[child]) {
                const nextOne = Dom.findWithCurrent(next[child], condition, next, sibling, child);
                if (nextOne) {
                    return nextOne;
                }
            }
            while(next && !next[sibling] && next !== root){
                next = next.parentNode;
            }
            if (next && next[sibling] && next !== root) {
                next = next[sibling];
            }
        }while (next && next !== root)
        return null;
    }
    /**
     * Get not empty sibling
     */ static findSibling(node, left = true, cond = (n)=>!Dom.isEmptyTextNode(n)) {
        let sibling = Dom.sibling(node, left);
        while(sibling && !cond(sibling)){
            sibling = Dom.sibling(sibling, left);
        }
        return sibling && cond(sibling) ? sibling : null;
    }
    /**
     * Returns the nearest non-empty sibling
     */ static findNotEmptySibling(node, left) {
        return Dom.findSibling(node, left, (n)=>{
            var _a;
            return !Dom.isEmptyTextNode(n) && Boolean(!Dom.isText(n) || ((_a = n.nodeValue) === null || _a === void 0 ? void 0 : _a.length) && (0,_helpers_string_trim_js__WEBPACK_IMPORTED_MODULE_3__/* .trim */ .Bq)(n.nodeValue));
        });
    }
    /**
     * Returns the nearest non-empty neighbor
     */ static findNotEmptyNeighbor(node, left, root) {
        return (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_4__/* .call */ .T1)(left ? Dom.prev : Dom.next, node, (n)=>Boolean(n && (!(Dom.isText(n) || Dom.isComment(n)) || (0,_helpers_string_trim_js__WEBPACK_IMPORTED_MODULE_3__/* .trim */ .Bq)((n === null || n === void 0 ? void 0 : n.nodeValue) || '').length)), root);
    }
    static sibling(node, left) {
        return left ? node.previousSibling : node.nextSibling;
    }
    /**
     * It goes through all the elements in ascending order, and checks to see if they meet the predetermined condition
     */ static up(node, condition, root, checkRoot = false) {
        let start = node;
        if (!start) {
            return null;
        }
        do {
            if (condition(start)) {
                return start;
            }
            if (start === root || !start.parentNode) {
                break;
            }
            start = start.parentNode;
        }while (start && start !== root)
        if (start === root && checkRoot && condition(start)) {
            return start;
        }
        return null;
    }
    static closest(node, tagsOrCondition, root) {
        let condition;
        const lc = (s)=>s.toLowerCase();
        if ((0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isFunction */ .Tn)(tagsOrCondition)) {
            condition = tagsOrCondition;
        } else if ((0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isArray */ .cy)(tagsOrCondition) || (0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isSet */ .vM)(tagsOrCondition)) {
            const set = (0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isSet */ .vM)(tagsOrCondition) ? tagsOrCondition : new Set(tagsOrCondition.map(lc));
            condition = (tag)=>Boolean(tag && set.has(lc(tag.nodeName)));
        } else {
            condition = (tag)=>Boolean(tag && lc(tagsOrCondition) === lc(tag.nodeName));
        }
        return Dom.up(node, condition, root);
    }
    /**
     * Furthest parent node matching condition
     */ static furthest(node, condition, root) {
        let matchedParent = null, current = node === null || node === void 0 ? void 0 : node.parentElement;
        while(current && current !== root){
            if (condition(current)) {
                matchedParent = current;
            }
            current = current === null || current === void 0 ? void 0 : current.parentElement;
        }
        return matchedParent;
    }
    /**
     * Append new element in the start of root
     */ static appendChildFirst(root, newElement) {
        const child = root.firstChild;
        if (child) {
            if (child !== newElement) {
                root.insertBefore(newElement, child);
            }
        } else {
            root.appendChild(newElement);
        }
    }
    /**
     * Insert newElement after element
     */ static after(elm, newElement) {
        const { parentNode } = elm;
        if (!parentNode) {
            return;
        }
        if (parentNode.lastChild === elm) {
            parentNode.appendChild(newElement);
        } else {
            parentNode.insertBefore(newElement, elm.nextSibling);
        }
    }
    /**
     * Insert newElement before element
     */ static before(elm, newElement) {
        const { parentNode } = elm;
        if (!parentNode) {
            return;
        }
        parentNode.insertBefore(newElement, elm);
    }
    /**
     * Insert newElement as first child inside element
     */ static prepend(root, newElement) {
        root.insertBefore(newElement, root.firstChild);
    }
    static append(root, newElement) {
        if ((0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isArray */ .cy)(newElement)) {
            newElement.forEach((node)=>{
                this.append(root, node);
            });
        } else {
            root.appendChild(newElement);
        }
    }
    /**
     * Move all content to another element
     */ static moveContent(from, to, inStart = false, filter = ()=>true) {
        const fragment = (from.ownerDocument || _constants_js__WEBPACK_IMPORTED_MODULE_0__.globalDocument).createDocumentFragment();
        (0,_helpers_array_to_array_js__WEBPACK_IMPORTED_MODULE_1__/* .toArray */ .$)(from.childNodes).filter((elm)=>{
            if (filter(elm)) {
                return true;
            }
            Dom.safeRemove(elm);
            return false;
        }).forEach((node)=>{
            fragment.appendChild(node);
        });
        if (!inStart || !to.firstChild) {
            to.appendChild(fragment);
        } else {
            to.insertBefore(fragment, to.firstChild);
        }
    }
    /**
     * Check root contains child or equal child
     */ static isOrContains(root, child, onlyContains = false) {
        if (root === child) {
            return !onlyContains;
        }
        return Boolean(child && root && this.up(child, (nd)=>nd === root, root, true));
    }
    /**
     * Safe remove element from DOM
     */ static safeRemove(...nodes) {
        nodes.forEach((node)=>Dom.isNode(node) && node.parentNode && node.parentNode.removeChild(node));
    }
    static safeInsertNode(range, node) {
        range.collapsed || range.deleteContents();
        const child = Dom.isFragment(node) ? node.lastChild : node;
        if (range.startContainer === range.endContainer && range.collapsed && Dom.isTag(range.startContainer, _constants_js__WEBPACK_IMPORTED_MODULE_0__.INSEPARABLE_TAGS)) {
            Dom.after(range.startContainer, node);
        } else {
            range.insertNode(node);
            child && range.setStartBefore(child);
        }
        range.collapse(true);
        // https://developer.mozilla.org/en-US/docs/Web/API/Range/insertNode
        // if the new node is to be added to a text Node, that Node is split at the
        // insertion point, and the insertion occurs between the two text nodes.
        [
            node.nextSibling,
            node.previousSibling
        ].forEach((n)=>Dom.isText(n) && !n.nodeValue && Dom.safeRemove(n));
    }
    /**
     * Hide element
     */ static hide(node) {
        if (!node) {
            return;
        }
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_4__/* .dataBind */ .mv)(node, '__old_display', node.style.display);
        node.style.display = 'none';
    }
    /**
     * Show element
     */ static show(node) {
        if (!node) {
            return;
        }
        const display = (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_4__/* .dataBind */ .mv)(node, '__old_display');
        if (node.style.display === 'none') {
            node.style.display = display || '';
        }
    }
    static isTag(node, tagNames) {
        if (!this.isElement(node)) {
            return false;
        }
        const nameL = node.tagName.toLowerCase();
        const nameU = node.tagName.toUpperCase();
        if (tagNames instanceof Set) {
            return tagNames.has(nameL) || tagNames.has(nameU);
        }
        if (Array.isArray(tagNames)) {
            throw new TypeError('Dom.isTag does not support array');
        }
        const tags = tagNames;
        if (nameL === tags || nameU === tags) {
            return true;
        }
        return false;
    }
    /**
     * Marks an item as temporary
     */ static markTemporary(element, attributes) {
        attributes && (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_4__/* .attr */ .CF)(element, attributes);
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_4__/* .attr */ .CF)(element, _constants_js__WEBPACK_IMPORTED_MODULE_0__.TEMP_ATTR, true);
        return element;
    }
    /**
     * Check if element is temporary
     */ static isTemporary(element) {
        if (!Dom.isElement(element)) {
            return false;
        }
        return (0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isMarker */ .rg)(element) || (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_4__/* .attr */ .CF)(element, _constants_js__WEBPACK_IMPORTED_MODULE_0__.TEMP_ATTR) === 'true';
    }
    /**
     * Replace temporary elements from string
     */ static replaceTemporaryFromString(value) {
        return value.replace(/<([a-z]+)[^>]+data-jodit-temp[^>]+>(.+?)<\/\1>/gi, '$2');
    }
    /**
     * Get temporary list
     */ static temporaryList(root) {
        return (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_4__.$$)(`[${_constants_js__WEBPACK_IMPORTED_MODULE_0__.TEMP_ATTR}]`, root);
    }
    constructor(){
        throw new Error('Dom is static module');
    }
}


/***/ }),

/***/ 2969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   R: function() { return /* binding */ JElement; }
/* harmony export */ });
/* harmony import */ var _render__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90129);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39804);
/* harmony import */ var jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82758);
/* harmony import */ var jodit_esm_core_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22732);
/* harmony import */ var jodit_esm_core_helpers_utils_assert__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38837);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */





const singleTags = new Set(jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_2__.INSEPARABLE_TAGS);
class JElement {
    get isText() {
        return this.type === Node.TEXT_NODE;
    }
    get isElement() {
        return this.type === Node.ELEMENT_NODE;
    }
    get isComment() {
        return this.type === Node.COMMENT_NODE;
    }
    get isSingle() {
        return singleTags.has(this.name);
    }
    get length() {
        return this.children.length;
    }
    constructor(node, parent) {
        this.parent = parent;
        this.name = node.nodeName.toLowerCase();
        this.type = node.nodeType;
        this.attributes = readAttributes(node);
        this.style = new _style__WEBPACK_IMPORTED_MODULE_1__/* .Style */ .O(this.attributes.style);
        this.children = [];
        node.childNodes.forEach((node) => this.children.push(JElement.make(node, this)));
    }
    static make(node, parent = null) {
        return new JElement(node, parent);
    }
    wrap(tag) {
        void 0;
        const wrapper = JElement.make(document.createElement(tag), this.parent);
        const index = this.parent.children.indexOf(this) ?? -1;
        if (index === -1) {
            this.parent.append(wrapper);
        }
        else {
            this.parent.children[index] = wrapper;
        }
        wrapper.append(this);
        return wrapper;
    }
    append(child) {
        void 0;
        child.remove();
        this.children.push(child);
        child.parent = this;
        return this;
    }
    get previousElement() {
        if (!this.parent) {
            return null;
        }
        const { children } = this.parent, index = children.indexOf(this);
        if (index !== -1) {
            for (let i = index - 1; i >= 0; i -= 1) {
                if (children[i].isElement) {
                    return children[i];
                }
            }
        }
        return null;
    }
    get lastElement() {
        const { children } = this;
        for (let i = children.length - 1; i >= 0; i -= 1) {
            if (children[i].isElement) {
                return children[i];
            }
        }
        return null;
    }
    get previous() {
        return this.sibling(false) ?? this.parent?.previous ?? null;
    }
    get next() {
        return this.sibling(true) ?? this.parent?.next ?? null;
    }
    sibling(next) {
        if (!this.parent) {
            return null;
        }
        const { children } = this.parent, index = children.indexOf(this);
        if (index !== -1 && children[index + (next ? 1 : -1)]) {
            return children[index + (next ? 1 : -1)];
        }
        return null;
    }
    forEach(callbackFn, recursion = false) {
        const children = [...this.children];
        for (const child of children) {
            if (callbackFn(child) === false) {
                return false;
            }
            if (recursion && child.forEach(callbackFn, true) === false) {
                return false;
            }
        }
    }
    find(predicate, recursion = true) {
        const result = [];
        this.forEach((elm) => {
            if (predicate(elm)) {
                result.push(elm);
            }
        }, recursion);
        return result;
    }
    map(callbackFn) {
        return this.children.map(callbackFn);
    }
    remove() {
        const index = this.parent?.children.indexOf(this);
        if (index != null && index !== -1) {
            this.parent?.children.splice(index, 1);
        }
        return this;
    }
    textBetween(start, end) {
        let startFound = false;
        const result = [];
        this.forEach((node) => {
            if (!startFound && start(node)) {
                startFound = true;
            }
            if (startFound && node.isText) {
                result.push((0,_render__WEBPACK_IMPORTED_MODULE_0__/* .html */ .q)(node));
            }
            if (startFound && end(node)) {
                return false;
            }
        }, true);
        return result.join('');
    }
}
function readAttributes(node) {
    const result = {};
    if (jodit_esm_core_dom__WEBPACK_IMPORTED_MODULE_3__/* .Dom */ .J.isElement(node)) {
        for (let i = 0, attrs = node.attributes; i < attrs.length; i += 1) {
            result[attrs[i].name] = attrs[i].value;
        }
    }
    else {
        result['nodeValue'] = node.nodeValue;
    }
    return result;
}


/***/ }),

/***/ 3115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export SpeechRecognizeNative */
/* harmony import */ var _core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37133);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_utils_utils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37790);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50911);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46614);
/* harmony import */ var _jodit_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2303);
/* harmony import */ var _helpers_exec_spell_command_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54076);
/* harmony import */ var _langs_index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90492);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









class SpeechRecognizeNative extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Plugin */ .k {
    afterInit(jodit) {
        const { commands } = jodit.o.speechRecognize;
        if (commands) {
            (0,_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .extendLang */ .JW)(_langs_index_js__WEBPACK_IMPORTED_MODULE_7__);
            (0,_core_helpers_utils_utils_js__WEBPACK_IMPORTED_MODULE_3__/* .keys */ .HP)(commands, false).forEach((words)=>{
                const keys = words.split('|');
                keys.forEach((key)=>{
                    key = key.trim().toLowerCase();
                    this._commandToWord[key] = commands[words];
                    const translatedKeys = jodit.i18n(key);
                    if (translatedKeys !== key) {
                        translatedKeys.split('|').forEach((translatedKey)=>{
                            this._commandToWord[translatedKey.trim().toLowerCase()] = commands[words].trim();
                        });
                    }
                });
            });
        }
    }
    beforeDestruct(jodit) {
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(this.messagePopup);
    }
    onSpeechRecognizeProgressResult(text) {
        if (!this.messagePopup) {
            this.messagePopup = this.j.create.div('jodit-speech-recognize__popup');
        }
        this.j.workplace.appendChild(this.messagePopup);
        this.j.async.clearTimeout(this.__hidePopupTimeout);
        this.__hidePopupTimeout = this.j.async.setTimeout(()=>{
            _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(this.messagePopup);
        }, 1000);
        this.messagePopup.innerText = text + '|';
    }
    onSpeechRecognizeResult(text) {
        this.j.async.clearTimeout(this.__hidePopupTimeout);
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(this.messagePopup);
        const { j } = this;
        const { s } = j;
        if (!this._checkCommand(text)) {
            const { range } = s, node = s.current();
            if (s.isCollapsed() && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isText(node) && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isOrContains(j.editor, node) && node.nodeValue) {
                const sentence = node.nodeValue;
                node.nodeValue = sentence + (/[\u00A0 ]\uFEFF*$/.test(sentence) ? '' : ' ') + text;
                range.setStartAfter(node);
                s.selectRange(range);
                j.synchronizeValues();
            } else {
                s.insertHTML(text);
            }
        }
    }
    _checkCommand(command) {
        command = command.toLowerCase().replace(/\./g, '');
        if (this._commandToWord[command]) {
            (0,_helpers_exec_spell_command_js__WEBPACK_IMPORTED_MODULE_8__/* .execSpellCommand */ .F)(this.j, this._commandToWord[command]);
            return true;
        }
        return false;
    }
    constructor(){
        super(...arguments);
        this.buttons = [
            {
                group: 'state',
                name: 'speechRecognize'
            }
        ];
        this._commandToWord = {};
    }
}
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_0__/* .watch */ .w)(':speechRecognizeProgressResult')
], SpeechRecognizeNative.prototype, "onSpeechRecognizeProgressResult", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_0__/* .watch */ .w)(':speechRecognizeResult')
], SpeechRecognizeNative.prototype, "onSpeechRecognizeResult", null);
_jodit_js__WEBPACK_IMPORTED_MODULE_6__/* .Jodit */ .x.plugins.add('speech-recognize', SpeechRecognizeNative);


/***/ }),

/***/ 3215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export imageProperties */
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21537);
/* harmony import */ var _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20356);
/* harmony import */ var _core_ui_button_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62843);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97536);
/* harmony import */ var _ui_ui_image_form_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59436);
/* harmony import */ var _utils_open_image_editor_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53636);
/* harmony import */ var _utils_open_image_popup_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10263);
/* harmony import */ var _readers_index_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94575);
/* harmony import */ var _writers_index_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34755);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};












/**
 * Plug-in for image editing window
 *
 * @example
 * ```javascript
 * const editor = Jodit.make('#editor', {
 *     image: {
 *         editSrc: false,
 *         editLink: false
 *     }
 * });
 * ```
 */ /**
 * Show dialog with image's options
 */ class imageProperties extends _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_4__/* .Plugin */ .k {
    get form() {
        return new _ui_ui_image_form_js__WEBPACK_IMPORTED_MODULE_7__/* .UIImagePropertiesForm */ .l(this.j, this.state, this.activeTabState, {
            openImageEditor: ()=>(0,_utils_open_image_editor_js__WEBPACK_IMPORTED_MODULE_8__/* .openImageEditorDialog */ .v)(this.j, this.state),
            openImagePopup: (target)=>(0,_utils_open_image_popup_js__WEBPACK_IMPORTED_MODULE_9__/* .openImagePopup */ .q)(this.j, this.dialog, this.state, target)
        });
    }
    /**
     * Dialog for form
     */ get dialog() {
        const { j } = this;
        const dialog = j.dlg({
            minWidth: Math.min(400, screen.width),
            minHeight: 590,
            buttons: [
                'fullsize',
                'dialog.close'
            ]
        });
        const buttons = this.__buttons;
        buttons.check.onAction(()=>{
            (0,_writers_index_js__WEBPACK_IMPORTED_MODULE_11__/* .applyValuesToImage */ .j)(j, this.state, this.state.sourceImage);
            j.synchronizeValues();
            dialog.close();
        });
        buttons.remove.onAction(()=>{
            j.s.removeNode(this.state.sourceImage);
            dialog.close();
        });
        buttons.cancel.onAction(()=>{
            dialog.close();
        });
        dialog.setHeader(j.i18n('Image properties'));
        dialog.setContent(this.form);
        dialog.setFooter([
            [
                buttons.cancel,
                buttons.remove
            ],
            buttons.check
        ]);
        j.e.on(dialog, 'afterClose', ()=>{
            if (this.state.image.parentNode && j.o.image.selectImageAfterClose) {
                j.s.select(this.state.sourceImage);
            }
        });
        dialog.setSize(j.o.image.dialogWidth);
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.markOwner)(j, dialog.container);
        return dialog;
    }
    get __buttons() {
        const { j } = this;
        return {
            check: (0,_core_ui_button_index_js__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .$n)(j, 'ok', 'Apply', 'primary'),
            remove: (0,_core_ui_button_index_js__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .$n)(j, 'bin', 'Delete'),
            cancel: (0,_core_ui_button_index_js__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .$n)(j, 'cancel', 'Cancel')
        };
    }
    /**
     * Open dialog editing image properties
     *
     * @example
     * ```javascript
     * const editor = Jodit.makeJodit('#editor');
     *     img = editor.createInside.element('img');
     *
     * img.setAttribute('src', 'images/some-image.png');
     * editor.s.insertImage(img);
     * // open the properties of the editing window
     * editor.events.fire('openImageProperties', img);
     * ```
     */ open() {
        this.activeTabState.activeTab = 'Image';
        this.__lock();
        this.dialog.open().setModal(true).setPosition();
        this.async.promise((resolve, reject)=>(0,_readers_index_js__WEBPACK_IMPORTED_MODULE_10__/* .readValuesFromImage */ .U)(this.j, this.state).then(resolve, reject)).catch((e)=>{
            if (!(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isAbortError)(e)) {
                this.dialog.message.error(e.message);
            }
        }).finally(()=>this.__unlock());
        return false;
    }
    __lock() {
        this.dialog.lock();
        this.form.setMod('lock', true);
        Object.values(this.__buttons).forEach((b)=>b.state.disabled = true);
    }
    __unlock() {
        this.dialog.unlock();
        this.form.setMod('lock', false);
        Object.values(this.__buttons).forEach((b)=>b.state.disabled = false);
    }
    /** @override **/ afterInit(editor) {
        const self = this;
        editor.e.on('afterConstructor changePlace', ()=>{
            editor.e.off(editor.editor, '.imageproperties').on(editor.editor, 'dblclick.imageproperties', (e)=>{
                const image = e.target;
                if (!_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(image, 'img')) {
                    return;
                }
                if (editor.o.image.openOnDblClick) {
                    if (this.j.e.fire('openOnDblClick', image) === false) {
                        return;
                    }
                    self.state.sourceImage = image;
                    self.state.image = image.cloneNode(true);
                    if (!editor.o.readonly) {
                        e.stopImmediatePropagation();
                        e.preventDefault();
                        self.open();
                    }
                } else {
                    e.stopImmediatePropagation();
                    editor.s.select(image);
                }
            });
        }).on('openImageProperties.imageproperties', (image)=>{
            self.state.sourceImage = image;
            this.state.image = image.cloneNode(true);
            this.open();
        });
    }
    async onStateValuesImageSrcChange() {
        const { image, values } = this.state;
        if (!image.src) {
            return;
        }
        try {
            this.__lock();
            await image.decode();
            if (this.state.sizeIsLocked && (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isNumeric)(values.imageWidth)) {
                const w = parseFloat(values.imageWidth.toString());
                values.imageHeight = Math.round(w / this.state.ratio);
            }
            this.j.e.fire('updateImageProperties.imageproperties', image);
        } catch (e) {
            this.j.alert(e.message);
        } finally{
            this.__unlock();
        }
    }
    /** @override */ beforeDestruct(editor) {
        var _a, _b, _c;
        Object.values((_a = (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.cached)(this, '__buttons')) !== null && _a !== void 0 ? _a : {}).forEach((b)=>b.destruct());
        (_b = (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.cached)(this, 'dialog')) === null || _b === void 0 ? void 0 : _b.destruct();
        (_c = (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.cached)(this, 'form')) === null || _c === void 0 ? void 0 : _c.destruct();
        editor.e.off(editor.editor, '.imageproperties').off('.imageproperties');
    }
    constructor(){
        super(...arguments);
        this.state = {
            image: new Image(),
            sourceImage: new Image(),
            get ratio () {
                const { naturalWidth, naturalHeight } = this.image;
                return naturalWidth / naturalHeight || 1;
            },
            sizeIsLocked: true,
            marginIsLocked: true,
            values: {
                style: '',
                imageSrc: '',
                borderRadius: 0,
                imageTitle: '',
                imageAlt: '',
                imageLink: '',
                imageLinkOpenInNewTab: false,
                imageWidth: 0,
                imageHeight: 0,
                marginTop: 0,
                marginRight: 0,
                marginBottom: 0,
                marginLeft: 0,
                classes: '',
                id: '',
                align: ''
            }
        };
        this.activeTabState = {
            activeTab: 'Image'
        };
    }
}
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.cache
], imageProperties.prototype, "form", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.cache
], imageProperties.prototype, "dialog", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.cache
], imageProperties.prototype, "__buttons", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)('state.image')
], imageProperties.prototype, "onStateValuesImageSrcChange", null);
_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .pluginSystem */ .fg.add('imageProperties', imageProperties);


/***/ }),

/***/ 3636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    Spellcheck: 'Spellchecking'
});


/***/ }),

/***/ 3703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   h: function() { return /* binding */ set; }
/* harmony export */ });
/* harmony import */ var _checker_is_array_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68345);
/* harmony import */ var _checker_is_numeric_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29807);
/* harmony import */ var _checker_is_plain_object_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72430);
/* harmony import */ var _checker_is_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70799);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



/**
 * Safe access in tree object
 *
 * @example
 * ```js
 * const a = {}, b = {};
 * Jodit.modules.Helpers.set('a.b.c.d.e', 1, a);
 * console.log(a);// {a: {b: {c: {d: {e: 1}}}}}
 *
 * Jodit.modules.Helpers.set('a.0.e', 1, b);
 * console.log(b);// {a: [{e: 1}]}
 * ```
 */ function set(chain, value, obj) {
    if (!(0,_checker_is_string_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .K)(chain) || !chain.length) {
        return;
    }
    const parts = chain.split('.');
    let result = obj, key = parts[0];
    for(let i = 0; i < parts.length - 1; i += 1){
        key = parts[i];
        if (!(0,_checker_is_array_js__WEBPACK_IMPORTED_MODULE_1__/* .isArray */ .c)(result[key]) && !(0,_checker_is_plain_object_js__WEBPACK_IMPORTED_MODULE_2__/* .isPlainObject */ .Q)(result[key])) {
            result[key] = (0,_checker_is_numeric_js__WEBPACK_IMPORTED_MODULE_3__/* .isNumeric */ .k)(parts[i + 1]) ? [] : {};
        }
        result = result[key];
    }
    if (result) {
        result[parts[parts.length - 1]] = value;
    }
}


/***/ }),

/***/ 3760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   b$: function() { return /* binding */ NUMBER_FIELDS_REG; },
/* harmony export */   iy: function() { return /* binding */ normalizeCssValue; },
/* harmony export */   n8: function() { return /* binding */ normalizeCssNumericValue; }
/* harmony export */ });
/* harmony import */ var _checker_is_numeric_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29807);
/* harmony import */ var _checker_is_void_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86068);
/* harmony import */ var _color_color_to_hex_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35278);
/* harmony import */ var _string_kebab_case_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12475);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/normalize
 */ 



const NUMBER_FIELDS_REG = /^(left|top|bottom|right|width|min|max|height|margin|padding|fontsize|font-size)/i;
function normalizeCssNumericValue(key, value) {
    if (!(0,_checker_is_void_js__WEBPACK_IMPORTED_MODULE_0__/* .isVoid */ .R)(value) && NUMBER_FIELDS_REG.test(key) && (0,_checker_is_numeric_js__WEBPACK_IMPORTED_MODULE_1__/* .isNumeric */ .k)(value.toString())) {
        return parseInt(value.toString(), 10) + 'px';
    }
    return value;
}
function normalizeCssValue(key, value) {
    switch((0,_string_kebab_case_js__WEBPACK_IMPORTED_MODULE_2__/* .kebabCase */ .k)(key)){
        case 'font-weight':
            switch(value.toString().toLowerCase()){
                case '700':
                case 'bold':
                    return 700;
                case '400':
                case 'normal':
                    return 400;
                case '900':
                case 'heavy':
                    return 900;
            }
            return (0,_checker_is_numeric_js__WEBPACK_IMPORTED_MODULE_1__/* .isNumeric */ .k)(value) ? Number(value) : value;
    }
    if (/color/i.test(key) && /^rgb/i.test(value.toString())) {
        return (0,_color_color_to_hex_js__WEBPACK_IMPORTED_MODULE_3__/* .colorToHex */ .s)(value.toString()) || value;
    }
    return value;
}


/***/ }),

/***/ 3827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Xr: function() { return /* reexport safe */ _store_js__WEBPACK_IMPORTED_MODULE_3__.X; },
/* harmony export */   bk: function() { return /* reexport safe */ _event_emitter_js__WEBPACK_IMPORTED_MODULE_0__.b; },
/* harmony export */   d$: function() { return /* reexport safe */ _store_js__WEBPACK_IMPORTED_MODULE_3__.d; },
/* harmony export */   h5: function() { return /* reexport safe */ _eventify_js__WEBPACK_IMPORTED_MODULE_1__.h; },
/* harmony export */   sH: function() { return /* reexport safe */ _observable_js__WEBPACK_IMPORTED_MODULE_2__.s; }
/* harmony export */ });
/* harmony import */ var _event_emitter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98220);
/* harmony import */ var _eventify_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72757);
/* harmony import */ var _observable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73026);
/* harmony import */ var _store_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15738);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module event-emitter
 */ 





/***/ }),

/***/ 3958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    symbols: 'symbol'
});


/***/ }),

/***/ 4012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   u: function() { return /* binding */ Component; }
/* harmony export */ });
/* harmony import */ var _async_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8884);
/* harmony import */ var _statuses_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78213);
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _helpers_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21537);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



const StatusListHandlers = new Map();
/**
 * The base class of all Jodit UI components. Provides work with a life cycle.
 */ class Component {
    get componentName() {
        if (!this.__componentName) {
            this.__componentName = 'jodit-' + (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.kebabCase)(((0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isFunction)(this.className) ? this.className() : '') || (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.getClassName)(this));
        }
        return this.__componentName;
    }
    getFullElName(elementName, mod, modValue) {
        const result = [
            this.componentName
        ];
        if (elementName) {
            elementName = elementName.replace(/[^a-z0-9-]/gi, '-');
            result.push(`__${elementName}`);
        }
        if (mod) {
            result.push('_', mod);
            result.push('_', (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isVoid)(modValue) ? 'true' : modValue.toString());
        }
        return result.join('');
    }
    /**
     * The document in which jodit was created
     */ get ownerDocument() {
        return this.ow.document;
    }
    /**
     * Shortcut for `this.ownerDocument`
     */ get od() {
        return this.ownerDocument;
    }
    get ow() {
        return this.ownerWindow;
    }
    /**
     * Safe get any field
     * @example
     * ```js
     * private a = {
     * 	b: {
     * 		c: {
     * 			e: {
     * 				g: {
     * 					color: 'red'
     * 				}
     * 			}
     * 		}
     * 	}
     * }
     *
     * this.get('a.b.c.e.g.color'); // Safe access to color
     * // instead using optionsl chaining
     * this?.a?.b?.c?.e?.g?.color
     * ```
     *
     * @param chain - the path to be traversed in the obj object
     * @param obj - the object in which the value is searched
     */ get(chain, obj) {
        return (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.get)(chain, obj || this);
    }
    /**
     * Component is ready for work
     */ get isReady() {
        return this.componentStatus === _statuses_js__WEBPACK_IMPORTED_MODULE_1__/* .STATUSES */ .f.ready;
    }
    /**
     * Component was destructed
     */ get isDestructed() {
        return this.componentStatus === _statuses_js__WEBPACK_IMPORTED_MODULE_1__/* .STATUSES */ .f.destructed;
    }
    /**
     * The component is currently undergoing destructuring or has already been destroyed.
     * Those. you should not the app froze new events on him now or do anything else with him.
     */ get isInDestruct() {
        return _statuses_js__WEBPACK_IMPORTED_MODULE_1__/* .STATUSES */ .f.beforeDestruct === this.componentStatus || _statuses_js__WEBPACK_IMPORTED_MODULE_1__/* .STATUSES */ .f.destructed === this.componentStatus;
    }
    /**
     * Bind destructor to some View
     */ bindDestruct(component) {
        component.hookStatus(_statuses_js__WEBPACK_IMPORTED_MODULE_1__/* .STATUSES */ .f.beforeDestruct, ()=>!this.isInDestruct && this.destruct());
        return this;
    }
    /**
     * Destruct component method
     */ destruct() {
        this.setStatus(_statuses_js__WEBPACK_IMPORTED_MODULE_1__/* .STATUSES */ .f.destructed);
        if (this.async) {
            this.async.destruct();
            // @ts-ignore
            this.async = undefined;
        }
        if (StatusListHandlers.get(this)) {
            StatusListHandlers.delete(this);
        }
        // @ts-ignore
        this.ownerWindow = undefined;
    }
    /**
     * Current component status
     */ get componentStatus() {
        return this.__componentStatus;
    }
    /**
     * Setter for current component status
     */ set componentStatus(componentStatus) {
        this.setStatus(componentStatus);
    }
    /**
     * Set component status
     * @param componentStatus - component status
     * @see ComponentStatus
     */ setStatus(componentStatus) {
        return this.setStatusComponent(componentStatus, this);
    }
    /**
     * Set status recursively on all parents
     */ setStatusComponent(componentStatus, component) {
        if (componentStatus === this.__componentStatus) {
            return;
        }
        if (component === this) {
            this.__componentStatus = componentStatus;
        }
        const proto = Object.getPrototypeOf(this);
        if (proto && (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isFunction)(proto.setStatusComponent)) {
            proto.setStatusComponent(componentStatus, component);
        }
        const statuses = StatusListHandlers.get(this), list = statuses === null || statuses === void 0 ? void 0 : statuses[componentStatus];
        if (list && list.length) {
            list.forEach((cb)=>cb(component));
        }
    }
    /**
     * Adds a handler for changing the component's status
     *
     * @param status - the status at which the callback is triggered
     * @param callback - a function that will be called when the status is `status`
     */ hookStatus(status, callback) {
        let list = StatusListHandlers.get(this);
        if (!list) {
            list = {};
            StatusListHandlers.set(this, list);
        }
        if (!list[status]) {
            list[status] = [];
        }
        list[status].push(callback);
    }
    static isInstanceOf(c, constructorFunc) {
        return c instanceof constructorFunc;
    }
    constructor(){
        this.async = new _async_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Async */ .j();
        /**
         * The window in which jodit was created
         */ this.ownerWindow = window;
        this.__componentStatus = _statuses_js__WEBPACK_IMPORTED_MODULE_1__/* .STATUSES */ .f.beforeInit;
        this.uid = 'jodit-uid-' + (0,_global_js__WEBPACK_IMPORTED_MODULE_2__/* .uniqueUid */ .w9)();
    }
}
Component.STATUSES = _statuses_js__WEBPACK_IMPORTED_MODULE_1__/* .STATUSES */ .f;


/***/ }),

/***/ 4038:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"><path d=\"M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z\"/></svg> ");


/***/ }),

/***/ 4104:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M789 559l-170 450q33 0 136.5 2t160.5 2q19 0 57-2-87-253-184-452zm-725 1105l2-79q23-7 56-12.5t57-10.5 49.5-14.5 44.5-29 31-50.5l237-616 280-724h128q8 14 11 21l205 480q33 78 106 257.5t114 274.5q15 34 58 144.5t72 168.5q20 45 35 57 19 15 88 29.5t84 20.5q6 38 6 57 0 4-.5 13t-.5 13q-63 0-190-8t-191-8q-76 0-215 7t-178 8q0-43 4-78l131-28q1 0 12.5-2.5t15.5-3.5 14.5-4.5 15-6.5 11-8 9-11 2.5-14q0-16-31-96.5t-72-177.5-42-100l-450-2q-26 58-76.5 195.5t-50.5 162.5q0 22 14 37.5t43.5 24.5 48.5 13.5 57 8.5 41 4q1 19 1 58 0 9-2 27-58 0-174.5-10t-174.5-10q-8 0-26.5 4t-21.5 4q-80 14-188 14z\"/> </svg> ");


/***/ }),

/***/ 4164:
/***/ (function(__unused_webpack_module, __webpack_exports__) {


/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'copy-format': '複製格式'
});


/***/ }),

/***/ 4242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   n: function() { return /* binding */ UIFileInput; }
/* harmony export */ });
/* harmony import */ var _decorators_component_component_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87325);
/* harmony import */ var _button_button_button_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10830);
/* harmony import */ var _input_input_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80256);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let UIFileInput = class UIFileInput extends _input_input_js__WEBPACK_IMPORTED_MODULE_1__/* .UIInput */ .t {
    /** @override */ className() {
        return 'UIFileInput';
    }
    createContainer(options) {
        this.button = new _button_button_button_js__WEBPACK_IMPORTED_MODULE_0__/* .UIButton */ .lD(this.j, {
            tooltip: options.tooltip,
            icon: {
                name: 'plus'
            }
        });
        const { container } = this.button;
        if (!this.nativeInput) {
            this.nativeInput = this.createNativeInput(options);
        }
        const { nativeInput } = this;
        nativeInput.classList.add(this.getFullElName('input'));
        container.classList.add(this.componentName);
        container.appendChild(nativeInput);
        return container;
    }
    createNativeInput(options) {
        return this.j.create.fromHTML(`<input
			type="file"
			accept="${options.onlyImages ? 'image/*' : '*'}"
			tabindex="-1"
			dir="auto"
			multiple=""
		/>`);
    }
    constructor(jodit, options){
        super(jodit, {
            type: 'file',
            ...options
        });
        this.state = {
            ..._input_input_js__WEBPACK_IMPORTED_MODULE_1__/* .UIInput */ .t.defaultState,
            type: 'file',
            onlyImages: true
        };
    }
};
UIFileInput = __decorate([
    _decorators_component_component_js__WEBPACK_IMPORTED_MODULE_2__/* .component */ .s
], UIFileInput);



/***/ }),

/***/ 4510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $: function() { return /* binding */ toArray; }
/* harmony export */ });
/* harmony import */ var _checker_is_native_function_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70722);
/* harmony import */ var _utils_reset_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58844);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/array
 */ 

/**
 * Always return Array. It's a safe polyfill for [Array.from](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from) method
 * In certain scenarios (such as with Joomla Mootools), Array.from may be substituted with a less optimal implementation
 * ```javascript
 * Jodit.modules.Helpers.toArray('123') // ['1', '2', '3']
 * Jodit.modules.Helpers.toArray(['test']) // ['test']
 * Jodit.modules.Helpers.toArray(1) // []
 * ```
 */ const toArray = function toArray(...args) {
    var _a;
    const func = (0,_checker_is_native_function_js__WEBPACK_IMPORTED_MODULE_1__/* .isNativeFunction */ .a)(Array.from) ? Array.from : (_a = (0,_utils_reset_js__WEBPACK_IMPORTED_MODULE_0__/* .reset */ .c)('Array.from')) !== null && _a !== void 0 ? _a : Array.from;
    return func.apply(Array, args);
};


/***/ }),

/***/ 4604:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6441);
/* harmony import */ var _enter_svg_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6342);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.addNewLine = true;
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.addNewLineOnDBLClick = true;
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.addNewLineTagsTriggers = [
    'table',
    'iframe',
    'img',
    'hr',
    'pre',
    'jodit'
];
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.addNewLineDeltaShow = 20;
_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_0__/* .Icon */ .I.set('enter', _enter_svg_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A);


/***/ }),

/***/ 4795:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'Type something': 'Napiš něco',
    'About Jodit': 'O Jodit',
    'Jodit Editor': 'Editor Jodit',
    'Free Non-commercial Version': 'Verze pro nekomerční použití',
    "Jodit User's Guide": 'Jodit Uživatelská příručka',
    'contains detailed help for using': 'obsahuje detailní nápovědu',
    'For information about the license, please go to our website:': 'Pro informace o licenci, prosím, přejděte na naši stránku:',
    'Buy full version': 'Koupit plnou verzi',
    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.': 'Copyright © XDSoft.net - Chupurnov Valeriy. Všechna práva vyhrazena.',
    Anchor: 'Anchor',
    'Open in new tab': 'Otevřít v nové záložce',
    'Open in fullsize': 'Otevřít v celoobrazovkovém režimu',
    'Clear Formatting': 'Vyčistit formátování',
    'Fill color or set the text color': 'Barva výplně a písma',
    Redo: 'Vpřed',
    Undo: 'Zpět',
    Bold: 'Tučné',
    Italic: 'Kurzíva',
    'Insert Unordered List': 'Odrážky',
    'Insert Ordered List': 'Číslovaný seznam',
    'Align Center': 'Zarovnat na střed',
    'Align Justify': 'Zarovnat do bloku',
    'Align Left': 'Zarovnat vlevo',
    'Align Right': 'Zarovnat vpravo',
    'Insert Horizontal Line': 'Vložit horizontální linku',
    'Insert Image': 'Vložit obrázek',
    'Insert file': 'Vložit soubor',
    'Insert youtube/vimeo video': 'Vložit video (YT/Vimeo)',
    'Insert link': 'Vložit odkaz',
    'Font size': 'Velikost písma',
    'Font family': 'Typ písma',
    'Insert format block': 'Formátovat blok',
    Normal: 'Normální text',
    'Heading 1': 'Nadpis 1',
    'Heading 2': 'Nadpis 2',
    'Heading 3': 'Nadpis 3',
    'Heading 4': 'Nadpis 4',
    Quote: 'Citát',
    Code: 'Kód',
    Insert: 'Vložit',
    'Insert table': 'Vložit tabulku',
    'Decrease Indent': 'Zmenšit odsazení',
    'Increase Indent': 'Zvětšit odsazení',
    'Select Special Character': 'Vybrat speciální symbol',
    'Insert Special Character': 'Vložit speciální symbol',
    'Paint format': 'Použít formát',
    'Change mode': 'Změnit mód',
    Margins: 'Okraje',
    top: 'horní',
    right: 'pravý',
    bottom: 'spodní',
    left: 'levý',
    Styles: 'Styly',
    Classes: 'Třídy',
    Align: 'Zarovnání',
    Right: 'Vpravo',
    Center: 'Na střed',
    Left: 'Vlevo',
    '--Not Set--': '--nenastaveno--',
    Src: 'src',
    Title: 'Titulek',
    Alternative: 'Alternativní text (alt)',
    Link: 'Link',
    'Open link in new tab': 'Otevřít link v nové záložce',
    Image: 'Obrázek',
    file: 'soubor',
    Advanced: 'Rozšířené',
    'Image properties': 'Vlastnosti obrázku',
    Cancel: 'Zpět',
    Ok: 'Ok',
    'Your code is similar to HTML. Keep as HTML?': 'Váš text se podobá HTML. Vložit ho jako HTML?',
    'Paste as HTML': 'Vložit jako HTML',
    Keep: 'Ponechat originál',
    Clean: 'Vyčistit',
    'Insert as Text': 'Vložit jako TEXT',
    'Insert only Text': 'Vložit pouze TEXT',
    'Word Paste Detected': 'Detekován fragment z Wordu nebo Excelu',
    'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?': 'Obsah, který vkládáte, je pravděpodobně z Microsoft Word / Excel. Chcete ponechat formát nebo vložit pouze text?',
    'File Browser': 'Prohlížeč souborů',
    'Error on load list': 'Chyba při načítání seznamu souborů',
    'Error on load folders': 'Chyba při načítání složek',
    'Are you sure?': 'Jste si jistý(á)?',
    'Enter Directory name': 'Název složky',
    'Create directory': 'Vytvořit složku',
    'type name': 'název',
    'Drop image': 'Přetáhněte sem obrázek',
    'Drop file': 'Přetáhněte sem soubor',
    'or click': 'nebo klikněte',
    'Alternative text': 'Alternativní text',
    Browse: 'Server',
    Upload: 'Nahrát',
    Background: 'Pozadí',
    Text: 'Text',
    Top: 'Nahoru',
    Middle: 'Na střed',
    Bottom: 'Dolu',
    'Insert column before': 'Vložit sloupec před',
    'Insert column after': 'Vložit sloupec za',
    'Insert row above': 'Vložit řádek nad',
    'Insert row below': 'Vložit řádek pod',
    'Delete table': 'Vymazat tabulku',
    'Delete row': 'Vymazat řádku',
    'Delete column': 'Vymazat sloupec',
    'Empty cell': 'Vyčistit buňku',
    source: 'HTML',
    bold: 'tučně',
    italic: 'kurzíva',
    brush: 'štětec',
    link: 'odkaz',
    undo: 'zpět',
    redo: 'vpřed',
    table: 'tabulka',
    image: 'obrázek',
    eraser: 'guma',
    paragraph: 'odstavec',
    fontsize: 'velikost písma',
    video: 'video',
    font: 'písmo',
    about: 'о editoru',
    print: 'tisk',
    underline: 'podtrženo',
    strikethrough: 'přeškrtnuto',
    indent: 'zvětšit odsazení',
    outdent: 'zmenšit odsazení',
    fullsize: 'celoobrazovkový režim',
    shrink: 'smrsknout',
    hr: 'Linka',
    ul: 'Odrážka',
    ol: 'Číslovaný seznam',
    cut: 'Vyjmout',
    selectall: 'Označit vše',
    'Embed code': 'Kód',
    'Open link': 'Otevřít odkaz',
    'Edit link': 'Upravit odkaz',
    'No follow': 'Atribut no-follow',
    Unlink: 'Odstranit odkaz',
    Eye: 'Zobrazit',
    pencil: 'Chcete-li upravit',
    Update: 'Aktualizovat',
    ' URL': 'URL',
    Edit: 'Editovat',
    'Horizontal align': 'Horizontální zarovnání',
    Filter: 'Filtr',
    'Sort by changed': 'Dle poslední změny',
    'Sort by name': 'Dle názvu',
    'Sort by size': 'Dle velikosti',
    'Add folder': 'Přidat složku',
    Reset: 'Reset',
    Save: 'Uložit',
    'Save as ...': 'Uložit jako...',
    Resize: 'Změnit rozměr',
    Crop: 'Ořezat',
    Width: 'Šířka',
    Height: 'Výška',
    'Keep Aspect Ratio': 'Ponechat poměr',
    Yes: 'Ano',
    No: 'Ne',
    Remove: 'Vyjmout',
    Select: 'Označit',
    'Chars: %d': 'Znaky: %d',
    'Words: %d': 'Slova: %d',
    All: 'Vše',
    'Select %s': 'Označit %s',
    'Select all': 'Označit vše',
    'Vertical align': 'Vertikální zarovnání',
    Split: 'Rozdělit',
    'Split vertical': 'Rozdělit vertikálně',
    'Split horizontal': 'Rozdělit horizontálně',
    Merge: 'Spojit',
    'Add column': 'Přidat sloupec',
    'Add row': 'Přidat řádek',
    Delete: 'Vymazat',
    Border: 'Okraj',
    'License: %s': 'Licence: %s',
    'Strike through': 'Přeškrtnuto',
    Underline: 'Podtrženo',
    superscript: 'Horní index',
    subscript: 'Dolní index',
    'Cut selection': 'Vyjmout označené',
    Break: 'Zalomení',
    'Search for': 'Najdi',
    'Replace with': 'Nahradit za',
    Replace: 'Vyměňte',
    Paste: 'Vložit',
    'Choose Content to Paste': 'Vyber obsah pro vložení',
    'You can only edit your own images. Download this image on the host?': 'Můžete upravovat pouze své obrázky. Načíst obrázek?',
    'The image has been successfully uploaded to the host!': 'Obrázek byl úspěšně nahrán!',
    palette: 'paleta',
    'There are no files': 'V tomto adresáři nejsou žádné soubory.',
    Rename: 'přejmenovat',
    'Enter new name': 'Zadejte nový název',
    preview: 'náhled',
    download: 'Stažení',
    'Paste from clipboard': 'Vložit ze schránky',
    "Your browser doesn't support direct access to the clipboard.": 'Váš prohlížeč nepodporuje přímý přístup do schránky.',
    'Copy selection': 'Kopírovat výběr',
    copy: 'kopírování',
    'Border radius': 'Border radius',
    'Show all': 'Zobrazit všechny',
    Apply: 'Platí',
    'Please fill out this field': 'Prosím, vyplňte toto pole',
    'Please enter a web address': 'Prosím, zadejte webovou adresu',
    Default: 'Výchozí',
    Circle: 'Kruh',
    Dot: 'Dot',
    Quadrate: 'Quadrate',
    Find: 'Najít',
    'Find Previous': 'Najít Předchozí',
    'Find Next': 'Najít Další',
    'Insert className': 'Vložte název třídy',
    'Press Alt for custom resizing': 'Stiskněte Alt pro vlastní změnu velikosti'
});


/***/ }),

/***/ 5082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    'Line height': 'ラインの高さ'
});


/***/ }),

/***/ 5119:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 270 270\"> <path d=\"m240.443652,220.45085l-47.410809,0l0,-10.342138c13.89973,-8.43655 25.752896,-19.844464 34.686646,-33.469923c11.445525,-17.455846 17.496072,-37.709239 17.496072,-58.570077c0,-59.589197 -49.208516,-108.068714 -109.693558,-108.068714s-109.69263,48.479517 -109.69263,108.069628c0,20.860839 6.050547,41.113316 17.497001,58.570077c8.93375,13.625459 20.787845,25.032458 34.686646,33.469008l0,10.342138l-47.412666,0c-10.256959,0 -18.571354,8.191376 -18.571354,18.296574c0,10.105198 8.314395,18.296574 18.571354,18.296574l65.98402,0c10.256959,0 18.571354,-8.191376 18.571354,-18.296574l0,-39.496814c0,-7.073455 -4.137698,-13.51202 -10.626529,-16.537358c-25.24497,-11.772016 -41.557118,-37.145704 -41.557118,-64.643625c0,-39.411735 32.545369,-71.476481 72.549922,-71.476481c40.004553,0 72.550851,32.064746 72.550851,71.476481c0,27.497006 -16.312149,52.87161 -41.557118,64.643625c-6.487902,3.026253 -10.6256,9.464818 -10.6256,16.537358l0,39.496814c0,10.105198 8.314395,18.296574 18.571354,18.296574l65.982163,0c10.256959,0 18.571354,-8.191376 18.571354,-18.296574c0,-10.105198 -8.314395,-18.296574 -18.571354,-18.296574z\"/> </svg> ");


/***/ }),

/***/ 5287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C: function() { return /* binding */ wrapText; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/**
 * If there is no container outside,
 * then we wrap all the nearest inline nodes in a container
 * @private
 */ function wrapText(fake, jodit) {
    let needWrap = fake;
    _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.up(needWrap, (node)=>{
        if (node && node.hasChildNodes() && node !== jodit.editor) {
            needWrap = node;
        }
    }, jodit.editor);
    const currentBox = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.wrapInline(needWrap, jodit.o.enter, jodit);
    if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isEmpty(currentBox)) {
        const br = jodit.createInside.element('br');
        currentBox.appendChild(br);
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.before(br, fake);
    }
    return currentBox;
}


/***/ }),

/***/ 5567:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45z\"/> </svg> ");


/***/ }),

/***/ 5700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   G: function() { return /* binding */ position; }
/* harmony export */ });
/* harmony import */ var _checker_is_jodit_object_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19306);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/**
 * Calculate screen element position
 */ function position(elm, jodit, recurse = false) {
    var _a, _b;
    const rect = elm.getBoundingClientRect();
    let xPos = rect.left, yPos = rect.top;
    if ((0,_checker_is_jodit_object_js__WEBPACK_IMPORTED_MODULE_0__/* .isJoditObject */ .y)(jodit) && jodit.iframe && jodit.ed.body.contains(elm) && !recurse) {
        const { left, top } = position(jodit.iframe, jodit, true);
        xPos += left;
        yPos += top;
    }
    return {
        left: Math.round(xPos),
        top: Math.round(yPos),
        width: Math.round((_a = elm.offsetWidth) !== null && _a !== void 0 ? _a : rect.width),
        height: Math.round((_b = elm.offsetHeight) !== null && _b !== void 0 ? _b : rect.height)
    };
}


/***/ }),

/***/ 5827:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6441);
/* harmony import */ var _icons_link_svg_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27190);
/* harmony import */ var _icons_unlink_svg_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42345);
/* harmony import */ var _template_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10411);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 





_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.link = {
    formTemplate: _template_js__WEBPACK_IMPORTED_MODULE_3__/* .formTemplate */ .B,
    followOnDblClick: false,
    processVideoLink: true,
    processPastedLink: true,
    noFollowCheckbox: true,
    openInNewTabCheckbox: true,
    modeClassName: 'input',
    selectMultipleClassName: true,
    preventReadOnlyNavigation: true,
    selectSizeClassName: 3,
    selectOptionsClassName: [],
    hotkeys: [
        'ctrl+k',
        'cmd+k'
    ]
};
_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .I.set('link', _icons_link_svg_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A).set('unlink', _icons_unlink_svg_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A);
_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.controls.unlink = {
    exec: (editor, current)=>{
        const anchor = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(current, 'a', editor.editor);
        if (anchor) {
            _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.unwrap(anchor);
        }
        editor.synchronizeValues();
        editor.e.fire('hidePopup');
    },
    tooltip: 'Unlink'
};
_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.controls.link = {
    isActive: (editor)=>{
        const current = editor.s.current();
        return Boolean(current && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(current, 'a', editor.editor));
    },
    popup: (editor, current, close)=>{
        return editor.e.fire('generateLinkForm.link', current, close);
    },
    tags: [
        'a'
    ],
    tooltip: 'Insert link'
};


/***/ }),

/***/ 5986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   l: function() { return /* binding */ clearClassName; }
/* harmony export */ });
/* harmony import */ var jodit_esm_core_helpers_string_trim__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49055);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */

const clearClassName = (elm) => {
    // Normalize or remove class
    if (elm.attributes.class) {
        elm.attributes.class = elm.attributes.class.replace(/(el\d+)|(font\d+)|msonormal|msolistparagraph\w*/gi, '');
        if (!(0,jodit_esm_core_helpers_string_trim__WEBPACK_IMPORTED_MODULE_0__/* .trim */ .Bq)(elm.attributes.class)) {
            elm.attributes.class = null;
        }
    }
    return elm;
};


/***/ }),

/***/ 6091:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M576 1376v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm-512-768v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm-512-768v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm128-320v1088q0 66-47 113t-113 47h-1344q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1344q66 0 113 47t47 113z\"/> </svg> ");


/***/ }),

/***/ 6342:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 128 128\" xml:space=\"preserve\"> <polygon points=\"112.4560547,23.3203125 112.4560547,75.8154297 31.4853516,75.8154297 31.4853516,61.953125 16.0131836,72.6357422 0.5410156,83.3164063 16.0131836,93.9990234 31.4853516,104.6796875 31.4853516,90.8183594 112.4560547,90.8183594 112.4560547,90.8339844 127.4589844,90.8339844 127.4589844,23.3203125\"/> </svg> ");


/***/ }),

/***/ 6402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    Spellcheck: 'Дүрмийн алдаа шалгах'
});


/***/ }),

/***/ 6441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   T: function() { return /* binding */ Config; }
/* harmony export */ });
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * Editor options. These can be configured upon the creation of the editor.
 * ```javascript
 * const editor = Jodit.make('#editor', {
 * 	 toolbar: true,
 * 	 buttons: ['bold', 'italic', 'underline']
 * 	 // other options
 * 	 // ...
 * });
 * ```
 * @packageDocumentation
 * @module config
 */ 

/**
 * Default Editor's Configuration
 */ class Config {
    static get defaultOptions() {
        if (!Config.__defaultOptions) {
            Config.__defaultOptions = new Config();
        }
        return Config.__defaultOptions;
    }
    constructor(){
        /**
         * Use cache for heavy methods
         */ this.cache = true;
        /**
         * Timeout of all asynchronous methods
         */ this.defaultTimeout = 100;
        this.namespace = '';
        /**
         * Editor loads completely without plugins. Useful when debugging your own plugin.
         */ this.safeMode = false;
        /**
         * Editor's width
         *
         * @example
         * ```javascript
         * Jodit.make('.editor', {
         *    width: '100%',
         * })
         * ```
         * @example
         * ```javascript
         * Jodit.make('.editor', {
         *    width: 600, // equivalent for '600px'
         * })
         * ```
         * @example
         * ```javascript
         * Jodit.make('.editor', {
         *    width: 'auto', // autosize
         * })
         * ```
         */ this.width = 'auto';
        /**
         * Editor's height
         *
         * @example
         * ```javascript
         * Jodit.make('.editor', {
         *    height: '100%',
         * })
         * ```
         * @example
         * ```javascript
         * Jodit.make('.editor', {
         *    height: 600, // equivalent for '600px'
         * })
         * ```
         * @example
         * ```javascript
         * Jodit.make('.editor', {
         *    height: 'auto', // default - autosize
         * })
         * ```
         */ this.height = 'auto';
        /**
         * List of plugins that will be initialized in safe mode.
         *
         * ```js
         * Jodit.make('#editor', {
         * 	safeMode: true,
         * 	safePluginsList: ['about'],
         * 	extraPlugins: ['yourPluginDev']
         * });
         * ```
         */ this.safePluginsList = [
            'about',
            'enter',
            'backspace',
            'size',
            'bold',
            'hotkeys'
        ];
        /**
         * Reserved for the paid version of the editor
         */ this.license = '';
        /**
         * The name of the preset that will be used to initialize the editor.
         * The list of available presets can be found here Jodit.defaultOptions.presets
         * ```javascript
         * Jodit.make('.editor', {
         * 	preset: 'inline'
         * });
         * ```
         */ this.preset = 'custom';
        this.presets = {
            inline: {
                inline: true,
                toolbar: false,
                toolbarInline: true,
                toolbarInlineForSelection: true,
                showXPathInStatusbar: false,
                showCharsCounter: false,
                showWordsCounter: false,
                showPlaceholder: false
            }
        };
        this.ownerDocument = _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.globalDocument;
        /**
         * Allows you to specify the window in which the editor will be created. Default - window
         * This is necessary if you are creating the editor inside an iframe but the code is running in the parent window
         */ this.ownerWindow = _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.globalWindow;
        /**
         * Shadow root if Jodit was created in it
         *
         * ```html
         * <div id="editor"></div>
         * ```
         *
         * ```js
         * const app = document.getElementById('editor');
         * app.attachShadow({ mode: 'open' });
         * const root = app.shadowRoot;
         *
         * root.innerHTML = `
         * <link rel="stylesheet" href="./build/jodit.css"/>
         * <h1>Jodit example in Shadow DOM</h1>
         * <div id="edit"></div>
         * `;
         *
         * const editor = Jodit.make(root.getElementById('edit'), {
         * 	globalFullSize: false,
         * 	shadowRoot: root
         * });
         * editor.value = '<p>start</p>';
         * ```
         */ this.shadowRoot = null;
        /**
         * z-index For editor
         */ this.zIndex = 0;
        /**
         * Change the read-only state of the editor
         */ this.readonly = false;
        /**
         * Change the disabled state of the editor
         */ this.disabled = false;
        /**
         * In readOnly mode, some buttons can still be useful, for example, the button to view source code or print
         */ this.activeButtonsInReadOnly = [
            'source',
            'fullsize',
            'print',
            'about',
            'dots',
            'selectall'
        ];
        /**
         * When the editor is in read-only mode, some commands can still be executed:
         * ```javascript
         * const editor = Jodit.make('.editor', {
         * 	 allowCommandsInReadOnly: ['selectall', 'preview', 'print']
         * 	 readonly: true
         * });
         * editor.execCommand('selectall');// will be selected all content
         * editor.execCommand('delete');// but content will not be deleted
         * ```
         */ this.allowCommandsInReadOnly = [
            'selectall',
            'preview',
            'print'
        ];
        /**
         * Size of icons in the toolbar (can be "small", "middle", "large")
         *
         * @example
         * ```javascript
         * const editor = Jodit.make(".dark_editor", {
         *      toolbarButtonSize: "small"
         * });
         * ```
         */ this.toolbarButtonSize = 'middle';
        /**
         * Allow navigation in the toolbar of the editor by Tab key
         */ this.allowTabNavigation = false;
        /**
         * Inline editing mode
         */ this.inline = false;
        /**
         * Theme (can be "dark")
         * @example
         * ```javascript
         * const editor = Jodit.make(".dark_editor", {
         *      theme: "dark"
         * });
         * ```
         */ this.theme = 'default';
        /**
         * if set true, then the current mode is saved in a cookie, and is restored after a reload of the page
         */ this.saveModeInStorage = false;
        /**
         * Class name that can be appended to the editable area
         *
         * @see [[Config.iframeCSSLinks]]
         * @see [[Config.iframeStyle]]
         *
         * @example
         * ```javascript
         * Jodit.make('#editor', {
         *    editorClassName: 'some_my_class'
         * });
         * ```
         * ```html
         * <style>
         * .some_my_class p{
         *    line-height: 16px;
         * }
         * </style>
         * ```
         */ this.editorClassName = false;
        /**
         * Class name that can be appended to the main editor container
         * @example
         * ```javascript
         * const jodit = Jodit.make('#editor', {
         *    className: 'some_my_class'
         * });
         *
         * console.log(jodit.container.classList.contains('some_my_class')); // true
         * ```
         * ```html
         * <style>
         * .some_my_class {
         *    max-width: 600px;
         *    margin: 0 auto;
         * }
         * </style>
         * ```
         */ this.className = false;
        /**
         * The internal styles of the editable area. They are intended to change
         * not the appearance of the editor, but to change the appearance of the content.
         * @example
         * ```javascript
         * Jodit.make('#editor', {
         * 		style: {
         * 		 font: '12px Arial',
         * 		 color: '#0c0c0c'
         * 		}
         * });
         * ```
         */ this.style = false;
        /**
         *
         * @example
         * ```javascript
         * Jodit.make('#editor', {
         * 		editorStyle: {
         * 		 font: '12px Arial',
         * 		 color: '#0c0c0c'
         * 		}
         * });
         * ```
         */ this.containerStyle = false;
        /**
         * Dictionary of variable values in css, a complete list can be found here
         * https://github.com/xdan/jodit/blob/main/src/styles/variables.less#L25
         *
         * @example
         * ```js
         * const editor = Jodit.make('#editor', {
         *   styleValues: {
         *		'color-text': 'red',
         *		colorBorder: 'black',
         *		'color-panel': 'blue'
         *   }
         * });
         * ```
         */ this.styleValues = {};
        /**
         * After all, changes in editors for textarea will call change trigger
         *
         * @example
         * ```javascript
         * const editor = Jodit.make('#editor');
         * document.getElementById('editor').addEventListener('change', function () {
         *      console.log(this.value);
         * })
         * ```
         */ this.triggerChangeEvent = true;
        /**
         * The writing direction of the language which is used to create editor content. Allowed values are: ''
         * (an empty string) – Indicates that content direction will be the same as either the editor UI direction or
         * the page element direction. 'ltr' – Indicates a Left-To-Right text direction (like in English).
         * 'rtl' – Indicates a Right-To-Left text direction (like in Arabic).
         *
         * @example
         * ```javascript
         * Jodit.make('.editor', {
         *    direction: 'rtl'
         * })
         * ```
         */ this.direction = '';
        /**
         * Language by default. if `auto` language set by document.documentElement.lang ||
         * (navigator.language && navigator.language.substr(0, 2)) ||
         * (navigator.browserLanguage && navigator.browserLanguage.substr(0, 2)) || 'en'
         *
         * @example
         * ```html
         * <!-- include in you page lang file -->
         * <script src="jodit/lang/de.js"></script>
         * <script>
         * var editor = Jodit.make('.editor', {
         *    language: 'de'
         * });
         * </script>
         * ```
         */ this.language = 'auto';
        /**
         * if true all Lang.i18n(key) return `{key}`
         *
         * @example
         * ```html
         * <script>
         * var editor = Jodit.make('.editor', {
         *    debugLanguage: true
         * });
         *
         * console.log(editor.i18n("Test")); // {Test}
         * </script>
         * ```
         */ this.debugLanguage = false;
        /**
         * Collection of language pack data `{en: {'Type something': 'Type something', ...}}`
         *
         * @example
         * ```javascript
         * const editor = Jodit.make('#editor', {
         *     language: 'ru',
         *     i18n: {
         *         ru: {
         *            'Type something': 'Начните что-либо вводить'
         *         }
         *     }
         * });
         * console.log(editor.i18n('Type something')) //Начните что-либо вводить
         * ```
         */ this.i18n = false;
        /**
         * The tabindex global attribute is an integer indicating if the element can take
         * input focus (is focusable), if it should participate to sequential keyboard navigation,
         * and if so, at what position. It can take several values
         */ this.tabIndex = -1;
        /**
         * Boolean, whether the toolbar should be shown.
         * Alternatively, a valid css-selector-string to use an element as toolbar container.
         */ this.toolbar = true;
        /**
         * Boolean, whether the statusbar should be shown.
         */ this.statusbar = true;
        /**
         * Show tooltip after mouse enter on the button
         */ this.showTooltip = true;
        /**
         * Delay before show tooltip
         */ this.showTooltipDelay = 200;
        /**
         * Instead of create custop tooltip - use native title tooltips
         */ this.useNativeTooltip = false;
        /**
         * Default insert method
         * @default insert_as_html
         */ this.defaultActionOnPaste = _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INSERT_AS_HTML;
        // TODO
        // autosave: false, // false or url
        // autosaveCallback: false, // function
        // interval: 60, // seconds
        // TODO
        /**
         * Element that will be created when you press Enter
         */ this.enter = _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.PARAGRAPH;
        /**
         * When this option is enabled, the editor's content will be placed in an iframe and isolated from the rest of the page.
         *
         * @example
         * ```javascript
         * Jodit.make('#editor', {
         *    iframe: true,
         *    iframeStyle: 'html{margin: 0px;}body{padding:10px;background:transparent;color:#000;position:relative;z-index:2;\
         *    user-select:auto;margin:0px;overflow:hidden;}body:after{content:"";clear:both;display:block}';
         * });
         * ```
         */ this.iframe = false;
        /**
         * Allow editing the entire HTML document(html, head)
         * \> Works together with the iframe option.
         * @example
         * ```js
         * const editor = Jodit.make('#editor', {
         *   iframe: true,
         *   editHTMLDocumentMode: true
         * });
         * editor.value = '<!DOCTYPE html><html lang="en" style="overflow-y:hidden">' +
         * 	'<head><title>Jodit Editor</title></head>' +
         * 	'<body spellcheck="false"><p>Some text</p><p> a </p></body>' +
         * 	'</html>';
         * ```
         */ this.editHTMLDocumentMode = false;
        /**
         * Use when you need to insert new block element
         * use enter option if not set
         */ this.enterBlock = this.enter !== 'br' ? this.enter : _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.PARAGRAPH;
        /**
         * Jodit.MODE_WYSIWYG The HTML editor allows you to write like MSWord,
         * Jodit.MODE_SOURCE syntax highlighting source editor
         * @example
         * ```javascript
         * var editor = Jodit.make('#editor', {
         *     defaultMode: Jodit.MODE_SPLIT
         * });
         * console.log(editor.getRealMode())
         * ```
         */ this.defaultMode = _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_WYSIWYG;
        /**
         * Use split mode
         */ this.useSplitMode = false;
        /**
         * The colors in HEX representation to select a color for the background and for the text in colorpicker
         * @example
         * ```javascript
         *  Jodit.make('#editor', {
         *     colors: ['#ff0000', '#00ff00', '#0000ff']
         * })
         * ```
         */ this.colors = {
            greyscale: [
                '#000000',
                '#434343',
                '#666666',
                '#999999',
                '#B7B7B7',
                '#CCCCCC',
                '#D9D9D9',
                '#EFEFEF',
                '#F3F3F3',
                '#FFFFFF'
            ],
            palette: [
                '#980000',
                '#FF0000',
                '#FF9900',
                '#FFFF00',
                '#00F0F0',
                '#00FFFF',
                '#4A86E8',
                '#0000FF',
                '#9900FF',
                '#FF00FF'
            ],
            full: [
                '#E6B8AF',
                '#F4CCCC',
                '#FCE5CD',
                '#FFF2CC',
                '#D9EAD3',
                '#D0E0E3',
                '#C9DAF8',
                '#CFE2F3',
                '#D9D2E9',
                '#EAD1DC',
                '#DD7E6B',
                '#EA9999',
                '#F9CB9C',
                '#FFE599',
                '#B6D7A8',
                '#A2C4C9',
                '#A4C2F4',
                '#9FC5E8',
                '#B4A7D6',
                '#D5A6BD',
                '#CC4125',
                '#E06666',
                '#F6B26B',
                '#FFD966',
                '#93C47D',
                '#76A5AF',
                '#6D9EEB',
                '#6FA8DC',
                '#8E7CC3',
                '#C27BA0',
                '#A61C00',
                '#CC0000',
                '#E69138',
                '#F1C232',
                '#6AA84F',
                '#45818E',
                '#3C78D8',
                '#3D85C6',
                '#674EA7',
                '#A64D79',
                '#85200C',
                '#990000',
                '#B45F06',
                '#BF9000',
                '#38761D',
                '#134F5C',
                '#1155CC',
                '#0B5394',
                '#351C75',
                '#733554',
                '#5B0F00',
                '#660000',
                '#783F04',
                '#7F6000',
                '#274E13',
                '#0C343D',
                '#1C4587',
                '#073763',
                '#20124D',
                '#4C1130'
            ]
        };
        /**
         * The default tab color picker
         * @example
         * ```javascript
         * Jodit.make('#editor2', {
         *     colorPickerDefaultTab: 'color'
         * })
         * ```
         */ this.colorPickerDefaultTab = 'background';
        /**
         * Image size defaults to a larger image
         */ this.imageDefaultWidth = 300;
        /**
         * Do not display these buttons that are on the list
         * @example
         * ```javascript
         * Jodit.make('#editor2', {
         *     removeButtons: ['hr', 'source']
         * });
         * ```
         */ this.removeButtons = [];
        /**
         * Do not init these plugins
         * @example
         * ```typescript
         * var editor = Jodit.make('.editor', {
         *    disablePlugins: 'table,iframe'
         * });
         * //or
         * var editor = Jodit.make('.editor', {
         *    disablePlugins: ['table', 'iframe']
         * });
         * ```
         */ this.disablePlugins = [];
        /**
         * Init and download extra plugins
         * @example
         * ```typescript
         * var editor = Jodit.make('.editor', {
         *    extraPlugins: ['emoji']
         * });
         * ```
         * It will try load %SCRIPT_PATH%/plugins/emoji/emoji.js and after load will try init it
         */ this.extraPlugins = [];
        /**
         * These buttons list will be added to the option. Buttons
         */ this.extraButtons = [];
        /**
         * By default, you can only install an icon from the Jodit suite.
         * You can add your icon to the set using the `Jodit.modules.Icon.set (name, svg Code)` method.
         * But for a declarative declaration, you can use this option.
         *
         * @example
         * ```js
         * Jodit.modules.Icon.set('someIcon', '<svg><path.../></svg>');
         * const editor = Jodit.make({
         *   extraButtons: [{
         *     name: 'someButton',
         *     icon: 'someIcon'
         *   }]
         * });
         *
         * @example
         * const editor = Jodit.make({
         *   extraIcons: {
         *     someIcon: '<svg><path.../></svg>'
         *   },
         *   extraButtons: [{
         *     name: 'someButton',
         *     icon: 'someIcon'
         *   }]
         * });
         * ```
         * @example
         * ```js
         * const editor = Jodit.make({
         *   extraButtons: [{
         *     name: 'someButton',
         *     icon: '<svg><path.../></svg>'
         *   }]
         * });
         * ```
         */ this.extraIcons = {};
        /**
         * Default attributes for created inside editor elements
         * @example
         * ```js
         * const editor2 = Jodit.make('#editor', {
         * 	createAttributes: {
         * 		div: {
         * 			class: 'test'
         * 		},
         * 		ul: function (ul) {
         * 			ul.classList.add('ui-test');
         * 		}
         * 	}
         * });
         *
         * const div2 = editor2.createInside.div();
         * expect(div2.className).equals('test');
         *
         * const ul = editor2.createInside.element('ul');
         * expect(ul.className).equals('ui-test');
         * ```
         * Or JSX in React
         * @example
         * ```jsx
         * import React, {useState, useRef} from 'react';
         * import JoditEditor from "jodit-react";
         *
         * const config = {
         * 	createAttributes: {
         * 		div: {
         * 			class: 'align-center'
         * 		}
         * 	}
         * };
         *
         * <JoditEditor config={config}/>
         * ```
         */ this.createAttributes = {
            table: {
                style: 'border-collapse:collapse;width: 100%;'
            }
        };
        /**
         * The width of the editor, accepted as the biggest. Used to the responsive version of the editor
         */ this.sizeLG = 900;
        /**
         * The width of the editor, accepted as the medium. Used to the responsive version of the editor
         */ this.sizeMD = 700;
        /**
         * The width of the editor, accepted as the small. Used to the responsive version of the editor
         */ this.sizeSM = 400;
        /**
         * The list of buttons that appear in the editor's toolbar on large places (≥ options.sizeLG).
         * Note - this is not the width of the device, the width of the editor
         * @example
         * ```javascript
         * Jodit.make('#editor', {
         *     buttons: ['bold', 'italic', 'source'],
         *     buttonsMD: ['bold', 'italic'],
         *     buttonsXS: ['bold', 'fullsize'],
         * });
         * ```
         * @example
         * ```javascript
         * Jodit.make('#editor2', {
         *     buttons: [{
         *         name: 'empty',
         *         icon: 'source',
         *         exec: function (editor) {
         *             const dialog = new Jodit.modules.Dialog({}),
         *                 text = editor.c.element('textarea');
         *
         *             dialog.setHeader('Source code');
         *             dialog.setContent(text);
         *             dialog.setSize(400, 300);
         *
         *             Jodit.modules.Helpers.css(elm, {
         *                 width: '100%',
         *                 height: '100%'
         *             })
    
         *             dialog.open();
         *         }
         *     }]
         * });
         * ```
         * @example
         * ```javascript
         * Jodit.make('#editor2', {
         *     buttons: Jodit.defaultOptions.buttons.concat([{
         *        name: 'listsss',
         *        iconURL: 'stuf/dummy.png',
         *        list: {
         *            h1: 'insert Header 1',
         *            h2: 'insert Header 2',
         *            clear: 'Empty editor',
         *        },
         *        exec: ({originalEvent, control, btn}) => {
         *             var key = control.args[0],
         *                value = control.args[1];
         *             if (key === 'clear') {
         *                 this.val('');
         *                 return;
         *             }
         *             this.s.insertNode(this.c.element(key, ''));
         *             this.message.info('Was inserted ' + value);
         *        },
         *        template: function (key, value) {
         *            return '<div>' + value + '</div>';
         *        }
         *  });
         * ```
         */ this.buttons = [
            {
                group: 'font-style',
                buttons: []
            },
            {
                group: 'list',
                buttons: []
            },
            {
                group: 'font',
                buttons: []
            },
            '---',
            {
                group: 'script',
                buttons: []
            },
            {
                group: 'media',
                buttons: []
            },
            '\n',
            {
                group: 'state',
                buttons: []
            },
            {
                group: 'clipboard',
                buttons: []
            },
            {
                group: 'insert',
                buttons: []
            },
            {
                group: 'indent',
                buttons: []
            },
            {
                group: 'color',
                buttons: []
            },
            {
                group: 'form',
                buttons: []
            },
            '---',
            {
                group: 'history',
                buttons: []
            },
            {
                group: 'search',
                buttons: []
            },
            {
                group: 'source',
                buttons: []
            },
            {
                group: 'other',
                buttons: []
            },
            {
                group: 'info',
                buttons: []
            }
        ];
        /**
         * Some events are called when the editor is initialized, for example, the `afterInit` event.
         * So this code won't work:
         * ```javascript
         * const editor = Jodit.make('#editor');
         * editor.events.on('afterInit', () => console.log('afterInit'));
         * ```
         * You need to do this:
         * ```javascript
         * Jodit.make('#editor', {
         * 		events: {
         * 	  	afterInit: () => console.log('afterInit')
         * 		}
         * });
         * ```
         * The option can use any Jodit events, for example:
         * ```javascript
         * const editor = Jodit.make('#editor', {
         * 		events: {
         * 			hello: (name) => console.log('Hello', name)
         * 		}
         * });
         * editor.e.fire('hello', 'Mike');
         * ```
         */ this.events = {};
        /**
         * Buttons in toolbat without SVG - only texts
         */ this.textIcons = false;
        /**
         * Element for dialog container
         */ this.popupRoot = null;
        /**
         * shows a INPUT[type=color] to open the browser color picker, on the right bottom of widget color picker
         */ this.showBrowserColorPicker = true;
    }
}
Config.prototype.controls = {};



/***/ }),

/***/ 6687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export redoUndo */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(580);
/* harmony import */ var _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20356);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6441);
/* harmony import */ var _icons_redo_svg_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66863);
/* harmony import */ var _icons_undo_svg_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64489);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 






_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .I.set('redo', _icons_redo_svg_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A).set('undo', _icons_undo_svg_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A);
_config_js__WEBPACK_IMPORTED_MODULE_4__/* .Config */ .T.prototype.controls.redo = {
    mode: _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_SPLIT,
    isDisabled: (editor)=>!editor.history.canRedo(),
    tooltip: 'Redo'
};
_config_js__WEBPACK_IMPORTED_MODULE_4__/* .Config */ .T.prototype.controls.undo = {
    mode: _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_SPLIT,
    isDisabled: (editor)=>!editor.history.canUndo(),
    tooltip: 'Undo'
};
/**
 * Custom process Redo and Undo functionality
 */ class redoUndo extends _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_2__/* .Plugin */ .k {
    beforeDestruct() {
    // do nothing
    }
    afterInit(editor) {
        const callback = (command)=>{
            editor.history[command]();
            return false;
        };
        editor.registerCommand('redo', {
            exec: callback,
            hotkeys: [
                'ctrl+y',
                'ctrl+shift+z',
                'cmd+y',
                'cmd+shift+z'
            ]
        });
        editor.registerCommand('undo', {
            exec: callback,
            hotkeys: [
                'ctrl+z',
                'cmd+z'
            ]
        });
    }
    constructor(){
        super(...arguments);
        /** @override */ this.buttons = [
            {
                name: 'undo',
                group: 'history'
            },
            {
                name: 'redo',
                group: 'history'
            }
        ];
    }
}
_core_global_js__WEBPACK_IMPORTED_MODULE_1__/* .pluginSystem */ .fg.add('redoUndo', redoUndo);


/***/ }),

/***/ 6700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   w: function() { return /* binding */ Storage; }
/* harmony export */ });
/* unused harmony export StorageKey */
/* harmony import */ var _helpers_string_camel_case_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87058);
/* harmony import */ var _engines_local_storage_provider_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65638);
/* harmony import */ var _engines_memory_storage_provider_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21162);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


const StorageKey = 'Jodit_';
class Storage {
    set(key, value) {
        this.provider.set((0,_helpers_string_camel_case_js__WEBPACK_IMPORTED_MODULE_1__/* .camelCase */ .x)(this.prefix + key), value);
        return this;
    }
    delete(key) {
        this.provider.delete((0,_helpers_string_camel_case_js__WEBPACK_IMPORTED_MODULE_1__/* .camelCase */ .x)(this.prefix + key));
        return this;
    }
    get(key) {
        return this.provider.get((0,_helpers_string_camel_case_js__WEBPACK_IMPORTED_MODULE_1__/* .camelCase */ .x)(this.prefix + key));
    }
    exists(key) {
        return this.provider.exists((0,_helpers_string_camel_case_js__WEBPACK_IMPORTED_MODULE_1__/* .camelCase */ .x)(this.prefix + key));
    }
    clear() {
        this.provider.clear();
        return this;
    }
    static makeStorage(persistent = false, suffix) {
        let provider;
        if (persistent && (0,_engines_local_storage_provider_js__WEBPACK_IMPORTED_MODULE_0__/* .canUsePersistentStorage */ .I)()) {
            provider = new _engines_local_storage_provider_js__WEBPACK_IMPORTED_MODULE_0__/* .LocalStorageProvider */ .O(StorageKey + suffix);
        }
        if (!provider) {
            provider = new _engines_memory_storage_provider_js__WEBPACK_IMPORTED_MODULE_2__/* .MemoryStorageProvider */ .M();
        }
        return new Storage(provider, suffix);
    }
    constructor(provider, suffix){
        this.provider = provider;
        this.prefix = StorageKey;
        if (suffix) {
            this.prefix += suffix;
        }
    }
}


/***/ }),

/***/ 6950:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 24 24\"> <path stroke-width=\"0\" d=\"M22,20.6L3.4,2H8V0H0v8h2V3.4L20.6,22H16v2h8v-8h-2V20.6z M16,0v2h4.7l-6.3,6.3l1.4,1.4L22,3.5V8h2V0H16z M8.3,14.3L2,20.6V16H0v8h8v-2H3.5l6.3-6.3L8.3,14.3z\"/> </svg> ");


/***/ }),

/***/ 6980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Y: function() { return /* binding */ wrapUnwrappedText; }
/* harmony export */ });
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _helpers_checker_is_marker_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78116);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/**
 * Wrap text or inline elements inside Block element
 * @private
 */ function wrapUnwrappedText(style, elm, jodit) {
    const root = jodit.editor, ci = jodit.createInside, edge = (n, key = 'previousSibling')=>{
        let edgeNode = n, node = n;
        while(node && !(0,_helpers_checker_is_marker_js__WEBPACK_IMPORTED_MODULE_1__/* .isMarker */ .r)(node)){
            if (_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(node, jodit.o.enter)) {
                break;
            }
            edgeNode = node;
            if (node[key]) {
                node = node[key];
            } else {
                node = node.parentNode && !_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isBlock(node.parentNode) && node.parentNode !== root ? node.parentNode : null;
            }
            if (_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isBlock(node)) {
                break;
            }
        }
        return edgeNode;
    };
    const start = edge(elm), end = edge(elm, 'nextSibling');
    const range = jodit.s.createRange();
    range.setStartBefore(start);
    range.setEndAfter(end);
    const fragment = range.extractContents();
    const wrapper = ci.element(style.element);
    wrapper.appendChild(fragment);
    _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeInsertNode(range, wrapper);
    if (style.elementIsBlock) {
        if (_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isEmpty(wrapper) && !_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(wrapper.firstElementChild, 'br')) {
            wrapper.appendChild(ci.element('br'));
        }
    }
    return wrapper;
}


/***/ }),

/***/ 7087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PasteFromWordPro: function() { return /* binding */ PasteFromWordPro; }
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64310);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46788);
/* harmony import */ var jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82758);
/* harmony import */ var jodit_esm_core_helpers_checker_is_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70799);
/* harmony import */ var jodit_esm_plugins_paste_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(117);
/* harmony import */ var jodit_esm_plugins_paste_from_word_paste_from_word__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31571);
/* harmony import */ var jodit_pro_jodit_pro__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34013);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */







class PasteFromWordPro extends jodit_esm_plugins_paste_from_word_paste_from_word__WEBPACK_IMPORTED_MODULE_4__/* .pasteFromWord */ .s {
    insertFromWordByType(e, html, insertType, texts) {
        if (this.j.o.pasteFromWord.enable &&
            (insertType === jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_2__.INSERT_AS_HTML || insertType === jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_2__.INSERT_AS_TEXT)) {
            html = (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .applyStylesPro */ .GW)(this.j, html, insertType === jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_2__.INSERT_AS_TEXT, texts.rtf);
            // @ts-ignore
            if (this.j.o.beautifyHTML) {
                const value = this.j.events?.fire('beautifyHTML', html);
                if ((0,jodit_esm_core_helpers_checker_is_string__WEBPACK_IMPORTED_MODULE_6__/* .isString */ .K)(value)) {
                    html = value;
                }
            }
            (0,jodit_esm_plugins_paste_helpers__WEBPACK_IMPORTED_MODULE_3__/* .pasteInsertHtml */ .sX)(e, this.j, html);
            return;
        }
        return super.insertFromWordByType(e, html, insertType, texts);
    }
}
/** @override */
PasteFromWordPro.requires = ['license'];
jodit_pro_jodit_pro__WEBPACK_IMPORTED_MODULE_5__/* .JoditPro */ .A.plugins.remove('pasteFromWord');
jodit_pro_jodit_pro__WEBPACK_IMPORTED_MODULE_5__/* .JoditPro */ .A.plugins.add('pasteFromWordPro', PasteFromWordPro);


/***/ }),

/***/ 7309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export stat */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20356);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99649);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 




/**
 * Show stat data - words and chars count
 */ class stat extends _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_3__/* .Plugin */ .k {
    /** @override */ afterInit() {
        this.charCounter = this.j.c.span();
        this.wordCounter = this.j.c.span();
        this.j.e.on('afterInit changePlace afterAddPlace', this.reInit);
        this.reInit();
    }
    /** @override */ beforeDestruct() {
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(this.charCounter);
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(this.wordCounter);
        this.j.e.off('afterInit changePlace afterAddPlace', this.reInit);
        this.charCounter = null;
        this.wordCounter = null;
    }
    constructor(){
        super(...arguments);
        this.charCounter = null;
        this.wordCounter = null;
        this.reInit = ()=>{
            if (this.j.o.showCharsCounter && this.charCounter) {
                this.j.statusbar.append(this.charCounter, true);
            }
            if (this.j.o.showWordsCounter && this.wordCounter) {
                this.j.statusbar.append(this.wordCounter, true);
            }
            this.j.e.off('change keyup', this.calc).on('change keyup', this.calc);
            this.calc();
        };
        this.calc = this.j.async.throttle(()=>{
            const text = this.j.text;
            if (this.j.o.showCharsCounter && this.charCounter) {
                let chars;
                if (this.j.o.countHTMLChars) {
                    chars = this.j.value;
                } else {
                    if (this.j.o.countTextSpaces) {
                        chars = text.replace((0,_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE_REG_EXP)(), '').replace(/[\r\n]/g, '');
                    } else {
                        chars = text.replace((0,_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.SPACE_REG_EXP)(), '');
                    }
                }
                this.charCounter.textContent = this.j.i18n('Chars: %d', chars.length);
            }
            if (this.j.o.showWordsCounter && this.wordCounter) {
                this.wordCounter.textContent = this.j.i18n('Words: %d', text.replace((0,_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE_REG_EXP)(), '').split((0,_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.SPACE_REG_EXP)()).filter((e)=>e.length).length);
            }
        }, this.j.defaultTimeout);
    }
}
_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .pluginSystem */ .fg.add('stat', stat);


/***/ }),

/***/ 7483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   S: function() { return /* binding */ TextAreaEditor; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41180);
/* harmony import */ var _sourceEditor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23370);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


class TextAreaEditor extends _sourceEditor_js__WEBPACK_IMPORTED_MODULE_1__/* .SourceEditor */ .F {
    init(editor) {
        this.instance = editor.c.element('textarea', {
            class: 'jodit-source__mirror',
            dir: editor.o.direction === 'rtl' ? 'rtl' : undefined
        });
        this.container.appendChild(this.instance);
        editor.e.on(this.instance, 'mousedown keydown touchstart input', editor.async.debounce(this.toWYSIWYG, editor.defaultTimeout)).on('setMinHeight.source', (minHeightD)=>{
            (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_2__/* .css */ .A)(this.instance, 'minHeight', minHeightD);
        }).on(this.instance, 'change keydown mousedown touchstart input', this.autosize).on('afterSetMode.source', this.autosize).on(this.instance, 'mousedown focus', (e)=>{
            editor.e.fire(e.type, e);
        });
        this.autosize();
        this.onReady();
    }
    destruct() {
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(this.instance);
    }
    getValue() {
        return this.instance.value;
    }
    setValue(raw) {
        this.instance.value = raw;
    }
    insertRaw(raw) {
        const value = this.getValue();
        if (this.getSelectionStart() >= 0) {
            const startPos = this.getSelectionStart(), endPos = this.getSelectionEnd();
            this.setValue(value.substring(0, startPos) + raw + value.substring(endPos, value.length));
        } else {
            this.setValue(value + raw);
        }
    }
    getSelectionStart() {
        return this.instance.selectionStart;
    }
    getSelectionEnd() {
        return this.instance.selectionEnd;
    }
    setSelectionRange(start, end = start) {
        this.instance.setSelectionRange(start, end);
    }
    get isFocused() {
        return this.instance === this.j.od.activeElement;
    }
    focus() {
        this.instance.focus();
    }
    blur() {
        this.instance.blur();
    }
    setPlaceHolder(title) {
        this.instance.setAttribute('placeholder', title);
    }
    setReadOnly(isReadOnly) {
        if (isReadOnly) {
            this.instance.setAttribute('readonly', 'true');
        } else {
            this.instance.removeAttribute('readonly');
        }
    }
    selectAll() {
        this.instance.select();
    }
    replaceUndoManager() {
        const { history } = this.jodit;
        this.j.e.on(this.instance, 'keydown', (e)=>{
            if ((e.ctrlKey || e.metaKey) && e.key === 'z') {
                if (e.shiftKey) {
                    history.redo();
                } else {
                    history.undo();
                }
                this.setSelectionRange(this.getValue().length);
                return false;
            }
        });
    }
    constructor(){
        super(...arguments);
        this.autosize = this.j.async.debounce(()=>{
            this.instance.style.height = 'auto';
            this.instance.style.height = this.instance.scrollHeight + 'px';
        }, this.j.defaultTimeout);
    }
}


/***/ }),

/***/ 7886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    aiAssistant: 'Asistente de IA',
    aiCommands: 'Comandos de IA',
    'AI Assistant': 'Asistente de IA',
    'AI Commands': 'Comandos de IA',
    'Improve writing': 'Mejorar escritura',
    'Make shorter': 'Hacer más corto',
    'Make longer': 'Hacer más largo',
    'Simplify language': 'Simplificar lenguaje',
    Summarize: 'Resumir',
    Continue: 'Continuar',
    Prompt: 'Solicitud',
    Insert: 'Insertar',
    'Insert After': 'Insertar después',
    'Try Again': 'Intentar de nuevo',
    'Ask AI to improve generated text': 'Pida a la IA que mejore el texto generado',
    'Change tone to professional': 'Cambiar tono a profesional',
    'Change tone to friendly': 'Cambiar tono a amigable',
    'Change tone to formal': 'Cambiar tono a formal',
    'Change tone to casual': 'Cambiar tono a casual',
    'Change tone to direct': 'Cambiar tono a directo',
    'Change tone to confident': 'Cambiar tono a confiado',
    'Change tone to business': 'Cambiar tono a empresarial',
    'Change style to legal': 'Cambiar estilo a legal',
    'Change style to journalism': 'Cambiar estilo a periodístico',
    'Change style to poetic': 'Cambiar estilo a poético',
    'Translate to Spanish': 'Traducir al español',
    'Translate to French': 'Traducir al francés',
    'Translate to German': 'Traducir al alemán',
    'Translate to Italian': 'Traducir al italiano',
    'Translate to Portuguese': 'Traducir al portugués',
    'Translate to English': 'Traducir al inglés',
    'Translate to Chinese': 'Traducir al chino',
    'Translate to Japanese': 'Traducid al japonés',
    'Translate to Korean': 'Traducir al coreano',
    'Translate to Russian': 'Traducir al ruso',
    'Translate to Arabic': 'Traducir al árabe',
    Submit: 'Enviar'
});


/***/ }),

/***/ 7903:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1472 930v318q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q63 0 117 25 15 7 18 23 3 17-9 29l-49 49q-10 10-23 10-3 0-9-2-23-6-45-6h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-254q0-13 9-22l64-64q10-10 23-10 6 0 12 3 20 8 20 29zm231-489l-814 814q-24 24-57 24t-57-24l-430-430q-24-24-24-57t24-57l110-110q24-24 57-24t57 24l263 263 647-647q24-24 57-24t57 24l110 110q24 24 24 57t-24 57z\"/> </svg> ");


/***/ }),

/***/ 8172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Q: function() { return /* reexport safe */ _files_files_js__WEBPACK_IMPORTED_MODULE_0__.Q; },
/* harmony export */   V: function() { return /* reexport safe */ _tree_tree_js__WEBPACK_IMPORTED_MODULE_1__.V; }
/* harmony export */ });
/* harmony import */ var _files_files_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97379);
/* harmony import */ var _tree_tree_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8193);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module modules/file-browser
 */ 



/***/ }),

/***/ 8193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   V: function() { return /* binding */ FileBrowserTree; }
/* harmony export */ });
/* harmony import */ var _core_ui_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67510);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
class FileBrowserTree extends _core_ui_index_js__WEBPACK_IMPORTED_MODULE_0__/* .UIGroup */ .Ue {
    className() {
        return 'FileBrowserTree';
    }
}


/***/ }),

/***/ 8355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export preview */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_utils_print_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11628);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



_config_js__WEBPACK_IMPORTED_MODULE_3__/* .Config */ .T.prototype.controls.preview = {
    icon: 'eye',
    command: 'preview',
    mode: _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_SOURCE + _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_WYSIWYG,
    tooltip: 'Preview'
};
function preview(editor) {
    editor.registerButton({
        name: 'preview'
    });
    editor.registerCommand('preview', (_, _1, defaultValue)=>{
        const dialog = editor.dlg();
        dialog.setSize(1024, 600).open('', editor.i18n('Preview')).setModal(true);
        const [, onDestrcut] = (0,_core_helpers_utils_print_js__WEBPACK_IMPORTED_MODULE_2__/* .previewBox */ .u)(editor, defaultValue, 'px', dialog.getElm('content'));
        dialog.e.on(dialog, 'afterClose', onDestrcut);
    });
}
_core_global_js__WEBPACK_IMPORTED_MODULE_1__/* .pluginSystem */ .fg.add('preview', preview);


/***/ }),

/***/ 8661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    newline: 'linha',
    delete: 'excluir',
    space: 'espaco',
    'Speech Recognize': 'Discurso Reconhecer',
    Sound: 'Som',
    'Interim Results': 'Resultados Provisórios'
});


/***/ }),

/***/ 8884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   j: function() { return /* reexport safe */ _async_js__WEBPACK_IMPORTED_MODULE_0__.j; }
/* harmony export */ });
/* harmony import */ var _async_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26992);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module async
 */ 


/***/ }),

/***/ 8959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $6: function() { return /* reexport safe */ _select_select_js__WEBPACK_IMPORTED_MODULE_4__.$; },
/* harmony export */   F0: function() { return /* reexport safe */ _area_area_js__WEBPACK_IMPORTED_MODULE_0__.F; },
/* harmony export */   cY: function() { return /* reexport safe */ _checkbox_checkbox_js__WEBPACK_IMPORTED_MODULE_1__.c; },
/* harmony export */   nE: function() { return /* reexport safe */ _file_file_js__WEBPACK_IMPORTED_MODULE_2__.n; },
/* harmony export */   tS: function() { return /* reexport safe */ _input_input_js__WEBPACK_IMPORTED_MODULE_3__.t; }
/* harmony export */ });
/* harmony import */ var _area_area_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85120);
/* harmony import */ var _checkbox_checkbox_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17328);
/* harmony import */ var _file_file_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4242);
/* harmony import */ var _input_input_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80256);
/* harmony import */ var _select_select_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12234);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module ui/form
 */ 






/***/ }),

/***/ 9045:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.dtd = {
    removeExtraBr: true,
    checkBlockNesting: true,
    blockLimits: {
        article: 1,
        aside: 1,
        audio: 1,
        body: 1,
        caption: 1,
        details: 1,
        dir: 1,
        div: 1,
        dl: 1,
        fieldset: 1,
        figcaption: 1,
        figure: 1,
        footer: 1,
        form: 1,
        header: 1,
        hgroup: 1,
        main: 1,
        menu: 1,
        nav: 1,
        ol: 1,
        section: 1,
        table: 1,
        td: 1,
        th: 1,
        tr: 1,
        ul: 1,
        video: 1
    }
};


/***/ }),

/***/ 9159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export resizeHandler */
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22732);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50911);
/* harmony import */ var _core_ui_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67510);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68252);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






let resizeHandler = class resizeHandler extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Plugin */ .k {
    /** @override **/ afterInit(editor) {
        const { height, width, allowResizeX } = editor.o;
        let { allowResizeY } = editor.o;
        if (height === 'auto' && width !== 'auto') {
            allowResizeY = false;
        }
        if ((height !== 'auto' || width !== 'auto') && (allowResizeX || allowResizeY)) {
            editor.statusbar.setMod('resize-handle', true);
            editor.e.on('toggleFullSize.resizeHandler', ()=>{
                this.handle.style.display = editor.isFullSize ? 'none' : 'block';
            }).on(this.handle, 'mousedown touchstart', this.onHandleResizeStart).on(editor.ow, 'mouseup touchend', this.onHandleResizeEnd);
            editor.container.appendChild(this.handle);
        }
    }
    /**
     * Handler: Click on handle - start resizing
     */ onHandleResizeStart(e) {
        this.isResized = true;
        this.start.x = e.clientX;
        this.start.y = e.clientY;
        this.start.w = this.j.container.offsetWidth;
        this.start.h = this.j.container.offsetHeight;
        this.j.lock();
        this.j.e.on(this.j.ow, 'mousemove touchmove', this.onHandleResize);
        e.preventDefault();
    }
    /**
     * Handler: Mouse move after start resizing
     */ onHandleResize(e) {
        if (!this.isResized) {
            return;
        }
        if (this.j.o.allowResizeY) {
            this.j.e.fire('setHeight', this.start.h + e.clientY - this.start.y);
        }
        if (this.j.o.allowResizeX) {
            this.j.e.fire('setWidth', this.start.w + e.clientX - this.start.x);
        }
        this.j.e.fire('resize');
    }
    /**
     * End of resizing
     */ onHandleResizeEnd() {
        if (this.isResized) {
            this.isResized = false;
            this.j.e.off(this.j.ow, 'mousemove touchmove', this.onHandleResize);
            this.j.unlock();
        }
    }
    /** @override **/ beforeDestruct() {
        _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(this.handle);
        this.j.e.off(this.j.ow, 'mouseup touchsend', this.onHandleResizeEnd);
    }
    constructor(){
        super(...arguments);
        /**
         * Plugin in resize process
         */ this.isResized = false;
        /**
         * Start point
         */ this.start = {
            x: 0,
            y: 0,
            w: 0,
            h: 0
        };
        /**
         * Resize handle
         */ this.handle = this.j.c.div('jodit-editor__resize', _core_ui_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .In.get('resize_handler'));
    }
};
/** @override **/ resizeHandler.requires = [
    'size'
];
resizeHandler = __decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], resizeHandler);

_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .pluginSystem */ .fg.add('resizeHandler', resizeHandler);


/***/ }),

/***/ 9881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export select */
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_string_camel_case_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87058);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50911);
/* harmony import */ var _core_ui_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67510);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67215);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







/**
 * A utility plugin that allows you to subscribe to a click/mousedown/touchstart/mouseup on an element in DOM order
 *
 * @example
 * ```js
 * const editor = Jodit.make('#editor');
 * editor.e.on('clickImg', (img) => {
 *   console.log(img.src);
 * })
 * ```
 */ class select extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Plugin */ .k {
    afterInit(jodit) {
        this.proxyEventsList.forEach((eventName)=>{
            jodit.e.on(eventName + '.select', this.onStartSelection);
        });
    }
    beforeDestruct(jodit) {
        this.proxyEventsList.forEach((eventName)=>{
            jodit.e.on(eventName + '.select', this.onStartSelection);
        });
    }
    onStartSelection(e) {
        const { j } = this;
        let result, target = e.target;
        while(result === undefined && target && target !== j.editor){
            result = j.e.fire((0,_core_helpers_string_camel_case_js__WEBPACK_IMPORTED_MODULE_6__/* .camelCase */ .x)(e.type + '_' + target.nodeName.toLowerCase()), target, e);
            target = target.parentElement;
        }
        if (e.type === 'click' && result === undefined && target === j.editor) {
            j.e.fire(e.type + 'Editor', target, e);
        }
    }
    /**
     * @event outsideClick(e) - when user clicked on the outside of editor
     */ onOutsideClick(e) {
        const node = e.target;
        if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.up(node, (elm)=>elm === this.j.editor)) {
            return;
        }
        const box = _core_ui_index_js__WEBPACK_IMPORTED_MODULE_4__/* .UIElement */ .D$.closestElement(node, _core_ui_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Popup */ .zD);
        if (!box) {
            this.j.e.fire('outsideClick', e);
        }
    }
    beforeCommandCut() {
        const { s } = this.j;
        if (!s.isCollapsed()) {
            const current = s.current();
            if (current && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isOrContains(this.j.editor, current)) {
                this.onCopyNormalizeSelectionBound();
            }
        }
    }
    beforeCommandSelectAll() {
        const { s } = this.j;
        s.focus();
        s.select(this.j.editor, true);
        s.expandSelection();
        return false;
    }
    /**
     * Normalize selection after triple click
     */ onTripleClickNormalizeSelection(e) {
        if (e.detail !== 3 || !this.j.o.select.normalizeTripleClick) {
            return;
        }
        const { s } = this.j;
        const { startContainer, startOffset } = s.range;
        if (startOffset === 0 && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isText(startContainer)) {
            s.select(_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.closest(startContainer, _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isBlock, this.j.editor) || startContainer, true);
        }
    }
    onCopyNormalizeSelectionBound(e) {
        const { s, editor, o } = this.j;
        if (!o.select.normalizeSelectionBeforeCutAndCopy || s.isCollapsed()) {
            return;
        }
        if (e && (!e.isTrusted || !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isNode(e.target) || !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isOrContains(editor, e.target))) {
            return;
        }
        this.jodit.s.expandSelection();
    }
    constructor(){
        super(...arguments);
        this.proxyEventsList = [
            'click',
            'mousedown',
            'touchstart',
            'mouseup',
            'touchend'
        ];
    }
}
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], select.prototype, "onStartSelection", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)('ow:click')
], select.prototype, "onOutsideClick", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)([
        ':beforeCommandCut'
    ])
], select.prototype, "beforeCommandCut", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)([
        ':beforeCommandSelectall'
    ])
], select.prototype, "beforeCommandSelectAll", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)([
        ':click'
    ])
], select.prototype, "onTripleClickNormalizeSelection", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)([
        ':copy',
        ':cut'
    ])
], select.prototype, "onCopyNormalizeSelectionBound", null);
_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .pluginSystem */ .fg.add('select', select);


/***/ }),

/***/ 9914:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 48 48\"> <path d=\"M6 18h4v-4h-4v4zm0-8h4v-4h-4v4zm8 32h4v-4h-4v4zm0-16h4v-4h-4v4zm-8 0h4v-4h-4v4zm0 16h4v-4h-4v4zm0-8h4v-4h-4v4zm8-24h4v-4h-4v4zm24 24h4v-4h-4v4zm-16 8h4v-36h-4v36zm16 0h4v-4h-4v4zm0-16h4v-4h-4v4zm0-20v4h4v-4h-4zm0 12h4v-4h-4v4zm-8-8h4v-4h-4v4zm0 32h4v-4h-4v4zm0-16h4v-4h-4v4z\"/> <path d=\"M0 0h48v48h-48z\" fill=\"none\"/> </svg> ");


/***/ }),

/***/ 9992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   F: function() { return /* binding */ normalizePath; }
/* harmony export */ });
/* harmony import */ var _string_trim_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49055);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/normalize
 */ 
/**
 * Replaces back slashes and correctly concatenates several parts of the path.
 */ const normalizePath = (...path)=>{
    return path.filter((part)=>(0,_string_trim_js__WEBPACK_IMPORTED_MODULE_0__/* .trim */ .Bq)(part).length).map((part, index)=>{
        part = part.replace(/([^:])[\\/]+/g, '$1/');
        if (index) {
            part = part.replace(/^\//, '');
        }
        if (index !== path.length - 1) {
            part = part.replace(/\/$/, '');
        }
        return part;
    }).join('/');
};


/***/ }),

/***/ 10052:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 18 18\"> <g fill-rule=\"evenodd\" stroke=\"none\" stroke-width=\"1\"> <g transform=\"translate(-381.000000, -381.000000)\"> <g transform=\"translate(381.000000, 381.000000)\"> <path d=\"M0,2 L2,2 L2,0 C0.9,0 0,0.9 0,2 L0,2 Z M0,10 L2,10 L2,8 L0,8 L0,10 L0,10 Z M4,18 L6,18 L6,16 L4,16 L4,18 L4,18 Z M0,6 L2,6 L2,4 L0,4 L0,6 L0,6 Z M10,0 L8,0 L8,2 L10,2 L10,0 L10,0 Z M16,0 L16,2 L18,2 C18,0.9 17.1,0 16,0 L16,0 Z M2,18 L2,16 L0,16 C0,17.1 0.9,18 2,18 L2,18 Z M0,14 L2,14 L2,12 L0,12 L0,14 L0,14 Z M6,0 L4,0 L4,2 L6,2 L6,0 L6,0 Z M8,18 L10,18 L10,16 L8,16 L8,18 L8,18 Z M16,10 L18,10 L18,8 L16,8 L16,10 L16,10 Z M16,18 C17.1,18 18,17.1 18,16 L16,16 L16,18 L16,18 Z M16,6 L18,6 L18,4 L16,4 L16,6 L16,6 Z M16,14 L18,14 L18,12 L16,12 L16,14 L16,14 Z M12,18 L14,18 L14,16 L12,16 L12,18 L12,18 Z M12,2 L14,2 L14,0 L12,0 L12,2 L12,2 Z M4,14 L14,14 L14,4 L4,4 L4,14 L4,14 Z M6,6 L12,6 L12,12 L6,12 L6,6 L6,6 Z\"/> </g> </g> </g> </svg> ");


/***/ }),

/***/ 10263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   q: function() { return /* binding */ openImagePopup; }
/* harmony export */ });
/* harmony import */ var _core_helpers_checker_is_array_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68345);
/* harmony import */ var _core_helpers_size_position_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5700);
/* harmony import */ var _core_ui_popup_popup_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56917);
/* harmony import */ var _modules_widget_file_selector_file_selector_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34793);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



/** @private */ function openImagePopup(j, dialog, state, button) {
    const popup = new _core_ui_popup_popup_js__WEBPACK_IMPORTED_MODULE_0__/* .Popup */ .z(dialog);
    const closePopup = ()=>{
        popup.close();
        popup.destruct();
    };
    popup.setContent((0,_modules_widget_file_selector_file_selector_js__WEBPACK_IMPORTED_MODULE_1__/* .FileSelectorWidget */ .k)(j, {
        upload: (data)=>{
            if (data.files && data.files.length) {
                state.values.imageSrc = data.baseurl + data.files[0];
            }
            closePopup();
        },
        filebrowser: async (data)=>{
            if (data && (0,_core_helpers_checker_is_array_js__WEBPACK_IMPORTED_MODULE_2__/* .isArray */ .c)(data.files) && data.files.length) {
                state.values.imageSrc = data.files[0];
                closePopup();
            }
        }
    }, state.image, closePopup)).open(()=>(0,_core_helpers_size_position_js__WEBPACK_IMPORTED_MODULE_3__/* .position */ .G)(button));
}


/***/ }),

/***/ 10411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B: function() { return /* binding */ formTemplate; }
/* harmony export */ });
/* harmony import */ var _core_ui_button_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62843);
/* harmony import */ var _core_ui_form_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2525);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

const formTemplate = (editor)=>{
    const { openInNewTabCheckbox, noFollowCheckbox, modeClassName, selectSizeClassName, selectMultipleClassName, selectOptionsClassName } = editor.o.link;
    return new _core_ui_form_index_js__WEBPACK_IMPORTED_MODULE_1__/* .UIForm */ .XV(editor, [
        new _core_ui_form_index_js__WEBPACK_IMPORTED_MODULE_1__/* .UIBlock */ .Yh(editor, [
            new _core_ui_form_index_js__WEBPACK_IMPORTED_MODULE_1__/* .UIInput */ .tS(editor, {
                name: 'url',
                type: 'text',
                ref: 'url_input',
                label: 'URL',
                placeholder: 'http://',
                required: true
            })
        ]),
        new _core_ui_form_index_js__WEBPACK_IMPORTED_MODULE_1__/* .UIBlock */ .Yh(editor, [
            new _core_ui_form_index_js__WEBPACK_IMPORTED_MODULE_1__/* .UIInput */ .tS(editor, {
                name: 'content',
                ref: 'content_input',
                label: 'Text'
            })
        ], {
            ref: 'content_input_box'
        }),
        modeClassName ? new _core_ui_form_index_js__WEBPACK_IMPORTED_MODULE_1__/* .UIBlock */ .Yh(editor, [
            (()=>{
                if (modeClassName === 'input') {
                    return new _core_ui_form_index_js__WEBPACK_IMPORTED_MODULE_1__/* .UIInput */ .tS(editor, {
                        name: 'className',
                        ref: 'className_input',
                        label: 'Class name'
                    });
                }
                if (modeClassName === 'select') {
                    return new _core_ui_form_index_js__WEBPACK_IMPORTED_MODULE_1__/* .UISelect */ .$6(editor, {
                        name: 'className',
                        ref: 'className_select',
                        label: 'Class name',
                        size: selectSizeClassName,
                        multiple: selectMultipleClassName,
                        options: selectOptionsClassName
                    });
                }
                return null;
            })()
        ]) : null,
        openInNewTabCheckbox ? new _core_ui_form_index_js__WEBPACK_IMPORTED_MODULE_1__/* .UICheckbox */ .cY(editor, {
            name: 'target',
            ref: 'target_checkbox',
            label: 'Open in new tab'
        }) : null,
        noFollowCheckbox ? new _core_ui_form_index_js__WEBPACK_IMPORTED_MODULE_1__/* .UICheckbox */ .cY(editor, {
            name: 'nofollow',
            ref: 'nofollow_checkbox',
            label: 'No follow'
        }) : null,
        new _core_ui_form_index_js__WEBPACK_IMPORTED_MODULE_1__/* .UIBlock */ .Yh(editor, [
            new _core_ui_button_index_js__WEBPACK_IMPORTED_MODULE_0__/* .UIButton */ .lD(editor, {
                name: 'unlink',
                variant: 'default',
                text: 'Unlink'
            }),
            new _core_ui_button_index_js__WEBPACK_IMPORTED_MODULE_0__/* .UIButton */ .lD(editor, {
                name: 'insert',
                type: 'submit',
                variant: 'primary',
                text: 'Insert'
            })
        ], {
            align: 'full'
        })
    ]);
};


/***/ }),

/***/ 10766:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\"> <path stroke=\"null\" d=\"m42.276011,26.302547c0.098397,-0.76605 0.172194,-1.54407 0.172194,-2.33406s-0.073797,-1.56801 -0.172194,-2.33406l5.202718,-3.961917c0.467384,-0.359086 0.602679,-1.005441 0.29519,-1.532101l-4.919828,-8.29489c-0.307489,-0.51469 -0.947067,-0.730142 -1.500548,-0.51469l-6.125186,2.405877c-1.266856,-0.945594 -2.656707,-1.747553 -4.157255,-2.357999l-0.922468,-6.343855c-0.110696,-0.562568 -0.614979,-1.005441 -1.229957,-1.005441l-9.839656,0c-0.614979,0 -1.119261,0.442873 -1.217657,1.005441l-0.922468,6.343855c-1.500548,0.610446 -2.890399,1.400436 -4.157255,2.357999l-6.125186,-2.405877c-0.553481,-0.203482 -1.193058,0 -1.500548,0.51469l-4.919828,8.29489c-0.307489,0.51469 -0.172194,1.161045 0.29519,1.532101l5.190419,3.961917c-0.098397,0.76605 -0.172194,1.54407 -0.172194,2.33406s0.073797,1.56801 0.172194,2.33406l-5.190419,3.961917c-0.467384,0.359086 -0.602679,1.005441 -0.29519,1.532101l4.919828,8.29489c0.307489,0.51469 0.947067,0.730142 1.500548,0.51469l6.125186,-2.405877c1.266856,0.945594 2.656707,1.747553 4.157255,2.357999l0.922468,6.343855c0.098397,0.562568 0.602679,1.005441 1.217657,1.005441l9.839656,0c0.614979,0 1.119261,-0.442873 1.217657,-1.005441l0.922468,-6.343855c1.500548,-0.610446 2.890399,-1.400436 4.157255,-2.357999l6.125186,2.405877c0.553481,0.203482 1.193058,0 1.500548,-0.51469l4.919828,-8.29489c0.307489,-0.51469 0.172194,-1.161045 -0.29519,-1.532101l-5.190419,-3.961917zm-18.277162,6.044617c-4.759934,0 -8.609699,-3.746465 -8.609699,-8.378677s3.849766,-8.378677 8.609699,-8.378677s8.609699,3.746465 8.609699,8.378677s-3.849766,8.378677 -8.609699,8.378677z\"/> </svg> ");


/***/ }),

/***/ 10830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $n: function() { return /* binding */ Button; },
/* harmony export */   lD: function() { return /* binding */ UIButton; },
/* harmony export */   ue: function() { return /* binding */ UIButtonState; }
/* harmony export */ });
/* harmony import */ var _component_statuses_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78213);
/* harmony import */ var _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2748);
/* harmony import */ var _helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23282);
/* harmony import */ var _helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70799);
/* harmony import */ var _helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43555);
/* harmony import */ var _element_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48538);
/* harmony import */ var _group_list_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24536);
/* harmony import */ var _icon_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12153);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









const UIButtonState = ()=>({
        size: 'middle',
        type: 'button',
        role: 'button',
        name: '',
        value: '',
        variant: 'initial',
        disabled: false,
        activated: false,
        icon: {
            name: 'empty',
            fill: '',
            iconURL: ''
        },
        tooltip: '',
        text: '',
        tabIndex: undefined
    });
let UIButton = class UIButton extends _element_js__WEBPACK_IMPORTED_MODULE_4__/* .UIElement */ .D {
    /** @override */ className() {
        return 'UIButton';
    }
    /**
     * Set state
     */ setState(state) {
        Object.assign(this.state, state);
        return this;
    }
    /**
     * DOM container for text content
     */ get text() {
        const text = this.getElm('text');
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__/* .assert */ .vA)(text, 'Text element not found');
        return text;
    }
    /**
     * DOM container for icon
     */ get icon() {
        const icon = this.getElm('icon');
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__/* .assert */ .vA)(icon, 'Icon element not found');
        return icon;
    }
    onChangeSize() {
        this.setMod('size', this.state.size);
    }
    onChangeType() {
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__/* .attr */ .CF)(this.container, 'type', this.state.type);
    }
    onChangeRole() {
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__/* .attr */ .CF)(this.container, 'role', this.state.role);
    }
    /**
     * Set size from a parent list
     */ updateSize() {
        const pe = this.closest(_group_list_js__WEBPACK_IMPORTED_MODULE_5__/* .UIList */ .z);
        if (pe) {
            this.state.size = pe.buttonSize;
            return;
        }
    }
    onChangeStatus() {
        this.setMod('variant', this.state.variant);
    }
    onChangeText() {
        this.text.textContent = this.jodit.i18n(this.state.text);
    }
    onChangeTextSetMode() {
        this.setMod('text-icons', Boolean(this.state.text.trim().length));
    }
    onChangeDisabled() {
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__/* .attr */ .CF)(this.container, 'disabled', this.state.disabled || null);
    }
    onChangeActivated() {
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__/* .attr */ .CF)(this.container, 'aria-pressed', this.state.activated);
    }
    onChangeName() {
        this.container.classList.add(`${this.componentName}_${this.clearName(this.state.name)}`);
        this.name = this.state.name;
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__/* .attr */ .CF)(this.container, 'data-ref', this.state.name);
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__/* .attr */ .CF)(this.container, 'ref', this.state.name);
    }
    onChangeTooltip() {
        if (this.get('j.o.useNativeTooltip')) {
            (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__/* .attr */ .CF)(this.container, 'title', this.state.tooltip);
        }
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__/* .attr */ .CF)(this.container, 'aria-label', this.state.tooltip);
    }
    onChangeTabIndex() {
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__/* .attr */ .CF)(this.container, 'tabindex', this.state.tabIndex);
    }
    onChangeIcon() {
        const textIcons = this.get('j.o.textIcons');
        if (textIcons === true || (0,_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_7__/* .isFunction */ .T)(textIcons) && textIcons(this.state.name)) {
            return;
        }
        _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.detach(this.icon);
        const iconElement = _icon_js__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .I.makeIcon(this.j, this.state.icon);
        iconElement && this.icon.appendChild(iconElement);
    }
    /**
     * Set focus on an element
     */ focus() {
        this.container.focus();
    }
    /**
     * Element has focus
     */ isFocused() {
        const { activeElement } = this.od;
        return Boolean(activeElement && _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isOrContains(this.container, activeElement));
    }
    /** @override */ createContainer() {
        const cn = this.componentName;
        const button = this.j.c.element('button', {
            class: cn,
            type: 'button',
            role: 'button',
            ariaPressed: false
        });
        const icon = this.j.c.span(cn + '__icon');
        const text = this.j.c.span(cn + '__text');
        button.appendChild(icon);
        button.appendChild(text);
        return button;
    }
    destruct() {
        this.j.e.off(this.container);
        return super.destruct();
    }
    /**
     * Add action handler
     */ onAction(callback) {
        this.actionHandlers.push(callback);
        return this;
    }
    /**
     * Fire all click handlers
     */ __onActionFire(e) {
        e.buffer = {
            actionTrigger: this
        };
        this.actionHandlers.forEach((callback)=>callback.call(this, e));
    }
    constructor(jodit, state){
        super(jodit);
        /**
         * Marker for buttons
         */ this.isButton = true;
        this.state = UIButtonState();
        this.actionHandlers = [];
        this.button = this.container;
        this.updateSize();
        this.onChangeSize();
        this.onChangeStatus();
        if (state) {
            this.hookStatus(_component_statuses_js__WEBPACK_IMPORTED_MODULE_0__/* .STATUSES */ .f.ready, ()=>{
                this.setState(state);
            });
        }
    }
};
__decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.cache
], UIButton.prototype, "text", null);
__decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.cache
], UIButton.prototype, "icon", null);
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)('state.size', {
        immediately: false
    })
], UIButton.prototype, "onChangeSize", null);
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)('state.type', {
        immediately: false
    })
], UIButton.prototype, "onChangeType", null);
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)('state.role', {
        immediately: false
    })
], UIButton.prototype, "onChangeRole", null);
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)('parentElement')
], UIButton.prototype, "updateSize", null);
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)('state.variant', {
        immediately: false
    })
], UIButton.prototype, "onChangeStatus", null);
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)('state.text', {
        immediately: false
    })
], UIButton.prototype, "onChangeText", null);
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)('state.text', {
        immediately: false
    })
], UIButton.prototype, "onChangeTextSetMode", null);
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)('state.disabled')
], UIButton.prototype, "onChangeDisabled", null);
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)('state.activated')
], UIButton.prototype, "onChangeActivated", null);
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)('state.name', {
        immediately: false
    })
], UIButton.prototype, "onChangeName", null);
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)('state.tooltip', {
        immediately: false
    })
], UIButton.prototype, "onChangeTooltip", null);
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)('state.tabIndex', {
        immediately: false
    })
], UIButton.prototype, "onChangeTabIndex", null);
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)('state.icon', {
        immediately: false
    })
], UIButton.prototype, "onChangeIcon", null);
__decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.cacheHTML
], UIButton.prototype, "createContainer", null);
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)('button:click')
], UIButton.prototype, "__onActionFire", null);
UIButton = __decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.component
], UIButton);

function Button(jodit, stateOrText, text, variant) {
    const button = new UIButton(jodit);
    button.state.tabIndex = jodit.o.allowTabNavigation ? 0 : -1;
    if ((0,_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_8__/* .isString */ .K)(stateOrText)) {
        button.state.icon.name = stateOrText;
        button.state.name = stateOrText;
        if (variant) {
            button.state.variant = variant;
        }
        if (text) {
            button.state.text = text;
        }
    } else {
        button.setState(stateOrText);
    }
    return button;
}


/***/ }),

/***/ 10937:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M24.89 32h4.18L18.86 6h-3.71L4.93 32h4.18l2.25-6h11.29l2.24 6zM12.86 22L17 10.95 21.14 22h-8.28zm30.31 1.17L27 39.34 19.66 32l-2.83 2.83L27 45l19-19-2.83-2.83z\"/> </svg> ");


/***/ }),

/***/ 11317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export file */
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(580);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6441);
/* harmony import */ var _modules_widget_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92762);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.controls.file = {
    popup: (editor, current, close)=>{
        const insert = (url, title = '')=>{
            editor.s.insertNode(editor.createInside.fromHTML(`<a href="${url}" title="${title}">${title || url}</a>`));
        };
        let sourceAnchor = null;
        if (current && (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(current, 'a') || _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(current, 'a', editor.editor))) {
            sourceAnchor = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(current, 'a') ? current : _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(current, 'a', editor.editor);
        }
        return (0,_modules_widget_index_js__WEBPACK_IMPORTED_MODULE_3__/* .FileSelectorWidget */ .kG)(editor, {
            filebrowser: (data)=>{
                data.files && data.files.forEach((file)=>insert(data.baseurl + file));
                close();
            },
            upload: true,
            url: (url, text)=>{
                if (sourceAnchor) {
                    sourceAnchor.setAttribute('href', url);
                    sourceAnchor.setAttribute('title', text);
                } else {
                    insert(url, text);
                }
                close();
            }
        }, sourceAnchor, close, false);
    },
    tags: [
        'a'
    ],
    tooltip: 'Insert file'
};
function file(editor) {
    editor.registerButton({
        name: 'file',
        group: 'media'
    });
}
_core_global_js__WEBPACK_IMPORTED_MODULE_1__/* .pluginSystem */ .fg.add('file', file);


/***/ }),

/***/ 11338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   L: function() { return /* binding */ checkNotCollapsed; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * On Not collapsed selection - should only remove whole selected content
 *
 * @example
 * ```html
 * <p>first | stop</p><p>second | stop</p>
 * ```
 * result
 * ```html
 * <p>first | stop</p>
 * ```
 * @private
 */ function checkNotCollapsed(jodit) {
    if (!jodit.s.isCollapsed()) {
        jodit.execCommand('Delete');
        return true;
    }
    return false;
}


/***/ }),

/***/ 11628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   u: function() { return /* binding */ previewBox; }
/* harmony export */ });
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70799);
/* harmony import */ var _attr_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29960);
/* harmony import */ var _css_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41180);
/* harmony import */ var _selector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76078);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 




/**
 * Fixes image sizes and sets absolute paths to images
 */ function fixedAssetsSizeAndAbsoluteLinks(editor, points) {
    const restoreAttributes = [];
    try {
        (0,_selector_js__WEBPACK_IMPORTED_MODULE_2__.$$)('img', editor.editor).forEach((item)=>{
            const previousAttrs = [
                (0,_attr_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .C)(item, 'width'),
                (0,_attr_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .C)(item, 'height'),
                item.src
            ];
            (0,_attr_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .C)(item, {
                width: item.offsetWidth + points,
                height: item.offsetHeight + points
            });
            const a = editor.createInside.a();
            editor.ed.body.appendChild(a);
            a.href = item.src;
            item.src = a.href;
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(a);
            restoreAttributes.push(()=>{
                var _a;
                item.src = (_a = previousAttrs[2]) !== null && _a !== void 0 ? _a : '';
                (0,_attr_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .C)(item, {
                    width: previousAttrs[0] || null,
                    height: previousAttrs[1] || null
                });
            });
        });
    } catch (e) {
        restoreAttributes.forEach((c)=>c());
        restoreAttributes.length = 0;
        throw e;
    }
    return restoreAttributes;
}
/**
 * Generates a copy of an HTML document, resizes images, executes JS
 *
 * @event beforePreviewBox(string | undefined, 'pt' | 'px' | '')
 * @event afterPreviewBox(HTMLElement)
 */ function previewBox(editor, defaultValue, points = 'px', container = null) {
    const onDestruct = [];
    const restoreAttributes = fixedAssetsSizeAndAbsoluteLinks(editor, points);
    try {
        const res = editor.e.fire('beforePreviewBox', defaultValue, points);
        if (res != null) {
            return res;
        }
        let div = editor.c.div('jodit__preview-box jodit-context');
        if (container) {
            container.appendChild(div);
        }
        (0,_css_js__WEBPACK_IMPORTED_MODULE_3__/* .css */ .A)(div, {
            position: 'relative',
            padding: 16
        });
        const value = editor.value || `<div style='position: absolute;left:50%;top:50%;transform: translateX(-50%) translateY(-50%);color:#ccc;'>${editor.i18n('Empty')}</div>`;
        if (editor.iframe) {
            const iframe = editor.create.element('iframe');
            (0,_css_js__WEBPACK_IMPORTED_MODULE_3__/* .css */ .A)(iframe, {
                minWidth: 800,
                minHeight: 600,
                border: 0
            });
            div.appendChild(iframe);
            const myWindow = iframe.contentWindow;
            if (myWindow) {
                editor.e.fire('generateDocumentStructure.iframe', myWindow.document, editor);
                div = myWindow.document.body;
                if (typeof ResizeObserver === 'function') {
                    let destructed = false;
                    const elm = myWindow.document.body;
                    const resizeObserver = new ResizeObserver(editor.async.debounce(()=>{
                        resizeObserver.unobserve(elm);
                        iframe.style.height = `${elm.offsetHeight + 20}px`;
                        editor.async.requestAnimationFrame(()=>{
                            !destructed && resizeObserver.observe(elm);
                        });
                    }, 100));
                    const beforeDestruct = ()=>{
                        destructed = true;
                        resizeObserver.unobserve(elm);
                        resizeObserver.disconnect();
                        editor.e.off('beforeDestruct', beforeDestruct);
                    };
                    onDestruct.push(beforeDestruct);
                    editor.e.on('beforeDestruct', beforeDestruct);
                }
            }
        } else {
            (0,_css_js__WEBPACK_IMPORTED_MODULE_3__/* .css */ .A)(div, {
                minWidth: 1024,
                minHeight: 600,
                border: 0
            });
        }
        const setHTML = (box, value)=>{
            const dv = (0,_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__/* .isString */ .K)(value) ? editor.c.div() : value;
            if ((0,_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__/* .isString */ .K)(value)) {
                dv.innerHTML = value;
            }
            for(let i = 0; i < dv.childNodes.length; i += 1){
                const c = dv.childNodes[i];
                if (_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isElement(c)) {
                    const newNode = box.ownerDocument.createElement(c.nodeName);
                    for(let j = 0; j < c.attributes.length; j += 1){
                        (0,_attr_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .C)(newNode, c.attributes[j].nodeName, c.attributes[j].nodeValue);
                    }
                    if (c.childNodes.length === 0 || _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(c, 'table')) {
                        switch(c.nodeName){
                            case 'SCRIPT':
                                if (c.textContent) {
                                    newNode.textContent = c.textContent;
                                }
                                break;
                            default:
                                if (c.innerHTML) {
                                    newNode.innerHTML = c.innerHTML;
                                }
                                break;
                        }
                    } else {
                        setHTML(newNode, c);
                    }
                    try {
                        box.appendChild(newNode);
                    } catch (_a) {}
                } else {
                    try {
                        box.appendChild(c.cloneNode(true));
                    } catch (_b) {}
                }
            }
        };
        setHTML(div, value);
        editor.e.fire('afterPreviewBox', div);
        return [
            div,
            ()=>{
                onDestruct.forEach((cb)=>cb());
            }
        ];
    } finally{
        restoreAttributes.forEach((clb)=>clb());
    }
}


/***/ }),

/***/ 11676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Q: function() { return /* binding */ ToolbarCollection; }
/* harmony export */ });
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65478);
/* harmony import */ var _core_helpers_utils_error_error_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82760);
/* harmony import */ var _core_ui_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67510);
/* harmony import */ var _factory_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21491);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let ToolbarCollection = class ToolbarCollection extends _core_ui_index_js__WEBPACK_IMPORTED_MODULE_2__/* .UIList */ .z4 {
    /** @override */ className() {
        return 'ToolbarCollection';
    }
    /**
     * First button in a list
     */ get firstButton() {
        const [button] = this.buttons;
        return button || null;
    }
    makeButton(control, target = null) {
        return (0,_factory_js__WEBPACK_IMPORTED_MODULE_3__/* .makeButton */ .BJ)(this.j, control, target);
    }
    makeSelect(control, target = null) {
        return (0,_factory_js__WEBPACK_IMPORTED_MODULE_3__/* .makeSelect */ .RR)(this.j, control, target);
    }
    /**
     * Button should be active
     */ shouldBeActive(button) {
        return undefined;
    }
    /**
     * The Button should be disabled
     */ shouldBeDisabled(button) {
        return undefined;
    }
    /**
     * Returns current target for button
     */ getTarget(button) {
        return button.target || null;
    }
    __immediateUpdate() {
        if (this.isDestructed || this.j.isLocked) {
            return;
        }
        super.update();
        this.j.e.fire('afterUpdateToolbar', this);
    }
    update() {
        this.__immediateUpdate();
    }
    /**
     * Set direction
     */ setDirection(direction) {
        this.container.style.direction = direction;
        this.container.setAttribute('dir', direction);
    }
    __initEvents() {
        this.j.e.on(this.__listenEvents, this.update).on('afterSetMode focus', this.__immediateUpdate);
    }
    hide() {
        this.container.remove();
    }
    show() {
        this.appendTo(this.j.toolbarContainer);
    }
    showInline(bound) {
        throw (0,_core_helpers_utils_error_error_js__WEBPACK_IMPORTED_MODULE_1__/* .error */ .z3)('The method is not implemented for this class.');
    }
    /** @override **/ build(items, target = null) {
        const itemsWithGroupps = this.j.e.fire('beforeToolbarBuild', items);
        if (itemsWithGroupps) {
            items = itemsWithGroupps;
        }
        super.build(items, target);
        return this;
    }
    /** @override **/ destruct() {
        if (this.isDestructed) {
            return;
        }
        this.j.e.off(this.__listenEvents, this.update).off('afterSetMode focus', this.__immediateUpdate);
        super.destruct();
    }
    constructor(jodit){
        super(jodit);
        this.__listenEvents = 'updatePlugins updateToolbar changeStack mousedown mouseup keydown change afterInit readonly afterResize ' + 'selectionchange changeSelection focus afterSetMode touchstart focus blur';
    }
};
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], ToolbarCollection.prototype, "__immediateUpdate", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.debounce)((ctx)=>ctx.j.defaultTimeout, true)
], ToolbarCollection.prototype, "update", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.hook)('ready')
], ToolbarCollection.prototype, "__initEvents", null);
ToolbarCollection = __decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.component
], ToolbarCollection);



/***/ }),

/***/ 11787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   o: function() { return /* binding */ DEFAULT_SOURCE_NAME; }
/* harmony export */ });
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21537);
/* harmony import */ var _core_request_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41601);
/* harmony import */ var _builders_item_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(159);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





const DEFAULT_SOURCE_NAME = 'default';
const possibleRules = new Set([
    'allowFiles',
    'allowFileMove',
    'allowFileUpload',
    'allowFileUploadRemote',
    'allowFileRemove',
    'allowFileRename',
    'allowFolders',
    'allowFolderMove',
    'allowFolderCreate',
    'allowFolderRemove',
    'allowFolderRename',
    'allowImageResize',
    'allowImageCrop'
]);
let DataProvider = class DataProvider {
    /**
     * Alias for options
     */ get o() {
        return this.options;
    }
    get(name) {
        const instances = this.__ajaxInstances;
        if (instances.has(name)) {
            const ajax = instances.get(name);
            ajax === null || ajax === void 0 ? void 0 : ajax.abort();
            instances.delete(name);
        }
        const opts = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.ConfigProto)(this.options[name] !== undefined ? this.options[name] : {}, (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.ConfigProto)({
            onProgress: this.progressHandler
        }, this.o.ajax));
        if (opts.prepareData) {
            opts.data = opts.prepareData.call(this, opts.data);
        }
        const ajax = new _core_request_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Ajax */ .d(opts);
        instances.set(name, ajax);
        const promise = ajax.send();
        promise.finally(()=>{
            ajax.destruct();
            instances.delete(name);
            this.progressHandler(100);
        }).catch(()=>null);
        return promise.then((resp)=>resp.json()).then((resp)=>{
            if (resp && !this.isSuccess(resp)) {
                throw new Error(this.getMessage(resp));
            }
            return resp;
        });
    }
    onProgress(callback) {
        this.progressHandler = callback;
    }
    /**
     * Load permissions for path and source
     */ async permissions(path, source) {
        if (!this.o.permissions) {
            return null;
        }
        this.o.permissions.data.path = path;
        this.o.permissions.data.source = source;
        if (this.o.permissions.url) {
            return this.get('permissions').then((resp)=>{
                if (this.parent.isInDestruct) {
                    throw (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.abort)();
                }
                let process = this.o.permissions.process;
                if (!process) {
                    process = this.o.ajax.process;
                }
                if (process) {
                    const respData = process.call(self, resp);
                    if (respData.data.permissions) {
                        this.parent.events.fire(this, 'changePermissions', this.__currentPermissions, respData.data.permissions);
                        this.__currentPermissions = respData.data.permissions;
                    }
                }
                return this.__currentPermissions;
            });
        }
        return null;
    }
    canI(action) {
        const rule = 'allow' + action;
        if (!_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD) {
            if (!possibleRules.has(rule)) {
                throw (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.error)('Wrong action ' + action);
            }
        }
        const presetValue = this.o.permissionsPresets[rule];
        if (presetValue !== undefined) {
            return presetValue;
        }
        return this.__currentPermissions == null || this.__currentPermissions[rule] === undefined || this.__currentPermissions[rule];
    }
    __items(path, source, mods, onResult) {
        const opt = this.options;
        if (!opt.items) {
            return Promise.reject(Error('Set Items api options'));
        }
        opt.items.data.path = path;
        opt.items.data.source = source;
        opt.items.data.mods = mods;
        return this.get('items').then((resp)=>{
            let process = this.o.items.process;
            if (!process) {
                process = this.o.ajax.process;
            }
            if (process) {
                resp = process.call(self, resp);
            }
            return onResult(resp);
        });
    }
    /**
     * Load items list by path and source
     */ items(path, source, mods = {}) {
        return this.__items(path, source, mods, (resp)=>this.generateItemsList(resp.data.sources, mods));
    }
    /**
     * Load items list by path and source
     */ itemsEx(path, source, mods = {}) {
        const calcTotal = (sources)=>sources.reduce((acc, source)=>acc + source.files.length, 0);
        return this.__items(path, source, mods, (resp)=>({
                items: this.generateItemsList(resp.data.sources, mods),
                loadedTotal: calcTotal(resp.data.sources)
            }));
    }
    generateItemsList(sources, mods = {}) {
        const elements = [];
        const canBeFile = (item)=>item.type === 'folder' || !mods.onlyImages || item.isImage === undefined || item.isImage;
        const inFilter = (item)=>{
            var _a;
            return !((_a = mods.filterWord) === null || _a === void 0 ? void 0 : _a.length) || this.o.filter === undefined || this.o.filter(item, mods.filterWord);
        };
        sources.forEach((source)=>{
            if (source.files && source.files.length) {
                const { sort } = this.o;
                if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.isFunction)(sort) && mods.sortBy) {
                    source.files.sort((a, b)=>sort(a, b, mods.sortBy));
                }
                source.files.forEach((item)=>{
                    if (inFilter(item) && canBeFile(item)) {
                        elements.push(_builders_item_js__WEBPACK_IMPORTED_MODULE_4__/* .FileBrowserItem */ .u.create({
                            ...item,
                            sourceName: source.name,
                            source
                        }));
                    }
                });
            }
        });
        return elements;
    }
    async tree(path, source) {
        path = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.normalizeRelativePath)(path);
        if (!this.o.folder) {
            return Promise.reject(Error('Set Folder Api options'));
        }
        await this.permissions(path, source);
        this.o.folder.data.path = path;
        this.o.folder.data.source = source;
        return this.get('folder').then((resp)=>{
            let process = this.o.folder.process;
            if (!process) {
                process = this.o.ajax.process;
            }
            if (process) {
                resp = process.call(self, resp);
            }
            return resp.data.sources;
        });
    }
    /**
     * Get path by url. You can use this method in another modules
     */ getPathByUrl(url) {
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.set)('options.getLocalFileByUrl.data.url', url, this);
        return this.get('getLocalFileByUrl').then((resp)=>{
            if (this.isSuccess(resp)) {
                return resp.data;
            }
            throw (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.error)(this.getMessage(resp));
        });
    }
    /**
     * Create a directory on the server
     *
     * @param name - Name the new folder
     * @param path - Relative directory in which you want create a folder
     * @param source - Server source key
     */ createFolder(name, path, source) {
        const { create } = this.o;
        if (!create) {
            throw (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.error)('Set Create api options');
        }
        create.data.source = source;
        create.data.path = path;
        create.data.name = name;
        return this.get('create').then((resp)=>{
            if (this.isSuccess(resp)) {
                return true;
            }
            throw (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.error)(this.getMessage(resp));
        });
    }
    /**
     * Move a file / directory on the server
     *
     * @param filepath - The relative path to the file / folder source
     * @param path - Relative to the directory where you want to move the file / folder
     */ move(filepath, path, source, isFile) {
        const mode = isFile ? 'fileMove' : 'folderMove';
        const option = this.options[mode];
        if (!option) {
            throw (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.error)('Set Move api options');
        }
        option.data.from = filepath;
        option.data.path = path;
        option.data.source = source;
        return this.get(mode).then((resp)=>{
            if (this.isSuccess(resp)) {
                return true;
            }
            throw (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.error)(this.getMessage(resp));
        });
    }
    /**
     * Deleting item
     *
     * @param path - Relative path
     * @param file - The filename
     * @param source - Source
     */ remove(action, path, file, source) {
        const fr = this.o[action];
        if (!fr) {
            throw (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.error)(`Set "${action}" api options`);
        }
        fr.data.path = path;
        fr.data.name = file;
        fr.data.source = source;
        return this.get(action).then((resp)=>{
            if (fr.process) {
                resp = fr.process.call(this, resp);
            }
            return this.getMessage(resp);
        });
    }
    /**
     * Deleting a file
     *
     * @param path - Relative path
     * @param file - The filename
     * @param source - Source
     */ fileRemove(path, file, source) {
        return this.remove('fileRemove', path, file, source);
    }
    /**
     * Deleting a folder
     *
     * @param path - Relative path
     * @param file - The filename
     * @param source - Source
     */ folderRemove(path, file, source) {
        return this.remove('folderRemove', path, file, source);
    }
    /**
     * Rename action
     *
     * @param path - Relative path
     * @param name - Old name
     * @param newname - New name
     * @param source - Source
     */ rename(action, path, name, newname, source) {
        const fr = this.o[action];
        if (!fr) {
            throw (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.error)(`Set "${action}" api options`);
        }
        fr.data.path = path;
        fr.data.name = name;
        fr.data.newname = newname;
        fr.data.source = source;
        return this.get(action).then((resp)=>{
            if (fr.process) {
                resp = fr.process.call(self, resp);
            }
            return this.getMessage(resp);
        });
    }
    /**
     * Rename folder
     */ folderRename(path, name, newname, source) {
        return this.rename('folderRename', path, name, newname, source);
    }
    /**
     * Rename file
     */ fileRename(path, name, newname, source) {
        return this.rename('fileRename', path, name, newname, source);
    }
    changeImage(type, path, source, name, newname, box) {
        if (!this.o[type]) {
            this.o[type] = {
                data: {}
            };
        }
        const query = this.o[type];
        if (query.data === undefined) {
            query.data = {
                action: type
            };
        }
        query.data.newname = newname || name;
        if (box) {
            query.data.box = box;
        }
        query.data.path = path;
        query.data.name = name;
        query.data.source = source;
        return this.get(type).then(()=>{
            return true;
        });
    }
    /**
     * Send command to server to crop image
     */ crop(path, source, name, newname, box) {
        return this.changeImage('crop', path, source, name, newname, box);
    }
    /**
     * Send command to server to resize image
     */ resize(path, source, name, newname, box) {
        return this.changeImage('resize', path, source, name, newname, box);
    }
    getMessage(resp) {
        return this.options.getMessage(resp);
    }
    isSuccess(resp) {
        return this.options.isSuccess(resp);
    }
    destruct() {
        this.__ajaxInstances.forEach((a)=>a.destruct());
        this.__ajaxInstances.clear();
    }
    constructor(parent, options){
        this.parent = parent;
        this.options = options;
        this.__currentPermissions = null;
        this.__ajaxInstances = new Map();
        this.progressHandler = (ignore)=>{};
    }
};
DataProvider = __decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], DataProvider);
/* harmony default export */ __webpack_exports__.A = (DataProvider);


/***/ }),

/***/ 11991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   f: function() { return /* binding */ clearAttributes; }
/* harmony export */ });
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */
const extraAttributes = [
    'cellspacing',
    'cellpadding',
    'border',
    'v:shapes',
    'o:spid'
];
function clearAttributes(elm) {
    if (/^OLE_LINK\d+$/.test(elm.attributes.name)) {
        elm.attributes.name = null;
        if (elm.length === 0) {
            elm.remove();
            return null;
        }
    }
    if (elm.attributes.name === '_GoBack') {
        elm.attributes.name = null;
    }
    // Remove extra attributes
    for (const attr of extraAttributes) {
        if (elm.attributes[attr]) {
            elm.attributes[attr] = null;
        }
    }
    return elm;
}


/***/ }),

/***/ 12019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export resizer */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2748);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21537);
/* harmony import */ var _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20356);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71675);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








const keyBInd = '__jodit-resizer_binded';
/**
 * The module creates a supporting frame for resizing of the elements img and table
 */ class resizer extends _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_5__/* .Plugin */ .k {
    /** @override */ afterInit(editor) {
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.$$)('div', this.rect).forEach((resizeHandle)=>{
            editor.e.on(resizeHandle, 'mousedown.resizer touchstart.resizer', this.onStartResizing.bind(this, resizeHandle));
        });
        _core_global_js__WEBPACK_IMPORTED_MODULE_3__/* .eventEmitter */ .RR.on('hideHelpers', this.hide);
        editor.e.on('readonly', (isReadOnly)=>{
            if (isReadOnly) {
                this.hide();
            }
        }).on('afterInit changePlace', this.addEventListeners.bind(this)).on('afterGetValueFromEditor.resizer', (data)=>{
            const rgx = /<jodit[^>]+data-jodit_iframe_wrapper[^>]+>(.*?<iframe[^>]*>.*?<\/iframe>.*?)<\/jodit>/gi;
            if (rgx.test(data.value)) {
                data.value = data.value.replace(rgx, '$1');
            }
        });
        this.addEventListeners();
        this.__onChangeEditor();
    }
    /**
     * Click in the editor area
     */ onEditorClick(e) {
        let node = e.target;
        const { editor, options: { allowResizeTags } } = this.j;
        while(node && node !== editor){
            if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isTag(node, allowResizeTags)) {
                this.__bind(node);
                this.onClickElement(node);
                return;
            }
            node = node.parentNode;
        }
    }
    __afterInsertImage(image) {
        if (this.j.o.resizer.forImageChangeAttributes) {
            return;
        }
        const width = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.attr)(image, 'width');
        if (width && !(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.css)(image, 'width', true)) {
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.css)(image, 'width', width);
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.attr)(image, 'width', null);
        }
    }
    addEventListeners() {
        const editor = this.j;
        editor.e.off(editor.editor, '.resizer').off(editor.ow, '.resizer').on(editor.editor, 'keydown.resizer', (e)=>{
            if (this.isShown && e.key === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_DELETE && this.element && !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isTag(this.element, 'table')) {
                this.onDelete(e);
            }
        }).on(editor.ow, 'resize.resizer', this.updateSize).on('resize.resizer', this.updateSize).on([
            editor.ow,
            editor.editor
        ], 'scroll.resizer', ()=>{
            if (this.isShown && !this.isResizeMode) {
                this.hide();
            }
        }).on(editor.ow, 'keydown.resizer', this.onKeyDown).on(editor.ow, 'keyup.resizer', this.onKeyUp).on(editor.ow, 'mouseup.resizer touchend.resizer', this.onClickOutside);
    }
    onStartResizing(resizeHandle, e) {
        if (!this.element || !this.element.parentNode) {
            this.hide();
            return false;
        }
        this.handle = resizeHandle;
        if (e.cancelable) {
            e.preventDefault();
        }
        e.stopImmediatePropagation();
        this.width = this.element.offsetWidth;
        this.height = this.element.offsetHeight;
        this.ratio = this.width / this.height;
        this.isResizeMode = true;
        this.startX = e.clientX;
        this.startY = e.clientY;
        this.pointerX = e.clientX;
        this.pointerY = e.clientY;
        const { j } = this;
        j.e.fire('hidePopup');
        j.lock(this.LOCK_KEY);
        j.e.on(j.ow, 'mousemove.resizer touchmove.resizer', this.onResize);
    }
    onEndResizing() {
        const { j } = this;
        j.unlock();
        this.isResizeMode = false;
        this.isAltMode = false;
        j.synchronizeValues();
        j.e.off(j.ow, 'mousemove.resizer touchmove.resizer', this.onResize);
    }
    onResize(e) {
        if (this.isResizeMode) {
            if (!this.element) {
                return;
            }
            this.pointerX = e.clientX;
            this.pointerY = e.clientY;
            let diff_x, diff_y;
            if (this.j.options.iframe) {
                const workplacePosition = this.getWorkplacePosition();
                diff_x = e.clientX + workplacePosition.left - this.startX;
                diff_y = e.clientY + workplacePosition.top - this.startY;
            } else {
                diff_x = this.pointerX - this.startX;
                diff_y = this.pointerY - this.startY;
            }
            const className = this.handle.className;
            let new_w = 0, new_h = 0;
            const uar = this.j.o.resizer.useAspectRatio;
            if (!this.isAltMode && (uar === true || uar && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isTag(this.element, uar))) {
                if (diff_x) {
                    new_w = this.width + (className.match(/left/) ? -1 : 1) * diff_x;
                    new_h = Math.round(new_w / this.ratio);
                } else {
                    new_h = this.height + (className.match(/top/) ? -1 : 1) * diff_y;
                    new_w = Math.round(new_h * this.ratio);
                }
                if (new_w > (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.innerWidth)(this.j.editor, this.j.ow)) {
                    new_w = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.innerWidth)(this.j.editor, this.j.ow);
                    new_h = Math.round(new_w / this.ratio);
                }
            } else {
                new_w = this.width + (className.match(/left/) ? -1 : 1) * diff_x;
                new_h = this.height + (className.match(/top/) ? -1 : 1) * diff_y;
            }
            if (new_w > this.j.o.resizer.min_width) {
                if (new_w < this.rect.parentNode.offsetWidth) {
                    this.applySize(this.element, 'width', new_w);
                } else {
                    this.applySize(this.element, 'width', '100%');
                }
            }
            if (new_h > this.j.o.resizer.min_height) {
                this.applySize(this.element, 'height', new_h);
            }
            this.updateSize();
            this.showSizeViewer(this.element.offsetWidth, this.element.offsetHeight);
            e.stopImmediatePropagation();
        }
    }
    onKeyDown(e) {
        this.isAltMode = e.key === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_ALT;
        if (!this.isAltMode && this.isResizeMode) {
            this.onEndResizing();
        }
    }
    onKeyUp() {
        if (this.isAltMode && this.isResizeMode && this.element) {
            this.width = this.element.offsetWidth;
            this.height = this.element.offsetHeight;
            this.ratio = this.width / this.height;
            this.startX = this.pointerX;
            this.startY = this.pointerY;
        }
        this.isAltMode = false;
    }
    onClickOutside(e) {
        if (!this.isShown) {
            return;
        }
        if (!this.isResizeMode) {
            return this.hide();
        }
        e.stopImmediatePropagation();
        this.onEndResizing();
    }
    getWorkplacePosition() {
        return (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.offset)(this.rect.parentNode || this.j.od.documentElement, this.j, this.j.od, true);
    }
    applySize(element, key, value) {
        const changeAttrs = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isImage(element) && this.j.o.resizer.forImageChangeAttributes;
        if (changeAttrs) {
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.attr)(element, key, value);
        }
        if (!changeAttrs || element.style[key]) {
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.css)(element, key, value);
        }
    }
    onDelete(e) {
        if (!this.element) {
            return;
        }
        if (this.element.tagName !== 'JODIT') {
            this.j.s.select(this.element);
        } else {
            _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(this.element);
            this.hide();
            e.preventDefault();
        }
    }
    __onChangeEditor() {
        if (this.isShown) {
            if (!this.element || !this.element.parentNode) {
                this.hide();
            } else {
                this.updateSize();
            }
        }
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.$$)('iframe', this.j.editor).forEach(this.__bind);
    }
    /**
     * Bind an edit element to element
     * @param element - The element that you want to add a function to resize
     */ __bind(element) {
        if (!_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isHTMLElement(element) || !this.j.o.allowResizeTags.has(element.tagName.toLowerCase()) || (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.dataBind)(element, keyBInd)) {
            return;
        }
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.dataBind)(element, keyBInd, true);
        let wrapper;
        if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isTag(element, 'iframe')) {
            const iframe = element;
            if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isHTMLElement(element.parentNode) && (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.attr)(element.parentNode, '-jodit_iframe_wrapper')) {
                element = element.parentNode;
            } else {
                wrapper = this.j.createInside.element('jodit', {
                    'data-jodit-temp': 1,
                    contenteditable: false,
                    draggable: true,
                    'data-jodit_iframe_wrapper': 1
                });
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.attr)(wrapper, 'style', (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.attr)(element, 'style'));
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.css)(wrapper, {
                    display: element.style.display === 'inline-block' ? 'inline-block' : 'block',
                    width: element.offsetWidth,
                    height: element.offsetHeight
                });
                if (element.parentNode) {
                    element.parentNode.insertBefore(wrapper, element);
                }
                wrapper.appendChild(element);
                this.j.e.on(wrapper, 'click', ()=>{
                    (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.attr)(wrapper, 'data-jodit-wrapper_active', true);
                });
                element = wrapper;
            }
            this.j.e.off(element, 'mousedown.select touchstart.select').on(element, 'mousedown.select touchstart.select', ()=>{
                this.j.s.select(element);
            }).off(element, 'changesize').on(element, 'changesize', ()=>{
                iframe.setAttribute('width', element.offsetWidth + 'px');
                iframe.setAttribute('height', element.offsetHeight + 'px');
            });
        }
        this.j.e.on(element, 'dragstart', this.hide);
        if (!_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_ES_NEXT && _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_IE) {
            // for IE don't show native resizer
            this.j.e.on(element, 'mousedown', (event)=>{
                if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isTag(element, 'img')) {
                    event.preventDefault();
                }
            });
        }
    }
    showSizeViewer(w, h) {
        if (!this.j.o.resizer.showSize) {
            return;
        }
        if (w < this.sizeViewer.offsetWidth || h < this.sizeViewer.offsetHeight) {
            this.hideSizeViewer();
            return;
        }
        this.sizeViewer.style.opacity = '1';
        this.sizeViewer.textContent = `${w} x ${h}`;
        this.j.async.setTimeout(this.hideSizeViewer, {
            timeout: this.j.o.resizer.hideSizeTimeout,
            label: 'hideSizeViewer'
        });
    }
    /**
     * Show resizer
     */ show() {
        if (this.j.o.readonly || this.isShown) {
            return;
        }
        this.isShown = true;
        if (!this.rect.parentNode) {
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.markOwner)(this.j, this.rect);
            this.j.workplace.appendChild(this.rect);
        }
        if (this.j.isFullSize) {
            this.rect.style.zIndex = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.css)(this.j.container, 'zIndex').toString();
        }
        this.updateSize();
    }
    /**
     * Hide resizer
     */ hide() {
        if (!this.isResizeMode) {
            this.isResizeMode = false;
            this.isShown = false;
            this.element = null;
            _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(this.rect);
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.$$)("[data-jodit-wrapper_active='true']", this.j.editor).forEach((elm)=>(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.attr)(elm, 'data-jodit-wrapper_active', false));
        }
    }
    beforeDestruct(jodit) {
        this.hide();
        _core_global_js__WEBPACK_IMPORTED_MODULE_3__/* .eventEmitter */ .RR.off('hideHelpers', this.hide);
        jodit.e.off(this.j.ow, '.resizer').off('.resizer');
    }
    constructor(){
        super(...arguments);
        this.LOCK_KEY = 'resizer';
        this.element = null;
        this.isResizeMode = false;
        this.isShown = false;
        this.startX = 0;
        this.startY = 0;
        this.width = 0;
        this.height = 0;
        this.ratio = 0;
        this.rect = this.j.c.fromHTML(`<div title="${this.j.i18n('Press Alt for custom resizing')}" class="jodit-resizer">
				<div class="jodit-resizer__top-left"></div>
				<div class="jodit-resizer__top-right"></div>
				<div class="jodit-resizer__bottom-right"></div>
				<div class="jodit-resizer__bottom-left"></div>
				<span>100x100</span>
			</div>`);
        this.sizeViewer = this.rect.getElementsByTagName('span')[0];
        this.pointerX = 0;
        this.pointerY = 0;
        this.isAltMode = false;
        this.onClickElement = (element)=>{
            if (this.isResizeMode) {
                return;
            }
            if (this.element !== element || !this.isShown) {
                this.element = element;
                this.show();
                if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isTag(this.element, 'img') && !this.element.complete) {
                    this.j.e.one(this.element, 'load', this.updateSize);
                }
            }
        };
        this.updateSize = ()=>{
            if (this.isInDestruct || !this.isShown) {
                return;
            }
            if (this.element && this.rect) {
                const workplacePosition = this.getWorkplacePosition();
                const pos = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.offset)(this.element, this.j, this.j.ed), left = parseInt(this.rect.style.left || '0', 10), top = parseInt(this.rect.style.top || '0', 10), w = this.rect.offsetWidth, h = this.rect.offsetHeight;
                const newTop = pos.top - workplacePosition.top, newLeft = pos.left - workplacePosition.left;
                if (top !== newTop || left !== newLeft || w !== this.element.offsetWidth || h !== this.element.offsetHeight) {
                    (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.css)(this.rect, {
                        top: newTop,
                        left: newLeft,
                        width: this.element.offsetWidth,
                        height: this.element.offsetHeight
                    });
                    if (this.j.events) {
                        this.j.e.fire(this.element, 'changesize');
                        // check for first init. Ex. inlinePopup hides when it was fired
                        if (!isNaN(left)) {
                            this.j.e.fire('resize');
                        }
                    }
                }
            }
        };
        this.hideSizeViewer = ()=>{
            this.sizeViewer.style.opacity = '0';
        };
    }
}
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)(':click')
], resizer.prototype, "onEditorClick", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)(':afterInsertImage')
], resizer.prototype, "__afterInsertImage", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], resizer.prototype, "onStartResizing", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], resizer.prototype, "onEndResizing", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], resizer.prototype, "onResize", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], resizer.prototype, "onKeyDown", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], resizer.prototype, "onKeyUp", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], resizer.prototype, "onClickOutside", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)(':change')
], resizer.prototype, "__onChangeEditor", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], resizer.prototype, "__bind", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind,
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)(':hideResizer')
], resizer.prototype, "hide", null);
_core_global_js__WEBPACK_IMPORTED_MODULE_3__/* .pluginSystem */ .fg.add('resizer', resizer);


/***/ }),

/***/ 12045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   z: function() { return /* binding */ isAbortError; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ function isAbortError(error) {
    return Boolean(error) && error instanceof DOMException && error.name === 'AbortError';
}


/***/ }),

/***/ 12060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   X: function() { return /* reexport safe */ _create_js__WEBPACK_IMPORTED_MODULE_0__.X; }
/* harmony export */ });
/* harmony import */ var _create_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20218);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module create
 */ 


/***/ }),

/***/ 12081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   wc: function() { return /* reexport safe */ _storage_js__WEBPACK_IMPORTED_MODULE_1__.w; }
/* harmony export */ });
/* harmony import */ var _engines_local_storage_provider_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65638);
/* harmony import */ var _storage_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6700);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module storage
 */ 




/***/ }),

/***/ 12117:
/***/ (function(__unused_webpack_module, __webpack_exports__) {


/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'copy-format': 'Kopioi muotoilu'
});


/***/ }),

/***/ 12153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   I: function() { return /* binding */ Icon; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _helpers_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21537);
/* harmony import */ var _helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41180);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


class Icon {
    static getIcon(name) {
        if (/<svg/i.test(name)) {
            return name;
        }
        const icon = Icon.icons[name] || Icon.icons[name.replace(/-/g, '_')] || Icon.icons[name.replace(/_/g, '-')] || Icon.icons[(0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.camelCase)(name)] || Icon.icons[(0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.kebabCase)(name)] || Icon.icons[name.toLowerCase()];
        if (!_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD && !icon) {
            console.warn(`Icon "${name}" not found`);
        }
        return icon;
    }
    /**
     * Check if icon exist in store
     */ static exists(name) {
        return this.getIcon(name) !== undefined;
    }
    /**
     * Return SVG icon
     */ static get(name, defaultValue = '<span></span>') {
        return this.getIcon(name) || defaultValue;
    }
    /**
     * Set SVG in store
     */ static set(name, value) {
        this.icons[name.replace('_', '-')] = value;
        return this;
    }
    /**
     * Make icon html element
     */ static makeIcon(jodit, icon) {
        var _a, _b, _c, _d;
        if (!icon) {
            return;
        }
        let iconElement;
        const { name, iconURL, fill } = icon;
        const clearName = name.replace(/[^a-zA-Z0-9]/g, '_');
        let iconFromEvent;
        if (!/<svg/.test(name)) {
            iconFromEvent = (_b = (_a = jodit.o).getIcon) === null || _b === void 0 ? void 0 : _b.call(_a, name, clearName);
        }
        const cacheKey = `${name}${iconURL}${fill}${iconFromEvent !== null && iconFromEvent !== void 0 ? iconFromEvent : ''}`;
        if (jodit.o.cache && this.__cache.has(cacheKey)) {
            return (_c = this.__cache.get(cacheKey)) === null || _c === void 0 ? void 0 : _c.cloneNode(true);
        }
        if (iconURL) {
            iconElement = jodit.c.span();
            (0,_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_2__/* .css */ .A)(iconElement, 'backgroundImage', 'url(' + iconURL.replace('{basePath}', (jodit === null || jodit === void 0 ? void 0 : jodit.basePath) || '') + ')');
        } else {
            const svg = iconFromEvent || Icon.get(name, '') || ((_d = jodit.o.extraIcons) === null || _d === void 0 ? void 0 : _d[name]);
            if (svg) {
                iconElement = jodit.c.fromHTML(svg.trim());
                if (!/^<svg/i.test(name)) {
                    iconElement.classList.add('jodit-icon_' + clearName);
                }
            }
        }
        if (iconElement) {
            iconElement.classList.add('jodit-icon');
            iconElement.style.fill = fill;
            jodit.o.cache && this.__cache.set(cacheKey, iconElement.cloneNode(true));
        }
        return iconElement;
    }
}
Icon.icons = {};
Icon.__cache = new Map();


/***/ }),

/***/ 12202:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1344 1472q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm256 0q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128-224v320q0 40-28 68t-68 28h-1472q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h427q21 56 70.5 92t110.5 36h256q61 0 110.5-36t70.5-92h427q40 0 68 28t28 68zm-325-648q-17 40-59 40h-256v448q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-448h-256q-42 0-59-40-17-39 14-69l448-448q18-19 45-19t45 19l448 448q31 30 14 69z\"/> </svg> ");


/***/ }),

/***/ 12234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $: function() { return /* binding */ UISelect; }
/* harmony export */ });
/* harmony import */ var _decorators_component_component_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87325);
/* harmony import */ var _helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29960);
/* harmony import */ var _input_input_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80256);
/* harmony import */ var _validators_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30389);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var UISelect_1;




let UISelect = UISelect_1 = class UISelect extends _input_input_js__WEBPACK_IMPORTED_MODULE_1__/* .UIInput */ .t {
    /** @override */ className() {
        return 'UISelect';
    }
    /** @override **/ createContainer(state) {
        var _a;
        const container = super.createContainer(state);
        const { j } = this, { nativeInput } = this;
        const opt = ()=>j.create.element('option');
        if (state.placeholder !== undefined) {
            const option = opt();
            option.value = '';
            option.text = j.i18n(state.placeholder);
            nativeInput.add(option);
        }
        (_a = state.options) === null || _a === void 0 ? void 0 : _a.forEach((element)=>{
            const option = opt();
            option.value = element.value.toString();
            option.text = j.i18n(element.text);
            nativeInput.add(option);
        });
        if (state.size && state.size > 0) {
            (0,_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__/* .attr */ .C)(nativeInput, 'size', state.size);
        }
        if (state.multiple) {
            (0,_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__/* .attr */ .C)(nativeInput, 'multiple', '');
        }
        return container;
    }
    /** @override **/ createNativeInput() {
        return this.j.create.element('select');
    }
    /** @override **/ updateValidators() {
        super.updateValidators();
        if (this.state.required) {
            this.validators.delete(_validators_index_js__WEBPACK_IMPORTED_MODULE_2__/* .inputValidators.required */ .O.required);
            this.validators.add(_validators_index_js__WEBPACK_IMPORTED_MODULE_2__/* .selectValidators.required */ .U.m);
        }
    }
    constructor(jodit, state){
        super(jodit, state);
        /** @override */ this.state = {
            ...UISelect_1.defaultState
        };
        Object.assign(this.state, state);
    }
};
/** @override */ UISelect.defaultState = {
    ..._input_input_js__WEBPACK_IMPORTED_MODULE_1__/* .UIInput */ .t.defaultState,
    options: [],
    size: 1,
    multiple: false
};
UISelect = UISelect_1 = __decorate([
    _decorators_component_component_js__WEBPACK_IMPORTED_MODULE_3__/* .component */ .s
], UISelect);



/***/ }),

/***/ 12270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   IJ: function() { return /* binding */ clearSelectionWrappers; },
/* harmony export */   Tz: function() { return /* binding */ clearSelectionWrappersFromHTML; },
/* harmony export */   _B: function() { return /* binding */ highlightTextRanges; },
/* harmony export */   zy: function() { return /* binding */ getSelectionWrappers; }
/* harmony export */ });
/* unused harmony export clearNativeSelection */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _core_helpers_utils_selector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76078);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/**
 * @private
 */ const TMP_ATTR = 'jd-tmp-selection';
/**
 * @private
 */ function highlightTextRanges(jodit, rng, restRanges, ci, root) {
    if (rng.startContainer.nodeValue == null || rng.endContainer.nodeValue == null) {
        return;
    }
    if (checkNativeSelectionMethod(jodit, rng, restRanges)) {
        return;
    }
    const span = ci.element('span', {
        [TMP_ATTR]: true
    });
    _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.markTemporary(span);
    normalizeRanges(rng, restRanges, ci);
    let next = rng.startContainer;
    do {
        if (!next) {
            break;
        }
        if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isText(next) && !isSelectionWrapper(next.parentNode)) {
            _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.wrap(next, span.cloneNode(), ci);
        }
        if (next === rng.endContainer) {
            break;
        }
        let step = next.firstChild || next.nextSibling;
        if (!step) {
            while(next && !next.nextSibling && next !== root){
                next = next.parentNode;
            }
            step = next === null || next === void 0 ? void 0 : next.nextSibling;
        }
        next = step;
    }while (next && next !== root)
}
/**
 * @private
 */ function getSelectionWrappers(root) {
    return (0,_core_helpers_utils_selector_js__WEBPACK_IMPORTED_MODULE_2__.$$)(`[${TMP_ATTR}]`, root);
}
/**
 * @private
 */ function clearSelectionWrappers(jodit) {
    getSelectionWrappers(jodit.editor).forEach((span)=>_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.unwrap(span));
    clearNativeSelection(jodit);
}
/**
 * @private
 */ function clearSelectionWrappersFromHTML(root) {
    return root.replace(RegExp(`<span[^>]+${TMP_ATTR}[^>]+>(.*?)</span>`, 'g'), '$1');
}
/**
 * @private
 */ function isSelectionWrapper(node) {
    return _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isElement(node) && node.hasAttribute(TMP_ATTR);
}
function checkNativeSelectionMethod(jodit, rng, restRanges) {
    if (jodit.o.search.useCustomHighlightAPI && // @ts-ignore Because Highlight is not defined in the types TS 5.3.3
    _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.globalWindow && typeof _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.globalWindow.Highlight !== 'undefined') {
        const ranges = [
            rng,
            ...restRanges
        ].map((rng)=>{
            const range = jodit.selection.createRange();
            range.setStart(rng.startContainer, rng.startOffset);
            range.setEnd(rng.endContainer, rng.endOffset);
            return range;
        });
        const searchHighlight = new Highlight(...ranges);
        // @ts-ignore
        CSS.highlights.clear();
        // @ts-ignore
        CSS.highlights.set('jodit-search-result', searchHighlight);
        restRanges.length = 0;
        return true;
    }
    return false;
}
function clearNativeSelection(jodit) {
    if (jodit.o.search.useCustomHighlightAPI && // @ts-ignore Because Highlight is not defined in the types TS 5.3.3
    _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.globalWindow && typeof _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.globalWindow.Highlight !== 'undefined') {
        // @ts-ignore
        CSS.highlights.clear();
    }
}
function normalizeRanges(rng, restRanges, ci) {
    const startText = rng.startContainer.nodeValue;
    let diff = 0;
    if (rng.startOffset !== 0) {
        const text = ci.text(startText.substring(0, rng.startOffset));
        rng.startContainer.nodeValue = startText.substring(rng.startOffset);
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.before(rng.startContainer, text);
        if (rng.startContainer === rng.endContainer) {
            diff = rng.startOffset;
            rng.endOffset -= diff;
        }
        rng.startOffset = 0;
    }
    const endText = rng.endContainer.nodeValue;
    if (rng.endOffset !== endText.length) {
        const text = ci.text(endText.substring(rng.endOffset));
        rng.endContainer.nodeValue = endText.substring(0, rng.endOffset);
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.after(rng.endContainer, text);
        for (const range of restRanges){
            if (range.startContainer === rng.endContainer) {
                range.startContainer = text;
                range.startOffset = range.startOffset - rng.endOffset - diff;
                if (range.endContainer === rng.endContainer) {
                    range.endContainer = text;
                    range.endOffset = range.endOffset - rng.endOffset - diff;
                }
            } else {
                break;
            }
        }
        rng.endOffset = rng.endContainer.nodeValue.length;
    }
}


/***/ }),

/***/ 12275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   q: function() { return /* binding */ license; }
/* harmony export */ });
/* harmony import */ var _helpers_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17263);
/* harmony import */ var jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var jodit_esm_core_dom_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var jodit_esm_core_helpers_checker_is_boolean__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87612);
/* harmony import */ var jodit_esm_core_helpers_checker_is_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70799);
/* harmony import */ var jodit_esm_core_plugin_plugin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20356);
/* harmony import */ var jodit_pro_jodit_pro__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34013);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */







class license extends jodit_esm_core_plugin_plugin__WEBPACK_IMPORTED_MODULE_2__/* .Plugin */ .k {
    static make(jodit) {
        return new license(jodit);
    }
    /** @override */
    afterInit(jodit) {
        this.j.e.on('checkReserve', async (checkDomain) => {
            const code = this.j.o.license;
            const domain = checkDomain;
            if (!(0,jodit_esm_core_helpers_checker_is_string__WEBPACK_IMPORTED_MODULE_4__/* .isString */ .K)(code)) {
                return '';
            }
            let valid = (0,_helpers_helpers__WEBPACK_IMPORTED_MODULE_5__/* .validateLicense */ .M0)(code, domain);
            if (!valid && code[12] > 'A' && !jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_0__.IS_TEST) {
                valid = await this.validateLicenseRemote(code, domain);
            }
            return valid ? 'normal' : '';
        });
    }
    /** @override */
    beforeDestruct(jodit) { }
    async validateLicenseRemote(code, domain) {
        const storageKey = 'validateJoditLicenseRemote', newCode = this.j.storage.get(storageKey);
        if (newCode && (0,_helpers_helpers__WEBPACK_IMPORTED_MODULE_5__/* .validateLicense */ .M0)(newCode, domain)) {
            return true;
        }
        const s = document.createElement('script');
        s.src = `https://xdsoft.net/jodit/pro/api/licenses/validate/?code=${encodeURIComponent(code)}&host=${encodeURIComponent(domain)}`;
        document.body.appendChild(s);
        return this.j.async.promise((res) => {
            window['onJoditResolveKeyCode'] = (newCode) => {
                try {
                    if ((0,jodit_esm_core_helpers_checker_is_boolean__WEBPACK_IMPORTED_MODULE_6__/* .isBoolean */ .L)(newCode)) {
                        return res(newCode);
                    }
                    if ((0,_helpers_helpers__WEBPACK_IMPORTED_MODULE_5__/* .validateLicense */ .M0)(newCode, domain)) {
                        this.j.storage.set(storageKey, newCode);
                        res(true);
                    }
                    else {
                        res(false);
                    }
                }
                finally {
                    jodit_esm_core_dom_dom__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(s);
                }
            };
            this.j.async.setTimeout(() => {
                res(false);
                jodit_esm_core_dom_dom__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(s);
            }, 3000);
        });
    }
}
jodit_pro_jodit_pro__WEBPACK_IMPORTED_MODULE_3__/* .JoditPro */ .A.plugins.add('license', license);


/***/ }),

/***/ 12391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export addNewLine */
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65478);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21537);
/* harmony import */ var _modules_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41409);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4604);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





const ns = 'addnewline';
/**
 * Create helper for adding new paragraph(Jodit.defaultOptions.enter tag) before iframe, table or image
 */ class addNewLine extends _modules_index_js__WEBPACK_IMPORTED_MODULE_3__.Plugin {
    __show() {
        if (this.j.o.readonly || this.j.isLocked) {
            return;
        }
        this.j.async.clearTimeout(this.__timeout);
        if (this.__isShown) {
            return;
        }
        this.__isShown = true;
        this.j.container.appendChild(this.__line);
        this.__line.style.width = this.j.container.clientWidth + 'px';
    }
    onLock(isLocked) {
        if (isLocked && this.__isShown) {
            this.__hideForce();
        }
    }
    __hide() {
        if (!this.__isShown || this.__lineInFocus) {
            return;
        }
        this.__timeout = this.j.async.setTimeout(this.__hideForce, {
            timeout: 500,
            label: 'add-new-line-hide'
        });
    }
    afterInit(editor) {
        if (!editor.o.addNewLine) {
            return;
        }
        editor.e.on(this.__line, 'mousemove', (e)=>{
            e.stopPropagation();
        }).on(this.__line, 'mousedown touchstart', this.__onClickLine).on('change', this.__hideForce).on(this.__line, 'mouseenter', ()=>{
            this.j.async.clearTimeout(this.__timeout);
            this.__lineInFocus = true;
        }).on(this.__line, 'mouseleave', ()=>{
            this.__lineInFocus = false;
        }).on('changePlace', this.__addEventListeners.bind(this));
        this.__addEventListeners();
    }
    __addEventListeners() {
        const editor = this.j;
        editor.e.off(editor.editor, '.' + ns).off(editor.container, '.' + ns).off('.' + ns).on([
            editor.ow,
            editor.ew,
            editor.editor
        ], 'scroll' + '.' + ns, this.__hideForce).on('finishedCleanHTMLWorker' + '.' + ns, this.__hideForce).on(editor.editor, 'click' + '.' + ns, this.__hide).on(editor.container, 'mouseleave' + '.' + ns, this.__hide).on(editor.editor, 'mousemove' + '.' + ns, this.__onMouseMove);
    }
    onDblClickEditor(e) {
        const editor = this.j;
        if (!editor.o.readonly && editor.o.addNewLineOnDBLClick && e.target === editor.editor && editor.s.isCollapsed()) {
            const editorBound = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.offset)(editor.editor, editor, editor.ed);
            const top = e.pageY - editor.ew.scrollX;
            const p = editor.createInside.element(editor.o.enter);
            if (Math.abs(top - editorBound.top) < Math.abs(top - (editorBound.height + editorBound.top)) && editor.editor.firstChild) {
                editor.editor.insertBefore(p, editor.editor.firstChild);
            } else {
                editor.editor.appendChild(p);
            }
            editor.s.setCursorIn(p);
            editor.synchronizeValues();
            this.__hideForce();
            e.preventDefault();
        }
    }
    __onMouseMove(e) {
        const editor = this.j;
        let currentElement = editor.ed.elementFromPoint(e.clientX, e.clientY);
        if (!_modules_index_js__WEBPACK_IMPORTED_MODULE_3__.Dom.isHTMLElement(currentElement) || !_modules_index_js__WEBPACK_IMPORTED_MODULE_3__.Dom.isOrContains(editor.editor, currentElement)) {
            return;
        }
        if (editor.editor !== currentElement && !this.__isMatchedTag(currentElement)) {
            currentElement = _modules_index_js__WEBPACK_IMPORTED_MODULE_3__.Dom.closest(currentElement, this.__isMatchedTag, editor.editor);
        }
        if (!currentElement) {
            this.__hide();
            return;
        }
        if (this.__isMatchedTag(currentElement)) {
            const parentBox = _modules_index_js__WEBPACK_IMPORTED_MODULE_3__.Dom.up(currentElement, _modules_index_js__WEBPACK_IMPORTED_MODULE_3__.Dom.isBlock, editor.editor);
            if (parentBox && parentBox !== editor.editor) {
                currentElement = parentBox;
            }
        }
        const pos = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.position)(currentElement, this.j);
        let top = false;
        let { clientY, clientX } = e;
        if (this.j.iframe) {
            const { top, left } = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.position)(this.j.iframe, this.j, true);
            clientY += top;
            clientX += left;
        }
        const delta = this.j.o.addNewLineDeltaShow;
        if (Math.abs(clientY - pos.top) <= delta) {
            top = pos.top;
            this.__isBeforeContent = true;
        } else if (Math.abs(clientY - (pos.top + pos.height)) <= delta) {
            top = pos.top + pos.height;
            this.__isBeforeContent = false;
        }
        const isEditor = editor.editor === currentElement;
        if (top !== false && (isEditor && !this.__isBeforeContent || !isEditor && !(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.call)(this.__isBeforeContent ? _modules_index_js__WEBPACK_IMPORTED_MODULE_3__.Dom.prev : _modules_index_js__WEBPACK_IMPORTED_MODULE_3__.Dom.next, currentElement, this.__canGetFocus, editor.editor))) {
            this.__line.style.top = top + 'px';
            this.__current = currentElement;
            this.__show();
            this.__line.style.setProperty('--jd-anl-handle-offset', clientX - pos.left - 10 + 'px');
        } else {
            this.__current = false;
            this.__hide();
        }
    }
    /** @override */ beforeDestruct() {
        this.j.async.clearTimeout(this.__timeout);
        this.j.e.off(this.__line).off('changePlace', this.__addEventListeners);
        _modules_index_js__WEBPACK_IMPORTED_MODULE_3__.Dom.safeRemove(this.__line);
        this.j.e.off([
            this.j.ow,
            this.j.ew,
            this.j.editor
        ], '.' + ns).off(this.j.container, '.' + ns).off('.' + ns);
    }
    constructor(){
        super(...arguments);
        this.__line = this.j.c.fromHTML(`<div role="button" tabindex="-1" title="${this.j.i18n('Break')}" class="jodit-add-new-line"><span>${_modules_index_js__WEBPACK_IMPORTED_MODULE_3__.Icon.get('enter')}</span></div>`);
        this.__isMatchedTag = (node)=>Boolean(node && this.j.o.addNewLineTagsTriggers.includes(node.nodeName.toLowerCase()));
        this.__isBeforeContent = false;
        this.__lineInFocus = false;
        this.__isShown = false;
        this.__hideForce = ()=>{
            if (!this.__isShown) {
                return;
            }
            this.__isShown = false;
            this.j.async.clearTimeout(this.__timeout);
            this.__lineInFocus = false;
            _modules_index_js__WEBPACK_IMPORTED_MODULE_3__.Dom.safeRemove(this.__line);
            this.__line.style.setProperty('--jd-anl-handle-offset', '0');
        };
        this.__canGetFocus = (elm)=>{
            return elm != null && _modules_index_js__WEBPACK_IMPORTED_MODULE_3__.Dom.isBlock(elm) && !/^(img|table|iframe|hr)$/i.test(elm.nodeName);
        };
        this.__onClickLine = (e)=>{
            const editor = this.j;
            const p = editor.createInside.element(editor.o.enter);
            if (this.__isBeforeContent && this.__current && this.__current.parentNode) {
                if (this.__current === editor.editor) {
                    _modules_index_js__WEBPACK_IMPORTED_MODULE_3__.Dom.prepend(editor.editor, p);
                } else {
                    this.__current.parentNode.insertBefore(p, this.__current);
                }
            } else {
                editor.editor.appendChild(p);
            }
            editor.s.setCursorIn(p);
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.scrollIntoViewIfNeeded)(p, editor.editor, editor.ed);
            editor.synchronizeValues();
            this.__hideForce();
            e.preventDefault();
        };
    }
}
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)(':lock')
], addNewLine.prototype, "onLock", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], addNewLine.prototype, "__hide", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)(':dblclick')
], addNewLine.prototype, "onDblClickEditor", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.throttle)((ctx)=>ctx.defaultTimeout)
], addNewLine.prototype, "__onMouseMove", null);
_core_global_js__WEBPACK_IMPORTED_MODULE_1__/* .pluginSystem */ .fg.add('addNewLine', addNewLine);


/***/ }),

/***/ 12474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   _: function() { return /* binding */ checkRemoveEmptyNeighbor; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/**
 * Check if it is possible to remove an empty adjacent element.
 *
 * @example
 * ```html
 * <p><br></p><p>|second stop</p>
 * ```
 * result
 * ```html
 * <p>|second stop</p>
 * ```
 * @private
 */ function checkRemoveEmptyNeighbor(jodit, fakeNode, backspace) {
    const parent = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(fakeNode, _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isElement, jodit.editor);
    if (!parent) {
        return false;
    }
    const neighbor = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.findNotEmptySibling(parent, backspace);
    if (neighbor && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isEmpty(neighbor)) {
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(neighbor);
        jodit.s.setCursorBefore(fakeNode);
        return true;
    }
    return false;
}


/***/ }),

/***/ 12475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   N: function() { return /* binding */ CamelCaseToKebabCase; },
/* harmony export */   k: function() { return /* binding */ kebabCase; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/string
 */ const kebabCase = (key)=>{
    return key.replace(/([A-Z])([A-Z])([a-z])/g, '$1-$2$3').replace(/([a-z])([A-Z])/g, '$1-$2').replace(/[\s_]+/g, '-').toLowerCase();
};
const CamelCaseToKebabCase = (key)=>{
    return key.replace(/([A-Z])([A-Z])([a-z])/g, '$1-$2$3').replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
};


/***/ }),

/***/ 12972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   f: function() { return /* binding */ normalizeLicense; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/normalize
 */ const normalizeLicense = (license, count = 8)=>{
    const parts = [];
    while(license.length){
        parts.push(license.substr(0, count));
        license = license.substr(count);
    }
    parts[1] = parts[1].replace(/./g, '*');
    parts[2] = parts[2].replace(/./g, '*');
    return parts.join('-');
};


/***/ }),

/***/ 13252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   D: function() { return /* binding */ clearTimeout; },
/* harmony export */   w: function() { return /* binding */ setTimeout; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/async
 */ 
/**
 * Create async callback if set timeout value - else call function immediately
 */ function setTimeout(callback, timeout, ...args) {
    if (!timeout) {
        callback.call(null, ...args);
    } else {
        return _constants_js__WEBPACK_IMPORTED_MODULE_0__.globalWindow.setTimeout(callback, timeout, ...args);
    }
    return 0;
}
/**
 * Clear timeout
 */ function clearTimeout(timer) {
    _constants_js__WEBPACK_IMPORTED_MODULE_0__.globalWindow.clearTimeout(timer);
}


/***/ }),

/***/ 13465:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path stroke-width=\"0\" d=\"M381 1620q0 80-54.5 126t-135.5 46q-106 0-172-66l57-88q49 45 106 45 29 0 50.5-14.5t21.5-42.5q0-64-105-56l-26-56q8-10 32.5-43.5t42.5-54 37-38.5v-1q-16 0-48.5 1t-48.5 1v53h-106v-152h333v88l-95 115q51 12 81 49t30 88zm2-627v159h-362q-6-36-6-54 0-51 23.5-93t56.5-68 66-47.5 56.5-43.5 23.5-45q0-25-14.5-38.5t-39.5-13.5q-46 0-81 58l-85-59q24-51 71.5-79.5t105.5-28.5q73 0 123 41.5t50 112.5q0 50-34 91.5t-75 64.5-75.5 50.5-35.5 52.5h127v-60h105zm1409 319v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-14 9-23t23-9h1216q13 0 22.5 9.5t9.5 22.5zm-1408-899v99h-335v-99h107q0-41 .5-122t.5-121v-12h-2q-8 17-50 54l-71-76 136-127h106v404h108zm1408 387v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-14 9-23t23-9h1216q13 0 22.5 9.5t9.5 22.5zm0-512v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5z\"/> </svg> ");


/***/ }),

/***/ 13525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   u: function() { return /* binding */ wait; }
/* harmony export */ });
/* harmony import */ var _component_statuses_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78213);
/* harmony import */ var _helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23282);
/* harmony import */ var _helpers_utils_error_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89890);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


function wait(condition) {
    return (target, propertyKey)=>{
        const fn = target[propertyKey];
        if (!(0,_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_2__/* .isFunction */ .T)(fn)) {
            throw (0,_helpers_utils_error_index_js__WEBPACK_IMPORTED_MODULE_1__/* .error */ .z3)('Handler must be a Function');
        }
        target.hookStatus(_component_statuses_js__WEBPACK_IMPORTED_MODULE_0__/* .STATUSES */ .f.ready, (component)=>{
            const { async } = component;
            const realMethod = component[propertyKey];
            let timeout = 0;
            Object.defineProperty(component, propertyKey, {
                configurable: true,
                value: function callProxy(...args) {
                    async.clearTimeout(timeout);
                    if (condition(component)) {
                        realMethod.apply(component, args);
                    } else {
                        timeout = async.setTimeout(()=>callProxy(...args), 10);
                    }
                }
            });
        });
    };
}


/***/ }),

/***/ 13995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    Spellcheck: '맞춤법 검사'
});


/***/ }),

/***/ 14041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   M: function() { return /* binding */ loadStyle; },
/* harmony export */   o: function() { return /* binding */ loadExtras; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _helpers_string_kebab_case_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12475);
/* harmony import */ var _helpers_utils_append_script_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63799);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89672);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



const styles = new Set();
/**
 * @private
 */ async function loadStyle(jodit, pluginName) {
    const url = getFullUrl(jodit, pluginName, false);
    if (styles.has(url)) {
        return;
    }
    styles.add(url);
    return (0,_helpers_utils_append_script_js__WEBPACK_IMPORTED_MODULE_1__/* .appendStyleAsync */ .S5)(jodit, url);
}
/**
 * Call full url to the script or style file
 * @private
 */ function getFullUrl(jodit, name, js) {
    name = (0,_helpers_string_kebab_case_js__WEBPACK_IMPORTED_MODULE_2__/* .kebabCase */ .k)(name);
    const min = jodit.minified ? '.min' : '';
    return jodit.basePath + 'plugins/' + name + '/' + name + min + '.' + (js ? 'js' : 'css');
}
/**
 * @private
 */ function loadExtras(items, jodit, extraList, callback) {
    try {
        const needLoadExtras = extraList.filter((extra)=>!items.has((0,_utils_js__WEBPACK_IMPORTED_MODULE_3__/* .normalizeName */ .P)(extra.name)));
        if (needLoadExtras.length) {
            load(jodit, needLoadExtras, callback);
        }
    } catch (e) {
        if (!_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD) {
            throw e;
        }
    }
}
/**
 * Download plugins
 * @private
 */ function load(jodit, pluginList, callback) {
    pluginList.map((extra)=>{
        const url = extra.url || getFullUrl(jodit, extra.name, true);
        return (0,_helpers_utils_append_script_js__WEBPACK_IMPORTED_MODULE_1__/* .appendScriptAsync */ .w4)(jodit, url).then(callback).catch(()=>null);
    });
}


/***/ }),

/***/ 14306:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/inline-popup
 */ /* harmony default export */ __webpack_exports__.A = ([
    'bold',
    'italic',
    '|',
    'ul',
    'ol',
    'eraser',
    '|',
    'fontsize',
    'brush',
    'paragraph',
    '---',
    'image',
    'table',
    '\n',
    'link',
    '|',
    'align',
    '|',
    'undo',
    'redo',
    '|',
    'copyformat',
    'fullsize',
    '---',
    'dots'
]);


/***/ }),

/***/ 14316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   O: function() { return /* binding */ Elms; }
/* harmony export */ });
/* harmony import */ var _helpers_array_to_array_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4510);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
class Elms {
    /**
     * Return element with BEM class name
     */ getElm(elementName) {
        return this.container.querySelector(`.${this.getFullElName(elementName)}`);
    }
    /**
     * Return elements with BEM class name
     */ getElms(elementName) {
        return (0,_helpers_array_to_array_js__WEBPACK_IMPORTED_MODULE_0__/* .toArray */ .$)(this.container.querySelectorAll(`.${this.getFullElName(elementName)}`));
    }
}


/***/ }),

/***/ 14415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   G: function() { return /* binding */ normalSizeFromString; },
/* harmony export */   n: function() { return /* binding */ normalSizeToString; }
/* harmony export */ });
/* harmony import */ var _core_helpers_checker_is_number_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84767);
/* harmony import */ var _core_helpers_string_trim_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49055);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/image-properties
 */ 

/** @private */ const normalSizeFromString = (value)=>{
    return /^[-+]?[0-9.]+(px)?$/.test(value.toString()) ? parseFloat(value.toString()) : value;
};
/** @private */ const normalSizeToString = (value)=>{
    if ((0,_core_helpers_checker_is_number_js__WEBPACK_IMPORTED_MODULE_1__/* .isNumber */ .E)(value)) {
        return value ? value + 'px' : value.toString();
    }
    value = (0,_core_helpers_string_trim_js__WEBPACK_IMPORTED_MODULE_0__/* .trim */ .Bq)(value);
    return /^[0-9]+$/.test(value) ? value + 'px' : value;
};


/***/ }),

/***/ 14625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Y: function() { return /* binding */ generateCriticalCSS; }
/* harmony export */ });
/* harmony import */ var _core_helpers_array_to_array_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4510);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/**
 * @private
 */ function generateCriticalCSS(jodit) {
    const getMatchedCSSRules = (el, css = el.ownerDocument.styleSheets)=>{
        const rules = (0,_core_helpers_array_to_array_js__WEBPACK_IMPORTED_MODULE_0__/* .toArray */ .$)(css).map((s)=>{
            try {
                return (0,_core_helpers_array_to_array_js__WEBPACK_IMPORTED_MODULE_0__/* .toArray */ .$)(s.cssRules);
            } catch (_a) {}
            return [];
        }).flat();
        return rules.filter((r)=>{
            try {
                return Boolean(r && el.matches(r.selectorText));
            } catch (_a) {}
            return false;
        });
    };
    class CSSCriticalPath {
        generateCSS() {
            let finalCSS = '';
            for(const k in this.css){
                if (/:not\(/.test(k)) {
                    continue;
                }
                finalCSS += k + ' { ';
                for(const j in this.css[k]){
                    finalCSS += j + ': ' + this.css[k][j] + '; ';
                }
                finalCSS += '}\n';
            }
            return finalCSS;
        }
        constructor(w, d, opts){
            this.css = {};
            const opt = opts || {};
            const pushCSS = (r)=>{
                const selectorText = r.selectorText.split(',').map((a)=>a.trim()).sort().join(',');
                if (Boolean(this.css[selectorText]) === false) {
                    this.css[selectorText] = {};
                }
                const styles = r.style.cssText.split(/;(?![A-Za-z0-9])/);
                for(let i = 0; i < styles.length; i++){
                    if (!styles[i]) {
                        continue;
                    }
                    const pair = styles[i].split(':');
                    pair[0] = pair[0].trim();
                    pair[1] = pair[1].trim();
                    this.css[selectorText][pair[0]] = pair[1].replace(/var\(([^)]+)\)/g, (varValue, key)=>{
                        const [name, def] = key.split(',');
                        return (jodit.ew.getComputedStyle(jodit.editor).getPropertyValue(name.trim()) || def || varValue).trim();
                    });
                }
            };
            const parseTree = ()=>{
                // Get a list of all the elements in the view.
                const height = w.innerHeight;
                const walker = d.createTreeWalker(jodit.editor, NodeFilter.SHOW_ELEMENT, ()=>NodeFilter.FILTER_ACCEPT);
                while(walker.nextNode()){
                    const node = walker.currentNode;
                    const rect = node.getBoundingClientRect();
                    if (rect.top < height || opt.scanFullPage) {
                        const rules = getMatchedCSSRules(node);
                        if (rules) {
                            for(let r = 0; r < rules.length; r++){
                                pushCSS(rules[r]);
                            }
                        }
                    }
                }
            };
            parseTree();
        }
    }
    try {
        const cp = new CSSCriticalPath(jodit.ew, jodit.ed, {
            scanFullPage: true
        });
        return cp.generateCSS();
    } catch (_a) {}
    return '';
}


/***/ }),

/***/ 14630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C: function() { return /* binding */ cases; }
/* harmony export */ });
/* harmony import */ var _check_join_neighbors_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62845);
/* harmony import */ var _check_join_two_lists_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91748);
/* harmony import */ var _check_remove_char_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73792);
/* harmony import */ var _check_remove_content_not_editable_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);
/* harmony import */ var _check_remove_empty_neighbor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12474);
/* harmony import */ var _check_remove_empty_parent_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58940);
/* harmony import */ var _check_remove_unbreakable_element_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56825);
/* harmony import */ var _check_table_cell_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90240);
/* harmony import */ var _check_unwrap_first_list_item_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68034);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/backspace
 */ 








/**
 * @private
 */ const cases = [
    _check_remove_unbreakable_element_js__WEBPACK_IMPORTED_MODULE_6__/* .checkRemoveUnbreakableElement */ .f,
    _check_remove_content_not_editable_js__WEBPACK_IMPORTED_MODULE_3__/* .checkRemoveContentNotEditable */ .V,
    _check_remove_char_js__WEBPACK_IMPORTED_MODULE_2__/* .checkRemoveChar */ .H,
    _check_table_cell_js__WEBPACK_IMPORTED_MODULE_7__/* .checkTableCell */ .R,
    _check_remove_empty_parent_js__WEBPACK_IMPORTED_MODULE_5__/* .checkRemoveEmptyParent */ .C,
    _check_remove_empty_neighbor_js__WEBPACK_IMPORTED_MODULE_4__/* .checkRemoveEmptyNeighbor */ ._,
    _check_join_two_lists_js__WEBPACK_IMPORTED_MODULE_1__/* .checkJoinTwoLists */ .a,
    _check_join_neighbors_js__WEBPACK_IMPORTED_MODULE_0__/* .checkJoinNeighbors */ .E,
    _check_unwrap_first_list_item_js__WEBPACK_IMPORTED_MODULE_8__/* .checkUnwrapFirstListItem */ .B
];


/***/ }),

/***/ 14721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   N: function() { return /* binding */ applyMargin; }
/* harmony export */ });
/* harmony import */ var _core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41180);
/* harmony import */ var _utils_utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14415);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/** @private */ function applyMargin(j, marginTop, marginRight, marginBottom, marginLeft, image, marginIsLocked) {
    const margins = [
        marginTop,
        marginRight,
        marginBottom,
        marginLeft
    ];
    const applyMargin = (key, value)=>{
        const oldValue = (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_1__/* .css */ .A)(image, key);
        const v = (0,_utils_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .normalSizeToString */ .n)(value);
        if (oldValue.toString() !== v.toString()) {
            (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_1__/* .css */ .A)(image, key, v);
        }
    };
    if (!marginIsLocked) {
        const sides = [
            'margin-top',
            'margin-right',
            'margin-bottom',
            'margin-left'
        ];
        margins.forEach((margin, index)=>{
            const side = sides[index];
            applyMargin(side, margin);
        });
    } else {
        applyMargin('margin', marginTop);
    }
}


/***/ }),

/***/ 14773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   y: function() { return /* binding */ isPromise; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/checker
 */ function isPromise(val) {
    return val && typeof val.then === 'function';
}


/***/ }),

/***/ 14862:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 312 312\"> <g transform=\"translate(0.000000,312.000000) scale(0.100000,-0.100000)\" stroke=\"none\"> <path d=\"M50 3109 c0 -7 -11 -22 -25 -35 l-25 -23 0 -961 0 -961 32 -29 32 -30 501 -2 500 -3 3 -502 2 -502 31 -30 31 -31 958 0 958 0 23 25 c13 13 30 25 37 25 9 0 12 199 12 960 0 686 -3 960 -11 960 -6 0 -24 12 -40 28 l-29 27 -503 5 -502 5 -5 502 -5 503 -28 29 c-15 16 -27 34 -27 40 0 8 -274 11 -960 11 -710 0 -960 -3 -960 -11z m1738 -698 l2 -453 -40 -40 c-22 -22 -40 -43 -40 -47 0 -4 36 -42 79 -85 88 -87 82 -87 141 -23 l26 27 455 -2 454 -3 0 -775 0 -775 -775 0 -775 0 -3 450 -2 449 47 48 47 48 -82 80 c-44 44 -84 80 -87 80 -3 0 -25 -18 -48 -40 l-41 -40 -456 2 -455 3 -3 765 c-1 421 0 771 3 778 3 10 164 12 777 10 l773 -3 3 -454z\"/> <path d=\"M607 2492 c-42 -42 -77 -82 -77 -87 0 -6 86 -96 190 -200 105 -104 190 -197 190 -205 0 -8 -41 -56 -92 -107 -65 -65 -87 -94 -77 -98 8 -3 138 -4 289 -3 l275 3 3 275 c1 151 0 281 -3 289 -4 10 -35 -14 -103 -82 -54 -53 -103 -97 -109 -97 -7 0 -99 88 -206 195 -107 107 -196 195 -198 195 -3 0 -39 -35 -82 -78z\"/> <path d=\"M1470 1639 c-47 -49 -87 -91 -89 -94 -5 -6 149 -165 160 -165 9 0 189 179 189 188 0 12 -154 162 -165 161 -6 0 -48 -41 -95 -90z\"/> <path d=\"M1797 1303 c-9 -8 -9 -568 0 -576 4 -4 50 36 103 88 54 52 101 95 106 95 5 0 95 -85 199 -190 104 -104 194 -190 200 -190 6 0 46 36 90 80 l79 79 -197 196 c-108 108 -197 199 -197 203 0 4 45 52 99 106 55 55 98 103 95 108 -6 10 -568 11 -577 1z\"/> </g> </svg> ");


/***/ }),

/***/ 14984:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21537);
/* harmony import */ var _core_ui_button_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62843);
/* harmony import */ var _core_ui_form_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2525);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6441);
/* harmony import */ var _modules_widget_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92762);
/* harmony import */ var _video_svg_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37775);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 






_config_js__WEBPACK_IMPORTED_MODULE_4__/* .Config */ .T.prototype.video = {
    parseUrlToVideoEmbed: _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.convertMediaUrlToVideoEmbed,
    defaultWidth: 400,
    defaultHeight: 345
};
_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .I.set('video', _video_svg_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A);
_config_js__WEBPACK_IMPORTED_MODULE_4__/* .Config */ .T.prototype.controls.video = {
    popup: (jodit, current, close)=>{
        const formLink = new _core_ui_form_index_js__WEBPACK_IMPORTED_MODULE_2__/* .UIForm */ .XV(jodit, [
            new _core_ui_form_index_js__WEBPACK_IMPORTED_MODULE_2__/* .UIBlock */ .Yh(jodit, [
                new _core_ui_form_index_js__WEBPACK_IMPORTED_MODULE_2__/* .UIInput */ .tS(jodit, {
                    name: 'url',
                    required: true,
                    label: 'URL',
                    placeholder: 'https://',
                    validators: [
                        'url'
                    ]
                })
            ]),
            new _core_ui_form_index_js__WEBPACK_IMPORTED_MODULE_2__/* .UIBlock */ .Yh(jodit, [
                (0,_core_ui_button_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .$n)(jodit, '', 'Insert', 'primary').onAction(()=>formLink.submit())
            ])
        ]), formCode = new _core_ui_form_index_js__WEBPACK_IMPORTED_MODULE_2__/* .UIForm */ .XV(jodit, [
            new _core_ui_form_index_js__WEBPACK_IMPORTED_MODULE_2__/* .UIBlock */ .Yh(jodit, [
                new _core_ui_form_index_js__WEBPACK_IMPORTED_MODULE_2__/* .UITextArea */ .F0(jodit, {
                    name: 'code',
                    required: true,
                    label: 'Embed code'
                })
            ]),
            new _core_ui_form_index_js__WEBPACK_IMPORTED_MODULE_2__/* .UIBlock */ .Yh(jodit, [
                (0,_core_ui_button_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .$n)(jodit, '', 'Insert', 'primary').onAction(()=>formCode.submit())
            ])
        ]), tabs = [], insertCode = (code)=>{
            jodit.s.restore();
            jodit.s.insertHTML(code);
            close();
        };
        jodit.s.save();
        tabs.push({
            icon: 'link',
            name: 'Link',
            content: formLink.container
        }, {
            icon: 'source',
            name: 'Code',
            content: formCode.container
        });
        formLink.onSubmit((data)=>{
            var _a, _b, _c, _d;
            insertCode((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.call)((_b = (_a = jodit.o.video) === null || _a === void 0 ? void 0 : _a.parseUrlToVideoEmbed) !== null && _b !== void 0 ? _b : _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.convertMediaUrlToVideoEmbed, data.url, {
                width: (_c = jodit.o.video) === null || _c === void 0 ? void 0 : _c.defaultWidth,
                height: (_d = jodit.o.video) === null || _d === void 0 ? void 0 : _d.defaultHeight
            }));
        });
        formCode.onSubmit((data)=>{
            insertCode(data.code);
        });
        return (0,_modules_widget_index_js__WEBPACK_IMPORTED_MODULE_5__/* .TabsWidget */ .Zg)(jodit, tabs);
    },
    tags: [
        'iframe'
    ],
    tooltip: 'Insert youtube/vimeo video'
};


/***/ }),

/***/ 15456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   X: function() { return /* binding */ ctrlKey; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/utils
 */ /**
 * CTRL pressed
 * @returns true ctrl key was pressed
 */ const ctrlKey = (e)=>{
    if (typeof navigator !== 'undefined' && navigator.userAgent.indexOf('Mac OS X') !== -1) {
        if (e.metaKey && !e.altKey) {
            return true;
        }
    } else if (e.ctrlKey && !e.altKey) {
        return true;
    }
    return false;
};


/***/ }),

/***/ 15738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   X: function() { return /* binding */ defaultNameSpace; },
/* harmony export */   d: function() { return /* binding */ EventHandlersStore; }
/* harmony export */ });
/* harmony import */ var _helpers_array_to_array_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4510);
/* harmony import */ var _helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38837);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

const defaultNameSpace = 'JoditEventDefaultNamespace';
class EventHandlersStore {
    get(event, namespace) {
        if (this.__store.has(namespace)) {
            const ns = this.__store.get(namespace);
            (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_1__/* .assert */ .v)(ns, '-');
            return ns[event];
        }
    }
    indexOf(event, namespace, originalCallback) {
        const blocks = this.get(event, namespace);
        if (blocks) {
            for(let i = 0; i < blocks.length; i += 1){
                if (blocks[i].originalCallback === originalCallback) {
                    return i;
                }
            }
        }
        return false;
    }
    namespaces(withoutDefault = false) {
        const nss = (0,_helpers_array_to_array_js__WEBPACK_IMPORTED_MODULE_0__/* .toArray */ .$)(this.__store.keys());
        return withoutDefault ? nss.filter((ns)=>ns !== defaultNameSpace) : nss;
    }
    events(namespace) {
        const ns = this.__store.get(namespace);
        return ns ? Object.keys(ns) : [];
    }
    set(event, namespace, data, onTop = false) {
        let ns = this.__store.get(namespace);
        if (!ns) {
            ns = {};
            this.__store.set(namespace, ns);
        }
        if (ns[event] === undefined) {
            ns[event] = [];
        }
        if (!onTop) {
            ns[event].push(data);
        } else {
            ns[event].unshift(data);
        }
    }
    clear() {
        this.__store.clear();
    }
    clearEvents(namespace, event) {
        const ns = this.__store.get(namespace);
        if (ns && ns[event]) {
            delete ns[event];
            if (!Object.keys(ns).length) {
                this.__store.delete(namespace);
            }
        }
    }
    isEmpty() {
        return this.__store.size === 0;
    }
    constructor(){
        this.__store = new Map();
    }
}


/***/ }),

/***/ 16020:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1760 896q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1728q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1728zm-1277-64q-28-35-51-80-48-97-48-188 0-181 134-309 133-127 393-127 50 0 167 19 66 12 177 48 10 38 21 118 14 123 14 183 0 18-5 45l-12 3-84-6-14-2q-50-149-103-205-88-91-210-91-114 0-182 59-67 58-67 146 0 73 66 140t279 129q69 20 173 66 58 28 95 52h-743zm507 256h411q7 39 7 92 0 111-41 212-23 55-71 104-37 35-109 81-80 48-153 66-80 21-203 21-114 0-195-23l-140-40q-57-16-72-28-8-8-8-22v-13q0-108-2-156-1-30 0-68l2-37v-44l102-2q15 34 30 71t22.5 56 12.5 27q35 57 80 94 43 36 105 57 59 22 132 22 64 0 139-27 77-26 122-86 47-61 47-129 0-84-81-157-34-29-137-71z\"/> </svg> ");


/***/ }),

/***/ 16233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export hr */
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22732);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(580);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6441);
/* harmony import */ var _hr_svg_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72337);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 




_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .I.set('hr', _hr_svg_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A);
_config_js__WEBPACK_IMPORTED_MODULE_3__/* .Config */ .T.prototype.controls.hr = {
    command: 'insertHorizontalRule',
    tags: [
        'hr'
    ],
    tooltip: 'Insert Horizontal Line'
};
function hr(editor) {
    editor.registerButton({
        name: 'hr',
        group: 'insert'
    });
    editor.registerCommand('insertHorizontalRule', ()=>{
        const elm = editor.createInside.element('hr');
        editor.s.insertNode(elm, false, false);
        const block = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(elm.parentElement, _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isBlock, editor.editor);
        if (block && _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isEmpty(block) && block !== editor.editor) {
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.after(block, elm);
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(block);
        }
        let p = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.next(elm, _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isBlock, editor.editor, false);
        if (!p) {
            p = editor.createInside.element(editor.o.enter);
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.after(elm, p);
        }
        editor.s.setCursorIn(p);
        return false;
    });
}
_core_global_js__WEBPACK_IMPORTED_MODULE_1__/* .pluginSystem */ .fg.add('hr', hr);


/***/ }),

/***/ 16260:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1203 544q0 13-10 23l-393 393 393 393q10 10 10 23t-10 23l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23z\"/> </svg> ");


/***/ }),

/***/ 16407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    newline: '改行',
    delete: '削除',
    space: 'スペース',
    'Speech Recognize': '音声認識',
    Sound: '音',
    'Interim Results': '中間結果'
});


/***/ }),

/***/ 16442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   m: function() { return /* binding */ getScrollParent; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _utils_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43555);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


function getScrollParent(node) {
    if (!node) {
        return null;
    }
    const isElement = _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isHTMLElement(node);
    const overflowY = isElement && (0,_utils_index_js__WEBPACK_IMPORTED_MODULE_2__/* .css */ .AH)(node, 'overflowY');
    const isScrollable = isElement && overflowY !== 'visible' && overflowY !== 'hidden';
    if (isScrollable && node.scrollHeight >= node.clientHeight) {
        return node;
    }
    return getScrollParent(node.parentNode) || _constants_js__WEBPACK_IMPORTED_MODULE_0__.globalDocument.scrollingElement || _constants_js__WEBPACK_IMPORTED_MODULE_0__.globalDocument.body;
}


/***/ }),

/***/ 17081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    newline: 'nylinje',
    delete: 'slette',
    space: 'rom',
    'Speech Recognize': 'Talegjenkjenning',
    Sound: 'Lyd',
    'Interim Results': 'Midlertidige resultater'
});


/***/ }),

/***/ 17096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   H: function() { return /* binding */ replaceOldTags; }
/* harmony export */ });
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */
const REPLACE_OLD_TAGS = {
    i: 'em',
    b: 'strong'
};
function replaceOldTags(elm) {
    const { name } = elm;
    if (name in REPLACE_OLD_TAGS) {
        elm.name = REPLACE_OLD_TAGS[name];
    }
    return elm;
}


/***/ }),

/***/ 17176:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1152 1376v-160q0-14-9-23t-23-9h-96v-512q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v160q0 14 9 23t23 9h96v320h-96q-14 0-23 9t-9 23v160q0 14 9 23t23 9h448q14 0 23-9t9-23zm-128-896v-160q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v160q0 14 9 23t23 9h192q14 0 23-9t9-23zm640 416q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z\"/> </svg> ");


/***/ }),

/***/ 17263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   M0: function() { return /* binding */ validateLicense; }
/* harmony export */ });
/* unused harmony exports validateEntLicense, domainsHash */
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */
const ALLOWED_SUBDOMAINS = [
    '*localhost*',
    'staging.',
    '*.dev.',
    '*.test.',
    '*.stg.',
    'stg.*',
    'test.*',
    'beta.*',
    '*demo.*',
    '*test.*',
    'acceptatie.*'
];
function escapeRegex(input) {
    return input.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&');
}
function isAllowedSubdomain(domain) {
    return ALLOWED_SUBDOMAINS.some((subdomain) => {
        const regex = new RegExp(escapeRegex(subdomain.replace(/\*/g, '%ANY%')).replace(/%ANY%/g, '.*'));
        return regex.test(domain);
    });
}
/**
 * Validate license
 */
function validateLicense(code, domain) {
    code = code.replace(/[^A-Z0-9-]/g, 'R');
    if (validateEntLicense(code)) {
        return true;
    }
    // For local and testing stages
    if (isAllowedSubdomain(domain)) {
        return true;
    }
    const domainsParts = domainsHash(domain);
    const parts = [
        '[A-F013456][A-F0-9]{3}{part}',
        '([0-3]){part}[E-L4-8]{2}\\1',
        '[A-D]{part}[J-P5-6]{3}',
        '{part}[A-R0-9]{3}[X-Z]'
    ].map((part, index) => {
        return part.replace('{part}', domainsParts[index] || '[R-T]');
    });
    const reg = RegExp(`^${parts.join('-')}$`, 'i');
    const type = code.substring(12, 13);
    const result = reg.test(code);
    if (!result && type === (typeof !domain).toUpperCase()[5]) {
        const parts = domain.split('.');
        parts.shift();
        return parts.length ? validateLicense(code, parts.join('.')) : false;
    }
    return result;
}
function validateEntLicense(code) {
    return /[A-Z0-9][013456][A-P0-9]{2}[ABC]-([0-3])[ELPDF][E-L4-8]{2}\1-[A-D][R0][J-P5-6]{3}-[DPGHYE][GFPOD]{3}[A-SX-Z]/.test(code);
}
function domainsHash(domain) {
    const domains = domain.split('.');
    return domains
        .map((p) => {
        if (p[0] && p[0].charCodeAt(0)) {
            return String.fromCharCode(p[0].charCodeAt(0) + 1);
        }
        return p[0];
    })
        .concat(domains.map((p) => {
        if (p[p.length - 1] && p[p.length - 1].charCodeAt(0)) {
            return String.fromCharCode(p[p.length - 1].charCodeAt(0) - 1);
        }
        return p[p.length - 1];
    }))
        .map((p) => (p != null && /\w/.test(p) ? p : 'r'));
}


/***/ }),

/***/ 17328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   c: function() { return /* binding */ UICheckbox; }
/* harmony export */ });
/* harmony import */ var _decorators_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65478);
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _input_input_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80256);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var UICheckbox_1;



let UICheckbox = UICheckbox_1 = class UICheckbox extends _input_input_js__WEBPACK_IMPORTED_MODULE_2__/* .UIInput */ .t {
    /** @override */ className() {
        return 'UICheckbox';
    }
    /** @override */ render() {
        return this.j.c.element('label', {
            className: this.componentName
        });
    }
    onChangeChecked() {
        this.value = this.state.checked.toString();
        this.nativeInput.checked = this.state.checked;
        this.setMod('checked', this.state.checked);
    }
    onChangeNativeCheckBox() {
        this.state.checked = this.nativeInput.checked;
    }
    onChangeSwitch() {
        this.setMod('switch', this.state.switch);
        let slider = this.getElm('switch-slider');
        if (this.state.switch) {
            if (!slider) {
                slider = this.j.c.div(this.getFullElName('switch-slider'));
            }
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.after(this.nativeInput, slider);
        } else {
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(slider);
        }
    }
    /** @override **/ constructor(jodit, options){
        super(jodit, {
            ...options,
            type: 'checkbox'
        });
        /** @override */ this.state = {
            ...UICheckbox_1.defaultState
        };
        Object.assign(this.state, options);
    }
};
/** @override */ UICheckbox.defaultState = {
    ..._input_input_js__WEBPACK_IMPORTED_MODULE_2__/* .UIInput */ .t.defaultState,
    checked: false,
    switch: false
};
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)('state.checked'),
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.hook)('ready')
], UICheckbox.prototype, "onChangeChecked", null);
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)('nativeInput:change')
], UICheckbox.prototype, "onChangeNativeCheckBox", null);
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)('state.switch'),
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.hook)('ready')
], UICheckbox.prototype, "onChangeSwitch", null);
UICheckbox = UICheckbox_1 = __decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.component
], UICheckbox);



/***/ }),

/***/ 17555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   angle_down: function() { return /* reexport safe */ _angle_down_svg_js__WEBPACK_IMPORTED_MODULE_0__.A; },
/* harmony export */   angle_left: function() { return /* reexport safe */ _angle_left_svg_js__WEBPACK_IMPORTED_MODULE_1__.A; },
/* harmony export */   angle_right: function() { return /* reexport safe */ _angle_right_svg_js__WEBPACK_IMPORTED_MODULE_2__.A; },
/* harmony export */   angle_up: function() { return /* reexport safe */ _angle_up_svg_js__WEBPACK_IMPORTED_MODULE_3__.A; },
/* harmony export */   bin: function() { return /* reexport safe */ _bin_svg_js__WEBPACK_IMPORTED_MODULE_4__.A; },
/* harmony export */   cancel: function() { return /* reexport safe */ _cancel_svg_js__WEBPACK_IMPORTED_MODULE_5__.A; },
/* harmony export */   center: function() { return /* reexport safe */ _center_svg_js__WEBPACK_IMPORTED_MODULE_6__.A; },
/* harmony export */   check: function() { return /* reexport safe */ _check_svg_js__WEBPACK_IMPORTED_MODULE_7__.A; },
/* harmony export */   chevron: function() { return /* reexport safe */ _chevron_svg_js__WEBPACK_IMPORTED_MODULE_8__.A; },
/* harmony export */   dots: function() { return /* reexport safe */ _dots_svg_js__WEBPACK_IMPORTED_MODULE_9__.A; },
/* harmony export */   eye: function() { return /* reexport safe */ _eye_svg_js__WEBPACK_IMPORTED_MODULE_10__.A; },
/* harmony export */   file: function() { return /* reexport safe */ _file_svg_js__WEBPACK_IMPORTED_MODULE_11__.A; },
/* harmony export */   folder: function() { return /* reexport safe */ _folder_svg_js__WEBPACK_IMPORTED_MODULE_12__.A; },
/* harmony export */   info_circle: function() { return /* reexport safe */ _info_circle_svg_js__WEBPACK_IMPORTED_MODULE_13__.A; },
/* harmony export */   left: function() { return /* reexport safe */ _left_svg_js__WEBPACK_IMPORTED_MODULE_14__.A; },
/* harmony export */   lock: function() { return /* reexport safe */ _lock_svg_js__WEBPACK_IMPORTED_MODULE_15__.A; },
/* harmony export */   ok: function() { return /* reexport safe */ _ok_svg_js__WEBPACK_IMPORTED_MODULE_16__.A; },
/* harmony export */   pencil: function() { return /* reexport safe */ _pencil_svg_js__WEBPACK_IMPORTED_MODULE_17__.A; },
/* harmony export */   plus: function() { return /* reexport safe */ _plus_svg_js__WEBPACK_IMPORTED_MODULE_18__.A; },
/* harmony export */   resize_handler: function() { return /* reexport safe */ _resize_handler_svg_js__WEBPACK_IMPORTED_MODULE_19__.A; },
/* harmony export */   right: function() { return /* reexport safe */ _right_svg_js__WEBPACK_IMPORTED_MODULE_20__.A; },
/* harmony export */   save: function() { return /* reexport safe */ _save_svg_js__WEBPACK_IMPORTED_MODULE_21__.A; },
/* harmony export */   settings: function() { return /* reexport safe */ _settings_svg_js__WEBPACK_IMPORTED_MODULE_22__.A; },
/* harmony export */   unlock: function() { return /* reexport safe */ _unlock_svg_js__WEBPACK_IMPORTED_MODULE_23__.A; },
/* harmony export */   update: function() { return /* reexport safe */ _update_svg_js__WEBPACK_IMPORTED_MODULE_24__.A; },
/* harmony export */   upload: function() { return /* reexport safe */ _upload_svg_js__WEBPACK_IMPORTED_MODULE_25__.A; },
/* harmony export */   valign: function() { return /* reexport safe */ _valign_svg_js__WEBPACK_IMPORTED_MODULE_26__.A; }
/* harmony export */ });
/* harmony import */ var _angle_down_svg_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78173);
/* harmony import */ var _angle_left_svg_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16260);
/* harmony import */ var _angle_right_svg_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37663);
/* harmony import */ var _angle_up_svg_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51036);
/* harmony import */ var _bin_svg_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31554);
/* harmony import */ var _cancel_svg_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18309);
/* harmony import */ var _center_svg_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99762);
/* harmony import */ var _check_svg_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7903);
/* harmony import */ var _chevron_svg_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(58032);
/* harmony import */ var _dots_svg_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52507);
/* harmony import */ var _eye_svg_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43478);
/* harmony import */ var _file_svg_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(60097);
/* harmony import */ var _folder_svg_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(49155);
/* harmony import */ var _info_circle_svg_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(17176);
/* harmony import */ var _left_svg_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(57882);
/* harmony import */ var _lock_svg_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(58908);
/* harmony import */ var _ok_svg_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(24829);
/* harmony import */ var _pencil_svg_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(4038);
/* harmony import */ var _plus_svg_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(45575);
/* harmony import */ var _resize_handler_svg_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(84858);
/* harmony import */ var _right_svg_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(445);
/* harmony import */ var _save_svg_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(36886);
/* harmony import */ var _settings_svg_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(10766);
/* harmony import */ var _unlock_svg_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(33651);
/* harmony import */ var _update_svg_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(20362);
/* harmony import */ var _upload_svg_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(12202);
/* harmony import */ var _valign_svg_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(80152);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * [[include:styles/icons/README.md]]
 * @packageDocumentation
 * @module icons
 */ 





























/***/ }),

/***/ 17583:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M448 1536h896v-256h-896v256zm0-640h896v-384h-160q-40 0-68-28t-28-68v-160h-640v640zm1152 64q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128 0v416q0 13-9.5 22.5t-22.5 9.5h-224v160q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-160h-224q-13 0-22.5-9.5t-9.5-22.5v-416q0-79 56.5-135.5t135.5-56.5h64v-544q0-40 28-68t68-28h672q40 0 88 20t76 48l152 152q28 28 48 76t20 88v256h64q79 0 135.5 56.5t56.5 135.5z\"/> </svg> ");


/***/ }),

/***/ 18309:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"> <g stroke=\"none\" stroke-width=\"1\"> <path d=\"M14,1.4 L12.6,0 L7,5.6 L1.4,0 L0,1.4 L5.6,7 L0,12.6 L1.4,14 L7,8.4 L12.6,14 L14,12.6 L8.4,7 L14,1.4 Z\"/> </g> </svg> ");


/***/ }),

/***/ 18363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export poweredByJodit */
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(580);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
function poweredByJodit(jodit) {
    const { o } = jodit;
    if (!o.hidePoweredByJodit && !o.inline && (o.showCharsCounter || o.showWordsCounter || o.showXPathInStatusbar)) {
        jodit.hookStatus('ready', ()=>{
            jodit.statusbar.append(jodit.create.fromHTML(`<a
						tabindex="-1"
						style="text-transform: uppercase"
						class="jodit-status-bar-link"
						target="_blank"
						href="https://xdsoft.net/jodit/">
							Powered by Jodit
						</a>`), true);
        });
    }
}
_core_global_js__WEBPACK_IMPORTED_MODULE_0__/* .pluginSystem */ .fg.add('poweredByJodit', poweredByJodit);


/***/ }),

/***/ 19007:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'Type something': 'Напишіть щось',
    'About Jodit': 'Про Jodit',
    'Jodit Editor': 'Редактор Jodit',
    "Jodit User's Guide": 'Jodit інструкція користувача',
    'contains detailed help for using': 'містить детальну інформацію щодо користування',
    'For information about the license, please go to our website:': 'Щоб дізнатись більше про ліцензію , будь ласка, перейдіть на наш сайт:',
    'Buy full version': 'Купити повну версію',
    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.': 'Авторські права © XDSoft.net - Чупурнов Валерій. Всі права захищені.',
    Anchor: 'Анкор',
    'Open in new tab': 'Відкрити у новій вкладці',
    'Open in fullsize': 'Відкрити редактор в повному розмірі',
    'Clear Formatting': 'Очистити форматування',
    'Fill color or set the text color': 'Колір заливки або колір текста',
    Redo: 'Повторити',
    Undo: 'Відмінити',
    Bold: 'Жирний',
    Italic: 'Курсів',
    'Insert Unordered List': 'Вставити невпорядкований список',
    'Insert Ordered List': 'Вставити нумерованний список',
    'Align Center': 'Вирівняти по центру',
    'Align Justify': 'Вирівняти по ширині',
    'Align Left': 'Вирівняти по лівому краю',
    'Align Right': 'Вирівняти по правому краю',
    'Insert Horizontal Line': 'Вставити горизонтальну лінію',
    'Insert Image': 'Вставити зображення',
    'Insert file': 'Вставити файл',
    'Insert youtube/vimeo video': 'Вставити відео',
    'Insert link': 'Вставити посилання',
    'Font size': 'Розмір шрифту',
    'Font family': 'Шрифт',
    'Insert format block': 'Вставити блочний елемент',
    Normal: 'Нормальний текст',
    'Heading 1': 'Заголовок 1',
    'Heading 2': 'Заголовок 2',
    'Heading 3': 'Заголовок 3',
    'Heading 4': 'Заголовок 4',
    Quote: 'Цитата',
    Code: 'Код',
    Insert: 'Вставити',
    'Insert table': 'Вставити таблицю',
    'Decrease Indent': 'Збільшити відступ',
    'Increase Indent': 'Зменшити відступ',
    'Select Special Character': 'Оберіть спеціальный символ',
    'Insert Special Character': 'Вставити спеціальный символ',
    'Paint format': 'Формат краски',
    'Change mode': 'Джерело',
    Margins: 'Відступи',
    top: 'зверху',
    right: 'справа',
    bottom: 'знизу',
    left: 'зліва',
    Styles: 'Стилі',
    Classes: 'Класи',
    Align: 'Вирівнювання',
    Right: 'По правому краю',
    Center: 'По центру',
    Left: 'По лівому краю',
    '--Not Set--': '--не встановлено--',
    Src: 'src',
    Title: 'Заголовок',
    Alternative: 'Альтернативний текст (alt)',
    Link: 'Посилання',
    'Open link in new tab': 'Відкрити посилання в новій вкладці',
    file: 'Файл',
    Advanced: 'Розширені',
    'Image properties': 'Властивості зображення',
    Cancel: 'Відміна',
    Ok: 'Ок',
    'Your code is similar to HTML. Keep as HTML?': 'Текст, який Ви намагаєтесь вставити схожий на HTML. Вставити його як HTML?',
    'Paste as HTML': 'Вставити його як HTML',
    Keep: 'Зберегти оригінал',
    Clean: 'Почистити',
    'Insert as Text': 'Вставити як текст',
    'Insert only Text': 'Вставити тільки текст',
    'Word Paste Detected': 'Можливо це фрагмент Word або Excel',
    'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?': 'Ви вставляєте контент з документа Microsoft Word або Excel. Бажаєте зберегти форматування?',
    'File Browser': 'Браузер файлів',
    'Error on load list': 'Помилка при завантаженні списку зображень',
    'Error on load folders': 'Помилка при завантаженні списку папок',
    'Are you sure?': 'Ви впевнені?',
    'Enter Directory name': 'Введіть назву папки',
    'Create directory': 'Створити папку',
    'type name': 'введіть назву',
    'Drop image': 'Перетягніть зображення сюди',
    'Drop file': 'Перетягніть файл сюди',
    'or click': 'або клікніть',
    'Alternative text': 'Альтернативный текст',
    Browse: 'Сервер',
    Upload: 'Завантаження',
    Background: 'Фон',
    Text: 'Текст',
    Top: ' Вгору',
    Middle: 'По центру',
    Bottom: 'Донизу',
    'Insert column before': 'Вставити стовпець до',
    'Insert column after': 'Вставити стовпець після',
    'Insert row above': 'Вставити рядок вище',
    'Insert row below': 'Вставити рядок нижче',
    'Delete table': 'Видалити таблицю',
    'Delete row': 'Видалити рядок',
    'Delete column': 'Видалити стовпчик',
    'Empty cell': 'Очистити кліинку',
    source: 'HTML',
    bold: 'жирний',
    italic: 'курсів',
    brush: 'заливка',
    link: 'посилання',
    undo: 'відмінити',
    redo: 'повторити',
    table: 'таблиця',
    image: 'зображення',
    eraser: 'видалення',
    paragraph: 'параграф',
    fontsize: 'розмір шрифту',
    video: 'відео',
    font: 'шрифт',
    about: 'про редактор',
    print: 'друк',
    underline: 'підкреслений',
    strikethrough: 'закреслений',
    indent: 'відступ',
    outdent: 'заступ',
    fullsize: 'на весь екран',
    shrink: 'звичайний розмір',
    hr: 'лінія',
    ul: 'Список',
    ol: 'Нумерований список',
    cut: 'Вирізати',
    selectall: 'Виділити все',
    'Embed code': 'Код',
    'Open link': 'Відкрити посилання',
    'Edit link': 'Редагувати посилання',
    'No follow': 'Атрибут nofollow',
    Unlink: 'Видалити посилання',
    Eye: 'Перегляд',
    pencil: 'Редагування',
    Update: 'Оновити',
    ' URL': 'URL',
    Edit: 'Редагувати',
    'Horizontal align': 'Горизонтальне вирівнювання',
    Filter: 'Фільтр',
    'Sort by changed': 'Сортувати за зміною',
    'Sort by name': "Сортувати за ім'ям",
    'Sort by size': 'Сортувати за розміром',
    'Add folder': 'Додати папку',
    Reset: 'Відновити',
    Save: 'Зберегти',
    'Save as ...': 'Зберегти як',
    Resize: 'Змінити розмір',
    Crop: 'Обрізати розмір',
    Width: 'Ширина',
    Height: 'Висота',
    'Keep Aspect Ratio': 'Зберегти пропорції',
    Yes: 'Так',
    No: 'Ні',
    Remove: 'Видалити',
    Select: 'Вибрати',
    'Chars: %d': 'Символів: %d',
    'Words: %d': 'Слів: %d',
    All: 'Вибрати все',
    'Select %s': 'Вибрати: %s',
    'Select all': 'Вибрати все',
    'Vertical align': 'Вертикальне вирівнювання',
    Split: 'Розділити',
    'Split vertical': 'Розділити по вертикалі',
    'Split horizontal': 'Розділити по горизонталі',
    Merge: "Об'єднати в одну",
    'Add column': 'Додати стовпчик',
    'Add row': 'Додати рядок',
    Delete: 'Видалити',
    Border: 'Рамка',
    'License: %s': 'Ліцензія: %s',
    'Strike through': 'Закреслений',
    Underline: 'Підкреслений',
    superscript: 'верхній індекс',
    subscript: 'індекс',
    'Cut selection': 'Обрізати вибране',
    Break: 'Межа',
    'Search for': 'Шукати',
    'Replace with': 'Замінити на',
    Replace: 'Замінити',
    Paste: 'Вставити',
    'Choose Content to Paste': 'Обрати контент для вставки',
    'You can only edit your own images. Download this image on the host?': 'Ви можете редагувати лише власні зображення. Завантажити зображення на ваш сервер?',
    'The image has been successfully uploaded to the host!': 'Зображення успішно завантажено на сервер!',
    palette: 'палітра',
    'There are no files': 'Файли відсутні',
    Rename: 'Змінити назву',
    'Enter new name': "Введіть нове імя'",
    preview: 'Попередній перегляд',
    download: 'Завантажити',
    'Paste from clipboard': 'Вставити з буфера обміну',
    "Your browser doesn't support direct access to the clipboard.": 'Ваш браузер не підтримує доступ до буфера обміну.',
    'Copy selection': 'Копіювати виділене',
    copy: 'копія',
    'Border radius': 'Радіус рамки',
    'Show all': 'Показати все',
    Apply: 'Застосувати',
    'Please fill out this field': 'Будь ласка, заповніть це поле',
    'Please enter a web address': 'Будь ласка, введіть веб-адресу',
    Default: 'За замовченням',
    Circle: 'Коло',
    Dot: 'Крапка',
    Quadrate: 'Квадрат',
    Find: 'Знайти',
    'Find Previous': 'Знайти попередні',
    'Find Next': 'Знайти наступні',
    'Insert className': 'Вставити клас',
    'Press Alt for custom resizing': 'Натисніть Alt для зміни розміру'
});


/***/ }),

/***/ 19033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    'Line height': '行高'
});


/***/ }),

/***/ 19057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   t: function() { return /* binding */ hasPreviousBlock; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/**
 * @private
 */ function hasPreviousBlock(fake, jodit) {
    return Boolean(_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.prev(fake, (elm)=>_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isBlock(elm) || _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isImage(elm), jodit.editor));
}


/***/ }),

/***/ 19063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export copyFormat */
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41180);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6441);
/* harmony import */ var _copy_format_svg_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57487);
/* harmony import */ var _langs_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23914);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 






const pluginKey = 'copy-format';
/**
 * Plug-in copy and paste formatting from one element to another
 */ const copyStyles = [
    'fontWeight',
    'fontStyle',
    'fontSize',
    'color',
    'margin',
    'padding',
    'borderWidth',
    'borderStyle',
    'borderColor',
    'borderRadius',
    'backgroundColor',
    'textDecorationLine',
    'fontFamily'
];
const getStyle = (editor, key, box, defaultStyles)=>{
    let result = (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_5__/* .css */ .A)(box, key);
    if (result === defaultStyles[key]) {
        if (box.parentNode && box !== editor.editor && box.parentNode !== editor.editor) {
            result = getStyle(editor, key, box.parentNode, defaultStyles);
        } else {
            result = undefined;
        }
    }
    return result;
};
const getStyles = (editor, box, defaultStyles)=>{
    const result = {};
    if (box) {
        copyStyles.forEach((key)=>{
            result[key] = getStyle(editor, key, box, defaultStyles);
            if (key.match(/border(Style|Color)/) && !result.borderWidth) {
                result[key] = undefined;
            }
        });
    }
    return result;
};
_config_js__WEBPACK_IMPORTED_MODULE_3__/* .Config */ .T.prototype.controls.copyformat = {
    exec: (editor, current, { button })=>{
        if (!current) {
            return;
        }
        if (editor.buffer.exists(pluginKey)) {
            editor.buffer.delete(pluginKey);
            editor.e.off(editor.editor, 'mouseup.' + pluginKey);
        } else {
            const defaultStyles = {}, box = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.up(current, (elm)=>elm && !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isText(elm), editor.editor) || editor.editor;
            const ideal = editor.createInside.span();
            editor.editor.appendChild(ideal);
            copyStyles.forEach((key)=>{
                defaultStyles[key] = (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_5__/* .css */ .A)(ideal, key);
            });
            if (ideal !== editor.editor) {
                _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(ideal);
            }
            const format = getStyles(editor, box, defaultStyles);
            const onMouseUp = ()=>{
                editor.buffer.delete(pluginKey);
                const currentNode = editor.s.current();
                if (currentNode) {
                    if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(currentNode, 'img')) {
                        (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_5__/* .css */ .A)(currentNode, format);
                    } else {
                        editor.s.commitStyle({
                            attributes: {
                                style: format
                            }
                        });
                    }
                }
                editor.e.off(editor.editor, 'mouseup.' + pluginKey);
            };
            editor.e.on(editor.editor, 'mouseup.' + pluginKey, onMouseUp);
            editor.buffer.set(pluginKey, true);
        }
        button.update();
    },
    isActive: (editor)=>editor.buffer.exists(pluginKey),
    tooltip: 'Paint format'
};
function copyFormat(editor) {
    editor.registerButton({
        name: 'copyformat',
        group: 'clipboard'
    });
    (0,_core_global_js__WEBPACK_IMPORTED_MODULE_1__/* .extendLang */ .JW)(_langs_index_js__WEBPACK_IMPORTED_MODULE_4__);
}
_core_global_js__WEBPACK_IMPORTED_MODULE_1__/* .pluginSystem */ .fg.add('copyformat', copyFormat);
_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .I.set('copyformat', _copy_format_svg_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A);


/***/ }),

/***/ 19070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Y: function() { return /* binding */ UIBlock; }
/* harmony export */ });
/* harmony import */ var _decorators_component_component_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87325);
/* harmony import */ var _helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43555);
/* harmony import */ var _group_group_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62405);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let UIBlock = class UIBlock extends _group_group_js__WEBPACK_IMPORTED_MODULE_1__/* .UIGroup */ .U {
    /** @override */ className() {
        return 'UIBlock';
    }
    constructor(jodit, elements, options = {
        align: 'left'
    }){
        super(jodit, elements);
        this.options = options;
        this.setMod('align', this.options.align || 'left');
        this.setMod('width', this.options.width || '');
        this.options.mod && this.setMod(this.options.mod, true);
        this.options.className && this.container.classList.add(this.options.className);
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_0__/* .attr */ .CF)(this.container, 'data-ref', options.ref);
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_0__/* .attr */ .CF)(this.container, 'ref', options.ref);
    }
};
UIBlock = __decorate([
    _decorators_component_component_js__WEBPACK_IMPORTED_MODULE_2__/* .component */ .s
], UIBlock);



/***/ }),

/***/ 19147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    newline: 'новая строка|перенос|энтер',
    delete: 'удалить',
    space: 'пробел',
    'Speech Recognize': 'Распознавание речи',
    Sound: 'Звук',
    'Interim Results': 'Промежуточные результаты'
});


/***/ }),

/***/ 19263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   L: function() { return /* binding */ wrap; }
/* harmony export */ });
/* harmony import */ var _dom_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22732);
/* harmony import */ var _helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29960);
/* harmony import */ var _list_wrap_list_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82515);
/* harmony import */ var _wrap_unwrapped_text_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6980);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



/**
 * Replaces the parent tag with the applicable one, or wraps the text and also replaces the tag
 * @private
 */ function wrap(commitStyle, font, jodit) {
    const wrapper = findOrCreateWrapper(commitStyle, font, jodit);
    return commitStyle.elementIsList ? (0,_list_wrap_list_js__WEBPACK_IMPORTED_MODULE_2__/* .wrapList */ .z)(commitStyle, wrapper, jodit) : _dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.replace(wrapper, commitStyle.element, jodit.createInside, true);
}
const WRAP_NODES = new Set([
    'td',
    'th',
    'tr',
    'tbody',
    'table',
    'li',
    'ul',
    'ol'
]);
/**
 * If we apply a block element, then it finds the closest block parent (exclude table cell etc.),
 * otherwise it wraps free text in an element.
 */ function findOrCreateWrapper(commitStyle, font, jodit) {
    if (commitStyle.elementIsBlock) {
        const box = _dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.up(font, (node)=>_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isBlock(node) && !_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(node, WRAP_NODES), jodit.editor);
        if (box) {
            return box;
        }
        return (0,_wrap_unwrapped_text_js__WEBPACK_IMPORTED_MODULE_3__/* .wrapUnwrappedText */ .Y)(commitStyle, font, jodit);
    }
    (0,_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .C)(font, 'size', null);
    return font;
}


/***/ }),

/***/ 19271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export dragAndDrop */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2748);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21537);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50911);
/* harmony import */ var _modules_file_browser_ui_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8172);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







/**
 * Process drag and drop image from FileBrowser and movev image inside the editor
 */ class dragAndDrop extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_5__/* .Plugin */ .k {
    /** @override */ afterInit() {
        this.j.e.on([
            window,
            this.j.ed,
            this.j.editor
        ], 'dragstart.DragAndDrop', this.onDragStart);
    }
    onDragStart(event) {
        let target = event.target;
        this.onDragEnd(); // remove old draggable
        this.isFragmentFromEditor = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isOrContains(this.j.editor, target, true);
        this.isCopyMode = this.isFragmentFromEditor ? (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.ctrlKey)(event) : true; // we can move only element from editor
        if (this.isFragmentFromEditor) {
            const sel = this.j.s.sel;
            const range = sel && sel.rangeCount ? sel.getRangeAt(0) : null;
            if (range) {
                this.bufferRange = range.cloneRange();
            }
        } else {
            this.bufferRange = null;
        }
        this.startDragPoint.x = event.clientX;
        this.startDragPoint.y = event.clientY;
        if (isFileBrowserFilesItem(target)) {
            target = target.querySelector('img');
        }
        if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isTag(target, 'img')) {
            this.draggable = target.cloneNode(true);
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.dataBind)(this.draggable, 'target', target);
        }
        this.addDragListeners();
    }
    addDragListeners() {
        this.j.e.on('dragover', this.onDrag).on('drop.DragAndDrop', this.onDrop).on(window, 'dragend.DragAndDrop drop.DragAndDrop mouseup.DragAndDrop', this.onDragEnd);
    }
    removeDragListeners() {
        this.j.e.off('dragover', this.onDrag).off('drop.DragAndDrop', this.onDrop).off(window, 'dragend.DragAndDrop drop.DragAndDrop mouseup.DragAndDrop', this.onDragEnd);
    }
    onDrag(event) {
        if (this.draggable) {
            this.j.e.fire('hidePopup');
            this.j.s.insertCursorAtPoint(event.clientX, event.clientY);
            event.preventDefault();
            event.stopPropagation();
        }
    }
    onDragEnd() {
        if (this.draggable) {
            _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(this.draggable);
            this.draggable = null;
        }
        this.isCopyMode = false;
        this.removeDragListeners();
    }
    onDrop(event) {
        if (!event.dataTransfer || !event.dataTransfer.files || !event.dataTransfer.files.length) {
            if (!this.isFragmentFromEditor && !this.draggable) {
                this.j.e.fire('paste', event);
                event.preventDefault();
                event.stopPropagation();
                return false;
            }
            const sel = this.j.s.sel;
            const range = this.bufferRange || (sel && sel.rangeCount ? sel.getRangeAt(0) : null);
            const fragment = this.__getWorkFragment(range, event);
            sel && sel.removeAllRanges();
            this.j.s.insertCursorAtPoint(event.clientX, event.clientY);
            if (fragment) {
                this.__insertFragment.call(this, fragment, range);
            }
            event.preventDefault();
            event.stopPropagation();
        }
        this.isFragmentFromEditor = false;
        this.removeDragListeners();
    }
    __getWorkFragment(range, event) {
        let fragment = null;
        if (!this.draggable && range) {
            fragment = this.isCopyMode ? range.cloneContents() : range.extractContents();
        } else if (this.draggable) {
            if (this.isCopyMode) {
                const [tagName, field] = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.attr)(this.draggable, '-is-file') === '1' ? [
                    'a',
                    'href'
                ] : [
                    'img',
                    'src'
                ];
                fragment = this.j.createInside.element(tagName);
                fragment.setAttribute(field, (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.attr)(this.draggable, 'data-src') || (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.attr)(this.draggable, 'src') || '');
                if (tagName === 'a') {
                    fragment.textContent = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.attr)(fragment, field) || '';
                }
            } else {
                fragment = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.dataBind)(this.draggable, 'target');
            }
        } else if (this.getText(event)) {
            fragment = this.j.createInside.fromHTML(this.getText(event));
        }
        return fragment;
    }
    __insertFragment(fragment, range) {
        this.j.s.insertNode(fragment, false, false);
        if (range && fragment.firstChild && fragment.lastChild) {
            range.setStartBefore(fragment.firstChild);
            range.setEndAfter(fragment.lastChild);
            this.j.s.selectRange(range);
            this.j.e.fire('synchro');
        }
        if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isTag(fragment, 'img') && this.j.events) {
            this.j.e.fire('afterInsertImage', fragment);
        }
    }
    /** @override */ beforeDestruct() {
        this.onDragEnd();
        this.j.e.off(window, '.DragAndDrop').off('.DragAndDrop').off([
            window,
            this.j.ed,
            this.j.editor
        ], 'dragstart.DragAndDrop', this.onDragStart);
    }
    constructor(){
        super(...arguments);
        this.isFragmentFromEditor = false;
        this.isCopyMode = false;
        this.startDragPoint = {
            x: 0,
            y: 0
        };
        this.draggable = null;
        this.bufferRange = null;
        this.getText = (event)=>{
            const dt = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.getDataTransfer)(event);
            return dt ? dt.getData(_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.TEXT_HTML) || dt.getData(_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.TEXT_PLAIN) : null;
        };
    }
}
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], dragAndDrop.prototype, "onDragStart", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.throttle)((ctx)=>ctx.defaultTimeout / 10)
], dragAndDrop.prototype, "onDrag", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], dragAndDrop.prototype, "onDragEnd", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], dragAndDrop.prototype, "onDrop", null);
/**
 * @private
 */ function isFileBrowserFilesItem(target) {
    return _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isElement(target) && target.classList.contains(_modules_file_browser_ui_index_js__WEBPACK_IMPORTED_MODULE_6__/* .FileBrowserFiles */ .Q.prototype.getFullElName('item'));
}
_core_global_js__WEBPACK_IMPORTED_MODULE_3__/* .pluginSystem */ .fg.add('dragAndDrop', dragAndDrop);


/***/ }),

/***/ 19292:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'Type something': 'Escreva algo...',
    Advanced: 'Avançado',
    'About Jodit': 'Sobre o Jodit',
    'Jodit Editor': 'Editor Jodit',
    "Jodit User's Guide": 'Guia de usuário Jodit',
    'contains detailed help for using': 'contém ajuda detalhada para o uso.',
    'For information about the license, please go to our website:': 'Para informação sobre a licença, por favor visite nosso site:',
    'Buy full version': 'Compre a versão completa',
    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.': 'Copyright © XDSoft.net - Chupurnov Valeriy. Todos os direitos reservados.',
    Anchor: 'Link',
    'Open in new tab': 'Abrir em nova aba',
    'Open in fullsize': 'Abrir editor em tela cheia',
    'Clear Formatting': 'Limpar formatação',
    'Fill color or set the text color': 'Cor de preenchimento ou cor do texto',
    Redo: 'Refazer',
    Undo: 'Desfazer',
    Bold: 'Negrito',
    Italic: 'Itálico',
    'Insert Unordered List': 'Inserir lista não ordenada',
    'Insert Ordered List': 'Inserir lista ordenada',
    'Align Center': 'Centralizar',
    'Align Justify': 'Justificar',
    'Align Left': 'Alinhar à Esquerda',
    'Align Right': 'Alinhar à Direita',
    'Insert Horizontal Line': 'Inserir linha horizontal',
    'Insert Image': 'Inserir imagem',
    'Insert file': 'Inserir arquivo',
    'Insert youtube/vimeo video': 'Inserir vídeo do Youtube/vimeo',
    'Insert link': 'Inserir link',
    'Font size': 'Tamanho da letra',
    'Font family': 'Fonte',
    'Insert format block': 'Inserir bloco',
    Normal: 'Normal',
    'Heading 1': 'Cabeçalho 1',
    'Heading 2': 'Cabeçalho 2',
    'Heading 3': 'Cabeçalho 3',
    'Heading 4': 'Cabeçalho 4',
    Quote: 'Citação',
    Code: 'Código',
    Insert: 'Inserir',
    'Insert table': 'Inserir tabela',
    'Decrease Indent': 'Diminuir recuo',
    'Increase Indent': 'Aumentar recuo',
    'Select Special Character': 'Selecionar caractere especial',
    'Insert Special Character': 'Inserir caractere especial',
    'Paint format': 'Copiar formato',
    'Change mode': 'Mudar modo',
    Margins: 'Margens',
    top: 'cima',
    right: 'direta',
    bottom: 'baixo',
    left: 'esquerda',
    Styles: 'Estilos CSS',
    Classes: 'Classes CSS',
    Align: 'Alinhamento',
    Right: 'Direita',
    Center: 'Centro',
    Left: 'Esquerda',
    '--Not Set--': '--Não Estabelecido--',
    Src: 'Fonte',
    Title: 'Título',
    Alternative: 'Texto Alternativo',
    Link: 'Link',
    'Open link in new tab': 'Abrir link em nova aba',
    Image: 'Imagem',
    file: 'Arquivo',
    'Image properties': 'Propriedades da imagem',
    Cancel: 'Cancelar',
    Ok: 'Ok',
    'Your code is similar to HTML. Keep as HTML?': 'Seu código é similar ao HTML. Manter como HTML?',
    'Paste as HTML': 'Colar como HTML?',
    Keep: 'Manter',
    Clean: 'Limpar',
    'Insert as Text': 'Inserir como Texto',
    'Word Paste Detected': 'Colado do Word Detectado',
    'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?': 'O conteúdo colado veio de um documento Microsoft Word/Excel. Você deseja manter o formato ou limpa-lo?',
    'Insert only Text': 'Inserir somente o Texto',
    'File Browser': 'Procurar arquivo',
    'Error on load list': 'Erro ao carregar a lista',
    'Error on load folders': 'Erro ao carregar as pastas',
    'Are you sure?': 'Você tem certeza?',
    'Enter Directory name': 'Escreva o nome da pasta',
    'Create directory': 'Criar pasta',
    'type name': 'Escreva seu nome',
    'Drop image': 'Soltar imagem',
    'Drop file': 'Soltar arquivo',
    'or click': 'ou clique',
    'Alternative text': 'Texto alternativo',
    Browse: 'Explorar',
    Upload: 'Upload',
    Background: 'Fundo',
    Text: 'Texto',
    Top: 'Cima',
    Middle: 'Meio',
    Bottom: 'Baixo',
    'Insert column before': 'Inserir coluna antes',
    'Insert column after': 'Inserir coluna depois',
    'Insert row above': 'Inserir linha acima',
    'Insert row below': 'Inserir linha abaixo',
    'Delete table': 'Excluir tabela',
    'Delete row': 'Excluir linha',
    'Delete column': 'Excluir coluna',
    'Empty cell': 'Limpar célula',
    Delete: 'Excluir',
    'Strike through': 'Tachado',
    Underline: 'Sublinhar',
    Break: 'Pausa',
    'Search for': 'Procurar por',
    'Replace with': 'Substituir com',
    Replace: 'Substituir',
    Edit: 'Editar',
    'Vertical align': 'Alinhamento vertical',
    'Horizontal align': 'Alinhamento horizontal',
    Filter: 'filtrar',
    'Sort by changed': 'Ordenar por modificação',
    'Sort by name': 'Ordenar por nome',
    'Sort by size': 'Ordenar por tamanho',
    'Add folder': 'Adicionar pasta',
    Split: 'Dividir',
    'Split vertical': 'Dividir vertical',
    'Split horizontal': 'Dividir horizontal',
    Merge: 'Mesclar',
    'Add column': 'Adicionar coluna',
    'Add row': 'Adicionar linha',
    Border: 'Borda',
    'Embed code': 'Incluir código',
    Update: 'Atualizar',
    superscript: 'sobrescrito',
    subscript: 'subscrito',
    'Cut selection': 'Cortar seleção',
    Paste: 'Colar',
    'Choose Content to Paste': 'Escolher conteúdo para colar',
    'Chars: %d': 'Caracteres: %d',
    'Words: %d': 'Palavras: %d',
    All: 'Tudo',
    'Select %s': 'Selecionar: %s',
    'Select all': 'Selecionar tudo',
    source: 'HTML',
    bold: 'negrito',
    italic: 'itálico',
    brush: 'pincel',
    link: 'link',
    undo: 'desfazer',
    redo: 'refazer',
    table: 'tabela',
    image: 'imagem',
    eraser: 'apagar',
    paragraph: 'parágrafo',
    fontsize: 'tamanho da letra',
    video: 'vídeo',
    font: 'fonte',
    about: 'Sobre de',
    print: 'Imprimir',
    underline: 'sublinhar',
    strikethrough: 'tachado',
    indent: 'recuar',
    outdent: 'diminuir recuo',
    fullsize: 'Tamanho completo',
    shrink: 'diminuir',
    hr: 'linha horizontal',
    ul: 'lista não ordenada',
    ol: 'lista ordenada',
    cut: 'Cortar',
    selectall: 'Selecionar tudo',
    'Open link': 'Abrir link',
    'Edit link': 'Editar link',
    'No follow': 'Não siga',
    Unlink: 'Remover link',
    Eye: 'Visualizar',
    pencil: 'Editar',
    ' URL': 'URL',
    Reset: 'Resetar',
    Save: 'Salvar',
    'Save as ...': 'Salvar como...',
    Resize: 'Redimensionar',
    Crop: 'Recortar',
    Width: 'Largura',
    Height: 'Altura',
    'Keep Aspect Ratio': 'Manter a proporção',
    Yes: 'Sim',
    No: 'Não',
    Remove: 'Remover',
    Select: 'Selecionar',
    'You can only edit your own images. Download this image on the host?': 'Você só pode editar suas próprias imagens. Baixar essa imagem pro servidor?',
    'The image has been successfully uploaded to the host!': 'A imagem foi enviada com sucesso para o servidor!',
    palette: 'Palette',
    'There are no files': 'Não há arquivos nesse diretório.',
    Rename: 'Húngara',
    'Enter new name': 'Digite um novo nome',
    preview: 'preview',
    download: 'Baixar',
    'Paste from clipboard': 'Colar da área de transferência',
    "Your browser doesn't support direct access to the clipboard.": 'O seu navegador não oferece suporte a acesso direto para a área de transferência.',
    'Copy selection': 'Selecção de cópia',
    copy: 'cópia',
    'Border radius': 'Border radius',
    'Show all': 'Mostrar todos os',
    Apply: 'Aplicar',
    'Please fill out this field': 'Por favor, preencha este campo',
    'Please enter a web address': 'Por favor introduza um endereço web',
    Default: 'Padrão',
    Circle: 'Círculo',
    Dot: 'Ponto',
    Quadrate: 'Quadro',
    'Lower Alpha': 'Letra Minúscula',
    'Lower Greek': 'Grego Minúscula',
    'Lower Roman': 'Romano Minúscula',
    'Upper Alpha': 'Letra Maiúscula',
    'Upper Roman': 'Romano Maiúscula',
    Find: 'Encontrar',
    'Find Previous': 'Encontrar Anteriores',
    'Find Next': 'Localizar Próxima',
    'Insert className': 'Insira o nome da classe',
    'Press Alt for custom resizing': 'Pressione Alt para redimensionamento personalizado'
});


/***/ }),

/***/ 19306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   y: function() { return /* binding */ isJoditObject; }
/* harmony export */ });
/* harmony import */ var _is_function_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23282);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/**
 * Check if element is instance of Jodit
 */ function isJoditObject(jodit) {
    return Boolean(jodit && jodit instanceof Object && (0,_is_function_js__WEBPACK_IMPORTED_MODULE_0__/* .isFunction */ .T)(jodit.constructor) && // @ts-ignore
    (typeof Jodit !== 'undefined' && jodit instanceof Jodit || jodit.isJodit));
}


/***/ }),

/***/ 19308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   en: function() { return /* reexport module object */ _en_js__WEBPACK_IMPORTED_MODULE_0__; },
/* harmony export */   es: function() { return /* reexport module object */ _es_js__WEBPACK_IMPORTED_MODULE_1__; }
/* harmony export */ });
/* harmony import */ var _en_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47193);
/* harmony import */ var _es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7886);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/ai-assistant
 */ 




/***/ }),

/***/ 20071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export media */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43555);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(757);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



/**
 * Process `video` and `audio`
 */ function media(editor) {
    const keyFake = 'jodit_fake_wrapper';
    const { mediaFakeTag, mediaBlocks, mediaInFakeBlock } = editor.options;
    const wrap = (element)=>{
        if (element.parentNode && (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_2__/* .attr */ .CF)(element.parentNode, 'data-jodit_iframe_wrapper')) {
            element = element.parentNode;
        } else {
            const wrapper = editor.createInside.element(mediaFakeTag, {
                'data-jodit-temp': 1,
                contenteditable: false,
                draggable: true,
                [`data-${keyFake}`]: 1
            });
            (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_2__/* .attr */ .CF)(wrapper, 'style', (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_2__/* .attr */ .CF)(element, 'style'));
            wrapper.style.display = element.style.display === 'inline-block' ? 'inline-block' : 'block';
            wrapper.style.width = element.offsetWidth + 'px';
            wrapper.style.height = element.offsetHeight + 'px';
            if (element.parentNode) {
                element.parentNode.insertBefore(wrapper, element);
            }
            wrapper.appendChild(element);
            element = wrapper;
        }
        editor.e.off(element, 'mousedown.select touchstart.select').on(element, 'mousedown.select touchstart.select', ()=>{
            editor.s.setCursorAfter(element);
        });
    };
    if (mediaInFakeBlock) {
        editor.e.on('afterGetValueFromEditor', (data)=>{
            const rxp = new RegExp(`<${mediaFakeTag}[^>]+data-${keyFake}[^>]+>([^]+?)</${mediaFakeTag}>`, 'ig');
            if (rxp.test(data.value)) {
                data.value = data.value.replace(rxp, '$1');
            }
        }).on('change afterInit afterSetMode changePlace', editor.async.debounce(()=>{
            if (!editor.isDestructed && editor.getMode() !== _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_SOURCE) {
                (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_2__.$$)(mediaBlocks.join(','), editor.editor).forEach((elm)=>{
                    if (!(0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_2__/* .dataBind */ .mv)(elm, keyFake)) {
                        (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_2__/* .dataBind */ .mv)(elm, keyFake, true);
                        wrap(elm);
                    }
                });
            }
        }, editor.defaultTimeout));
    }
}
_core_global_js__WEBPACK_IMPORTED_MODULE_1__/* .pluginSystem */ .fg.add('media', media);


/***/ }),

/***/ 20199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   k: function() { return /* binding */ toggleOrderedList; }
/* harmony export */ });
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38837);
/* harmony import */ var _extract_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32526);
/* harmony import */ var _toggle_attributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44253);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77361);
/* harmony import */ var _wrap_list_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82515);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 





/**
 * Replaces `ul->ol` or `ol->ul`, apply styles to the list, or remove a list item from it
 * @private
 */ function toggleOrderedList(commitStyle, li, jodit, mode) {
    if (!li) {
        return mode;
    }
    const list = li.parentElement;
    if (!list) {
        return mode;
    }
    const result = jodit.e.fire(`${_constants_js__WEBPACK_IMPORTED_MODULE_5__/* ._PREFIX */ .ar}BeforeToggleList`, mode, commitStyle, list);
    if (result !== undefined) {
        return result;
    }
    const hook = jodit.e.fire.bind(jodit.e, `${_constants_js__WEBPACK_IMPORTED_MODULE_5__/* ._PREFIX */ .ar}AfterToggleList`);
    if (mode !== _constants_js__WEBPACK_IMPORTED_MODULE_5__/* .UNWRAP */ .OJ) {
        const isChangeMode = (0,_toggle_attributes_js__WEBPACK_IMPORTED_MODULE_3__/* .toggleAttributes */ .Y)(commitStyle, li.parentElement, jodit, _constants_js__WEBPACK_IMPORTED_MODULE_5__/* .INITIAL */ .DI, true) === _constants_js__WEBPACK_IMPORTED_MODULE_5__/* .CHANGE */ .PL;
        // ul => ol, ol => ul or ul => ul.class1
        if (mode === _constants_js__WEBPACK_IMPORTED_MODULE_5__/* .REPLACE */ .dj || isChangeMode || list.tagName.toLowerCase() !== commitStyle.element) {
            const wrapper = unwrapList(_constants_js__WEBPACK_IMPORTED_MODULE_5__/* .REPLACE */ .dj, list, li, jodit, commitStyle);
            const newList = (0,_wrap_list_js__WEBPACK_IMPORTED_MODULE_4__/* .wrapList */ .z)(commitStyle, wrapper, jodit);
            hook(_constants_js__WEBPACK_IMPORTED_MODULE_5__/* .REPLACE */ .dj, newList, commitStyle);
            return _constants_js__WEBPACK_IMPORTED_MODULE_5__/* .REPLACE */ .dj;
        }
    }
    const wrapper = unwrapList(_constants_js__WEBPACK_IMPORTED_MODULE_5__/* .UNWRAP */ .OJ, list, li, jodit, commitStyle);
    hook(_constants_js__WEBPACK_IMPORTED_MODULE_5__/* .UNWRAP */ .OJ, wrapper, commitStyle);
    return _constants_js__WEBPACK_IMPORTED_MODULE_5__/* .UNWRAP */ .OJ;
}
function unwrapList(mode, list, li, jodit, cs) {
    const result = jodit.e.fire(`${_constants_js__WEBPACK_IMPORTED_MODULE_5__/* ._PREFIX */ .ar}BeforeUnwrapList`, mode, list, cs);
    if (result) {
        (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_1__/* .assert */ .v)(_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isHTMLElement(result), `${_constants_js__WEBPACK_IMPORTED_MODULE_5__/* ._PREFIX */ .ar}BeforeUnwrapList hook must return HTMLElement`);
        return result;
    }
    (0,_extract_js__WEBPACK_IMPORTED_MODULE_2__/* .extractSelectedPart */ .y)(list, li, jodit);
    (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_1__/* .assert */ .v)(_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isHTMLElement(li.parentElement), 'Element should be inside the list');
    _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.unwrap(li.parentElement);
    return _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.replace(li, jodit.o.enter.toLowerCase() !== 'br' ? jodit.o.enter : jodit.createInside.fragment(), jodit.createInside);
}


/***/ }),

/***/ 20201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   r: function() { return /* binding */ loadTree; }
/* harmony export */ });
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22732);
/* harmony import */ var _load_items_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30465);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/**
 * Loads a list of directories
 * @private
 */ async function loadTree(fb) {
    fb.tree.setMod('active', true);
    _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.detach(fb.tree.container);
    const items = (0,_load_items_js__WEBPACK_IMPORTED_MODULE_1__/* .loadItems */ .f)(fb);
    if (fb.o.showFoldersPanel) {
        fb.tree.setMod('loading', true);
        const tree = fb.dataProvider.tree(fb.state.currentPath, fb.state.currentSource).then((resp)=>{
            fb.state.sources = resp;
        }).catch(fb.status).finally(()=>fb.tree.setMod('loading', false));
        return Promise.all([
            tree,
            items
        ]);
    }
    fb.tree.setMod('active', false);
    return items;
}


/***/ }),

/***/ 20218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   X: function() { return /* binding */ Create; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _helpers_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21537);
/* harmony import */ var _helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38837);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



class Create {
    get doc() {
        // @ts-ignore - TODO it's a function
        return (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.isFunction)(this.document) ? this.document() : this.document;
    }
    element(tagName, childrenOrAttributes, children) {
        const elm = this.doc.createElement(tagName.toLowerCase());
        this.applyCreateAttributes(elm);
        if (childrenOrAttributes) {
            if ((0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.isPlainObject)(childrenOrAttributes)) {
                (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.attr)(elm, childrenOrAttributes);
            } else {
                children = childrenOrAttributes;
            }
        }
        if (children) {
            (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.asArray)(children).forEach((child)=>elm.appendChild((0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.isString)(child) ? this.fromHTML(child) : child));
        }
        return elm;
    }
    div(className, childrenOrAttributes, children) {
        const div = this.element('div', childrenOrAttributes, children);
        if (className) {
            div.className = className;
        }
        return div;
    }
    sandbox() {
        var _a;
        const iframe = this.element('iframe', {
            sandbox: 'allow-same-origin'
        });
        this.doc.body.appendChild(iframe);
        const doc = (_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.document;
        (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_3__/* .assert */ .v)(doc, 'iframe.contentWindow.document');
        if (!doc) {
            throw Error('Iframe error');
        }
        doc.open();
        doc.write('<!DOCTYPE html><html><head></head><body></body></html>');
        doc.close();
        return [
            doc.body,
            iframe
        ];
    }
    span(className, childrenOrAttributes, children) {
        const span = this.element('span', childrenOrAttributes, children);
        if (className) {
            span.className = className;
        }
        return span;
    }
    a(className, childrenOrAttributes, children) {
        const a = this.element('a', childrenOrAttributes, children);
        if (className) {
            a.className = className;
        }
        return a;
    }
    /**
     * Create text node
     */ text(value) {
        return this.doc.createTextNode(value);
    }
    /**
     * Create invisible text node
     */ fake() {
        return this.text(_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE);
    }
    /**
     * Create HTML Document fragment element
     */ fragment() {
        return this.doc.createDocumentFragment();
    }
    /**
     * Create a DOM element from HTML text
     *
     // eslint-disable-next-line tsdoc/syntax
     * @param refsToggleElement - State dictionary in which you can set the visibility of some of the elements
     * ```js
     * const editor = Jodit.make('#editor');
     * editor.createInside.fromHTML(`<div>
     *   <input name="name" ref="name"/>
     *   <input name="email" ref="email"/>
     * </div>`, {
     *   name: true,
     *   email: false
     * });
     * ```
     */ fromHTML(html, refsToggleElement) {
        const div = this.div();
        div.innerHTML = html.toString();
        const child = div.firstChild !== div.lastChild || !div.firstChild ? div : div.firstChild;
        _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(child);
        if (refsToggleElement) {
            const refElements = (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.refs)(child);
            Object.keys(refsToggleElement).forEach((key)=>{
                const elm = refElements[key];
                if (elm && refsToggleElement[key] === false) {
                    _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.hide(elm);
                }
            });
        }
        return child;
    }
    /**
     * Apply to element `createAttributes` options
     */ applyCreateAttributes(elm) {
        if (this.createAttributes) {
            const ca = this.createAttributes;
            if (ca && ca[elm.tagName.toLowerCase()]) {
                const attrsOpt = ca[elm.tagName.toLowerCase()];
                if ((0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.isFunction)(attrsOpt)) {
                    attrsOpt(elm);
                } else if ((0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.isPlainObject)(attrsOpt)) {
                    (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.attr)(elm, attrsOpt);
                }
            }
        }
    }
    constructor(document, createAttributes){
        this.document = document;
        this.createAttributes = createAttributes;
    }
}


/***/ }),

/***/ 20356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   k: function() { return /* binding */ Plugin; }
/* harmony export */ });
/* harmony import */ var _component_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91907);
/* harmony import */ var _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _helpers_checker_is_jodit_object_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19306);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



class Plugin extends _component_index_js__WEBPACK_IMPORTED_MODULE_0__/* .ViewComponent */ .vG {
    /** @override */ className() {
        return 'Plugin';
    }
    __afterPluginSystemInit() {
        const { j, buttons } = this;
        if (buttons && (0,_helpers_checker_is_jodit_object_js__WEBPACK_IMPORTED_MODULE_2__/* .isJoditObject */ .y)(j)) {
            buttons.forEach((btn)=>{
                j.registerButton(btn);
            });
        }
    }
    __afterInit() {
        this.__inited = true;
        this.setStatus(_component_index_js__WEBPACK_IMPORTED_MODULE_0__/* .STATUSES */ .f.ready);
        this.afterInit(this.jodit);
    }
    init(jodit) {
        if (this.jodit.isReady) {
            this.afterInit(this.jodit);
            this.__afterPluginSystemInit();
            this.jodit.e.fire('rebuildToolbar');
        }
    }
    __beforeDestruct() {
        var _a;
        if (this.isInDestruct) {
            return;
        }
        const { j } = this;
        j.e.off('afterPluginSystemInit', this.__afterPluginSystemInit).off('afterInit', this.__afterInit).off('beforeDestruct', this.destruct);
        this.setStatus(_component_index_js__WEBPACK_IMPORTED_MODULE_0__/* .STATUSES */ .f.beforeDestruct);
        if (!this.__inited) {
            return super.destruct();
        }
        if ((0,_helpers_checker_is_jodit_object_js__WEBPACK_IMPORTED_MODULE_2__/* .isJoditObject */ .y)(j)) {
            (_a = this.buttons) === null || _a === void 0 ? void 0 : _a.forEach((btn)=>{
                j === null || j === void 0 ? void 0 : j.unregisterButton(btn);
            });
        }
        this.beforeDestruct(this.j);
        super.destruct();
    }
    constructor(jodit){
        super(jodit);
        /** @override */ this.buttons = [];
        /**
         * Plugin have CSS style and it should be loaded
         */ this.hasStyle = false;
        this.__inited = false;
        jodit.e.on('afterPluginSystemInit', this.__afterPluginSystemInit).on('afterInit', this.__afterInit).on('beforeDestruct', this.__beforeDestruct);
    }
}
Plugin.requires = [];
__decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], Plugin.prototype, "__afterPluginSystemInit", null);
__decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], Plugin.prototype, "__afterInit", null);
__decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], Plugin.prototype, "__beforeDestruct", null);


/***/ }),

/***/ 20362:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1639 1056q0 5-1 7-64 268-268 434.5t-478 166.5q-146 0-282.5-55t-243.5-157l-129 129q-19 19-45 19t-45-19-19-45v-448q0-26 19-45t45-19h448q26 0 45 19t19 45-19 45l-137 137q71 66 161 102t187 36q134 0 250-65t186-179q11-17 53-117 8-23 30-23h192q13 0 22.5 9.5t9.5 22.5zm25-800v448q0 26-19 45t-45 19h-448q-26 0-45-19t-19-45 19-45l138-138q-148-137-349-137-134 0-250 65t-186 179q-11 17-53 117-8 23-30 23h-199q-13 0-22.5-9.5t-9.5-22.5v-7q65-268 270-434.5t480-166.5q146 0 284 55.5t245 156.5l130-129q19-19 45-19t45 19 19 45z\"/> </svg> ");


/***/ }),

/***/ 20741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    symbols: 'رمز'
});


/***/ }),

/***/ 20882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   M: function() { return /* binding */ align; }
/* harmony export */ });
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22732);
/* harmony import */ var _core_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70799);
/* harmony import */ var _core_helpers_utils_align_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25726);
/* harmony import */ var _core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41180);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



const align = {
    name: 'left',
    childTemplate: (_, __, value)=>value,
    list: [
        'Left',
        'Right',
        'Center',
        'Normal'
    ],
    exec: (editor, elm, { control })=>{
        if (!_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(elm, new Set([
            'img',
            'jodit',
            'jodit-media'
        ]))) {
            return;
        }
        const command = control.args && (0,_core_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .K)(control.args[0]) ? control.args[0].toLowerCase() : '';
        if (!command) {
            return false;
        }
        (0,_core_helpers_utils_align_js__WEBPACK_IMPORTED_MODULE_1__/* .hAlignElement */ .Mr)(elm, command);
        if (_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(elm, new Set([
            'jodit',
            'jodit-media'
        ])) && elm.firstElementChild) {
            (0,_core_helpers_utils_align_js__WEBPACK_IMPORTED_MODULE_1__/* .hAlignElement */ .Mr)(elm.firstElementChild, command);
        }
        editor.synchronizeValues();
        editor.e.fire('recalcPositionPopup');
    },
    tooltip: 'Horizontal align'
};
/* harmony default export */ __webpack_exports__.A = ([
    {
        name: 'delete',
        icon: 'bin',
        tooltip: 'Delete',
        exec: (editor, image)=>{
            image && editor.s.removeNode(image);
        }
    },
    {
        name: 'pencil',
        exec (editor, current) {
            const tagName = current.tagName.toLowerCase();
            if (tagName === 'img') {
                editor.e.fire('openImageProperties', current);
            }
        },
        tooltip: 'Edit'
    },
    {
        name: 'valign',
        list: [
            'Top',
            'Middle',
            'Bottom',
            'Normal'
        ],
        tooltip: 'Vertical align',
        exec: (editor, image, { control })=>{
            if (!_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(image, 'img')) {
                return;
            }
            const command = control.args && (0,_core_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .K)(control.args[0]) ? control.args[0].toLowerCase() : '';
            if (!command) {
                return false;
            }
            (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_3__/* .css */ .A)(image, 'vertical-align', command === 'normal' ? '' : command);
            editor.e.fire('recalcPositionPopup');
        }
    },
    align
]);


/***/ }),

/***/ 21162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   M: function() { return /* binding */ MemoryStorageProvider; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ class MemoryStorageProvider {
    set(key, value) {
        this.data.set(key, value);
        return this;
    }
    delete(key) {
        this.data.delete(key);
        return this;
    }
    get(key) {
        return this.data.get(key);
    }
    exists(key) {
        return this.data.has(key);
    }
    clear() {
        this.data.clear();
        return this;
    }
    constructor(){
        this.data = new Map();
    }
}


/***/ }),

/***/ 21224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $: function() { return /* binding */ normalizeColor; }
/* harmony export */ });
/* harmony import */ var _color_color_to_hex_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35278);
/* harmony import */ var _string_trim_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49055);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/normalize
 */ 

/**
 * Convert rgba and short HEX color to Full text color. #fff to #FFFFFF
 *
 * @param colorInput - string like rgba(red, green, blue, alpha) or rgb(red, green, blue) or #fff or #ffffff
 * @returns HEX color, false - for transparent color
 */ const normalizeColor = (colorInput)=>{
    const newcolor = [
        '#'
    ];
    let color = (0,_color_color_to_hex_js__WEBPACK_IMPORTED_MODULE_1__/* .colorToHex */ .s)(colorInput);
    if (!color) {
        return false;
    }
    color = (0,_string_trim_js__WEBPACK_IMPORTED_MODULE_0__/* .trim */ .Bq)(color.toUpperCase());
    color = color.substring(1);
    if (color.length === 3) {
        for(let i = 0; i < 3; i += 1){
            newcolor.push(color[i]);
            newcolor.push(color[i]);
        }
        return newcolor.join('');
    }
    if (color.length > 6) {
        color = color.slice(0, 6);
    }
    return '#' + color;
};


/***/ }),

/***/ 21473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   N: function() { return /* binding */ processLinks; }
/* harmony export */ });
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */
const processLinks = (elm, ctx) => {
    const links = ctx.links ?? {};
    if (elm.attributes.href && elm.attributes.href.match(/#.+$/)) {
        const name = elm.attributes.href.match(/#(.+)$/)[1];
        links[name] = elm;
    }
    if (elm.attributes.name && links[elm.attributes.name]) {
        const link = links[elm.attributes.name];
        link.attributes.href = link.attributes.href.replace(/.*#(.*)$/, '#$1');
    }
    ctx.links = links;
    return elm;
};


/***/ }),

/***/ 21491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $K: function() { return /* binding */ makeCollection; },
/* harmony export */   BJ: function() { return /* binding */ makeButton; },
/* harmony export */   RR: function() { return /* binding */ makeSelect; }
/* harmony export */ });
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21537);
/* harmony import */ var _button_button_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78644);
/* harmony import */ var _button_content_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80319);
/* harmony import */ var _button_select_select_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83111);
/* harmony import */ var _collection_collection_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11676);
/* harmony import */ var _collection_editor_collection_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37426);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 





/**
 * Collection factory
 */ function makeCollection(jodit, parentElement) {
    const collection = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.isJoditObject)(jodit) ? new _collection_editor_collection_js__WEBPACK_IMPORTED_MODULE_5__/* .ToolbarEditorCollection */ .b(jodit) : new _collection_collection_js__WEBPACK_IMPORTED_MODULE_4__/* .ToolbarCollection */ .Q(jodit);
    if (jodit.o.textIcons) {
        collection.container.classList.add('jodit_text_icons');
    }
    if (parentElement) {
        collection.parentElement = parentElement;
    }
    if (jodit.o.toolbarButtonSize) {
        collection.buttonSize = jodit.o.toolbarButtonSize;
    }
    return collection;
}
/**
 * Button factory
 */ function makeButton(jodit, control, target = null) {
    if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.isFunction)(control.getContent)) {
        return new _button_content_js__WEBPACK_IMPORTED_MODULE_2__/* .ToolbarContent */ .P(jodit, control, target);
    }
    const button = new _button_button_js__WEBPACK_IMPORTED_MODULE_1__/* .ToolbarButton */ .I(jodit, control, target);
    button.state.tabIndex = jodit.o.allowTabNavigation ? 0 : -1;
    return button;
}
function makeSelect(view, control, target = null) {
    return new _button_select_select_js__WEBPACK_IMPORTED_MODULE_3__/* .ToolbarSelect */ .q(view, control, target);
}


/***/ }),

/***/ 21496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   E: function() { return /* binding */ size; }
/* harmony export */ });
/* harmony import */ var _checker_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27613);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
function size(subject) {
    if ((0,_checker_index_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .Kg)(subject) || (0,_checker_index_js__WEBPACK_IMPORTED_MODULE_0__/* .isArray */ .cy)(subject)) {
        return subject.length;
    }
    if ((0,_checker_index_js__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .Qd)(subject)) {
        return Object.keys(subject).length;
    }
    return 0;
}


/***/ }),

/***/ 21537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $$: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.$$; },
/* harmony export */   CamelCaseToKebabCase: function() { return /* reexport safe */ _string_index_js__WEBPACK_IMPORTED_MODULE_7__.N; },
/* harmony export */   ConfigDeepFlatten: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.pi; },
/* harmony export */   ConfigFlatten: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.VL; },
/* harmony export */   ConfigProto: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.tb; },
/* harmony export */   ConnectionError: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.Rc; },
/* harmony export */   LimitedStack: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.dh; },
/* harmony export */   NUMBER_FIELDS_REG: function() { return /* reexport safe */ _normalize_index_js__WEBPACK_IMPORTED_MODULE_5__.b$; },
/* harmony export */   OptionsError: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.ZW; },
/* harmony export */   abort: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.h2; },
/* harmony export */   alignElement: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.Op; },
/* harmony export */   alreadyLoadedList: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.EW; },
/* harmony export */   appendScriptAsync: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.w4; },
/* harmony export */   appendStyleAsync: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.S5; },
/* harmony export */   applyStyles: function() { return /* reexport safe */ _html_index_js__WEBPACK_IMPORTED_MODULE_4__.ZM; },
/* harmony export */   asArray: function() { return /* reexport safe */ _array_index_js__WEBPACK_IMPORTED_MODULE_0__._j; },
/* harmony export */   assert: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.vA; },
/* harmony export */   attr: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.CF; },
/* harmony export */   browser: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.T; },
/* harmony export */   buildQuery: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.Zq; },
/* harmony export */   call: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.T1; },
/* harmony export */   callPromise: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.o_; },
/* harmony export */   camelCase: function() { return /* reexport safe */ _string_index_js__WEBPACK_IMPORTED_MODULE_7__.xQ; },
/* harmony export */   cleanFromWord: function() { return /* reexport safe */ _html_index_js__WEBPACK_IMPORTED_MODULE_4__.wE; },
/* harmony export */   clearAlign: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.Xm; },
/* harmony export */   clearCenterAlign: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.aE; },
/* harmony export */   clearTimeout: function() { return /* reexport safe */ _async_index_js__WEBPACK_IMPORTED_MODULE_1__.D; },
/* harmony export */   cns: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.fV; },
/* harmony export */   colorToHex: function() { return /* reexport safe */ _color_index_js__WEBPACK_IMPORTED_MODULE_3__.s; },
/* harmony export */   completeUrl: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.XO; },
/* harmony export */   connection: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.FI; },
/* harmony export */   convertMediaUrlToVideoEmbed: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.mY; },
/* harmony export */   css: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.AH; },
/* harmony export */   cssPath: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.bE; },
/* harmony export */   ctrlKey: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.Xu; },
/* harmony export */   dataBind: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.mv; },
/* harmony export */   defaultLanguage: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.eG; },
/* harmony export */   error: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.z3; },
/* harmony export */   fastClone: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.y6; },
/* harmony export */   fuzzySearchIndex: function() { return /* reexport safe */ _string_index_js__WEBPACK_IMPORTED_MODULE_7__.Hp; },
/* harmony export */   get: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.Jt; },
/* harmony export */   getClassName: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.uB; },
/* harmony export */   getContentWidth: function() { return /* reexport safe */ _size_index_js__WEBPACK_IMPORTED_MODULE_6__.y6; },
/* harmony export */   getDataTransfer: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.my; },
/* harmony export */   getScrollParent: function() { return /* reexport safe */ _size_index_js__WEBPACK_IMPORTED_MODULE_6__.mH; },
/* harmony export */   getXPathByElement: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.fz; },
/* harmony export */   hAlignElement: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.Mr; },
/* harmony export */   hasBrowserColorPicker: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.kC; },
/* harmony export */   hasContainer: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.kO; },
/* harmony export */   htmlspecialchars: function() { return /* reexport safe */ _html_index_js__WEBPACK_IMPORTED_MODULE_4__.Gq; },
/* harmony export */   humanSizeToBytes: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.zP; },
/* harmony export */   i18n: function() { return /* reexport safe */ _string_index_js__WEBPACK_IMPORTED_MODULE_7__.Ru; },
/* harmony export */   inView: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.l7; },
/* harmony export */   innerWidth: function() { return /* reexport safe */ _size_index_js__WEBPACK_IMPORTED_MODULE_6__.xM; },
/* harmony export */   isAbort: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.rV; },
/* harmony export */   isAbortError: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.zf; },
/* harmony export */   isArray: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.cy; },
/* harmony export */   isAtom: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.mA; },
/* harmony export */   isBoolean: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.Lm; },
/* harmony export */   isDestructable: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.pV; },
/* harmony export */   isEqual: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.n4; },
/* harmony export */   isFastEqual: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.P5; },
/* harmony export */   isFunction: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.Tn; },
/* harmony export */   isHTML: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.AH; },
/* harmony export */   isHtmlFromWord: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.CE; },
/* harmony export */   isInitable: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.Gp; },
/* harmony export */   isInt: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.E6; },
/* harmony export */   isJoditObject: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.y0; },
/* harmony export */   isLicense: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.Mj; },
/* harmony export */   isMarker: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.rg; },
/* harmony export */   isNativeFunction: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.a3; },
/* harmony export */   isNumber: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.Et; },
/* harmony export */   isNumeric: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.kf; },
/* harmony export */   isPlainObject: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.Qd; },
/* harmony export */   isPromise: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.yL; },
/* harmony export */   isSet: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.vM; },
/* harmony export */   isString: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.Kg; },
/* harmony export */   isStringArray: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.Bo; },
/* harmony export */   isURL: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.mv; },
/* harmony export */   isValidName: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.uV; },
/* harmony export */   isViewObject: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.hH; },
/* harmony export */   isVoid: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.Rd; },
/* harmony export */   isWindow: function() { return /* reexport safe */ _checker_index_js__WEBPACK_IMPORTED_MODULE_2__.l6; },
/* harmony export */   kebabCase: function() { return /* reexport safe */ _string_index_js__WEBPACK_IMPORTED_MODULE_7__.kW; },
/* harmony export */   keepNames: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.MJ; },
/* harmony export */   keys: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.HP; },
/* harmony export */   loadImage: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.yt; },
/* harmony export */   loadNext: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.Qt; },
/* harmony export */   loadNextStyle: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.x_; },
/* harmony export */   markAsAtomic: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.Hp; },
/* harmony export */   markDeprecated: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.BG; },
/* harmony export */   markOwner: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.b_; },
/* harmony export */   memorizeExec: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.qN; },
/* harmony export */   nl2br: function() { return /* reexport safe */ _html_index_js__WEBPACK_IMPORTED_MODULE_4__.HA; },
/* harmony export */   normalizeColor: function() { return /* reexport safe */ _normalize_index_js__WEBPACK_IMPORTED_MODULE_5__.$2; },
/* harmony export */   normalizeCssNumericValue: function() { return /* reexport safe */ _normalize_index_js__WEBPACK_IMPORTED_MODULE_5__.n8; },
/* harmony export */   normalizeCssValue: function() { return /* reexport safe */ _normalize_index_js__WEBPACK_IMPORTED_MODULE_5__.iy; },
/* harmony export */   normalizeKeyAliases: function() { return /* reexport safe */ _normalize_index_js__WEBPACK_IMPORTED_MODULE_5__.jB; },
/* harmony export */   normalizeLicense: function() { return /* reexport safe */ _normalize_index_js__WEBPACK_IMPORTED_MODULE_5__.f; },
/* harmony export */   normalizePath: function() { return /* reexport safe */ _normalize_index_js__WEBPACK_IMPORTED_MODULE_5__.Fd; },
/* harmony export */   normalizeRelativePath: function() { return /* reexport safe */ _normalize_index_js__WEBPACK_IMPORTED_MODULE_5__.Vd; },
/* harmony export */   normalizeSize: function() { return /* reexport safe */ _normalize_index_js__WEBPACK_IMPORTED_MODULE_5__.rn; },
/* harmony export */   normalizeUrl: function() { return /* reexport safe */ _normalize_index_js__WEBPACK_IMPORTED_MODULE_5__.l2; },
/* harmony export */   offset: function() { return /* reexport safe */ _size_index_js__WEBPACK_IMPORTED_MODULE_6__.cY; },
/* harmony export */   options: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.fF; },
/* harmony export */   parseQuery: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.Vc; },
/* harmony export */   position: function() { return /* reexport safe */ _size_index_js__WEBPACK_IMPORTED_MODULE_6__.G1; },
/* harmony export */   previewBox: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.u_; },
/* harmony export */   refs: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.DY; },
/* harmony export */   reset: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.cL; },
/* harmony export */   resolveElement: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.tI; },
/* harmony export */   safeHTML: function() { return /* reexport safe */ _html_index_js__WEBPACK_IMPORTED_MODULE_4__.t_; },
/* harmony export */   sanitizeHTMLElement: function() { return /* reexport safe */ _html_index_js__WEBPACK_IMPORTED_MODULE_4__.vn; },
/* harmony export */   scrollIntoViewIfNeeded: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.$v; },
/* harmony export */   set: function() { return /* reexport safe */ _utils_index_js__WEBPACK_IMPORTED_MODULE_8__.hZ; },
/* harmony export */   setTimeout: function() { return /* reexport safe */ _async_index_js__WEBPACK_IMPORTED_MODULE_1__.w; },
/* harmony export */   size: function() { return /* reexport safe */ _size_index_js__WEBPACK_IMPORTED_MODULE_6__.Ej; },
/* harmony export */   splitArray: function() { return /* reexport safe */ _array_index_js__WEBPACK_IMPORTED_MODULE_0__.uM; },
/* harmony export */   sprintf: function() { return /* reexport safe */ _string_index_js__WEBPACK_IMPORTED_MODULE_7__.nv; },
/* harmony export */   stringify: function() { return /* reexport safe */ _string_index_js__WEBPACK_IMPORTED_MODULE_7__.As; },
/* harmony export */   stripTags: function() { return /* reexport safe */ _html_index_js__WEBPACK_IMPORTED_MODULE_4__.Kq; },
/* harmony export */   toArray: function() { return /* reexport safe */ _array_index_js__WEBPACK_IMPORTED_MODULE_0__.$r; },
/* harmony export */   trim: function() { return /* reexport safe */ _string_index_js__WEBPACK_IMPORTED_MODULE_7__.Bq; },
/* harmony export */   trimChars: function() { return /* reexport safe */ _string_index_js__WEBPACK_IMPORTED_MODULE_7__.Gd; },
/* harmony export */   trimInv: function() { return /* reexport safe */ _string_index_js__WEBPACK_IMPORTED_MODULE_7__.gj; },
/* harmony export */   ucfirst: function() { return /* reexport safe */ _string_index_js__WEBPACK_IMPORTED_MODULE_7__.Z2; }
/* harmony export */ });
/* harmony import */ var _array_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76855);
/* harmony import */ var _async_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91898);
/* harmony import */ var _checker_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27613);
/* harmony import */ var _color_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58149);
/* harmony import */ var _html_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75275);
/* harmony import */ var _normalize_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71521);
/* harmony import */ var _size_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56175);
/* harmony import */ var _string_index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59007);
/* harmony import */ var _utils_index_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43555);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * [[include:core/helpers/README.md]]
 * @packageDocumentation
 * @module helpers
 */ 










/***/ }),

/***/ 21597:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\"> <path clip-rule=\"evenodd\" d=\"M306.39,154.09c19.628,4.543,35.244,21.259,39.787,39.523 c1.551,8.54,8.998,14.989,17.904,14.989c9.991,0,18.168-8.175,18.168-18.17c0-13.083-10.991-32.98-25.985-47.881 c-14.719-14.537-32.252-24.802-46.695-24.802c-9.991,0-18.172,8.45-18.172,18.446C291.396,145.094,297.847,152.546,306.39,154.09z M56.629,392.312c-14.09,14.08-14.09,36.979,0,51.059c14.08,14.092,36.981,14.092,50.965,0l104.392-104.303 c24.347,15.181,53.062,23.991,83.953,23.991c87.857,0,158.995-71.142,158.995-158.999c0-87.854-71.138-158.995-158.995-158.995 c-87.856,0-158.995,71.141-158.995,158.995c0,30.802,8.819,59.606,23.992,83.953L56.629,392.312z M182.371,204.06 c0-62.687,50.875-113.568,113.568-113.568s113.569,50.881,113.569,113.568c0,62.694-50.876,113.569-113.569,113.569 S182.371,266.754,182.371,204.06z\" fill-rule=\"evenodd\"/> </svg> ");


/***/ }),

/***/ 21988:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21537);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6441);
/* harmony import */ var _modules_widget_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92762);
/* harmony import */ var _brush_svg_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46104);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 





_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .I.set('brush', _brush_svg_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A);
_config_js__WEBPACK_IMPORTED_MODULE_3__/* .Config */ .T.prototype.controls.brushCell = {
    isVisible: (editor)=>{
        return !editor.o.disablePlugins.includes('color');
    },
    icon: 'brush',
    popup: (editor, _, close)=>{
        if (!(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.isJoditObject)(editor)) {
            return;
        }
        const tableModule = editor.getInstance('Table', editor.o), selected = tableModule.getAllSelectedCells();
        if (!selected.length) {
            return false;
        }
        const makeColorPicker = (key)=>(0,_modules_widget_index_js__WEBPACK_IMPORTED_MODULE_4__/* .ColorPickerWidget */ .Kn)(editor, (value)=>{
                selected.forEach((cell)=>{
                    (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.css)(cell, key, value);
                });
                editor.lock();
                editor.synchronizeValues();
                close();
                editor.unlock();
            }, (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.css)(selected[0], key));
        return (0,_modules_widget_index_js__WEBPACK_IMPORTED_MODULE_4__/* .TabsWidget */ .Zg)(editor, [
            {
                name: 'Background',
                content: makeColorPicker('background-color')
            },
            {
                name: 'Text',
                content: makeColorPicker('color')
            },
            {
                name: 'Border',
                content: makeColorPicker('border-color')
            }
        ]);
    },
    tooltip: 'Background'
};
_config_js__WEBPACK_IMPORTED_MODULE_3__/* .Config */ .T.prototype.controls.brush = {
    isVisible: (editor)=>{
        return !editor.o.disablePlugins.includes('color');
    },
    update (editor, button) {
        const color = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.dataBind)(button, 'color');
        const update = (key, value)=>{
            if (value && value !== (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.css)(editor.editor, key).toString()) {
                button.state.icon.fill = value;
                return;
            }
        };
        if (color) {
            const mode = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.dataBind)(button, 'color');
            update(mode === 'color' ? mode : 'background-color', color);
            return;
        }
        const current = editor.s.current();
        if (current && !button.state.disabled) {
            const currentBpx = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(current, _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isElement, editor.editor) || editor.editor;
            update('color', (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.css)(currentBpx, 'color').toString());
            update('background-color', (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.css)(currentBpx, 'background-color').toString());
        }
        button.state.icon.fill = '';
        button.state.activated = false;
    },
    popup: (editor, current, close, button)=>{
        let colorHEX = '', bg_color = '', tabs = [], currentElement = null;
        if (current && current !== editor.editor && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isNode(current)) {
            if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isElement(current) && editor.s.isCollapsed() && !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(current, new Set([
                'br',
                'hr'
            ]))) {
                currentElement = current;
            }
            _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.up(current, (node)=>{
                if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isHTMLElement(node)) {
                    const color = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.css)(node, 'color', true), background = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.css)(node, 'background-color', true);
                    if (color) {
                        colorHEX = color.toString();
                        return true;
                    }
                    if (background) {
                        bg_color = background.toString();
                        return true;
                    }
                }
            }, editor.editor);
        }
        const backgroundTag = (0,_modules_widget_index_js__WEBPACK_IMPORTED_MODULE_4__/* .ColorPickerWidget */ .Kn)(editor, (value)=>{
            if (!currentElement) {
                editor.execCommand('background', false, value);
            } else {
                currentElement.style.backgroundColor = value;
            }
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.dataBind)(button, 'color', value);
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.dataBind)(button, 'color-mode', 'background');
            close();
        }, bg_color);
        const colorTab = (0,_modules_widget_index_js__WEBPACK_IMPORTED_MODULE_4__/* .ColorPickerWidget */ .Kn)(editor, (value)=>{
            if (!currentElement) {
                editor.execCommand('forecolor', false, value);
            } else {
                currentElement.style.color = value;
            }
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.dataBind)(button, 'color', value);
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.dataBind)(button, 'color-mode', 'color');
            close();
        }, colorHEX);
        tabs = [
            {
                name: 'Background',
                content: backgroundTag
            },
            {
                name: 'Text',
                content: colorTab
            }
        ];
        if (editor.o.colorPickerDefaultTab !== 'background') {
            tabs = tabs.reverse();
        }
        return (0,_modules_widget_index_js__WEBPACK_IMPORTED_MODULE_4__/* .TabsWidget */ .Zg)(editor, tabs, currentElement);
    },
    exec (jodit, current, { button }) {
        const mode = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.dataBind)(button, 'color-mode'), color = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.dataBind)(button, 'color');
        if (!mode) {
            return false;
        }
        if (current && current !== jodit.editor && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isNode(current) && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isElement(current)) {
            switch(mode){
                case 'color':
                    current.style.color = color;
                    break;
                case 'background':
                    current.style.backgroundColor = color;
                    break;
            }
        } else {
            jodit.execCommand(mode === 'background' ? mode : 'forecolor', false, color);
        }
    },
    tooltip: 'Fill color or set the text color'
};


/***/ }),

/***/ 22030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Y: function() { return /* binding */ hasSameStyleKeys; },
/* harmony export */   g: function() { return /* binding */ hasSameStyle; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _helpers_checker_is_void_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86068);
/* harmony import */ var _helpers_normalize_normalize_css_value_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3760);
/* harmony import */ var _helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38837);
/* harmony import */ var _helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41180);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 





/**
 * Element has the same styles as in the commit
 * @private
 */ function hasSameStyle(elm, rules) {
    return Boolean(!_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(elm, 'font') && _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isHTMLElement(elm) && Object.keys(rules).every((property)=>{
        const value = (0,_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_3__/* .css */ .A)(elm, property, true);
        if (value === '' && (rules[property] === '' || rules[property] == null)) {
            return true;
        }
        return !(0,_helpers_checker_is_void_js__WEBPACK_IMPORTED_MODULE_4__/* .isVoid */ .R)(value) && value !== '' && !(0,_helpers_checker_is_void_js__WEBPACK_IMPORTED_MODULE_4__/* .isVoid */ .R)(rules[property]) && (0,_helpers_normalize_normalize_css_value_js__WEBPACK_IMPORTED_MODULE_5__/* .normalizeCssValue */ .iy)(property, rules[property]).toString().toLowerCase() === value.toString().toLowerCase();
    }));
}
if (_constants_js__WEBPACK_IMPORTED_MODULE_0__.globalDocument) {
    const elm = _constants_js__WEBPACK_IMPORTED_MODULE_0__.globalDocument.createElement('div');
    elm.style.color = 'red';
    (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_2__/* .assert */ .v)(hasSameStyle(elm, {
        color: 'red'
    }), 'Style test');
    (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_2__/* .assert */ .v)(hasSameStyle(elm, {
        fontSize: null
    }), 'Style test');
    (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_2__/* .assert */ .v)(hasSameStyle(elm, {
        fontSize: ''
    }), 'Style test');
}
/**
 * Element has the similar styles keys
 */ function hasSameStyleKeys(elm, rules) {
    return Boolean(!_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(elm, 'font') && _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isHTMLElement(elm) && Object.keys(rules).every((property)=>{
        const value = (0,_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_3__/* .css */ .A)(elm, property, true);
        return value !== '';
    }));
}
if (_constants_js__WEBPACK_IMPORTED_MODULE_0__.globalDocument) {
    const elm2 = _constants_js__WEBPACK_IMPORTED_MODULE_0__.globalDocument.createElement('div');
    elm2.style.color = 'red';
    (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_2__/* .assert */ .v)(hasSameStyleKeys(elm2, {
        color: 'red'
    }), 'Style test');
    (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_2__/* .assert */ .v)(!hasSameStyleKeys(elm2, {
        font: 'Arial',
        color: 'red'
    }), 'Style test');
    (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_2__/* .assert */ .v)(!hasSameStyleKeys(elm2, {
        border: '1px solid #ccc'
    }), 'Style test');
}


/***/ }),

/***/ 22113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    newline: 'Шинэ мөр',
    delete: 'Устгах',
    space: 'Зай',
    'Speech Recognize': 'Дуу хоолой таних',
    Sound: 'Дуу',
    'Interim Results': 'Түр зуурын үр дүн'
});


/***/ }),

/***/ 22396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    symbols: '기호'
});


/***/ }),

/***/ 22432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    newline: 'regel',
    delete: 'verwijderen',
    space: 'ruimte',
    'Speech Recognize': 'Spraak Herkennen',
    Sound: 'Geluid',
    'Interim Results': 'Tussentijdse Resultaten'
});


/***/ }),

/***/ 22461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: function() { return /* binding */ form; }
/* harmony export */ });
/* harmony import */ var _core_ui_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67510);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
const jie = 'jodit-image-editor';
const gi = _core_ui_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Icon */ .In.get.bind(_core_ui_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Icon */ .In);
const act = (el, className = 'jodti-image-editor_active')=>el ? className : '';
const form = (editor, o)=>{
    const i = editor.i18n.bind(editor);
    const switcher = (label, ref, active = true)=>`<div class="jodit-form__group">
			<label class="jodit-switcher-wrapper">
				<span class='jodit-switcher'>
					<input ${act(active, 'checked')} data-ref="${ref}" type="checkbox"/>
					<span class="jodit-switcher__slider"></span>
				</span>
				<span>${i(label)}</span>
			</label>
	</div>`;
    return editor.create.fromHTML(`<form class="${jie} jodit-properties">
		<div class="jodit-grid jodit-grid_xs-column">
			<div class="jodit_col-lg-3-4 jodit_col-sm-5-5">
			${o.resize ? `<div class="${jie}__area ${jie}__area_resize ${jie}_active">
							<div data-ref="resizeBox" class="${jie}__box"></div>
							<div class="${jie}__resizer">
								<i class="jodit_bottomright"></i>
							</div>
						</div>` : ''}
			${o.crop ? `<div class="${jie}__area ${jie}__area_crop ${act(!o.resize)}">
							<div data-ref="cropBox" class="${jie}__box">
								<div class="${jie}__croper">
									<i class="jodit_bottomright"></i>
									<i class="${jie}__sizes"></i>
								</div>
							</div>
						</div>` : ''}
			</div>
			<div class="jodit_col-lg-1-4 jodit_col-sm-5-5">
			${o.resize ? `<div data-area="resize" class="${jie}__slider ${jie}_active">
							<div class="${jie}__slider-title">
								${gi('resize')}
								${i('Resize')}
							</div>
							<div class="${jie}__slider-content">
								<div class="jodit-form__group">
									<label>
										${i('Width')}
									</label>
									<input type="number" data-ref="widthInput" class="jodit-input"/>
								</div>
								<div class="jodit-form__group">
									<label>
										${i('Height')}
									</label>
									<input type="number" data-ref="heightInput" class="jodit-input"/>
								</div>
								${switcher('Keep Aspect Ratio', 'keepAspectRatioResize')}
							</div>
						</div>` : ''}
			${o.crop ? `<div data-area="crop" class="${jie}__slider ${act(!o.resize)}'">
							<div class="${jie}__slider-title">
								${gi('crop')}
								${i('Crop')}
							</div>
							<div class="${jie}__slider-content">
								${switcher('Keep Aspect Ratio', 'keepAspectRatioCrop')}
							</div>
						</div>` : ''}
			</div>
		</div>
	</form>`);
};


/***/ }),

/***/ 22732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   J: function() { return /* reexport safe */ _dom_js__WEBPACK_IMPORTED_MODULE_0__.J; },
/* harmony export */   p: function() { return /* reexport safe */ _lazy_walker_js__WEBPACK_IMPORTED_MODULE_1__.p; }
/* harmony export */ });
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _lazy_walker_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70071);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module dom
 */ 



/***/ }),

/***/ 22859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K: function() { return /* binding */ ColorPickerWidget; }
/* harmony export */ });
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22732);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21537);
/* harmony import */ var _core_ui_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67510);
/* harmony import */ var _palette_svg_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37068);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



_core_ui_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .In.set('palette', _palette_svg_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A);
/**
 * Build color picker
 *
 * @param callback - Callback 'function (color) \{\}'
 * @param coldColor - Color value ex. #fff or rgb(123, 123, 123) or rgba(123, 123, 123, 1)
 * @example
 * ```javascript
 * const tabs = TabsWidget(editor, {
 *    'Text': ColorPickerWidget(editor, function (color) {
 *         box.style.color = color;
 *     }, box.style.color),
 *     'Background': ColorPickerWidget(editor, function (color) {
 *         box.style.backgroundColor = color;
 *     }, box.style.backgroundColor),
 * });
 * ```
 */ const ColorPickerWidget = (editor, callback, coldColor)=>{
    const cn = 'jodit-color-picker', valueHex = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.normalizeColor)(coldColor), form = editor.c.div(cn), iconPalette = editor.o.textIcons ? `<span>${editor.i18n('palette')}</span>` : _core_ui_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .In.get('palette'), eachColor = (colors)=>{
        const stack = [];
        if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.isPlainObject)(colors)) {
            Object.keys(colors).forEach((key)=>{
                stack.push(`<div class="${cn}__group ${cn}__group-${key}">`);
                stack.push(eachColor(colors[key]));
                stack.push('</div>');
            });
        } else if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.isArray)(colors)) {
            colors.forEach((color)=>{
                stack.push(`<span class='${cn}__color-item ${valueHex === color ? cn + '__color-item_active_true' : ''}' title="${color}" style="background-color:${color}" data-color="${color}"></span>`);
            });
        }
        return stack.join('');
    };
    form.appendChild(editor.c.fromHTML(`<div class="${cn}__groups">${eachColor(editor.o.colors)}</div>`));
    form.appendChild(editor.c.fromHTML(`<div data-ref="extra" class="${cn}__extra"></div>`));
    const { extra } = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.refs)(form);
    if (editor.o.showBrowserColorPicker && (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.hasBrowserColorPicker)()) {
        extra.appendChild(editor.c.fromHTML(`<div class="${cn}__native">${iconPalette}<input type="color" value="#ffffff"/></div>`));
        editor.e.on(form, 'change', (e)=>{
            e.stopPropagation();
            const target = e.target;
            if (!target || !target.tagName || !_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(target, 'input')) {
                return;
            }
            const color = target.value || '';
            if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.isFunction)(callback)) {
                callback(color);
            }
            e.preventDefault();
        });
    }
    editor.e.on(form, 'mousedown touchend', (e)=>{
        e.stopPropagation();
        e.preventDefault();
        let target = e.target;
        if ((!target || !target.tagName || _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(target, 'svg') || _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(target, 'path')) && target.parentNode) {
            target = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(target.parentNode, 'span', editor.editor);
        }
        if (!_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(target, 'span') || !target.classList.contains(cn + '__color-item')) {
            return;
        }
        const color = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.attr)(target, '-color') || '';
        if (callback && (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.isFunction)(callback)) {
            callback(color);
        }
    });
    editor.e.fire('afterGenerateColorPicker', form, extra, callback, valueHex);
    return form;
};


/***/ }),

/***/ 23140:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M960 896q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zm300 64l507 398q28 20 25 56-5 35-35 51l-128 64q-13 7-29 7-17 0-31-8l-690-387-110 66q-8 4-12 5 14 49 10 97-7 77-56 147.5t-132 123.5q-132 84-277 84-136 0-222-78-90-84-79-207 7-76 56-147t131-124q132-84 278-84 83 0 151 31 9-13 22-22l122-73-122-73q-13-9-22-22-68 31-151 31-146 0-278-84-82-53-131-124t-56-147q-5-59 15.5-113t63.5-93q85-79 222-79 145 0 277 84 83 52 132 123t56 148q4 48-10 97 4 1 12 5l110 66 690-387q14-8 31-8 16 0 29 7l128 64q30 16 35 51 3 36-25 56zm-681-260q46-42 21-108t-106-117q-92-59-192-59-74 0-113 36-46 42-21 108t106 117q92 59 192 59 74 0 113-36zm-85 745q81-51 106-117t-21-108q-39-36-113-36-100 0-192 59-81 51-106 117t21 108q39 36 113 36 100 0 192-59zm178-613l96 58v-11q0-36 33-56l14-8-79-47-26 26q-3 3-10 11t-12 12q-2 2-4 3.5t-3 2.5zm224 224l96 32 736-576-128-64-768 431v113l-160 96 9 8q2 2 7 6 4 4 11 12t11 12l26 26zm704 416l128-64-520-408-177 138q-2 3-13 7z\"/> </svg> ");


/***/ }),

/***/ 23282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   T: function() { return /* binding */ isFunction; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/checker
 */ /**
 * Check value is Function
 */ function isFunction(value) {
    return typeof value === 'function';
}


/***/ }),

/***/ 23370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   F: function() { return /* binding */ SourceEditor; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ class SourceEditor {
    /**
     * Short alias for this.jodit
     */ get j() {
        return this.jodit;
    }
    onReady() {
        this.replaceUndoManager();
        this.isReady = true;
        this.j.e.fire(this, 'ready');
    }
    onReadyAlways(onReady) {
        var _a;
        if (!this.isReady) {
            (_a = this.j.events) === null || _a === void 0 ? void 0 : _a.on(this, 'ready', onReady);
        } else {
            onReady();
        }
    }
    constructor(jodit, container, toWYSIWYG, fromWYSIWYG){
        this.jodit = jodit;
        this.container = container;
        this.toWYSIWYG = toWYSIWYG;
        this.fromWYSIWYG = fromWYSIWYG;
        this.className = '';
        this.isReady = false;
    }
}


/***/ }),

/***/ 23399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export font */
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21537);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28252);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/**
 * Process commands `fontsize` and `fontname`
 */ function font(editor) {
    editor.registerButton({
        name: 'font',
        group: 'font'
    }).registerButton({
        name: 'fontsize',
        group: 'font'
    });
    const callback = (command, second, third)=>{
        switch(command){
            case 'fontsize':
                editor.s.commitStyle({
                    attributes: {
                        style: {
                            fontSize: (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.normalizeSize)(third, editor.o.defaultFontSizePoints)
                        }
                    }
                });
                break;
            case 'fontname':
                editor.s.commitStyle({
                    attributes: {
                        style: {
                            fontFamily: third
                        }
                    }
                });
                break;
        }
        editor.synchronizeValues();
        return false;
    };
    editor.registerCommand('fontsize', callback).registerCommand('fontname', callback);
}
_core_global_js__WEBPACK_IMPORTED_MODULE_0__/* .pluginSystem */ .fg.add('font', font);


/***/ }),

/***/ 23512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   e: function() { return /* binding */ StatusBar; }
/* harmony export */ });
/* harmony import */ var _core_component_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91907);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2748);
/* harmony import */ var _core_traits_elms_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14316);
/* harmony import */ var _core_traits_mods_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34176);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





let StatusBar = class StatusBar extends _core_component_index_js__WEBPACK_IMPORTED_MODULE_0__/* .ViewComponent */ .vG {
    className() {
        return 'StatusBar';
    }
    /**
     * Hide statusbar
     */ hide() {
        this.container.classList.add('jodit_hidden');
    }
    /**
     * Show statusbar
     */ show() {
        this.container.classList.remove('jodit_hidden');
    }
    /**
     * Status bar is shown
     */ get isShown() {
        return !this.container.classList.contains('jodit_hidden');
    }
    /**
     * Height of statusbar
     */ getHeight() {
        var _a, _b;
        return (_b = (_a = this.container) === null || _a === void 0 ? void 0 : _a.offsetHeight) !== null && _b !== void 0 ? _b : 0;
    }
    findEmpty(inTheRight = false) {
        const items = this.getElms(inTheRight ? 'item-right' : 'item');
        for(let i = 0; i < items.length; i += 1){
            if (!items[i].innerHTML.trim().length) {
                return items[i];
            }
        }
        return;
    }
    /**
     * Add element in statusbar
     */ append(child, inTheRight = false) {
        var _a;
        const wrapper = this.findEmpty(inTheRight) || this.j.c.div(this.getFullElName('item'));
        if (inTheRight) {
            wrapper.classList.add(this.getFullElName('item-right'));
        }
        wrapper.appendChild(child);
        (_a = this.container) === null || _a === void 0 ? void 0 : _a.appendChild(wrapper);
        if (this.j.o.statusbar) {
            this.show();
        }
        this.j.e.fire('resize');
    }
    destruct() {
        if (this.isInDestruct) {
            return;
        }
        this.setStatus(_core_component_index_js__WEBPACK_IMPORTED_MODULE_0__/* .STATUSES */ .f.beforeDestruct);
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(this.container);
        super.destruct();
    }
    constructor(jodit, target){
        super(jodit);
        this.target = target;
        this.mods = {};
        this.container = jodit.c.div('jodit-status-bar');
        target.appendChild(this.container);
        this.hide();
    }
};
StatusBar = __decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.component,
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.derive)(_core_traits_mods_js__WEBPACK_IMPORTED_MODULE_4__/* .Mods */ .K, _core_traits_elms_js__WEBPACK_IMPORTED_MODULE_3__/* .Elms */ .O)
], StatusBar);



/***/ }),

/***/ 23531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export image */
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22732);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21537);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6441);
/* harmony import */ var _modules_widget_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92762);
/* harmony import */ var _image_svg_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25179);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 






_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .I.set('image', _image_svg_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A);
_config_js__WEBPACK_IMPORTED_MODULE_4__/* .Config */ .T.prototype.controls.image = {
    popup: (editor, current, close)=>{
        let sourceImage = null;
        if (current && !_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isText(current) && _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isHTMLElement(current) && (_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(current, 'img') || (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.$$)('img', current).length)) {
            sourceImage = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(current, 'img') ? current : (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.$$)('img', current)[0];
        }
        editor.s.save();
        return (0,_modules_widget_index_js__WEBPACK_IMPORTED_MODULE_5__/* .FileSelectorWidget */ .kG)(editor, {
            filebrowser: (data)=>{
                editor.s.restore();
                data.files && data.files.forEach((file)=>editor.s.insertImage(data.baseurl + file, null, editor.o.imageDefaultWidth));
                close();
            },
            upload: true,
            url: async (url, text)=>{
                editor.s.restore();
                if (/^[a-z\d_-]+(\.[a-z\d_-]+)+/i.test(url)) {
                    url = '//' + url;
                }
                const image = sourceImage || editor.createInside.element('img');
                image.setAttribute('src', url);
                image.setAttribute('alt', text);
                if (!sourceImage) {
                    await editor.s.insertImage(image, null, editor.o.imageDefaultWidth);
                }
                close();
            }
        }, sourceImage, close);
    },
    tags: [
        'img'
    ],
    tooltip: 'Insert Image'
};
function image(editor) {
    editor.registerButton({
        name: 'image',
        group: 'media'
    });
}
_core_global_js__WEBPACK_IMPORTED_MODULE_1__/* .pluginSystem */ .fg.add('image', image);


/***/ }),

/***/ 23658:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 24 24\"> <g transform=\"scale(1.2 1.2) translate(-2 -0.5)\"> <path d=\"M 22,12.5 A 1.49995,1.49995 0 0 0 20.50006,11 H 20 V 10 A 3,3 0 0 0 17,7 H 13 V 5.7226 a 2,2 0 1 0 -2,0 V 7 H 7 a 3,3 0 0 0 -3,3 v 1 H 3.49994 a 1.5,1.5 0 0 0 0,3 H 4 v 1 A 3.00128,3.00128 0 0 0 6.20251,17.89282 1.03113,1.03113 0 0 1 7,18.86975 v 0.716 a 0.99928,0.99928 0 0 0 1.00726,1.002 0.9792,0.9792 0 0 0 0.69983,-0.29486 l 2,-2 A 1,1 0 0 1 11.41425,18 H 17 a 3,3 0 0 0 3,-3 v -1 h 0.50006 A 1.49995,1.49995 0 0 0 22,12.5 Z M 19,15 a 2.00226,2.00226 0 0 1 -2,2 H 11.41425 A 1.987,1.987 0 0 0 10,17.58575 l -2,2 v -0.716 A 2.02082,2.02082 0 0 0 6.46771,16.92865 2.00439,2.00439 0 0 1 5,15 V 10 A 2.00226,2.00226 0 0 1 7,8 h 10 a 2.00222,2.00222 0 0 1 2,2 z M 10,12.5 A 1.5,1.5 0 1 1 8.5,11 1.5,1.5 0 0 1 10,12.5 Z m 7,0 A 1.5,1.5 0 1 1 15.5,11 1.5,1.5 0 0 1 17,12.5 Z\"/> </g> </svg> ");


/***/ }),

/***/ 23738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   G: function() { return /* binding */ getSuitChild; }
/* harmony export */ });
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _is_normal_node_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29136);
/* harmony import */ var _is_suit_element_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97380);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/**
 * Checks if child elements are suitable for applying styles.
 * An element is suitable for us only if it is the only significant child.
 * If the child matches then returns it.
 * @example
 * `<font><strong>selected</strong></font>`
 * @private
 */ function getSuitChild(style, font) {
    let { firstChild: child } = font;
    while(child && !(0,_is_normal_node_js__WEBPACK_IMPORTED_MODULE_1__/* .isNormalNode */ ._)(child)){
        child = child.nextSibling;
        if (!child) {
            return null;
        }
    }
    if (child && !_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.next(child, _is_normal_node_js__WEBPACK_IMPORTED_MODULE_1__/* .isNormalNode */ ._, font) && (0,_is_suit_element_js__WEBPACK_IMPORTED_MODULE_2__/* .isSuitElement */ .sz)(style, child, false)) {
        return child;
    }
    return null;
}


/***/ }),

/***/ 23769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   z: function() { return /* binding */ ProgressBar; }
/* harmony export */ });
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _element_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48538);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

class ProgressBar extends _element_js__WEBPACK_IMPORTED_MODULE_1__/* .UIElement */ .D {
    /** @override */ className() {
        return 'ProgressBar';
    }
    /** @override */ render() {
        return '<div><div></div></div>';
    }
    /**
     * Show progress bar
     */ show() {
        const container = this.j.workplace || this.j.container;
        container.appendChild(this.container);
        return this;
    }
    hide() {
        _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(this.container);
        return this;
    }
    progress(percentage) {
        this.container.style.width = percentage.toFixed(2) + '%';
        return this;
    }
    destruct() {
        this.hide();
        return super.destruct();
    }
}


/***/ }),

/***/ 23914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ar: function() { return /* reexport safe */ _ar_js__WEBPACK_IMPORTED_MODULE_0__.A; },
/* harmony export */   cs_cz: function() { return /* reexport safe */ _cs_cz_js__WEBPACK_IMPORTED_MODULE_1__.A; },
/* harmony export */   de: function() { return /* reexport safe */ _de_js__WEBPACK_IMPORTED_MODULE_2__.A; },
/* harmony export */   es: function() { return /* reexport safe */ _es_js__WEBPACK_IMPORTED_MODULE_3__.A; },
/* harmony export */   fa: function() { return /* reexport safe */ _fa_js__WEBPACK_IMPORTED_MODULE_4__.A; },
/* harmony export */   fi: function() { return /* reexport safe */ _fi_js__WEBPACK_IMPORTED_MODULE_5__.A; },
/* harmony export */   fr: function() { return /* reexport safe */ _fr_js__WEBPACK_IMPORTED_MODULE_6__.A; },
/* harmony export */   he: function() { return /* reexport safe */ _he_js__WEBPACK_IMPORTED_MODULE_7__.A; },
/* harmony export */   hu: function() { return /* reexport safe */ _hu_js__WEBPACK_IMPORTED_MODULE_8__.A; },
/* harmony export */   id: function() { return /* reexport safe */ _id_js__WEBPACK_IMPORTED_MODULE_9__.A; },
/* harmony export */   it: function() { return /* reexport safe */ _it_js__WEBPACK_IMPORTED_MODULE_10__.A; },
/* harmony export */   ja: function() { return /* reexport safe */ _ja_js__WEBPACK_IMPORTED_MODULE_11__.A; },
/* harmony export */   ko: function() { return /* reexport safe */ _ko_js__WEBPACK_IMPORTED_MODULE_12__.A; },
/* harmony export */   mn: function() { return /* reexport safe */ _mn_js__WEBPACK_IMPORTED_MODULE_13__.A; },
/* harmony export */   nl: function() { return /* reexport safe */ _nl_js__WEBPACK_IMPORTED_MODULE_14__.A; },
/* harmony export */   pl: function() { return /* reexport safe */ _pl_js__WEBPACK_IMPORTED_MODULE_15__.A; },
/* harmony export */   pt_br: function() { return /* reexport safe */ _pt_br_js__WEBPACK_IMPORTED_MODULE_16__.A; },
/* harmony export */   ru: function() { return /* reexport safe */ _ru_js__WEBPACK_IMPORTED_MODULE_17__.A; },
/* harmony export */   tr: function() { return /* reexport safe */ _tr_js__WEBPACK_IMPORTED_MODULE_18__.A; },
/* harmony export */   zh_cn: function() { return /* reexport safe */ _zh_cn_js__WEBPACK_IMPORTED_MODULE_19__.A; },
/* harmony export */   zh_tw: function() { return /* reexport safe */ _zh_tw_js__WEBPACK_IMPORTED_MODULE_20__.A; }
/* harmony export */ });
/* harmony import */ var _ar_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63819);
/* harmony import */ var _cs_cz_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72392);
/* harmony import */ var _de_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74551);
/* harmony import */ var _es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2536);
/* harmony import */ var _fa_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52285);
/* harmony import */ var _fi_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12117);
/* harmony import */ var _fr_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35140);
/* harmony import */ var _he_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28435);
/* harmony import */ var _hu_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98019);
/* harmony import */ var _id_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96457);
/* harmony import */ var _it_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(33561);
/* harmony import */ var _ja_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(96545);
/* harmony import */ var _ko_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(52230);
/* harmony import */ var _mn_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(33307);
/* harmony import */ var _nl_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(71042);
/* harmony import */ var _pl_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(32172);
/* harmony import */ var _pt_br_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(39179);
/* harmony import */ var _ru_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(60629);
/* harmony import */ var _tr_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(68278);
/* harmony import */ var _zh_cn_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(1172);
/* harmony import */ var _zh_tw_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(4164);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 























/***/ }),

/***/ 24231:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg viewBox=\"0 0 18.151 18.151\" xmlns=\"http://www.w3.org/2000/svg\"> <g> <path stroke-width=\"0\" d=\"M6.237,16.546H3.649V1.604h5.916v5.728c0.474-0.122,0.968-0.194,1.479-0.194 c0.042,0,0.083,0.006,0.125,0.006V0H2.044v18.15h5.934C7.295,17.736,6.704,17.19,6.237,16.546z\"/> <path stroke-width=\"0\" d=\"M11.169,8.275c-2.723,0-4.938,2.215-4.938,4.938s2.215,4.938,4.938,4.938s4.938-2.215,4.938-4.938 S13.892,8.275,11.169,8.275z M11.169,16.81c-1.983,0-3.598-1.612-3.598-3.598c0-1.983,1.614-3.597,3.598-3.597 s3.597,1.613,3.597,3.597C14.766,15.198,13.153,16.81,11.169,16.81z\"/> <polygon stroke-width=\"0\" points=\"11.792,11.073 10.502,11.073 10.502,12.578 9.03,12.578 9.03,13.868 10.502,13.868 10.502,15.352 11.792,15.352 11.792,13.868 13.309,13.868 13.309,12.578 11.792,12.578 \"/> </g> </svg> ");


/***/ }),

/***/ 24351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    Spellcheck: 'Kontrola pravopisu'
});


/***/ }),

/***/ 24526:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6441);
/* harmony import */ var _items_a_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61122);
/* harmony import */ var _items_cells_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62000);
/* harmony import */ var _items_iframe_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66789);
/* harmony import */ var _items_img_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20882);
/* harmony import */ var _items_toolbar_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14306);
/* harmony import */ var _icons_addcolumn_svg_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24231);
/* harmony import */ var _icons_addrow_svg_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75393);
/* harmony import */ var _icons_merge_svg_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14862);
/* harmony import */ var _icons_splitg_svg_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96257);
/* harmony import */ var _icons_splitv_svg_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9914);
/* harmony import */ var _icons_th_svg_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53696);
/* harmony import */ var _icons_th_list_svg_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(33489);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 













_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.toolbarInline = true;
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.toolbarInlineForSelection = false;
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.toolbarInlineDisableFor = [];
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.toolbarInlineDisabledButtons = [
    'source'
];
_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_0__/* .Icon */ .I.set('addcolumn', _icons_addcolumn_svg_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A).set('addrow', _icons_addrow_svg_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A).set('merge', _icons_merge_svg_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A).set('th', _icons_th_svg_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A).set('splitg', _icons_splitg_svg_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .A).set('splitv', _icons_splitv_svg_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .A).set('th-list', _icons_th_list_svg_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .A);
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.popup = {
    a: _items_a_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A,
    img: _items_img_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A,
    cells: _items_cells_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A,
    toolbar: _items_toolbar_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .A,
    jodit: _items_iframe_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A,
    iframe: _items_iframe_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A,
    'jodit-media': _items_iframe_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A,
    selection: [
        'bold',
        'underline',
        'italic',
        'ul',
        'ol',
        '\n',
        'outdent',
        'indent',
        'fontsize',
        'brush',
        'cut',
        '\n',
        'paragraph',
        'link',
        'align',
        'dots'
    ]
};


/***/ }),

/***/ 24536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   z: function() { return /* binding */ UIList; }
/* harmony export */ });
/* harmony import */ var _component_component_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4012);
/* harmony import */ var _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _helpers_array_split_array_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46559);
/* harmony import */ var _button_button_button_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10830);
/* harmony import */ var _group_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62405);
/* harmony import */ var _separator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92113);
/* harmony import */ var _spacer_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34244);
/* harmony import */ var _helpers_buttons_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43649);
/* harmony import */ var _helpers_get_control_type_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72157);
/* harmony import */ var _helpers_get_strong_control_types_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71262);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};










let UIList = class UIList extends _group_js__WEBPACK_IMPORTED_MODULE_3__/* .UIGroup */ .U {
    /** @override */ className() {
        return 'UIList';
    }
    __onChangeMode() {
        this.setMod('mode', this.mode);
    }
    /**
     * Make new group and append it in list of elements
     */ makeGroup() {
        return new _group_js__WEBPACK_IMPORTED_MODULE_3__/* .UIGroup */ .U(this.jodit);
    }
    /**
     * All buttons from list
     */ get buttons() {
        return this.allChildren.filter((elm)=>_component_component_js__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .u.isInstanceOf(elm, _button_button_button_js__WEBPACK_IMPORTED_MODULE_2__/* .UIButton */ .lD));
    }
    /**
     * Helper for getting full plain button list
     */ getButtonsNames() {
        return this.buttons.map((a)=>a instanceof _button_button_button_js__WEBPACK_IMPORTED_MODULE_2__/* .UIButton */ .lD && a.state.name || '').filter((a)=>a !== '');
    }
    setRemoveButtons(removeButtons) {
        this.removeButtons = removeButtons || [];
        return this;
    }
    build(items, target = null) {
        items = (0,_helpers_array_split_array_js__WEBPACK_IMPORTED_MODULE_8__/* .splitArray */ .u)(items);
        this.clear();
        let lastBtnSeparator = false;
        let line = this.makeGroup();
        this.append(line);
        line.setMod('line', true);
        let group;
        const addButton = (control)=>{
            let elm = null;
            switch(control.name){
                case '\n':
                    line = this.makeGroup();
                    line.setMod('line', true);
                    group = this.makeGroup();
                    line.append(group);
                    this.append(line);
                    break;
                case '|':
                    if (!lastBtnSeparator) {
                        lastBtnSeparator = true;
                        elm = new _separator_js__WEBPACK_IMPORTED_MODULE_4__/* .UISeparator */ .C(this.j);
                    }
                    break;
                case '---':
                    {
                        group.setMod('before-spacer', true);
                        const space = new _spacer_js__WEBPACK_IMPORTED_MODULE_5__/* .UISpacer */ .b(this.j);
                        line.append(space);
                        group = this.makeGroup();
                        line.append(group);
                        lastBtnSeparator = false;
                        break;
                    }
                default:
                    lastBtnSeparator = false;
                    switch(control.component){
                        case 'select':
                            elm = this.makeSelect(control, target);
                            break;
                        case 'button':
                        default:
                            elm = this.makeButton(control, target);
                    }
            }
            if (elm) {
                if (!group) {
                    group = this.makeGroup();
                    line.append(group);
                }
                group.append(elm);
            }
        };
        const isNotRemoved = (b)=>{
            var _a;
            return !this.removeButtons.includes(b.name) && (!b.isVisible || ((_a = b.isVisible) === null || _a === void 0 ? void 0 : _a.call(b, this.j, b)));
        };
        items.forEach((item)=>{
            if ((0,_helpers_buttons_js__WEBPACK_IMPORTED_MODULE_9__/* .isButtonGroup */ .i)(item)) {
                const buttons = item.buttons.filter((b)=>b);
                if (buttons.length) {
                    group = this.makeGroup();
                    group.setMod('separated', true).setMod('group', item.group);
                    line.append(group);
                    (0,_helpers_get_strong_control_types_js__WEBPACK_IMPORTED_MODULE_7__/* .getStrongControlTypes */ .Q)(buttons, this.j.o.controls).filter(isNotRemoved).forEach(addButton);
                }
            } else {
                if (!group) {
                    group = this.makeGroup();
                    line.append(group);
                }
                const control = (0,_helpers_get_control_type_js__WEBPACK_IMPORTED_MODULE_6__/* .getControlType */ .U)(item, this.j.o.controls);
                isNotRemoved(control) && addButton(control);
            }
        });
        this.update();
        return this;
    }
    makeSelect(control, target) {
        throw new Error('Not implemented behaviour');
    }
    /**
     * Create button instance
     */ makeButton(control, target) {
        return new _button_button_button_js__WEBPACK_IMPORTED_MODULE_2__/* .UIButton */ .lD(this.j, {
            name: control.name
        });
    }
    constructor(jodit){
        super(jodit);
        this.mode = 'horizontal';
        this.removeButtons = [];
    }
};
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)('mode'),
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.hook)('ready')
], UIList.prototype, "__onChangeMode", null);
UIList = __decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.component
], UIList);



/***/ }),

/***/ 24630:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _core_helpers_checker_is_plain_object_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72430);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6441);
/* harmony import */ var _paragraph_svg_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89816);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 




_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .I.set('paragraph', _paragraph_svg_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A);
_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.controls.paragraph = {
    command: 'formatBlock',
    value (editor, button) {
        var _a, _b;
        const control = button.control, current = editor.s.current();
        const currentBox = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(current, _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isBlock, editor.editor);
        return (_a = currentBox === null || currentBox === void 0 ? void 0 : currentBox.nodeName.toLowerCase()) !== null && _a !== void 0 ? _a : (_b = control.data) === null || _b === void 0 ? void 0 : _b.currentValue;
    },
    update (editor, button) {
        const control = button.control, current = editor.s.current();
        if (!current) {
            return false;
        }
        const currentValue = button.state.value, list = control.list;
        if ((0,_core_helpers_checker_is_plain_object_js__WEBPACK_IMPORTED_MODULE_4__/* .isPlainObject */ .Q)(list) && list[currentValue.toString()]) {
            if (editor.o.textIcons) {
                button.state.text = list[currentValue.toString()].toString();
            }
        }
        return false;
    },
    data: {
        currentValue: 'p'
    },
    list: {
        p: 'Paragraph',
        h1: 'Heading 1',
        h2: 'Heading 2',
        h3: 'Heading 3',
        h4: 'Heading 4',
        blockquote: 'Quote',
        pre: 'Code'
    },
    isChildActive: (editor, button)=>{
        var _a, _b;
        return Boolean(button.state.value === ((_b = (_a = button.control) === null || _a === void 0 ? void 0 : _a.args) === null || _b === void 0 ? void 0 : _b[0]));
    },
    isActive: (editor, button)=>{
        return button.state.value !== editor.o.enter && (0,_core_helpers_checker_is_plain_object_js__WEBPACK_IMPORTED_MODULE_4__/* .isPlainObject */ .Q)(button.control.list) && Boolean(button.control.list[button.state.value]);
    },
    childTemplate: (e, key, value)=>`<${key} style="margin:0;padding:0"><span>${e.i18n(value)}</span></${key}>`,
    tooltip: 'Insert format block'
};


/***/ }),

/***/ 24829:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 32 32\"> <path d=\"M27 4l-15 15-7-7-5 5 12 12 20-20z\"/> </svg> ");


/***/ }),

/***/ 24877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    newline: 'újsor',
    delete: 'törlés',
    space: 'tér',
    'Speech Recognize': 'A Beszéd Felismeri',
    Sound: 'Hang',
    'Interim Results': 'Időközi Eredmények'
});


/***/ }),

/***/ 25179:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M576 576q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1024 384v448h-1408v-192l320-320 160 160 512-512zm96-704h-1600q-13 0-22.5 9.5t-9.5 22.5v1216q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5v-1216q0-13-9.5-22.5t-22.5-9.5zm160 32v1216q0 66-47 113t-113 47h-1600q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1600q66 0 113 47t47 113z\"/> </svg> ");


/***/ }),

/***/ 25187:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _about_about_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73391);
/* harmony import */ var _add_new_line_add_new_line_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12391);
/* harmony import */ var _backspace_backspace_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93183);
/* harmony import */ var _delete_delete_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66707);
/* harmony import */ var _bold_bold_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41107);
/* harmony import */ var _class_span_class_span_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71255);
/* harmony import */ var _clean_html_clean_html_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82439);
/* harmony import */ var _clipboard_clipboard_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61323);
/* harmony import */ var _color_color_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93079);
/* harmony import */ var _copy_format_copy_format_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19063);
/* harmony import */ var _drag_and_drop_drag_and_drop_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19271);
/* harmony import */ var _drag_and_drop_element_drag_and_drop_element_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1255);
/* harmony import */ var _enter_enter_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(575);
/* harmony import */ var _file_file_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(11317);
/* harmony import */ var _focus_focus_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(36243);
/* harmony import */ var _font_font_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(23399);
/* harmony import */ var _format_block_format_block_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(96111);
/* harmony import */ var _fullsize_fullsize_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(2169);
/* harmony import */ var _hotkeys_hotkeys_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(42263);
/* harmony import */ var _hr_hr_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(16233);
/* harmony import */ var _iframe_iframe_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(77469);
/* harmony import */ var _image_image_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(23531);
/* harmony import */ var _image_processor_image_processor_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(80763);
/* harmony import */ var _image_properties_image_properties_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(3215);
/* harmony import */ var _indent_indent_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(70045);
/* harmony import */ var _inline_popup_inline_popup_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(93401);
/* harmony import */ var _justify_justify_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(76295);
/* harmony import */ var _key_arrow_outside_key_arrow_outside_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(59483);
/* harmony import */ var _limit_limit_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(91071);
/* harmony import */ var _line_height_line_height_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(61019);
/* harmony import */ var _link_link_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(65517);
/* harmony import */ var _media_media_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(20071);
/* harmony import */ var _mobile_mobile_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(32309);
/* harmony import */ var _ordered_list_ordered_list_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(64837);
/* harmony import */ var _paste_paste_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(79799);
/* harmony import */ var _paste_from_word_paste_from_word_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(31571);
/* harmony import */ var _paste_storage_paste_storage_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(85407);
/* harmony import */ var _placeholder_placeholder_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(59451);
/* harmony import */ var _powered_by_jodit_powered_by_jodit_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(18363);
/* harmony import */ var _preview_preview_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(8355);
/* harmony import */ var _print_print_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(58519);
/* harmony import */ var _redo_undo_redo_undo_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(6687);
/* harmony import */ var _resize_cells_resize_cells_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(56113);
/* harmony import */ var _resize_handler_resize_handler_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(9159);
/* harmony import */ var _resizer_resizer_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(12019);
/* harmony import */ var _search_search_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(36125);
/* harmony import */ var _select_select_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(9881);
/* harmony import */ var _select_cells_select_cells_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(28545);
/* harmony import */ var _size_size_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(45927);
/* harmony import */ var _source_source_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(52951);
/* harmony import */ var _spellcheck_spellcheck_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(43809);
/* harmony import */ var _stat_stat_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(7309);
/* harmony import */ var _sticky_sticky_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(68687);
/* harmony import */ var _symbols_symbols_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(59495);
/* harmony import */ var _ai_assistant_ai_assistant_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(39627);
/* harmony import */ var _tab_tab_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(767);
/* harmony import */ var _table_table_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(43003);
/* harmony import */ var _table_keyboard_navigation_table_keyboard_navigation_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(72439);
/* harmony import */ var _video_video_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(26551);
/* harmony import */ var _wrap_nodes_wrap_nodes_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(72253);
/* harmony import */ var _dtd_dtd_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(65735);
/* harmony import */ var _xpath_xpath_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(83671);
/* harmony import */ var _speech_recognize_speech_recognize_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(3115);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * [[include:plugins/README.md]]
 * @packageDocumentation
 * @module plugins
 */ 


// import 'jodit/plugins/debug/debug';



























































// JODIT-START:FAT
 // JODIT-END:FAT


/***/ }),

/***/ 25639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   x: function() { return /* binding */ CommitStyle; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _helpers_string_camel_case_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87058);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77361);
/* harmony import */ var _apply_style_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83632);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



class CommitStyle {
    isApplied(elm, key) {
        const data = this.__applyMap.get(elm);
        if (!data) {
            return false;
        }
        return data[key];
    }
    setApplied(elm, key) {
        var _a;
        const data = (_a = this.__applyMap.get(elm)) !== null && _a !== void 0 ? _a : {};
        data[key] = true;
        this.__applyMap.set(elm, data);
    }
    get elementIsList() {
        return Boolean(this.options.element && _constants_js__WEBPACK_IMPORTED_MODULE_0__.LIST_TAGS.has(this.options.element));
    }
    get element() {
        return this.options.element || this.defaultTag;
    }
    /**
     * New element is blocked
     */ get elementIsBlock() {
        return Boolean(this.options.element && _constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_BLOCK.test(this.options.element));
    }
    /**
     * The commit applies the tag change
     */ get isElementCommit() {
        return Boolean(this.options.element && this.options.element !== this.options.defaultTag);
    }
    get defaultTag() {
        if (this.options.defaultTag) {
            return this.options.defaultTag;
        }
        return this.elementIsBlock ? 'p' : 'span';
    }
    get elementIsDefault() {
        return this.element === this.defaultTag;
    }
    apply(jodit) {
        const { hooks } = this.options;
        const keys = hooks ? Object.keys(hooks) : [];
        try {
            keys.forEach((key)=>{
                jodit.e.on((0,_helpers_string_camel_case_js__WEBPACK_IMPORTED_MODULE_2__/* .camelCase */ .x)(_constants_js__WEBPACK_IMPORTED_MODULE_3__/* ._PREFIX */ .ar + '_' + key), hooks[key]);
            });
            (0,_apply_style_js__WEBPACK_IMPORTED_MODULE_1__/* .ApplyStyle */ .O)(jodit, this);
        } finally{
            keys.forEach((key)=>{
                jodit.e.off((0,_helpers_string_camel_case_js__WEBPACK_IMPORTED_MODULE_2__/* .camelCase */ .x)(_constants_js__WEBPACK_IMPORTED_MODULE_3__/* ._PREFIX */ .ar + '_' + key), hooks[key]);
            });
            this.__applyMap = new WeakMap();
        }
        jodit.synchronizeValues();
        jodit.e.fire('afterCommitStyle', this);
    }
    constructor(options){
        this.options = options;
        this.__applyMap = new WeakMap();
    }
}


/***/ }),

/***/ 25685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   required: function() { return /* binding */ required; },
/* harmony export */   url: function() { return /* binding */ url; }
/* harmony export */ });
/* harmony import */ var _helpers_checker_is_url_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26049);
/* harmony import */ var _helpers_string_trim_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49055);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/**
 * Input is required
 */ const required = function(input) {
    if (!(0,_helpers_string_trim_js__WEBPACK_IMPORTED_MODULE_1__/* .trim */ .Bq)(input.value).length) {
        input.error = 'Please fill out this field';
        return false;
    }
    return true;
};
/**
 * Input value should be valid URL
 */ const url = function(input) {
    if (!(0,_helpers_checker_is_url_js__WEBPACK_IMPORTED_MODULE_0__/* .isURL */ .m)((0,_helpers_string_trim_js__WEBPACK_IMPORTED_MODULE_1__/* .trim */ .Bq)(input.value))) {
        input.error = 'Please enter a web address';
        return false;
    }
    return true;
};


/***/ }),

/***/ 25726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Mr: function() { return /* binding */ hAlignElement; },
/* harmony export */   Op: function() { return /* binding */ alignElement; },
/* harmony export */   Xm: function() { return /* binding */ clearAlign; }
/* harmony export */ });
/* harmony import */ var _dom_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22732);
/* harmony import */ var _css_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41180);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/**
 * Align image
 */ function hAlignElement(image, align) {
    if (align && align !== 'normal') {
        if (align !== 'center') {
            (0,_css_js__WEBPACK_IMPORTED_MODULE_1__/* .css */ .A)(image, 'float', align);
            (0,_css_js__WEBPACK_IMPORTED_MODULE_1__/* .clearCenterAlign */ .a)(image);
        } else {
            (0,_css_js__WEBPACK_IMPORTED_MODULE_1__/* .css */ .A)(image, {
                float: '',
                display: 'block',
                marginLeft: 'auto',
                marginRight: 'auto'
            });
        }
    } else {
        if ((0,_css_js__WEBPACK_IMPORTED_MODULE_1__/* .css */ .A)(image, 'float') && [
            'right',
            'left'
        ].indexOf((0,_css_js__WEBPACK_IMPORTED_MODULE_1__/* .css */ .A)(image, 'float').toString().toLowerCase()) !== -1) {
            (0,_css_js__WEBPACK_IMPORTED_MODULE_1__/* .css */ .A)(image, 'float', '');
        }
        (0,_css_js__WEBPACK_IMPORTED_MODULE_1__/* .clearCenterAlign */ .a)(image);
    }
}
/**
 * Remove text-align style for all selected children
 */ function clearAlign(node) {
    _dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.each(node, (elm)=>{
        if (_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isHTMLElement(elm)) {
            if (elm.style.textAlign) {
                elm.style.textAlign = '';
                if (!elm.style.cssText.trim().length) {
                    elm.removeAttribute('style');
                }
            }
        }
    });
}
/**
 * Apply align for element
 */ function alignElement(command, box) {
    if (_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isNode(box) && _dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isElement(box)) {
        clearAlign(box);
        switch(command.toLowerCase()){
            case 'justifyfull':
                box.style.textAlign = 'justify';
                break;
            case 'justifyright':
                box.style.textAlign = 'right';
                break;
            case 'justifyleft':
                box.style.textAlign = 'left';
                break;
            case 'justifycenter':
                box.style.textAlign = 'center';
                break;
        }
    }
}


/***/ }),

/***/ 25813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   u: function() { return /* binding */ removeInvTextNodes; }
/* harmony export */ });
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/**
 * @private
 */ function removeInvTextNodes(jodit, node, hadEffect, arg, argi, currentNode) {
    if (currentNode === node || !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isText(node) || node.nodeValue == null) {
        return hadEffect;
    }
    if (!(0,_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE_REG_EXP)().test(node.nodeValue)) {
        return hadEffect;
    }
    const focusBox = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.furthest(currentNode, _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isBlock, jodit.editor);
    if (!focusBox || _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isOrContains(focusBox, node)) {
        return hadEffect;
    }
    node.nodeValue = node.nodeValue.replace((0,_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE_REG_EXP)(), '');
    if (node === currentNode && jodit.s.isCollapsed()) {
        jodit.s.setCursorAfter(node);
    }
    if (!node.nodeValue) {
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(node);
    }
    return true;
}


/***/ }),

/***/ 26049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   m: function() { return /* binding */ isURL; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/checker
 */ 
/**
 * Check if a string is an url
 */ function isURL(str) {
    if (str.includes(' ')) {
        return false;
    }
    if (typeof URL !== 'undefined') {
        try {
            const url = new URL(str);
            return [
                'https:',
                'http:',
                'ftp:',
                'file:',
                'rtmp:'
            ].includes(url.protocol);
        } catch (e) {
            return false;
        }
    }
    const a = _constants_js__WEBPACK_IMPORTED_MODULE_0__.globalDocument.createElement('a');
    a.href = str;
    return Boolean(a.hostname);
}


/***/ }),

/***/ 26152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_helpers_checker_is_array_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(68345);
/* harmony import */ var _langs_ar_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79910);
/* harmony import */ var _langs_cs_cz_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4795);
/* harmony import */ var _langs_de_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62770);
/* harmony import */ var _langs_en_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1830);
/* harmony import */ var _langs_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86273);
/* harmony import */ var _langs_fi_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82168);
/* harmony import */ var _langs_fr_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85017);
/* harmony import */ var _langs_he_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32726);
/* harmony import */ var _langs_hu_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67078);
/* harmony import */ var _langs_id_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92648);
/* harmony import */ var _langs_it_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62232);
/* harmony import */ var _langs_ja_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(62700);
/* harmony import */ var _langs_keys_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(75445);
/* harmony import */ var _langs_ko_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(97519);
/* harmony import */ var _langs_mn_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(80926);
/* harmony import */ var _langs_nl_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(52995);
/* harmony import */ var _langs_no_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(59526);
/* harmony import */ var _langs_pl_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(40565);
/* harmony import */ var _langs_pt_br_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(19292);
/* harmony import */ var _langs_ru_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(83160);
/* harmony import */ var _langs_tr_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(28923);
/* harmony import */ var _langs_ua_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(19007);
/* harmony import */ var _langs_zh_cn_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(60175);
/* harmony import */ var _langs_zh_tw_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(69159);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
























let exp = {};
exp = {
    ar: _langs_ar_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A,
    cs_cz: _langs_cs_cz_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A,
    de: _langs_de_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A,
    en: _langs_en_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A,
    es: _langs_es_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A,
    fi: _langs_fi_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A,
    fr: _langs_fr_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A,
    he: _langs_he_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A,
    hu: _langs_hu_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A,
    id: _langs_id_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A,
    it: _langs_it_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .A,
    ja: _langs_ja_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .A,
    ko: _langs_ko_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .A,
    mn: _langs_mn_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .A,
    nl: _langs_nl_js__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .A,
    no: _langs_no_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .A,
    pl: _langs_pl_js__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .A,
    pt_br: _langs_pt_br_js__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .A,
    ru: _langs_ru_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .A,
    tr: _langs_tr_js__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .A,
    ua: _langs_ua_js__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .A,
    zh_cn: _langs_zh_cn_js__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .A,
    zh_tw: _langs_zh_tw_js__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .A
};
/* Unpack array to hash */ const get = (value)=>value ? value.default || value : {}, hashLang = {};
if ((0,_core_helpers_checker_is_array_js__WEBPACK_IMPORTED_MODULE_24__/* .isArray */ .c)(get(_langs_keys_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .A))) {
    get(_langs_keys_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .A).forEach((key, index)=>{
        hashLang[index] = key;
    });
}
Object.keys(exp).forEach((lang)=>{
    const list = get(exp[lang]);
    if ((0,_core_helpers_checker_is_array_js__WEBPACK_IMPORTED_MODULE_24__/* .isArray */ .c)(list)) {
        exp[lang] = {};
        list.forEach((value, index)=>{
            exp[lang][hashLang[index]] = value;
        });
    } else {
        exp[lang] = list;
    }
});
/* harmony default export */ __webpack_exports__.A = (exp);


/***/ }),

/***/ 26295:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21537);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6441);
/* harmony import */ var _line_height_svg_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53259);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.defaultLineHeight = null;
_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .I.set('line-height', _line_height_svg_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A);
_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.controls.lineHeight = {
    command: 'applyLineHeight',
    tags: [
        'ol'
    ],
    tooltip: 'Line height',
    list: [
        1,
        1.1,
        1.2,
        1.3,
        1.4,
        1.5,
        2
    ],
    exec: (editor, event, { control })=>(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.memorizeExec)(editor, event, {
            control
        }, (value)=>value)
};


/***/ }),

/***/ 26395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $: function() { return /* binding */ scrollIntoViewIfNeeded; },
/* harmony export */   l: function() { return /* binding */ inView; }
/* harmony export */ });
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/**
 * @module helpers/utils
 */ /**
 * Check if element is in view
 */ function inView(elm, root, doc) {
    let rect = elm.getBoundingClientRect(), el = elm;
    const top = rect.top, height = rect.height;
    while(el && el !== root && el.parentNode){
        el = el.parentNode;
        rect = el.getBoundingClientRect();
        if (!(top <= rect.bottom)) {
            return false;
        }
        // Check if the element is out of view due to a container scrolling
        if (top + height <= rect.top) {
            return false;
        }
    }
    // Check it's within the document viewport
    return top <= (doc.documentElement && doc.documentElement.clientHeight || 0);
}
/**
 * Scroll element into view if it is not in view
 */ function scrollIntoViewIfNeeded(elm, root, doc) {
    if (_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isHTMLElement(elm) && !inView(elm, root, doc)) {
        if (root.clientHeight !== root.scrollHeight) {
            root.scrollTop = elm.offsetTop;
        }
        if (!inView(elm, root, doc)) {
            elm.scrollIntoView();
        }
    }
}


/***/ }),

/***/ 26428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    Spellcheck: 'غلطیابی املایی'
});


/***/ }),

/***/ 26529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ar: function() { return /* reexport module object */ _ar_js__WEBPACK_IMPORTED_MODULE_0__; },
/* harmony export */   cs_cz: function() { return /* reexport module object */ _cs_cz_js__WEBPACK_IMPORTED_MODULE_1__; },
/* harmony export */   de: function() { return /* reexport module object */ _de_js__WEBPACK_IMPORTED_MODULE_2__; },
/* harmony export */   es: function() { return /* reexport module object */ _es_js__WEBPACK_IMPORTED_MODULE_3__; },
/* harmony export */   fa: function() { return /* reexport module object */ _fa_js__WEBPACK_IMPORTED_MODULE_4__; },
/* harmony export */   fi: function() { return /* reexport module object */ _fi_js__WEBPACK_IMPORTED_MODULE_5__; },
/* harmony export */   fr: function() { return /* reexport module object */ _fr_js__WEBPACK_IMPORTED_MODULE_6__; },
/* harmony export */   he: function() { return /* reexport module object */ _he_js__WEBPACK_IMPORTED_MODULE_7__; },
/* harmony export */   hu: function() { return /* reexport module object */ _hu_js__WEBPACK_IMPORTED_MODULE_8__; },
/* harmony export */   id: function() { return /* reexport module object */ _id_js__WEBPACK_IMPORTED_MODULE_9__; },
/* harmony export */   it: function() { return /* reexport module object */ _it_js__WEBPACK_IMPORTED_MODULE_10__; },
/* harmony export */   ja: function() { return /* reexport module object */ _ja_js__WEBPACK_IMPORTED_MODULE_11__; },
/* harmony export */   ko: function() { return /* reexport module object */ _ko_js__WEBPACK_IMPORTED_MODULE_12__; },
/* harmony export */   mn: function() { return /* reexport module object */ _mn_js__WEBPACK_IMPORTED_MODULE_13__; },
/* harmony export */   nl: function() { return /* reexport module object */ _nl_js__WEBPACK_IMPORTED_MODULE_14__; },
/* harmony export */   no: function() { return /* reexport module object */ _no_js__WEBPACK_IMPORTED_MODULE_15__; },
/* harmony export */   pl: function() { return /* reexport module object */ _pl_js__WEBPACK_IMPORTED_MODULE_16__; },
/* harmony export */   pt_br: function() { return /* reexport module object */ _pt_br_js__WEBPACK_IMPORTED_MODULE_17__; },
/* harmony export */   ru: function() { return /* reexport module object */ _ru_js__WEBPACK_IMPORTED_MODULE_18__; },
/* harmony export */   tr: function() { return /* reexport module object */ _tr_js__WEBPACK_IMPORTED_MODULE_19__; },
/* harmony export */   ua: function() { return /* reexport module object */ _ua_js__WEBPACK_IMPORTED_MODULE_20__; },
/* harmony export */   zh_cn: function() { return /* reexport module object */ _zh_cn_js__WEBPACK_IMPORTED_MODULE_21__; },
/* harmony export */   zh_tw: function() { return /* reexport module object */ _zh_tw_js__WEBPACK_IMPORTED_MODULE_22__; }
/* harmony export */ });
/* harmony import */ var _ar_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28906);
/* harmony import */ var _cs_cz_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24351);
/* harmony import */ var _de_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32806);
/* harmony import */ var _es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77725);
/* harmony import */ var _fa_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26428);
/* harmony import */ var _fi_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42820);
/* harmony import */ var _fr_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60373);
/* harmony import */ var _he_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98370);
/* harmony import */ var _hu_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44850);
/* harmony import */ var _id_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3636);
/* harmony import */ var _it_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(73220);
/* harmony import */ var _ja_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(55776);
/* harmony import */ var _ko_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(13995);
/* harmony import */ var _mn_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6402);
/* harmony import */ var _nl_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(1879);
/* harmony import */ var _no_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(1322);
/* harmony import */ var _pl_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(53361);
/* harmony import */ var _pt_br_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(70824);
/* harmony import */ var _ru_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(65140);
/* harmony import */ var _tr_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(42247);
/* harmony import */ var _ua_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(68891);
/* harmony import */ var _zh_cn_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(63195);
/* harmony import */ var _zh_tw_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(42107);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

























/***/ }),

/***/ 26532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   o: function() { return /* binding */ SpeechRecognition; }
/* harmony export */ });
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
const SpeechRecognition = _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.globalWindow ? _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.globalWindow.SpeechRecognition || _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.globalWindow.webkitSpeechRecognition : undefined;


/***/ }),

/***/ 26551:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(580);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14984);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

function video(editor) {
    editor.registerButton({
        name: 'video',
        group: 'media'
    });
}
_core_global_js__WEBPACK_IMPORTED_MODULE_0__/* .pluginSystem */ .fg.add('video', video);


/***/ }),

/***/ 26556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    'Line height': 'Зураасны өндөр'
});


/***/ }),

/***/ 26658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   O: function() { return /* binding */ onTabInsideLi; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _core_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38837);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/**
 * Checks if the cursor is at the beginning of the LI element when tabbed.
 * If so then add an internal list
 * @private
 */ function onTabInsideLi(jodit, shift = false) {
    if (!jodit.o.tab.tabInsideLiInsertNewList) {
        return false;
    }
    const [fake, fake2] = fakeCursors(jodit);
    try {
        const li = getParentLeaf(jodit, fake, shift);
        if (!li) {
            return false;
        }
        if (!isSameLeftCursorPosition(li, jodit, fake)) {
            return false;
        }
        const list = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(li, [
            'ol',
            'ul'
        ], jodit.editor);
        if (!list || shift && !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(list, 'li', jodit.editor)) {
            return false;
        }
        if (!shift) {
            appendNestedList(jodit, list, li);
        } else {
            removeNestedList(jodit, list, li);
        }
        return true;
    } finally{
        const range = jodit.s.createRange();
        range.setStartAfter(fake);
        range.setEndBefore(fake2);
        jodit.s.selectRange(range);
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(fake);
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(fake2);
    }
    return false;
}
function fakeCursors(jodit) {
    const fake = jodit.createInside.fake();
    const fake2 = jodit.createInside.fake();
    const r = jodit.s.range.cloneRange();
    r.collapse(true);
    r.insertNode(fake);
    const r2 = jodit.s.range.cloneRange();
    r2.collapse(false);
    r2.insertNode(fake2);
    return [
        fake,
        fake2
    ];
}
function getParentLeaf(jodit, fake, shift) {
    const li = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(fake, 'li', jodit.editor);
    if (!li) {
        return false;
    }
    if (!shift && !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isLeaf(li.previousElementSibling)) {
        return false;
    }
    if (shift && !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(li, 'li', jodit.editor)) {
        return false;
    }
    return li;
}
function isSameLeftCursorPosition(li, jodit, fake) {
    const li2 = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(fake, 'li', jodit.editor);
    return !(!li2 || li2 !== li && !li.contains(li2));
}
function appendNestedList(jodit, list, li) {
    const previousLi = li.previousElementSibling;
    (0,_core_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_1__/* .assert */ .v)(previousLi, 'tab previousElementSibling is null');
    const lastElm = previousLi.lastElementChild;
    const newList = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(lastElm, list.tagName) ? lastElm : jodit.createInside.element(list.tagName, Array.from(list.attributes).reduce((acc, attr)=>{
        acc[attr.name] = attr.value;
        return acc;
    }, {}));
    newList.appendChild(li);
    lastElm !== newList && previousLi.appendChild(newList);
}
function removeNestedList(jodit, list, li) {
    const parentLi = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(list, 'li', jodit.editor);
    (0,_core_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_1__/* .assert */ .v)(parentLi, 'tab parentLi is null');
    const items = Array.from(list.children).filter((t)=>_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isLeaf(t));
    _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.after(parentLi, li);
    const index = items.indexOf(li);
    if (index === 0 || items.length === 1) {
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(list);
    }
    if (index !== items.length - 1) {
        const clone = list.cloneNode();
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.append(li, clone);
        for(let i = index + 1; i < items.length; i += 1){
            _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.append(clone, items[i]);
        }
    }
}


/***/ }),

/***/ 26716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   W: function() { return /* binding */ moveNodeInsideStart; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/**
 * Moves the fake node inside the adjacent element if it lies next to it but not inside.
 * When the cursor is positioned in its place, it must be inside the element and not outside its border.
 * @private
 */ function moveNodeInsideStart(j, node, start) {
    let sibling = _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.findSibling(node, start), anotherSibling = _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.findSibling(node, !start);
    while(_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isElement(sibling) && !_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(sibling, _constants_js__WEBPACK_IMPORTED_MODULE_0__.INSEPARABLE_TAGS) && _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isContentEditable(sibling, j.editor) && (!anotherSibling || !_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.closest(node, _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isElement, j.editor))){
        if (start || !sibling.firstChild) {
            sibling.appendChild(node);
        } else {
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.before(sibling.firstChild, node);
        }
        sibling = _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.sibling(node, start);
        anotherSibling = _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.sibling(node, !start);
    }
}


/***/ }),

/***/ 26866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   p: function() { return /* binding */ Confirm; }
/* harmony export */ });
/* harmony import */ var _core_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23282);
/* harmony import */ var _core_ui_button_button_button_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10830);
/* harmony import */ var _dialog_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78584);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/**
 * Show `confirm` dialog. Work without Jodit object
 *
 * @param title - Title or callback
 * @param callback - callback. The first argument is the value entered
 * @example
 * ```javascript
 * Jodit.Confirm("Are you sure?", "Confirm Dialog", function (yes) {
 *     if (yes) {
 *         // do something
 *     }
 * });
 * ```
 */ function Confirm(msg, title, callback) {
    const dialog = this instanceof _dialog_js__WEBPACK_IMPORTED_MODULE_1__/* .Dialog */ .l ? this : new _dialog_js__WEBPACK_IMPORTED_MODULE_1__/* .Dialog */ .l({
        closeOnClickOverlay: true
    }), $div = dialog.c.fromHTML('<form class="jodit-dialog_prompt"></form>'), $label = dialog.c.element('label');
    if ((0,_core_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_2__/* .isFunction */ .T)(title)) {
        callback = title;
        title = undefined;
    }
    $label.appendChild(dialog.c.fromHTML(msg));
    $div.appendChild($label);
    const action = (yes)=>()=>{
            if (!callback || callback(yes) !== false) {
                dialog.close();
            }
        };
    const $cancel = (0,_core_ui_button_button_button_js__WEBPACK_IMPORTED_MODULE_0__/* .Button */ .$n)(dialog, 'cancel', 'Cancel');
    const $ok = (0,_core_ui_button_button_button_js__WEBPACK_IMPORTED_MODULE_0__/* .Button */ .$n)(dialog, 'ok', 'Yes');
    $cancel.onAction(action(false));
    $ok.onAction(action(true));
    dialog.e.on($div, 'submit', ()=>{
        action(true)();
        return false;
    });
    dialog.setFooter([
        $ok,
        $cancel
    ]);
    dialog.open($div, title || '&nbsp;', true, true);
    $ok.focus();
    return dialog;
}


/***/ }),

/***/ 26992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   j: function() { return /* binding */ Async; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _helpers_async_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91898);
/* harmony import */ var _helpers_checker_is_abort_error_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12045);
/* harmony import */ var _helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23282);
/* harmony import */ var _helpers_checker_is_number_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84767);
/* harmony import */ var _helpers_checker_is_plain_object_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72430);
/* harmony import */ var _helpers_checker_is_promise_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14773);
/* harmony import */ var _helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70799);
/* harmony import */ var _helpers_checker_is_void_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86068);
/* harmony import */ var _helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38837);
/* harmony import */ var _helpers_utils_error_errors_abort_error_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93661);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 










class Async {
    delay(timeout) {
        return this.promise((resolve)=>this.setTimeout(resolve, timeout));
    }
    setTimeout(callback, timeout, ...args) {
        if (this.isDestructed) {
            return 0;
        }
        let options = {};
        if ((0,_helpers_checker_is_void_js__WEBPACK_IMPORTED_MODULE_3__/* .isVoid */ .R)(timeout)) {
            timeout = 0;
        }
        if (!(0,_helpers_checker_is_number_js__WEBPACK_IMPORTED_MODULE_4__/* .isNumber */ .E)(timeout)) {
            options = timeout;
            timeout = options.timeout || 0;
        }
        if (options.label) {
            this.clearLabel(options.label);
        }
        const timer = (0,_helpers_async_index_js__WEBPACK_IMPORTED_MODULE_1__/* .setTimeout */ .w)(callback, timeout, ...args);
        const key = options.label || timer;
        this.timers.set(key, timer);
        this.__callbacks.set(key, callback);
        return timer;
    }
    updateTimeout(label, timeout) {
        (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_2__/* .assert */ .v)(label && this.timers.has(label), 'Label does not exist');
        if (!label || !this.timers.has(label)) {
            return null;
        }
        const callback = this.__callbacks.get(label);
        (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_2__/* .assert */ .v)((0,_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_5__/* .isFunction */ .T)(callback), 'Callback is not a function');
        return this.setTimeout(callback, {
            label,
            timeout
        });
    }
    clearLabel(label) {
        if (label && this.timers.has(label)) {
            (0,_helpers_async_index_js__WEBPACK_IMPORTED_MODULE_1__/* .clearTimeout */ .D)(this.timers.get(label));
            this.timers.delete(label);
            this.__callbacks.delete(label);
        }
    }
    clearTimeout(timerOrLabel) {
        if ((0,_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_6__/* .isString */ .K)(timerOrLabel)) {
            return this.clearLabel(timerOrLabel);
        }
        (0,_helpers_async_index_js__WEBPACK_IMPORTED_MODULE_1__/* .clearTimeout */ .D)(timerOrLabel);
        this.timers.delete(timerOrLabel);
        this.__callbacks.delete(timerOrLabel);
    }
    /**
     * Debouncing enforces that a function not be called again until a certain amount of time has passed without
     * it being called. As in "execute this function only if 100 milliseconds have passed without it being called."
     *
     * @example
     * ```javascript
     * var jodit = Jodit.make('.editor');
     * jodit.e.on('mousemove', jodit.async.debounce(() => {
     * 	// Do expensive things
     * }, 100));
     * ```
     */ debounce(fn, timeout, firstCallImmediately = false) {
        let timer = 0, fired = false;
        const promises = [];
        const callFn = (...args)=>{
            if (!fired) {
                timer = 0;
                const res = fn(...args);
                fired = true;
                if (promises.length) {
                    const runPromises = ()=>{
                        promises.forEach((res)=>res());
                        promises.length = 0;
                    };
                    (0,_helpers_checker_is_promise_js__WEBPACK_IMPORTED_MODULE_7__/* .isPromise */ .y)(res) ? res.finally(runPromises) : runPromises();
                }
            }
        };
        const onFire = (...args)=>{
            fired = false;
            if (!timeout) {
                callFn(...args);
            } else {
                if (!timer && firstCallImmediately) {
                    callFn(...args);
                }
                (0,_helpers_async_index_js__WEBPACK_IMPORTED_MODULE_1__/* .clearTimeout */ .D)(timer);
                timer = this.setTimeout(()=>callFn(...args), (0,_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_5__/* .isFunction */ .T)(timeout) ? timeout() : timeout);
                this.timers.set(fn, timer);
            }
        };
        return (0,_helpers_checker_is_plain_object_js__WEBPACK_IMPORTED_MODULE_8__/* .isPlainObject */ .Q)(timeout) && timeout.promisify ? (...args)=>{
            const promise = this.promise((res)=>{
                promises.push(res);
            }).catch((e)=>{
                if ((0,_helpers_checker_is_abort_error_js__WEBPACK_IMPORTED_MODULE_9__/* .isAbortError */ .z)(e)) {
                    return null;
                }
                throw e;
            });
            onFire(...args);
            return promise;
        } : onFire;
    }
    microDebounce(fn, firstCallImmediately = false) {
        let scheduled = false;
        let needCall = true;
        let savedArgs;
        return (...args)=>{
            savedArgs = args;
            if (scheduled) {
                needCall = true;
                return;
            }
            needCall = true;
            if (firstCallImmediately) {
                needCall = false;
                fn(...savedArgs);
            }
            scheduled = true;
            this.__queueMicrotaskNative(()=>{
                scheduled = false;
                if (this.isDestructed) {
                    return;
                }
                needCall && fn(...savedArgs);
            });
        };
    }
    /**
     * Throttling enforces a maximum number of times a function can be called over time.
     * As in "execute this function at most once every 100 milliseconds."
     *
     * @example
     * ```javascript
     * var jodit = Jodit.make('.editor');
     * jodit.e.on(document.body, 'scroll', jodit.async.throttle(function() {
     * 	// Do expensive things
     * }, 100));
     * ```
     */ throttle(fn, timeout, ignore = false) {
        let timer = null, needInvoke, callee, lastArgs;
        return (...args)=>{
            needInvoke = true;
            lastArgs = args;
            if (!timeout) {
                fn(...lastArgs);
                return;
            }
            if (!timer) {
                callee = ()=>{
                    if (needInvoke) {
                        fn(...lastArgs);
                        needInvoke = false;
                        timer = this.setTimeout(callee, (0,_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_5__/* .isFunction */ .T)(timeout) ? timeout() : timeout);
                        this.timers.set(callee, timer);
                    } else {
                        timer = null;
                    }
                };
                callee();
            }
        };
    }
    promise(executor) {
        let rejectCallback = ()=>{};
        const promise = new Promise((resolve, reject)=>{
            rejectCallback = ()=>reject((0,_helpers_utils_error_errors_abort_error_js__WEBPACK_IMPORTED_MODULE_10__/* .abort */ .h)('Abort async'));
            this.promisesRejections.add(rejectCallback);
            executor(resolve, reject);
        });
        if (!promise.finally && typeof process !== 'undefined' && !_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_ES_NEXT) {
            promise.finally = (onfinally)=>{
                promise.then(onfinally).catch(onfinally);
                return promise;
            };
        }
        promise.finally(()=>{
            this.promisesRejections.delete(rejectCallback);
        }).catch(()=>null);
        promise.rejectCallback = rejectCallback;
        return promise;
    }
    /**
     * Get Promise status
     */ promiseState(p) {
        if (p.status) {
            return p.status;
        }
        // Hi IE11
        if (!Promise.race) {
            return new Promise((resolve)=>{
                p.then((v)=>{
                    resolve('fulfilled');
                    return v;
                }, (e)=>{
                    resolve('rejected');
                    throw e;
                });
                this.setTimeout(()=>{
                    resolve('pending');
                }, 100);
            });
        }
        const t = {};
        return Promise.race([
            p,
            t
        ]).then((v)=>v === t ? 'pending' : 'fulfilled', ()=>'rejected');
    }
    requestIdleCallback(callback, options = {
        timeout: 100
    }) {
        const request = this.__requestIdleCallbackNative(callback, options);
        this.__requestsIdle.add(request);
        return request;
    }
    requestIdlePromise(options) {
        return this.promise((res)=>{
            const request = this.requestIdleCallback(()=>res(request), options);
        });
    }
    /**
     * Try to use scheduler.postTask if it is available https://wicg.github.io/scheduling-apis/
     */ schedulerPostTask(task, options = {
        delay: 0,
        priority: 'user-visible'
    }) {
        const controller = new AbortController();
        if (options.signal) {
            options.signal.addEventListener('abort', ()=>controller.abort());
        }
        this.__controllers.add(controller);
        // @ts-ignore
        if (typeof globalThis.scheduler !== 'undefined') {
            const scheduler = globalThis.scheduler;
            const promise = scheduler.postTask(task, {
                ...options,
                signal: controller.signal
            });
            promise.finally(()=>{
                this.__controllers.delete(controller);
            }).catch(()=>null);
            return promise;
        }
        return this.promise((resolve, reject)=>{
            const timeout = this.setTimeout(()=>{
                try {
                    resolve(task());
                } catch (e) {
                    reject(e);
                }
                this.__controllers.delete(controller);
            }, options.delay || 1);
            controller.signal.addEventListener('abort', ()=>{
                this.clearTimeout(timeout);
                this.__controllers.delete(controller);
                reject((0,_helpers_utils_error_errors_abort_error_js__WEBPACK_IMPORTED_MODULE_10__/* .abort */ .h)());
            });
        });
    }
    schedulerYield() {
        return this.schedulerPostTask(()=>{}, {
            priority: 'user-visible'
        });
    }
    cancelIdleCallback(request) {
        this.__requestsIdle.delete(request);
        return this.__cancelIdleCallbackNative(request);
    }
    requestAnimationFrame(callback) {
        const request = requestAnimationFrame(callback);
        this.__requestsRaf.add(request);
        return request;
    }
    cancelAnimationFrame(request) {
        this.__requestsRaf.delete(request);
        cancelAnimationFrame(request);
    }
    clear() {
        this.__requestsIdle.forEach((key)=>this.cancelIdleCallback(key));
        this.__requestsRaf.forEach((key)=>this.cancelAnimationFrame(key));
        this.__controllers.forEach((controller)=>controller.abort());
        this.timers.forEach((key)=>(0,_helpers_async_index_js__WEBPACK_IMPORTED_MODULE_1__/* .clearTimeout */ .D)(this.timers.get(key)));
        this.timers.clear();
        this.promisesRejections.forEach((reject)=>reject());
        this.promisesRejections.clear();
    }
    destruct() {
        this.clear();
        this.isDestructed = true;
    }
    constructor(){
        var _a, _b, _c, _d, _e;
        this.timers = new Map();
        this.__callbacks = new Map();
        this.__queueMicrotaskNative = (_a = queueMicrotask === null || queueMicrotask === void 0 ? void 0 : queueMicrotask.bind(window)) !== null && _a !== void 0 ? _a : Promise.resolve().then.bind(Promise.resolve());
        this.promisesRejections = new Set();
        this.__requestsIdle = new Set();
        this.__controllers = new Set();
        this.__requestsRaf = new Set();
        this.__requestIdleCallbackNative = (_c = (_b = window['requestIdleCallback']) === null || _b === void 0 ? void 0 : _b.bind(window)) !== null && _c !== void 0 ? _c : (callback, options)=>{
            var _a;
            const start = Date.now();
            return this.setTimeout(()=>{
                callback({
                    didTimeout: false,
                    timeRemaining: ()=>Math.max(0, 50 - (Date.now() - start))
                });
            }, (_a = options === null || options === void 0 ? void 0 : options.timeout) !== null && _a !== void 0 ? _a : 1);
        };
        this.__cancelIdleCallbackNative = (_e = (_d = window['cancelIdleCallback']) === null || _d === void 0 ? void 0 : _d.bind(window)) !== null && _e !== void 0 ? _e : (request)=>{
            this.clearTimeout(request);
        };
        this.isDestructed = false;
    }
}


/***/ }),

/***/ 27190:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1520 1216q0-40-28-68l-208-208q-28-28-68-28-42 0-72 32 3 3 19 18.5t21.5 21.5 15 19 13 25.5 3.5 27.5q0 40-28 68t-68 28q-15 0-27.5-3.5t-25.5-13-19-15-21.5-21.5-18.5-19q-33 31-33 73 0 40 28 68l206 207q27 27 68 27 40 0 68-26l147-146q28-28 28-67zm-703-705q0-40-28-68l-206-207q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l208 208q27 27 68 27 42 0 72-31-3-3-19-18.5t-21.5-21.5-15-19-13-25.5-3.5-27.5q0-40 28-68t68-28q15 0 27.5 3.5t25.5 13 19 15 21.5 21.5 18.5 19q33-31 33-73zm895 705q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-206-207q-83-83-83-203 0-123 88-209l-88-88q-86 88-208 88-120 0-204-84l-208-208q-84-84-84-204t85-203l147-146q83-83 203-83 121 0 204 85l206 207q83 83 83 203 0 123-88 209l88 88q86-88 208-88 120 0 204 84l208 208q84 84 84 204z\"/> </svg> ");


/***/ }),

/***/ 27613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AH: function() { return /* reexport safe */ _is_html_js__WEBPACK_IMPORTED_MODULE_6__.A; },
/* harmony export */   Bo: function() { return /* reexport safe */ _is_string_js__WEBPACK_IMPORTED_MODULE_19__.B; },
/* harmony export */   CE: function() { return /* reexport safe */ _is_html_from_word_js__WEBPACK_IMPORTED_MODULE_7__.C; },
/* harmony export */   E6: function() { return /* reexport safe */ _is_int_js__WEBPACK_IMPORTED_MODULE_9__.E; },
/* harmony export */   Et: function() { return /* reexport safe */ _is_number_js__WEBPACK_IMPORTED_MODULE_14__.E; },
/* harmony export */   Gp: function() { return /* reexport safe */ _is_imp_interface_js__WEBPACK_IMPORTED_MODULE_8__.n4; },
/* harmony export */   Kg: function() { return /* reexport safe */ _is_string_js__WEBPACK_IMPORTED_MODULE_19__.K; },
/* harmony export */   Lm: function() { return /* reexport safe */ _is_boolean_js__WEBPACK_IMPORTED_MODULE_3__.L; },
/* harmony export */   Mj: function() { return /* reexport safe */ _is_license_js__WEBPACK_IMPORTED_MODULE_11__.M; },
/* harmony export */   P5: function() { return /* reexport safe */ _is_equal_js__WEBPACK_IMPORTED_MODULE_4__.P; },
/* harmony export */   Qd: function() { return /* reexport safe */ _is_plain_object_js__WEBPACK_IMPORTED_MODULE_16__.Q; },
/* harmony export */   Rd: function() { return /* reexport safe */ _is_void_js__WEBPACK_IMPORTED_MODULE_23__.R; },
/* harmony export */   Tn: function() { return /* reexport safe */ _is_function_js__WEBPACK_IMPORTED_MODULE_5__.T; },
/* harmony export */   a3: function() { return /* reexport safe */ _is_native_function_js__WEBPACK_IMPORTED_MODULE_13__.a; },
/* harmony export */   cy: function() { return /* reexport safe */ _is_array_js__WEBPACK_IMPORTED_MODULE_2__.c; },
/* harmony export */   hH: function() { return /* reexport safe */ _is_view_object_js__WEBPACK_IMPORTED_MODULE_22__.h; },
/* harmony export */   kC: function() { return /* reexport safe */ _has_browser_color_picker_js__WEBPACK_IMPORTED_MODULE_0__.k; },
/* harmony export */   kO: function() { return /* reexport safe */ _is_imp_interface_js__WEBPACK_IMPORTED_MODULE_8__.kO; },
/* harmony export */   kf: function() { return /* reexport safe */ _is_numeric_js__WEBPACK_IMPORTED_MODULE_15__.k; },
/* harmony export */   l6: function() { return /* reexport safe */ _is_window_js__WEBPACK_IMPORTED_MODULE_24__.l; },
/* harmony export */   mv: function() { return /* reexport safe */ _is_url_js__WEBPACK_IMPORTED_MODULE_20__.m; },
/* harmony export */   n4: function() { return /* reexport safe */ _is_equal_js__WEBPACK_IMPORTED_MODULE_4__.n; },
/* harmony export */   pV: function() { return /* reexport safe */ _is_imp_interface_js__WEBPACK_IMPORTED_MODULE_8__.pV; },
/* harmony export */   rg: function() { return /* reexport safe */ _is_marker_js__WEBPACK_IMPORTED_MODULE_12__.r; },
/* harmony export */   uV: function() { return /* reexport safe */ _is_valid_name_js__WEBPACK_IMPORTED_MODULE_21__.u; },
/* harmony export */   vM: function() { return /* reexport safe */ _is_set_js__WEBPACK_IMPORTED_MODULE_18__.v; },
/* harmony export */   y0: function() { return /* reexport safe */ _is_jodit_object_js__WEBPACK_IMPORTED_MODULE_10__.y; },
/* harmony export */   yL: function() { return /* reexport safe */ _is_promise_js__WEBPACK_IMPORTED_MODULE_17__.y; },
/* harmony export */   zf: function() { return /* reexport safe */ _is_abort_error_js__WEBPACK_IMPORTED_MODULE_1__.z; }
/* harmony export */ });
/* harmony import */ var _has_browser_color_picker_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54765);
/* harmony import */ var _is_abort_error_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12045);
/* harmony import */ var _is_array_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68345);
/* harmony import */ var _is_boolean_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87612);
/* harmony import */ var _is_equal_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59292);
/* harmony import */ var _is_function_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23282);
/* harmony import */ var _is_html_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58487);
/* harmony import */ var _is_html_from_word_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29673);
/* harmony import */ var _is_imp_interface_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60132);
/* harmony import */ var _is_int_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(72913);
/* harmony import */ var _is_jodit_object_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19306);
/* harmony import */ var _is_license_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(45603);
/* harmony import */ var _is_marker_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78116);
/* harmony import */ var _is_native_function_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(70722);
/* harmony import */ var _is_number_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(84767);
/* harmony import */ var _is_numeric_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(29807);
/* harmony import */ var _is_plain_object_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(72430);
/* harmony import */ var _is_promise_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(14773);
/* harmony import */ var _is_set_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(42320);
/* harmony import */ var _is_string_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(70799);
/* harmony import */ var _is_url_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26049);
/* harmony import */ var _is_valid_name_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(37508);
/* harmony import */ var _is_view_object_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(39955);
/* harmony import */ var _is_void_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(86068);
/* harmony import */ var _is_window_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(52742);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/checker
 */ 


























/***/ }),

/***/ 28143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ar: function() { return /* reexport module object */ _ar_js__WEBPACK_IMPORTED_MODULE_0__; },
/* harmony export */   cs_cz: function() { return /* reexport module object */ _cs_cz_js__WEBPACK_IMPORTED_MODULE_1__; },
/* harmony export */   de: function() { return /* reexport module object */ _de_js__WEBPACK_IMPORTED_MODULE_2__; },
/* harmony export */   es: function() { return /* reexport module object */ _es_js__WEBPACK_IMPORTED_MODULE_3__; },
/* harmony export */   fa: function() { return /* reexport module object */ _fa_js__WEBPACK_IMPORTED_MODULE_4__; },
/* harmony export */   fi: function() { return /* reexport module object */ _fi_js__WEBPACK_IMPORTED_MODULE_5__; },
/* harmony export */   fr: function() { return /* reexport module object */ _fr_js__WEBPACK_IMPORTED_MODULE_6__; },
/* harmony export */   he: function() { return /* reexport module object */ _he_js__WEBPACK_IMPORTED_MODULE_7__; },
/* harmony export */   hu: function() { return /* reexport module object */ _hu_js__WEBPACK_IMPORTED_MODULE_8__; },
/* harmony export */   id: function() { return /* reexport module object */ _id_js__WEBPACK_IMPORTED_MODULE_9__; },
/* harmony export */   it: function() { return /* reexport module object */ _it_js__WEBPACK_IMPORTED_MODULE_10__; },
/* harmony export */   ja: function() { return /* reexport module object */ _ja_js__WEBPACK_IMPORTED_MODULE_11__; },
/* harmony export */   ko: function() { return /* reexport module object */ _ko_js__WEBPACK_IMPORTED_MODULE_12__; },
/* harmony export */   mn: function() { return /* reexport module object */ _mn_js__WEBPACK_IMPORTED_MODULE_13__; },
/* harmony export */   nl: function() { return /* reexport module object */ _nl_js__WEBPACK_IMPORTED_MODULE_14__; },
/* harmony export */   pl: function() { return /* reexport module object */ _pl_js__WEBPACK_IMPORTED_MODULE_15__; },
/* harmony export */   pt_br: function() { return /* reexport module object */ _pt_br_js__WEBPACK_IMPORTED_MODULE_16__; },
/* harmony export */   ru: function() { return /* reexport module object */ _ru_js__WEBPACK_IMPORTED_MODULE_17__; },
/* harmony export */   tr: function() { return /* reexport module object */ _tr_js__WEBPACK_IMPORTED_MODULE_18__; },
/* harmony export */   ua: function() { return /* reexport module object */ _ua_js__WEBPACK_IMPORTED_MODULE_19__; },
/* harmony export */   zh_cn: function() { return /* reexport module object */ _zh_cn_js__WEBPACK_IMPORTED_MODULE_20__; },
/* harmony export */   zh_tw: function() { return /* reexport module object */ _zh_tw_js__WEBPACK_IMPORTED_MODULE_21__; }
/* harmony export */ });
/* harmony import */ var _ar_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80084);
/* harmony import */ var _cs_cz_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76725);
/* harmony import */ var _de_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71724);
/* harmony import */ var _es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46295);
/* harmony import */ var _fa_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70190);
/* harmony import */ var _fi_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67206);
/* harmony import */ var _fr_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85723);
/* harmony import */ var _he_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61072);
/* harmony import */ var _hu_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30592);
/* harmony import */ var _id_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89194);
/* harmony import */ var _it_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51834);
/* harmony import */ var _ja_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5082);
/* harmony import */ var _ko_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(80105);
/* harmony import */ var _mn_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26556);
/* harmony import */ var _nl_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(98689);
/* harmony import */ var _pl_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(42727);
/* harmony import */ var _pt_br_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(43646);
/* harmony import */ var _ru_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(53822);
/* harmony import */ var _tr_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(41817);
/* harmony import */ var _ua_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(69625);
/* harmony import */ var _zh_cn_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(28973);
/* harmony import */ var _zh_tw_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(19033);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
























/***/ }),

/***/ 28252:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22732);
/* harmony import */ var _core_helpers_string_trim_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49055);
/* harmony import */ var _core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41180);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6441);
/* harmony import */ var _icons_font_svg_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4104);
/* harmony import */ var _icons_fontsize_svg_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83709);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 






/**
 * Default font-size points
 */ _config_js__WEBPACK_IMPORTED_MODULE_3__/* .Config */ .T.prototype.defaultFontSizePoints = 'px';
_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .I.set('font', _icons_font_svg_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A).set('fontsize', _icons_fontsize_svg_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A);
_config_js__WEBPACK_IMPORTED_MODULE_3__/* .Config */ .T.prototype.controls.fontsize = {
    command: 'fontsize',
    data: {
        cssRule: 'font-size',
        normalise: (v, editor)=>{
            if (/pt$/i.test(v) && editor.o.defaultFontSizePoints === 'pt') {
                return v.replace(/pt$/i, '');
            }
            return v;
        }
    },
    list: [
        8,
        9,
        10,
        11,
        12,
        14,
        16,
        18,
        24,
        30,
        32,
        34,
        36,
        48,
        60,
        72,
        96
    ],
    textTemplate: (editor, value)=>{
        return value + editor.o.defaultFontSizePoints;
    },
    childTemplate: (editor, key, value)=>{
        return `${value}${editor.o.defaultFontSizePoints}`;
    },
    tooltip: 'Font size',
    value: (editor, button)=>{
        var _a;
        const current = editor.s.current();
        if (!current) {
            return;
        }
        const box = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(current, _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isElement, editor.editor);
        if (!box) {
            return;
        }
        const control = button.control;
        const cssKey = ((_a = control.data) === null || _a === void 0 ? void 0 : _a.cssRule) || 'font-size';
        const value = (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_6__/* .css */ .A)(box, cssKey);
        return value.toString();
    },
    isChildActive: (editor, button)=>{
        var _a, _b;
        const value = button.state.value;
        const normalize = (_b = (_a = button.control.data) === null || _a === void 0 ? void 0 : _a.normalize) !== null && _b !== void 0 ? _b : (v)=>v;
        return Boolean(value && button.control.args && normalize(button.control.args[0].toString()) === normalize(value.toString()));
    },
    isActive: (editor, button)=>{
        var _a, _b;
        const value = button.state.value;
        if (!value) {
            return false;
        }
        const normalize = (_b = (_a = button.control.data) === null || _a === void 0 ? void 0 : _a.normalize) !== null && _b !== void 0 ? _b : (v)=>v;
        let keySet = button.control.data.cacheListSet;
        if (!keySet) {
            const keys = Object.keys(button.control.list).map(normalize);
            keySet = new Set(keys);
            button.control.data.cacheListSet = keySet;
        }
        return keySet.has(normalize(value.toString()));
    }
};
_config_js__WEBPACK_IMPORTED_MODULE_3__/* .Config */ .T.prototype.controls.font = {
    ..._config_js__WEBPACK_IMPORTED_MODULE_3__/* .Config */ .T.prototype.controls.fontsize,
    command: 'fontname',
    textTemplate: (j, value)=>{
        const [first] = value.split(',');
        return (0,_core_helpers_string_trim_js__WEBPACK_IMPORTED_MODULE_1__/* .trimChars */ .Gd)(first, '"\'');
    },
    list: {
        '': 'Default',
        'Arial, Helvetica, sans-serif': 'Arial',
        "'Courier New', Courier, monospace": 'Courier New',
        'Georgia, Palatino, serif': 'Georgia',
        "'Lucida Sans Unicode', 'Lucida Grande', sans-serif": 'Lucida Sans Unicode',
        'Tahoma, Geneva, sans-serif': 'Tahoma',
        "'Times New Roman', Times, serif": 'Times New Roman',
        "'Trebuchet MS', Helvetica, sans-serif": 'Trebuchet MS',
        'Helvetica, sans-serif': 'Helvetica',
        'Impact, Charcoal, sans-serif': 'Impact',
        'Verdana, Geneva, sans-serif': 'Verdana'
    },
    childTemplate: (editor, key, value)=>{
        let isAvailable = false;
        try {
            isAvailable = key.indexOf('dings') === -1 && document.fonts.check(`16px ${key}`, value);
        } catch (_a) {}
        return `<span data-style="${key}" style="${isAvailable ? `font-family: ${key}!important;` : ''}">${value}</span>`;
    },
    data: {
        cssRule: 'font-family',
        normalize: (v)=>{
            return v.toLowerCase().replace(/['"]+/g, '').replace(/[^a-z0-9-]+/g, ',');
        }
    },
    tooltip: 'Font family'
};


/***/ }),

/***/ 28435:
/***/ (function(__unused_webpack_module, __webpack_exports__) {


/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'copy-format': 'העתק עיצוב'
});


/***/ }),

/***/ 28545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export selectCells */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2748);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21537);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50911);
/* harmony import */ var _modules_table_table_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76014);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55311);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








const key = 'table_processor_observer';
const MOUSE_MOVE_LABEL = 'onMoveTableSelectCell';
class selectCells extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_5__/* .Plugin */ .k {
    /**
     * Shortcut for Jodit.modules.Table
     */ get __tableModule() {
        return this.j.getInstance(_modules_table_table_js__WEBPACK_IMPORTED_MODULE_6__/* .Table */ .X, this.j.o);
    }
    afterInit(jodit) {
        if (!jodit.o.tableAllowCellSelection) {
            return;
        }
        jodit.e.on('keydown.select-cells', (event)=>{
            if (event.key === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_TAB) {
                this.unselectCells();
            }
        }).on('beforeCommand.select-cells', this.onExecCommand).on('afterCommand.select-cells', this.onAfterCommand)// see `plugins/select.ts`
        .on([
            'clickEditor',
            'mousedownTd',
            'mousedownTh',
            'touchstartTd',
            'touchstartTh'
        ].map((e)=>e + '.select-cells').join(' '), this.onStartSelection)// For `clickEditor` correct working. Because `mousedown` on first cell
        // and mouseup on another cell call `click` only for `TR` element.
        .on('clickTr clickTbody', ()=>{
            var _a;
            const cellsCount = this.__tableModule.getAllSelectedCells().length;
            if (cellsCount) {
                if (cellsCount > 1) {
                    (_a = this.j.s.sel) === null || _a === void 0 ? void 0 : _a.removeAllRanges();
                }
                return false;
            }
        });
    }
    /**
     * Mouse click inside the table
     */ onStartSelection(cell) {
        if (this.j.o.readonly) {
            return;
        }
        this.unselectCells();
        if (cell === this.j.editor) {
            return;
        }
        const table = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.closest(cell, 'table', this.j.editor);
        if (!cell || !table) {
            return;
        }
        if (!cell.firstChild) {
            cell.appendChild(this.j.createInside.element('br'));
        }
        this.__isSelectionMode = true;
        this.__selectedCell = cell;
        this.__tableModule.addSelection(cell);
        this.j.e.on(table, 'mousemove.select-cells touchmove.select-cells', // Don't use decorator because need clear label on mouseup
        this.j.async.throttle(this.__onMove.bind(this, table), {
            label: MOUSE_MOVE_LABEL,
            timeout: this.j.defaultTimeout / 2
        })).on(table, 'mouseup.select-cells touchend.select-cells', this.__onStopSelection.bind(this, table));
        return false;
    }
    onOutsideClick() {
        this.__selectedCell = null;
        this.__onRemoveSelection();
    }
    onChange() {
        if (!this.j.isLocked && !this.__isSelectionMode) {
            this.__onRemoveSelection();
        }
    }
    /**
     * Mouse move inside the table
     */ __onMove(table, e) {
        var _a;
        if (this.j.o.readonly && !this.j.isLocked) {
            return;
        }
        if (this.j.isLockedNotBy(key)) {
            return;
        }
        const node = this.j.ed.elementFromPoint(e.clientX, e.clientY);
        if (!node) {
            return;
        }
        const cell = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.closest(node, [
            'td',
            'th'
        ], table);
        if (!cell || !this.__selectedCell) {
            return;
        }
        if (cell !== this.__selectedCell) {
            this.j.lock(key);
        }
        this.unselectCells();
        const bound = this.__tableModule.getSelectedBound(table, [
            cell,
            this.__selectedCell
        ]), box = this.__tableModule.formalMatrix(table);
        for(let i = bound[0][0]; i <= bound[1][0]; i += 1){
            for(let j = bound[0][1]; j <= bound[1][1]; j += 1){
                this.__tableModule.addSelection(box[i][j]);
            }
        }
        const cellsCount = this.__tableModule.getAllSelectedCells().length;
        if (cellsCount > 1) {
            (_a = this.j.s.sel) === null || _a === void 0 ? void 0 : _a.removeAllRanges();
        }
        this.j.e.fire('hidePopup');
        e.stopPropagation();
        // Hack for FireFox for force redraw selection
        (()=>{
            const n = this.j.createInside.fromHTML('<div style="color:rgba(0,0,0,0.01);width:0;height:0">&nbsp;</div>');
            cell.appendChild(n);
            this.j.async.setTimeout(()=>{
                var _a;
                (_a = n.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(n);
            }, this.j.defaultTimeout / 5);
        })();
    }
    /**
     * On click in outside - remove selection
     */ __onRemoveSelection(e) {
        var _a;
        if (!((_a = e === null || e === void 0 ? void 0 : e.buffer) === null || _a === void 0 ? void 0 : _a.actionTrigger) && !this.__selectedCell && this.__tableModule.getAllSelectedCells().length) {
            this.j.unlock();
            this.unselectCells();
            this.j.e.fire('hidePopup', 'cells');
            return;
        }
        this.__isSelectionMode = false;
        this.__selectedCell = null;
    }
    /**
     * Stop a selection process
     */ __onStopSelection(table, e) {
        if (!this.__selectedCell) {
            return;
        }
        this.__isSelectionMode = false;
        this.j.unlock();
        const node = this.j.ed.elementFromPoint(e.clientX, e.clientY);
        if (!node) {
            return;
        }
        const cell = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.closest(node, [
            'td',
            'th'
        ], table);
        if (!cell) {
            return;
        }
        const ownTable = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.closest(cell, 'table', table);
        if (ownTable && ownTable !== table) {
            return; // Nested tables
        }
        const bound = this.__tableModule.getSelectedBound(table, [
            cell,
            this.__selectedCell
        ]), box = this.__tableModule.formalMatrix(table);
        const max = box[bound[1][0]][bound[1][1]], min = box[bound[0][0]][bound[0][1]];
        this.j.e.fire('showPopup', table, ()=>{
            const minOffset = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.position)(min, this.j), maxOffset = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.position)(max, this.j);
            return {
                left: minOffset.left,
                top: minOffset.top,
                width: maxOffset.left - minOffset.left + maxOffset.width,
                height: maxOffset.top - minOffset.top + maxOffset.height
            };
        }, 'cells');
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.$$)('table', this.j.editor).forEach((table)=>{
            this.j.e.off(table, 'mousemove.select-cells touchmove.select-cells mouseup.select-cells touchend.select-cells');
        });
        this.j.async.clearTimeout(MOUSE_MOVE_LABEL);
    }
    /**
     * Remove selection for all cells
     */ unselectCells(currentCell) {
        const module = this.__tableModule;
        const cells = module.getAllSelectedCells();
        if (cells.length) {
            cells.forEach((cell)=>{
                if (!currentCell || currentCell !== cell) {
                    module.removeSelection(cell);
                }
            });
        }
    }
    /**
     * Execute custom commands for table
     */ onExecCommand(command) {
        if (/table(splitv|splitg|merge|empty|bin|binrow|bincolumn|addcolumn|addrow)/.test(command)) {
            command = command.replace('table', '');
            const cells = this.__tableModule.getAllSelectedCells();
            if (cells.length) {
                const [cell] = cells;
                if (!cell) {
                    return;
                }
                const table = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.closest(cell, 'table', this.j.editor);
                if (!table) {
                    return;
                }
                switch(command){
                    case 'splitv':
                        this.__tableModule.splitVertical(table);
                        break;
                    case 'splitg':
                        this.__tableModule.splitHorizontal(table);
                        break;
                    case 'merge':
                        this.__tableModule.mergeSelected(table);
                        break;
                    case 'empty':
                        cells.forEach((td)=>_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.detach(td));
                        break;
                    case 'bin':
                        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(table);
                        break;
                    case 'binrow':
                        new Set(cells.map((td)=>td.parentNode)).forEach((row)=>{
                            this.__tableModule.removeRow(table, row.rowIndex);
                        });
                        break;
                    case 'bincolumn':
                        {
                            const columnsSet = new Set(), columns = cells.reduce((acc, td)=>{
                                if (!columnsSet.has(td.cellIndex)) {
                                    acc.push(td);
                                    columnsSet.add(td.cellIndex);
                                }
                                return acc;
                            }, []);
                            columns.forEach((td)=>{
                                this.__tableModule.removeColumn(table, td.cellIndex);
                            });
                        }
                        break;
                    case 'addcolumnafter':
                    case 'addcolumnbefore':
                        this.__tableModule.appendColumn(table, cell, command === 'addcolumnafter');
                        break;
                    case 'addrowafter':
                    case 'addrowbefore':
                        this.__tableModule.appendRow(table, cell.parentNode, command === 'addrowafter');
                        break;
                }
            }
            return false;
        }
    }
    /**
     * Add some align after native command
     */ onAfterCommand(command) {
        if (/^justify/.test(command)) {
            this.__tableModule.getAllSelectedCells().forEach((elm)=>(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.alignElement)(command, elm));
        }
    }
    /** @override */ beforeDestruct(jodit) {
        this.__onRemoveSelection();
        jodit.e.off('.select-cells');
    }
    constructor(){
        super(...arguments);
        /**
         * First selected cell
         */ this.__selectedCell = null;
        /**
         * User is selecting cells now
         */ this.__isSelectionMode = false;
    }
}
selectCells.requires = [
    'select'
];
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], selectCells.prototype, "onStartSelection", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)(':outsideClick')
], selectCells.prototype, "onOutsideClick", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)(':change')
], selectCells.prototype, "onChange", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], selectCells.prototype, "__onRemoveSelection", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], selectCells.prototype, "__onStopSelection", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], selectCells.prototype, "onExecCommand", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], selectCells.prototype, "onAfterCommand", null);
_core_global_js__WEBPACK_IMPORTED_MODULE_3__/* .pluginSystem */ .fg.add('selectCells', selectCells);


/***/ }),

/***/ 28800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   k: function() { return /* binding */ tryRemoveNode; }
/* harmony export */ });
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _core_helpers_string_trim_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49055);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/**
 * @private
 */ function tryRemoveNode(jodit, nodeElm, hadEffect, allowTags, denyTags, currentSelectionNode) {
    if (isRemovableNode(jodit, nodeElm, currentSelectionNode, allowTags, denyTags)) {
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(nodeElm);
        return true;
    }
    return hadEffect;
}
/**
 * @private
 */ function isRemovableNode(jodit, node, current, allow, deny) {
    if (!_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isText(node)) {
        if (allow && !allow[node.nodeName]) {
            return true;
        }
        if (!allow && deny && deny[node.nodeName]) {
            return true;
        }
    }
    if (!jodit.o.cleanHTML.removeEmptyElements) {
        return false;
    }
    return _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isElement(node) && node.nodeName.match(_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_INLINE) != null && !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTemporary(node) && (0,_core_helpers_string_trim_js__WEBPACK_IMPORTED_MODULE_2__/* .trim */ .Bq)(node.innerHTML).length === 0 && (current == null || !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isOrContains(node, current));
}


/***/ }),

/***/ 28906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    Spellcheck: 'التدقيق الإملائي'
});


/***/ }),

/***/ 28911:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M896 960v448q0 26-19 45t-45 19-45-19l-144-144-332 332q-10 10-23 10t-23-10l-114-114q-10-10-10-23t10-23l332-332-144-144q-19-19-19-45t19-45 45-19h448q26 0 45 19t19 45zm755-672q0 13-10 23l-332 332 144 144q19 19 19 45t-19 45-45 19h-448q-26 0-45-19t-19-45v-448q0-26 19-45t45-19 45 19l144 144 332-332q10-10 23-10t23 10l114 114q10 10 10 23z\"/> </svg> ");


/***/ }),

/***/ 28923:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'Type something': 'Bir şeyler yaz',
    Advanced: 'Gelişmiş',
    'About Jodit': 'Jodit Hakkında',
    'Jodit Editor': 'Jodit Editor',
    "Jodit User's Guide": 'Jodit Kullanım Kılavuzu',
    'contains detailed help for using': 'kullanım için detaylı bilgiler içerir',
    'For information about the license, please go to our website:': 'Lisans hakkında bilgi için lütfen web sitemize gidin:',
    'Buy full version': 'Tam versiyonunu satın al',
    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.': 'Copyright © XDSoft.net - Chupurnov Valeriy. Tüm hakları saklıdır.',
    Anchor: 'Bağlantı',
    'Open in new tab': 'Yeni sekmede aç',
    'Open in fullsize': 'Editörü tam ekranda aç',
    'Clear Formatting': 'Stili temizle',
    'Fill color or set the text color': 'Renk doldur veya yazı rengi seç',
    Redo: 'Yinele',
    Undo: 'Geri Al',
    Bold: 'Kalın',
    Italic: 'İtalik',
    'Insert Unordered List': 'Sırasız Liste Ekle',
    'Insert Ordered List': 'Sıralı Liste Ekle',
    'Align Center': 'Ortala',
    'Align Justify': 'Kenarlara Yasla',
    'Align Left': 'Sola Yasla',
    'Align Right': 'Sağa Yasla',
    'Insert Horizontal Line': 'Yatay Çizgi Ekle',
    'Insert Image': 'Resim Ekle',
    'Insert file': 'Dosya Ekle',
    'Insert youtube/vimeo video': 'Youtube/Vimeo Videosu Ekle',
    'Insert link': 'Bağlantı Ekle',
    'Font size': 'Font Boyutu',
    'Font family': 'Font Ailesi',
    'Insert format block': 'Blok Ekle',
    Normal: 'Normal',
    'Heading 1': 'Başlık 1',
    'Heading 2': 'Başlık 2',
    'Heading 3': 'Başlık 3',
    'Heading 4': 'Başlık 4',
    Quote: 'Alıntı',
    Code: 'Kod',
    Insert: 'Ekle',
    'Insert table': 'Tablo Ekle',
    'Decrease Indent': 'Girintiyi Azalt',
    'Increase Indent': 'Girintiyi Arttır',
    'Select Special Character': 'Özel Karakter Seç',
    'Insert Special Character': 'Özel Karakter Ekle',
    'Paint format': 'Resim Biçimi',
    'Change mode': 'Mod Değiştir',
    Margins: 'Boşluklar',
    top: 'Üst',
    right: 'Sağ',
    bottom: 'Alt',
    left: 'Sol',
    Styles: 'CSS Stilleri',
    Classes: 'CSS Sınıfları',
    Align: 'Hizalama',
    Right: 'Sağ',
    Center: 'Ortalı',
    Left: 'Sol',
    '--Not Set--': 'Belirsiz',
    Src: 'Kaynak',
    Title: 'Başlık',
    Alternative: 'Alternatif Yazı',
    Link: 'Link',
    'Open link in new tab': 'Bağlantıyı yeni sekmede aç',
    Image: 'Resim',
    file: 'Dosya',
    'Image properties': 'Resim özellikleri',
    Cancel: 'İptal',
    Ok: 'Tamam',
    'Your code is similar to HTML. Keep as HTML?': 'Kodunuz HTML koduna benziyor. HTML olarak devam etmek ister misiniz?',
    'Paste as HTML': 'HTML olarak yapıştır',
    Keep: 'Sakla',
    Clean: 'Temizle',
    'Insert as Text': 'Yazı olarak ekle',
    'Word Paste Detected': 'Word biçiminde yapıştırma algılandı',
    'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?': 'Der Inhalt, den Sie einfügen, stammt aus einem Microsoft Word / Excel-Dokument. Möchten Sie das Format erhalten oder löschen?',
    'Insert only Text': 'Sadece yazıyı ekle',
    'File Browser': 'Dosya Listeleyici',
    'Error on load list': 'Liste yüklenirken hata oluştu',
    'Error on load folders': 'Klasörler yüklenirken hata oluştur',
    'Are you sure?': 'Emin misiniz?',
    'Enter Directory name': 'Dizin yolu giriniz',
    'Create directory': 'Dizin oluştur',
    'type name': 'İsim yaz',
    'Drop image': 'Resim bırak',
    'Drop file': 'Dosya bırak',
    'or click': 'veya tıkla',
    'Alternative text': 'Alternatif yazı',
    Browse: 'Gözat',
    Upload: 'Yükle',
    Background: 'Arka plan',
    Text: 'Yazı',
    Top: 'Üst',
    Middle: 'Orta',
    Bottom: 'Aşağı',
    'Insert column before': 'Öncesine kolon ekle',
    'Insert column after': 'Sonrasına kolon ekle',
    'Insert row above': 'Üstüne satır ekle',
    'Insert row below': 'Altına satır ekle',
    'Delete table': 'Tabloyu sil',
    'Delete row': 'Satırı sil',
    'Delete column': 'Kolonu sil',
    'Empty cell': 'Hücreyi temizle',
    Delete: 'Sil',
    'Strike through': 'Üstü çizili',
    Underline: 'Alt çizgi',
    Break: 'Satır sonu',
    'Search for': 'Ara',
    'Replace with': 'Şununla değiştir',
    Replace: 'Değiştir',
    Edit: 'Düzenle',
    'Vertical align': 'Dikey hizala',
    'Horizontal align': 'Yatay hizala',
    Filter: 'Filtre',
    'Sort by changed': 'Değişime göre sırala',
    'Sort by name': 'İsme göre sırala',
    'Sort by size': 'Boyuta göre sırala',
    'Add folder': 'Klasör ekle',
    Split: 'Ayır',
    'Split vertical': 'Dikey ayır',
    'Split horizontal': 'Yatay ayır',
    Merge: 'Birleştir',
    'Add column': 'Kolon ekle',
    'Add row': 'Satır ekle',
    Border: 'Kenarlık',
    'Embed code': 'Kod ekle',
    Update: 'Güncelle',
    superscript: 'Üst yazı',
    subscript: 'Alt yazı',
    'Cut selection': 'Seçilimi kes',
    Paste: 'Yapıştır',
    'Choose Content to Paste': 'Yapıştırılacak içerik seç',
    'Chars: %d': 'Harfler: %d',
    'Words: %d': 'Kelimeler: %d',
    All: 'Tümü',
    'Select %s': 'Seç: %s',
    'Select all': 'Tümünü seç',
    source: 'Kaynak',
    bold: 'Kalın',
    italic: 'italik',
    brush: 'Fırça',
    link: 'Bağlantı',
    undo: 'Geri al',
    redo: 'Yinele',
    table: 'Tablo',
    image: 'Resim',
    eraser: 'Silgi',
    paragraph: 'Paragraf',
    fontsize: 'Font boyutu',
    video: 'Video',
    font: 'Font',
    about: 'Hakkında',
    print: 'Yazdır',
    underline: 'Alt çizgi',
    strikethrough: 'Üstü çizili',
    indent: 'Girinti',
    outdent: 'Çıkıntı',
    fullsize: 'Tam ekran',
    shrink: 'Küçült',
    hr: 'Ayraç',
    ul: 'Sırasız liste',
    ol: 'Sıralı liste',
    cut: 'Kes',
    selectall: 'Tümünü seç',
    'Open link': 'Bağlantıyı aç',
    'Edit link': 'Bağlantıyı düzenle',
    'No follow': 'Nofollow özelliği',
    Unlink: 'Bağlantıyı kaldır',
    Eye: 'Yorumu',
    pencil: 'Düzenlemek için',
    ' URL': 'URL',
    Reset: 'Sıfırla',
    Save: 'Kaydet',
    'Save as ...': 'Farklı kaydet',
    Resize: 'Boyutlandır',
    Crop: 'Kırp',
    Width: 'Genişlik',
    Height: 'Yükseklik',
    'Keep Aspect Ratio': 'En boy oranını koru',
    Yes: 'Evet',
    No: 'Hayır',
    Remove: 'Sil',
    Select: 'Seç',
    'You can only edit your own images. Download this image on the host?': 'Sadece kendi resimlerinizi düzenleyebilirsiniz. Bu görseli kendi hostunuza indirmek ister misiniz?',
    'The image has been successfully uploaded to the host!': 'Görsel başarıyla hostunuza yüklendi',
    palette: 'Palet',
    'There are no files': 'Bu dizinde dosya yok',
    Rename: 'Yeniden isimlendir',
    'Enter new name': 'Yeni isim girin',
    preview: 'Ön izleme',
    download: 'İndir',
    'Paste from clipboard': 'Panodan yapıştır ',
    "Your browser doesn't support direct access to the clipboard.": 'Tarayıcınız panoya doğrudan erişimi desteklemiyor.',
    'Copy selection': 'Seçimi kopyala',
    copy: 'Kopyala',
    'Border radius': 'Sınır yarıçapı',
    'Show all': 'Tümünü Göster',
    Apply: 'Uygula',
    'Please fill out this field': 'Lütfen bu alanı doldurun',
    'Please enter a web address': 'Lütfen bir web adresi girin',
    Default: 'Varsayılan',
    Circle: 'Daire',
    Dot: 'Nokta',
    Quadrate: 'Kare',
    Find: 'Bul',
    'Find Previous': 'Öncekini Bul',
    'Find Next': 'Sonrakini Bul',
    'Insert className': 'Sınıf adı girin',
    'Press Alt for custom resizing': 'Özel yeniden boyutlandırma için Alt tuşuna basın'
});


/***/ }),

/***/ 28973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    'Line height': '线高'
});


/***/ }),

/***/ 29136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   _: function() { return /* binding */ isNormalNode; }
/* harmony export */ });
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _helpers_checker_is_marker_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78116);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/**
 * Is normal usual element
 * @private
 */ function isNormalNode(elm) {
    return Boolean(elm && !_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isEmptyTextNode(elm) && !_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTemporary(elm) && !(0,_helpers_checker_is_marker_js__WEBPACK_IMPORTED_MODULE_1__/* .isMarker */ .r)(elm));
}


/***/ }),

/***/ 29345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   f: function() { return /* binding */ markPageBreakElements; }
/* harmony export */ });
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */
const markPageBreakElements = (elm) => {
    if ((elm.isElement && elm.style.get('page-break-before') === 'always') ||
        elm.style.get('break-before') === 'page') {
        elm.attributes['jd-safe'] = true;
        elm.style.add('page-break-before', 'always');
        if (elm.isSingle) {
            elm.name = 'div';
        }
    }
    return elm;
};


/***/ }),

/***/ 29615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   j: function() { return /* binding */ applyLink; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29960);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/** @private */ function applyLink(j, image, imageLink, imageLinkOpenInNewTab) {
    // Link
    let link = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(image, 'a', j.editor);
    if (imageLink) {
        if (!link) {
            link = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.wrap(image, 'a', j.createInside);
        }
        (0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .C)(link, 'href', imageLink);
        (0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .C)(link, 'target', imageLinkOpenInNewTab ? '_blank' : null);
    } else {
        if (link && link.parentNode) {
            link.parentNode.replaceChild(image, link);
        }
    }
}


/***/ }),

/***/ 29673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C: function() { return /* binding */ isHtmlFromWord; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/checker
 */ /**
 * Detect if string is HTML from MS Word or Excel
 */ function isHtmlFromWord(data) {
    return data.search(/<meta.*?Microsoft Excel\s[\d].*?>/) !== -1 || data.search(/<meta.*?Microsoft Word\s[\d].*?>/) !== -1 || data.search(/style="[^"]*mso-/) !== -1 && data.search(/<font/) !== -1;
}


/***/ }),

/***/ 29807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   k: function() { return /* binding */ isNumeric; }
/* harmony export */ });
/* harmony import */ var _is_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70799);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/checker
 */ 
/**
 * Check value has numeric format
 */ function isNumeric(value) {
    if ((0,_is_string_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .K)(value)) {
        if (!value.match(/^([+-])?[0-9]+(\.?)([0-9]+)?(e[0-9]+)?$/)) {
            return false;
        }
        value = parseFloat(value);
    }
    return typeof value === 'number' && !isNaN(value) && isFinite(value);
}


/***/ }),

/***/ 29827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   _: function() { return /* binding */ UIImagePositionTab; }
/* harmony export */ });
/* harmony import */ var _core_decorators_component_component_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87325);
/* harmony import */ var _core_decorators_hook_hook_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97357);
/* harmony import */ var _core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37133);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21537);
/* harmony import */ var _core_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70799);
/* harmony import */ var _core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29960);
/* harmony import */ var _core_ui_element_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48538);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12153);
/* harmony import */ var _utils_utils_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14415);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









/** @private */ let UIImagePositionTab = class UIImagePositionTab extends _core_ui_element_js__WEBPACK_IMPORTED_MODULE_4__/* .UIElement */ .D {
    className() {
        return 'UIImagePositionTab';
    }
    render({ availableClasses }) {
        return `<div class="jodit-form__group &__editMargins">
			<label>~Margins~</label>
			<div class="jodit-grid jodit_vertical_middle">
				<input class="jodit_col-lg-1-5 jodit-input &__marginTop" type="text" placeholder="~top~"/>
				<a style="text-align: center;" class="jodit-properties__lock jodit_col-lg-1-5 &__lockMargin">*lock*</a>
				<input disabled="disabled" class="jodit_col-lg-1-5 jodit-input &__marginRight" type="text" placeholder="~right~"/>
				<input disabled="disabled" class="jodit_col-lg-1-5 jodit-input &__marginBottom" type="text" placeholder="~bottom~"/>
				<input disabled="disabled" class="jodit_col-lg-1-5 jodit-input &__marginLeft" type="text" placeholder="~left~"/>
			</div>
		</div>
		<div class="jodit-form__group &__editAlign">
			<label>~Align~</label>
			<select class="jodit-select &__align">
				<option value="">~--Not Set--~</option>
				<option value="left">~Left~</option>
				<option value="center">~Center~</option>
				<option value="right">~Right~</option>
			</select>
		</div>
		<div class="jodit-form__group &__editStyle">
			<label>~Styles~</label>
			<input type="text" class="jodit-input &__style"/>
		</div>
		<div class="jodit-form__group &__editClass">
			<label>~Classes~</label>
			${(()=>{
            const classInput = [];
            if (availableClasses && availableClasses.length > 0) {
                classInput.push('<select class="jodit-input jodit-select &__classes">');
                availableClasses.forEach((item)=>{
                    if ((0,_core_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_7__/* .isString */ .K)(item)) {
                        classInput.push(`<option value="${item}">${item}</option>`);
                    } else {
                        classInput.push(`<option value="${item[0]}">${item[1]}</option>`);
                    }
                });
                classInput.push('</select>');
            } else {
                classInput.push('<input type="text" class="jodit-input &__classes"/>');
            }
            return classInput.join('');
        })()}
		</div>
		<div class="jodit-form__group &__editId">
			<label>Id</label>
			<input type="text" class="jodit-input &__id"/>
		</div>
		<div
			class="jodit-form__group &__editBorderRadius"
		>
			<label>~Border radius~</label>
			<input type="number" class="jodit-input &__borderRadius"/>
		</div>`;
    }
    onStateAlignChange() {
        const align = this.getElm('align');
        align.value = this.state.values.align;
    }
    onChangeAlign() {
        const align = this.getElm('align');
        this.state.values.align = align.value;
    }
    onStateValuesBorderRadiusChange() {
        const borderRadius = this.getElm('borderRadius');
        borderRadius.value = this.state.values.borderRadius.toString();
    }
    onChangeBorderRadius() {
        const borderRadius = this.getElm('borderRadius');
        this.state.values.borderRadius = parseFloat(borderRadius.value);
    }
    onStateValuesIdChange() {
        const id = this.getElm('id');
        id.value = this.state.values.id;
    }
    onChangeId() {
        const id = this.getElm('id');
        this.state.values.id = id.value;
    }
    onStateValuesStyleChange() {
        const style = this.getElm('style');
        style.value = this.state.values.style;
    }
    onChangeStyle() {
        const style = this.getElm('style');
        this.state.values.style = style.value;
    }
    onStateValuesClassesChange() {
        const classes = this.getElm('classes');
        classes.value = this.state.values.classes;
    }
    onChangClasses() {
        const classes = this.getElm('classes');
        this.state.values.classes = classes.value;
    }
    onLockMarginClick(e) {
        this.state.marginIsLocked = !this.state.marginIsLocked;
        e.preventDefault();
    }
    onChangeMarginIsLocked() {
        const marginBottom = this.getElm('marginBottom');
        const marginRight = this.getElm('marginRight');
        const marginLeft = this.getElm('marginLeft');
        const lockMargin = this.getElm('lockMargin');
        [
            marginRight,
            marginBottom,
            marginLeft
        ].forEach((elm)=>{
            (0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_3__/* .attr */ .C)(elm, 'disabled', this.state.marginIsLocked || null);
        });
        lockMargin.innerHTML = _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_5__/* .Icon */ .I.get(this.state.marginIsLocked ? 'lock' : 'unlock');
        if (this.state.marginIsLocked) {
            const marginTop = this.state.values.marginTop;
            this.state.values.marginRight = marginTop;
            this.state.values.marginBottom = marginTop;
            this.state.values.marginLeft = marginTop;
        }
    }
    onStateValuesMarginChange() {
        const marginTop = this.getElm('marginTop');
        const marginRight = this.getElm('marginRight');
        const marginBottom = this.getElm('marginBottom');
        const marginLeft = this.getElm('marginLeft');
        marginTop.value = this.state.values.marginTop.toString();
        marginRight.value = this.state.values.marginRight.toString();
        marginBottom.value = this.state.values.marginBottom.toString();
        marginLeft.value = this.state.values.marginLeft.toString();
    }
    onChangeMargin() {
        const marginTop = this.getElm('marginTop');
        const marginRight = this.getElm('marginRight');
        const marginBottom = this.getElm('marginBottom');
        const marginLeft = this.getElm('marginLeft');
        this.state.values.marginTop = (0,_utils_utils_js__WEBPACK_IMPORTED_MODULE_6__/* .normalSizeFromString */ .G)(marginTop.value);
        if (this.state.marginIsLocked) {
            this.state.values.marginRight = this.state.values.marginTop;
            this.state.values.marginBottom = this.state.values.marginTop;
            this.state.values.marginLeft = this.state.values.marginTop;
        } else {
            this.state.values.marginRight = (0,_utils_utils_js__WEBPACK_IMPORTED_MODULE_6__/* .normalSizeFromString */ .G)(marginRight.value);
            this.state.values.marginBottom = (0,_utils_utils_js__WEBPACK_IMPORTED_MODULE_6__/* .normalSizeFromString */ .G)(marginBottom.value);
            this.state.values.marginLeft = (0,_utils_utils_js__WEBPACK_IMPORTED_MODULE_6__/* .normalSizeFromString */ .G)(marginLeft.value);
        }
    }
    hideFieldByOptions() {
        const opt = this.j.o.image;
        [
            [
                'editMargins',
                'editMargins'
            ],
            [
                'editAlign',
                'editAlign'
            ],
            [
                'editStyle',
                'editStyle'
            ],
            [
                'editClass',
                'editClass'
            ],
            [
                'editId',
                'editId'
            ],
            [
                'editBorderRadius',
                'editBorderRadius'
            ]
        ].forEach(([optKey, elmKey])=>{
            const elm = this.getElm(elmKey);
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.css)(elm, 'display', opt[optKey] ? null : 'none');
        });
    }
    constructor(jodit, state, handlers){
        super(jodit, {
            availableClasses: jodit.o.image.availableClasses
        });
        this.state = state;
        this.handlers = handlers;
    }
};
__decorate([
    (0,_core_decorators_hook_hook_js__WEBPACK_IMPORTED_MODULE_0__/* .hook */ .A)('ready'),
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)('state.values.align')
], UIImagePositionTab.prototype, "onStateAlignChange", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)('align:change')
], UIImagePositionTab.prototype, "onChangeAlign", null);
__decorate([
    (0,_core_decorators_hook_hook_js__WEBPACK_IMPORTED_MODULE_0__/* .hook */ .A)('ready'),
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)('state.values.borderRadius')
], UIImagePositionTab.prototype, "onStateValuesBorderRadiusChange", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)('borderRadius:change')
], UIImagePositionTab.prototype, "onChangeBorderRadius", null);
__decorate([
    (0,_core_decorators_hook_hook_js__WEBPACK_IMPORTED_MODULE_0__/* .hook */ .A)('ready'),
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)('state.values.id')
], UIImagePositionTab.prototype, "onStateValuesIdChange", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)('id:change')
], UIImagePositionTab.prototype, "onChangeId", null);
__decorate([
    (0,_core_decorators_hook_hook_js__WEBPACK_IMPORTED_MODULE_0__/* .hook */ .A)('ready'),
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)('state.values.style')
], UIImagePositionTab.prototype, "onStateValuesStyleChange", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)('style:change')
], UIImagePositionTab.prototype, "onChangeStyle", null);
__decorate([
    (0,_core_decorators_hook_hook_js__WEBPACK_IMPORTED_MODULE_0__/* .hook */ .A)('ready'),
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)('state.values.classes')
], UIImagePositionTab.prototype, "onStateValuesClassesChange", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)('classes:change')
], UIImagePositionTab.prototype, "onChangClasses", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)('lockMargin:click')
], UIImagePositionTab.prototype, "onLockMarginClick", null);
__decorate([
    (0,_core_decorators_hook_hook_js__WEBPACK_IMPORTED_MODULE_0__/* .hook */ .A)('ready'),
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)('state.marginIsLocked')
], UIImagePositionTab.prototype, "onChangeMarginIsLocked", null);
__decorate([
    (0,_core_decorators_hook_hook_js__WEBPACK_IMPORTED_MODULE_0__/* .hook */ .A)('ready'),
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)([
        'state.values.marginTop',
        'state.values.marginRight',
        'state.values.marginBottom',
        'state.values.marginLeft'
    ])
], UIImagePositionTab.prototype, "onStateValuesMarginChange", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)([
        'marginTop:change',
        'marginRight:change',
        'marginBottom:change',
        'marginLeft:change'
    ])
], UIImagePositionTab.prototype, "onChangeMargin", null);
__decorate([
    (0,_core_decorators_hook_hook_js__WEBPACK_IMPORTED_MODULE_0__/* .hook */ .A)('ready')
], UIImagePositionTab.prototype, "hideFieldByOptions", null);
UIImagePositionTab = __decorate([
    _core_decorators_component_component_js__WEBPACK_IMPORTED_MODULE_8__/* .component */ .s
], UIImagePositionTab);



/***/ }),

/***/ 29960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C: function() { return /* binding */ attr; }
/* harmony export */ });
/* harmony import */ var _checker_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27613);
/* harmony import */ var _string_kebab_case_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12475);
/* harmony import */ var _css_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41180);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/**
 * Alias for `elm.getAttribute` but if set second argument `-{key}`
 * it will also check `data-{key}` attribute
 * if set `value` it is alias for setAttribute with the same logic
 */ function attr(elm, keyOrAttributes, value) {
    if (!elm || !(0,_checker_index_js__WEBPACK_IMPORTED_MODULE_0__/* .isFunction */ .Tn)(elm.getAttribute)) {
        return null;
    }
    if (!(0,_checker_index_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .Kg)(keyOrAttributes)) {
        Object.keys(keyOrAttributes).forEach((key)=>{
            const value = keyOrAttributes[key];
            if ((0,_checker_index_js__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .Qd)(value) && key === 'style') {
                (0,_css_js__WEBPACK_IMPORTED_MODULE_1__/* .css */ .A)(elm, value);
            } else {
                if (key === 'className') {
                    key = 'class';
                }
                attr(elm, key, value);
            }
        });
        return null;
    }
    let key = (0,_string_kebab_case_js__WEBPACK_IMPORTED_MODULE_2__/* .CamelCaseToKebabCase */ .N)(keyOrAttributes);
    if (/^-/.test(key)) {
        const res = attr(elm, `data${key}`);
        if (res) {
            return res;
        }
        key = key.substr(1);
    }
    if (value !== undefined) {
        if (value == null) {
            elm.hasAttribute(key) && elm.removeAttribute(key);
        } else {
            let replaceValue = value.toString();
            if (elm.nodeName === 'IMG' && (key === 'width' || key === 'height')) {
                replaceValue = replaceValue.replace('px', '');
            }
            elm.setAttribute(key, replaceValue);
            return replaceValue;
        }
    }
    return elm.getAttribute(key);
}


/***/ }),

/***/ 29999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   _: function() { return /* binding */ asArray; }
/* harmony export */ });
/* harmony import */ var _checker_is_array_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68345);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/array
 */ 
/**
 * Always return Array
 * ```javascript
 * Jodit.modules.Helpers.asArray('test') // ['test']
 * Jodit.modules.Helpers.asArray(['test']) // ['test']
 * Jodit.modules.Helpers.asArray(1) // [1]
 * ```
 */ const asArray = (a)=>(0,_checker_is_array_js__WEBPACK_IMPORTED_MODULE_0__/* .isArray */ .c)(a) ? a : [
        a
    ];


/***/ }),

/***/ 30389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   O: function() { return /* reexport module object */ _input_js__WEBPACK_IMPORTED_MODULE_0__; },
/* harmony export */   U: function() { return /* reexport module object */ _select_js__WEBPACK_IMPORTED_MODULE_1__; }
/* harmony export */ });
/* harmony import */ var _input_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25685);
/* harmony import */ var _select_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66465);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module ui/form
 */ 



/***/ }),

/***/ 30465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   f: function() { return /* binding */ loadItems; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * Loads a list of files and adds them to the state
 * @private
 */ function loadItems(fb) {
    fb.files.setMod('active', true);
    fb.files.setMod('loading', true);
    return fb.dataProvider.items(fb.state.currentPath, fb.state.currentSource, {
        sortBy: fb.state.sortBy,
        onlyImages: fb.state.onlyImages,
        filterWord: fb.state.filterWord
    }).then((resp)=>{
        if (resp) {
            fb.state.elements = resp;
            fb.state.activeElements = [];
        }
    }).catch(fb.status).finally(()=>fb.files.setMod('loading', false));
}


/***/ }),

/***/ 30592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    'Line height': 'Vonal magassága'
});


/***/ }),

/***/ 30798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    newline: 'newline',
    delete: 'usunąć',
    space: 'przestrzeń',
    'Speech Recognize': 'Rozpoznawanie Mowy',
    Sound: 'Dźwięk',
    'Interim Results': 'Wyniki Okresowe'
});


/***/ }),

/***/ 31117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   LE: function() { return /* reexport safe */ _checkers__WEBPACK_IMPORTED_MODULE_0__.LE; },
/* harmony export */   Lv: function() { return /* reexport safe */ _checkers__WEBPACK_IMPORTED_MODULE_0__.Lv; },
/* harmony export */   OH: function() { return /* reexport safe */ _render__WEBPACK_IMPORTED_MODULE_2__.O; },
/* harmony export */   Rd: function() { return /* reexport safe */ _element__WEBPACK_IMPORTED_MODULE_1__.R; },
/* harmony export */   hJ: function() { return /* reexport safe */ _checkers__WEBPACK_IMPORTED_MODULE_0__.hJ; },
/* harmony export */   qy: function() { return /* reexport safe */ _render__WEBPACK_IMPORTED_MODULE_2__.q; },
/* harmony export */   xe: function() { return /* reexport safe */ _checkers__WEBPACK_IMPORTED_MODULE_0__.xe; }
/* harmony export */ });
/* harmony import */ var _checkers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84661);
/* harmony import */ var _element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2969);
/* harmony import */ var _render__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90129);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */





/***/ }),

/***/ 31151:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M36 4h-24c-2.21 0-4 1.79-4 4v32c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4v-32c0-2.21-1.79-4-4-4zm-24 4h10v16l-5-3-5 3v-16z\"/> </svg> ");


/***/ }),

/***/ 31359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   T: function() { return /* binding */ init; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(580);
/* harmony import */ var _helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27613);
/* harmony import */ var _load_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14041);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



/**
 * Init plugin if it has no dependencies, in another case wait requires plugins will be init
 * @private
 */ function init(jodit, pluginName, plugin, instance, doneList, waitingList) {
    if ((0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isInitable */ .Gp)(instance)) {
        try {
            instance.init(jodit);
        } catch (e) {
            console.error(e);
            if (!_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD) {
                throw e;
            }
        }
    }
    doneList.set(pluginName, instance);
    waitingList.delete(pluginName);
    if (instance.hasStyle) {
        (0,_load_js__WEBPACK_IMPORTED_MODULE_3__/* .loadStyle */ .M)(jodit, pluginName).catch((e)=>{
            !_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD && console.error(e);
        });
    }
    if (instance.styles) {
        const style = (0,_global_js__WEBPACK_IMPORTED_MODULE_1__/* .getContainer */ .My)(jodit, pluginName, 'style');
        style.innerHTML = instance.styles;
    }
}


/***/ }),

/***/ 31461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   J: function() { return /* binding */ processImage; }
/* harmony export */ });
/* harmony import */ var jodit_esm_core_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21537);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */

const processImage = (elm, ctx) => {
    if (ctx.rtf &&
        elm.name === '#comment' &&
        elm.attributes.nodeValue &&
        elm.attributes.nodeValue.indexOf('<v:shape') !== -1) {
        if (!ctx.shapes) {
            ctx.shapes = {};
        }
        const elms = ctx.jodit.create.fromHTML(elm.attributes.nodeValue);
        (0,jodit_esm_core_helpers__WEBPACK_IMPORTED_MODULE_0__.toArray)(elms.getElementsByTagName('v:shape')).forEach((e) => {
            ctx.shapes[e.id] = e.getAttribute('o:spid');
        });
        return elm;
    }
    if (elm.name !== 'img') {
        return elm;
    }
    if (ctx.rtf && elm.attributes['v:shapes']) {
        const spid = ctx.shapes?.[elm.attributes['v:shapes']];
        if (spid) {
            const imageMap = ctx.imageMap ?? {};
            if (!ctx.imageMap) {
                ctx.imageMap = imageMap;
                parseImages(ctx.rtf, 'i', '\\shppict', ctx.imageMap);
                parseImages(ctx.rtf, 's', '\\shp{', ctx.imageMap);
            }
            const a = imageMap[spid.substring(7)];
            if (a) {
                const base = [], parsedD = a.hex.match(/[0-9a-f]{2}/gi);
                if (parsedD) {
                    for (let i = 0; i < parsedD.length; i++) {
                        const digit = parseInt(parsedD[i], 16);
                        base.push(String.fromCharCode(digit));
                    }
                    elm.attributes.src =
                        'data:' + a.type + ';base64,' + btoa(base.join(''));
                }
            }
        }
    }
    return elm;
};
function parseImages(rtf, prefix, separator, imageMap) {
    const parts = rtf.split(separator);
    for (const part of parts) {
        const shapes = part.split('shplid');
        if (1 < shapes.length) {
            const shape = shapes[1];
            let id = '';
            for (let i = 0; i < shape.length && !/[{ \r\n\\]/.test(shape[i]); i++) {
                id += shape[i];
            }
            const images = shape.split('bliptag');
            if (images && images.length < 2) {
                continue;
            }
            let format = null;
            if (images[0].indexOf('pngblip')) {
                format = 'image/png';
            }
            else if (images[0].indexOf('jpegblip') !== -1) {
                format = 'image/jpeg';
            }
            if (!format) {
                continue;
            }
            const endings = images[1].split('}');
            if (endings && endings.length < 2) {
                continue;
            }
            let result;
            if (2 < endings.length && endings[0].includes('blipuid')) {
                result = endings[1].split(' ');
            }
            else {
                result = endings[0].split(' ');
                if (result && result.length < 2) {
                    continue;
                }
                result.shift();
            }
            imageMap[prefix + id] = {
                hex: result.join(''),
                type: format
            };
        }
    }
}


/***/ }),

/***/ 31554:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M704 1376v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm-544-992h448l-48-117q-7-9-17-11h-317q-10 2-17 11zm928 32v64q0 14-9 23t-23 9h-96v948q0 83-47 143.5t-113 60.5h-832q-66 0-113-58.5t-47-141.5v-952h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h309l70-167q15-37 54-63t79-26h320q40 0 79 26t54 63l70 167h309q14 0 23 9t9 23z\"/> </svg> ");


/***/ }),

/***/ 31571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   s: function() { return /* binding */ pasteFromWord; }
/* harmony export */ });
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21537);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50911);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71842);
/* harmony import */ var _paste_helpers_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(117);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







class pasteFromWord extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Plugin */ .k {
    afterInit(jodit) {}
    beforeDestruct(jodit) {}
    /**
     * Try if text is Word's document fragment and try process this
     */ processWordHTML(e, text, texts) {
        const { j } = this, { processPasteFromWord, askBeforePasteFromWord, defaultActionOnPasteFromWord, defaultActionOnPaste, pasteFromWordActionList } = j.o;
        if (processPasteFromWord && (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isHtmlFromWord)(text)) {
            if (askBeforePasteFromWord) {
                (0,_paste_helpers_js__WEBPACK_IMPORTED_MODULE_6__/* .askInsertTypeDialog */ .PU)(j, 'The pasted content is coming from a Microsoft Word/Excel document. ' + 'Do you want to keep the format or clean it up?', 'Word Paste Detected', (insertType)=>{
                    this.insertFromWordByType(e, text, insertType, texts);
                }, pasteFromWordActionList);
            } else {
                this.insertFromWordByType(e, text, defaultActionOnPasteFromWord || defaultActionOnPaste, texts);
            }
            return true;
        }
        return false;
    }
    /**
     * Clear extra styles and tags from Word's pasted text
     */ insertFromWordByType(e, html, insertType, texts) {
        var _a;
        switch(insertType){
            case _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INSERT_AS_HTML:
                {
                    html = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.applyStyles)(html);
                    const value = (_a = this.j.events) === null || _a === void 0 ? void 0 : _a.fire('beautifyHTML', html);
                    if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isString)(value)) {
                        html = value;
                    }
                    break;
                }
            case _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INSERT_AS_TEXT:
                {
                    html = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.cleanFromWord)(html);
                    break;
                }
            case _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INSERT_ONLY_TEXT:
                {
                    html = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.stripTags)((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.cleanFromWord)(html));
                    break;
                }
        }
        (0,_paste_helpers_js__WEBPACK_IMPORTED_MODULE_6__/* .pasteInsertHtml */ .sX)(e, this.j, html);
    }
}
pasteFromWord.requires = [
    'paste'
];
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)(':processHTML')
], pasteFromWord.prototype, "processWordHTML", null);
_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .pluginSystem */ .fg.add('pasteFromWord', pasteFromWord);


/***/ }),

/***/ 31589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   m: function() { return /* binding */ nonenumerable; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * [[include:core/decorators/nonenumerable/README.md]]
 * @packageDocumentation
 * @module decorators/nonenumerable
 */ const nonenumerable = (target, propertyKey)=>{
    const descriptor = Object.getOwnPropertyDescriptor(target, propertyKey) || {};
    if (descriptor.enumerable !== false) {
        Object.defineProperty(target, propertyKey, {
            enumerable: false,
            set (value) {
                Object.defineProperty(this, propertyKey, {
                    enumerable: false,
                    writable: true,
                    value
                });
            }
        });
    }
};


/***/ }),

/***/ 31635:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Cg: function() { return /* binding */ __decorate; }
/* harmony export */ });
/* unused harmony exports __extends, __assign, __rest, __param, __esDecorate, __runInitializers, __propKey, __setFunctionName, __metadata, __awaiter, __generator, __createBinding, __exportStar, __values, __read, __spread, __spreadArrays, __spreadArray, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn, __addDisposableResource, __disposeResources, __rewriteRelativeImportExtension */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
  function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
  function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

var ownKeys = function(o) {
  ownKeys = Object.getOwnPropertyNames || function (o) {
    var ar = [];
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
    return ar;
  };
  return ownKeys(o);
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose, inner;
    if (async) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      dispose = value[Symbol.dispose];
      if (async) inner = dispose;
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  var r, s = 0;
  function next() {
    while (r = env.stack.pop()) {
      try {
        if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
        if (r.dispose) {
          var result = r.dispose.call(r.value);
          if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
        }
        else s |= 1;
      }
      catch (e) {
        fail(e);
      }
    }
    if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
    if (env.hasError) throw env.error;
  }
  return next();
}

function __rewriteRelativeImportExtension(path, preserveJsx) {
  if (typeof path === "string" && /^\.\.?\//.test(path)) {
      return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
          return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
      });
  }
  return path;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __esDecorate,
  __runInitializers,
  __propKey,
  __setFunctionName,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
  __rewriteRelativeImportExtension,
});


/***/ }),

/***/ 31974:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6441);
/* harmony import */ var _ai_assistant_svg_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64488);
/* harmony import */ var _chat_bot_svg_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23658);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



const aiAssistantDefaults = {
    aiCommonPrefixPrompt: '',
    aiCommonSuffixPrompt: '',
    aiImproveWritingPrompt: 'It needs to be refined for better clarity, coherence, and overall quality. Please enhance the writing style while keeping the original meaning and language intact.',
    aiMakeShorterPrompt: 'Please condense this content to make it more concise, while preserving the key messages, language and information.',
    aiMakeLongerPrompt: 'Expand on this content to provide more detail, depth, and richness, without diverging from the original message and language.',
    aiSimplifyLanguagePrompt: 'The language used here needs to be simplified for easier understanding, without altering the core information and the original language.',
    aiSummarizePrompt: 'Provide a brief summary of this content, capturing the essential points in a concise manner. Preserve the original language and meaning.',
    aiContinuePrompt: 'Continue the narrative or discussion from this content seamlessly, maintaining the same language, tone and style.',
    aiChangeToneProfessionalPrompt: 'Adjust the tone to be professional, suitable for a formal business or academic setting, while retaining the original message and language.',
    aiChangeToneFriendlyPrompt: 'It needs to be rewritten in a friendly tone while maintaining the original message and language. Please modify this content to be warm, approachable, and engaging.',
    aiChangeToneFormalPrompt: 'Transform this content to have a formal tone, appropriate for official or serious contexts, without changing the main points and language.',
    aiChangeToneCasualPrompt: 'Revise this content to have a casual, relaxed tone, making it feel more personal and less formal, without changing the original meaning and language.',
    aiChangeToneDirectPrompt: 'Make the tone more direct, with straightforward language and a clear, assertive approach, without changing the original meaning and language.',
    aiChangeToneConfidentPrompt: 'Infuse this content with a confident tone, showcasing assurance and decisiveness, without changing the original meaning and language.',
    aiChangeStyleBusinessPrompt: 'Rewrite this content with a business-oriented style, focusing on clarity, efficiency, and professionalism, without changing the original meaning and language.',
    aiChangeStyleLegalPrompt: 'Adapt this content to a legal style, incorporating appropriate terminology and formality typical of legal documents, without changing the original meaning and language.',
    aiChangeStyleJournalismPrompt: 'Convert this content into a journalistic style, emphasizing factual accuracy, objectivity, and informative reporting, without changing the original meaning and language.',
    aiChangeStylePoeticPrompt: 'Recreate this content with a poetic style, using expressive language, rhythm, and imagery to convey the message, without changing the original meaning and language.',
    aiTranslateToSpanishPrompt: 'Translate this content into Spanish, ensuring the translation is accurate and maintains the original meaning.',
    aiTranslateToFrenchPrompt: 'Translate this content into French, ensuring the translation is accurate and maintains the original meaning.',
    aiTranslateToGermanPrompt: 'Translate this content into German, ensuring the translation is accurate and maintains the original meaning.',
    aiTranslateToItalianPrompt: 'Translate this content into Italian, ensuring the translation is accurate and maintains the original meaning.',
    aiTranslateToPortuguesePrompt: 'Translate this content into Portuguese, ensuring the translation is accurate and maintains the original meaning.',
    aiTranslateToEnglishPrompt: 'Translate this content into English, ensuring the translation is accurate and maintains the original meaning.',
    aiTranslateToChinesePrompt: 'Translate this content into Chinese, ensuring the translation is accurate and maintains the original meaning.',
    aiTranslateToJapanesePrompt: 'Translate this content into Japanese, ensuring the translation is accurate and maintains the original meaning.',
    aiTranslateToKoreanPrompt: 'Translate this content into Korean, ensuring the translation is accurate and maintains the original meaning.',
    aiTranslateToRussianPrompt: 'Translate this content into Russian, ensuring the translation is accurate and maintains the original meaning.',
    aiTranslateToArabicPrompt: 'Translate this content into Arabic, ensuring the translation is accurate and maintains the original meaning.'
};
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.aiAssistant = aiAssistantDefaults;
_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_0__/* .Icon */ .I.set('ai-assistant', _chat_bot_svg_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A);
_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_0__/* .Icon */ .I.set('ai-commands', _ai_assistant_svg_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A);
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.controls['ai-commands'] = {
    isDisabled (editor) {
        return !editor.o.aiAssistant.aiAssistantCallback;
    },
    tooltip: 'AI Commands',
    list: {
        aiImproveWritingPrompt: 'Improve writing',
        aiMakeShorterPrompt: 'Make shorter',
        aiMakeLongerPrompt: 'Make longer',
        aiSimplifyLanguagePrompt: 'Simplify language',
        aiSummarizePrompt: 'Summarize',
        aiContinuePrompt: 'Continue',
        aiChangeToneProfessionalPrompt: 'Change tone to professional',
        aiChangeToneFriendlyPrompt: 'Change tone to friendly',
        aiChangeToneFormalPrompt: 'Change tone to formal',
        aiChangeToneCasualPrompt: 'Change tone to casual',
        aiChangeToneDirectPrompt: 'Change tone to direct',
        aiChangeToneConfidentPrompt: 'Change tone to confident',
        aiChangeStyleBusinessPrompt: 'Change style to business',
        aiChangeStyleLegalPrompt: 'Change style to legal',
        aiChangeStyleJournalismPrompt: 'Change style of journalism',
        aiChangeStylePoeticPrompt: 'Change style to poetic',
        aiTranslateToSpanishPrompt: 'Translate to Spanish',
        aiTranslateToFrenchPrompt: 'Translate to French',
        aiTranslateToGermanPrompt: 'Translate to German',
        aiTranslateToItalianPrompt: 'Translate to Italian',
        aiTranslateToPortuguesePrompt: 'Translate to Portuguese',
        aiTranslateToEnglishPrompt: 'Translate to English',
        aiTranslateToChinesePrompt: 'Translate to Chinese',
        aiTranslateToJapanesePrompt: 'Translate to Japanese',
        aiTranslateToKoreanPrompt: 'Translate to Korean',
        aiTranslateToRussianPrompt: 'Translate to Russian',
        aiTranslateToArabicPrompt: 'Translate to Arabic'
    },
    exec: (editor, event, { control })=>{
        editor.e.fire('generateAiAssistantForm.ai-assistant', control.name);
    }
};
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.controls['ai-assistant'] = {
    isDisabled (editor) {
        return !editor.o.aiAssistant.aiAssistantCallback;
    },
    hotkeys: [
        'ctrl+a+i',
        'cmd+a+i'
    ],
    tooltip: 'AI Assistant',
    exec: (editor, current, close)=>{
        editor.e.fire('generateAiAssistantForm.ai-assistant');
    }
};


/***/ }),

/***/ 32118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   a: function() { return /* binding */ elementsMap; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ const map = new WeakMap();
/**
 * Returns a map of the file's key correspondence to its DOM element in the file browser
 * @private
 */ const elementsMap = (view)=>{
    let result = map.get(view);
    if (!result) {
        result = {};
        map.set(view, result);
    }
    return result;
};


/***/ }),

/***/ 32172:
/***/ (function(__unused_webpack_module, __webpack_exports__) {


/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'copy-format': 'format kopii'
});


/***/ }),

/***/ 32309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export mobile */
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21537);
/* harmony import */ var _core_ui_helpers_buttons_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43649);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37585);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



/**
 * Rebuild toolbar in depends on editor's width
 */ function mobile(editor) {
    let timeout = 0, store = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.splitArray)(editor.o.buttons);
    if (editor.o.mobileTapTimeout) {
        // Emulate double tap
        editor.e.on('touchend', (e)=>{
            if (e.changedTouches && e.changedTouches.length) {
                const now = new Date().getTime(), diff = now - timeout;
                if (diff > editor.o.mobileTapTimeout) {
                    timeout = now;
                    if (diff < editor.o.mobileTapTimeout * 1.5) {
                        editor.s.insertCursorAtPoint(e.clientX, e.clientY);
                    }
                }
            }
        });
    }
    editor.e.on('getDiffButtons.mobile', (toolbar)=>{
        if (toolbar === editor.toolbar) {
            const buttons = (0,_core_ui_helpers_buttons_js__WEBPACK_IMPORTED_MODULE_3__/* .flatButtonsSet */ .V)((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.splitArray)(editor.o.buttons), editor), flatStore = (0,_core_ui_helpers_buttons_js__WEBPACK_IMPORTED_MODULE_3__/* .flatButtonsSet */ .V)(store, editor);
            return (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.toArray)(buttons).reduce((acc, item)=>{
                if (!flatStore.has(item)) {
                    acc.push(item);
                }
                return acc;
            }, []);
        }
    });
    if (editor.o.toolbarAdaptive) {
        editor.e.on('resize afterInit recalcAdaptive changePlace afterAddPlace', ()=>{
            var _a, _b;
            if (!editor.o.toolbar) {
                return;
            }
            const width = ((_a = editor.container.parentElement) !== null && _a !== void 0 ? _a : editor.container).offsetWidth;
            const newStore = (()=>{
                if (editor.isFullSize || width >= editor.o.sizeLG) {
                    return (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.splitArray)(editor.o.buttons);
                }
                if (width >= editor.o.sizeMD) {
                    return (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.splitArray)(editor.o.buttonsMD);
                }
                if (width >= editor.o.sizeSM) {
                    return (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.splitArray)(editor.o.buttonsSM);
                }
                return (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.splitArray)(editor.o.buttonsXS);
            })();
            if (newStore.toString() !== store.toString()) {
                store = newStore;
                editor.e.fire('closeAllPopups');
                (_b = editor.toolbar) === null || _b === void 0 ? void 0 : _b.setRemoveButtons(editor.o.removeButtons).build(store.concat(editor.o.extraButtons));
            }
        }).on(editor.ow, 'load resize', ()=>editor.e.fire('recalcAdaptive'));
    }
}
_core_global_js__WEBPACK_IMPORTED_MODULE_0__/* .pluginSystem */ .fg.add('mobile', mobile);


/***/ }),

/***/ 32496:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/backspace
 */ 
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.delete = {
    hotkeys: {
        delete: [
            'delete',
            'cmd+backspace'
        ],
        deleteWord: [
            'ctrl+delete',
            'cmd+alt+backspace',
            'ctrl+alt+backspace'
        ],
        deleteSentence: [
            'ctrl+shift+delete',
            'cmd+shift+delete'
        ],
        backspace: [
            'backspace'
        ],
        backspaceWord: [
            'ctrl+backspace'
        ],
        backspaceSentence: [
            'ctrl+shift+backspace',
            'cmd+shift+backspace'
        ]
    }
};


/***/ }),

/***/ 32523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   b: function() { return /* binding */ UiAiAssistant; }
/* harmony export */ });
/* harmony import */ var _core_decorators_component_component_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87325);
/* harmony import */ var _core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37133);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _core_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70799);
/* harmony import */ var _core_ui_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67510);
/* harmony import */ var _core_ui_element_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48538);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






let UiAiAssistant = class UiAiAssistant extends _core_ui_element_js__WEBPACK_IMPORTED_MODULE_3__/* .UIElement */ .D {
    className() {
        return 'UIAiAssistant';
    }
    render() {
        return `<div>
				<div class="&__container">
						<div class="&__error"></div>
						<div class="&__body"></div>
						<div class="&__buttons &_hide_true"></div>
						<div class="&__results &_hide_true">
								<div class="&__spinner"></div>
						</div>
				</div>
		</div>`;
    }
    setPrompt(prompt) {
        if (prompt) {
            const { jodit } = this;
            const promptOpt = jodit.o.aiAssistant[prompt];
            const { aiCommonPrefixPrompt, aiCommonSuffixPrompt } = jodit.o.aiAssistant;
            this.promptInput.value = [
                aiCommonPrefixPrompt,
                (0,_core_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__/* .isString */ .K)(promptOpt) ? promptOpt : '',
                aiCommonSuffixPrompt
            ].filter(Boolean).join(' ');
            this.__toggleInsertButton(true);
            if (this.promptInput.value) {
                this.__formAiAssistant.submit();
                this.__toggleSubmitButton(true);
            }
        }
        this.promptInput.focus();
    }
    onAiAssistentResponse(result) {
        this.setMod('loading', false);
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.detach(this.__results);
        this.__aiResult = result;
        this.__results.appendChild(this.jodit.c.fromHTML(result));
        this.__toggleSubmitButton(false);
        this.__toggleInsertButton(false);
    }
    onAiAssistentError(error) {
        this.__aiResult = '';
        this.setMod('loading', false);
        this.__error.textContent = error;
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.detach(this.__results);
        this.__toggleSubmitButton(false);
        const hideMod = this.getFullElName('', 'hide', 'true');
        this.__results.classList.add(hideMod);
        this.__toggleInsertButton(true);
    }
    onChangePromptValue() {
        this.__toggleSubmitButton(!this.promptInput.value);
    }
    __toggleSubmitButton(value) {
        this.__submitButton.state.disabled = value;
        this.__tryAgainButton.state.disabled = value;
    }
    __toggleInsertButton(value) {
        this.__insertButton.state.disabled = value;
        this.__insertAfterButton.state.disabled = value;
    }
    constructor(jodit, { onInsert, onInsertAfter }){
        super(jodit);
        this.__aiResult = '';
        this.__error = this.getElm('error');
        this.__body = this.getElm('body');
        this.__buttons = this.getElm('buttons');
        this.__results = this.getElm('results');
        this.__spinner = this.getElm('spinner');
        this.__insertButton = (0,_core_ui_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .$n)(jodit, '', 'Insert', 'primary').onAction(()=>onInsert(this.__aiResult));
        this.__insertAfterButton = (0,_core_ui_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .$n)(jodit, '', 'Insert After', 'initial').onAction(()=>onInsertAfter(this.__aiResult));
        const onSubmit = ()=>{
            if (this.__formAiAssistant.validate()) {
                this.__formAiAssistant.submit();
                this.__toggleInsertButton(true);
                this.__toggleSubmitButton(true);
            }
        };
        this.__submitButton = (0,_core_ui_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .$n)(jodit, 'ai-assistant', '').onAction(onSubmit);
        this.__tryAgainButton = (0,_core_ui_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .$n)(jodit, 'update', '', 'initial').onAction(onSubmit);
        this.promptInput = new _core_ui_index_js__WEBPACK_IMPORTED_MODULE_2__/* .UITextArea */ .F0(jodit, {
            name: 'prompt',
            required: true,
            label: 'Prompt',
            placeholder: 'Ask AI to improve generated text',
            className: this.getFullElName('prompt-row-input')
        });
        const buttonsBLock = new _core_ui_index_js__WEBPACK_IMPORTED_MODULE_2__/* .UIBlock */ .Yh(jodit, [
            this.__insertButton,
            this.__insertAfterButton,
            this.__tryAgainButton
        ], {
            className: this.getFullElName('prompt-row')
        });
        this.__formAiAssistant = new _core_ui_index_js__WEBPACK_IMPORTED_MODULE_2__/* .UIForm */ .XV(jodit, [
            new _core_ui_index_js__WEBPACK_IMPORTED_MODULE_2__/* .UIBlock */ .Yh(jodit, [
                this.promptInput,
                this.__submitButton
            ], {
                className: this.getFullElName('prompt-row')
            })
        ]).onSubmit((data)=>{
            this.__error.textContent = '';
            this.setMod('loading', true);
            jodit.e.fire('invokeAiAssistant', data.prompt);
            const hideMod = this.getFullElName('', 'hide', 'true');
            this.__results.classList.remove(hideMod);
            this.__buttons.classList.remove(hideMod);
            _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.detach(this.__results);
            this.__results.appendChild(this.__spinner);
            this.__insertButton.focus();
        });
        this.__buttons.appendChild(buttonsBLock.container);
        this.__body.appendChild(this.__formAiAssistant.container);
        this.onChangePromptValue();
    }
};
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_0__/* .watch */ .w)(':ai-assistant-response')
], UiAiAssistant.prototype, "onAiAssistentResponse", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_0__/* .watch */ .w)(':ai-assistant-error')
], UiAiAssistant.prototype, "onAiAssistentError", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_0__/* .watch */ .w)('promptInput:change')
], UiAiAssistant.prototype, "onChangePromptValue", null);
UiAiAssistant = __decorate([
    _core_decorators_component_component_js__WEBPACK_IMPORTED_MODULE_5__/* .component */ .s
], UiAiAssistant);



/***/ }),

/***/ 32526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   y: function() { return /* binding */ extractSelectedPart; }
/* harmony export */ });
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _helpers_checker_is_marker_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78116);
/* harmony import */ var _helpers_string_trim_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49055);
/* harmony import */ var _helpers_utils_utils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37790);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



/**
 * If the selection area is inside an element that matches the commit (suitable relative),
 * but does not completely fill it.
 * Then the method cuts the parent and leaves itself in a copy of the parent (suitable relative) in the middle.
 *
 * @example
 * Apply strong to
 * ```html
 * 	<strong><span>some<font>SELECTED</font>text</span></strong>
 * ```
 * Should extract selection from parent `strong`
 * ```html
 * `<strong><span>some</span></strong><strong><span><font>SELECTED</font></span></strong><strong><span>test</span></strong>
 * ```
 * @private
 */ function extractSelectedPart(wrapper, font, jodit) {
    const range = jodit.s.createRange();
    // Left part
    const leftEdge = (0,_helpers_checker_is_marker_js__WEBPACK_IMPORTED_MODULE_1__/* .isMarker */ .r)(font.previousSibling) ? font.previousSibling : font;
    range.setStartBefore(wrapper);
    range.setEndBefore(leftEdge);
    extractAndMove(wrapper, range, true);
    // Right part
    const rightEdge = (0,_helpers_checker_is_marker_js__WEBPACK_IMPORTED_MODULE_1__/* .isMarker */ .r)(font.nextSibling) ? font.nextSibling : font;
    range.setStartAfter(rightEdge);
    range.setEndAfter(wrapper);
    extractAndMove(wrapper, range, false);
}
/**
 * Retrieves content before after the selected area, clears it if it is empty, and inserts before after the framed selection
 * @private
 */ function extractAndMove(wrapper, range, left) {
    const fragment = range.extractContents();
    if ((!fragment.textContent || !(0,_helpers_string_trim_js__WEBPACK_IMPORTED_MODULE_2__/* .trim */ .Bq)(fragment.textContent).length) && fragment.firstChild) {
        _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.unwrap(fragment.firstChild);
    }
    if (wrapper.parentNode) {
        (0,_helpers_utils_utils_js__WEBPACK_IMPORTED_MODULE_3__/* .call */ .T1)(left ? _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.before : _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.after, wrapper, fragment);
    }
}


/***/ }),

/***/ 32566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   P: function() { return /* binding */ readSizes; }
/* harmony export */ });
/* harmony import */ var _core_helpers_checker_is_numeric_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29807);
/* harmony import */ var _core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29960);
/* harmony import */ var _core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41180);
/* harmony import */ var _utils_utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14415);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/image-properties
 */ 



/** @private */ async function readSizes(image, values, state) {
    await image.decode();
    const width = (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_2__/* .css */ .A)(image, 'width', true) || (0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__/* .attr */ .C)(image, 'width') || false;
    const height = (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_2__/* .css */ .A)(image, 'height', true) || (0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__/* .attr */ .C)(image, 'height') || false;
    values.imageWidth = width !== false ? (0,_utils_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .normalSizeFromString */ .G)(width) : image.offsetWidth || image.naturalWidth;
    if ((0,_core_helpers_checker_is_numeric_js__WEBPACK_IMPORTED_MODULE_3__/* .isNumeric */ .k)(values.imageWidth)) {
        values.imageHeight = height !== false ? (0,_utils_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .normalSizeFromString */ .G)(height) : image.offsetHeight || image.naturalHeight;
    } else {
        values.imageHeight = height || '';
    }
    const { imageWidth, imageHeight } = values;
    const w = parseFloat(imageWidth.toString());
    if (!(0,_core_helpers_checker_is_numeric_js__WEBPACK_IMPORTED_MODULE_3__/* .isNumeric */ .k)(imageWidth) || !(0,_core_helpers_checker_is_numeric_js__WEBPACK_IMPORTED_MODULE_3__/* .isNumeric */ .k)(imageHeight)) {
        state.sizeIsLocked = false;
        return;
    }
    if (height === false) {
        values.imageHeight = Math.round(w / state.ratio);
        state.sizeIsLocked = true;
        return;
    }
    const h = parseFloat(imageHeight.toString());
    state.sizeIsLocked = Math.abs(w - h * state.ratio) < 1;
}


/***/ }),

/***/ 32574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: function() { return /* binding */ applyStyles; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _string_trim_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49055);
/* harmony import */ var _utils_selector_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76078);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/html
 */ 



function normalizeCSS(s) {
    return s.replace(/mso-[a-z-]+:[\s]*[^;]+;/gi, '').replace(/mso-[a-z-]+:[\s]*[^";']+$/gi, '').replace(/border[a-z-]*:[\s]*[^;]+;/gi, '').replace(/([0-9.]+)(pt|cm)/gi, (match, units, metrics)=>{
        switch(metrics.toLowerCase()){
            case 'pt':
                return (parseFloat(units) * 1.328).toFixed(0) + 'px';
            case 'cm':
                return (parseFloat(units) * 0.02645833).toFixed(0) + 'px';
        }
        return match;
    });
}
/**
 * If the HTML has CSS rules with selectors,
 * it applies them to the selectors in the HTML itself
 * and then removes the selector styles, leaving only the inline ones.
 */ function applyStyles(html) {
    if (html.indexOf('<html ') === -1) {
        return html;
    }
    html = html.substring(html.indexOf('<html '), html.length);
    html = html.substring(0, html.lastIndexOf('</html>') + '</html>'.length);
    const iframe = _constants_js__WEBPACK_IMPORTED_MODULE_0__.globalDocument.createElement('iframe');
    iframe.style.display = 'none';
    _constants_js__WEBPACK_IMPORTED_MODULE_0__.globalDocument.body.appendChild(iframe);
    let convertedString = '', collection = [];
    try {
        const iframeDoc = iframe.contentDocument || (iframe.contentWindow ? iframe.contentWindow.document : null);
        if (iframeDoc) {
            iframeDoc.open();
            iframeDoc.write(html);
            iframeDoc.close();
            try {
                for(let i = 0; i < iframeDoc.styleSheets.length; i += 1){
                    const rules = iframeDoc.styleSheets[i].cssRules;
                    for(let idx = 0; idx < rules.length; idx += 1){
                        if (rules[idx].selectorText === '') {
                            continue;
                        }
                        collection = (0,_utils_selector_js__WEBPACK_IMPORTED_MODULE_3__.$$)(rules[idx].selectorText, iframeDoc.body);
                        collection.forEach((elm)=>{
                            elm.style.cssText = normalizeCSS(rules[idx].style.cssText + ';' + elm.style.cssText);
                        });
                    }
                }
            } catch (e) {
                if (!_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD) {
                    throw e;
                }
            }
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.each(iframeDoc.body, (node)=>{
                if (_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isElement(node)) {
                    const elm = node;
                    const css = elm.getAttribute('style');
                    if (css) {
                        elm.style.cssText = normalizeCSS(css);
                    }
                    if (elm.hasAttribute('style') && !elm.getAttribute('style')) {
                        elm.removeAttribute('style');
                    }
                }
            });
            convertedString = iframeDoc.firstChild ? (0,_string_trim_js__WEBPACK_IMPORTED_MODULE_2__/* .trim */ .Bq)(iframeDoc.body.innerHTML) : '';
        }
    } catch (_a) {} finally{
        _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(iframe);
    }
    if (convertedString) {
        html = convertedString;
    }
    return (0,_string_trim_js__WEBPACK_IMPORTED_MODULE_2__/* .trim */ .Bq)(html.replace(/<(\/)?(html|colgroup|col|o:p)[^>]*>/g, '').replace(/<!--[^>]*>/g, ''));
}


/***/ }),

/***/ 32726:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'Type something': 'הקלד משהו...',
    Advanced: 'מתקדם',
    'About Jodit': 'About Jodit',
    'Jodit Editor': 'Jodit Editor',
    "Jodit User's Guide": "Jodit User's Guide",
    'contains detailed help for using': 'contains detailed help for using.',
    'For information about the license, please go to our website:': 'For information about the license, please go to our website:',
    'Buy full version': 'Buy full version',
    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.': 'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.',
    Anchor: 'מקום עיגון',
    'Open in new tab': 'פתח בכרטיסיה חדשה',
    'Open in fullsize': 'פתח את העורך בחלון חדש',
    'Clear Formatting': 'נקה עיצוב',
    'Fill color or set the text color': 'שנה צבע טקסט או רקע',
    Redo: 'בצע שוב',
    Undo: 'בטל',
    Bold: 'מודגש',
    Italic: 'נטוי',
    'Insert Unordered List': 'הכנס רשימת תבליטים',
    'Insert Ordered List': 'הכנס רשימה ממוספרת',
    'Align Center': 'מרכז',
    'Align Justify': 'ישר ',
    'Align Left': 'ישר לשמאל',
    'Align Right': 'ישר לימין',
    'Insert Horizontal Line': 'הכנס קו אופקי',
    'Insert Image': 'הכנס תמונה',
    'Insert file': 'הכנס קובץ',
    'Insert youtube/vimeo video': 'הכנס סרטון וידאו מYouTube/Vimeo',
    'Insert link': 'הכנס קישור',
    'Font size': 'גודל גופן',
    'Font family': 'גופן',
    'Insert format block': 'מעוצב מראש',
    Normal: 'רגיל',
    'Heading 1': 'כותרת 1',
    'Heading 2': 'כותרת 2',
    'Heading 3': 'כותרת 3',
    'Heading 4': 'כותרת 4',
    Quote: 'ציטוט',
    Code: 'קוד',
    Insert: 'הכנס',
    'Insert table': 'הכנס טבלה',
    'Decrease Indent': 'הקטן כניסה',
    'Increase Indent': 'הגדל כניסה',
    'Select Special Character': 'בחר תו מיוחד',
    'Insert Special Character': 'הכנס תו מיוחד',
    'Paint format': 'העתק עיצוב',
    'Change mode': 'החלף מצב',
    Margins: 'ריווח',
    top: 'עליון',
    right: 'ימין',
    bottom: 'תחתון',
    left: 'שמאל',
    Styles: 'עיצוב CSS',
    Classes: 'מחלקת CSS',
    Align: 'יישור',
    Right: 'ימין',
    Center: 'מרכז',
    Left: 'שמאל',
    '--Not Set--': '--לא נקבע--',
    Src: 'מקור',
    Title: 'כותרת',
    Alternative: 'כיתוב חלופי',
    Link: 'קישור',
    'Open link in new tab': 'פתח בכרטיסיה חדשה',
    Image: 'תמונה',
    file: 'קובץ',
    'Image properties': 'מאפייני תמונה',
    Cancel: 'ביטול',
    Ok: 'אישור',
    'Your code is similar to HTML. Keep as HTML?': 'הקוד דומה לHTML, האם להשאיר כHTML',
    'Paste as HTML': 'הדבק כHTML',
    Keep: 'השאר',
    Clean: 'נקה',
    'Insert as Text': 'הכנס כטקסט',
    'Word Paste Detected': 'זוהתה הדבקה מ"וורד"',
    'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?': 'התוכן המודבק מגיע ממסמך וורד/אקסל. האם ברצונך להשאיר את העיצוב או לנקותו',
    'Insert only Text': 'הכנס טקסט בלבד',
    'File Browser': 'סייר הקבצים',
    'Error on load list': 'שגיאה  בזמן טעינת רשימה',
    'Error on load folders': 'שגיאה בזמן טעינת תקיות',
    'Are you sure?': 'האם אתה בטוח?',
    'Enter Directory name': 'הכנס שם תקיה',
    'Create directory': 'צור תקיה',
    'type name': 'סוג הקובץ',
    'Drop image': 'הסר תמונה',
    'Drop file': 'הסר קובץ',
    'or click': 'או לחץ',
    'Alternative text': 'כיתוב חלופי',
    Browse: 'סייר',
    Upload: 'העלה',
    Background: 'רקע',
    Text: 'טקסט',
    Top: 'עליון',
    Middle: 'מרכז',
    Bottom: 'תחתון',
    'Insert column before': 'הכנס עמודה לפני',
    'Insert column after': 'הכנס עמודה אחרי',
    'Insert row above': 'הכנס שורה מעל',
    'Insert row below': 'הכנס שורה מתחת',
    'Delete table': 'מחק טבלה',
    'Delete row': 'מחק שורה',
    'Delete column': 'מחק עמודה',
    'Empty cell': 'רוקן תא',
    Delete: 'מחק',
    'Strike through': 'קו חוצה',
    Underline: 'קו תחתון',
    Break: 'שבירת שורה',
    'Search for': 'חפש',
    'Replace with': 'החלף ב',
    Replace: 'להחליף',
    Edit: 'ערוך',
    'Vertical align': 'יישור אנכי',
    'Horizontal align': 'יישור אופקי',
    Filter: 'סנן',
    'Sort by changed': 'מין לפי שינוי',
    'Sort by name': 'מיין לפי שם',
    'Sort by size': 'מיין לפי גודל',
    'Add folder': 'הוסף תקייה',
    Split: 'פיצול',
    'Split vertical': 'פיצול אנכי',
    'Split horizontal': 'פיצול אופקי',
    Merge: 'מזג',
    'Add column': 'הוסף עמודה',
    'Add row': 'הוסף שורה',
    Border: 'מסגרת',
    'Embed code': 'הוסף קוד',
    Update: 'עדכן',
    superscript: 'superscript',
    subscript: 'subscript',
    'Cut selection': 'גזור בחירה',
    Paste: 'הדבק',
    'Choose Content to Paste': 'בחר תוכן להדבקה',
    'Chars: %d': 'תווים: %d',
    'Words: %d': 'מילים: %d',
    All: 'הכל',
    'Select %s': 'נבחר: %s',
    'Select all': 'בחר הכל',
    source: 'HTML',
    bold: 'מודגש',
    italic: 'נטוי',
    brush: 'מברשת',
    link: 'קישור',
    undo: 'בטל',
    redo: 'בצע שוב',
    table: 'טבלה',
    image: 'תמונה',
    eraser: 'מחק',
    paragraph: 'פסקה',
    fontsize: 'גודל גופן',
    video: 'וידאו',
    font: 'גופן',
    about: 'עלינו',
    print: 'הדפס',
    underline: 'קו תחתון',
    strikethrough: 'קו חוצה',
    indent: 'הגדל כניסה',
    outdent: 'הקטן כניסה',
    fullsize: 'גודל מלא',
    shrink: 'כווץ',
    hr: 'קו אופקי',
    ul: 'רשימת תבליטים',
    ol: 'רשימה ממוספרת',
    cut: 'חתוך',
    selectall: 'בחר הכל',
    'Open link': 'פתח קישור',
    'Edit link': 'ערוך קישור',
    'No follow': 'ללא מעקב',
    Unlink: 'בטל קישור',
    Eye: 'הצג',
    pencil: 'כדי לערוך',
    ' URL': 'כתובת',
    Reset: 'אפס',
    Save: 'שמור',
    'Save as ...': 'שמור בשם...',
    Resize: 'שנה גודל',
    Crop: 'חתוך',
    Width: 'רוחב',
    Height: 'גובה',
    'Keep Aspect Ratio': 'שמור יחס',
    Yes: 'כן',
    No: 'לא',
    Remove: 'הסר',
    Select: 'בחר',
    'You can only edit your own images. Download this image on the host?': 'רק קבצים המשוייכים שלך ניתנים לעריכה. האם להוריד את הקובץ?',
    'The image has been successfully uploaded to the host!': 'התמונה עלתה בהצלחה!',
    palette: 'לוח',
    'There are no files': 'אין קבצים בספריה זו.',
    Rename: 'הונגרית',
    'Enter new name': 'הזן שם חדש',
    preview: 'תצוגה מקדימה',
    download: 'הורד',
    'Paste from clipboard': 'להדביק מהלוח',
    "Your browser doesn't support direct access to the clipboard.": 'הדפדפן שלך לא תומך גישה ישירה ללוח.',
    'Copy selection': 'העתק בחירה',
    copy: 'העתק',
    'Border radius': 'רדיוס הגבול',
    'Show all': 'הצג את כל',
    Apply: 'החל',
    'Please fill out this field': 'נא למלא שדה זה',
    'Please enter a web address': 'אנא הזן כתובת אינטרנט',
    Default: 'ברירת המחדל',
    Circle: 'מעגל',
    Dot: 'נקודה',
    Quadrate: 'הריבוע הזה',
    Find: 'למצוא',
    'Find Previous': 'מצא את הקודם',
    'Find Next': 'חפש את הבא',
    'Insert className': 'הכנס את שם הכיתה',
    'Press Alt for custom resizing': 'לחץ על אלט לשינוי גודל מותאם אישית'
});


/***/ }),

/***/ 32806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    Spellcheck: 'Rechtschreibprüfung'
});


/***/ }),

/***/ 32824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ar: function() { return /* reexport module object */ _ar_js__WEBPACK_IMPORTED_MODULE_0__; },
/* harmony export */   cs_cz: function() { return /* reexport module object */ _cs_cz_js__WEBPACK_IMPORTED_MODULE_1__; },
/* harmony export */   de: function() { return /* reexport module object */ _de_js__WEBPACK_IMPORTED_MODULE_2__; },
/* harmony export */   es: function() { return /* reexport module object */ _es_js__WEBPACK_IMPORTED_MODULE_3__; },
/* harmony export */   fa: function() { return /* reexport module object */ _fa_js__WEBPACK_IMPORTED_MODULE_4__; },
/* harmony export */   fi: function() { return /* reexport module object */ _fi_js__WEBPACK_IMPORTED_MODULE_5__; },
/* harmony export */   fr: function() { return /* reexport module object */ _fr_js__WEBPACK_IMPORTED_MODULE_6__; },
/* harmony export */   he: function() { return /* reexport module object */ _he_js__WEBPACK_IMPORTED_MODULE_7__; },
/* harmony export */   hu: function() { return /* reexport module object */ _hu_js__WEBPACK_IMPORTED_MODULE_8__; },
/* harmony export */   id: function() { return /* reexport module object */ _id_js__WEBPACK_IMPORTED_MODULE_9__; },
/* harmony export */   it: function() { return /* reexport module object */ _it_js__WEBPACK_IMPORTED_MODULE_10__; },
/* harmony export */   ja: function() { return /* reexport module object */ _ja_js__WEBPACK_IMPORTED_MODULE_11__; },
/* harmony export */   ko: function() { return /* reexport module object */ _ko_js__WEBPACK_IMPORTED_MODULE_12__; },
/* harmony export */   mn: function() { return /* reexport module object */ _mn_js__WEBPACK_IMPORTED_MODULE_13__; },
/* harmony export */   nl: function() { return /* reexport module object */ _nl_js__WEBPACK_IMPORTED_MODULE_14__; },
/* harmony export */   pl: function() { return /* reexport module object */ _pl_js__WEBPACK_IMPORTED_MODULE_15__; },
/* harmony export */   pt_br: function() { return /* reexport module object */ _pt_br_js__WEBPACK_IMPORTED_MODULE_16__; },
/* harmony export */   ru: function() { return /* reexport module object */ _ru_js__WEBPACK_IMPORTED_MODULE_17__; },
/* harmony export */   tr: function() { return /* reexport module object */ _tr_js__WEBPACK_IMPORTED_MODULE_18__; },
/* harmony export */   ua: function() { return /* reexport module object */ _ua_js__WEBPACK_IMPORTED_MODULE_19__; },
/* harmony export */   zh_cn: function() { return /* reexport module object */ _zh_cn_js__WEBPACK_IMPORTED_MODULE_20__; },
/* harmony export */   zh_tw: function() { return /* reexport module object */ _zh_tw_js__WEBPACK_IMPORTED_MODULE_21__; }
/* harmony export */ });
/* harmony import */ var _ar_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20741);
/* harmony import */ var _cs_cz_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3958);
/* harmony import */ var _de_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53437);
/* harmony import */ var _es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56882);
/* harmony import */ var _fa_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75703);
/* harmony import */ var _fi_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49759);
/* harmony import */ var _fr_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44730);
/* harmony import */ var _he_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70945);
/* harmony import */ var _hu_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49841);
/* harmony import */ var _id_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(33295);
/* harmony import */ var _it_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47615);
/* harmony import */ var _ja_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83059);
/* harmony import */ var _ko_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(22396);
/* harmony import */ var _mn_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(58285);
/* harmony import */ var _nl_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(51804);
/* harmony import */ var _pl_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(53650);
/* harmony import */ var _pt_br_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(41369);
/* harmony import */ var _ru_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(57855);
/* harmony import */ var _tr_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(44328);
/* harmony import */ var _ua_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(91080);
/* harmony import */ var _zh_cn_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(89702);
/* harmony import */ var _zh_tw_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(66434);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
























/***/ }),

/***/ 32880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Rc: function() { return /* reexport safe */ _connection_error_js__WEBPACK_IMPORTED_MODULE_1__.R; },
/* harmony export */   ZW: function() { return /* reexport safe */ _options_error_js__WEBPACK_IMPORTED_MODULE_2__.Z; },
/* harmony export */   h2: function() { return /* reexport safe */ _abort_error_js__WEBPACK_IMPORTED_MODULE_0__.h; },
/* harmony export */   rV: function() { return /* reexport safe */ _abort_error_js__WEBPACK_IMPORTED_MODULE_0__.r; }
/* harmony export */ });
/* harmony import */ var _abort_error_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93661);
/* harmony import */ var _connection_error_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86397);
/* harmony import */ var _options_error_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57865);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/utils
 */ 




/***/ }),

/***/ 33281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   c: function() { return /* binding */ selfListeners; }
/* harmony export */ });
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21537);
/* harmony import */ var _core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27613);
/* harmony import */ var _data_provider_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11787);
/* harmony import */ var _fetch_delete_file_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44450);
/* harmony import */ var _fetch_load_items_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30465);
/* harmony import */ var _fetch_load_tree_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20201);
/* harmony import */ var _image_editor_image_editor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50050);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 






/**
 * @private
 */ function selfListeners() {
    const state = this.state, dp = this.dataProvider, self = this;
    self.e.on('view.filebrowser', (view)=>{
        if (view !== state.view) {
            state.view = view;
        }
    }).on('sort.filebrowser', (value)=>{
        if (value !== state.sortBy) {
            state.sortBy = value;
            (0,_fetch_load_items_js__WEBPACK_IMPORTED_MODULE_5__/* .loadItems */ .f)(self);
        }
    }).on('filter.filebrowser', (value)=>{
        if (value !== state.filterWord) {
            state.filterWord = value;
            (0,_fetch_load_items_js__WEBPACK_IMPORTED_MODULE_5__/* .loadItems */ .f)(self);
        }
    }).on('openFolder.filebrowser', (data)=>{
        let path;
        if (data.name === '..') {
            path = data.path.split('/').filter((p)=>p.length).slice(0, -1).join('/');
        } else {
            path = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.normalizePath)(data.path, data.name);
        }
        self.state.currentPath = path;
        self.state.currentSource = data.name === '.' ? _data_provider_js__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_SOURCE_NAME */ .o : data.source;
    }).on('removeFolder.filebrowser', (data)=>{
        self.confirm('Are you sure?', 'Delete', (yes)=>{
            if (yes) {
                dp.folderRemove(data.path, data.name, data.source).then((message)=>{
                    self.status(message, true);
                    return (0,_fetch_load_tree_js__WEBPACK_IMPORTED_MODULE_3__/* .loadTree */ .r)(self);
                }).catch(self.status);
            }
        });
    }).on('renameFolder.filebrowser', (data)=>{
        self.prompt('Enter new name', 'Rename', (newName)=>{
            if (!(0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isValidName */ .uV)(newName)) {
                self.status(self.i18n('Enter new name'));
                return false;
            }
            dp.folderRename(data.path, data.name, newName, data.source).then((message)=>{
                self.state.activeElements = [];
                self.status(message, true);
                return (0,_fetch_load_tree_js__WEBPACK_IMPORTED_MODULE_3__/* .loadTree */ .r)(self);
            }).catch(self.status);
            return;
        }, 'type name', data.name);
    }).on('addFolder.filebrowser', (data)=>{
        self.prompt('Enter Directory name', 'Create directory', (name)=>{
            dp.createFolder(name, data.path, data.source).then(()=>(0,_fetch_load_tree_js__WEBPACK_IMPORTED_MODULE_3__/* .loadTree */ .r)(self)).catch(self.status);
        }, 'type name');
    }).on('fileRemove.filebrowser', ()=>{
        if (self.state.activeElements.length) {
            self.confirm('Are you sure?', '', (yes)=>{
                if (yes) {
                    const promises = [];
                    self.state.activeElements.forEach((item)=>{
                        promises.push((0,_fetch_delete_file_js__WEBPACK_IMPORTED_MODULE_6__/* .deleteFile */ .W)(self, item.file || item.name || '', item.sourceName));
                    });
                    self.state.activeElements = [];
                    Promise.all(promises).then(()=>(0,_fetch_load_tree_js__WEBPACK_IMPORTED_MODULE_3__/* .loadTree */ .r)(self).catch(self.status), self.status);
                }
            });
        }
    }).on('edit.filebrowser', ()=>{
        if (self.state.activeElements.length === 1) {
            const [file] = this.state.activeElements;
            _image_editor_image_editor_js__WEBPACK_IMPORTED_MODULE_4__/* .openImageEditor */ .B.call(self, file.fileURL, file.file || '', file.path, file.sourceName);
        }
    }).on('fileRename.filebrowser', (name, path, source)=>{
        if (self.state.activeElements.length === 1) {
            self.prompt('Enter new name', 'Rename', (newName)=>{
                if (!(0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isValidName */ .uV)(newName)) {
                    self.status(self.i18n('Enter new name'));
                    return false;
                }
                dp.fileRename(path, name, newName, source).then((message)=>{
                    self.state.activeElements = [];
                    self.status(message, true);
                    (0,_fetch_load_items_js__WEBPACK_IMPORTED_MODULE_5__/* .loadItems */ .f)(self);
                }).catch(self.status);
                return;
            }, 'type name', name);
        }
    }).on('update.filebrowser', ()=>{
        (0,_fetch_load_tree_js__WEBPACK_IMPORTED_MODULE_3__/* .loadTree */ .r)(this).then(this.status, this.status);
    });
}


/***/ }),

/***/ 33295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    symbols: 'simbol'
});


/***/ }),

/***/ 33307:
/***/ (function(__unused_webpack_module, __webpack_exports__) {


/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'copy-format': 'Формат хуулах'
});


/***/ }),

/***/ 33433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   OK: function() { return /* binding */ cacheHTML; },
/* harmony export */   PO: function() { return /* binding */ cached; },
/* harmony export */   PP: function() { return /* binding */ cache; }
/* harmony export */ });
/* harmony import */ var _component_statuses_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78213);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82758);
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2748);
/* harmony import */ var _helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27613);
/* harmony import */ var _helpers_utils_error_error_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82760);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 




/**
 * Retrieves a cached property value from an object if it exists; otherwise, returns `null`.
 *
 * This utility is particularly useful when working with properties that are lazily initialized
 * or dynamically created, such as getters or cached computations. It ensures you can safely
 * access the value without triggering initialization or creating a new instance.
 *
 * ### Usage Example:
 * ```typescript
 * import type { IUIElement } from "jodit";
 *
 * const { component, cache, cached } = Jodit.decorators;
 * const { UIElement } = Jodit.modules;
 *
 * @component
 * class SomeComponent extends UIElement {
 *   @cache
 *   get someElement(): IUIElement {
 *     return new UIElement(this.jodit);
 *   }
 *
 *   destruct() {
 *     // Use the cached utility to clean up only if the property is initialized
 *     cached(this, 'someElement')?.destruct();
 *     super.destruct();
 *   }
 * }
 * ```
 *
 * @param object - The object containing the property to check.
 * @param property - The name of the property to retrieve from the cache.
 * @returns The cached value of the property if it exists; otherwise, `null`.
 *
 * ### Notes:
 * - If the property is defined as a getter, the function will return `null`
 *   instead of invoking the getter.
 * - This function is non-destructive and does not alter the object's state.
 */ function cached(object, property) {
    const descriptor = Object.getOwnPropertyDescriptor(object, property);
    if (!descriptor || (0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_3__/* .isFunction */ .Tn)(descriptor.get)) {
        return null;
    }
    return descriptor.value;
}
/**
 * A decorator that caches the result of a getter method. Once the getter is accessed for the first time,
 * its computed value is stored as a property of the object. Subsequent accesses return the cached value
 * without recalculating it, improving performance and avoiding redundant computations.
 *
 * ### Key Features:
 * - **Lazy Initialization**: The original getter is invoked only once, the first time the property is accessed.
 * - **Immutability**: After caching, the value is stored as a non-writable, non-configurable property, preventing accidental modifications.
 * - **Conditional Caching**: If the returned value has a property `noCache` set to `true`, the caching mechanism is bypassed, and the getter is invoked each time.
 *
 * ### Usage Example 1: Basic Caching
 * ```typescript
 * import { cache } from './decorators';
 *
 * class Example {
 *   private counter = 0;
 *
 *   @cache
 *   get expensiveComputation(): number {
 *     console.log('Calculating...');
 *     return ++this.counter;
 *   }
 * }
 *
 * const instance = new Example();
 * console.log(instance.expensiveComputation); // Logs "Calculating..." and returns 1
 * console.log(instance.expensiveComputation); // Returns 1 (cached value, no calculation)
 * ```
 *
 * ### Usage Example 2: Integration with Cached Utilities
 * ```typescript
 * import { cache, cached } from './decorators';
 * import type { IUIElement } from "jodit";
 *
 * const { component } = Jodit.decorators;
 * const { UIElement } = Jodit.modules;
 *
 * @component
 * class SomeComponent extends UIElement {
 *   @cache
 *   get someElement(): IUIElement {
 *     return new UIElement(this.jodit);
 *   }
 *
 *   destruct() {
 *     // Use the cached utility to clean up only if the property is initialized
 *     cached(this, 'someElement')?.destruct();
 *     super.destruct();
 *   }
 * }
 * ```
 *
 * @param _ - The target object (not used directly).
 * @param name - The name of the property to decorate.
 * @param descriptor - The property descriptor, which must include a getter method.
 * @throws Will throw an error if the descriptor does not include a getter.
 *
 * ### Notes:
 * - **Performance**: Ideal for properties that are computationally expensive and do not change after the initial computation.
 * - **Flexibility**: Supports conditional caching via the `noCache` property in the returned value.
 * - **Compatibility**: Designed to work seamlessly with objects and classes in TypeScript or JavaScript.
 */ function cache(_, name, descriptor) {
    const getter = descriptor.get;
    if (!getter) {
        throw (0,_helpers_utils_error_error_js__WEBPACK_IMPORTED_MODULE_4__/* .error */ .z3)('Getter property descriptor expected');
    }
    descriptor.get = function() {
        if (!_constants_js__WEBPACK_IMPORTED_MODULE_1__.IS_PROD) {
            if (this.isInDestruct) {
                console.error('Trying to access property in destructed component');
            }
        }
        const value = getter.call(this);
        if (value && value.noCache === true) {
            return value;
        }
        Object.defineProperty(this, name, {
            configurable: descriptor.configurable,
            enumerable: descriptor.enumerable,
            writable: false,
            value
        });
        return value;
    };
}
function cacheHTML(target, _, descriptor) {
    const fn = descriptor.value;
    if (!(0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_3__/* .isFunction */ .Tn)(fn)) {
        throw (0,_helpers_utils_error_error_js__WEBPACK_IMPORTED_MODULE_4__/* .error */ .z3)('Handler must be a Function');
    }
    let useCache = true;
    const cached = new WeakMap();
    descriptor.value = function(...attrs) {
        var _a;
        if (useCache && cached.has(this.constructor)) {
            return (_a = cached.get(this.constructor)) === null || _a === void 0 ? void 0 : _a.cloneNode(true);
        }
        const value = fn.apply(this, attrs);
        if (useCache && _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isElement(value)) {
            cached.set(this.constructor, value);
        }
        return useCache ? value.cloneNode(true) : value;
    };
    target.hookStatus(_component_statuses_js__WEBPACK_IMPORTED_MODULE_0__/* .STATUSES */ .f.ready, (component)=>{
        const view = (0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_3__/* .isViewObject */ .hH)(component) ? component : component.jodit;
        useCache = Boolean(view.options.cache);
    });
}


/***/ }),

/***/ 33489:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M512 1248v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm1280 512v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68zm-1280-1024v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm1280 512v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68z\"/> </svg> ");


/***/ }),

/***/ 33561:
/***/ (function(__unused_webpack_module, __webpack_exports__) {


/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'copy-format': 'Copia il formato'
});


/***/ }),

/***/ 33651:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1728 576v256q0 26-19 45t-45 19h-64q-26 0-45-19t-19-45v-256q0-106-75-181t-181-75-181 75-75 181v192h96q40 0 68 28t28 68v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h672v-192q0-185 131.5-316.5t316.5-131.5 316.5 131.5 131.5 316.5z\"/> </svg> ");


/***/ }),

/***/ 34013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ JoditPro; }
/* harmony export */ });
/* harmony import */ var jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var jodit_esm_core_helpers_utils_append_script__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63799);
/* harmony import */ var jodit_esm_core_helpers_utils_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41180);
/* harmony import */ var jodit_esm_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86019);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65917);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */
// eslint-disable-next-line simple-import-sort/imports






class JoditPro extends jodit_esm_index__WEBPACK_IMPORTED_MODULE_2__/* .Jodit */ .x {
    beforeInitHook() {
        if (jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_0__.IS_PROD && !jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_0__.IS_TEST && this.o.loadExternalConfig) {
            return (0,jodit_esm_core_helpers_utils_append_script__WEBPACK_IMPORTED_MODULE_1__/* .appendScriptAsync */ .w4)(this, this.basePath + 'config.js');
        }
        return;
    }
    afterInitHook() {
        (async () => {
            if ((await this.e.fire('checkReserve', location.host)) !== 'normal') {
                if (this.isInDestruct) {
                    return;
                }
                const message = 'Trial version. Buy <a href="https://xdsoft.net/jodit/pro/">Jodit Pro</a>';
                const pro = this.c.div('', message);
                if (!jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_0__.IS_TEST && jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_0__.IS_PROD) {
                    console.error(message);
                }
                (0,jodit_esm_core_helpers_utils_css__WEBPACK_IMPORTED_MODULE_4__/* .css */ .A)(pro, {
                    position: 'absolute',
                    color: 'red',
                    right: 10,
                    bottom: 10
                });
                this.addDisclaimer(pro);
            }
        })().catch(() => null);
        super.afterInitHook();
    }
    /** @override */
    getVersion() {
        return 'PRO ' + jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_0__.APP_VERSION;
    }
}


/***/ }),

/***/ 34176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K: function() { return /* binding */ Mods; }
/* harmony export */ });
/* harmony import */ var _helpers_checker_is_void_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86068);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
class Mods {
    afterSetMod(name, value) {}
    /**
     * Set/remove BEM class modification
     *
     * @param value - if null, mod will be removed
     */ setMod(name, value, container) {
        name = name.toLowerCase();
        const oldValue = this.mods[name];
        if (oldValue === value) {
            return this;
        }
        const mod = `${this.componentName}_${name}_`, cl = (container || this.container).classList;
        if (oldValue != null) {
            cl.remove(`${mod}${oldValue.toString().toLowerCase()}`);
        }
        !(0,_helpers_checker_is_void_js__WEBPACK_IMPORTED_MODULE_0__/* .isVoid */ .R)(value) && value !== '' && cl.add(`${mod}${value.toString().toLowerCase()}`);
        this.mods[name] = value;
        this.afterSetMod(name, value);
        return this;
    }
    /**
     * Get BEM class modification value
     */ getMod(name) {
        var _a;
        return (_a = this.mods[name]) !== null && _a !== void 0 ? _a : null;
    }
}


/***/ }),

/***/ 34244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   b: function() { return /* binding */ UISpacer; }
/* harmony export */ });
/* harmony import */ var _decorators_component_component_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87325);
/* harmony import */ var _element_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48538);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * @module ui/group
 */ 

let UISpacer = class UISpacer extends _element_js__WEBPACK_IMPORTED_MODULE_0__/* .UIElement */ .D {
    className() {
        return 'UISpacer';
    }
};
UISpacer = __decorate([
    _decorators_component_component_js__WEBPACK_IMPORTED_MODULE_1__/* .component */ .s
], UISpacer);



/***/ }),

/***/ 34755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   j: function() { return /* binding */ applyValuesToImage; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43555);
/* harmony import */ var _link_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29615);
/* harmony import */ var _margin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14721);
/* harmony import */ var _size_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87602);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 




/**
 * Apply form's values to image
 * @private
 */ function applyValuesToImage(j, state, image) {
    const { style, imageSrc, borderRadius, imageTitle, imageAlt, imageLink, imageWidth, imageHeight, marginTop, marginRight, marginBottom, marginLeft, imageLinkOpenInNewTab, align, classes, id } = state.values;
    const opt = j.o;
    // styles
    if (opt.image.editStyle) {
        (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .CF)(image, 'style', style || null);
    }
    // Src
    if (imageSrc) {
        (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .CF)(image, 'src', imageSrc);
    } else {
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(image);
        return;
    }
    // Border radius
    image.style.borderRadius = borderRadius ? borderRadius + 'px' : '';
    // Title
    (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .CF)(image, 'title', imageTitle || null);
    // Alt
    (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .CF)(image, 'alt', imageAlt || null);
    // Link
    (0,_link_js__WEBPACK_IMPORTED_MODULE_2__/* .applyLink */ .j)(j, image, imageLink, imageLinkOpenInNewTab);
    // Size
    (0,_size_js__WEBPACK_IMPORTED_MODULE_4__/* .applySize */ .q)(image, imageWidth, imageHeight, state.sizeIsLocked);
    // Margin
    if (j.o.image.editMargins) {
        (0,_margin_js__WEBPACK_IMPORTED_MODULE_3__/* .applyMargin */ .N)(j, marginTop, marginRight, marginBottom, marginLeft, image, state.marginIsLocked);
    }
    if (opt.image.editClass) {
        (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .CF)(image, 'class', classes || null);
    }
    if (opt.image.editId) {
        (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .CF)(image, 'id', id || null);
    }
    if (opt.image.editAlign) {
        (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .hAlignElement */ .Mr)(image, align);
    }
}


/***/ }),

/***/ 34793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   k: function() { return /* binding */ FileSelectorWidget; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21537);
/* harmony import */ var _core_ui_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67510);
/* harmony import */ var _tabs_tabs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38927);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



/**
 * Generate 3 tabs
 * upload - Use Drag and Drop
 * url - By specifying the image url
 * filebrowser - After opening the file browser. In the absence of one of the parameters will be less tabs
 *
 * @param callbacks - Object with keys `url`, `upload` and `filebrowser`, values which are callback
 * functions with different parameters
 */ const FileSelectorWidget = (editor, callbacks, elm, close, isImage = true)=>{
    let currentImage;
    const tabs = [];
    if (callbacks.upload && editor.o.uploader && (editor.o.uploader.url || editor.o.uploader.insertImageAsBase64URI)) {
        const dragBox = editor.c.fromHTML('<div class="jodit-drag-and-drop__file-box">' + `<strong>${editor.i18n(isImage ? 'Drop image' : 'Drop file')}</strong>` + `<span><br>${editor.i18n('or click')}</span>` + `<input type="file" accept="${isImage ? 'image/*' : '*'}" tabindex="-1" dir="auto" multiple=""/>` + '</div>');
        editor.uploader.bind(dragBox, (resp)=>{
            const handler = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.isFunction)(callbacks.upload) ? callbacks.upload : editor.o.uploader.defaultHandlerSuccess;
            if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.isFunction)(handler)) {
                handler.call(editor, resp);
            }
            editor.e.fire('closeAllPopups');
        }, (error)=>{
            editor.message.error(error.message);
            editor.e.fire('closeAllPopups');
        });
        tabs.push({
            icon: 'upload',
            name: 'Upload',
            content: dragBox
        });
    }
    if (callbacks.filebrowser) {
        if (editor.o.filebrowser.ajax.url || editor.o.filebrowser.items.url) {
            tabs.push({
                icon: 'folder',
                name: 'Browse',
                content: ()=>{
                    close && close();
                    if (callbacks.filebrowser) {
                        editor.filebrowser.open(callbacks.filebrowser, isImage);
                    }
                }
            });
        }
    }
    if (callbacks.url) {
        const button = new _core_ui_index_js__WEBPACK_IMPORTED_MODULE_2__/* .UIButton */ .lD(editor, {
            type: 'submit',
            variant: 'primary',
            text: 'Insert'
        }), form = new _core_ui_index_js__WEBPACK_IMPORTED_MODULE_2__/* .UIForm */ .XV(editor, [
            new _core_ui_index_js__WEBPACK_IMPORTED_MODULE_2__/* .UIInput */ .tS(editor, {
                required: true,
                label: 'URL',
                name: 'url',
                type: 'text',
                placeholder: 'https://'
            }),
            new _core_ui_index_js__WEBPACK_IMPORTED_MODULE_2__/* .UIInput */ .tS(editor, {
                name: 'text',
                label: 'Alternative text'
            }),
            new _core_ui_index_js__WEBPACK_IMPORTED_MODULE_2__/* .UIBlock */ .Yh(editor, [
                button
            ])
        ]);
        currentImage = null;
        if (elm && !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isText(elm) && !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isComment(elm) && (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(elm, 'img') || (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.$$)('img', elm).length)) {
            currentImage = elm.tagName === 'IMG' ? elm : (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.$$)('img', elm)[0];
            val(form.container, 'input[name=url]', (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.attr)(currentImage, 'src'));
            val(form.container, 'input[name=text]', (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.attr)(currentImage, 'alt'));
            button.state.text = 'Update';
        }
        if (elm && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(elm, 'a')) {
            val(form.container, 'input[name=url]', (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.attr)(elm, 'href'));
            val(form.container, 'input[name=text]', (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.attr)(elm, 'title'));
            button.state.text = 'Update';
        }
        form.onSubmit((data)=>{
            if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.isFunction)(callbacks.url)) {
                callbacks.url.call(editor, data.url, data.text);
            }
        });
        tabs.push({
            icon: 'link',
            name: 'URL',
            content: form.container
        });
    }
    return (0,_tabs_tabs_js__WEBPACK_IMPORTED_MODULE_3__/* .TabsWidget */ .Z)(editor, tabs);
};
function val(elm, selector, value) {
    const child = elm.querySelector(selector);
    if (!child) {
        return '';
    }
    if (value) {
        child.value = value;
    }
    return child.value;
}


/***/ }),

/***/ 34945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    newline: 'Zeilenumbruch',
    delete: 'löschen',
    space: 'Raum',
    'Speech Recognize': 'Sprache Erkennen',
    Sound: 'Sound',
    'Interim Results': 'Zwischenergebnis'
});


/***/ }),

/***/ 35105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   k: function() { return /* binding */ UIImageMainTab; }
/* harmony export */ });
/* harmony import */ var _core_decorators_component_component_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87325);
/* harmony import */ var _core_decorators_hook_hook_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97357);
/* harmony import */ var _core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37133);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21537);
/* harmony import */ var _core_ui_group_group_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62405);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





/** @private */ let UIImageMainTab = class UIImageMainTab extends _core_ui_group_group_js__WEBPACK_IMPORTED_MODULE_3__/* .UIGroup */ .U {
    className() {
        return 'UIImageMainTab';
    }
    appendChildToContainer() {
    // Do nothing
    }
    render() {
        return `<div class="jodit-form__group &__editSrc">
			<label>~Src~</label>
			<div class="jodit-input_group">
				<input class="jodit-input &__imageSrc" type="text"/>
				<div class="jodit-input_group-buttons &__fixImage">
						<a class="jodit-button &__changeImage">*image*</a>
						<a class="jodit-button &__editImage">*crop*</a>
				</div>
			</div>
		</div>
		<div class="jodit-form__group &__editTitle">
			<label>~Title~</label>
			<input type="text" class="jodit-input &__imageTitle"/>
		</div>
		<div class="jodit-form__group &__editAlt">
			<label>~Alternative~</label>
			<input type="text" class="jodit-input &__imageAlt"/>
		</div>
		<div class="jodit-form__group &__editLink">
			<label>~Link~</label>
			<input type="text" class="jodit-input &__imageLink"/>
		</div>
		<div class="jodit-form__group &__editLinkTarget">
			<label class="jodit_vertical_middle">
				<input type="checkbox" class="jodit-checkbox &__imageLinkOpenInNewTab"/>
				<span>~Open link in new tab~</span>
			</label>
		</div>`;
    }
    async onStateImageSrcChange() {
        const imageSrc = this.getElm('imageSrc');
        imageSrc.value = this.state.values.imageSrc;
    }
    onImageSrcChange() {
        this.state.values.imageSrc = this.getElm('imageSrc').value;
    }
    /**
     * Open image editor
     */ onEditImageClick(e) {
        this.handlers.openImageEditor();
        e.stopPropagation();
    }
    /**
     * Open popup with filebrowser/uploader buttons for image
     */ onChangeImageClick(e) {
        this.handlers.openImagePopup(this.getElm('changeImage'));
        e.stopPropagation();
    }
    onStateTitleChange() {
        const title = this.getElm('imageTitle');
        title.value = this.state.values.imageTitle;
    }
    onTitleChange() {
        this.state.values.imageTitle = this.getElm('imageTitle').value;
    }
    onStateAltChange() {
        const alt = this.getElm('imageAlt');
        alt.value = this.state.values.imageAlt;
    }
    onAltChange() {
        this.state.values.imageAlt = this.getElm('imageAlt').value;
    }
    onStateImageLinkChange() {
        const imageLink = this.getElm('imageLink');
        imageLink.value = this.state.values.imageLink;
    }
    onImageLinkChange() {
        this.state.values.imageLink = this.getElm('imageLink').value;
    }
    onStateImageLinkOpenInNewTabChange() {
        const imageLinkOpenInNewTab = this.getElm('imageLinkOpenInNewTab');
        imageLinkOpenInNewTab.checked = this.state.values.imageLinkOpenInNewTab;
    }
    onImageLinkOpenInNewTabChange() {
        this.state.values.imageLinkOpenInNewTab = this.getElm('imageLinkOpenInNewTab').checked;
    }
    hideFieldByOptions() {
        const o = this.j.o;
        const opt = o.image;
        [
            [
                'editSrc',
                'editSrc'
            ],
            [
                'editTitle',
                'editTitle'
            ],
            [
                'editAlt',
                'editAlt'
            ],
            [
                'editLink',
                'editLink'
            ],
            [
                'editLink',
                'editLinkTarget'
            ],
            [
                'useImageEditor',
                'editImage'
            ]
        ].forEach(([optKey, elmKey])=>{
            const elm = this.getElm(elmKey);
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.css)(elm, 'display', opt[optKey] ? null : 'none');
        });
        const changeImage = this.getElm('changeImage');
        const needShowChangeImage = Boolean(o.filebrowser.ajax.url || o.uploader.url);
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.css)(changeImage, 'display', needShowChangeImage ? null : 'none');
        const editImage = this.getElm('editImage');
        const needShowEditImage = Boolean(o.filebrowser.ajax.url) && opt.useImageEditor;
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.css)(editImage, 'display', needShowEditImage ? null : 'none');
        const fixImage = this.getElm('fixImage');
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.css)(fixImage, 'display', needShowChangeImage || needShowEditImage ? null : 'none');
    }
    constructor(view, state, handlers){
        super(view);
        this.state = state;
        this.handlers = handlers;
    }
};
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)('state.values.imageSrc')
], UIImageMainTab.prototype, "onStateImageSrcChange", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)('imageSrc:change')
], UIImageMainTab.prototype, "onImageSrcChange", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)('editImage:click')
], UIImageMainTab.prototype, "onEditImageClick", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)('changeImage:click')
], UIImageMainTab.prototype, "onChangeImageClick", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)('state.values.imageTitle')
], UIImageMainTab.prototype, "onStateTitleChange", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)('imageTitle:change')
], UIImageMainTab.prototype, "onTitleChange", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)('state.values.imageAlt')
], UIImageMainTab.prototype, "onStateAltChange", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)('imageAlt:change')
], UIImageMainTab.prototype, "onAltChange", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)('state.values.imageLink')
], UIImageMainTab.prototype, "onStateImageLinkChange", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)('imageLink:change')
], UIImageMainTab.prototype, "onImageLinkChange", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)('state.values.imageLinkOpenInNewTab')
], UIImageMainTab.prototype, "onStateImageLinkOpenInNewTabChange", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)('imageLinkOpenInNewTab:change')
], UIImageMainTab.prototype, "onImageLinkOpenInNewTabChange", null);
__decorate([
    (0,_core_decorators_hook_hook_js__WEBPACK_IMPORTED_MODULE_0__/* .hook */ .A)('ready')
], UIImageMainTab.prototype, "hideFieldByOptions", null);
UIImageMainTab = __decorate([
    _core_decorators_component_component_js__WEBPACK_IMPORTED_MODULE_4__/* .component */ .s
], UIImageMainTab);



/***/ }),

/***/ 35140:
/***/ (function(__unused_webpack_module, __webpack_exports__) {


/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'copy-format': 'Format de copie'
});


/***/ }),

/***/ 35278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   s: function() { return /* binding */ colorToHex; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/color
 */ /**
 * Converts rgba text representation of color in hex
 *
 * @param color - string like rgba(red, green, blue, alpha) or rgb(red, green, blue)
 * @returns hex color view, NaN - for transparent color
 * @example
 * ```javascript
 * var p = document.createElement('p');
 * p.style.color = '#ffffff';
 * console.log(p.getAttribute('style')); // color: rgb(255, 255, 255);
 * console.log(colorTohex(p.style.color)); // #ffffff
 * ```
 */ const colorToHex = (color)=>{
    if (color === 'rgba(0, 0, 0, 0)' || color === '') {
        return false;
    }
    if (!color) {
        return '#000000';
    }
    if (color.substr(0, 1) === '#') {
        return color;
    }
    const digits = /([\s\n\t\r]*?)rgb\((\d+), (\d+), (\d+)\)/.exec(color) || /([\s\n\t\r]*?)rgba\((\d+), (\d+), (\d+), ([\d.]+)\)/.exec(color);
    if (!digits) {
        return '#000000';
    }
    const red = parseInt(digits[2], 10), green = parseInt(digits[3], 10), blue = parseInt(digits[4], 10), rgb = blue | green << 8 | red << 16;
    let hex = rgb.toString(16).toUpperCase();
    while(hex.length < 6){
        hex = '0' + hex;
    }
    return digits[1] + '#' + hex;
};


/***/ }),

/***/ 35399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C1: function() { return /* reexport safe */ _wrap_text_js__WEBPACK_IMPORTED_MODULE_8__.C; },
/* harmony export */   Dk: function() { return /* reexport safe */ _get_block_wrapper_js__WEBPACK_IMPORTED_MODULE_2__.D; },
/* harmony export */   HS: function() { return /* reexport safe */ _split_fragment_js__WEBPACK_IMPORTED_MODULE_7__.H; },
/* harmony export */   Mt: function() { return /* reexport safe */ _move_cursor_out_from_specal_tags_js__WEBPACK_IMPORTED_MODULE_5__.M; },
/* harmony export */   bD: function() { return /* reexport safe */ _check_unsplittable_box_js__WEBPACK_IMPORTED_MODULE_1__.b; },
/* harmony export */   cf: function() { return /* reexport safe */ _process_empty_li_leaf_js__WEBPACK_IMPORTED_MODULE_6__.c; },
/* harmony export */   lN: function() { return /* reexport safe */ _check_br_js__WEBPACK_IMPORTED_MODULE_0__.l; },
/* harmony export */   tX: function() { return /* reexport safe */ _has_previous_block_js__WEBPACK_IMPORTED_MODULE_3__.t; },
/* harmony export */   yh: function() { return /* reexport safe */ _insert_paragraph_js__WEBPACK_IMPORTED_MODULE_4__.y; }
/* harmony export */ });
/* harmony import */ var _check_br_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41872);
/* harmony import */ var _check_unsplittable_box_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61991);
/* harmony import */ var _get_block_wrapper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54041);
/* harmony import */ var _has_previous_block_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19057);
/* harmony import */ var _insert_paragraph_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44245);
/* harmony import */ var _move_cursor_out_from_specal_tags_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91388);
/* harmony import */ var _process_empty_li_leaf_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65181);
/* harmony import */ var _split_fragment_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54600);
/* harmony import */ var _wrap_text_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5287);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/enter
 */ 










/***/ }),

/***/ 35599:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M553 1399l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23t-10 23l-393 393 393 393q10 10 10 23t-10 23zm591-1067l-373 1291q-4 13-15.5 19.5t-23.5 2.5l-62-17q-13-4-19.5-15.5t-2.5-24.5l373-1291q4-13 15.5-19.5t23.5-2.5l62 17q13 4 19.5 15.5t2.5 24.5zm657 651l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23t-10 23z\"/> </svg> ");


/***/ }),

/***/ 35608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   S: function() { return /* binding */ View; }
/* harmony export */ });
/* harmony import */ var _component_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91907);
/* harmony import */ var _component_component_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4012);
/* harmony import */ var _component_statuses_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78213);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82758);
/* harmony import */ var _create_create_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20218);
/* harmony import */ var _decorators_cache_cache_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33433);
/* harmony import */ var _decorators_derive_derive_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(55153);
/* harmony import */ var _decorators_hook_hook_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97357);
/* harmony import */ var _dom_index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22732);
/* harmony import */ var _event_emitter_index_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3827);
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(580);
/* harmony import */ var _helpers_index_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(21537);
/* harmony import */ var _storage_storage_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6700);
/* harmony import */ var _traits_elms_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14316);
/* harmony import */ var _traits_mods_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(34176);
/* harmony import */ var _ui_progress_bar_progress_bar_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(23769);
/* harmony import */ var _modules_messages_messages_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(1808);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var View_1;

















let View = View_1 = class View extends _component_component_js__WEBPACK_IMPORTED_MODULE_1__/* .Component */ .u {
    /**
     * Get a path for loading extra staff
     */ get basePath() {
        if (this.o.basePath) {
            return this.o.basePath;
        }
        return _constants_js__WEBPACK_IMPORTED_MODULE_3__.BASE_PATH;
    }
    /**
     * Plugin autoloader should load minified version of the file
     */ get minified() {
        if (this.o.minified !== undefined) {
            return this.o.minified;
        }
        return _constants_js__WEBPACK_IMPORTED_MODULE_3__.BASE_PATH_IS_MIN;
    }
    /**
     * Return a default timeout period in milliseconds for some debounce or throttle functions.
     * By default, `{history.timeout}` options
     */ get defaultTimeout() {
        return (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_10__.isVoid)(this.o.defaultTimeout) ? 100 : this.o.defaultTimeout;
    }
    /**
     * Some extra data inside editor
     * @see copyformat plugin
     */ get buffer() {
        return _storage_storage_js__WEBPACK_IMPORTED_MODULE_11__/* .Storage */ .w.makeStorage();
    }
    get message() {
        return this.getMessageModule(this.container);
    }
    getMessageModule(container) {
        return new _modules_messages_messages_js__WEBPACK_IMPORTED_MODULE_14__/* .UIMessages */ .N(this, container);
    }
    /**
     * Container for persistent set/get value
     */ get storage() {
        return _storage_storage_js__WEBPACK_IMPORTED_MODULE_11__/* .Storage */ .w.makeStorage(true, this.id);
    }
    /**
     * Short alias for `create`
     */ get c() {
        return this.create;
    }
    get container() {
        return this.__container;
    }
    set container(container) {
        this.__container = container;
    }
    /**
     * Short alias for `events`
     */ get e() {
        return this.events;
    }
    /**
     * progress_bar Progress bar
     */ get progressbar() {
        return new _ui_progress_bar_progress_bar_js__WEBPACK_IMPORTED_MODULE_13__/* .ProgressBar */ .z(this);
    }
    get options() {
        return this.__options;
    }
    set options(options) {
        this.__options = options;
    }
    /**
     * Short alias for options
     */ get o() {
        return this.options;
    }
    /**
     * Internationalization method. Uses Jodit.lang object
     */ i18n(text, ...params) {
        return (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_10__.i18n)(text, params, this.options);
    }
    toggleFullSize(isFullSize) {
        if (isFullSize === undefined) {
            isFullSize = !this.__isFullSize;
        }
        if (isFullSize === this.__isFullSize) {
            return;
        }
        this.__isFullSize = isFullSize;
        this.e.fire('toggleFullSize', isFullSize);
    }
    /**
     * View is locked
     */ get isLocked() {
        return this.__whoLocked !== '';
    }
    /**
     * Disable selecting
     */ lock(name = 'any') {
        if (!this.isLocked) {
            this.__whoLocked = name;
            return true;
        }
        return false;
    }
    /**
     * Enable selecting
     */ unlock() {
        if (this.isLocked) {
            this.__whoLocked = '';
            return true;
        }
        return false;
    }
    /**
     * View is in fullSize
     */ get isFullSize() {
        return this.__isFullSize;
    }
    /**
     * Return current version
     */ getVersion() {
        return View_1.version;
    }
    static getVersion() {
        return View_1.version;
    }
    /** @override */ initOptions(options) {
        this.options = (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_10__.ConfigProto)(options || {}, (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_10__.ConfigProto)(this.options || {}, View_1.defaultOptions));
    }
    /**
     * Can change ownerWindow here
     */ initOwners() {
        var _a;
        this.ownerWindow = (_a = this.o.ownerWindow) !== null && _a !== void 0 ? _a : window;
    }
    /**
     * Add option's event handlers in emitter
     */ attachEvents(options) {
        if (!options) {
            return;
        }
        const e = options === null || options === void 0 ? void 0 : options.events;
        e && Object.keys(e).forEach((key)=>this.e.on(key, e[key]));
    }
    getInstance(moduleNameOrConstructor, options) {
        const moduleName = (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_10__.isFunction)(moduleNameOrConstructor) ? moduleNameOrConstructor.prototype.className() : moduleNameOrConstructor;
        const instance = this.e.fire((0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_10__.camelCase)('getInstance_' + moduleName), options);
        if (instance) {
            return instance;
        }
        const module = (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_10__.isFunction)(moduleNameOrConstructor) ? moduleNameOrConstructor : _global_js__WEBPACK_IMPORTED_MODULE_9__/* .modules */ .av[moduleName], mi = this.__modulesInstances;
        if (!(0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_10__.isFunction)(module)) {
            throw (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_10__.error)('Need real module name');
        }
        if (!mi.has(moduleName)) {
            const instance = module.prototype instanceof _component_index_js__WEBPACK_IMPORTED_MODULE_0__/* .ViewComponent */ .vG ? new module(this, options) : new module(options);
            this.components.add(instance);
            mi.set(moduleName, instance);
        }
        return mi.get(moduleName);
    }
    /** Add some element to box */ addDisclaimer(elm) {
        this.container.appendChild(elm);
    }
    /**
     * Call before destruct
     */ beforeDestruct() {
        this.e.fire(_component_statuses_js__WEBPACK_IMPORTED_MODULE_2__/* .STATUSES */ .f.beforeDestruct, this);
        this.components.forEach((component)=>{
            if ((0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_10__.isDestructable)(component) && !component.isInDestruct) {
                component.destruct();
            }
        });
        this.components.clear();
    }
    /** @override */ destruct() {
        var _a, _b, _c;
        if (this.isDestructed) {
            return;
        }
        (_a = (0,_decorators_cache_cache_js__WEBPACK_IMPORTED_MODULE_5__/* .cached */ .PO)(this, 'progressbar')) === null || _a === void 0 ? void 0 : _a.destruct();
        (_b = (0,_decorators_cache_cache_js__WEBPACK_IMPORTED_MODULE_5__/* .cached */ .PO)(this, 'message')) === null || _b === void 0 ? void 0 : _b.destruct();
        if (this.events) {
            this.events.destruct();
            // @ts-ignore
            this.events = undefined;
        }
        (_c = (0,_decorators_cache_cache_js__WEBPACK_IMPORTED_MODULE_5__/* .cached */ .PO)(this, 'buffer')) === null || _c === void 0 ? void 0 : _c.clear();
        _dom_index_js__WEBPACK_IMPORTED_MODULE_7__/* .Dom */ .J.safeRemove(this.container);
        super.destruct();
    }
    constructor(options, isJodit = false){
        super();
        this.isJodit = isJodit;
        this.isView = true;
        this.parent = null;
        this.mods = {};
        /**
         * All created ViewComponent inside this view
         */ this.components = new Set();
        this.OPTIONS = View_1.defaultOptions;
        this.__isFullSize = false;
        this.__whoLocked = '';
        this.isLockedNotBy = (name)=>this.isLocked && this.__whoLocked !== name;
        this.__modulesInstances = new Map();
        this.id = new Date().getTime().toString();
        this.initOptions(options);
        this.initOwners();
        this.events = new _event_emitter_index_js__WEBPACK_IMPORTED_MODULE_8__/* .EventEmitter */ .bk(this.od);
        this.create = new _create_create_js__WEBPACK_IMPORTED_MODULE_4__/* .Create */ .X(this.od);
        this.container = this.c.div(`jodit ${this.componentName}`);
    }
};
// from webpack.config.ts
View.ES = _constants_js__WEBPACK_IMPORTED_MODULE_3__.ES;
View.version = _constants_js__WEBPACK_IMPORTED_MODULE_3__.APP_VERSION;
View.esNext = _constants_js__WEBPACK_IMPORTED_MODULE_3__.IS_ES_NEXT; // from webpack.config.ts
View.esModern = _constants_js__WEBPACK_IMPORTED_MODULE_3__.IS_ES_MODERN; // from webpack.config.ts
__decorate([
    _decorators_cache_cache_js__WEBPACK_IMPORTED_MODULE_5__/* .cache */ .PP
], View.prototype, "buffer", null);
__decorate([
    _decorators_cache_cache_js__WEBPACK_IMPORTED_MODULE_5__/* .cache */ .PP
], View.prototype, "message", null);
__decorate([
    _decorators_cache_cache_js__WEBPACK_IMPORTED_MODULE_5__/* .cache */ .PP
], View.prototype, "storage", null);
__decorate([
    _decorators_cache_cache_js__WEBPACK_IMPORTED_MODULE_5__/* .cache */ .PP
], View.prototype, "c", null);
__decorate([
    _decorators_cache_cache_js__WEBPACK_IMPORTED_MODULE_5__/* .cache */ .PP
], View.prototype, "e", null);
__decorate([
    _decorators_cache_cache_js__WEBPACK_IMPORTED_MODULE_5__/* .cache */ .PP
], View.prototype, "progressbar", null);
__decorate([
    (0,_decorators_hook_hook_js__WEBPACK_IMPORTED_MODULE_6__/* .hook */ .A)(_component_statuses_js__WEBPACK_IMPORTED_MODULE_2__/* .STATUSES */ .f.beforeDestruct)
], View.prototype, "beforeDestruct", null);
View = View_1 = __decorate([
    (0,_decorators_derive_derive_js__WEBPACK_IMPORTED_MODULE_15__/* .derive */ .C)(_traits_mods_js__WEBPACK_IMPORTED_MODULE_16__/* .Mods */ .K, _traits_elms_js__WEBPACK_IMPORTED_MODULE_12__/* .Elms */ .O)
], View);

View.defaultOptions = {
    extraButtons: [],
    cache: true,
    textIcons: false,
    namespace: '',
    removeButtons: [],
    zIndex: 100002,
    defaultTimeout: 100,
    fullsize: false,
    showTooltip: true,
    useNativeTooltip: false,
    buttons: [],
    globalFullSize: true,
    language: 'auto'
};


/***/ }),

/***/ 36125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export search */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22732);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21537);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50911);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55099);
/* harmony import */ var _helpers_index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55611);
/* harmony import */ var _ui_search_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92278);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









/**
 * Search plugin. it is used for custom search in text
 * ![search](https://user-images.githubusercontent.com/794318/34545433-cd0a9220-f10e-11e7-8d26-7e22f66e266d.gif)
 *
 * @example
 * ```typescript
 * const jodit = Jodit.make('#editor', {
 *  useSearch: false
 * });
 * // or
 * const jodit = Jodit.make('#editor', {
 *  disablePlugins: 'search'
 * });
 * ```
 */ class search extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_5__/* .Plugin */ .k {
    get ui() {
        return new _ui_search_js__WEBPACK_IMPORTED_MODULE_8__/* .UISearch */ .F(this.j);
    }
    async updateCounters() {
        if (!this.ui.isOpened) {
            return;
        }
        this.ui.count = await this.calcCounts(this.ui.query);
    }
    onPressReplaceButton() {
        this.findAndReplace(this.ui.query);
        this.updateCounters();
    }
    tryScrollToElement(startContainer) {
        // find scrollable element
        let parentBox = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.closest(startContainer, _core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isElement, this.j.editor);
        if (!parentBox) {
            parentBox = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.prev(startContainer, _core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isElement, this.j.editor);
        }
        parentBox && parentBox !== this.j.editor && (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.scrollIntoViewIfNeeded)(parentBox, this.j.editor, this.j.ed);
    }
    async calcCounts(query) {
        return (await this.findQueryBounds(query, 'walkerCount')).length;
    }
    async findQueryBounds(query, walkerKey) {
        let walker = this[walkerKey];
        if (walker) {
            walker.break();
        }
        walker = new _core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__/* .LazyWalker */ .p(this.j.async, {
            timeout: this.j.o.search.lazyIdleTimeout
        });
        this[walkerKey] = walker;
        return this.find(walker, query).catch((e)=>{
            !_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD && console.error(e);
            return [];
        });
    }
    async findAndReplace(query) {
        const bounds = await this.findQueryBounds(query, 'walker');
        if (!bounds.length) {
            return false;
        }
        let currentIndex = this.findCurrentIndexInRanges(bounds, this.j.s.range);
        if (currentIndex === -1) {
            currentIndex = 0;
        }
        const bound = bounds[currentIndex];
        if (bound) {
            try {
                const rng = this.j.ed.createRange();
                rng.setStart(bound.startContainer, bound.startOffset);
                rng.setEnd(bound.endContainer, bound.endOffset);
                rng.deleteContents();
                const textNode = this.j.createInside.text(this.ui.replace);
                _core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeInsertNode(rng, textNode);
                (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_7__/* .clearSelectionWrappers */ .IJ)(this.j);
                this.j.s.setCursorAfter(textNode);
                this.tryScrollToElement(textNode);
                this.cache = {};
                this.ui.currentIndex = currentIndex;
                await this.findAndSelect(query, true).catch((e)=>{
                    !_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD && console.error(e);
                    return null;
                });
            } finally{
                this.j.synchronizeValues();
            }
            this.j.e.fire('afterFindAndReplace');
            return true;
        }
        return false;
    }
    async findAndSelect(query, next) {
        var _a;
        const bounds = await this.findQueryBounds(query, 'walker');
        if (!bounds.length) {
            return false;
        }
        if (this.previousQuery !== query || !(0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_7__/* .getSelectionWrappers */ .zy)(this.j.editor).length) {
            (_a = this.drawPromise) === null || _a === void 0 ? void 0 : _a.rejectCallback();
            this.j.async.cancelAnimationFrame(this.wrapFrameRequest);
            (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_7__/* .clearSelectionWrappers */ .IJ)(this.j);
            this.drawPromise = this.__drawSelectionRanges(bounds);
        }
        this.previousQuery = query;
        let currentIndex = this.ui.currentIndex - 1;
        if (currentIndex === -1) {
            currentIndex = 0;
        } else if (next) {
            currentIndex = currentIndex === bounds.length - 1 ? 0 : currentIndex + 1;
        } else {
            currentIndex = currentIndex === 0 ? bounds.length - 1 : currentIndex - 1;
        }
        this.ui.currentIndex = currentIndex + 1;
        const bound = bounds[currentIndex];
        if (bound) {
            const rng = this.j.ed.createRange();
            try {
                rng.setStart(bound.startContainer, bound.startOffset);
                rng.setEnd(bound.endContainer, bound.endOffset);
                this.j.s.selectRange(rng);
            } catch (e) {
                !_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD && console.error(e);
            }
            this.tryScrollToElement(bound.startContainer);
            await this.updateCounters();
            await this.drawPromise;
            this.j.e.fire('afterFindAndSelect');
            return true;
        }
        return false;
    }
    findCurrentIndexInRanges(bounds, range) {
        return bounds.findIndex((bound)=>bound.startContainer === range.startContainer && bound.startOffset === range.startOffset && bound.endContainer === range.startContainer && bound.endOffset === range.endOffset);
    }
    async isValidCache(promise) {
        const res = await promise;
        return res.every((r)=>{
            var _a, _b, _c, _d;
            return r.startContainer.isConnected && r.startOffset <= ((_b = (_a = r.startContainer.nodeValue) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) && r.endContainer.isConnected && r.endOffset <= ((_d = (_c = r.endContainer.nodeValue) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0);
        });
    }
    async find(walker, query) {
        if (!query.length) {
            return [];
        }
        const cache = this.cache[query];
        if (cache && await this.isValidCache(cache)) {
            return cache;
        }
        this.cache[query] = this.j.async.promise((resolve)=>{
            const sentence = new _helpers_index_js__WEBPACK_IMPORTED_MODULE_7__/* .SentenceFinder */ .QN(this.j.o.search.fuzzySearch);
            walker.on('break', ()=>{
                resolve([]);
            }).on('visit', (elm)=>{
                if (_core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isText(elm)) {
                    sentence.add(elm);
                }
                return false;
            }).on('end', ()=>{
                var _a;
                resolve((_a = sentence.ranges(query)) !== null && _a !== void 0 ? _a : []);
            }).setWork(this.j.editor);
        });
        return this.cache[query];
    }
    __drawSelectionRanges(ranges) {
        const { async, createInside: ci, editor } = this.j;
        async.cancelAnimationFrame(this.wrapFrameRequest);
        const parts = [
            ...ranges
        ];
        let sRange, total = 0;
        return async.promise((resolve)=>{
            const drawParts = ()=>{
                do {
                    sRange = parts.shift();
                    if (sRange) {
                        (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_7__/* .highlightTextRanges */ ._B)(this.j, sRange, parts, ci, editor);
                    }
                    total += 1;
                }while (sRange && total <= 5)
                if (parts.length) {
                    this.wrapFrameRequest = async.requestAnimationFrame(drawParts);
                } else {
                    resolve();
                }
            };
            drawParts();
        });
    }
    onAfterGetValueFromEditor(data) {
        data.value = (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_7__/* .clearSelectionWrappersFromHTML */ .Tz)(data.value);
    }
    /** @override */ afterInit(editor) {
        if (editor.o.useSearch) {
            const self = this;
            editor.e.on('beforeSetMode.search', ()=>{
                this.ui.close();
            }).on(this.ui, 'afterClose', ()=>{
                (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_7__/* .clearSelectionWrappers */ .IJ)(editor);
                this.ui.currentIndex = 0;
                this.ui.count = 0;
                this.cache = {};
                editor.focus();
            }).on('click', ()=>{
                this.ui.currentIndex = 0;
                (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_7__/* .clearSelectionWrappers */ .IJ)(editor);
            }).on('change.search', ()=>{
                this.cache = {};
            }).on('keydown.search mousedown.search', editor.async.debounce(()=>{
                if (this.ui.selInfo) {
                    editor.s.removeMarkers();
                    this.ui.selInfo = null;
                }
                if (this.ui.isOpened) {
                    void this.updateCounters();
                }
            }, editor.defaultTimeout)).on('searchNext.search searchPrevious.search', ()=>{
                if (!this.ui.isOpened) {
                    this.ui.open();
                }
                return self.findAndSelect(self.ui.query, editor.e.current === 'searchNext').catch((e)=>{
                    !_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD && console.error('Search error', e);
                });
            }).on('search.search', (value, next = true)=>{
                this.ui.currentIndex = 0;
                return self.findAndSelect(value || '', next).catch((e)=>{
                    !_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD && console.error('Search error', e);
                });
            });
            editor.registerCommand('search', {
                exec: (command, value, next = true)=>{
                    value && self.findAndSelect(value, next).catch((e)=>{
                        !_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD && console.error('Search error', e);
                    });
                    return false;
                }
            }).registerCommand('openSearchDialog', {
                exec: (command, value)=>{
                    self.ui.open(value);
                    return false;
                },
                hotkeys: [
                    'ctrl+f',
                    'cmd+f'
                ]
            }).registerCommand('openReplaceDialog', {
                exec: (command, query, replace)=>{
                    if (!editor.o.readonly) {
                        self.ui.open(query, replace, true);
                    }
                    return false;
                },
                hotkeys: [
                    'ctrl+h',
                    'cmd+h'
                ]
            });
        }
    }
    /** @override */ beforeDestruct(jodit) {
        var _a;
        (_a = (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.cached)(this, 'ui')) === null || _a === void 0 ? void 0 : _a.destruct();
        jodit.e.off('.search');
    }
    constructor(){
        super(...arguments);
        this.buttons = [
            {
                name: 'find',
                group: 'search'
            }
        ];
        this.previousQuery = '';
        this.drawPromise = null;
        this.walker = null;
        this.walkerCount = null;
        this.cache = {};
        this.wrapFrameRequest = 0;
    }
}
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.cache
], search.prototype, "ui", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)('ui:needUpdateCounters')
], search.prototype, "updateCounters", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)('ui:pressReplaceButton')
], search.prototype, "onPressReplaceButton", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], search.prototype, "findQueryBounds", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], search.prototype, "findAndReplace", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], search.prototype, "findAndSelect", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], search.prototype, "find", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)(':afterGetValueFromEditor')
], search.prototype, "onAfterGetValueFromEditor", null);
_core_global_js__WEBPACK_IMPORTED_MODULE_3__/* .pluginSystem */ .fg.add('search', search);


/***/ }),

/***/ 36204:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6441);
/* harmony import */ var _source_svg_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35599);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.beautifyHTML = !_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_IE;
_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.sourceEditor = 'ace';
_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.sourceEditorNativeOptions = {
    /**
     * Show gutter
     */ showGutter: true,
    /**
     * Default theme
     */ theme: 'ace/theme/idle_fingers',
    /**
     * Default mode
     */ mode: 'ace/mode/html',
    /**
     * Wrap lines. Possible values - "off", 80-100..., true, "free"
     */ wrap: true,
    /**
     * Highlight active line
     */ highlightActiveLine: true
};
_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.sourceEditorCDNUrlsJS = [
    'https://cdnjs.cloudflare.com/ajax/libs/ace/1.4.2/ace.js'
];
_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.beautifyHTMLCDNUrlsJS = [
    'https://cdnjs.cloudflare.com/ajax/libs/js-beautify/1.14.4/beautify.min.js',
    'https://cdnjs.cloudflare.com/ajax/libs/js-beautify/1.14.4/beautify-html.min.js'
];
_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .I.set('source', _source_svg_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A);
_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.controls.source = {
    mode: _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_SPLIT,
    exec: (editor)=>{
        editor.toggleMode();
    },
    isActive: (editor)=>{
        return editor.getRealMode() === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_SOURCE;
    },
    tooltip: 'Change mode'
};


/***/ }),

/***/ 36243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export focus */
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22732);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(580);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/**
 * After loading the page into the editor once the focus is set
 */ _config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.autofocus = false;
/**
 * Cursor position after autofocus
 */ _config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.cursorAfterAutofocus = 'end';
/**
 * Save current selection on blur event
 */ _config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.saveSelectionOnBlur = true;
function focus(editor) {
    if (editor.o.saveSelectionOnBlur) {
        editor.e.on('blur', ()=>{
            if (editor.isEditorMode()) {
                editor.s.save(true);
            }
        }).on('focus', ()=>{
            editor.s.restore();
        });
    }
    const focus = ()=>{
        editor.s.focus();
        if (editor.o.cursorAfterAutofocus === 'end') {
            const lastTextNode = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.last(editor.editor, (node)=>_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isText(node));
            if (lastTextNode) {
                editor.s.setCursorIn(lastTextNode, false);
            }
        }
    };
    editor.e.on('afterInit', ()=>{
        if (editor.o.autofocus) {
            if (editor.defaultTimeout) {
                editor.async.setTimeout(focus, 300);
            } else {
                focus();
            }
        }
    });
    editor.e.on('afterInit afterAddPlace', ()=>{
        editor.e.off(editor.editor, 'mousedown.autofocus').on(editor.editor, 'mousedown.autofocus', (e)=>{
            if (editor.isEditorMode() && e.target && _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isBlock(e.target) && !e.target.childNodes.length) {
                if (editor.editor === e.target) {
                    editor.s.focus();
                } else {
                    editor.s.setCursorIn(e.target);
                }
            }
        });
    });
}
_core_global_js__WEBPACK_IMPORTED_MODULE_1__/* .pluginSystem */ .fg.add('focus', focus);


/***/ }),

/***/ 36409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: function() { return /* binding */ ucfirst; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/string
 */ /**
 * Make a string's first character uppercase
 */ function ucfirst(value) {
    if (!value.length) {
        return '';
    }
    return value[0].toUpperCase() + value.substring(1);
}


/***/ }),

/***/ 36646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   IB: function() { return /* reexport safe */ _button_js__WEBPACK_IMPORTED_MODULE_0__.I; },
/* harmony export */   P1: function() { return /* reexport safe */ _content_js__WEBPACK_IMPORTED_MODULE_1__.P; },
/* harmony export */   q4: function() { return /* reexport safe */ _select_select_js__WEBPACK_IMPORTED_MODULE_2__.q; }
/* harmony export */ });
/* harmony import */ var _button_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78644);
/* harmony import */ var _content_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80319);
/* harmony import */ var _select_select_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83111);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module modules/toolbar/button
 */ 




/***/ }),

/***/ 36806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   X: function() { return /* binding */ Prompt; }
/* harmony export */ });
/* harmony import */ var _core_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23282);
/* harmony import */ var _core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29960);
/* harmony import */ var _core_ui_button_button_button_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10830);
/* harmony import */ var _dialog_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78584);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



/**
 * Show `Prompt` dialog. Work without Jodit object
 *
 * @param msg - Dialog content
 * @param title - Title or callback
 * @param callback - callback. The first argument is the value entered
 * @param placeholder - Placeholder for input
 * @example
 * ```javascript
 * Jodit.Prompt("Enter your name", "Prompt Dialog", function (name) {
 *     if (name.length < 3) {
 *         Jodit.Alert("The name must be at least 3 letters");
 *         return false;
 *     }
 *     // do something
 * });
 * ```
 */ function Prompt(msg, title, callback, placeholder, defaultValue) {
    const dialog = this instanceof _dialog_js__WEBPACK_IMPORTED_MODULE_2__/* .Dialog */ .l ? this : new _dialog_js__WEBPACK_IMPORTED_MODULE_2__/* .Dialog */ .l({
        closeOnClickOverlay: true
    }), cancelButton = (0,_core_ui_button_button_button_js__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .$n)(dialog, 'cancel', 'Cancel'), okButton = (0,_core_ui_button_button_button_js__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .$n)(dialog, 'ok', 'Ok'), form = dialog.c.element('form', {
        class: 'jodit-dialog_prompt'
    }), inputElement = dialog.c.element('input', {
        autofocus: true,
        class: 'jodit-input'
    }), labelElement = dialog.c.element('label');
    if ((0,_core_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_3__/* .isFunction */ .T)(title)) {
        callback = title;
        title = undefined;
    }
    if (placeholder) {
        (0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__/* .attr */ .C)(inputElement, 'placeholder', placeholder);
    }
    labelElement.appendChild(dialog.c.text(msg));
    form.appendChild(labelElement);
    form.appendChild(inputElement);
    cancelButton.onAction(dialog.close);
    const onclick = ()=>{
        if (!callback || !(0,_core_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_3__/* .isFunction */ .T)(callback) || callback(inputElement.value) !== false) {
            dialog.close();
        }
    };
    okButton.onAction(onclick);
    dialog.e.on(form, 'submit', ()=>{
        onclick();
        return false;
    });
    dialog.setFooter([
        okButton,
        cancelButton
    ]);
    dialog.open(form, title || '&nbsp;', true, true);
    inputElement.focus();
    if (defaultValue !== undefined && defaultValue.length) {
        inputElement.value = defaultValue;
        inputElement.select();
    }
    return dialog;
}


/***/ }),

/***/ 36886:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M512 1536h768v-384h-768v384zm896 0h128v-896q0-14-10-38.5t-20-34.5l-281-281q-10-10-34-20t-39-10v416q0 40-28 68t-68 28h-576q-40 0-68-28t-28-68v-416h-128v1280h128v-416q0-40 28-68t68-28h832q40 0 68 28t28 68v416zm-384-928v-320q0-13-9.5-22.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 22.5v320q0 13 9.5 22.5t22.5 9.5h192q13 0 22.5-9.5t9.5-22.5zm640 32v928q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1344q0-40 28-68t68-28h928q40 0 88 20t76 48l280 280q28 28 48 76t20 88z\"/> </svg> ");


/***/ }),

/***/ 37068:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' x=\"0px\" y=\"0px\" viewBox=\"0 0 459 459\"> <g> <path d=\"M229.5,0C102,0,0,102,0,229.5S102,459,229.5,459c20.4,0,38.25-17.85,38.25-38.25c0-10.2-2.55-17.85-10.2-25.5 c-5.1-7.65-10.2-15.3-10.2-25.5c0-20.4,17.851-38.25,38.25-38.25h45.9c71.4,0,127.5-56.1,127.5-127.5C459,91.8,357,0,229.5,0z M89.25,229.5c-20.4,0-38.25-17.85-38.25-38.25S68.85,153,89.25,153s38.25,17.85,38.25,38.25S109.65,229.5,89.25,229.5z M165.75,127.5c-20.4,0-38.25-17.85-38.25-38.25S145.35,51,165.75,51S204,68.85,204,89.25S186.15,127.5,165.75,127.5z M293.25,127.5c-20.4,0-38.25-17.85-38.25-38.25S272.85,51,293.25,51s38.25,17.85,38.25,38.25S313.65,127.5,293.25,127.5z M369.75,229.5c-20.4,0-38.25-17.85-38.25-38.25S349.35,153,369.75,153S408,170.85,408,191.25S390.15,229.5,369.75,229.5z\" /> </g> </svg> ");


/***/ }),

/***/ 37133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   N: function() { return /* binding */ getPropertyDescriptor; },
/* harmony export */   w: function() { return /* binding */ watch; }
/* harmony export */ });
/* harmony import */ var _component_statuses_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78213);
/* harmony import */ var _event_emitter_observable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73026);
/* harmony import */ var _helpers_array_split_array_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46559);
/* harmony import */ var _helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23282);
/* harmony import */ var _helpers_checker_is_plain_object_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72430);
/* harmony import */ var _helpers_checker_is_view_object_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39955);
/* harmony import */ var _helpers_utils_error_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89890);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 






function getPropertyDescriptor(obj, prop) {
    let desc;
    do {
        desc = Object.getOwnPropertyDescriptor(obj, prop);
        obj = Object.getPrototypeOf(obj);
    }while (!desc && obj)
    return desc;
}
/**
 * Watch decorator. Added observer for some change in field value
 */ function watch(observeFields, opts) {
    return (target, propertyKey)=>{
        var _a;
        if (!(0,_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_3__/* .isFunction */ .T)(target[propertyKey])) {
            throw (0,_helpers_utils_error_index_js__WEBPACK_IMPORTED_MODULE_2__/* .error */ .z3)('Handler must be a Function');
        }
        const immediately = (_a = opts === null || opts === void 0 ? void 0 : opts.immediately) !== null && _a !== void 0 ? _a : true;
        const context = opts === null || opts === void 0 ? void 0 : opts.context;
        const process = (component)=>{
            const view = (0,_helpers_checker_is_view_object_js__WEBPACK_IMPORTED_MODULE_4__/* .isViewObject */ .h)(component) ? component : component.jodit;
            let callback = (key, ...args)=>{
                if (component.isInDestruct) {
                    return;
                }
                return component[propertyKey](key, ...args);
            };
            if (!immediately) {
                callback = component.async.microDebounce(callback, true);
            }
            (0,_helpers_array_split_array_js__WEBPACK_IMPORTED_MODULE_5__/* .splitArray */ .u)(observeFields).forEach((field)=>{
                if (/:/.test(field)) {
                    const [objectPath, eventName] = field.split(':');
                    let ctx = context;
                    if (objectPath.length) {
                        ctx = component.get(objectPath);
                    }
                    if ((0,_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_3__/* .isFunction */ .T)(ctx)) {
                        ctx = ctx(component);
                    }
                    view.events.on(ctx || component, eventName, callback);
                    if (!ctx) {
                        view.events.on(eventName, callback);
                    }
                    component.hookStatus('beforeDestruct', ()=>{
                        view.events.off(ctx || component, eventName, callback).off(eventName, callback);
                    });
                    return;
                }
                const parts = field.split('.'), [key] = parts, teil = parts.slice(1);
                let value = component[key];
                if ((0,_helpers_checker_is_plain_object_js__WEBPACK_IMPORTED_MODULE_6__/* .isPlainObject */ .Q)(value)) {
                    const observableValue = (0,_event_emitter_observable_js__WEBPACK_IMPORTED_MODULE_1__/* .observable */ .s)(value);
                    observableValue.on(`change.${teil.join('.')}`, callback);
                }
                const descriptor = getPropertyDescriptor(target, key);
                Object.defineProperty(component, key, {
                    configurable: true,
                    set (v) {
                        const oldValue = value;
                        if (oldValue === v) {
                            return;
                        }
                        value = v;
                        if (descriptor && descriptor.set) {
                            descriptor.set.call(component, v);
                        }
                        if ((0,_helpers_checker_is_plain_object_js__WEBPACK_IMPORTED_MODULE_6__/* .isPlainObject */ .Q)(value)) {
                            value = (0,_event_emitter_observable_js__WEBPACK_IMPORTED_MODULE_1__/* .observable */ .s)(value);
                            value.on(`change.${teil.join('.')}`, callback);
                        }
                        callback(key, oldValue, value);
                    },
                    get () {
                        if (descriptor && descriptor.get) {
                            return descriptor.get.call(component);
                        }
                        return value;
                    }
                });
            });
        };
        if ((0,_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_3__/* .isFunction */ .T)(target.hookStatus)) {
            target.hookStatus(_component_statuses_js__WEBPACK_IMPORTED_MODULE_0__/* .STATUSES */ .f.ready, process);
        } else {
            process(target);
        }
    };
}


/***/ }),

/***/ 37272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    newline: '줄 바꿈',
    delete: '삭제',
    space: '공간',
    'Speech Recognize': '음성 인식',
    Sound: '소리',
    'Interim Results': '중간 결과'
});


/***/ }),

/***/ 37406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   l: function() { return /* binding */ normalizeUrl; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/normalize
 */ const normalizeUrl = (...urls)=>{
    return urls.filter((url)=>url.length).map((url)=>url.replace(/\/$/, '')).join('/').replace(/([^:])[\\/]+/g, '$1/');
};


/***/ }),

/***/ 37426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   b: function() { return /* binding */ ToolbarEditorCollection; }
/* harmony export */ });
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22732);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21537);
/* harmony import */ var _collection_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11676);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





let ToolbarEditorCollection = class ToolbarEditorCollection extends _collection_js__WEBPACK_IMPORTED_MODULE_4__/* .ToolbarCollection */ .Q {
    /** @override */ className() {
        return 'ToolbarEditorCollection';
    }
    /** @override */ shouldBeDisabled(button) {
        const disabled = super.shouldBeDisabled(button);
        if (disabled !== undefined) {
            return disabled;
        }
        const mode = button.control.mode === undefined ? _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_WYSIWYG : button.control.mode;
        return !(mode === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_SPLIT || mode === this.j.getRealMode());
    }
    /** @override */ shouldBeActive(button) {
        const active = super.shouldBeActive(button);
        if (active !== undefined) {
            return active;
        }
        const element = this.j.selection ? this.j.s.current() : null;
        if (!element) {
            return false;
        }
        let elm;
        if (button.control.tags) {
            const tags = button.control.tags;
            elm = element;
            if (_core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.up(elm, (node)=>{
                if (node && tags.indexOf(node.nodeName.toLowerCase()) !== -1) {
                    return true;
                }
            }, this.j.editor)) {
                return true;
            }
        }
        // activate by supposed css
        if (button.control.css) {
            const css = button.control.css;
            elm = element;
            if (_core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.up(elm, (node)=>{
                if (node && !_core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isText(node) && !_core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isComment(node)) {
                    return this.checkActiveStatus(css, node);
                }
            }, this.j.editor)) {
                return true;
            }
        }
        return false;
    }
    /** @override */ getTarget(button) {
        return button.target || this.j.s.current() || null;
    }
    /**
     * Adds an invisible element to the container that can handle the
     * situation when the editor is inside the <label>
     *
     * @see https://github.com/jodit/jodit-react/issues/138
     */ prependInvisibleInput(container) {
        const input = this.j.create.element('input', {
            tabIndex: -1,
            disabled: true,
            style: 'width: 0; height:0; position: absolute; visibility: hidden;'
        });
        _core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.appendChildFirst(container, input);
    }
    /**
     * Show the inline toolbar inside WYSIWYG editor.
     * @param bound - you can set the place for displaying the toolbar,
     * or the place will be in the place of the cursor
     */ showInline(bound) {
        this.jodit.e.fire('showInlineToolbar', bound);
    }
    hide() {
        this.jodit.e.fire('hidePopup');
        super.hide();
        this.jodit.e.fire('toggleToolbar');
    }
    show() {
        super.show();
        this.jodit.e.fire('toggleToolbar');
    }
    /** @override */ constructor(jodit){
        super(jodit);
        this.checkActiveStatus = (cssObject, node)=>{
            let matches = 0, total = 0;
            Object.keys(cssObject).forEach((cssProperty)=>{
                const cssValue = cssObject[cssProperty];
                if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isFunction)(cssValue)) {
                    if (cssValue(this.j, (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(node, cssProperty).toString())) {
                        matches += 1;
                    }
                } else {
                    if (cssValue.indexOf((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(node, cssProperty).toString()) !== -1) {
                        matches += 1;
                    }
                }
                total += 1;
            });
            return total === matches;
        };
        this.prependInvisibleInput(this.container);
    }
};
ToolbarEditorCollection = __decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.component
], ToolbarEditorCollection);



/***/ }),

/***/ 37467:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/resize-cells
 */ 
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.tableAllowCellResize = true;


/***/ }),

/***/ 37508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   u: function() { return /* binding */ isValidName; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/checker
 */ /**
 * Check if name has a normal format
 */ function isValidName(name) {
    if (!name.length) {
        return false;
    }
    return !/[^0-9A-Za-zа-яА-ЯЁё\w\-_. ]/.test(name) && name.trim().length > 0;
}


/***/ }),

/***/ 37585:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21537);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6441);
/* harmony import */ var _modules_toolbar_collection_collection_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11676);
/* harmony import */ var _modules_toolbar_factory_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21491);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 




_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.mobileTapTimeout = 300;
_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.toolbarAdaptive = true;
_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.buttonsMD = [
    {
        group: 'font-style',
        buttons: []
    },
    {
        group: 'list',
        buttons: []
    },
    {
        group: 'font',
        buttons: []
    },
    '---',
    {
        group: 'media',
        buttons: []
    },
    '\n',
    {
        group: 'state',
        buttons: []
    },
    {
        group: 'insert',
        buttons: []
    },
    {
        group: 'indent',
        buttons: []
    },
    {
        group: 'color',
        buttons: []
    },
    '---',
    {
        group: 'history',
        buttons: []
    },
    {
        group: 'other',
        buttons: []
    },
    '|',
    'dots'
];
_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.buttonsSM = [
    {
        group: 'font-style',
        buttons: []
    },
    {
        group: 'list',
        buttons: []
    },
    '---',
    {
        group: 'font',
        buttons: []
    },
    '\n',
    {
        group: 'state',
        buttons: []
    },
    {
        group: 'indent',
        buttons: []
    },
    {
        group: 'color',
        buttons: []
    },
    '---',
    {
        group: 'history',
        buttons: []
    },
    '|',
    'dots'
];
_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.buttonsXS = [
    {
        group: 'font-style',
        buttons: []
    },
    {
        group: 'list',
        buttons: []
    },
    '---',
    {
        group: 'font',
        buttons: []
    },
    {
        group: 'color',
        buttons: []
    },
    '---',
    'dots'
];
_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.controls.dots = {
    mode: _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_SOURCE + _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_WYSIWYG,
    popup: (editor, current, close, button)=>{
        let store = button.control.data;
        if (store === undefined) {
            store = {
                toolbar: (0,_modules_toolbar_factory_js__WEBPACK_IMPORTED_MODULE_4__/* .makeCollection */ .$K)(editor),
                rebuild: ()=>{
                    var _a, _b;
                    if (button) {
                        const buttons = editor.e.fire('getDiffButtons.mobile', button.closest(_modules_toolbar_collection_collection_js__WEBPACK_IMPORTED_MODULE_3__/* .ToolbarCollection */ .Q));
                        if (buttons && store) {
                            store.toolbar.build((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.splitArray)(buttons));
                            const w = ((_b = (_a = editor.toolbar) === null || _a === void 0 ? void 0 : _a.firstButton) === null || _b === void 0 ? void 0 : _b.container.offsetWidth) || 36;
                            store.toolbar.container.style.width = (w + 4) * 3 + 'px';
                        }
                    }
                }
            };
            button.control.data = store;
        }
        store.rebuild();
        return store.toolbar;
    },
    tooltip: 'Show all'
};


/***/ }),

/***/ 37643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   s: function() { return /* binding */ sound; }
/* harmony export */ });
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85567);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/speech-recognize
 */ 

/**
 * @internal
 */ function sound({ sec = 0.1, frequency = _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .PII */ .N, gain = 0.1, type = 'sine' } = {}) {
    if (!_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.globalWindow || typeof _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.globalWindow.AudioContext === 'undefined' && typeof _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.globalWindow.webkitAudioContext === 'undefined') {
        return;
    }
    // one context per document
    const context = new (_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.globalWindow.AudioContext || _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.globalWindow.webkitAudioContext)();
    const vol = context.createGain();
    const osc = context.createOscillator();
    osc.type = type;
    osc.frequency.value = frequency; // Hz
    osc.connect(vol);
    vol.connect(context.destination);
    osc.start(); // start the oscillator
    osc.stop(context.currentTime + sec);
    vol.gain.value = gain;
}


/***/ }),

/***/ 37663:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1171 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z\"/> </svg> ");


/***/ }),

/***/ 37775:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1792 352v1088q0 42-39 59-13 5-25 5-27 0-45-19l-403-403v166q0 119-84.5 203.5t-203.5 84.5h-704q-119 0-203.5-84.5t-84.5-203.5v-704q0-119 84.5-203.5t203.5-84.5h704q119 0 203.5 84.5t84.5 203.5v165l403-402q18-19 45-19 12 0 25 5 39 17 39 59z\"/> </svg> ");


/***/ }),

/***/ 37790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   HP: function() { return /* binding */ keys; },
/* harmony export */   T1: function() { return /* binding */ call; },
/* harmony export */   b_: function() { return /* binding */ markOwner; },
/* harmony export */   my: function() { return /* binding */ getDataTransfer; },
/* harmony export */   o_: function() { return /* binding */ callPromise; },
/* harmony export */   qN: function() { return /* binding */ memorizeExec; },
/* harmony export */   yt: function() { return /* binding */ loadImage; }
/* harmony export */ });
/* harmony import */ var _checker_is_promise_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14773);
/* harmony import */ var _checker_is_void_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86068);
/* harmony import */ var _attr_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29960);
/* harmony import */ var _data_bind_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86583);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



/**
 * Call function with parameters
 *
 * @example
 * ```js
 * const f = Math.random();
 * Jodit.modules.Helpers.call(f > 0.5 ? Math.ceil : Math.floor, f);
 * ```
 */ function call(func, ...args) {
    return func(...args);
}
/**
 * Mark element for debugging
 */ function markOwner(jodit, elm) {
    (0,_attr_js__WEBPACK_IMPORTED_MODULE_0__/* .attr */ .C)(elm, 'data-editor_id', jodit.id);
    !elm.component && Object.defineProperty(elm, 'jodit', {
        value: jodit
    });
}
function callPromise(condition, callback) {
    if ((0,_checker_is_promise_js__WEBPACK_IMPORTED_MODULE_2__/* .isPromise */ .y)(condition)) {
        return condition.then((resp)=>resp, ()=>null).finally(callback);
    }
    return callback === null || callback === void 0 ? void 0 : callback();
}
/**
 * Allow load image in promise
 */ const loadImage = (src, jodit)=>jodit.async.promise((res, rej)=>{
        const image = new Image(), onError = ()=>{
            jodit.e.off(image);
            rej === null || rej === void 0 ? void 0 : rej();
        }, onSuccess = ()=>{
            jodit.e.off(image);
            res(image);
        };
        jodit.e.one(image, 'load', onSuccess).one(image, 'error', onError).one(image, 'abort', onError);
        image.src = src;
        if (image.complete) {
            onSuccess();
        }
    });
const keys = (obj, own = true)=>{
    if (own) {
        return Object.keys(obj);
    }
    const props = [];
    for(const key in obj){
        props.push(key);
    }
    return props;
};
/**
 * Memorize last user chose
 */ const memorizeExec = (editor, _, { control }, preProcessValue)=>{
    var _a;
    const key = `button${control.command}`;
    let value = (_a = control.args && control.args[0]) !== null && _a !== void 0 ? _a : (0,_data_bind_js__WEBPACK_IMPORTED_MODULE_1__/* .dataBind */ .m)(editor, key);
    if ((0,_checker_is_void_js__WEBPACK_IMPORTED_MODULE_3__/* .isVoid */ .R)(value)) {
        return false;
    }
    (0,_data_bind_js__WEBPACK_IMPORTED_MODULE_1__/* .dataBind */ .m)(editor, key, value);
    if (preProcessValue) {
        value = preProcessValue(value);
    }
    editor.execCommand(control.command, false, value !== null && value !== void 0 ? value : undefined);
};
/**
 * Get DataTransfer from different event types
 */ const getDataTransfer = (event)=>{
    if (event.clipboardData) {
        return event.clipboardData;
    }
    try {
        return event.dataTransfer || new DataTransfer();
    } catch (_a) {
        return null;
    }
};


/***/ }),

/***/ 38420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   z: function() { return /* binding */ humanSizeToBytes; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/utils
 */ /**
 * Converts from human readable file size (kb,mb,gb,tb) to bytes
 * @param human - readable file size. Example 1gb or 11.2mb
 */ const humanSizeToBytes = (human)=>{
    if (/^[0-9.]+$/.test(human.toString())) {
        return parseFloat(human);
    }
    const format = human.substr(-2, 2).toUpperCase(), formats = [
        'KB',
        'MB',
        'GB',
        'TB'
    ], number = parseFloat(human.substr(0, human.length - 2));
    return formats.indexOf(format) !== -1 ? number * Math.pow(1024, formats.indexOf(format) + 1) : parseInt(human, 10);
};


/***/ }),

/***/ 38837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   v: function() { return /* binding */ assert; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/utils
 */ class AssertionError extends Error {
    constructor(message){
        super(message);
        this.name = 'AssertionError';
    }
}
/** Asserts that condition is truthy (or evaluates to true). */ function assert(condition, message) {
    if (!condition) {
        throw new AssertionError(`Assertion failed: ${message}`);
    }
}



/***/ }),

/***/ 38927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: function() { return /* binding */ TabsWidget; }
/* harmony export */ });
/* harmony import */ var _core_component_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91907);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _core_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23282);
/* harmony import */ var _core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29960);
/* harmony import */ var _core_ui_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67510);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 




/**
 * Build tabs system
 *
 * @param tabs - PlainObject where 'key' will be tab's Title and `value` is tab's content
 * @param state - You can use for this param any HTML element for remembering active tab
 *
 * @example
 * ```javascript
 * const editor = Jodit.make('#editor');
 * const tabs = Jodit.modules.TabsWidget(editor, [
 *  { name: 'Images', content: '<div>Images</div>' },
 *  {
 *    name: 'Title 2',
 *    content: editor.c.fromHTML('<div>Some content</div>')
 *  },
 *  {
 *    name: 'Color Picker',
 *    content: ColorPickerWidget(
 *      editor,
 *      function (color) {
 *        box.style.color = color;
 *      },
 *      box.style.color
 *    )
 *  }
 * ]);
 * ```
 */ const TabsWidget = (jodit, tabs, state)=>{
    const box = jodit.c.div('jodit-tabs');
    const tabBox = jodit.c.div('jodit-tabs__wrapper');
    const buttons = jodit.c.div('jodit-tabs__buttons');
    (0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_2__/* .attr */ .C)(buttons, {
        role: 'tablist',
        'aria-orientation': 'horizontal'
    });
    const nameToTab = {};
    const buttonList = [];
    let firstTab = '';
    box.appendChild(buttons);
    box.appendChild(tabBox);
    const setActive = (tab)=>{
        if (!nameToTab[tab]) {
            return;
        }
        buttonList.forEach((b)=>{
            b.state.activated = false;
        });
        Object.values(nameToTab).forEach(({ tab })=>tab.classList.remove('jodit-tab_active'));
        nameToTab[tab].button.state.activated = true;
        nameToTab[tab].tab.classList.add('jodit-tab_active');
    };
    tabs.forEach(({ icon, name, content })=>{
        const tab = jodit.c.div('jodit-tab');
        (0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_2__/* .attr */ .C)(tab, {
            role: 'tabpanel'
        });
        const button = (0,_core_ui_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .$n)(jodit, icon || name, name);
        button.state.role = 'tab';
        // Stop lose the focus
        jodit.e.on(button.container, 'pointerdown', (e)=>e.preventDefault());
        if (!firstTab) {
            firstTab = name;
        }
        buttons.appendChild(button.container);
        buttonList.push(button);
        button.container.classList.add('jodit-tabs__button', 'jodit-tabs__button_columns_' + tabs.length);
        if (!(0,_core_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_4__/* .isFunction */ .T)(content)) {
            tab.appendChild(_core_component_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA.isInstanceOf(content, _core_ui_index_js__WEBPACK_IMPORTED_MODULE_3__/* .UIElement */ .D$) ? content.container : content);
        } else {
            tab.appendChild(jodit.c.div('jodit-tab_empty'));
        }
        tabBox.appendChild(tab);
        button.onAction(()=>{
            setActive(name);
            if ((0,_core_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_4__/* .isFunction */ .T)(content) && !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isElement(content)) {
                content.call(jodit);
            }
            if (state) {
                state.activeTab = name;
            }
            return false;
        });
        nameToTab[name] = {
            button,
            tab
        };
    });
    Object.values(nameToTab).forEach(({ button })=>{
        button.container.style.width = (100 / tabs.length).toFixed(10) + '%';
    });
    const tab = !state || !state.activeTab || !nameToTab[state.activeTab] ? firstTab : state.activeTab;
    setActive(tab);
    if (state) {
        let activeTab = state.activeTab;
        Object.defineProperty(state, 'activeTab', {
            configurable: true,
            enumerable: false,
            get () {
                return activeTab;
            },
            set (value) {
                activeTab = value;
                setActive(value);
            }
        });
    }
    return box;
};


/***/ }),

/***/ 39179:
/***/ (function(__unused_webpack_module, __webpack_exports__) {


/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'copy-format': 'Copiar formato'
});


/***/ }),

/***/ 39433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   f: function() { return /* binding */ fillEmptyParagraph; }
/* harmony export */ });
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

const TABLE_CONTAINER_TAGS = new Set([
    'table',
    'tbody',
    'thead',
    'tfoot',
    'tr'
]);
/**
 * @private
 */ function fillEmptyParagraph(jodit, nodeElm, hadEffect) {
    if (jodit.o.cleanHTML.fillEmptyParagraph && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isBlock(nodeElm) && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isEmpty(nodeElm, _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INSEPARABLE_TAGS) && !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(nodeElm, TABLE_CONTAINER_TAGS)) {
        const br = jodit.createInside.element('br');
        nodeElm.appendChild(br);
        return true;
    }
    return hadEffect;
}


/***/ }),

/***/ 39516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   e: function() { return /* binding */ visitNodeWalker; }
/* harmony export */ });
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _filters_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45235);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

const keys = Object.keys(_filters_index_js__WEBPACK_IMPORTED_MODULE_1__);
/**
 * @private
 */ function visitNodeWalker(jodit, nodeElm, allowTags, denyTags, currentSelectionNode) {
    let hadEffect = false;
    const dcf = jodit.o.cleanHTML.disableCleanFilter;
    for (const key of keys){
        if (dcf && dcf.has(key)) {
            continue;
        }
        const filter = _filters_index_js__WEBPACK_IMPORTED_MODULE_1__[key];
        const tmp = hadEffect;
        hadEffect = filter(jodit, nodeElm, hadEffect, allowTags, denyTags, currentSelectionNode);
        if (!_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD && !tmp && hadEffect) {
            console.warn(`CleanHTML: Effect "${key}"`);
        }
        if (!nodeElm.isConnected) {
            return true;
        }
    }
    return hadEffect;
}


/***/ }),

/***/ 39627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export aiAssistant */
/* harmony import */ var _core_decorators_cache_cache_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33433);
/* harmony import */ var _core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37133);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_checker_is_abort_error_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12045);
/* harmony import */ var _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20356);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31974);
/* harmony import */ var _ui_ui_ai_assistant_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32523);
/* harmony import */ var _langs_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19308);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








/**
 * The plugin inserts content generated by AI into the editor.
 */ class aiAssistant extends _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_3__/* .Plugin */ .k {
    get __dialog() {
        return this.jodit.dlg({
            buttons: [
                'fullsize',
                'dialog.close'
            ],
            closeOnClickOverlay: true,
            closeOnEsc: true,
            resizable: false,
            draggable: true,
            minHeight: 160
        });
    }
    get __container() {
        const { jodit, __dialog } = this;
        return new _ui_ui_ai_assistant_js__WEBPACK_IMPORTED_MODULE_5__/* .UiAiAssistant */ .b(jodit, {
            onInsertAfter (html) {
                jodit.s.focus();
                jodit.s.setCursorAfter(jodit.s.current());
                jodit.s.insertHTML(html);
                __dialog.close();
            },
            onInsert (html) {
                jodit.s.focus();
                jodit.s.insertHTML(html);
                __dialog.close();
            }
        });
    }
    /** @override */ afterInit() {}
    onGenerateAiAssistantForm(prompt) {
        this.__dialog.open(this.__container, 'AI Assistant');
        this.__container.setPrompt(prompt);
    }
    onInvokeAiAssistant(prompt) {
        const { jodit } = this;
        jodit.s.focus();
        const selectedText = jodit.s.html;
        jodit.async.promise(async (resolve, reject)=>{
            try {
                const result = await jodit.o.aiAssistant.aiAssistantCallback(prompt, selectedText);
                resolve(result);
            } catch (error) {
                reject(error);
            }
        }).then((htmlFragment)=>{
            jodit.e.fire('ai-assistant-response', htmlFragment);
        }).catch((error)=>{
            if ((0,_core_helpers_checker_is_abort_error_js__WEBPACK_IMPORTED_MODULE_7__/* .isAbortError */ .z)(error)) {
                return;
            }
            jodit.message.error(error.message);
            jodit.e.fire('ai-assistant-error', error.message);
        });
    }
    /** @override */ beforeDestruct(_) {
        var _a, _b;
        (_a = (0,_core_decorators_cache_cache_js__WEBPACK_IMPORTED_MODULE_0__/* .cached */ .PO)(this, '__container')) === null || _a === void 0 ? void 0 : _a.destruct();
        (_b = (0,_core_decorators_cache_cache_js__WEBPACK_IMPORTED_MODULE_0__/* .cached */ .PO)(this, '__dialog')) === null || _b === void 0 ? void 0 : _b.destruct();
    }
    constructor(jodit){
        super(jodit);
        /** @override */ this.buttons = [
            {
                name: 'ai-commands',
                group: 'insert'
            },
            {
                name: 'ai-assistant',
                group: 'insert'
            }
        ];
        (0,_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .extendLang */ .JW)(_langs_index_js__WEBPACK_IMPORTED_MODULE_6__);
    }
}
__decorate([
    _core_decorators_cache_cache_js__WEBPACK_IMPORTED_MODULE_0__/* .cache */ .PP
], aiAssistant.prototype, "__dialog", null);
__decorate([
    _core_decorators_cache_cache_js__WEBPACK_IMPORTED_MODULE_0__/* .cache */ .PP
], aiAssistant.prototype, "__container", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)(':generateAiAssistantForm.ai-assistant')
], aiAssistant.prototype, "onGenerateAiAssistantForm", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)(':invokeAiAssistant')
], aiAssistant.prototype, "onInvokeAiAssistant", null);
_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .pluginSystem */ .fg.add('ai-assistant', aiAssistant);


/***/ }),

/***/ 39804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   O: function() { return /* binding */ Style; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31635);
/* harmony import */ var jodit_esm_core_decorators__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65478);
/* harmony import */ var jodit_esm_core_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21537);
/* harmony import */ var jodit_pro_plugins_paste_from_word_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46788);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */




let Style = class Style {
    constructor(str) {
        this._data = readStyles(str);
    }
    get keys() {
        return Object.keys(this._data);
    }
    forEach(f) {
        this.keys.forEach((key) => f(key));
    }
    clear() {
        this._data = {};
    }
    set(key, value) {
        this._data[key] = value;
    }
    get(key) {
        return this._data[key] ?? null;
    }
    has(key) {
        return this._data[key] !== undefined;
    }
    add(key, value) {
        this._data = readStyles(this.str() + ';' + `${key}:${value}`);
        return this;
    }
    str(filter = (k) => true) {
        const styleKeys = Object.keys(this._data).filter((key) => key &&
            !/^mso-/.test(key) &&
            filter(key) &&
            this.get(key) != null);
        const n = (v) => {
            if ((0,jodit_esm_core_helpers__WEBPACK_IMPORTED_MODULE_1__.isString)(v)) {
                return /^0[a-z]+$/i.test(v) ? '0' : v;
            }
            return v.toString();
        };
        ['padding', 'margin'].forEach((key) => {
            if (this._data[key]) {
                const indexMain = styleKeys.indexOf(key);
                const margins = (0,jodit_pro_plugins_paste_from_word_helpers__WEBPACK_IMPORTED_MODULE_2__/* .calcMarginParts */ .i)(this._data[key]);
                ['top', 'right', 'bottom', 'left'].forEach((side, index) => {
                    const name = `${key}-${side}`, value = this._data[name];
                    if (value != null &&
                        (styleKeys.indexOf(name) < indexMain ||
                            n(margins[index]) === n(value))) {
                        styleKeys.indexOf(name) !== -1 &&
                            styleKeys.splice(styleKeys.indexOf(name), 1);
                    }
                });
            }
        });
        if (styleKeys.length) {
            return styleKeys
                .map((key) => `${(0,jodit_esm_core_helpers__WEBPACK_IMPORTED_MODULE_1__.kebabCase)(key)}:${this.get(key)}`)
                .join(';');
        }
        return '';
    }
};
Style = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__decorate */ .Cg)([
    jodit_esm_core_decorators__WEBPACK_IMPORTED_MODULE_0__.autobind
], Style);

function readStyles(style) {
    return uniqueMax((style ?? '')
        .replace(/&quot;/g, '"')
        .split(';')
        .filter(Boolean)
        .map((s) => (0,jodit_esm_core_helpers__WEBPACK_IMPORTED_MODULE_1__.trim)(s).split(':').map(jodit_esm_core_helpers__WEBPACK_IMPORTED_MODULE_1__.trim))).reduce((acc, [key, value]) => {
        if (key && value) {
            acc[key] = value;
        }
        return acc;
    }, {});
}
function uniqueMax(array) {
    const keys = {};
    const result = [];
    for (let i = array.length - 1; i >= 0; i -= 1) {
        const key = array[i][0];
        if (keys[key]) {
            continue;
        }
        keys[key] = true;
        result.unshift(array[i]);
    }
    return result;
}


/***/ }),

/***/ 39955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   h: function() { return /* binding */ isViewObject; }
/* harmony export */ });
/* harmony import */ var _is_function_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23282);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/**
 * Check if an element is instance of View
 */ function isViewObject(jodit) {
    return Boolean(jodit && jodit instanceof Object && (0,_is_function_js__WEBPACK_IMPORTED_MODULE_0__/* .isFunction */ .T)(jodit.constructor) && jodit.isView);
}


/***/ }),

/***/ 40329:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22732);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21537);
/* harmony import */ var _core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43555);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6441);
/* harmony import */ var _table_svg_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6091);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 





_config_js__WEBPACK_IMPORTED_MODULE_4__/* .Config */ .T.prototype.table = {
    selectionCellStyle: 'border: 1px double #1e88e5 !important;',
    useExtraClassesOptions: false
};
_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .I.set('table', _table_svg_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A);
_config_js__WEBPACK_IMPORTED_MODULE_4__/* .Config */ .T.prototype.controls.table = {
    data: {
        cols: 10,
        rows: 10,
        classList: {
            'table table-bordered': 'Bootstrap Bordered',
            'table table-striped': 'Bootstrap Striped',
            'table table-dark': 'Bootstrap Dark'
        }
    },
    popup: (editor, current, close, button)=>{
        editor.editor.normalize();
        const snapshot = editor.history.snapshot.make();
        const control = button.control;
        const default_rows_count = control.data && control.data.rows ? control.data.rows : 10, default_cols_count = control.data && control.data.cols ? control.data.cols : 10;
        const generateExtraClasses = ()=>{
            if (!editor.o.table.useExtraClassesOptions) {
                return '';
            }
            const out = [];
            if (control.data) {
                const classList = control.data.classList;
                Object.keys(classList).forEach((classes)=>{
                    out.push(`<label class="jodit_vertical_middle"><input class="jodit-checkbox" value="${classes}" type="checkbox"/>${classList[classes]}</label>`);
                });
            }
            return out.join('');
        };
        const form = editor.c.fromHTML('<form class="jodit-form jodit-form__inserter">' + '<div class="jodit-form__table-creator-box">' + '<div class="jodit-form__container"></div>' + '<div class="jodit-form__options">' + generateExtraClasses() + '</div>' + '</div>' + '<label class="jodit-form__center">' + '<span>1</span> &times; <span>1</span>' + '</label>' + '</form>'), rows = form.querySelectorAll('span')[0], cols = form.querySelectorAll('span')[1], blocksContainer = form.querySelector('.jodit-form__container'), options = form.querySelector('.jodit-form__options'), cells = [];
        const cnt = default_rows_count * default_cols_count;
        for(let i = 0; i < cnt; i += 1){
            if (!cells[i]) {
                cells.push(editor.c.element('span', {
                    dataIndex: i
                }));
            }
        }
        const mouseenter = (e, index)=>{
            const dv = e.target;
            if (!_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(dv, 'span')) {
                return;
            }
            const k = index === undefined || isNaN(index) ? parseInt((0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_2__/* .attr */ .CF)(dv, '-index') || '0', 10) : index || 0;
            const rows_count = Math.ceil((k + 1) / default_cols_count), cols_count = k % default_cols_count + 1;
            for(let i = 0; i < cells.length; i += 1){
                if (cols_count >= i % default_cols_count + 1 && rows_count >= Math.ceil((i + 1) / default_cols_count)) {
                    cells[i].className = 'jodit_hovered';
                } else {
                    cells[i].className = '';
                }
            }
            cols.textContent = cols_count.toString();
            rows.textContent = rows_count.toString();
        };
        editor.e.on(blocksContainer, 'mousemove', mouseenter).on(blocksContainer, 'touchstart mousedown', (e)=>{
            const dv = e.target;
            e.preventDefault();
            e.stopImmediatePropagation();
            if (!_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(dv, 'span')) {
                return;
            }
            const k = parseInt((0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_2__/* .attr */ .CF)(dv, '-index') || '0', 10);
            const rows_count = Math.ceil((k + 1) / default_cols_count), cols_count = k % default_cols_count + 1;
            const crt = editor.createInside, tbody = crt.element('tbody'), table = crt.element('table');
            table.appendChild(tbody);
            let first_td = null, tr, td;
            for(let i = 1; i <= rows_count; i += 1){
                tr = crt.element('tr');
                for(let j = 1; j <= cols_count; j += 1){
                    td = crt.element('td');
                    if (!first_td) {
                        first_td = td;
                    }
                    (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.css)(td, 'width', (100 / cols_count).toFixed(4) + '%');
                    td.appendChild(crt.element('br'));
                    tr.appendChild(crt.text('\n'));
                    tr.appendChild(crt.text('\t'));
                    tr.appendChild(td);
                }
                tbody.appendChild(crt.text('\n'));
                tbody.appendChild(tr);
            }
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.$$)('input[type=checkbox]:checked', options).forEach((input)=>{
                input.value.split(/[\s]+/).forEach((className)=>{
                    table.classList.add(className);
                });
            });
            editor.s.restore();
            editor.s.removeMarkers();
            editor.editor.normalize();
            editor.history.snapshot.restore(snapshot);
            const block = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.furthest(editor.s.current(), _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isBlock, editor.editor);
            if (block && _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isEmpty(block)) {
                _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.replace(block, table, undefined, false, true);
            } else {
                if (block) {
                    const fake = crt.text('\n');
                    _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.after(block, fake);
                    _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.after(fake, table);
                } else {
                    editor.s.insertNode(table, false);
                }
            }
            if (first_td) {
                editor.s.setCursorIn(first_td);
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.scrollIntoViewIfNeeded)(first_td, editor.editor, editor.ed);
            }
            close();
        });
        if (button && button.parentElement) {
            for(let i = 0; i < default_rows_count; i += 1){
                const row = editor.c.div();
                for(let j = 0; j < default_cols_count; j += 1){
                    row.appendChild(cells[i * default_cols_count + j]);
                }
                blocksContainer.appendChild(row);
            }
            if (cells[0]) {
                cells[0].className = 'hovered';
            }
        }
        return form;
    },
    tooltip: 'Insert table'
};


/***/ }),

/***/ 40372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    newline: 'новая строка|перенос|ентер',
    delete: 'видалити',
    space: 'пробел',
    'Speech Recognize': 'Распознавание речи',
    Sound: 'Звук',
    'Interim Results': 'Проміжні результати'
});


/***/ }),

/***/ 40401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ay: function() { return /* binding */ autobind; }
/* harmony export */ });
/* unused harmony exports boundMethod, boundClass */
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
    }
    return _typeof(obj);
}
/**
 * Return a descriptor removing the value and returning a getter
 * The getter will return a .bind version of the function
 * and memoize the result against a symbol on the instance
 */ function boundMethod(target, key, descriptor) {
    var fn = descriptor.value;
    if (typeof fn !== 'function') {
        throw new TypeError("@boundMethod decorator can only be applied to methods not: ".concat(_typeof(fn)));
    } // In IE11 calling Object.defineProperty has a side-effect of evaluating the
    // getter for the property which is being replaced. This causes infinite
    // recursion and an "Out of stack space" error.
    var definingProperty = false;
    return {
        configurable: true,
        get: function get() {
            // eslint-disable-next-line no-prototype-builtins
            if (definingProperty || this === target.prototype || this.hasOwnProperty(key) || typeof fn !== 'function') {
                return fn;
            }
            var boundFn = fn.bind(this);
            definingProperty = true;
            Object.defineProperty(this, key, {
                configurable: true,
                get: function get() {
                    return boundFn;
                },
                set: function set(value) {
                    fn = value;
                    delete this[key];
                }
            });
            definingProperty = false;
            return boundFn;
        },
        set: function set(value) {
            fn = value;
        }
    };
}
/**
 * Use boundMethod to bind all methods on the target.prototype
 */ function boundClass(target) {
    // (Using reflect to get all keys including symbols)
    var keys; // Use Reflect if exists
    if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
        keys = Reflect.ownKeys(target.prototype);
    } else {
        keys = Object.getOwnPropertyNames(target.prototype); // Use symbols if support is provided
        if (typeof Object.getOwnPropertySymbols === 'function') {
            keys = keys.concat(Object.getOwnPropertySymbols(target.prototype));
        }
    }
    keys.forEach(function(key) {
        // Ignore special case target method
        if (key === 'constructor') {
            return;
        }
        var descriptor = Object.getOwnPropertyDescriptor(target.prototype, key); // Only methods need binding
        if (typeof descriptor.value === 'function') {
            Object.defineProperty(target.prototype, key, boundMethod(target, key, descriptor));
        }
    });
    return target;
}
function autobind() {
    if (arguments.length === 1) {
        return boundClass.apply(void 0, arguments);
    }
    return boundMethod.apply(void 0, arguments);
}


/***/ }),

/***/ 40565:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'Type something': 'Napisz coś',
    Advanced: 'Zaawansowane',
    'About Jodit': 'O Jodit',
    'Jodit Editor': 'Edytor Jodit',
    "Jodit User's Guide": 'Instrukcja Jodit',
    'contains detailed help for using': 'zawiera szczegółowe informacje dotyczące użytkowania.',
    'For information about the license, please go to our website:': 'Odwiedź naszą stronę, aby uzyskać więcej informacji na temat licencji:',
    'Buy full version': 'Zakup pełnej wersji',
    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.': 'Copyright © XDSoft.net - Chupurnov Valeriy. Wszystkie prawa zastrzeżone.',
    Anchor: 'Kotwica',
    'Open in new tab': 'Otwórz w nowej zakładce',
    'Open in fullsize': 'Otwórz edytor w pełnym rozmiarze',
    'Clear Formatting': 'Wyczyść formatowanie',
    'Fill color or set the text color': 'Kolor wypełnienia lub ustaw kolor tekstu',
    Redo: 'Ponów',
    Undo: 'Cofnij',
    Bold: 'Pogrubienie',
    Italic: 'Kursywa',
    'Insert Unordered List': 'Wstaw listę wypunktowaną',
    'Insert Ordered List': 'Wstaw listę numeryczną',
    'Align Center': 'Wyśrodkuj',
    'Align Justify': 'Wyjustuj',
    'Align Left': 'Wyrównaj do lewej',
    'Align Right': 'Wyrównaj do prawej',
    'Insert Horizontal Line': 'Wstaw linię poziomą',
    'Insert Image': 'Wstaw grafikę',
    'Insert file': 'Wstaw plik',
    'Insert youtube/vimeo video': 'Wstaw film Youtube/vimeo',
    'Insert link': 'Wstaw link',
    'Font size': 'Rozmiar tekstu',
    'Font family': 'Krój czcionki',
    'Insert format block': 'Wstaw formatowanie',
    Normal: 'Normalne',
    'Heading 1': 'Nagłówek 1',
    'Heading 2': 'Nagłówek 2',
    'Heading 3': 'Nagłówek 3',
    'Heading 4': 'Nagłówek 4',
    Quote: 'Cytat',
    Code: 'Kod',
    Insert: 'Wstaw',
    'Insert table': 'Wstaw tabelę',
    'Decrease Indent': 'Zmniejsz wcięcie',
    'Increase Indent': 'Zwiększ wcięcie',
    'Select Special Character': 'Wybierz znak specjalny',
    'Insert Special Character': 'Wstaw znak specjalny',
    'Paint format': 'Malarz formatów',
    'Change mode': 'Zmień tryb',
    Margins: 'Marginesy',
    top: 'Górny',
    right: 'Prawy',
    bottom: 'Dolny',
    left: 'Levy',
    Styles: 'Style CSS',
    Classes: 'Klasy CSS',
    Align: 'Wyrównanie',
    Right: 'Prawa',
    Center: 'środek',
    Left: 'Lewa',
    '--Not Set--': 'brak',
    Src: 'Źródło',
    Title: 'Tytuł',
    Alternative: 'Tekst alternatywny',
    Link: 'Link',
    'Open link in new tab': 'Otwórz w nowej zakładce',
    Image: 'Grafika',
    file: 'Plik',
    'Image properties': 'Właściwości grafiki',
    Cancel: 'Anuluj',
    Ok: 'OK',
    'Your code is similar to HTML. Keep as HTML?': 'Twój kod wygląda jak HTML. Zachować HTML?',
    'Paste as HTML': 'Wkleić jako HTML?',
    Keep: 'Oryginalny tekst',
    Clean: 'Wyczyść',
    'Insert as Text': 'Wstaw jako tekst',
    'Word Paste Detected': 'Wykryto tekst w formacie Word',
    'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?': 'Wklejany tekst pochodzi z dokumentu Microsoft Word/Excel. Chcesz zachować ten format czy wyczyścić go? ',
    'Insert only Text': 'Wstaw tylko treść',
    'File Browser': 'Przeglądarka plików',
    'Error on load list': 'Błąd ładowania listy plików',
    'Error on load folders': 'Błąd ładowania folderów',
    'Are you sure?': 'Czy jesteś pewien?',
    'Enter Directory name': 'Wprowadź nazwę folderu',
    'Create directory': 'Utwórz folder',
    'type name': 'wprowadź nazwę',
    'Drop image': 'Upuść plik graficzny',
    'Drop file': 'Upuść plik',
    'or click': 'lub kliknij tu',
    'Alternative text': 'Tekst alternatywny',
    Browse: 'Przeglądaj',
    Upload: 'Wczytaj',
    Background: 'Tło',
    Text: 'Treść',
    Top: 'Góra',
    Middle: 'Środek',
    Bottom: 'Dół',
    'Insert column before': 'Wstaw kolumnę przed',
    'Insert column after': 'Wstaw kolumnę po',
    'Insert row above': 'Wstaw wiersz przed',
    'Insert row below': 'Wstaw wiersz po',
    'Delete table': 'Usuń tabelę',
    'Delete row': 'Usuń wiersz',
    'Delete column': 'Usuń kolumnę',
    'Empty cell': 'Wyczyść komórkę',
    Delete: 'Usuń',
    'Strike through': 'Przekreślenie',
    Underline: 'Podkreślenie',
    Break: 'Przerwa',
    'Search for': 'Szukaj',
    'Replace with': 'Zamień na',
    Replace: 'Wymienić',
    Edit: 'Edytuj',
    'Vertical align': 'Wyrównywanie w pionie',
    'Horizontal align': 'Wyrównywanie w poziomie',
    Filter: 'Filtruj',
    'Sort by changed': 'Sortuj wg zmiany',
    'Sort by name': 'Sortuj wg nazwy',
    'Sort by size': 'Sortuj wg rozmiaru',
    'Add folder': 'Dodaj folder',
    'Split vertical': 'Podziel w pionie',
    'Split horizontal': 'Podziel w poziomie',
    Split: 'Podziel',
    Merge: 'Scal',
    'Add column': 'Dodaj kolumnę',
    'Add row': 'Dodaj wiersz',
    Border: 'Obramowanie',
    'Embed code': 'Wstaw kod',
    Update: 'Aktualizuj',
    superscript: 'indeks górny',
    subscript: 'index dolny',
    'Cut selection': 'Wytnij zaznaczenie',
    Paste: 'Wklej',
    'Choose Content to Paste': 'Wybierz zawartość do wklejenia',
    'Chars: %d': 'Znaki: %d',
    'Words: %d': 'Słowa: %d',
    All: 'Wszystko',
    'Select %s': 'Wybierz: %s',
    'Select all': 'Wybierz wszystko',
    source: 'HTML',
    bold: 'pogrubienie',
    italic: 'kursywa',
    brush: 'pędzel',
    link: 'link',
    undo: 'cofnij',
    redo: 'ponów',
    table: 'tabela',
    image: 'grafika',
    eraser: 'wyczyść',
    paragraph: 'akapit',
    fontsize: 'rozmiar czcionki',
    video: 'wideo',
    font: 'czcionka',
    about: 'O programie',
    print: 'drukuj',
    underline: 'podkreślenie',
    strikethrough: 'przekreślenie',
    indent: 'wcięcie',
    outdent: 'wycięcie',
    fullsize: 'pełen rozmiar',
    shrink: 'przytnij',
    hr: 'linia pozioma',
    ul: 'lista',
    ol: 'lista numerowana',
    cut: 'wytnij',
    selectall: 'zaznacz wszystko',
    'Open link': 'otwórz link',
    'Edit link': 'edytuj link',
    'No follow': 'Atrybut no-follow',
    Unlink: 'Usuń link',
    Eye: 'szukaj',
    pencil: 'edytuj',
    ' URL': 'URL',
    Reset: 'wyczyść',
    Save: 'zapisz',
    'Save as ...': 'zapisz jako',
    Resize: 'Zmień rozmiar',
    Crop: 'Przytnij',
    Width: 'Szerokość',
    Height: 'Wysokość',
    'Keep Aspect Ratio': 'Zachowaj proporcje',
    Yes: 'Tak',
    No: 'Nie',
    Remove: 'Usuń',
    Select: 'Wybierz',
    'You can only edit your own images. Download this image on the host?': 'Możesz edytować tylko swoje grafiki. Czy chcesz pobrać tą grafikę?',
    'The image has been successfully uploaded to the host!': 'Grafika została pomyślnienie dodana na serwer',
    palette: 'Paleta',
    'There are no files': 'Brak plików.',
    Rename: 'zmień nazwę',
    'Enter new name': 'Wprowadź nową nazwę',
    preview: 'podgląd',
    download: 'pobierz',
    'Paste from clipboard': 'Wklej ze schowka',
    "Your browser doesn't support direct access to the clipboard.": 'Twoja przeglądarka nie obsługuje schowka',
    'Copy selection': 'Kopiuj zaznaczenie',
    copy: 'kopiuj',
    'Border radius': 'Zaokrąglenie krawędzi',
    'Show all': 'Pokaż wszystkie',
    Apply: 'Zastosuj',
    'Please fill out this field': 'Proszę wypełnić to pole',
    'Please enter a web address': 'Proszę, wpisz adres sieci web',
    Default: 'Domyślnie',
    Circle: 'Koło',
    Dot: 'Punkt',
    Quadrate: 'Kwadrat',
    Find: 'Znaleźć',
    'Find Previous': 'Znaleźć Poprzednie',
    'Find Next': 'Znajdź Dalej',
    'Insert className': 'Wstaw nazwę zajęć',
    'Press Alt for custom resizing': 'Naciśnij Alt, aby zmienić rozmiar'
});


/***/ }),

/***/ 41107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export bold */
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21537);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6441);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73674);
/* harmony import */ var _icons_bold_svg_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(820);
/* harmony import */ var _icons_italic_svg_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53651);
/* harmony import */ var _icons_strikethrough_svg_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16020);
/* harmony import */ var _icons_subscript_svg_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89758);
/* harmony import */ var _icons_superscript_svg_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98527);
/* harmony import */ var _icons_underline_svg_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51855);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 











/**
 * Adds `bold`,` strikethrough`, `underline` and` italic` buttons to Jodit
 */ function bold(editor) {
    const callBack = (command)=>{
        const control = _config_js__WEBPACK_IMPORTED_MODULE_3__/* .Config */ .T.defaultOptions.controls[command], cssOptions = {
            ...control.css
        };
        let cssRules;
        Object.keys(cssOptions).forEach((key)=>{
            if (!cssRules) {
                cssRules = {};
            }
            cssRules[key] = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.isArray)(cssOptions[key]) ? cssOptions[key][0] : cssOptions[key];
        });
        editor.s.commitStyle({
            element: control.tags ? control.tags[0] : undefined
        });
        editor.synchronizeValues();
        return false;
    };
    [
        'bold',
        'italic',
        'underline',
        'strikethrough'
    ].forEach((name)=>{
        editor.registerButton({
            name,
            group: 'font-style'
        });
    });
    [
        'superscript',
        'subscript'
    ].forEach((name)=>{
        editor.registerButton({
            name,
            group: 'script'
        });
    });
    editor.registerCommand('bold', {
        exec: callBack,
        hotkeys: [
            'ctrl+b',
            'cmd+b'
        ]
    }).registerCommand('italic', {
        exec: callBack,
        hotkeys: [
            'ctrl+i',
            'cmd+i'
        ]
    }).registerCommand('underline', {
        exec: callBack,
        hotkeys: [
            'ctrl+u',
            'cmd+u'
        ]
    }).registerCommand('strikethrough', {
        exec: callBack
    }).registerCommand('subscript', {
        exec: callBack
    }).registerCommand('superscript', {
        exec: callBack
    });
}
_core_global_js__WEBPACK_IMPORTED_MODULE_0__/* .pluginSystem */ .fg.add('bold', bold);
_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .I.set('bold', _icons_bold_svg_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A).set('italic', _icons_italic_svg_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A).set('strikethrough', _icons_strikethrough_svg_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A).set('subscript', _icons_subscript_svg_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A).set('superscript', _icons_superscript_svg_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A).set('underline', _icons_underline_svg_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .A);


/***/ }),

/***/ 41180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ css; },
/* harmony export */   a: function() { return /* binding */ clearCenterAlign; }
/* harmony export */ });
/* harmony import */ var _checker_is_boolean_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87612);
/* harmony import */ var _checker_is_plain_object_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72430);
/* harmony import */ var _normalize_normalize_css_value_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3760);
/* harmony import */ var _string_camel_case_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87058);
/* harmony import */ var _string_kebab_case_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12475);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 




/**
 * Get the value of a computed style property for the first element in the set of matched elements or set one or
 * more CSS properties for every matched element
 *
 * @param element - HTML element
 * @param key - An object of property-value pairs to set. A CSS property name.
 * @param value - A value to set for the property.
 * @param onlyStyleMode - Get value from style attribute, without calculating
 */ function css(element, key, value, onlyStyleMode = false) {
    if ((0,_checker_is_boolean_js__WEBPACK_IMPORTED_MODULE_0__/* .isBoolean */ .L)(value)) {
        onlyStyleMode = value;
        value = undefined;
    }
    if ((0,_checker_is_plain_object_js__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .Q)(key) || value !== undefined) {
        const setValue = (elm, _key, _value)=>{
            _value = (0,_normalize_normalize_css_value_js__WEBPACK_IMPORTED_MODULE_2__/* .normalizeCssNumericValue */ .n8)(_key, _value);
            if (_value !== undefined && (_value == null || css(elm, _key, true) !== (0,_normalize_normalize_css_value_js__WEBPACK_IMPORTED_MODULE_2__/* .normalizeCssValue */ .iy)(_key, _value))) {
                elm.style[_key] = _value;
            }
        };
        if ((0,_checker_is_plain_object_js__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .Q)(key)) {
            const keys = Object.keys(key);
            for(let j = 0; j < keys.length; j += 1){
                setValue(element, (0,_string_camel_case_js__WEBPACK_IMPORTED_MODULE_3__/* .camelCase */ .x)(keys[j]), key[keys[j]]);
            }
        } else {
            setValue(element, (0,_string_camel_case_js__WEBPACK_IMPORTED_MODULE_3__/* .camelCase */ .x)(key), value);
        }
        return '';
    }
    const key2 = (0,_string_kebab_case_js__WEBPACK_IMPORTED_MODULE_4__/* .kebabCase */ .k)(key), doc = element.ownerDocument || document, win = doc ? doc.defaultView || doc.parentWindow : false;
    const currentValue = element.style[key];
    let result = '';
    if (currentValue !== undefined && currentValue !== '') {
        result = currentValue;
    } else if (win && !onlyStyleMode) {
        result = win.getComputedStyle(element).getPropertyValue(key2);
    }
    if (_normalize_normalize_css_value_js__WEBPACK_IMPORTED_MODULE_2__/* .NUMBER_FIELDS_REG */ .b$.test(key) && /^[-+]?[0-9.]+px$/.test(result.toString())) {
        result = parseInt(result.toString(), 10);
    }
    return (0,_normalize_normalize_css_value_js__WEBPACK_IMPORTED_MODULE_2__/* .normalizeCssValue */ .iy)(key, result);
}
/**
 * Clear center align
 */ const clearCenterAlign = (image)=>{
    if (css(image, 'display') === 'block') {
        css(image, 'display', '');
    }
    const { style } = image;
    if (style.marginLeft === 'auto' && style.marginRight === 'auto') {
        style.marginLeft = '';
        style.marginRight = '';
    }
};


/***/ }),

/***/ 41369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    symbols: 'Símbolo'
});


/***/ }),

/***/ 41409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ajax: function() { return /* reexport safe */ _core_request_index_js__WEBPACK_IMPORTED_MODULE_10__.d; },
/* harmony export */   Alert: function() { return /* reexport safe */ _dialog_index_js__WEBPACK_IMPORTED_MODULE_3__.Fc; },
/* harmony export */   Async: function() { return /* reexport safe */ _core_async_index_js__WEBPACK_IMPORTED_MODULE_5__.j; },
/* harmony export */   Button: function() { return /* reexport safe */ _core_ui_index_js__WEBPACK_IMPORTED_MODULE_11__.$n; },
/* harmony export */   CommitStyle: function() { return /* reexport safe */ _core_selection_index_js__WEBPACK_IMPORTED_MODULE_25__.xk; },
/* harmony export */   Component: function() { return /* reexport safe */ _core_component_index_js__WEBPACK_IMPORTED_MODULE_0__.uA; },
/* harmony export */   Confirm: function() { return /* reexport safe */ _dialog_index_js__WEBPACK_IMPORTED_MODULE_3__.pT; },
/* harmony export */   ContextMenu: function() { return /* reexport safe */ _context_menu_context_menu_js__WEBPACK_IMPORTED_MODULE_2__.t; },
/* harmony export */   Create: function() { return /* reexport safe */ _core_create_index_js__WEBPACK_IMPORTED_MODULE_6__.X; },
/* harmony export */   Dialog: function() { return /* reexport safe */ _dialog_index_js__WEBPACK_IMPORTED_MODULE_3__.lG; },
/* harmony export */   Dom: function() { return /* reexport safe */ _core_dom_index_js__WEBPACK_IMPORTED_MODULE_7__.J; },
/* harmony export */   EventEmitter: function() { return /* reexport safe */ _core_event_emitter_index_js__WEBPACK_IMPORTED_MODULE_8__.bk; },
/* harmony export */   EventHandlersStore: function() { return /* reexport safe */ _core_event_emitter_index_js__WEBPACK_IMPORTED_MODULE_8__.d$; },
/* harmony export */   Eventify: function() { return /* reexport safe */ _core_event_emitter_index_js__WEBPACK_IMPORTED_MODULE_8__.h5; },
/* harmony export */   FileBrowser: function() { return /* reexport safe */ _file_browser_index_js__WEBPACK_IMPORTED_MODULE_4__.V; },
/* harmony export */   Helpers: function() { return /* reexport module object */ _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__; },
/* harmony export */   History: function() { return /* reexport safe */ _history_history_js__WEBPACK_IMPORTED_MODULE_14__.B; },
/* harmony export */   Icon: function() { return /* reexport safe */ _core_ui_index_js__WEBPACK_IMPORTED_MODULE_11__.In; },
/* harmony export */   ImageEditor: function() { return /* reexport safe */ _image_editor_image_editor_js__WEBPACK_IMPORTED_MODULE_16__.n; },
/* harmony export */   LazyWalker: function() { return /* reexport safe */ _core_dom_index_js__WEBPACK_IMPORTED_MODULE_7__.p; },
/* harmony export */   Plugin: function() { return /* reexport safe */ _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_9__.k; },
/* harmony export */   PluginSystem: function() { return /* reexport safe */ _core_plugin_plugin_system_js__WEBPACK_IMPORTED_MODULE_24__.$; },
/* harmony export */   Popup: function() { return /* reexport safe */ _core_ui_index_js__WEBPACK_IMPORTED_MODULE_11__.zD; },
/* harmony export */   ProgressBar: function() { return /* reexport safe */ _core_ui_index_js__WEBPACK_IMPORTED_MODULE_11__.z2; },
/* harmony export */   Prompt: function() { return /* reexport safe */ _dialog_index_js__WEBPACK_IMPORTED_MODULE_3__.XG; },
/* harmony export */   Response: function() { return /* reexport safe */ _core_request_index_js__WEBPACK_IMPORTED_MODULE_10__.Y; },
/* harmony export */   STATUSES: function() { return /* reexport safe */ _core_component_index_js__WEBPACK_IMPORTED_MODULE_0__.f; },
/* harmony export */   Selection: function() { return /* reexport safe */ _core_selection_index_js__WEBPACK_IMPORTED_MODULE_25__.LN; },
/* harmony export */   Snapshot: function() { return /* reexport safe */ _history_snapshot_js__WEBPACK_IMPORTED_MODULE_15__.F; },
/* harmony export */   StatusBar: function() { return /* reexport safe */ _status_bar_status_bar_js__WEBPACK_IMPORTED_MODULE_18__.e; },
/* harmony export */   Table: function() { return /* reexport safe */ _table_table_js__WEBPACK_IMPORTED_MODULE_19__.X; },
/* harmony export */   ToolbarButton: function() { return /* reexport safe */ _toolbar_button_index_js__WEBPACK_IMPORTED_MODULE_20__.IB; },
/* harmony export */   ToolbarCollection: function() { return /* reexport safe */ _toolbar_collection_collection_js__WEBPACK_IMPORTED_MODULE_21__.Q; },
/* harmony export */   ToolbarContent: function() { return /* reexport safe */ _toolbar_button_index_js__WEBPACK_IMPORTED_MODULE_20__.P1; },
/* harmony export */   ToolbarEditorCollection: function() { return /* reexport safe */ _toolbar_collection_editor_collection_js__WEBPACK_IMPORTED_MODULE_22__.b; },
/* harmony export */   ToolbarSelect: function() { return /* reexport safe */ _toolbar_button_index_js__WEBPACK_IMPORTED_MODULE_20__.q4; },
/* harmony export */   UIBlock: function() { return /* reexport safe */ _core_ui_index_js__WEBPACK_IMPORTED_MODULE_11__.Yh; },
/* harmony export */   UIButton: function() { return /* reexport safe */ _core_ui_index_js__WEBPACK_IMPORTED_MODULE_11__.lD; },
/* harmony export */   UIButtonGroup: function() { return /* reexport safe */ _core_ui_index_js__WEBPACK_IMPORTED_MODULE_11__.ss; },
/* harmony export */   UIButtonState: function() { return /* reexport safe */ _core_ui_index_js__WEBPACK_IMPORTED_MODULE_11__.ue; },
/* harmony export */   UICheckbox: function() { return /* reexport safe */ _core_ui_index_js__WEBPACK_IMPORTED_MODULE_11__.cY; },
/* harmony export */   UIElement: function() { return /* reexport safe */ _core_ui_index_js__WEBPACK_IMPORTED_MODULE_11__.D$; },
/* harmony export */   UIFileInput: function() { return /* reexport safe */ _core_ui_index_js__WEBPACK_IMPORTED_MODULE_11__.nE; },
/* harmony export */   UIForm: function() { return /* reexport safe */ _core_ui_index_js__WEBPACK_IMPORTED_MODULE_11__.XV; },
/* harmony export */   UIGroup: function() { return /* reexport safe */ _core_ui_index_js__WEBPACK_IMPORTED_MODULE_11__.Ue; },
/* harmony export */   UIInput: function() { return /* reexport safe */ _core_ui_index_js__WEBPACK_IMPORTED_MODULE_11__.tS; },
/* harmony export */   UIList: function() { return /* reexport safe */ _core_ui_index_js__WEBPACK_IMPORTED_MODULE_11__.z4; },
/* harmony export */   UIMessages: function() { return /* reexport safe */ _messages_messages_js__WEBPACK_IMPORTED_MODULE_17__.N; },
/* harmony export */   UISelect: function() { return /* reexport safe */ _core_ui_index_js__WEBPACK_IMPORTED_MODULE_11__.$6; },
/* harmony export */   UISeparator: function() { return /* reexport safe */ _core_ui_index_js__WEBPACK_IMPORTED_MODULE_11__.CP; },
/* harmony export */   UISpacer: function() { return /* reexport safe */ _core_ui_index_js__WEBPACK_IMPORTED_MODULE_11__.bk; },
/* harmony export */   UITextArea: function() { return /* reexport safe */ _core_ui_index_js__WEBPACK_IMPORTED_MODULE_11__.F0; },
/* harmony export */   UITooltip: function() { return /* reexport safe */ _core_ui_index_js__WEBPACK_IMPORTED_MODULE_11__.SB; },
/* harmony export */   Uploader: function() { return /* reexport safe */ _uploader_uploader_js__WEBPACK_IMPORTED_MODULE_23__.d; },
/* harmony export */   View: function() { return /* reexport safe */ _core_view_view_js__WEBPACK_IMPORTED_MODULE_12__.S; },
/* harmony export */   ViewComponent: function() { return /* reexport safe */ _core_component_index_js__WEBPACK_IMPORTED_MODULE_0__.vG; },
/* harmony export */   ViewWithToolbar: function() { return /* reexport safe */ _core_view_view_with_toolbar_js__WEBPACK_IMPORTED_MODULE_13__.T; },
/* harmony export */   defaultNameSpace: function() { return /* reexport safe */ _core_event_emitter_index_js__WEBPACK_IMPORTED_MODULE_8__.Xr; },
/* harmony export */   observable: function() { return /* reexport safe */ _core_event_emitter_index_js__WEBPACK_IMPORTED_MODULE_8__.sH; }
/* harmony export */ });
/* harmony import */ var _core_component_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91907);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21537);
/* harmony import */ var _context_menu_context_menu_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80870);
/* harmony import */ var _dialog_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(638);
/* harmony import */ var _file_browser_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78513);
/* harmony import */ var _core_async_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8884);
/* harmony import */ var _core_create_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12060);
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22732);
/* harmony import */ var _core_event_emitter_index_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3827);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50911);
/* harmony import */ var _core_request_index_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41601);
/* harmony import */ var _core_ui_index_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67510);
/* harmony import */ var _core_view_view_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35608);
/* harmony import */ var _core_view_view_with_toolbar_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(84075);
/* harmony import */ var _history_history_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(78818);
/* harmony import */ var _history_snapshot_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(52604);
/* harmony import */ var _image_editor_image_editor_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(50050);
/* harmony import */ var _messages_messages_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(1808);
/* harmony import */ var _status_bar_status_bar_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(23512);
/* harmony import */ var _table_table_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(76014);
/* harmony import */ var _toolbar_button_index_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(36646);
/* harmony import */ var _toolbar_collection_collection_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(11676);
/* harmony import */ var _toolbar_collection_editor_collection_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(37426);
/* harmony import */ var _uploader_uploader_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(57380);
/* harmony import */ var _core_plugin_plugin_system_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(41876);
/* harmony import */ var _core_selection_index_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(59242);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * [[include:modules/README.md]]
 * @packageDocumentation
 * @module modules
 */ 





























/***/ }),

/***/ 41457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22732);
/* harmony import */ var _core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43555);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12153);
/* harmony import */ var _elements_map_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32118);
/* harmony import */ var _factories_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63399);
/* harmony import */ var _fetch_delete_file_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44450);
/* harmony import */ var _fetch_load_tree_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20201);
/* harmony import */ var _listeners_native_listeners_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73948);
/* harmony import */ var _image_editor_image_editor_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50050);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 








const CLASS_PREVIEW = 'jodit-file-browser-preview', preview_tpl_next = (next = 'next', right = 'right')=>`<div class="${CLASS_PREVIEW}__navigation ${CLASS_PREVIEW}__navigation_arrow_${next}">` + '' + _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .I.get('angle-' + right) + '</a>';
/* harmony default export */ __webpack_exports__.A = ((self)=>{
    if (!self.o.contextMenu) {
        return ()=>{};
    }
    const contextmenu = (0,_factories_js__WEBPACK_IMPORTED_MODULE_4__/* .makeContextMenu */ .V)(self);
    return (e)=>{
        const a = (0,_listeners_native_listeners_js__WEBPACK_IMPORTED_MODULE_6__/* .getItem */ .Gq)(e.target, self.container);
        if (!a) {
            return;
        }
        let item = a;
        const opt = self.options, ga = (key)=>(0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .CF)(item, key) || '';
        self.async.setTimeout(()=>{
            const selectedItem = (0,_listeners_native_listeners_js__WEBPACK_IMPORTED_MODULE_6__/* .elementToItem */ .PZ)(a, (0,_elements_map_js__WEBPACK_IMPORTED_MODULE_3__/* .elementsMap */ .a)(self));
            if (!selectedItem) {
                return;
            }
            self.state.activeElements = [
                selectedItem
            ];
            contextmenu.show(e.clientX, e.clientY, [
                ga('data-is-file') !== '1' && opt.editImage && (self.dataProvider.canI('ImageResize') || self.dataProvider.canI('ImageCrop')) ? {
                    icon: 'pencil',
                    title: 'Edit',
                    exec: ()=>_image_editor_image_editor_js__WEBPACK_IMPORTED_MODULE_7__/* .openImageEditor */ .B.call(self, ga('href'), ga('data-name'), ga('data-path'), ga('data-source'))
                } : false,
                self.dataProvider.canI('FileRename') ? {
                    icon: 'italic',
                    title: 'Rename',
                    exec: ()=>{
                        self.e.fire('fileRename.filebrowser', ga('data-name'), ga('data-path'), ga('data-source'));
                    }
                } : false,
                self.dataProvider.canI('FileRemove') ? {
                    icon: 'bin',
                    title: 'Delete',
                    exec: async ()=>{
                        try {
                            await (0,_fetch_delete_file_js__WEBPACK_IMPORTED_MODULE_8__/* .deleteFile */ .W)(self, ga('data-name'), ga('data-source'));
                        } catch (e) {
                            return self.status(e);
                        }
                        self.state.activeElements = [];
                        return (0,_fetch_load_tree_js__WEBPACK_IMPORTED_MODULE_5__/* .loadTree */ .r)(self).catch(self.status);
                    }
                } : false,
                opt.preview ? {
                    icon: 'eye',
                    title: 'Preview',
                    exec: ()=>{
                        const preview = self.dlg({
                            buttons: [
                                'fullsize',
                                'dialog.close'
                            ]
                        }), temp_content = self.c.div(CLASS_PREVIEW, '<div class="jodit-icon_loader"></div>'), preview_box = self.c.div(CLASS_PREVIEW + '__box'), next = self.c.fromHTML(preview_tpl_next()), prev = self.c.fromHTML(preview_tpl_next('prev', 'left')), addLoadHandler = (src)=>{
                            const image = self.c.element('img');
                            image.setAttribute('src', src);
                            const onload = ()=>{
                                var _a;
                                if (self.isInDestruct) {
                                    return;
                                }
                                self.e.off(image, 'load');
                                _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.detach(temp_content);
                                if (opt.showPreviewNavigation) {
                                    if (_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.prevWithClass(item, self.files.getFullElName('item'))) {
                                        temp_content.appendChild(prev);
                                    }
                                    if (_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.nextWithClass(item, self.files.getFullElName('item'))) {
                                        temp_content.appendChild(next);
                                    }
                                }
                                temp_content.appendChild(preview_box);
                                preview_box.appendChild(image);
                                preview.setPosition();
                                (_a = self === null || self === void 0 ? void 0 : self.events) === null || _a === void 0 ? void 0 : _a.fire('previewOpenedAndLoaded');
                            };
                            self.e.on(image, 'load', onload);
                            if (image.complete) {
                                onload();
                            }
                        };
                        self.e.on([
                            next,
                            prev
                        ], 'click', function() {
                            if (this === next) {
                                item = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.nextWithClass(item, self.files.getFullElName('item'));
                            } else {
                                item = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.prevWithClass(item, self.files.getFullElName('item'));
                            }
                            if (!item) {
                                throw (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .error */ .z3)('Need element');
                            }
                            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.detach(temp_content);
                            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.detach(preview_box);
                            temp_content.innerHTML = '<div class="jodit-icon_loader"></div>';
                            addLoadHandler(ga('href'));
                        });
                        self.e.on('beforeDestruct', ()=>{
                            preview.destruct();
                        });
                        preview.container.classList.add(CLASS_PREVIEW + '__dialog');
                        preview.setContent(temp_content);
                        preview.setPosition();
                        preview.open();
                        addLoadHandler(ga('href'));
                        self.events.on('beforeDestruct', ()=>{
                            preview.destruct();
                        }).fire('previewOpened');
                    }
                } : false,
                {
                    icon: 'upload',
                    title: 'Download',
                    exec: ()=>{
                        const url = ga('href');
                        if (url) {
                            self.ow.open(url);
                        }
                    }
                }
            ]);
        }, self.defaultTimeout);
        self.e.on('beforeClose', ()=>{
            contextmenu.close();
        }).on('beforeDestruct', ()=>contextmenu.destruct());
        e.stopPropagation();
        e.preventDefault();
        return false;
    };
});


/***/ }),

/***/ 41601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Y: function() { return /* reexport safe */ _response_js__WEBPACK_IMPORTED_MODULE_1__.Y; },
/* harmony export */   d: function() { return /* reexport safe */ _ajax_js__WEBPACK_IMPORTED_MODULE_0__.d; }
/* harmony export */ });
/* harmony import */ var _ajax_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54079);
/* harmony import */ var _response_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98582);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module request
 */ 



/***/ }),

/***/ 41817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    'Line height': 'Çizgi yüksekliği'
});


/***/ }),

/***/ 41872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   l: function() { return /* binding */ checkBR; }
/* harmony export */ });
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _core_helpers_utils_scroll_into_view_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26395);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/**
 * Checks the possibility and necessity of inserting a BR instead of a block
 * @private
 */ function checkBR(fake, jodit, shiftKeyPressed) {
    const isMultiLineBlock = Boolean(_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.closest(fake, [
        'pre',
        'blockquote'
    ], jodit.editor));
    const isCell = !isMultiLineBlock && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.closest(fake, [
        'td',
        'th'
    ], jodit.editor);
    const isBRMode = jodit.o.enter.toLowerCase() === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.BR.toLowerCase();
    // if you use <br> defaultTag for break line or when was entered SHIFt key or in <td> or <th> or <blockquote>
    if (isBRMode || isCell || shiftKeyPressed && !isMultiLineBlock || !shiftKeyPressed && isMultiLineBlock) {
        // 2 BR before
        if (isMultiLineBlock && checkSeveralBR(fake)) {
            return false;
        }
        const br = jodit.createInside.element('br');
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.before(fake, br);
        if (!_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.findNotEmptySibling(br, false)) {
            const clone = br.cloneNode();
            _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.after(br, clone);
            _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.before(clone, fake);
        }
        (0,_core_helpers_utils_scroll_into_view_js__WEBPACK_IMPORTED_MODULE_2__/* .scrollIntoViewIfNeeded */ .$)(br, jodit.editor, jodit.ed);
        return true;
    }
    return false;
}
function checkSeveralBR(fake) {
    // 2 BR before
    const preBr = brBefore(brBefore(fake));
    if (preBr) {
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(brBefore(fake));
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(preBr);
        return true;
    }
    return false;
}
function brBefore(start) {
    if (!start) {
        return false;
    }
    const prev = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.findSibling(start, true);
    if (!prev || !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(prev, 'br')) {
        return false;
    }
    return prev;
}


/***/ }),

/***/ 41876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $: function() { return /* binding */ PluginSystem; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(580);
/* harmony import */ var _helpers_array_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76855);
/* harmony import */ var _helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27613);
/* harmony import */ var _helpers_init_instance_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31359);
/* harmony import */ var _helpers_load_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14041);
/* harmony import */ var _helpers_make_instance_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48591);
/* harmony import */ var _helpers_utils_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89672);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 








/**
 * Jodit plugin system
 * @example
 * ```js
 * Jodit.plugins.add('emoji2', {
 * 	init() {
 *  	alert('emoji Inited2')
 * 	},
 *	destruct() {}
 * });
 * ```
 */ class PluginSystem {
    get size() {
        return this.__items.size;
    }
    /**
     * Add plugin in store
     */ add(name, plugin) {
        this.__items.set((0,_helpers_utils_js__WEBPACK_IMPORTED_MODULE_7__/* .normalizeName */ .P)(name), plugin);
        _global_js__WEBPACK_IMPORTED_MODULE_1__/* .eventEmitter */ .RR.fire(`plugin:${name}:ready`);
    }
    /**
     * Get plugin from store
     */ get(name) {
        return this.__items.get((0,_helpers_utils_js__WEBPACK_IMPORTED_MODULE_7__/* .normalizeName */ .P)(name));
    }
    /**
     * Remove plugin from store
     */ remove(name) {
        this.__items.delete((0,_helpers_utils_js__WEBPACK_IMPORTED_MODULE_7__/* .normalizeName */ .P)(name));
    }
    __getFullPluginsList(filter) {
        const results = [];
        this.__items.forEach((plugin, name)=>{
            if (!filter || filter.has(name)) {
                results.push([
                    name,
                    plugin
                ]);
            }
        });
        return results;
    }
    /**
     * Public method for async init all plugins
     */ __init(jodit) {
        const { extraList, disableList, filter } = getSpecialLists(jodit);
        const doneList = new Map();
        const pluginsMap = {};
        const waitingList = new Set();
        jodit.__plugins = pluginsMap;
        const initPlugins = ()=>{
            if (jodit.isInDestruct) {
                return;
            }
            let commit = false;
            this.__getFullPluginsList(filter).forEach(([name, plugin])=>{
                if (disableList.has(name) || doneList.has(name)) {
                    return;
                }
                const requires = plugin === null || plugin === void 0 ? void 0 : plugin.requires;
                if (requires && (0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_3__/* .isArray */ .cy)(requires) && requires.length) {
                    if (requires.some((req)=>disableList.has(req))) {
                        return;
                    }
                    if (!requires.every((name)=>doneList.has(name))) {
                        waitingList.add(name);
                        return;
                    }
                }
                commit = true;
                const instance = (0,_helpers_make_instance_js__WEBPACK_IMPORTED_MODULE_6__/* .makeInstance */ .k)(jodit, plugin);
                if (!instance) {
                    doneList.set(name, null);
                    waitingList.delete(name);
                    return;
                }
                (0,_helpers_init_instance_js__WEBPACK_IMPORTED_MODULE_4__/* .init */ .T)(jodit, name, plugin, instance, doneList, waitingList);
                pluginsMap[name] = instance;
            });
            if (commit) {
                jodit.e.fire('updatePlugins');
                initPlugins();
            }
        };
        if (extraList && extraList.length) {
            (0,_helpers_load_js__WEBPACK_IMPORTED_MODULE_5__/* .loadExtras */ .o)(this.__items, jodit, extraList, initPlugins);
        }
        initPlugins();
        bindOnBeforeDestruct(jodit, pluginsMap);
        if (!_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD && waitingList.size) {
            console.warn('After init plugin waiting list is not clean:', waitingList);
        }
    }
    /**
     * Returns the promise to wait for the plugin to load.
     */ wait(name) {
        return new Promise((resolve)=>{
            if (this.get(name)) {
                return resolve();
            }
            const onReady = ()=>{
                resolve();
                _global_js__WEBPACK_IMPORTED_MODULE_1__/* .eventEmitter */ .RR.off(`plugin:${name}:ready`, onReady);
            };
            _global_js__WEBPACK_IMPORTED_MODULE_1__/* .eventEmitter */ .RR.on(`plugin:${name}:ready`, onReady);
        });
    }
    constructor(){
        this.__items = new Map();
    }
}
/**
 * Destroy all plugins before - Jodit will be destroyed
 */ function bindOnBeforeDestruct(jodit, plugins) {
    jodit.e.on('beforeDestruct', ()=>{
        Object.keys(plugins).forEach((name)=>{
            const instance = plugins[name];
            if ((0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_3__/* .isDestructable */ .pV)(instance)) {
                instance.destruct(jodit);
            }
            delete plugins[name];
        });
        delete jodit.__plugins;
    });
}
function getSpecialLists(jodit) {
    const extraList = jodit.o.extraPlugins.map((s)=>(0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .Kg)(s) ? {
            name: s
        } : s);
    const disableList = new Set((0,_helpers_array_index_js__WEBPACK_IMPORTED_MODULE_2__/* .splitArray */ .uM)(jodit.o.disablePlugins).map(_helpers_utils_js__WEBPACK_IMPORTED_MODULE_7__/* .normalizeName */ .P));
    const filter = jodit.o.safeMode ? new Set(jodit.o.safePluginsList) : null;
    return {
        extraList,
        disableList,
        filter
    };
}


/***/ }),

/***/ 42107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    Spellcheck: '拼字檢查'
});


/***/ }),

/***/ 42247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    Spellcheck: 'Yazım denetimi'
});


/***/ }),

/***/ 42263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export hotkeys */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21537);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50911);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78524);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 




/**
 * Allow set hotkey for command or button
 */ class hotkeys extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Plugin */ .k {
    /** @override */ afterInit(editor) {
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.keys)(editor.o.commandToHotkeys, false).forEach((commandName)=>{
            const shortcuts = editor.o.commandToHotkeys[commandName];
            if (shortcuts && ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.isArray)(shortcuts) || (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.isString)(shortcuts))) {
                editor.registerHotkeyToCommand(shortcuts, commandName);
            }
        });
        let itIsHotkey = false;
        editor.e.off('.hotkeys').on([
            editor.ow,
            editor.ew
        ], 'keydown.hotkeys', (e)=>{
            if (e.key === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_ESC) {
                return this.j.e.fire('escape', e);
            }
        }).on('keydown.hotkeys', (event)=>{
            const shortcut = this.onKeyPress(event);
            const stop = {
                shouldStop: true
            };
            const resultOfFire = this.j.e.fire(shortcut + '.hotkey', event.type, stop);
            if (resultOfFire === false) {
                if (stop.shouldStop) {
                    itIsHotkey = true;
                    editor.e.stopPropagation('keydown');
                    return false;
                } else {
                    event.preventDefault();
                }
            }
        }, {
            top: true
        }).on('keyup.hotkeys', ()=>{
            if (itIsHotkey) {
                itIsHotkey = false;
                editor.e.stopPropagation('keyup');
                return false;
            }
        }, {
            top: true
        });
    }
    /** @override */ beforeDestruct(jodit) {
        if (jodit.events) {
            jodit.e.off('.hotkeys');
        }
    }
    constructor(){
        super(...arguments);
        this.onKeyPress = (event)=>{
            const special = this.specialKeys[event.which];
            const character = (event.key || String.fromCharCode(event.which)).toLowerCase();
            const modif = [
                special || character
            ];
            [
                'alt',
                'ctrl',
                'shift',
                'meta'
            ].forEach((specialKey)=>{
                if (event[specialKey + 'Key'] && special !== specialKey) {
                    modif.push(specialKey);
                }
            });
            return (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.normalizeKeyAliases)(modif.join('+'));
        };
        this.specialKeys = {
            8: 'backspace',
            9: 'tab',
            10: 'return',
            13: 'return',
            16: 'shift',
            17: 'ctrl',
            18: 'alt',
            19: 'pause',
            20: 'capslock',
            27: 'esc',
            32: 'space',
            33: 'pageup',
            34: 'pagedown',
            35: 'end',
            36: 'home',
            37: 'left',
            38: 'up',
            39: 'right',
            40: 'down',
            45: 'insert',
            46: 'del',
            59: ';',
            61: '=',
            91: 'meta',
            96: '0',
            97: '1',
            98: '2',
            99: '3',
            100: '4',
            101: '5',
            102: '6',
            103: '7',
            104: '8',
            105: '9',
            106: '*',
            107: '+',
            109: '-',
            110: '.',
            111: '/',
            112: 'f1',
            113: 'f2',
            114: 'f3',
            115: 'f4',
            116: 'f5',
            117: 'f6',
            118: 'f7',
            119: 'f8',
            120: 'f9',
            121: 'f10',
            122: 'f11',
            123: 'f12',
            144: 'numlock',
            145: 'scroll',
            173: '-',
            186: ';',
            187: '=',
            188: ',',
            189: '-',
            190: '.',
            191: '/',
            192: '`',
            219: '[',
            220: '\\',
            221: ']',
            222: "'"
        };
    }
}
_core_global_js__WEBPACK_IMPORTED_MODULE_1__/* .pluginSystem */ .fg.add('hotkeys', hotkeys);


/***/ }),

/***/ 42312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   h: function() { return /* binding */ removeFormatForSelection; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43555);
/* harmony import */ var _remove_format_for_collapsed_selection_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84272);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/**
 * Remove formatting for all selected elements
 * @private
 */ function removeFormatForSelection(jodit) {
    const { s, editor, createInside } = jodit, { range } = s, left = range.cloneRange(), right = range.cloneRange(), fakeLeft = createInside.fake(), fakeRight = createInside.fake();
    left.collapse(true);
    right.collapse(false);
    _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeInsertNode(left, fakeLeft);
    _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeInsertNode(right, fakeRight);
    range.setStartBefore(fakeLeft);
    range.collapse(true);
    s.selectRange(range);
    (0,_remove_format_for_collapsed_selection_js__WEBPACK_IMPORTED_MODULE_2__/* .removeFormatForCollapsedSelection */ .w)(jodit, fakeLeft);
    range.setEndAfter(fakeRight);
    range.collapse(false);
    s.selectRange(range);
    (0,_remove_format_for_collapsed_selection_js__WEBPACK_IMPORTED_MODULE_2__/* .removeFormatForCollapsedSelection */ .w)(jodit, fakeRight);
    const shouldUnwrap = [];
    _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.between(fakeLeft, fakeRight, (node)=>{
        if ((0,_remove_format_for_collapsed_selection_js__WEBPACK_IMPORTED_MODULE_2__/* .isInlineBlock */ .D)(node) && !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(node, 'a')) {
            shouldUnwrap.push(node);
        }
        if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isElement(node) && (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .CF)(node, 'style')) {
            (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .CF)(node, 'style', null);
        }
    });
    shouldUnwrap.forEach((node)=>_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.unwrap(node));
    const clearParent = (node, left)=>{
        if (!_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.findNotEmptySibling(node, left)) {
            const pn = node.parentNode;
            if (pn && pn !== editor && (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .CF)(pn, 'style')) {
                (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .CF)(pn, 'style', null);
                clearParent(pn, left);
                return true;
            }
        }
    };
    clearParent(fakeLeft, true) && clearParent(fakeRight, false);
    range.setStartAfter(fakeLeft);
    range.setEndBefore(fakeRight);
    s.selectRange(range);
    _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(fakeLeft);
    _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(fakeRight);
}


/***/ }),

/***/ 42320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   v: function() { return /* binding */ isSet; }
/* harmony export */ });
/* harmony import */ var _is_function_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23282);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/checker
 */ 
/**
 * Check if element is set
 */ function isSet(elm) {
    return Boolean(elm) && (0,_is_function_js__WEBPACK_IMPORTED_MODULE_0__/* .isFunction */ .T)(elm.has) && (0,_is_function_js__WEBPACK_IMPORTED_MODULE_0__/* .isFunction */ .T)(elm.add) && (0,_is_function_js__WEBPACK_IMPORTED_MODULE_0__/* .isFunction */ .T)(elm.delete);
}


/***/ }),

/***/ 42345:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M503 1271l-256 256q-10 9-23 9-12 0-23-9-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23zm169 41v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zm-224-224q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zm1264 128q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-334-335q-21-21-42-56l239-18 273 274q27 27 68 27.5t68-26.5l147-146q28-28 28-67 0-40-28-68l-274-275 18-239q35 21 56 42l336 336q84 86 84 204zm-617-724l-239 18-273-274q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l274 274-18 240q-35-21-56-42l-336-336q-84-86-84-204 0-120 85-203l147-146q83-83 203-83 121 0 204 85l334 335q21 21 42 56zm633 84q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zm-544-544v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zm407 151l-256 256q-11 9-23 9t-23-9q-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23z\"/> </svg> ");


/***/ }),

/***/ 42640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Q: function() { return /* binding */ cleanStyles; }
/* harmony export */ });
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */
const forbiddenStyles = {
    'text-justify': ['inter-ideograph']
};
function cleanStyles(elm) {
    if (elm.isElement && elm.attributes.style) {
        Object.keys(forbiddenStyles).forEach((key) => {
            const values = forbiddenStyles[key];
            if (elm.style.has(key)) {
                // @ts-ignore
                if (values.includes(elm.style.get(key)?.toString())) {
                    elm.style.set(key, null);
                }
            }
        });
    }
    return elm;
}


/***/ }),

/***/ 42727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    'Line height': 'Wysokość linii'
});


/***/ }),

/***/ 42820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    Spellcheck: 'Oikeinkirjoituksen tarkistus'
});


/***/ }),

/***/ 43003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export table */
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(580);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40329);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

function table(editor) {
    editor.registerButton({
        name: 'table',
        group: 'insert'
    });
}
_core_global_js__WEBPACK_IMPORTED_MODULE_0__/* .pluginSystem */ .fg.add('table', table);


/***/ }),

/***/ 43267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   checkBlockNesting: function() { return /* reexport safe */ _check_block_nesting_js__WEBPACK_IMPORTED_MODULE_0__.o; }
/* harmony export */ });
/* harmony import */ var _check_block_nesting_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78720);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/dtd
 * @internal
 */ 


/***/ }),

/***/ 43463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   G: function() { return /* binding */ moveTheNodeAlongTheEdgeOutward; }
/* harmony export */ });
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/**
 * Moves the fake node up until it encounters a non-empty sibling on the left(right)
 * @private
 */ function moveTheNodeAlongTheEdgeOutward(node, start, root) {
    let item = node;
    while(item && item !== root){
        const sibling = _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.findSibling(item, start);
        if (sibling) {
            return;
        }
        if (_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isBlock(item.parentElement)) {
            break;
        }
        item = item.parentElement;
        if (item && item !== root) {
            start ? _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.before(item, node) : _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.after(item, node);
        }
    }
    return;
}


/***/ }),

/***/ 43478:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1664 960q-152-236-381-353 61 104 61 225 0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-121 61-225-229 117-381 353 133 205 333.5 326.5t434.5 121.5 434.5-121.5 333.5-326.5zm-720-384q0-20-14-34t-34-14q-125 0-214.5 89.5t-89.5 214.5q0 20 14 34t34 14 34-14 14-34q0-86 61-147t147-61q20 0 34-14t14-34zm848 384q0 34-20 69-140 230-376.5 368.5t-499.5 138.5-499.5-139-376.5-368q-20-35-20-69t20-69q140-229 376.5-368t499.5-139 499.5 139 376.5 368q20 35 20 69z\"/> </svg> ");


/***/ }),

/***/ 43555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $$: function() { return /* reexport safe */ _selector_js__WEBPACK_IMPORTED_MODULE_23__.$$; },
/* harmony export */   $v: function() { return /* reexport safe */ _scroll_into_view_js__WEBPACK_IMPORTED_MODULE_22__.$; },
/* harmony export */   AH: function() { return /* reexport safe */ _css_js__WEBPACK_IMPORTED_MODULE_9__.A; },
/* harmony export */   BG: function() { return /* reexport safe */ _mark_deprecated_js__WEBPACK_IMPORTED_MODULE_18__.B; },
/* harmony export */   CF: function() { return /* reexport safe */ _attr_js__WEBPACK_IMPORTED_MODULE_3__.C; },
/* harmony export */   DY: function() { return /* reexport safe */ _selector_js__WEBPACK_IMPORTED_MODULE_23__.DY; },
/* harmony export */   EW: function() { return /* reexport safe */ _append_script_js__WEBPACK_IMPORTED_MODULE_1__.EW; },
/* harmony export */   FI: function() { return /* reexport safe */ _error_index_js__WEBPACK_IMPORTED_MODULE_13__.FI; },
/* harmony export */   HP: function() { return /* reexport safe */ _utils_js__WEBPACK_IMPORTED_MODULE_26__.HP; },
/* harmony export */   Hp: function() { return /* reexport safe */ _extend_js__WEBPACK_IMPORTED_MODULE_14__.Hp; },
/* harmony export */   Jt: function() { return /* reexport safe */ _get_js__WEBPACK_IMPORTED_MODULE_15__.J; },
/* harmony export */   MJ: function() { return /* reexport safe */ _get_class_name_js__WEBPACK_IMPORTED_MODULE_16__.M; },
/* harmony export */   Mr: function() { return /* reexport safe */ _align_js__WEBPACK_IMPORTED_MODULE_0__.Mr; },
/* harmony export */   Op: function() { return /* reexport safe */ _align_js__WEBPACK_IMPORTED_MODULE_0__.Op; },
/* harmony export */   Qt: function() { return /* reexport safe */ _append_script_js__WEBPACK_IMPORTED_MODULE_1__.Qt; },
/* harmony export */   Rc: function() { return /* reexport safe */ _error_index_js__WEBPACK_IMPORTED_MODULE_13__.Rc; },
/* harmony export */   S5: function() { return /* reexport safe */ _append_script_js__WEBPACK_IMPORTED_MODULE_1__.S5; },
/* harmony export */   T: function() { return /* reexport safe */ _browser_js__WEBPACK_IMPORTED_MODULE_4__.T; },
/* harmony export */   T1: function() { return /* reexport safe */ _utils_js__WEBPACK_IMPORTED_MODULE_26__.T1; },
/* harmony export */   VL: function() { return /* reexport safe */ _config_proto_js__WEBPACK_IMPORTED_MODULE_7__.VL; },
/* harmony export */   Vc: function() { return /* reexport safe */ _parse_query_js__WEBPACK_IMPORTED_MODULE_19__.m; },
/* harmony export */   XO: function() { return /* reexport safe */ _complete_url_js__WEBPACK_IMPORTED_MODULE_6__.X; },
/* harmony export */   Xm: function() { return /* reexport safe */ _align_js__WEBPACK_IMPORTED_MODULE_0__.Xm; },
/* harmony export */   Xu: function() { return /* reexport safe */ _ctrl_key_js__WEBPACK_IMPORTED_MODULE_10__.X; },
/* harmony export */   ZW: function() { return /* reexport safe */ _error_index_js__WEBPACK_IMPORTED_MODULE_13__.ZW; },
/* harmony export */   Zq: function() { return /* reexport safe */ _build_query_js__WEBPACK_IMPORTED_MODULE_5__.Z; },
/* harmony export */   aE: function() { return /* reexport safe */ _css_js__WEBPACK_IMPORTED_MODULE_9__.a; },
/* harmony export */   bE: function() { return /* reexport safe */ _selector_js__WEBPACK_IMPORTED_MODULE_23__.bE; },
/* harmony export */   b_: function() { return /* reexport safe */ _utils_js__WEBPACK_IMPORTED_MODULE_26__.b_; },
/* harmony export */   cL: function() { return /* reexport safe */ _reset_js__WEBPACK_IMPORTED_MODULE_21__.c; },
/* harmony export */   dh: function() { return /* reexport safe */ _stack_js__WEBPACK_IMPORTED_MODULE_25__.d; },
/* harmony export */   eG: function() { return /* reexport safe */ _default_language_js__WEBPACK_IMPORTED_MODULE_12__.e; },
/* harmony export */   fF: function() { return /* reexport safe */ _error_index_js__WEBPACK_IMPORTED_MODULE_13__.fF; },
/* harmony export */   fV: function() { return /* reexport safe */ _mark_deprecated_js__WEBPACK_IMPORTED_MODULE_18__.f; },
/* harmony export */   fz: function() { return /* reexport safe */ _selector_js__WEBPACK_IMPORTED_MODULE_23__.fz; },
/* harmony export */   h2: function() { return /* reexport safe */ _error_index_js__WEBPACK_IMPORTED_MODULE_13__.h2; },
/* harmony export */   hZ: function() { return /* reexport safe */ _set_js__WEBPACK_IMPORTED_MODULE_24__.h; },
/* harmony export */   l7: function() { return /* reexport safe */ _scroll_into_view_js__WEBPACK_IMPORTED_MODULE_22__.l; },
/* harmony export */   mA: function() { return /* reexport safe */ _extend_js__WEBPACK_IMPORTED_MODULE_14__.mA; },
/* harmony export */   mY: function() { return /* reexport safe */ _convert_media_url_to_video_embed_js__WEBPACK_IMPORTED_MODULE_8__.m; },
/* harmony export */   mv: function() { return /* reexport safe */ _data_bind_js__WEBPACK_IMPORTED_MODULE_11__.m; },
/* harmony export */   my: function() { return /* reexport safe */ _utils_js__WEBPACK_IMPORTED_MODULE_26__.my; },
/* harmony export */   o_: function() { return /* reexport safe */ _utils_js__WEBPACK_IMPORTED_MODULE_26__.o_; },
/* harmony export */   pi: function() { return /* reexport safe */ _config_proto_js__WEBPACK_IMPORTED_MODULE_7__.pi; },
/* harmony export */   qN: function() { return /* reexport safe */ _utils_js__WEBPACK_IMPORTED_MODULE_26__.qN; },
/* harmony export */   rV: function() { return /* reexport safe */ _error_index_js__WEBPACK_IMPORTED_MODULE_13__.rV; },
/* harmony export */   tI: function() { return /* reexport safe */ _selector_js__WEBPACK_IMPORTED_MODULE_23__.tI; },
/* harmony export */   tb: function() { return /* reexport safe */ _config_proto_js__WEBPACK_IMPORTED_MODULE_7__.tb; },
/* harmony export */   uB: function() { return /* reexport safe */ _get_class_name_js__WEBPACK_IMPORTED_MODULE_16__.u; },
/* harmony export */   u_: function() { return /* reexport safe */ _print_js__WEBPACK_IMPORTED_MODULE_20__.u; },
/* harmony export */   vA: function() { return /* reexport safe */ _assert_js__WEBPACK_IMPORTED_MODULE_2__.v; },
/* harmony export */   w4: function() { return /* reexport safe */ _append_script_js__WEBPACK_IMPORTED_MODULE_1__.w4; },
/* harmony export */   x_: function() { return /* reexport safe */ _append_script_js__WEBPACK_IMPORTED_MODULE_1__.x_; },
/* harmony export */   y6: function() { return /* reexport safe */ _extend_js__WEBPACK_IMPORTED_MODULE_14__.y6; },
/* harmony export */   yt: function() { return /* reexport safe */ _utils_js__WEBPACK_IMPORTED_MODULE_26__.yt; },
/* harmony export */   z3: function() { return /* reexport safe */ _error_index_js__WEBPACK_IMPORTED_MODULE_13__.z3; },
/* harmony export */   zP: function() { return /* reexport safe */ _human_size_to_bytes_js__WEBPACK_IMPORTED_MODULE_17__.z; }
/* harmony export */ });
/* harmony import */ var _align_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25726);
/* harmony import */ var _append_script_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63799);
/* harmony import */ var _assert_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38837);
/* harmony import */ var _attr_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29960);
/* harmony import */ var _browser_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97639);
/* harmony import */ var _build_query_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44710);
/* harmony import */ var _complete_url_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66292);
/* harmony import */ var _config_proto_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68934);
/* harmony import */ var _convert_media_url_to_video_embed_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55877);
/* harmony import */ var _css_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41180);
/* harmony import */ var _ctrl_key_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15456);
/* harmony import */ var _data_bind_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86583);
/* harmony import */ var _default_language_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96325);
/* harmony import */ var _error_index_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(89890);
/* harmony import */ var _extend_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(97735);
/* harmony import */ var _get_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(94643);
/* harmony import */ var _get_class_name_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(80568);
/* harmony import */ var _human_size_to_bytes_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(38420);
/* harmony import */ var _mark_deprecated_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(95942);
/* harmony import */ var _parse_query_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(82501);
/* harmony import */ var _print_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(11628);
/* harmony import */ var _reset_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(58844);
/* harmony import */ var _scroll_into_view_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(26395);
/* harmony import */ var _selector_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(76078);
/* harmony import */ var _set_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(3703);
/* harmony import */ var _stack_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(50535);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(37790);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/utils
 */ 




























/***/ }),

/***/ 43646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    'Line height': 'Altura da linha'
});


/***/ }),

/***/ 43649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   V: function() { return /* binding */ flatButtonsSet; },
/* harmony export */   i: function() { return /* binding */ isButtonGroup; }
/* harmony export */ });
/* harmony import */ var _helpers_checker_is_array_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68345);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/**
 * @private
 */ const isButtonGroup = (item)=>{
    return (0,_helpers_checker_is_array_js__WEBPACK_IMPORTED_MODULE_0__/* .isArray */ .c)(item.buttons);
};
/**
 * @private
 */ function flatButtonsSet(buttons, jodit) {
    const groups = jodit.getRegisteredButtonGroups();
    return new Set(buttons.reduce((acc, item)=>{
        var _a;
        if (isButtonGroup(item)) {
            acc = acc.concat([
                ...item.buttons,
                ...(_a = groups[item.group]) !== null && _a !== void 0 ? _a : []
            ]);
        } else {
            acc.push(item);
        }
        return acc;
    }, []));
}


/***/ }),

/***/ 43809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export spellcheck */
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65478);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29960);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50911);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99085);
/* harmony import */ var _langs_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26529);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






class spellcheck extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Plugin */ .k {
    afterInit(jodit) {
        jodit.e.on('afterInit afterAddPlace prepareWYSIWYGEditor', this.toggleSpellcheck);
        this.toggleSpellcheck();
        jodit.registerCommand('toggleSpellcheck', ()=>{
            this.jodit.o.spellcheck = !this.jodit.o.spellcheck;
            this.toggleSpellcheck();
            this.j.e.fire('updateToolbar');
        });
    }
    toggleSpellcheck() {
        (0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_2__/* .attr */ .C)(this.jodit.editor, 'spellcheck', this.jodit.o.spellcheck);
    }
    beforeDestruct(jodit) {}
    constructor(jodit){
        super(jodit);
        this.buttons = [
            {
                group: 'state',
                name: 'spellcheck'
            }
        ];
        (0,_core_global_js__WEBPACK_IMPORTED_MODULE_1__/* .extendLang */ .JW)(_langs_index_js__WEBPACK_IMPORTED_MODULE_5__);
    }
}
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], spellcheck.prototype, "toggleSpellcheck", null);
_core_global_js__WEBPACK_IMPORTED_MODULE_1__/* .pluginSystem */ .fg.add('spellcheck', spellcheck);


/***/ }),

/***/ 44245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   y: function() { return /* binding */ insertParagraph; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _core_helpers_utils_scroll_into_view_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26395);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/**
 * Insert default paragraph
 * @private
 */ function insertParagraph(fake, editor, wrapperTag, style) {
    const isBR = wrapperTag.toLowerCase() === 'br', { createInside } = editor, p = createInside.element(wrapperTag), br = createInside.element('br');
    if (!isBR) {
        p.appendChild(br);
    }
    if (style && style.cssText) {
        p.setAttribute('style', style.cssText);
    }
    _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.after(fake, p);
    _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.before(isBR ? p : br, fake);
    (0,_core_helpers_utils_scroll_into_view_js__WEBPACK_IMPORTED_MODULE_1__/* .scrollIntoViewIfNeeded */ .$)(p, editor.editor, editor.ed);
    return p;
}


/***/ }),

/***/ 44253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Y: function() { return /* binding */ toggleAttributes; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27613);
/* harmony import */ var _helpers_normalize_normalize_css_value_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3760);
/* harmony import */ var _helpers_size_object_size_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21496);
/* harmony import */ var _helpers_string_kebab_case_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12475);
/* harmony import */ var _helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43555);
/* harmony import */ var _helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41180);
/* harmony import */ var _helpers_utils_data_bind_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86583);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(77361);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 










const tak = 'toggleAttributes';
/**
 * Toggles attributes
 * @private
 */ function toggleAttributes(commitStyle, elm, jodit, mode, dry = false) {
    if (!dry && commitStyle.isApplied(elm, tak)) {
        return mode;
    }
    !dry && commitStyle.setApplied(elm, tak);
    const { attributes } = commitStyle.options;
    if (attributes && (0,_helpers_size_object_size_js__WEBPACK_IMPORTED_MODULE_4__/* .size */ .E)(attributes) > 0) {
        Object.keys(attributes).forEach((key)=>{
            const value = attributes[key];
            switch(key){
                case 'style':
                    {
                        mode = toggleStyle(commitStyle, jodit, value, elm, dry, mode);
                        break;
                    }
                case 'className':
                case 'class':
                    mode = toggleClass(jodit, value, elm, mode, dry);
                    break;
                default:
                    mode = toggleAttribute(jodit, value, elm, key, dry, mode);
            }
        });
    }
    return mode;
}
function toggleStyle(commitStyle, jodit, style, elm, dry, mode) {
    (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_5__/* .assert */ .vA)((0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_3__/* .isPlainObject */ .Qd)(style) && (0,_helpers_size_object_size_js__WEBPACK_IMPORTED_MODULE_4__/* .size */ .E)(style), 'Style must be an object');
    Object.keys(style).forEach((rule)=>{
        const inlineValue = elm.style.getPropertyValue((0,_helpers_string_kebab_case_js__WEBPACK_IMPORTED_MODULE_7__/* .kebabCase */ .k)(rule));
        const newValue = style[rule];
        if (inlineValue === '' && newValue == null) {
            return;
        }
        if (getNativeCSSValue(jodit, elm, rule) === (0,_helpers_normalize_normalize_css_value_js__WEBPACK_IMPORTED_MODULE_8__/* .normalizeCssValue */ .iy)(rule, newValue)) {
            if (!inlineValue) {
                return;
            }
            !dry && (0,_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_9__/* .css */ .A)(elm, rule, null);
            mode = _constants_js__WEBPACK_IMPORTED_MODULE_10__/* .UNSET */ .Ag;
            mode = removeExtraStyleAttribute(commitStyle, elm, mode);
            return;
        }
        mode = _constants_js__WEBPACK_IMPORTED_MODULE_10__/* .CHANGE */ .PL;
        if (!dry) {
            (0,_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_9__/* .css */ .A)(elm, rule, newValue);
            mode = removeExtraStyleAttribute(commitStyle, elm, mode);
        }
    });
    return mode;
}
function toggleClass(jodit, value, elm, mode, dry) {
    (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_5__/* .assert */ .vA)((0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .Kg)(value), 'Class name must be a string');
    const hook = jodit.e.fire.bind(jodit.e, `${_constants_js__WEBPACK_IMPORTED_MODULE_10__/* ._PREFIX */ .ar}AfterToggleAttribute`);
    if (elm.classList.contains(value.toString())) {
        mode = _constants_js__WEBPACK_IMPORTED_MODULE_10__/* .UNSET */ .Ag;
        if (!dry) {
            elm.classList.remove(value);
            if (elm.classList.length === 0) {
                (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_5__/* .attr */ .CF)(elm, 'class', null);
                hook(mode, elm, 'class', null);
            }
        }
    } else {
        mode = _constants_js__WEBPACK_IMPORTED_MODULE_10__/* .CHANGE */ .PL;
        if (!dry) {
            elm.classList.add(value);
            hook(mode, elm, 'class', value);
        }
    }
    return mode;
}
function toggleAttribute(jodit, value, elm, key, dry, mode) {
    (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_5__/* .assert */ .vA)((0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .Kg)(value) || (0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_3__/* .isNumber */ .Et)(value) || (0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_3__/* .isBoolean */ .Lm)(value) || value == null, 'Attribute value must be a string or number or boolean or null');
    const hook = jodit.e.fire.bind(jodit.e, `${_constants_js__WEBPACK_IMPORTED_MODULE_10__/* ._PREFIX */ .ar}AfterToggleAttribute`);
    if ((0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_5__/* .attr */ .CF)(elm, key) === value) {
        !dry && (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_5__/* .attr */ .CF)(elm, key, null);
        mode = _constants_js__WEBPACK_IMPORTED_MODULE_10__/* .UNSET */ .Ag;
        !dry && hook(mode, elm, key, value);
        return mode;
    }
    mode = _constants_js__WEBPACK_IMPORTED_MODULE_10__/* .CHANGE */ .PL;
    if (!dry) {
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_5__/* .attr */ .CF)(elm, key, value);
        hook(mode, elm, key, value);
    }
    return mode;
}
/**
 * If the element has an empty style attribute, it removes the attribute,
 * and if it is default, it removes the element itself
 */ function removeExtraStyleAttribute(commitStyle, elm, mode) {
    if (!(0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_5__/* .attr */ .CF)(elm, 'style')) {
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_5__/* .attr */ .CF)(elm, 'style', null);
        if (elm.tagName.toLowerCase() === commitStyle.defaultTag) {
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.unwrap(elm);
            mode = _constants_js__WEBPACK_IMPORTED_MODULE_10__/* .UNWRAP */ .OJ;
        }
    }
    return mode;
}
/**
 * Creates an iframe into which elements will be inserted to test their default styles in the browser
 */ function getShadowRoot(jodit) {
    var _a;
    if ((0,_helpers_utils_data_bind_js__WEBPACK_IMPORTED_MODULE_6__/* .dataBind */ .m)(jodit, 'shadowRoot') !== undefined) {
        return (0,_helpers_utils_data_bind_js__WEBPACK_IMPORTED_MODULE_6__/* .dataBind */ .m)(jodit, 'shadowRoot');
    }
    const container = (0,_global_js__WEBPACK_IMPORTED_MODULE_2__/* .getContainer */ .My)(jodit);
    const iframe = _constants_js__WEBPACK_IMPORTED_MODULE_0__.globalDocument.createElement('iframe');
    (0,_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_9__/* .css */ .A)(iframe, {
        width: 0,
        height: 0,
        position: 'absolute',
        border: 0
    });
    iframe.src = 'about:blank';
    container.appendChild(iframe);
    const doc = (_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.document;
    const shadowRoot = !doc ? jodit.od.body : doc.body;
    (0,_helpers_utils_data_bind_js__WEBPACK_IMPORTED_MODULE_6__/* .dataBind */ .m)(jodit, 'shadowRoot', shadowRoot);
    return shadowRoot;
}
/**
 * `strong -> fontWeight 700`
 */ function getNativeCSSValue(jodit, elm, key) {
    const newElm = jodit.create.element(elm.tagName.toLowerCase());
    newElm.style.cssText = elm.style.cssText;
    const root = getShadowRoot(jodit);
    root.appendChild(newElm);
    const result = (0,_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_9__/* .css */ .A)(newElm, key);
    _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(newElm);
    return result;
}


/***/ }),

/***/ 44328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    symbols: 'Sembol'
});


/***/ }),

/***/ 44330:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M832 1408l336-384h-768l-336 384h768zm1013-1077q15 34 9.5 71.5t-30.5 65.5l-896 1024q-38 44-96 44h-768q-38 0-69.5-20.5t-47.5-54.5q-15-34-9.5-71.5t30.5-65.5l896-1024q38-44 96-44h768q38 0 69.5 20.5t47.5 54.5z\"/> </svg> ");


/***/ }),

/***/ 44450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   W: function() { return /* binding */ deleteFile; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * Removes a file from the server
 * @private
 */ function deleteFile(fb, name, source) {
    return fb.dataProvider.fileRemove(fb.state.currentPath, name, source).then((message)=>{
        fb.status(message || fb.i18n('File "%s" was deleted', name), true);
    }).catch(fb.status);
}


/***/ }),

/***/ 44506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   y: function() { return /* binding */ getContentWidth; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/size
 */ const getContentWidth = (element, win)=>{
    const pi = (value)=>parseInt(value, 10), style = win.getComputedStyle(element), width = element.offsetWidth, paddingLeft = pi(style.getPropertyValue('padding-left') || '0'), paddingRight = pi(style.getPropertyValue('padding-right') || '0');
    return width - paddingLeft - paddingRight;
};


/***/ }),

/***/ 44586:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/drag-and-drop-element
 */ 
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.draggableTags = [
    'img',
    'jodit-media',
    'jodit'
];


/***/ }),

/***/ 44602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ getSuitParent; }
/* harmony export */ });
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _is_normal_node_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29136);
/* harmony import */ var _is_suit_element_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97380);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/**
 * Checks if the parent of an element is suitable for applying styles, if applicable, then returns the parent *
 *
 * @param style - styles to be applied
 * @param node - checked item
 * @param root - editor root
 * @private
 */ function getSuitParent(style, node, root) {
    const { parentNode } = node;
    if (parentNode === root || !_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isHTMLElement(parentNode) || _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.next(node, _is_normal_node_js__WEBPACK_IMPORTED_MODULE_1__/* .isNormalNode */ ._, parentNode) || _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.prev(node, _is_normal_node_js__WEBPACK_IMPORTED_MODULE_1__/* .isNormalNode */ ._, parentNode)) {
        return null;
    }
    // <h3><span style="color:red">|test|</span></h3> => apply <h2>
    if (style.isElementCommit && style.elementIsBlock && !_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isBlock(parentNode)) {
        return getSuitParent(style, parentNode, root);
    }
    if ((0,_is_suit_element_js__WEBPACK_IMPORTED_MODULE_2__/* .isSuitElement */ .sz)(style, parentNode, false) && (!_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isBlock(parentNode) || style.elementIsBlock)) {
        return parentNode;
    }
    // <strong style="color:red"><em>|test|</em></strong> => apply <strong>
    if (style.isElementCommit && !_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isBlock(parentNode)) {
        return getSuitParent(style, parentNode, root);
    }
    return null;
}


/***/ }),

/***/ 44710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: function() { return /* binding */ buildQuery; }
/* harmony export */ });
/* harmony import */ var _checker_is_plain_object_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72430);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/**
 * Build query string
 */ const buildQuery = (data, prefix)=>{
    const str = [];
    const enc = encodeURIComponent;
    for(const dataKey in data){
        if (Object.prototype.hasOwnProperty.call(data, dataKey)) {
            const k = prefix ? prefix + '[' + dataKey + ']' : dataKey;
            const v = data[dataKey];
            str.push((0,_checker_is_plain_object_js__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .Q)(v) ? buildQuery(v, k) : enc(k) + '=' + enc(v));
        }
    }
    return str.join('&');
};


/***/ }),

/***/ 44730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    symbols: 'caractère'
});


/***/ }),

/***/ 44850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    Spellcheck: 'Helyesírás-ellenőrzés'
});


/***/ }),

/***/ 45124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Qe: function() { return /* binding */ cursorInTheEdgeOfString; },
/* harmony export */   W8: function() { return /* reexport safe */ _move_node_inside_start_js__WEBPACK_IMPORTED_MODULE_2__.W; },
/* harmony export */   dY: function() { return /* binding */ findCorrectCurrentNode; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _move_node_inside_start_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26716);
/* harmony import */ var _move_the_node_along_the_edge_outward_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43463);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module selection
 */ 



/**
 * Check if the cursor is at the edge of the string
 * @private
 */ function cursorInTheEdgeOfString(container, offset, start, end) {
    var _a;
    const text = ((_a = container.nodeValue) === null || _a === void 0 ? void 0 : _a.length) ? container.nodeValue : '';
    if (end && text.replace((0,_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE_REG_EXP_END)(), '').length > offset) {
        return true;
    }
    const inv = (0,_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE_REG_EXP_START)().exec(text);
    return start && (inv && inv[0].length < offset || !inv && offset > 0);
}
function findCorrectCurrentNode(node, range, rightMode, isCollapsed, checkChild, child) {
    node = range.startContainer.childNodes[range.startOffset];
    if (!node) {
        node = range.startContainer.childNodes[range.startOffset - 1];
        rightMode = true;
    }
    if (node && isCollapsed && !_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isText(node)) {
        // test Current method - Cursor in the left of some SPAN
        if (!rightMode && _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isText(node.previousSibling)) {
            node = node.previousSibling;
        } else if (checkChild) {
            let current = child(node);
            while(current){
                if (current && _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isText(current)) {
                    node = current;
                    break;
                }
                current = child(current);
            }
        }
    }
    if (node && !isCollapsed && !_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isText(node)) {
        let leftChild = node, rightChild = node;
        do {
            leftChild = leftChild.firstChild;
            rightChild = rightChild.lastChild;
        }while (leftChild && rightChild && !_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isText(leftChild))
        if (leftChild === rightChild && leftChild && _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isText(leftChild)) {
            node = leftChild;
        }
    }
    return {
        node,
        rightMode
    };
}


/***/ }),

/***/ 45219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   d: function() { return /* reexport safe */ autobind_decorator__WEBPACK_IMPORTED_MODULE_0__.Ay; }
/* harmony export */ });
/* harmony import */ var autobind_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40401);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * [[include:core/decorators/autobind/README.md]]
 * @packageDocumentation
 * @module decorators/autobind
 */ 


/***/ }),

/***/ 45235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   allowAttributes: function() { return /* reexport safe */ _allow_attributes_js__WEBPACK_IMPORTED_MODULE_0__.f; },
/* harmony export */   fillEmptyParagraph: function() { return /* reexport safe */ _fill_empty_paragraph_js__WEBPACK_IMPORTED_MODULE_1__.f; },
/* harmony export */   removeEmptyTextNode: function() { return /* reexport safe */ _remove_empty_text_node_js__WEBPACK_IMPORTED_MODULE_2__.r; },
/* harmony export */   removeInvTextNodes: function() { return /* reexport safe */ _remove_inv_text_nodes_js__WEBPACK_IMPORTED_MODULE_3__.u; },
/* harmony export */   replaceOldTags: function() { return /* reexport safe */ _replace_old_tags_js__WEBPACK_IMPORTED_MODULE_4__.H; },
/* harmony export */   sanitizeAttributes: function() { return /* reexport safe */ _sanitize_attributes_js__WEBPACK_IMPORTED_MODULE_5__.L; },
/* harmony export */   tryRemoveNode: function() { return /* reexport safe */ _try_remove_node_js__WEBPACK_IMPORTED_MODULE_6__.k; }
/* harmony export */ });
/* harmony import */ var _allow_attributes_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82558);
/* harmony import */ var _fill_empty_paragraph_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39433);
/* harmony import */ var _remove_empty_text_node_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53392);
/* harmony import */ var _remove_inv_text_nodes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25813);
/* harmony import */ var _replace_old_tags_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80973);
/* harmony import */ var _sanitize_attributes_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(384);
/* harmony import */ var _try_remove_node_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28800);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/clean-html
 */ /**
 * @private
 */ 








/***/ }),

/***/ 45575:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"><path d=\"M1600 736v192q0 40-28 68t-68 28h-416v416q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-416h-416q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h416v-416q0-40 28-68t68-28h192q40 0 68 28t28 68v416h416q40 0 68 28t28 68z\"/></svg> ");


/***/ }),

/***/ 45603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   M: function() { return /* binding */ isLicense; }
/* harmony export */ });
/* harmony import */ var _is_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70799);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/checker
 */ 
const isLicense = (license)=>(0,_is_string_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .K)(license) && license.length === 23 && /^[a-z0-9]{5}-[a-z0-9]{5}-[a-z0-9]{5}-[a-z0-9]{5}$/i.test(license);


/***/ }),

/***/ 45927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export size */
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65478);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_checker_is_number_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84767);
/* harmony import */ var _core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41180);
/* harmony import */ var _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20356);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80792);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






/**
 * Calculate sizes for editor workspace and handle setHeight and setWidth events
 */ let size = class size extends _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_2__/* .Plugin */ .k {
    afterInit(editor) {
        editor.e.on('setHeight.size', this.__setHeight).on('setWidth.size', this.__setWidth).on('afterInit.size changePlace.size', this.__initialize, {
            top: true
        }).on(editor.ow, 'load.size', this.__resizeWorkspaces).on('afterInit.size resize.size afterUpdateToolbar.size ' + 'scroll.size afterResize.size', this.__resizeWorkspaces).on('toggleFullSize.size toggleToolbar.size', this.__resizeWorkspaceImd);
        this.__initialize();
    }
    /**
     * Set editor size by options
     */ __initialize() {
        const { j } = this;
        if (j.o.inline) {
            return;
        }
        let { height } = j.o;
        if (j.o.saveHeightInStorage && height !== 'auto') {
            const localHeight = j.storage.get('height');
            if (localHeight) {
                height = localHeight;
            }
        }
        (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_4__/* .css */ .A)(j.editor, {
            minHeight: '100%'
        });
        (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_4__/* .css */ .A)(j.container, {
            minHeight: j.o.minHeight,
            maxHeight: j.o.maxHeight,
            minWidth: j.o.minWidth,
            maxWidth: j.o.maxWidth
        });
        if (!j.isFullSize) {
            this.__setHeight(height);
            this.__setWidth(j.o.width);
        }
    }
    /**
     * Manually change height
     */ __setHeight(height) {
        const { clientHeight, clientWidth } = this.j.container;
        if ((0,_core_helpers_checker_is_number_js__WEBPACK_IMPORTED_MODULE_5__/* .isNumber */ .E)(height)) {
            const { minHeight, maxHeight } = this.j.o;
            if ((0,_core_helpers_checker_is_number_js__WEBPACK_IMPORTED_MODULE_5__/* .isNumber */ .E)(minHeight) && minHeight > height) {
                height = minHeight;
            }
            if ((0,_core_helpers_checker_is_number_js__WEBPACK_IMPORTED_MODULE_5__/* .isNumber */ .E)(maxHeight) && maxHeight < height) {
                height = maxHeight;
            }
        }
        (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_4__/* .css */ .A)(this.j.container, 'height', height);
        if (this.j.o.saveHeightInStorage) {
            this.j.storage.set('height', height);
        }
        this.__resizeWorkspaceImd({
            clientHeight,
            clientWidth
        });
    }
    /**
     * Manually change width
     */ __setWidth(width) {
        const { clientHeight, clientWidth } = this.j.container;
        if ((0,_core_helpers_checker_is_number_js__WEBPACK_IMPORTED_MODULE_5__/* .isNumber */ .E)(width)) {
            const { minWidth, maxWidth } = this.j.o;
            if ((0,_core_helpers_checker_is_number_js__WEBPACK_IMPORTED_MODULE_5__/* .isNumber */ .E)(minWidth) && minWidth > width) {
                width = minWidth;
            }
            if ((0,_core_helpers_checker_is_number_js__WEBPACK_IMPORTED_MODULE_5__/* .isNumber */ .E)(maxWidth) && maxWidth < width) {
                width = maxWidth;
            }
        }
        (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_4__/* .css */ .A)(this.j.container, 'width', width);
        this.__resizeWorkspaceImd({
            clientHeight,
            clientWidth
        });
    }
    /**
     * Returns service spaces: toolbar + statusbar
     */ __getNotWorkHeight() {
        var _a, _b;
        return (((_a = this.j.toolbarContainer) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0) + (((_b = this.j.statusbar) === null || _b === void 0 ? void 0 : _b.getHeight()) || 0) + 2;
    }
    /**
     * Calculate workspace height
     */ __resizeWorkspaceImd({ clientHeight, clientWidth } = this.j.container) {
        if (!this.j || this.j.isDestructed || !this.j.o || this.j.o.inline) {
            return;
        }
        if (!this.j.container || !this.j.container.parentNode) {
            return;
        }
        const minHeight = ((0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_4__/* .css */ .A)(this.j.container, 'minHeight') || 0) - this.__getNotWorkHeight();
        if ((0,_core_helpers_checker_is_number_js__WEBPACK_IMPORTED_MODULE_5__/* .isNumber */ .E)(minHeight) && minHeight > 0) {
            [
                this.j.workplace,
                this.j.iframe,
                this.j.editor
            ].map((elm)=>{
                elm && (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_4__/* .css */ .A)(elm, 'minHeight', minHeight);
            });
            this.j.e.fire('setMinHeight', minHeight);
        }
        if ((0,_core_helpers_checker_is_number_js__WEBPACK_IMPORTED_MODULE_5__/* .isNumber */ .E)(this.j.o.maxHeight)) {
            const maxHeight = this.j.o.maxHeight - this.__getNotWorkHeight();
            [
                this.j.workplace,
                this.j.iframe,
                this.j.editor
            ].map((elm)=>{
                elm && (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_4__/* .css */ .A)(elm, 'maxHeight', maxHeight);
            });
            this.j.e.fire('setMaxHeight', maxHeight);
        }
        if (this.j.container) {
            (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_4__/* .css */ .A)(this.j.workplace, 'height', this.j.o.height !== 'auto' || this.j.isFullSize ? this.j.container.offsetHeight - this.__getNotWorkHeight() : 'auto');
        }
        const { clientHeight: newClientHeight, clientWidth: newClientWidth } = this.j.container;
        if (clientHeight !== newClientHeight || clientWidth !== newClientWidth) {
            this.j.e.fire(this.j, 'resize');
        }
    }
    /** @override **/ beforeDestruct(jodit) {
        jodit.e.off(jodit.ow, 'load.size', this.__resizeWorkspaces).off('.size');
    }
    constructor(){
        super(...arguments);
        /**
         * Debounced wrapper for resizeWorkspaceImd
         */ this.__resizeWorkspaces = this.j.async.debounce(this.__resizeWorkspaceImd, this.j.defaultTimeout, true);
    }
};
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.throttle)()
], size.prototype, "__initialize", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], size.prototype, "__resizeWorkspaceImd", null);
size = __decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], size);

_core_global_js__WEBPACK_IMPORTED_MODULE_1__/* .pluginSystem */ .fg.add('size', size);


/***/ }),

/***/ 45971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   H: function() { return /* binding */ nl2br; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/html
 */ /**
 *  Inserts HTML line breaks before all newlines in a string
 */ function nl2br(html) {
    return html.replace(/\r\n|\r|\n/g, '<br/>');
}


/***/ }),

/***/ 46104:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M896 1152q0-36-20-69-1-1-15.5-22.5t-25.5-38-25-44-21-50.5q-4-16-21-16t-21 16q-7 23-21 50.5t-25 44-25.5 38-15.5 22.5q-20 33-20 69 0 53 37.5 90.5t90.5 37.5 90.5-37.5 37.5-90.5zm512-128q0 212-150 362t-362 150-362-150-150-362q0-145 81-275 6-9 62.5-90.5t101-151 99.5-178 83-201.5q9-30 34-47t51-17 51.5 17 33.5 47q28 93 83 201.5t99.5 178 101 151 62.5 90.5q81 127 81 275z\"/> </svg> ");


/***/ }),

/***/ 46124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   removeExtraBr: function() { return /* reexport safe */ _remove_extra_br_js__WEBPACK_IMPORTED_MODULE_0__.z; }
/* harmony export */ });
/* harmony import */ var _remove_extra_br_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94870);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/dtd
 * @internal
 */ 


/***/ }),

/***/ 46295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    'Line height': 'Altura de la línea'
});


/***/ }),

/***/ 46334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   r: function() { return /* binding */ normalizeSize; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/normalize
 */ /**
 * Normalize value to CSS meters
 */ const normalizeSize = (value, units)=>{
    if (/^[0-9]+$/.test(value.toString())) {
        return value + units;
    }
    return value.toString();
};


/***/ }),

/***/ 46448:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _about_about_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73391);
/* harmony import */ var _backspace_backspace_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93183);
/* harmony import */ var _delete_delete_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66707);
/* harmony import */ var _bold_bold_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41107);
/* harmony import */ var _color_color_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93079);
/* harmony import */ var _enter_enter_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(575);
/* harmony import */ var _font_font_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23399);
/* harmony import */ var _format_block_format_block_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96111);
/* harmony import */ var _hotkeys_hotkeys_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42263);
/* harmony import */ var _iframe_iframe_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77469);
/* harmony import */ var _image_image_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(23531);
/* harmony import */ var _inline_popup_inline_popup_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93401);
/* harmony import */ var _link_link_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(65517);
/* harmony import */ var _ordered_list_ordered_list_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(64837);
/* harmony import */ var _placeholder_placeholder_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(59451);
/* harmony import */ var _powered_by_jodit_powered_by_jodit_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(18363);
/* harmony import */ var _redo_undo_redo_undo_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(6687);
/* harmony import */ var _size_size_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(45927);
/* harmony import */ var _stat_stat_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(7309);
/* harmony import */ var _table_table_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(43003);
/* harmony import */ var _wrap_nodes_wrap_nodes_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(72253);
/* harmony import */ var _dtd_dtd_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(65735);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * [[include:plugins/README.md]]
 * @packageDocumentation
 * @module plugins
 */ 

// import 'jodit/plugins/debug/debug';






















/***/ }),

/***/ 46559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   u: function() { return /* binding */ splitArray; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * Return an array from string or array
 * ```javascript
 * Jodit.modules.Helpers.splitArray('1,2,3') // ['1', '2', '3']
 * Jodit.modules.Helpers.splitArray(['1', '2', '3']) // ['1', '2', '3']
 * ```
 */ function splitArray(a) {
    return Array.isArray(a) ? a : a.split(/[,\s]+/);
}


/***/ }),

/***/ 46614:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_helpers_checker_is_boolean_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87612);
/* harmony import */ var _core_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70799);
/* harmony import */ var _core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29960);
/* harmony import */ var _core_helpers_utils_data_bind_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86583);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6441);
/* harmony import */ var _helpers_api_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26532);
/* harmony import */ var _helpers_recognize_manager_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93602);
/* harmony import */ var _speech_recognize_svg_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75259);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 








_config_js__WEBPACK_IMPORTED_MODULE_3__/* .Config */ .T.prototype.speechRecognize = {
    api: typeof _helpers_api_js__WEBPACK_IMPORTED_MODULE_4__/* .SpeechRecognition */ .o !== 'undefined' ? _helpers_api_js__WEBPACK_IMPORTED_MODULE_4__/* .SpeechRecognition */ .o : null,
    sound: true,
    continuous: false,
    interimResults: true,
    commands: {
        'newline|enter': 'enter',
        'delete|remove word|delete word': 'backspaceWordButton',
        comma: 'inserthtml::,',
        underline: 'inserthtml::_',
        hyphen: 'inserthtml::-',
        space: 'inserthtml:: ',
        question: 'inserthtml::?',
        dot: 'inserthtml::.',
        'quote|quotes|open quote': "inserthtml::'",
        'header|header h1': 'formatblock::h1',
        'select all': 'selectall'
    }
};
_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .I.set('speech-recognize', _speech_recognize_svg_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A);
_config_js__WEBPACK_IMPORTED_MODULE_3__/* .Config */ .T.prototype.controls.speechRecognize = {
    isVisible (j) {
        return Boolean(j.o.speechRecognize.api);
    },
    isActive (jodit, _) {
        const api = (0,_core_helpers_utils_data_bind_js__WEBPACK_IMPORTED_MODULE_1__/* .dataBind */ .m)(jodit, 'speech');
        return Boolean(api === null || api === void 0 ? void 0 : api.isEnabled);
    },
    isDisabled (jodit) {
        return !jodit.o.speechRecognize.api;
    },
    exec (jodit, current, { button, control }) {
        var _a;
        const { api: ApiConstructor, lang, continuous, interimResults, sound } = jodit.o.speechRecognize;
        if (!ApiConstructor) {
            jodit.alert('Speech recognize API unsupported in your browser');
            return;
        }
        let api = (0,_core_helpers_utils_data_bind_js__WEBPACK_IMPORTED_MODULE_1__/* .dataBind */ .m)(jodit, 'speech');
        if (!api) {
            const nativeApi = new ApiConstructor();
            api = new _helpers_recognize_manager_js__WEBPACK_IMPORTED_MODULE_5__/* .RecognizeManager */ .g(jodit.async, nativeApi);
            api.lang = (0,_core_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_7__/* .isString */ .K)(lang) ? lang : (_a = (0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__/* .attr */ .C)(jodit.od.documentElement, 'lang')) !== null && _a !== void 0 ? _a : undefined;
            api.continuous = continuous;
            api.interimResults = interimResults;
            api.sound = sound;
            (0,_core_helpers_utils_data_bind_js__WEBPACK_IMPORTED_MODULE_1__/* .dataBind */ .m)(jodit, 'speech', api);
            api.on('pulse', (enable)=>{
                button.setMod('pulse', enable);
            });
            api.on('result', (text)=>jodit.e.fire('speechRecognizeResult', text));
            api.on('progress', (text)=>jodit.e.fire('speechRecognizeProgressResult', text));
            api.on('error', (text)=>jodit.message.error(text));
            button.hookStatus('beforeDestruct', ()=>{
                (0,_core_helpers_utils_data_bind_js__WEBPACK_IMPORTED_MODULE_1__/* .dataBind */ .m)(jodit, 'speech', null);
                api.destruct();
            });
        }
        if (control.args) {
            const key = control.args[0];
            if ((0,_core_helpers_checker_is_boolean_js__WEBPACK_IMPORTED_MODULE_8__/* .isBoolean */ .L)(api[key])) {
                api[key] = !api[key];
                if (api.isEnabled) {
                    api.restart();
                }
                return;
            }
        }
        api.toggle();
        if (api.isEnabled) {
            button.setMod('pulse', true);
        }
        button.state.activated = api.isEnabled;
    },
    name: 'speechRecognize',
    command: 'toggleSpeechRecognize',
    tooltip: 'Speech Recognize',
    list: {
        sound: 'Sound',
        interimResults: 'Interim Results'
    },
    childTemplate (jodit, key, value) {
        var _a;
        const api = (0,_core_helpers_utils_data_bind_js__WEBPACK_IMPORTED_MODULE_1__/* .dataBind */ .m)(jodit, 'speech'), checked = (_a = api === null || api === void 0 ? void 0 : api[key]) !== null && _a !== void 0 ? _a : jodit.o.speechRecognize[key];
        return `<span class='jodit-speech-recognize__list-item'><input ${checked ? 'checked' : ''} class='jodit-checkbox' type='checkbox'>&nbsp;${value}</span>`;
    },
    mods: {
        stroke: false
    }
};


/***/ }),

/***/ 46776:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6441);
/* harmony import */ var _eraser_svg_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44330);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.cleanHTML = {
    timeout: 300,
    removeEmptyElements: true,
    fillEmptyParagraph: true,
    replaceNBSP: true,
    replaceOldTags: {
        i: 'em',
        b: 'strong'
    },
    allowTags: false,
    denyTags: 'script',
    useIframeSandbox: false,
    removeOnError: true,
    safeJavaScriptLink: true,
    disableCleanFilter: null
};
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.controls.eraser = {
    command: 'removeFormat',
    tooltip: 'Clear Formatting'
};
_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_0__/* .Icon */ .I.set('eraser', _eraser_svg_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A);


/***/ }),

/***/ 46788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Bj: function() { return /* reexport safe */ _helpers__WEBPACK_IMPORTED_MODULE_2__.Bj; },
/* harmony export */   GW: function() { return /* reexport safe */ _apply_styles_pro__WEBPACK_IMPORTED_MODULE_0__.G; },
/* harmony export */   i: function() { return /* reexport safe */ _helpers__WEBPACK_IMPORTED_MODULE_2__.i; },
/* harmony export */   jh: function() { return /* reexport safe */ _helpers__WEBPACK_IMPORTED_MODULE_2__.jh; },
/* harmony export */   lT: function() { return /* reexport safe */ _calc_list_levels__WEBPACK_IMPORTED_MODULE_1__.l; }
/* harmony export */ });
/* harmony import */ var _apply_styles_pro__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60181);
/* harmony import */ var _calc_list_levels__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91126);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48430);
/* harmony import */ var _transform_word_to_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56869);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */






/***/ }),

/***/ 47193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    aiAssistant: 'AI Assistant',
    aiCommands: 'AI Commands',
    'AI Assistant': 'AI Assistant',
    Prompt: 'Prompt',
    'Ask AI to improve generated text': 'Ask AI to improve generated text',
    Submit: 'Submit'
});


/***/ }),

/***/ 47615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    symbols: 'Simbolo'
});


/***/ }),

/***/ 47686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   O: function() { return /* reexport safe */ _on_tab_inside_li_js__WEBPACK_IMPORTED_MODULE_0__.O; }
/* harmony export */ });
/* harmony import */ var _on_tab_inside_li_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26658);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/tab
 */ 


/***/ }),

/***/ 47749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   E: function() { return /* binding */ readMargins; }
/* harmony export */ });
/* harmony import */ var _core_helpers_string_kebab_case_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12475);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/image-properties
 */ 
/** @private */ function readMargins(image, values, state) {
    // Margins
    let equal = true, wasEmptyField = false;
    [
        'marginTop',
        'marginRight',
        'marginBottom',
        'marginLeft'
    ].forEach((id)=>{
        let value = image.style.getPropertyValue((0,_core_helpers_string_kebab_case_js__WEBPACK_IMPORTED_MODULE_0__/* .kebabCase */ .k)(id));
        if (!value) {
            wasEmptyField = true;
            values[id] = 0;
            return;
        }
        if (/^[0-9]+(px)?$/.test(value)) {
            value = parseInt(value, 10);
        }
        values[id] = value;
        if (wasEmptyField && values[id] || equal && id !== 'marginTop' && values[id] !== values.marginTop) {
            equal = false;
        }
    });
    state.marginIsLocked = equal;
}


/***/ }),

/***/ 48038:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/sticky
 */ 
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.toolbarSticky = true;
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.toolbarDisableStickyForMobile = true;
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.toolbarStickyOffset = 0;


/***/ }),

/***/ 48430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Bj: function() { return /* binding */ convertUnitToPx; },
/* harmony export */   i: function() { return /* binding */ calcMarginParts; },
/* harmony export */   jh: function() { return /* binding */ calcStartBySymbol; },
/* harmony export */   x0: function() { return /* binding */ realPixelIndent; }
/* harmony export */ });
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */
function calcMarginParts(margin) {
    if (!margin) {
        return [0, 0, 0, 0];
    }
    const widths = margin.match(/(0|auto|(-?[.\d]+(?:\w+|%)))/g) || ['0px'];
    switch (widths.length) {
        case 2:
            return [0, 1, 0, 1].map((index) => widths[index]);
        case 3:
            return [0, 1, 2, 1].map((index) => widths[index]);
        case 4:
            return [0, 1, 2, 3].map((index) => widths[index]);
        default:
            return [0, 0, 0, 0].map((index) => widths[index]);
    }
}
let fakeMeasureBox;
/**
 * Convert css units to pixels, excluding percentages
 * @example
 * ```js
 * convertUnitToPx('55pt')
 * convertUnitToPx('55cm')
 * ```
 */
function convertUnitToPx(unit) {
    if (typeof unit === 'number') {
        return unit;
    }
    if (/%$/.test(unit)) {
        return 0;
    }
    if (!fakeMeasureBox) {
        fakeMeasureBox = document.createElement('div');
        Object.assign(fakeMeasureBox.style, {
            position: 'absolute',
            left: '-9999px',
            top: '-9999px',
            margin: '0',
            padding: '0',
            border: '0'
        });
        document.body.append(fakeMeasureBox);
        // Clean after work
        setTimeout(() => {
            fakeMeasureBox?.remove();
            fakeMeasureBox = null;
        });
    }
    const isNegative = parseFloat(unit) < 0;
    if (isNegative) {
        unit = unit.replace('-', '');
    }
    fakeMeasureBox.style.width = unit;
    const result = fakeMeasureBox.clientWidth;
    if (isNegative) {
        return -result;
    }
    return result;
}
function realPixelIndent(element) {
    const { style } = element;
    let marginSplit = [0, 0, 0, 0];
    const marginKeys = style.keys.filter((k) => /margin/.test(k));
    const maxMarginLeftIndex = Math.max(marginKeys.indexOf('margin-left'), marginKeys.indexOf('margin'));
    const marginKey = maxMarginLeftIndex > 0 ? marginKeys[maxMarginLeftIndex] : 'margin-left';
    let marginLeft;
    if (marginKey === 'margin') {
        const margin = style.get('margin');
        marginSplit = calcMarginParts(margin);
        marginLeft = marginSplit[3] || 0;
    }
    else {
        marginLeft = style.get(marginKey) || 0;
    }
    return convertUnitToPx(marginLeft);
}
function calcStartBySymbol(symbol) {
    if (/\d.\d/.test(symbol)) {
        return symbol.split('.').pop() || null;
    }
    if (/^\d/.test(symbol)) {
        return (parseInt(symbol, 10) || 1).toString();
    }
    return null;
}


/***/ }),

/***/ 48538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   D: function() { return /* binding */ UIElement; }
/* harmony export */ });
/* harmony import */ var _component_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91907);
/* harmony import */ var _decorators_derive_derive_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55153);
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70799);
/* harmony import */ var _traits_elms_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14316);
/* harmony import */ var _traits_mods_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34176);
/* harmony import */ var _icon_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12153);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var UIElement_1;







let UIElement = UIElement_1 = class UIElement extends _component_index_js__WEBPACK_IMPORTED_MODULE_0__/* .ViewComponent */ .vG {
    get parentElement() {
        return this.__parentElement;
    }
    set parentElement(parentElement) {
        this.__parentElement = parentElement;
        if (parentElement) {
            parentElement.hookStatus('beforeDestruct', ()=>this.destruct());
        }
        this.updateParentElement(this);
    }
    bubble(callback) {
        let parent = this.parentElement;
        while(parent){
            callback(parent);
            parent = parent.parentElement;
        }
        return this;
    }
    updateParentElement(target) {
        var _a;
        (_a = this.__parentElement) === null || _a === void 0 ? void 0 : _a.updateParentElement(target);
        return this;
    }
    /** @override */ get(chain, obj) {
        return super.get(chain, obj) || this.getElm(chain);
    }
    /**
     * Find match parent
     */ closest(type) {
        const c = typeof type === 'object' ? (pe)=>pe === type : (pe)=>_component_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA.isInstanceOf(pe, type);
        let pe = this.__parentElement;
        while(pe){
            if (c(pe)) {
                return pe;
            }
            if (!pe.parentElement && pe.container.parentElement) {
                pe = UIElement_1.closestElement(pe.container.parentElement, UIElement_1);
            } else {
                pe = pe.parentElement;
            }
        }
        return null;
    }
    /**
     * Find closest UIElement in DOM
     */ static closestElement(node, type) {
        const elm = _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.up(node, (elm)=>{
            if (elm) {
                const { component } = elm;
                return component && _component_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA.isInstanceOf(component, type);
            }
            return false;
        });
        return elm ? elm === null || elm === void 0 ? void 0 : elm.component : null;
    }
    /**
     * Update UI from state
     */ update() {
    // empty
    }
    /**
     * Append container to element
     */ appendTo(element) {
        element.appendChild(this.container);
        return this;
    }
    /**
     * Valid name only with valid chars
     */ clearName(name) {
        return name.replace(/[^a-zA-Z0-9]/g, '_');
    }
    /**
     * Method create only box
     */ render(options) {
        return this.j.c.div(this.componentName);
    }
    /**
     * Create main HTML container
     */ createContainer(options) {
        const result = this.render(options);
        if ((0,_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__/* .isString */ .K)(result)) {
            const elm = this.parseTemplate(result);
            elm.classList.add(this.componentName);
            return elm;
        }
        return result;
    }
    parseTemplate(result) {
        return this.j.c.fromHTML(result.replace(/\*([^*]+?)\*/g, (_, name)=>_icon_js__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .I.get(name) || '').replace(/&_/g, this.componentName + '_').replace(/~([^~]+?)~/g, (_, s)=>this.i18n(s)));
    }
    /** @override */ destruct() {
        _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(this.container);
        this.parentElement = null;
        return super.destruct();
    }
    /** @override */ constructor(jodit, options){
        super(jodit);
        this.name = '';
        this.__parentElement = null;
        this.mods = {};
        this.container = this.createContainer(options);
        Object.defineProperty(this.container, 'component', {
            value: this,
            configurable: true
        });
    }
};
UIElement = UIElement_1 = __decorate([
    (0,_decorators_derive_derive_js__WEBPACK_IMPORTED_MODULE_5__/* .derive */ .C)(_traits_mods_js__WEBPACK_IMPORTED_MODULE_6__/* .Mods */ .K, _traits_elms_js__WEBPACK_IMPORTED_MODULE_2__/* .Elms */ .O)
], UIElement);



/***/ }),

/***/ 48591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   k: function() { return /* binding */ makeInstance; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23282);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/**
 * Create instance of plugin
 * @private
 */ function makeInstance(jodit, plugin) {
    try {
        try {
            // @ts-ignore
            return (0,_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_1__/* .isFunction */ .T)(plugin) ? new plugin(jodit) : plugin;
        } catch (e) {
            if ((0,_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_1__/* .isFunction */ .T)(plugin) && !plugin.prototype) {
                return plugin(jodit);
            }
        }
    } catch (e) {
        console.error(e);
        if (!_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD) {
            throw e;
        }
    }
    return null;
}


/***/ }),

/***/ 49033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   j: function() { return /* binding */ normalizeKeyAliases; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _string_trim_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49055);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/**
 * Normalize keys to some standard name
 */ function normalizeKeyAliases(keys) {
    const memory = {};
    const order = {
        meta: 1,
        ctrl: 2,
        control: 2,
        alt: 3,
        shift: 4,
        space: 5
    };
    return keys.replace(/\+\+/g, '+add').split(/[\s]*\+[\s]*/).map((key)=>(0,_string_trim_js__WEBPACK_IMPORTED_MODULE_1__/* .trim */ .Bq)(key.toLowerCase())).map((key)=>_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_ALIASES[key] || key).sort((a, b)=>{
        if (order[a] && !order[b]) {
            return -1;
        }
        if (!order[a] && order[b]) {
            return 1;
        }
        if (order[a] && order[b]) {
            return order[a] - order[b];
        }
        return a > b ? 1 : -1;
    }).filter((key)=>!memory[key] && key !== '' && (memory[key] = true)).join('+');
}


/***/ }),

/***/ 49055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Bq: function() { return /* binding */ trim; },
/* harmony export */   Gd: function() { return /* binding */ trimChars; },
/* harmony export */   gj: function() { return /* binding */ trimInv; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/string
 */ 
/**
 * It clears the line of all auxiliary invisible characters , from the spaces and line breaks , tabs
 * from the beginning and end of the line
 */ function trim(value) {
    return value.replace((0,_constants_js__WEBPACK_IMPORTED_MODULE_0__.SPACE_REG_EXP_END)(), '').replace((0,_constants_js__WEBPACK_IMPORTED_MODULE_0__.SPACE_REG_EXP_START)(), '');
}
function trimChars(value, chars) {
    return value.replace(RegExp(`[${chars}]+$`), '').replace(RegExp(`^[${chars}]+`), '');
}
/**
 * Trim only invisible chars
 */ function trimInv(value) {
    return value.replace((0,_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE_REG_EXP_END)(), '').replace((0,_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE_REG_EXP_START)(), '');
}


/***/ }),

/***/ 49155:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1728 608v704q0 92-66 158t-158 66h-1216q-92 0-158-66t-66-158v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h672q92 0 158 66t66 158z\"/> </svg> ");


/***/ }),

/***/ 49399:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg viewBox=\"0 0 1792 1792\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M1088 1256v240q0 16-12 28t-28 12h-240q-16 0-28-12t-12-28v-240q0-16 12-28t28-12h240q16 0 28 12t12 28zm316-600q0 54-15.5 101t-35 76.5-55 59.5-57.5 43.5-61 35.5q-41 23-68.5 65t-27.5 67q0 17-12 32.5t-28 15.5h-240q-15 0-25.5-18.5t-10.5-37.5v-45q0-83 65-156.5t143-108.5q59-27 84-56t25-76q0-42-46.5-74t-107.5-32q-65 0-108 29-35 25-107 115-13 16-31 16-12 0-25-8l-164-125q-13-10-15.5-25t5.5-28q160-266 464-266 80 0 161 31t146 83 106 127.5 41 158.5z\"/> </svg> ");


/***/ }),

/***/ 49759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    symbols: 'Symbolit'
});


/***/ }),

/***/ 49841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    symbols: 'Szimbólum'
});


/***/ }),

/***/ 49922:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M621 1280h595v-595zm-45-45l595-595h-595v595zm1152 77v192q0 14-9 23t-23 9h-224v224q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-224h-864q-14 0-23-9t-9-23v-864h-224q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h224v-224q0-14 9-23t23-9h192q14 0 23 9t9 23v224h851l246-247q10-9 23-9t23 9q9 10 9 23t-9 23l-247 246v851h224q14 0 23 9t9 23z\"/> </svg> ");


/***/ }),

/***/ 49996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   E: function() { return /* binding */ FiniteStateMachine; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70799);
/* harmony import */ var _helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38837);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/**
 * A state machine implementation for applying styles.
 */ class FiniteStateMachine {
    setState(state) {
        (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_1__/* .assert */ .v)(!this.__previewsStates.has(state), 'Circled states');
        this.__previewsStates.add(state);
        this.__state = state;
    }
    getState() {
        return this.__state;
    }
    disableSilent() {
        this.silent = false;
    }
    dispatch(actionName, value) {
        const action = this.transitions[this.getState()][actionName];
        if (action) {
            const res = action.call(this, value);
            (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_1__/* .assert */ .v)(res && res !== value, 'Action should return new value');
            (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_1__/* .assert */ .v)((0,_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .K)(res.next), 'Value should contain the next state');
            (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_1__/* .assert */ .v)(res.next !== this.getState(), 'The new state should not be equal to the old one.');
            this.setState(res.next);
            if (!_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD && !this.silent) {
                // eslint-disable-next-line no-console
                console.log(`State: ${this.getState()}`);
            }
            return res;
        }
        throw new Error(`invalid action: ${this.getState()}.${actionName.toString()}`);
    }
    constructor(state, transitions){
        this.transitions = transitions;
        this.silent = true;
        this.__previewsStates = new Set();
        this.setState(state);
    }
}


/***/ }),

/***/ 50050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B: function() { return /* binding */ openImageEditor; },
/* harmony export */   n: function() { return /* binding */ ImageEditor; }
/* harmony export */ });
/* harmony import */ var _core_component_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91907);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22732);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21537);
/* harmony import */ var _core_ui_button_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62843);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6441);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62489);
/* harmony import */ var _templates_form_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22461);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ImageEditor_1;








const jie = 'jodit-image-editor';
const TABS = {
    resize: 'resize',
    crop: 'crop'
};
/**
 * The module allows you to edit the image: resize or cut any part of it
 *
 */ let ImageEditor = ImageEditor_1 = class ImageEditor extends _core_component_index_js__WEBPACK_IMPORTED_MODULE_0__/* .ViewComponent */ .vG {
    /** @override */ className() {
        return 'ImageEditor';
    }
    get o() {
        return this.options;
    }
    /**
     * Hide image editor
     */ hide() {
        this._dialog.close();
    }
    /**
     * Open image editor
     * @example
     * ```javascript
     * const jodit = Jodit.make('.editor', {
     *		 imageeditor: {
     *				 crop: false,
     *				 closeAfterSave: true,
     *				 width: 500
     *		 }
     * });
     * jodit.imageeditor.open('https://xdsoft.net/jodit/images/test.png', function (name, data, success, failed) {
     *		 var img = jodit.node.c('img');
     *		 img.setAttribute('src', 'https://xdsoft.net/jodit/images/test.png');
     *		 if (box.action !== 'resize') {
     *					return failed('Sorry it is work only in resize mode. For croping use FileBrowser');
     *		 }
     *		 img.style.width = data.w;
     *		 img.style.height = data.h;
     *		 jodit.s.insertNode(img);
     *		 success();
     * });
     * ```
     */ open(url, save) {
        return this.j.async.promise((resolve)=>{
            const timestamp = new Date().getTime();
            this.image = this.j.c.element('img');
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.$$)('img,.jodit-icon_loader', this.resize_box).forEach(_core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove);
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.$$)('img,.jodit-icon_loader', this.crop_box).forEach(_core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove);
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(this.cropHandler, 'background', 'transparent');
            this.onSave = save;
            this.resize_box.appendChild(this.j.c.element('i', {
                class: 'jodit-icon_loader'
            }));
            this.crop_box.appendChild(this.j.c.element('i', {
                class: 'jodit-icon_loader'
            }));
            if (/\?/.test(url)) {
                url += '&_tst=' + timestamp;
            } else {
                url += '?_tst=' + timestamp;
            }
            this.image.setAttribute('src', url);
            this._dialog.open();
            const { widthInput, heightInput } = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.refs)(this.editor);
            const onload = ()=>{
                if (this.isDestructed) {
                    return;
                }
                this.image.removeEventListener('load', onload);
                this.naturalWidth = this.image.naturalWidth;
                this.naturalHeight = this.image.naturalHeight;
                widthInput.value = this.naturalWidth.toString();
                heightInput.value = this.naturalHeight.toString();
                this.ratio = this.naturalWidth / this.naturalHeight;
                this.resize_box.appendChild(this.image);
                this.cropImage = this.image.cloneNode(true);
                this.crop_box.appendChild(this.cropImage);
                _core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove.apply(null, (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.$$)('.jodit-icon_loader', this.editor));
                if (this.activeTab === TABS.crop) {
                    this.showCrop();
                }
                this.j.e.fire(this.resizeHandler, 'updatesize');
                this.j.e.fire(this.cropHandler, 'updatesize');
                this._dialog.setPosition();
                this.j.e.fire('afterImageEditor');
                resolve(this._dialog);
            };
            this.image.addEventListener('load', onload);
            if (this.image.complete) {
                onload();
            }
        });
    }
    onTitleModeClick(e) {
        const self = this, title = e.target;
        const slide = title === null || title === void 0 ? void 0 : title.parentElement;
        if (!slide) {
            return;
        }
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.$$)(`.${jie}__slider,.${jie}__area`, self.editor).forEach((elm)=>elm.classList.remove(`${jie}_active`));
        slide.classList.add(`${jie}_active`);
        this.activeTab = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(slide, '-area') || TABS.resize;
        const tab = self.editor.querySelector(`.${jie}__area.${jie}__area_` + self.activeTab);
        if (tab) {
            tab.classList.add(`${jie}_active`);
        }
        if (self.activeTab === TABS.crop) {
            self.showCrop();
        }
    }
    onChangeSizeInput(e) {
        const self = this, input = e.target, { widthInput, heightInput } = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.refs)(this.editor), isWidth = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(input, 'data-ref') === 'widthInput', x = parseInt(input.value, 10), minX = isWidth ? self.o.min_width : self.o.min_height, minY = !isWidth ? self.o.min_width : self.o.min_height;
        let y;
        if (x > minX) {
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(self.image, isWidth ? 'width' : 'height', x);
            if (self.resizeUseRatio) {
                y = isWidth ? Math.round(x / self.ratio) : Math.round(x * self.ratio);
                if (y > minY) {
                    (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(self.image, !isWidth ? 'width' : 'height', y);
                    if (isWidth) {
                        heightInput.value = y.toString();
                    } else {
                        widthInput.value = y.toString();
                    }
                }
            }
        }
        this.j.e.fire(self.resizeHandler, 'updatesize');
    }
    onResizeHandleMouseDown(e) {
        const self = this;
        self.target = e.target;
        e.preventDefault();
        e.stopImmediatePropagation();
        self.clicked = true;
        self.start_x = e.clientX;
        self.start_y = e.clientY;
        if (self.activeTab === TABS.crop) {
            self.top_x = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(self.cropHandler, 'left');
            self.top_y = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(self.cropHandler, 'top');
            self.width = self.cropHandler.offsetWidth;
            self.height = self.cropHandler.offsetHeight;
        } else {
            self.width = self.image.offsetWidth;
            self.height = self.image.offsetHeight;
        }
        self.j.e.on(this.j.ow, 'mousemove', this.onGlobalMouseMove).one(this.j.ow, 'mouseup', this.onGlobalMouseUp);
    }
    onGlobalMouseUp(e) {
        if (this.clicked) {
            this.clicked = false;
            e.stopImmediatePropagation();
            this.j.e.off(this.j.ow, 'mousemove', this.onGlobalMouseMove);
        }
    }
    onGlobalMouseMove(e) {
        const self = this;
        if (!self.clicked) {
            return;
        }
        const { widthInput, heightInput } = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.refs)(this.editor);
        self.diff_x = e.clientX - self.start_x;
        self.diff_y = e.clientY - self.start_y;
        if (self.activeTab === TABS.resize && self.resizeUseRatio || self.activeTab === TABS.crop && self.cropUseRatio) {
            if (self.diff_x) {
                self.new_w = self.width + self.diff_x;
                self.new_h = Math.round(self.new_w / self.ratio);
            } else {
                self.new_h = self.height + self.diff_y;
                self.new_w = Math.round(self.new_h * self.ratio);
            }
        } else {
            self.new_w = self.width + self.diff_x;
            self.new_h = self.height + self.diff_y;
        }
        if (self.activeTab === TABS.resize) {
            if (self.new_w > self.o.resizeMinWidth) {
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(self.image, 'width', self.new_w + 'px');
                widthInput.value = self.new_w.toString();
            }
            if (self.new_h > self.o.resizeMinHeight) {
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(self.image, 'height', self.new_h + 'px');
                heightInput.value = self.new_h.toString();
            }
            this.j.e.fire(self.resizeHandler, 'updatesize');
        } else {
            if (self.target !== self.cropHandler) {
                if (self.top_x + self.new_w > self.cropImage.offsetWidth) {
                    self.new_w = self.cropImage.offsetWidth - self.top_x;
                }
                if (self.top_y + self.new_h > self.cropImage.offsetHeight) {
                    self.new_h = self.cropImage.offsetHeight - self.top_y;
                }
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(self.cropHandler, {
                    width: self.new_w,
                    height: self.new_h
                });
            } else {
                if (self.top_x + self.diff_x + self.cropHandler.offsetWidth > self.cropImage.offsetWidth) {
                    self.diff_x = self.cropImage.offsetWidth - self.top_x - self.cropHandler.offsetWidth;
                }
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(self.cropHandler, 'left', self.top_x + self.diff_x);
                if (self.top_y + self.diff_y + self.cropHandler.offsetHeight > self.cropImage.offsetHeight) {
                    self.diff_y = self.cropImage.offsetHeight - self.top_y - self.cropHandler.offsetHeight;
                }
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(self.cropHandler, 'top', self.top_y + self.diff_y);
            }
            this.j.e.fire(self.cropHandler, 'updatesize');
        }
    }
    /** @override */ destruct() {
        if (this.isDestructed) {
            return;
        }
        if (this._dialog && !this._dialog.isInDestruct) {
            this._dialog.destruct();
        }
        _core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(this.editor);
        if (this.j.e) {
            this.j.e.off(this.j.ow, 'mousemove', this.onGlobalMouseMove).off(this.j.ow, 'mouseup', this.onGlobalMouseUp).off(this.ow, `.${jie}`).off(`.${jie}`);
        }
        super.destruct();
    }
    constructor(editor){
        super(editor);
        this.resizeUseRatio = true;
        this.cropUseRatio = true;
        this.clicked = false;
        this.start_x = 0;
        this.start_y = 0;
        this.top_x = 0;
        this.top_y = 0;
        this.width = 0;
        this.height = 0;
        this.activeTab = TABS.resize;
        this.naturalWidth = 0;
        this.naturalHeight = 0;
        this.ratio = 0;
        this.new_h = 0;
        this.new_w = 0;
        this.diff_x = 0;
        this.diff_y = 0;
        this.cropBox = {
            x: 0,
            y: 0,
            w: 0,
            h: 0
        };
        this.resizeBox = {
            w: 0,
            h: 0
        };
        this.calcCropBox = ()=>{
            const node = this.crop_box.parentNode, w = node.offsetWidth * 0.8, h = node.offsetHeight * 0.8;
            let wn = w, hn = h;
            const { naturalWidth: nw, naturalHeight: nh } = this;
            if (w > nw && h > nh) {
                wn = nw;
                hn = nh;
            } else if (this.ratio > w / h) {
                wn = w;
                hn = nh * (w / nw);
            } else {
                wn = nw * (h / nh);
                hn = h;
            }
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(this.crop_box, {
                width: wn,
                height: hn
            });
        };
        this.showCrop = ()=>{
            if (!this.cropImage) {
                return;
            }
            this.calcCropBox();
            const w = this.cropImage.offsetWidth || this.image.offsetWidth || this.image.naturalWidth;
            this.new_w = ImageEditor_1.calcValueByPercent(w, this.o.cropDefaultWidth);
            const h = this.cropImage.offsetHeight || this.image.offsetHeight || this.image.naturalHeight;
            if (this.cropUseRatio) {
                this.new_h = this.new_w / this.ratio;
            } else {
                this.new_h = ImageEditor_1.calcValueByPercent(h, this.o.cropDefaultHeight);
            }
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(this.cropHandler, {
                backgroundImage: 'url(' + (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(this.cropImage, 'src') + ')',
                width: this.new_w,
                height: this.new_h,
                left: w / 2 - this.new_w / 2,
                top: h / 2 - this.new_h / 2
            });
            this.j.e.fire(this.cropHandler, 'updatesize');
        };
        this.updateCropBox = ()=>{
            if (!this.cropImage) {
                return;
            }
            const ratioX = this.cropImage.offsetWidth / this.naturalWidth, ratioY = this.cropImage.offsetHeight / this.naturalHeight;
            this.cropBox.x = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(this.cropHandler, 'left') / ratioX;
            this.cropBox.y = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(this.cropHandler, 'top') / ratioY;
            this.cropBox.w = this.cropHandler.offsetWidth / ratioX;
            this.cropBox.h = this.cropHandler.offsetHeight / ratioY;
            this.sizes.textContent = this.cropBox.w.toFixed(0) + 'x' + this.cropBox.h.toFixed(0);
        };
        this.updateResizeBox = ()=>{
            this.resizeBox.w = this.image.offsetWidth || this.naturalWidth;
            this.resizeBox.h = this.image.offsetHeight || this.naturalHeight;
        };
        this.setHandlers = ()=>{
            const self = this;
            const { widthInput, heightInput } = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.refs)(this.editor);
            self.j.e.on([
                self.editor.querySelector('.jodit_bottomright'),
                self.cropHandler
            ], `mousedown.${jie}`, this.onResizeHandleMouseDown).on(this.j.ow, `resize.${jie}`, ()=>{
                this.j.e.fire(self.resizeHandler, 'updatesize');
                self.showCrop();
                this.j.e.fire(self.cropHandler, 'updatesize');
            });
            self.j.e.on((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.toArray)(this.editor.querySelectorAll(`.${jie}__slider-title`)), 'click', this.onTitleModeClick).on([
                widthInput,
                heightInput
            ], 'input', this.onChangeSizeInput);
            const { keepAspectRatioResize, keepAspectRatioCrop } = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.refs)(this.editor);
            if (keepAspectRatioResize) {
                keepAspectRatioResize.addEventListener('change', ()=>{
                    this.resizeUseRatio = keepAspectRatioResize.checked;
                });
            }
            if (keepAspectRatioCrop) {
                keepAspectRatioCrop.addEventListener('change', ()=>{
                    this.cropUseRatio = keepAspectRatioCrop.checked;
                });
            }
            self.j.e.on(self.resizeHandler, 'updatesize', ()=>{
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(self.resizeHandler, {
                    top: 0,
                    left: 0,
                    width: self.image.offsetWidth || self.naturalWidth,
                    height: self.image.offsetHeight || self.naturalHeight
                });
                this.updateResizeBox();
            }).on(self.cropHandler, 'updatesize', ()=>{
                if (!self.cropImage) {
                    return;
                }
                let new_x = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(self.cropHandler, 'left'), new_y = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(self.cropHandler, 'top'), new_width = self.cropHandler.offsetWidth, new_height = self.cropHandler.offsetHeight;
                if (new_x < 0) {
                    new_x = 0;
                }
                if (new_y < 0) {
                    new_y = 0;
                }
                if (new_x + new_width > self.cropImage.offsetWidth) {
                    new_width = self.cropImage.offsetWidth - new_x;
                    if (self.cropUseRatio) {
                        new_height = new_width / self.ratio;
                    }
                }
                if (new_y + new_height > self.cropImage.offsetHeight) {
                    new_height = self.cropImage.offsetHeight - new_y;
                    if (self.cropUseRatio) {
                        new_width = new_height * self.ratio;
                    }
                }
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(self.cropHandler, {
                    width: new_width,
                    height: new_height,
                    left: new_x,
                    top: new_y,
                    backgroundPosition: -new_x - 1 + 'px ' + (-new_y - 1) + 'px',
                    backgroundSize: self.cropImage.offsetWidth + 'px ' + self.cropImage.offsetHeight + 'px'
                });
                self.updateCropBox();
            });
            Object.values(self.buttons).forEach((button)=>{
                button.onAction(()=>{
                    const data = {
                        action: self.activeTab,
                        box: self.activeTab === TABS.resize ? self.resizeBox : self.cropBox
                    };
                    switch(button){
                        case self.buttons.saveas:
                            self.j.prompt('Enter new name', 'Save in new file', (name)=>{
                                if (!(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.trim)(name)) {
                                    self.j.alert('The name should not be empty');
                                    return false;
                                }
                                self.onSave(name, data, self.hide, (e)=>{
                                    self.j.alert(e.message);
                                });
                            });
                            break;
                        case self.buttons.save:
                            self.onSave(undefined, data, self.hide, (e)=>{
                                self.j.alert(e.message);
                            });
                            break;
                        case self.buttons.reset:
                            if (self.activeTab === TABS.resize) {
                                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(self.image, {
                                    width: null,
                                    height: null
                                });
                                widthInput.value = self.naturalWidth.toString();
                                heightInput.value = self.naturalHeight.toString();
                                self.j.e.fire(self.resizeHandler, 'updatesize');
                            } else {
                                self.showCrop();
                            }
                            break;
                    }
                });
            });
        };
        this.options = editor && editor.o && editor.o.imageeditor ? editor.o.imageeditor : _config_js__WEBPACK_IMPORTED_MODULE_5__/* .Config */ .T.defaultOptions.imageeditor;
        const o = this.options;
        this.resizeUseRatio = o.resizeUseRatio;
        this.cropUseRatio = o.cropUseRatio;
        this.buttons = {
            reset: (0,_core_ui_button_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .$n)(this.j, 'update', 'Reset'),
            save: (0,_core_ui_button_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .$n)(this.j, 'save', 'Save'),
            saveas: (0,_core_ui_button_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .$n)(this.j, 'save', 'Save as ...')
        };
        this.activeTab = o.resize ? TABS.resize : TABS.crop;
        this.editor = (0,_templates_form_js__WEBPACK_IMPORTED_MODULE_7__/* .form */ .Z)(this.j, this.options);
        const { resizeBox, cropBox } = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.refs)(this.editor);
        this.resize_box = resizeBox;
        this.crop_box = cropBox;
        this.sizes = this.editor.querySelector(`.${jie}__area.${jie}__area_crop .jodit-image-editor__sizes`);
        this.resizeHandler = this.editor.querySelector(`.${jie}__resizer`);
        this.cropHandler = this.editor.querySelector(`.${jie}__croper`);
        this._dialog = this.j.dlg({
            buttons: [
                'fullsize',
                'dialog.close'
            ]
        });
        this._dialog.setContent(this.editor);
        this._dialog.setSize(this.o.width, this.o.height);
        this._dialog.setHeader([
            this.buttons.reset,
            this.buttons.save,
            this.buttons.saveas
        ]);
        this.setHandlers();
    }
};
ImageEditor.calcValueByPercent = (value, percent)=>{
    const percentStr = percent.toString();
    const valueNbr = parseFloat(value.toString());
    let match;
    match = /^[-+]?[0-9]+(px)?$/.exec(percentStr);
    if (match) {
        return parseInt(percentStr, 10);
    }
    match = /^([-+]?[0-9.]+)%$/.exec(percentStr);
    if (match) {
        return Math.round(valueNbr * (parseFloat(match[1]) / 100));
    }
    return valueNbr || 0;
};
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], ImageEditor.prototype, "hide", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], ImageEditor.prototype, "open", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], ImageEditor.prototype, "onTitleModeClick", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.debounce)(),
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], ImageEditor.prototype, "onChangeSizeInput", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], ImageEditor.prototype, "onResizeHandleMouseDown", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], ImageEditor.prototype, "onGlobalMouseUp", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.throttle)(10)
], ImageEditor.prototype, "onGlobalMouseMove", null);
ImageEditor = ImageEditor_1 = __decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.component
], ImageEditor);

/**
 * Open Image Editor
 */ function openImageEditor(href, name, path, source, onSuccess, onFailed) {
    return this.getInstance('ImageEditor', this.o).open(href, (newname, box, success, failed)=>(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.call)(box.action === 'resize' ? this.dataProvider.resize : this.dataProvider.crop, path, source, name, newname, box.box).then((ok)=>{
            if (ok) {
                success();
                if (onSuccess) {
                    onSuccess();
                }
            }
        }).catch((error)=>{
            failed(error);
            if (onFailed) {
                onFailed(error);
            }
        }));
}


/***/ }),

/***/ 50267:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path stroke-width=\"0\" d=\"M384 1408q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm0-512q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1408 416v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5zm-1408-928q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1408 416v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5zm0-512v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5z\"/> </svg> ");


/***/ }),

/***/ 50373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   d: function() { return /* binding */ processOldBrowserDrag; }
/* harmony export */ });
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22732);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21537);
/* harmony import */ var _data_uri_to_blob_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74569);
/* harmony import */ var _send_files_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80020);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 





function processOldBrowserDrag(self, cData, handlerSuccess, handlerError, onFinally) {
    if (cData && (!cData.types.length || cData.types[0] !== _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.TEXT_PLAIN)) {
        const div = self.j.c.div('', {
            tabindex: -1,
            style: 'left: -9999px; top: 0; width: 0; height: 100%;line-height: 140%; ' + 'overflow: hidden; position: fixed; z-index: 2147483647; word-break: break-all;',
            contenteditable: true
        });
        (0,_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .getContainer */ .My)(self.j, self.constructor).appendChild(div);
        const selection = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isJoditObject)(self.j) ? self.j.s.save() : null, restore = ()=>selection && (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isJoditObject)(self.j) && self.j.s.restore();
        div.focus();
        self.j.async.setTimeout(()=>{
            const child = div.firstChild;
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(div);
            if (child && child.hasAttribute('src')) {
                const src = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(child, 'src') || '';
                restore();
                (0,_send_files_js__WEBPACK_IMPORTED_MODULE_4__/* .sendFiles */ ._)(self, [
                    (0,_data_uri_to_blob_js__WEBPACK_IMPORTED_MODULE_5__/* .dataURItoBlob */ .z)(src)
                ], handlerSuccess, handlerError).finally(onFinally);
            }
        }, self.j.defaultTimeout);
    }
}


/***/ }),

/***/ 50535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   d: function() { return /* binding */ LimitedStack; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ class LimitedStack {
    push(item) {
        this.stack.push(item);
        if (this.stack.length > this.limit) {
            this.stack.shift();
        }
        return this;
    }
    pop() {
        return this.stack.pop();
    }
    find(clb) {
        return this.stack.find(clb);
    }
    constructor(limit){
        this.limit = limit;
        this.stack = [];
    }
}


/***/ }),

/***/ 50911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   k: function() { return /* reexport safe */ _plugin_js__WEBPACK_IMPORTED_MODULE_0__.k; }
/* harmony export */ });
/* harmony import */ var _plugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20356);
/* harmony import */ var _plugin_system_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41876);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugin
 */ 



/***/ }),

/***/ 50963:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/iframe
 */ 
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.iframeBaseUrl = '';
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.iframeTitle = 'Jodit Editor';
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.iframeDoctype = '<!DOCTYPE html>';
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.iframeDefaultSrc = 'about:blank';
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.iframeStyle = 'html{' + 'margin:0;' + 'padding:0;' + 'min-height: 100%;' + '}' + 'body{' + 'box-sizing:border-box;' + 'font-size:13px;' + 'line-height:1.6;' + 'padding:10px;' + 'margin:0;' + 'background:transparent;' + 'color:#000;' + 'position:' + 'relative;' + 'z-index:2;' + 'user-select:auto;' + 'margin:0px;' + 'overflow:auto;' + 'outline:none;' + '}' + 'table{' + 'width:100%;' + 'border:none;' + 'border-collapse:collapse;' + 'empty-cells: show;' + 'max-width: 100%;' + '}' + 'th,td{' + 'padding: 2px 5px;' + 'border:1px solid #ccc;' + '-webkit-user-select:text;' + '-moz-user-select:text;' + '-ms-user-select:text;' + 'user-select:text' + '}' + 'p{' + 'margin-top:0;' + '}' + '.jodit_editor .jodit_iframe_wrapper{' + 'display: block;' + 'clear: both;' + 'user-select: none;' + 'position: relative;' + '}' + '.jodit_editor .jodit_iframe_wrapper:after {' + 'position:absolute;' + 'content:"";' + 'z-index:1;' + 'top:0;' + 'left:0;' + 'right: 0;' + 'bottom: 0;' + 'cursor: pointer;' + 'display: block;' + 'background: rgba(0, 0, 0, 0);' + '} ' + '.jodit_disabled{' + 'user-select: none;' + '-o-user-select: none;' + '-moz-user-select: none;' + '-khtml-user-select: none;' + '-webkit-user-select: none;' + '-ms-user-select: none' + '}';
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.iframeCSSLinks = [];
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.iframeSandbox = null;


/***/ }),

/***/ 51036:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1395 1184q0 13-10 23l-50 50q-10 10-23 10t-23-10l-393-393-393 393q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l466 466q10 10 10 23z\"/> </svg> ");


/***/ }),

/***/ 51642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   g: function() { return /* binding */ readAlign; }
/* harmony export */ });
/* harmony import */ var _core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41180);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/**
 * @private
 */ function readAlign(image, values) {
    // Align
    if (image.style.cssFloat && [
        'left',
        'right'
    ].indexOf(image.style.cssFloat.toLowerCase()) !== -1) {
        values.align = (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_0__/* .css */ .A)(image, 'float');
    } else {
        if ((0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_0__/* .css */ .A)(image, 'display') === 'block' && image.style.marginLeft === 'auto' && image.style.marginRight === 'auto') {
            values.align = 'center';
        } else {
            values.align = '';
        }
    }
}


/***/ }),

/***/ 51804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    symbols: 'symbool'
});


/***/ }),

/***/ 51834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    'Line height': 'Altezza linea'
});


/***/ }),

/***/ 51855:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M176 223q-37-2-45-4l-3-88q13-1 40-1 60 0 112 4 132 7 166 7 86 0 168-3 116-4 146-5 56 0 86-2l-1 14 2 64v9q-60 9-124 9-60 0-79 25-13 14-13 132 0 13 .5 32.5t.5 25.5l1 229 14 280q6 124 51 202 35 59 96 92 88 47 177 47 104 0 191-28 56-18 99-51 48-36 65-64 36-56 53-114 21-73 21-229 0-79-3.5-128t-11-122.5-13.5-159.5l-4-59q-5-67-24-88-34-35-77-34l-100 2-14-3 2-86h84l205 10q76 3 196-10l18 2q6 38 6 51 0 7-4 31-45 12-84 13-73 11-79 17-15 15-15 41 0 7 1.5 27t1.5 31q8 19 22 396 6 195-15 304-15 76-41 122-38 65-112 123-75 57-182 89-109 33-255 33-167 0-284-46-119-47-179-122-61-76-83-195-16-80-16-237v-333q0-188-17-213-25-36-147-39zm1488 1409v-64q0-14-9-23t-23-9h-1472q-14 0-23 9t-9 23v64q0 14 9 23t23 9h1472q14 0 23-9t9-23z\"/> </svg> ");


/***/ }),

/***/ 52230:
/***/ (function(__unused_webpack_module, __webpack_exports__) {


/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'copy-format': '복사 형식'
});


/***/ }),

/***/ 52285:
/***/ (function(__unused_webpack_module, __webpack_exports__) {


/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'copy-format': 'کپی کردن قالب'
});


/***/ }),

/***/ 52507:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 24 24\" > <circle cx=\"12\" cy=\"12\" r=\"2.2\"/> <circle cx=\"12\" cy=\"5\" r=\"2.2\"/> <circle cx=\"12\" cy=\"19\" r=\"2.2\"/> </svg> ");


/***/ }),

/***/ 52604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   F: function() { return /* binding */ Snapshot; }
/* harmony export */ });
/* harmony import */ var _core_component_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91907);
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82758);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2748);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/**
 * Module for creating snapshot of editor which includes html content and the current selection
 */ class Snapshot extends _core_component_index_js__WEBPACK_IMPORTED_MODULE_0__/* .ViewComponent */ .vG {
    /** @override */ className() {
        return 'Snapshot';
    }
    /**
     * Compare two snapshotes, if and htmls and selections match, then return true
     *
     * @param first - the first snapshote
     * @param second - second shot
     */ static equal(first, second) {
        return first.html === second.html && JSON.stringify(first.range) === JSON.stringify(second.range);
    }
    /**
     * Calc count element before some node in parentNode. All text nodes are joined
     */ static countNodesBeforeInParent(elm) {
        if (!elm.parentNode) {
            return 0;
        }
        const elms = elm.parentNode.childNodes;
        let count = 0, previous = null;
        for(let j = 0; j < elms.length; j += 1){
            if (previous && !this.isIgnoredNode(elms[j]) && !(_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isText(previous) && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isText(elms[j]))) {
                count += 1;
            }
            if (elms[j] === elm) {
                return count;
            }
            previous = elms[j];
        }
        return 0;
    }
    /**
     * Calc normal offset in joined text nodes
     */ static strokeOffset(elm, offset) {
        while(_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isText(elm)){
            elm = elm.previousSibling;
            if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isText(elm) && elm.nodeValue) {
                offset += elm.nodeValue.length;
            }
        }
        return offset;
    }
    /**
     * Calc whole hierarchy path before some element in editor's tree
     */ calcHierarchyLadder(elm) {
        const counts = [];
        if (!elm || !elm.parentNode || !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isOrContains(this.j.editor, elm)) {
            return [];
        }
        while(elm && elm !== this.j.editor){
            if (elm && !Snapshot.isIgnoredNode(elm)) {
                counts.push(Snapshot.countNodesBeforeInParent(elm));
            }
            elm = elm.parentNode;
        }
        return counts.reverse();
    }
    getElementByLadder(ladder) {
        let n = this.j.editor, i;
        for(i = 0; n && i < ladder.length; i += 1){
            n = n.childNodes[ladder[i]];
        }
        return n;
    }
    get isBlocked() {
        return this.__isBlocked;
    }
    __block(enable) {
        this.__isBlocked = enable;
    }
    transaction(changes) {
        this.__block(true);
        this.__levelOfTransaction += 1;
        try {
            changes();
        } catch (e) {
            if (!_core_constants_js__WEBPACK_IMPORTED_MODULE_1__.IS_PROD) {
                throw e;
            }
        } finally{
            this.__levelOfTransaction -= 1;
            if (this.__levelOfTransaction === 0) {
                this.__block(false);
            }
        }
    }
    /**
     * Creates object a snapshot of editor: html and the current selection. Current selection calculate by
     * offset by start document
     * \{html: string, range: \{startContainer: int, startOffset: int, endContainer: int, endOffset: int\}\} or
     * \{html: string\} without selection
     */ make() {
        const snapshot = {
            html: '',
            range: {
                startContainer: [],
                startOffset: 0,
                endContainer: [],
                endOffset: 0
            }
        };
        snapshot.html = this.__getCleanedEditorValue(this.j.editor);
        const sel = this.j.s.sel;
        if (sel && sel.rangeCount) {
            const range = sel.getRangeAt(0);
            const startContainer = this.calcHierarchyLadder(range.startContainer);
            const endContainer = this.calcHierarchyLadder(range.endContainer);
            let startOffset = Snapshot.strokeOffset(range.startContainer, range.startOffset), endOffset = Snapshot.strokeOffset(range.endContainer, range.endOffset);
            if (!startContainer.length && range.startContainer !== this.j.editor) {
                startOffset = 0;
            }
            if (!endContainer.length && range.endContainer !== this.j.editor) {
                endOffset = 0;
            }
            snapshot.range = {
                startContainer,
                startOffset,
                endContainer,
                endOffset
            };
        }
        return snapshot;
    }
    /**
     * Restores the state of the editor of the snapshot. Rebounding is not only html but selected text
     *
     * @param snapshot - snapshot of editor resulting from the `[[Snapshot.make]]` method
     * @see make
     */ restore(snapshot) {
        this.transaction(()=>{
            const scroll = this.storeScrollState();
            const html = this.__getCleanedEditorValue(this.j.editor);
            if (html !== snapshot.html) {
                this.j.value = snapshot.html;
            }
            this.restoreOnlySelection(snapshot);
            this.restoreScrollState(scroll);
        });
    }
    storeScrollState() {
        return [
            this.j.ow.scrollY,
            this.j.editor.scrollTop
        ];
    }
    restoreScrollState(scrolls) {
        const { j } = this, { ow } = j;
        ow.scrollTo(ow.scrollX, scrolls[0]);
        j.editor.scrollTop = scrolls[1];
    }
    /**
     * Restore selection from snapshot
     *
     * @param snapshot - snapshot of editor resulting from the [[Snapshot.make]] method
     * @see make
     */ restoreOnlySelection(snapshot) {
        try {
            if (snapshot.range) {
                const range = this.j.ed.createRange();
                range.setStart(this.getElementByLadder(snapshot.range.startContainer), snapshot.range.startOffset);
                range.setEnd(this.getElementByLadder(snapshot.range.endContainer), snapshot.range.endOffset);
                this.j.s.selectRange(range);
            }
        } catch (__ignore) {
            this.j.editor.lastChild && this.j.s.setCursorAfter(this.j.editor.lastChild);
            if (!_core_constants_js__WEBPACK_IMPORTED_MODULE_1__.IS_PROD) {
                // tslint:disable-next-line:no-console
                console.warn('Broken snapshot', __ignore);
            }
        }
    }
    destruct() {
        this.__block(false);
        super.destruct();
    }
    static isIgnoredNode(node) {
        return _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isText(node) && !node.nodeValue || _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isTemporary(node);
    }
    __getCleanedEditorValue(node) {
        const clone = node.cloneNode(true);
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.temporaryList(clone).forEach(_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.unwrap);
        return clone.innerHTML;
    }
    constructor(){
        super(...arguments);
        this.__isBlocked = false;
        this.__levelOfTransaction = 0;
    }
}


/***/ }),

/***/ 52742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   l: function() { return /* binding */ isWindow; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/checker
 */ function isWindow(obj) {
    return obj != null && obj === obj.window;
}


/***/ }),

/***/ 52951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export source */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2748);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21537);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50911);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36204);
/* harmony import */ var _editor_factory_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70022);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









/**
 * Plug-in change simple textarea on CodeMirror editor in Source code mode
 */ class source extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_5__/* .Plugin */ .k {
    onInsertHTML(html) {
        var _a;
        if (!this.j.o.readonly && !this.j.isEditorMode()) {
            (_a = this.sourceEditor) === null || _a === void 0 ? void 0 : _a.insertRaw(html);
            this.toWYSIWYG();
            return false;
        }
    }
    /**
     * Update source editor from WYSIWYG area
     */ fromWYSIWYG(force = false) {
        if (!this.__lock || force === true) {
            this.__lock = true;
            const new_value = this.j.getEditorValue(false, _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.SOURCE_CONSUMER);
            if (new_value !== this.getMirrorValue()) {
                this.setMirrorValue(new_value);
            }
            this.__lock = false;
        }
    }
    /**
     * Update WYSIWYG area from source editor
     */ toWYSIWYG() {
        if (this.__lock) {
            return;
        }
        const value = this.getMirrorValue();
        if (value === this.__oldMirrorValue) {
            return;
        }
        this.__lock = true;
        this.j.value = value;
        this.__lock = false;
        this.__oldMirrorValue = value;
    }
    getNormalPosition(pos, str) {
        str = str.replace(/<(script|style|iframe)[^>]*>[^]*?<\/\1>/im, (m)=>{
            let res = '';
            for(let i = 0; i < m.length; i += 1){
                res += _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE;
            }
            return res;
        });
        while(pos > 0 && str[pos] === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE){
            pos--;
        }
        let start = pos;
        while(start > 0){
            start--;
            if (str[start] === '<' && str[start + 1] !== undefined && str[start + 1].match(/[\w/]+/i)) {
                return start;
            }
            if (str[start] === '>') {
                return pos;
            }
        }
        return pos;
    }
    clnInv(str) {
        return str.replace(_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE_REG_EXP(), '');
    }
    onSelectAll(command) {
        var _a;
        if (command.toLowerCase() === 'selectall' && this.j.getRealMode() === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_SOURCE) {
            (_a = this.sourceEditor) === null || _a === void 0 ? void 0 : _a.selectAll();
            return false;
        }
    }
    getMirrorValue() {
        var _a;
        return ((_a = this.sourceEditor) === null || _a === void 0 ? void 0 : _a.getValue()) || '';
    }
    setMirrorValue(value) {
        var _a;
        (_a = this.sourceEditor) === null || _a === void 0 ? void 0 : _a.setValue(value);
    }
    setFocusToMirror() {
        var _a;
        (_a = this.sourceEditor) === null || _a === void 0 ? void 0 : _a.focus();
    }
    saveSelection() {
        if (this.j.getRealMode() === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_WYSIWYG) {
            this.j.s.save();
            this.j.synchronizeValues();
            this.fromWYSIWYG(true);
        } else {
            if (this.j.o.editHTMLDocumentMode) {
                return;
            }
            const value = this.getMirrorValue();
            if (this.getSelectionStart() === this.getSelectionEnd()) {
                const marker = this.j.s.marker(true);
                const selectionStart = this.getNormalPosition(this.getSelectionStart(), this.getMirrorValue());
                this.setMirrorValue(value.substring(0, selectionStart) + this.clnInv(marker.outerHTML) + value.substring(selectionStart));
            } else {
                const markerStart = this.j.s.marker(true);
                const markerEnd = this.j.s.marker(false);
                const selectionStart = this.getNormalPosition(this.getSelectionStart(), value);
                const selectionEnd = this.getNormalPosition(this.getSelectionEnd(), value);
                this.setMirrorValue(value.slice(0, selectionStart) + this.clnInv(markerStart.outerHTML) + value.slice(selectionStart, selectionEnd) + this.clnInv(markerEnd.outerHTML) + value.slice(selectionEnd));
            }
            this.toWYSIWYG();
        }
    }
    removeSelection() {
        if (this.j.getRealMode() === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_WYSIWYG) {
            this.__lock = true;
            this.j.s.restore();
            this.__lock = false;
            return;
        }
        let value = this.getMirrorValue();
        let selectionStart = 0, selectionEnd = 0;
        try {
            value = value.replace(/<span[^>]+data-jodit-selection_marker=(["'])start\1[^>]*>[<>]*?<\/span>/gim, this.tempMarkerStart).replace(/<span[^>]+data-jodit-selection_marker=(["'])end\1[^>]*>[<>]*?<\/span>/gim, this.tempMarkerEnd);
            if (!this.j.o.editHTMLDocumentMode && this.j.o.beautifyHTML) {
                const html = this.j.e.fire('beautifyHTML', value);
                if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.isString)(html)) {
                    value = html;
                }
            }
            selectionStart = value.indexOf(this.tempMarkerStart);
            selectionEnd = selectionStart;
            value = value.replace(this.tempMarkerStartReg, '');
            if (selectionStart !== -1) {
                const selectionEndCursor = value.indexOf(this.tempMarkerEnd);
                if (selectionEndCursor !== -1) {
                    selectionEnd = selectionEndCursor;
                }
            }
            value = value.replace(this.tempMarkerEndReg, '');
        } finally{
            value = value.replace(this.tempMarkerEndReg, '').replace(this.tempMarkerStartReg, '');
        }
        this.setMirrorValue(value);
        this.setMirrorSelectionRange(selectionStart, selectionEnd);
        this.toWYSIWYG();
        this.setFocusToMirror(); // need for setting focus after change mode
    }
    setMirrorSelectionRange(start, end) {
        var _a;
        (_a = this.sourceEditor) === null || _a === void 0 ? void 0 : _a.setSelectionRange(start, end);
    }
    onReadonlyReact() {
        var _a;
        (_a = this.sourceEditor) === null || _a === void 0 ? void 0 : _a.setReadOnly(this.j.o.readonly);
    }
    /** @override */ afterInit(editor) {
        this.mirrorContainer = editor.c.div('jodit-source');
        editor.workplace.appendChild(this.mirrorContainer);
        editor.e.on('afterAddPlace changePlace afterInit', ()=>{
            editor.workplace.appendChild(this.mirrorContainer);
        });
        this.sourceEditor = (0,_editor_factory_js__WEBPACK_IMPORTED_MODULE_7__/* .createSourceEditor */ .b)('area', editor, this.mirrorContainer, this.toWYSIWYG, this.fromWYSIWYG);
        editor.e.on(editor.ow, 'keydown', (e)=>{
            var _a;
            if (e.key === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_ESC && ((_a = this.sourceEditor) === null || _a === void 0 ? void 0 : _a.isFocused)) {
                this.sourceEditor.blur();
            }
        });
        this.onReadonlyReact();
        editor.e.on('placeholder.source', (text)=>{
            var _a;
            (_a = this.sourceEditor) === null || _a === void 0 ? void 0 : _a.setPlaceHolder(text);
        }).on('change.source', this.syncValueFromWYSIWYG).on('beautifyHTML', (html)=>html);
        if (editor.o.beautifyHTML) {
            const addEventListener = ()=>{
                var _a;
                if (editor.isInDestruct) {
                    return false;
                }
                const html_beautify = editor.ow.html_beautify;
                if (html_beautify && !editor.isInDestruct) {
                    (_a = editor.events) === null || _a === void 0 ? void 0 : _a.off('beautifyHTML').on('beautifyHTML', (html)=>html_beautify(html));
                    return true;
                }
                return false;
            };
            if (!addEventListener()) {
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.loadNext)(editor, editor.o.beautifyHTMLCDNUrlsJS).then(addEventListener, ()=>null);
            }
        }
        this.syncValueFromWYSIWYG(true);
        this.initSourceEditor(editor);
    }
    syncValueFromWYSIWYG(force = false) {
        const editor = this.j;
        if (editor.getMode() === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_SPLIT || editor.getMode() === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_SOURCE) {
            this.fromWYSIWYG(force);
        }
    }
    initSourceEditor(editor) {
        var _a;
        if (editor.o.sourceEditor !== 'area') {
            const sourceEditor = (0,_editor_factory_js__WEBPACK_IMPORTED_MODULE_7__/* .createSourceEditor */ .b)(editor.o.sourceEditor, editor, this.mirrorContainer, this.toWYSIWYG, this.fromWYSIWYG);
            sourceEditor.onReadyAlways(()=>{
                var _a, _b;
                (_a = this.sourceEditor) === null || _a === void 0 ? void 0 : _a.destruct();
                this.sourceEditor = sourceEditor;
                this.syncValueFromWYSIWYG(true);
                (_b = editor.events) === null || _b === void 0 ? void 0 : _b.fire('sourceEditorReady', editor);
            });
        } else {
            (_a = this.sourceEditor) === null || _a === void 0 ? void 0 : _a.onReadyAlways(()=>{
                var _a;
                this.syncValueFromWYSIWYG(true);
                (_a = editor.events) === null || _a === void 0 ? void 0 : _a.fire('sourceEditorReady', editor);
            });
        }
    }
    /** @override */ beforeDestruct() {
        if (this.sourceEditor) {
            this.sourceEditor.destruct();
            delete this.sourceEditor;
        }
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(this.mirrorContainer);
    }
    constructor(){
        super(...arguments);
        /** @override */ this.buttons = [
            {
                name: 'source',
                group: 'source'
            }
        ];
        this.__lock = false;
        this.__oldMirrorValue = '';
        this.tempMarkerStart = '{start-jodit-selection}';
        this.tempMarkerStartReg = /{start-jodit-selection}/g;
        this.tempMarkerEnd = '{end-jodit-selection}';
        this.tempMarkerEndReg = /{end-jodit-selection}/g;
        // override it for ace editors
        this.getSelectionStart = ()=>{
            var _a, _b;
            return (_b = (_a = this.sourceEditor) === null || _a === void 0 ? void 0 : _a.getSelectionStart()) !== null && _b !== void 0 ? _b : 0;
        };
        this.getSelectionEnd = ()=>{
            var _a, _b;
            return (_b = (_a = this.sourceEditor) === null || _a === void 0 ? void 0 : _a.getSelectionEnd()) !== null && _b !== void 0 ? _b : 0;
        };
    }
}
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)(':insertHTML.source')
], source.prototype, "onInsertHTML", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], source.prototype, "fromWYSIWYG", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], source.prototype, "toWYSIWYG", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], source.prototype, "getNormalPosition", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)(':beforeCommand.source')
], source.prototype, "onSelectAll", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)(':beforeSetMode.source')
], source.prototype, "saveSelection", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)(':afterSetMode.source')
], source.prototype, "removeSelection", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], source.prototype, "setMirrorSelectionRange", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)(':readonly.source')
], source.prototype, "onReadonlyReact", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], source.prototype, "syncValueFromWYSIWYG", null);
_core_global_js__WEBPACK_IMPORTED_MODULE_3__/* .pluginSystem */ .fg.add('source', source);


/***/ }),

/***/ 52968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   S: function() { return /* reexport safe */ _area_js__WEBPACK_IMPORTED_MODULE_1__.S; },
/* harmony export */   p: function() { return /* reexport safe */ _ace_js__WEBPACK_IMPORTED_MODULE_0__.p; }
/* harmony export */ });
/* harmony import */ var _ace_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60031);
/* harmony import */ var _area_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7483);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/source
 */ 
 // export * from "./custom"; // You can add here another source editor


/***/ }),

/***/ 52995:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'Type something': 'Begin met typen..',
    Advanced: 'Geavanceerd',
    'About Jodit': 'Over Jodit',
    'Jodit Editor': 'Jodit Editor',
    'Free Non-commercial Version': 'Gratis niet-commerciële versie',
    "Jodit User's Guide": 'Jodit gebruikershandleiding',
    'contains detailed help for using': 'bevat gedetailleerde informatie voor gebruik.',
    'For information about the license, please go to our website:': 'Voor informatie over de licentie, ga naar onze website:',
    'Buy full version': 'Volledige versie kopen',
    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.': 'Copyright © XDSoft.net - Chupurnov Valeriy. Alle rechten voorbehouden.',
    Anchor: 'Anker',
    'Open in new tab': 'Open in nieuwe tab',
    'Open in fullsize': 'Editor in volledig scherm openen',
    'Clear Formatting': 'Opmaak verwijderen',
    'Fill color or set the text color': 'Vulkleur of tekstkleur aanpassen',
    Redo: 'Opnieuw',
    Undo: 'Ongedaan maken',
    Bold: 'Vet',
    Italic: 'Cursief',
    'Insert Unordered List': 'Geordende list invoegen',
    'Insert Ordered List': 'Ongeordende lijst invoegen',
    'Align Center': 'Centreren',
    'Align Justify': 'Uitlijnen op volledige breedte',
    'Align Left': 'Links uitlijnen',
    'Align Right': 'Rechts uitlijnen',
    'Insert Horizontal Line': 'Horizontale lijn invoegen',
    'Insert Image': 'Afbeelding invoegen',
    'Insert file': 'Bestand invoegen',
    'Insert youtube/vimeo video': 'Youtube/Vimeo video invoegen',
    'Insert link': 'Link toevoegen',
    'Font size': 'Tekstgrootte',
    'Font family': 'Lettertype',
    'Insert format block': 'Format blok invoegen',
    Normal: 'Normaal',
    'Heading 1': 'Koptekst 1',
    'Heading 2': 'Koptekst 2',
    'Heading 3': 'Koptekst 3',
    'Heading 4': 'Koptekst 4',
    Quote: 'Citaat',
    Code: 'Code',
    Insert: 'Invoegen',
    'Insert table': 'Tabel invoegen',
    'Decrease Indent': 'Inspringing verkleinen',
    'Increase Indent': 'Inspringing vergroten',
    'Select Special Character': 'Symbool selecteren',
    'Insert Special Character': 'Symbool invoegen',
    'Paint format': 'Opmaak kopieren',
    'Change mode': 'Modus veranderen',
    Margins: 'Marges',
    top: 'Boven',
    right: 'Rechts',
    bottom: 'Onder',
    left: 'Links',
    Styles: 'CSS styles',
    Classes: 'CSS classes',
    Align: 'Uitlijning',
    Right: 'Rechts',
    Center: 'Gecentreerd',
    Left: 'Links',
    '--Not Set--': '--Leeg--',
    Src: 'Src',
    Title: 'Titel',
    Alternative: 'Alternatieve tekst',
    Link: 'Link',
    'Open link in new tab': 'Link in nieuwe tab openen',
    Image: 'Afbeelding',
    file: 'Bestand',
    'Image properties': 'Afbeeldingseigenschappen',
    Cancel: 'Annuleren',
    Ok: 'OK',
    'Your code is similar to HTML. Keep as HTML?': 'Deze code lijkt op HTML. Als HTML behouden?',
    'Paste as HTML': 'Invoegen als HTML',
    Keep: 'Origineel behouden',
    Clean: 'Opschonen',
    'Insert as Text': 'Als tekst invoegen',
    'Word Paste Detected': 'Word-tekst gedetecteerd',
    'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?': 'De geplakte tekst is afkomstig van een Microsoft Word/Excel document. Wil je de opmaak behouden of opschonen?',
    'Insert only Text': 'Als onopgemaakte tekst invoegen',
    'File Browser': 'Bestandsbrowser',
    'Error on load list': 'Fout bij het laden van de lijst',
    'Error on load folders': 'Fout bij het laden van de mappenlijst',
    'Are you sure?': 'Weet je het zeker?',
    'Enter Directory name': 'Geef de map een naam',
    'Create directory': 'Map aanmaken',
    'type name': 'Type naam',
    'Drop image': 'Sleep hier een afbeelding naartoe',
    'Drop file': 'Sleep hier een bestand naartoe',
    'or click': 'of klik',
    'Alternative text': 'Alternatieve tekst',
    Browse: 'Bladeren',
    Upload: 'Uploaden',
    Background: 'Achtergrond',
    Text: 'Tekst',
    Top: 'Boven',
    Middle: 'Midden',
    Bottom: 'Onder',
    'Insert column before': 'Kolom invoegen (voor)',
    'Insert column after': 'Kolom invoegen (na)',
    'Insert row above': 'Rij invoegen (boven)',
    'Insert row below': 'Rij invoegen (onder)',
    'Delete table': 'Tabel verwijderen',
    'Delete row': 'Rij verwijderen',
    'Delete column': 'Kolom verwijderen',
    'Empty cell': 'Cel leegmaken',
    Delete: 'Verwijderen',
    'Strike through': 'Doorstrepen',
    Underline: 'Onderstrepen',
    Break: 'Enter',
    'Search for': 'Zoek naar',
    'Replace with': 'Vervangen door',
    Replace: 'Vervangen',
    Edit: 'Bewerken',
    'Vertical align': 'Verticaal uitlijnen',
    'Horizontal align': 'Horizontaal uitlijnen',
    Filter: 'Filteren',
    'Sort by changed': 'Sorteren op wijzigingsdatum',
    'Sort by name': 'Sorteren op naam',
    'Sort by size': 'Sorteren op grootte',
    'Add folder': 'Map toevoegen',
    Split: 'Splitsen',
    'Split vertical': 'Verticaal splitsen',
    'Split horizontal': 'Horizontaal splitsen',
    Merge: 'Samenvoegen',
    'Add column': 'Kolom toevoegen',
    'Add row': 'Rij toevoegen',
    Border: 'Rand',
    'Embed code': 'Embed code',
    Update: 'Updaten',
    superscript: 'Superscript',
    subscript: 'Subscript',
    'Cut selection': 'Selectie knippen',
    Paste: 'Plakken',
    'Choose Content to Paste': 'Kies content om te plakken',
    'Chars: %d': 'Tekens: %d',
    'Words: %d': 'Woorden: %d',
    All: 'Alles',
    'Select %s': 'Selecteer: %s',
    'Select all': 'Selecteer alles',
    source: 'Broncode',
    bold: 'vet',
    italic: 'cursief',
    brush: 'kwast',
    link: 'link',
    undo: 'ongedaan maken',
    redo: 'opnieuw',
    table: 'tabel',
    image: 'afbeelding',
    eraser: 'gum',
    paragraph: 'paragraaf',
    fontsize: 'lettergrootte',
    video: 'video',
    font: 'lettertype',
    about: 'over',
    print: 'afdrukken',
    underline: 'onderstreept',
    strikethrough: 'doorgestreept',
    indent: 'inspringen',
    outdent: 'minder inspringen',
    fullsize: 'volledige grootte',
    shrink: 'kleiner maken',
    hr: 'horizontale lijn',
    ul: 'lijst',
    ol: 'genummerde lijst',
    cut: 'knip',
    selectall: 'alles selecteren',
    'Open link': 'Link openen',
    'Edit link': 'Link aanpassen',
    'No follow': 'Niet volgen',
    Unlink: 'link verwijderen',
    Eye: 'Recensie',
    pencil: 'Om te bewerken',
    ' URL': ' URL',
    Reset: 'Herstellen',
    Save: 'Opslaan',
    'Save as ...': 'Opslaan als ...',
    Resize: 'Grootte aanpassen',
    Crop: 'Bijknippen',
    Width: 'Breedte',
    Height: 'Hoogte',
    'Keep Aspect Ratio': 'Verhouding behouden',
    Yes: 'Ja',
    No: 'Nee',
    Remove: 'Verwijderen',
    Select: 'Selecteren',
    'You can only edit your own images. Download this image on the host?': 'Je kunt alleen je eigen afbeeldingen aanpassen. Deze afbeelding downloaden?',
    'The image has been successfully uploaded to the host!': 'De afbeelding is succesvol geüploadet!',
    palette: 'Palette',
    'There are no files': 'Er zijn geen bestanden in deze map.',
    Rename: 'Hernoemen',
    'Enter new name': 'Voer een nieuwe naam in',
    preview: 'Voorvertoning',
    download: 'Download',
    'Paste from clipboard': 'Plakken van klembord',
    "Your browser doesn't support direct access to the clipboard.": 'Uw browser ondersteunt geen directe toegang tot het klembord.',
    'Copy selection': 'Selectie kopiëren',
    copy: 'kopiëren',
    'Border radius': 'Border radius',
    'Show all': 'Toon alle',
    Apply: 'Toepassen',
    'Please fill out this field': 'Vul dit veld in',
    'Please enter a web address': 'Voer een webadres in',
    Default: 'Standaard',
    Circle: 'Cirkel',
    Dot: 'Punt',
    Quadrate: 'Kwadraat',
    Find: 'Zoeken',
    'Find Previous': 'Vorige Zoeken',
    'Find Next': 'Volgende Zoeken',
    'Insert className': 'Voeg de klassenaam in',
    'Press Alt for custom resizing': 'Druk op Alt voor aangepaste grootte'
});


/***/ }),

/***/ 53212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   w: function() { return /* binding */ cleanFromWord; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _array_to_array_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4510);
/* harmony import */ var _string_trim_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49055);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/html
 */ 



/**
 * The method automatically cleans up content from Microsoft Word and other HTML sources to ensure clean, compliant
 * content that matches the look and feel of the site.
 */ function cleanFromWord(html) {
    if (html.indexOf('<html ') !== -1) {
        html = html.substring(html.indexOf('<html '), html.length);
        html = html.substring(0, html.lastIndexOf('</html>') + '</html>'.length);
    }
    let convertedString = '';
    try {
        const div = _constants_js__WEBPACK_IMPORTED_MODULE_0__.globalDocument.createElement('div');
        div.innerHTML = html;
        const marks = [];
        if (div.firstChild) {
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.each(div, (node)=>{
                if (!node) {
                    return;
                }
                switch(node.nodeType){
                    case Node.ELEMENT_NODE:
                        switch(node.nodeName){
                            case 'STYLE':
                            case 'LINK':
                            case 'META':
                                marks.push(node);
                                break;
                            case 'W:SDT':
                            case 'W:SDTPR':
                            case 'FONT':
                                _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.unwrap(node);
                                break;
                            default:
                                (0,_array_to_array_js__WEBPACK_IMPORTED_MODULE_2__/* .toArray */ .$)(node.attributes).forEach((attr)=>{
                                    if ([
                                        'src',
                                        'href',
                                        'rel',
                                        'content'
                                    ].indexOf(attr.name.toLowerCase()) === -1) {
                                        node.removeAttribute(attr.name);
                                    }
                                });
                        }
                        break;
                    case Node.TEXT_NODE:
                        break;
                    default:
                        marks.push(node);
                }
            });
        }
        _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove.apply(null, marks);
        convertedString = div.innerHTML;
    } catch (e) {}
    if (convertedString) {
        html = convertedString;
    }
    html = html.split(/(\n)/).filter(_string_trim_js__WEBPACK_IMPORTED_MODULE_3__/* .trim */ .Bq).join('\n');
    return html.replace(/<(\/)?(html|colgroup|col|o:p)[^>]*>/g, '').replace(/<!--[^>]*>/g, '');
}


/***/ }),

/***/ 53213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   y: function() { return /* binding */ persistent; }
/* harmony export */ });
/* harmony import */ var _component_statuses_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78213);
/* harmony import */ var _helpers_checker_is_view_object_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39955);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

function persistent(target, propertyKey) {
    target.hookStatus(_component_statuses_js__WEBPACK_IMPORTED_MODULE_0__/* .STATUSES */ .f.ready, (component)=>{
        const jodit = (0,_helpers_checker_is_view_object_js__WEBPACK_IMPORTED_MODULE_1__/* .isViewObject */ .h)(component) ? component : component.jodit, storageKey = `${jodit.options.namespace}${component.componentName}_prop_${propertyKey}`, initialValue = component[propertyKey];
        Object.defineProperty(component, propertyKey, {
            get () {
                var _a;
                return (_a = jodit.storage.get(storageKey)) !== null && _a !== void 0 ? _a : initialValue;
            },
            set (value) {
                jodit.storage.set(storageKey, value);
            }
        });
    });
}


/***/ }),

/***/ 53253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K: function() { return /* binding */ AutocompleteItem; }
/* harmony export */ });
/* harmony import */ var jodit_esm_core_helpers_checker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27613);
/* harmony import */ var jodit_esm_core_ui_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48538);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */



class AutocompleteItem extends jodit_esm_core_ui_element__WEBPACK_IMPORTED_MODULE_1__/* .UIElement */ .D {
    /** @override */
    className() {
        return 'AutocompleteItem';
    }
    constructor(jodit, item) {
        super(jodit);
        this.item = item;
        const { container } = this;
        if ((0,jodit_esm_core_helpers_checker__WEBPACK_IMPORTED_MODULE_0__/* .isFunction */ .Tn)(item.itemRenderer)) {
            const elm = item.itemRenderer(item);
            if ((0,jodit_esm_core_helpers_checker__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .Kg)(elm)) {
                container.innerHTML = elm;
            }
            else {
                container.appendChild(elm);
            }
        }
        else {
            container.innerText = item.title ?? item.value;
        }
    }
}


/***/ }),

/***/ 53259:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M5.09668 6.99707H7.17358L4.17358 3.99707L1.17358 6.99707H3.09668V17.0031H1.15881L4.15881 20.0031L7.15881 17.0031H5.09668V6.99707Z\"/> <path d=\"M22.8412 7H8.84119V5H22.8412V7Z\"/> <path d=\"M22.8412 11H8.84119V9H22.8412V11Z\"/> <path d=\"M8.84119 15H22.8412V13H8.84119V15Z\"/> <path d=\"M22.8412 19H8.84119V17H22.8412V19Z\"/> </svg> ");


/***/ }),

/***/ 53326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   G: function() { return /* binding */ htmlspecialchars; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/html
 */ 
/**
 * Convert special characters to HTML entities
 */ function htmlspecialchars(html) {
    const tmp = _constants_js__WEBPACK_IMPORTED_MODULE_0__.globalDocument.createElement('div');
    tmp.textContent = html;
    return tmp.innerHTML;
}


/***/ }),

/***/ 53361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    Spellcheck: 'Sprawdzanie pisowni'
});


/***/ }),

/***/ 53392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   r: function() { return /* binding */ removeEmptyTextNode; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/**
 * @private
 */ function removeEmptyTextNode(jodit, node, hadEffect, arg, argi, currentNode) {
    if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isText(node) && !node.nodeValue) {
        if (node === currentNode && jodit.s.isCollapsed()) {
            jodit.s.setCursorAfter(node);
        }
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(node);
        return true;
    }
    return hadEffect;
}


/***/ }),

/***/ 53437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    symbols: 'Symbol'
});


/***/ }),

/***/ 53636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   v: function() { return /* binding */ openImageEditorDialog; }
/* harmony export */ });
/* harmony import */ var _core_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70799);
/* harmony import */ var _core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29960);
/* harmony import */ var _modules_image_editor_image_editor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50050);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/**
 * Open image editor dialog
 * @private
 */ function openImageEditorDialog(j, state) {
    const url = (0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__/* .attr */ .C)(state.image, 'src') || '', a = j.c.element('a'), loadExternal = ()=>{
        if (a.host !== location.host) {
            j.confirm('You can only edit your own images. Download this image on the host?', (yes)=>{
                if (yes && j.uploader) {
                    j.uploader.uploadRemoteImage(a.href.toString(), (resp)=>{
                        j.alert('The image has been successfully uploaded to the host!', ()=>{
                            if ((0,_core_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .K)(resp.newfilename)) {
                                state.values.imageSrc = resp.baseurl + resp.newfilename;
                            }
                        });
                    }, (error)=>{
                        j.alert('There was an error loading %s', error.message);
                    });
                }
            });
            return;
        }
    };
    a.href = url;
    j.filebrowser.dataProvider.getPathByUrl(a.href.toString()).then((resp)=>{
        _modules_image_editor_image_editor_js__WEBPACK_IMPORTED_MODULE_1__/* .openImageEditor */ .B.call(j.filebrowser, a.href, resp.name, resp.path, resp.source, ()=>{
            const timestamp = new Date().getTime();
            state.values.imageSrc = url + (url.indexOf('?') !== -1 ? '' : '?') + '&_tmp=' + timestamp.toString();
        }, (error)=>{
            j.alert(error.message);
        });
    }).catch((error)=>{
        j.alert(error.message, loadExternal);
    });
}


/***/ }),

/***/ 53650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    symbols: 'symbol'
});


/***/ }),

/***/ 53651:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M384 1662l17-85q6-2 81.5-21.5t111.5-37.5q28-35 41-101 1-7 62-289t114-543.5 52-296.5v-25q-24-13-54.5-18.5t-69.5-8-58-5.5l19-103q33 2 120 6.5t149.5 7 120.5 2.5q48 0 98.5-2.5t121-7 98.5-6.5q-5 39-19 89-30 10-101.5 28.5t-108.5 33.5q-8 19-14 42.5t-9 40-7.5 45.5-6.5 42q-27 148-87.5 419.5t-77.5 355.5q-2 9-13 58t-20 90-16 83.5-6 57.5l1 18q17 4 185 31-3 44-16 99-11 0-32.5 1.5t-32.5 1.5q-29 0-87-10t-86-10q-138-2-206-2-51 0-143 9t-121 11z\"/> </svg> ");


/***/ }),

/***/ 53696:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M512 1248v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm640 512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm-640-1024v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm640 512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm640 512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm-640-1024v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm640 512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68z\"/> </svg> ");


/***/ }),

/***/ 53822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    'Line height': 'Высота линии'
});


/***/ }),

/***/ 54041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   D: function() { return /* binding */ getBlockWrapper; }
/* harmony export */ });
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/**
 * Finds a suitable parent block container
 * @private
 */ function getBlockWrapper(fake, jodit, tagReg = _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_BLOCK) {
    let node = fake;
    const root = jodit.editor;
    do {
        if (!node || node === root) {
            break;
        }
        if (tagReg.test(node.nodeName)) {
            if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isLeaf(node)) {
                return node;
            }
            return getBlockWrapper(node.parentNode, jodit, /^li$/i) || node;
        }
        node = node.parentNode;
    }while (node && node !== root)
    return null;
}


/***/ }),

/***/ 54076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   F: function() { return /* binding */ execSpellCommand; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ function execSpellCommand(jodit, commandSentence) {
    const [command, value] = commandSentence.split('::');
    jodit.execCommand(command, null, value);
}


/***/ }),

/***/ 54079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   d: function() { return /* binding */ Ajax; }
/* harmony export */ });
/* harmony import */ var _async_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8884);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82758);
/* harmony import */ var _decorators_autobind_autobind_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40401);
/* harmony import */ var _helpers_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21537);
/* harmony import */ var _helpers_utils_error_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89890);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6441);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57459);
/* harmony import */ var _response_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98582);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








class Ajax {
    className() {
        return 'Ajax';
    }
    __buildParams(obj, prefix) {
        if ((0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.isPlainObject)(obj) && this.options.contentType && this.options.contentType.includes('application/json')) {
            return JSON.stringify(obj);
        }
        if ((0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.isFunction)(this.o.queryBuild)) {
            return this.o.queryBuild.call(this, obj, prefix);
        }
        if ((0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.isString)(obj) || obj instanceof _constants_js__WEBPACK_IMPORTED_MODULE_1__.globalWindow.FormData || typeof obj === 'object' && obj != null && (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.isFunction)(obj.append)) {
            return obj;
        }
        return (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.buildQuery)(obj);
    }
    get o() {
        return this.options;
    }
    abort() {
        if (this.__isFulfilled) {
            return this;
        }
        try {
            this.__isFulfilled = true;
            this.xhr.abort();
        } catch (_a) {}
        return this;
    }
    send() {
        this.__activated = true;
        const { xhr, o } = this;
        const request = this.prepareRequest();
        return this.__async.promise(async (resolve, reject)=>{
            var _a;
            const onReject = ()=>{
                this.__isFulfilled = true;
                reject(_helpers_utils_error_index_js__WEBPACK_IMPORTED_MODULE_3__/* .connection */ .FI('Connection error'));
            };
            const onResolve = ()=>{
                this.__isFulfilled = true;
                resolve(new _response_js__WEBPACK_IMPORTED_MODULE_6__/* .Response */ .Y(request, xhr.status, xhr.statusText, !xhr.responseType ? xhr.responseText : xhr.response));
            };
            xhr.onload = onResolve;
            xhr.onabort = ()=>{
                this.__isFulfilled = true;
                reject(_helpers_utils_error_index_js__WEBPACK_IMPORTED_MODULE_3__/* .abort */ .h2('Abort connection'));
            };
            xhr.onerror = onReject;
            xhr.ontimeout = onReject;
            if (o.responseType) {
                xhr.responseType = o.responseType;
            }
            xhr.onprogress = (e)=>{
                var _a, _b;
                let percentComplete = 0;
                if (e.lengthComputable) {
                    percentComplete = e.loaded / e.total * 100;
                }
                (_b = (_a = this.options).onProgress) === null || _b === void 0 ? void 0 : _b.call(_a, percentComplete);
            };
            xhr.onreadystatechange = ()=>{
                var _a, _b;
                (_b = (_a = this.options).onProgress) === null || _b === void 0 ? void 0 : _b.call(_a, 10);
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    if (o.successStatuses.includes(xhr.status)) {
                        onResolve();
                    } else if (xhr.statusText) {
                        this.__isFulfilled = true;
                        reject(_helpers_utils_error_index_js__WEBPACK_IMPORTED_MODULE_3__/* .connection */ .FI(xhr.statusText));
                    }
                }
            };
            xhr.withCredentials = (_a = o.withCredentials) !== null && _a !== void 0 ? _a : false;
            const { url, data, method } = request;
            xhr.open(method, url, true);
            if (o.contentType && xhr.setRequestHeader) {
                xhr.setRequestHeader('Content-type', o.contentType);
            }
            let { headers } = o;
            if ((0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.isFunction)(headers)) {
                headers = await headers.call(this);
            }
            if (headers && xhr.setRequestHeader) {
                Object.keys(headers).forEach((key)=>{
                    xhr.setRequestHeader(key, headers[key]);
                });
            }
            // IE
            this.__async.setTimeout(()=>{
                xhr.send(data ? this.__buildParams(data) : undefined);
            }, 0);
        });
    }
    prepareRequest() {
        if (!this.o.url) {
            throw _helpers_utils_error_index_js__WEBPACK_IMPORTED_MODULE_3__/* .error */ .z3('Need URL for AJAX request');
        }
        let url = this.o.url;
        const data = this.o.data;
        const method = (this.o.method || 'get').toLowerCase();
        if (method === 'get' && data && (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.isPlainObject)(data)) {
            const qIndex = url.indexOf('?');
            if (qIndex !== -1) {
                const urlData = (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.parseQuery)(url);
                url = url.substring(0, qIndex) + '?' + (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.buildQuery)({
                    ...urlData,
                    ...data
                });
            } else {
                url += '?' + (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.buildQuery)(this.o.data);
            }
        }
        const request = {
            url,
            method,
            data
        };
        Ajax.log.splice(100);
        Ajax.log.push(request);
        return request;
    }
    destruct() {
        if (!this.__isDestructed) {
            this.__isDestructed = true;
            if (this.__activated && !this.__isFulfilled) {
                this.abort();
                this.__isFulfilled = true;
            }
            this.__async.destruct();
        }
    }
    constructor(options, defaultAjaxOptions = _config_js__WEBPACK_IMPORTED_MODULE_4__/* .Config */ .T.prototype.defaultAjaxOptions){
        this.__async = new _async_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Async */ .j();
        this.__isFulfilled = false;
        this.__activated = false;
        this.__isDestructed = false;
        this.options = (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.ConfigProto)(options || {}, defaultAjaxOptions);
        this.xhr = this.o.xhr ? this.o.xhr() : new XMLHttpRequest();
    }
}
Ajax.log = [];
__decorate([
    _decorators_autobind_autobind_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Ay
], Ajax.prototype, "destruct", null);


/***/ }),

/***/ 54389:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22732);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6441);
/* harmony import */ var _icons_indent_svg_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78614);
/* harmony import */ var _icons_outdent_svg_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86835);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(302);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 





_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .I.set('indent', _icons_indent_svg_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A).set('outdent', _icons_outdent_svg_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A);
_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.controls.indent = {
    tooltip: 'Increase Indent'
};
_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.controls.outdent = {
    isDisabled: (editor)=>{
        const current = editor.s.current();
        if (current) {
            const currentBox = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(current, _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isBlock, editor.editor);
            if (currentBox) {
                const arrow = (0,_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .getKey */ .i)(editor.o.direction, currentBox);
                return !currentBox.style[arrow] || parseInt(currentBox.style[arrow], 10) <= 0;
            }
        }
        return true;
    },
    tooltip: 'Decrease Indent'
};
_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.indentMargin = 10;


/***/ }),

/***/ 54600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   H: function() { return /* binding */ splitFragment; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _core_helpers_utils_scroll_into_view_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26395);
/* harmony import */ var _insert_paragraph_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44245);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/**
 * Splits a block element into two parts
 * and adds a new default block in the middle/start/end
 * @private
 */ function splitFragment(fake, jodit, block) {
    const sel = jodit.s, { enter } = jodit.o;
    const defaultTag = enter.toLowerCase();
    const isLi = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isLeaf(block);
    const canSplit = block.tagName.toLowerCase() === defaultTag || isLi;
    const cursorOnTheRight = sel.cursorOnTheRight(block, fake);
    const cursorOnTheLeft = sel.cursorOnTheLeft(block, fake);
    if (!canSplit && (cursorOnTheRight || cursorOnTheLeft)) {
        if (cursorOnTheRight) {
            _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.after(block, fake);
        } else {
            _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.before(block, fake);
        }
        (0,_insert_paragraph_js__WEBPACK_IMPORTED_MODULE_2__/* .insertParagraph */ .y)(fake, jodit, defaultTag);
        if (cursorOnTheLeft && !cursorOnTheRight) {
            _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.prepend(block, fake);
        }
        return;
    }
    const newP = sel.splitSelection(block, fake);
    (0,_core_helpers_utils_scroll_into_view_js__WEBPACK_IMPORTED_MODULE_1__/* .scrollIntoViewIfNeeded */ .$)(newP, jodit.editor, jodit.ed);
}


/***/ }),

/***/ 54765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   k: function() { return /* binding */ hasBrowserColorPicker; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/checker
 */ 
/**
 * Check if browser has a color picker (a new HTML5 attribute for input tag)
 */ function hasBrowserColorPicker() {
    let supportsColor = true;
    try {
        const a = _constants_js__WEBPACK_IMPORTED_MODULE_0__.globalDocument.createElement('input');
        a.type = 'color';
        a.value = '!';
        supportsColor = a.type === 'color' && a.value !== '!';
    } catch (e) {
        supportsColor = false;
    }
    return supportsColor;
}


/***/ }),

/***/ 55099:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6441);
/* harmony import */ var _search_svg_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21597);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 




_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.useSearch = true;
_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.search = {
    lazyIdleTimeout: 0,
    useCustomHighlightAPI: _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.globalWindow && typeof _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.globalWindow.Highlight !== 'undefined'
};
_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .I.set('search', _search_svg_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A);
_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.controls.find = {
    tooltip: 'Find',
    icon: 'search',
    exec (jodit, _, { control }) {
        const value = control.args && control.args[0];
        switch(value){
            case 'findPrevious':
                jodit.e.fire('searchPrevious');
                break;
            case 'findNext':
                jodit.e.fire('searchNext');
                break;
            case 'replace':
                jodit.execCommand('openReplaceDialog');
                break;
            default:
                jodit.execCommand('openSearchDialog');
        }
    },
    list: {
        search: 'Find',
        findNext: 'Find Next',
        findPrevious: 'Find Previous',
        replace: 'Replace'
    },
    childTemplate: (_, k, v)=>v
};


/***/ }),

/***/ 55153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C: function() { return /* binding */ derive; }
/* harmony export */ });
/* harmony import */ var _helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23282);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * [[include:core/decorators/derive/README.md]]
 * @packageDocumentation
 * @module decorators/derive
 */ 
function derive(...traits) {
    return (target)=>{
        const origin = target.prototype;
        for(let i = 0; i < traits.length; i++){
            const trait = traits[i];
            const keys = Object.getOwnPropertyNames(trait.prototype);
            for(let j = 0; j < keys.length; j++){
                const key = keys[j], method = Object.getOwnPropertyDescriptor(trait.prototype, key);
                const canDerive = method != null && (0,_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_0__/* .isFunction */ .T)(method.value) && !(0,_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_0__/* .isFunction */ .T)(origin[key]);
                if (canDerive) {
                    Object.defineProperty(origin, key, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: function(...args) {
                            return method.value.call(this, ...args);
                        }
                    });
                }
            }
        }
    };
}


/***/ }),

/***/ 55307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   g: function() { return /* binding */ transactions; },
/* harmony export */   x: function() { return /* binding */ states; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38837);
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59242);
/* harmony import */ var _api_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63687);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 




const states = {
    START: 'START',
    ELEMENT: 'ELEMENT',
    UNWRAP: 'UNWRAP',
    UNWRAP_CHILDREN: 'UNWRAP_CHILDREN',
    CHANGE: 'CHANGE',
    REPLACE_DEFAULT: 'REPLACE_DEFAULT',
    LIST: 'LIST',
    TOGGLE_LIST: 'TOGGLE_LIST',
    WRAP: 'WRAP',
    EXTRACT: 'EXTRACT',
    END: 'END'
};
const transactions = {
    [states.START]: {
        exec (value) {
            const { element, jodit, style, mode, collapsed } = value;
            if ((0,_api_index_js__WEBPACK_IMPORTED_MODULE_4__/* .isInsideInvisibleElement */ .iu)(element, jodit.editor) || !collapsed && _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isEmptyContent(element)) {
                return {
                    ...value,
                    next: states.END
                };
            }
            const elm = (0,_api_index_js__WEBPACK_IMPORTED_MODULE_4__/* .getSuitParent */ .AS)(style, element, jodit.editor) || (0,_api_index_js__WEBPACK_IMPORTED_MODULE_4__/* .getSuitChild */ .G6)(style, element);
            if (elm) {
                return {
                    ...value,
                    next: states.ELEMENT,
                    element: elm
                };
            }
            const suit = (0,_api_index_js__WEBPACK_IMPORTED_MODULE_4__/* .suitableClosest */ .$s)(style, element, jodit.editor);
            if (style.elementIsList && _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isList(suit)) {
                return {
                    ...value,
                    next: states.LIST
                };
            }
            if (suit) {
                return {
                    ...value,
                    next: states.EXTRACT
                };
            }
            return {
                ...value,
                next: mode !== _index_js__WEBPACK_IMPORTED_MODULE_3__/* .UNWRAP */ .OJ ? states.UNWRAP_CHILDREN : states.END
            };
        }
    },
    [states.LIST]: {
        exec (value) {
            const { element, jodit, mode } = value;
            if (mode !== _index_js__WEBPACK_IMPORTED_MODULE_3__/* .INITIAL */ .DI && mode !== _index_js__WEBPACK_IMPORTED_MODULE_3__/* .UNWRAP */ .OJ && mode !== _index_js__WEBPACK_IMPORTED_MODULE_3__/* .REPLACE */ .dj) {
                return {
                    ...value,
                    next: states.END
                };
            }
            const li = _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.closest(element, 'li', jodit.editor);
            if (!li) {
                return {
                    ...value,
                    next: states.END
                };
            }
            const list = _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.closest(element, _constants_js__WEBPACK_IMPORTED_MODULE_0__.LIST_TAGS, jodit.editor);
            if (list) {
                return {
                    ...value,
                    element: li,
                    next: states.TOGGLE_LIST
                };
            }
            return {
                ...value,
                next: states.END
            };
        }
    },
    [states.TOGGLE_LIST]: {
        exec (value) {
            return {
                ...value,
                mode: (0,_api_index_js__WEBPACK_IMPORTED_MODULE_4__/* .toggleOrderedList */ .ks)(value.style, value.element, value.jodit, value.mode),
                next: states.END
            };
        }
    },
    [states.EXTRACT]: {
        exec (value) {
            const { element, jodit, style } = value;
            const suit = (0,_api_index_js__WEBPACK_IMPORTED_MODULE_4__/* .suitableClosest */ .$s)(style, element, jodit.editor);
            (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_2__/* .assert */ .v)(suit, 'This place should have an element');
            if (!style.elementIsBlock) {
                (0,_api_index_js__WEBPACK_IMPORTED_MODULE_4__/* .extractSelectedPart */ .yP)(suit, element, jodit);
            }
            return {
                ...value,
                element: suit,
                next: states.ELEMENT
            };
        }
    },
    [states.UNWRAP_CHILDREN]: {
        exec (value) {
            const { element, style } = value;
            if (!(0,_api_index_js__WEBPACK_IMPORTED_MODULE_4__/* .unwrapChildren */ .tm)(style, element)) {
                return {
                    ...value,
                    next: states.WRAP
                };
            }
            return {
                ...value,
                mode: _index_js__WEBPACK_IMPORTED_MODULE_3__/* .UNWRAP */ .OJ,
                next: states.END
            };
        }
    },
    [states.WRAP]: {
        exec (value) {
            const { element, jodit, style } = value;
            const wrapper = (0,_api_index_js__WEBPACK_IMPORTED_MODULE_4__/* .wrap */ .LV)(style, element, jodit);
            return {
                ...value,
                next: style.elementIsList ? states.END : states.CHANGE,
                mode: _index_js__WEBPACK_IMPORTED_MODULE_3__/* .WRAP */ .Zk,
                element: wrapper
            };
        }
    },
    [states.ELEMENT]: {
        exec (value) {
            const { style, element, jodit } = value;
            if ((0,_api_index_js__WEBPACK_IMPORTED_MODULE_4__/* .toggleAttributes */ .Yx)(style, element, jodit, _index_js__WEBPACK_IMPORTED_MODULE_3__/* .INITIAL */ .DI, true) !== _index_js__WEBPACK_IMPORTED_MODULE_3__/* .INITIAL */ .DI) {
                return {
                    ...value,
                    next: states.CHANGE
                };
            }
            // Apply same color for anchor https://github.com/xdan/jodit/issues/936
            if (!_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(element, style.element)) {
                return {
                    ...value,
                    next: states.END
                };
            }
            return {
                ...value,
                next: states.UNWRAP
            };
        }
    },
    [states.CHANGE]: {
        exec (value) {
            const { style, element, jodit, mode } = value;
            const newMode = (0,_api_index_js__WEBPACK_IMPORTED_MODULE_4__/* .toggleAttributes */ .Yx)(style, element, jodit, value.mode);
            if (mode !== _index_js__WEBPACK_IMPORTED_MODULE_3__/* .WRAP */ .Zk && newMode === _index_js__WEBPACK_IMPORTED_MODULE_3__/* .UNSET */ .Ag && !element.attributes.length && _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(element, style.element)) {
                return {
                    ...value,
                    next: states.UNWRAP
                };
            }
            return {
                ...value,
                mode: newMode,
                next: states.END
            };
        }
    },
    [states.UNWRAP]: {
        exec (value) {
            if (value.element.attributes.length && _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(value.element, value.style.element)) {
                return {
                    ...value,
                    next: states.REPLACE_DEFAULT
                };
            }
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.unwrap(value.element);
            return {
                ...value,
                mode: _index_js__WEBPACK_IMPORTED_MODULE_3__/* .UNWRAP */ .OJ,
                next: states.END
            };
        }
    },
    [states.REPLACE_DEFAULT]: {
        exec (value) {
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.replace(value.element, value.style.defaultTag, value.jodit.createInside, true);
            return {
                ...value,
                mode: _index_js__WEBPACK_IMPORTED_MODULE_3__/* .REPLACE */ .dj,
                next: states.END
            };
        }
    },
    [states.END]: {
        exec (value) {
            return value;
        }
    }
};


/***/ }),

/***/ 55311:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/select-cells
 */ 
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.tableAllowCellSelection = true;


/***/ }),

/***/ 55611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   IJ: function() { return /* reexport safe */ _highlight_text_ranges_js__WEBPACK_IMPORTED_MODULE_0__.IJ; },
/* harmony export */   QN: function() { return /* reexport safe */ _sentence_finder_js__WEBPACK_IMPORTED_MODULE_1__.Q; },
/* harmony export */   Tz: function() { return /* reexport safe */ _highlight_text_ranges_js__WEBPACK_IMPORTED_MODULE_0__.Tz; },
/* harmony export */   _B: function() { return /* reexport safe */ _highlight_text_ranges_js__WEBPACK_IMPORTED_MODULE_0__._B; },
/* harmony export */   zy: function() { return /* reexport safe */ _highlight_text_ranges_js__WEBPACK_IMPORTED_MODULE_0__.zy; }
/* harmony export */ });
/* harmony import */ var _highlight_text_ranges_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12270);
/* harmony import */ var _sentence_finder_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93119);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/search
 */ 



/***/ }),

/***/ 55776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    Spellcheck: 'スペルチェック'
});


/***/ }),

/***/ 55877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   m: function() { return /* binding */ convertMediaUrlToVideoEmbed; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _checker_is_url_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26049);
/* harmony import */ var _parse_query_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82501);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/utils
 */ 


/**
 * Javascript url pattern converter replace youtube/vimeo url in embed code.
 */ const convertMediaUrlToVideoEmbed = (url, { width = 400, height = 345 } = {})=>{
    if (!(0,_checker_is_url_js__WEBPACK_IMPORTED_MODULE_1__/* .isURL */ .m)(url)) {
        return url;
    }
    const parser = _constants_js__WEBPACK_IMPORTED_MODULE_0__.globalDocument.createElement('a');
    const pattern1 = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g;
    parser.href = url;
    if (!width) {
        width = 400;
    }
    if (!height) {
        height = 345;
    }
    const protocol = parser.protocol || '';
    switch(parser.hostname){
        case 'www.vimeo.com':
        case 'vimeo.com':
            return pattern1.test(url) ? url.replace(pattern1, '<iframe width="' + width + '" height="' + height + '" src="' + protocol + '//player.vimeo.com/video/$1" frameborder="0" allowfullscreen></iframe>') : url;
        case 'youtube.com':
        case 'www.youtube.com':
        case 'youtu.be':
        case 'www.youtu.be':
            {
                const query = parser.search ? (0,_parse_query_js__WEBPACK_IMPORTED_MODULE_2__/* .parseQuery */ .m)(parser.search) : {
                    v: parser.pathname.substring(1)
                };
                if (/^embed\/.*/.test(query.v)) {
                    query.v = query.v.substring(6);
                }
                return query.v ? '<iframe width="' + width + '" height="' + height + '" src="' + protocol + '//www.youtube.com/embed/' + query.v + '" frameborder="0" allowfullscreen></iframe>' : url;
            }
    }
    return url;
};


/***/ }),

/***/ 56113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export resizeCells */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2748);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21537);
/* harmony import */ var _modules_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41409);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37467);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







const key = 'table_processor_observer-resize';
/**
 * Process tables in editor
 */ class resizeCells extends _modules_index_js__WEBPACK_IMPORTED_MODULE_5__.Plugin {
    /**
     * Shortcut for Table module
     */ get module() {
        return this.j.getInstance('Table', this.j.o);
    }
    /**
     * Now editor has rtl direction
     */ get isRTL() {
        return this.j.o.direction === 'rtl';
    }
    showResizeHandle() {
        this.j.async.clearTimeout(this.hideTimeout);
        this.j.workplace.appendChild(this.resizeHandler);
    }
    hideResizeHandle() {
        this.hideTimeout = this.j.async.setTimeout(()=>{
            _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(this.resizeHandler);
        }, {
            timeout: this.j.defaultTimeout,
            label: 'hideResizer'
        });
    }
    /**
     * Click on resize handle
     */ onHandleMouseDown(event) {
        if (this.j.isLocked) {
            return;
        }
        this.drag = true;
        this.j.e.on(this.j.ow, 'mouseup.resize-cells touchend.resize-cells', this.onMouseUp).on(this.j.ew, 'mousemove.table touchmove.table', this.onMouseMove);
        this.startX = event.clientX;
        this.j.lock(key);
        this.resizeHandler.classList.add('jodit-table-resizer_moved');
        let box, tableBox = this.workTable.getBoundingClientRect();
        this.minX = 0;
        this.maxX = 1000000;
        if (this.wholeTable != null) {
            tableBox = this.workTable.parentNode.getBoundingClientRect();
            this.minX = tableBox.left;
            this.maxX = this.minX + tableBox.width;
        } else {
            // find maximum columns
            const coordinate = this.module.formalCoordinate(this.workTable, this.workCell, true);
            this.module.formalMatrix(this.workTable, (td, i, j)=>{
                if (coordinate[1] === j) {
                    box = td.getBoundingClientRect();
                    this.minX = Math.max(box.left + _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.NEARBY / 2, this.minX);
                }
                if (coordinate[1] + (this.isRTL ? -1 : 1) === j) {
                    box = td.getBoundingClientRect();
                    this.maxX = Math.min(box.left + box.width - _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.NEARBY / 2, this.maxX);
                }
            });
        }
        return false;
    }
    /**
     * Mouse move after click on resize handle
     */ onMouseMove(event) {
        if (!this.drag) {
            return;
        }
        this.j.e.fire('closeAllPopups');
        let x = event.clientX;
        const workplacePosition = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.offset)(this.resizeHandler.parentNode || this.j.od.documentElement, this.j, this.j.od, true);
        if (x < this.minX) {
            x = this.minX;
        }
        if (x > this.maxX) {
            x = this.maxX;
        }
        this.resizeDelta = x - this.startX + (!this.j.o.iframe ? 0 : workplacePosition.left);
        this.resizeHandler.style.left = x - (this.j.o.iframe ? 0 : workplacePosition.left) + 'px';
        const sel = this.j.s.sel;
        sel && sel.removeAllRanges();
    }
    /**
     * Mouse up every where after move and click
     */ onMouseUp(e) {
        if (this.selectMode || this.drag) {
            this.selectMode = false;
            this.j.unlock();
        }
        if (!this.resizeHandler || !this.drag) {
            return;
        }
        this.drag = false;
        this.j.e.off(this.j.ew, 'mousemove.table touchmove.table', this.onMouseMove);
        this.resizeHandler.classList.remove('jodit-table-resizer_moved');
        if (this.startX !== e.clientX) {
            // resize column
            if (this.wholeTable == null) {
                this.resizeColumns();
            } else {
                this.resizeTable();
            }
        }
        this.j.synchronizeValues();
        this.j.s.focus();
    }
    /**
     * Resize only one column
     */ resizeColumns() {
        const delta = this.resizeDelta;
        const marked = [];
        const tableModule = this.module;
        tableModule.setColumnWidthByDelta(this.workTable, tableModule.formalCoordinate(this.workTable, this.workCell, true)[1], delta, true, marked);
        const nextTD = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.call)(this.isRTL ? _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.prev : _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.next, this.workCell, _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isCell, this.workCell.parentNode);
        tableModule.setColumnWidthByDelta(this.workTable, tableModule.formalCoordinate(this.workTable, nextTD)[1], -delta, false, marked);
    }
    /**
     * Resize whole table
     */ resizeTable() {
        const delta = this.resizeDelta * (this.isRTL ? -1 : 1);
        const width = this.workTable.offsetWidth, parentWidth = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.getContentWidth)(this.workTable.parentNode, this.j.ew);
        // for RTL use mirror logic
        const rightSide = !this.wholeTable;
        const needChangeWidth = this.isRTL ? !rightSide : rightSide;
        // right side
        if (needChangeWidth) {
            this.workTable.style.width = (width + delta) / parentWidth * 100 + '%';
        } else {
            const side = this.isRTL ? 'marginRight' : 'marginLeft';
            const margin = parseInt(this.j.ew.getComputedStyle(this.workTable)[side] || '0', 10);
            this.workTable.style.width = (width - delta) / parentWidth * 100 + '%';
            this.workTable.style[side] = (margin + delta) / parentWidth * 100 + '%';
        }
    }
    /**
     * Memoize current cell
     *
     * @param wholeTable - resize whole table by left side,
     * false - resize whole table by right side, null - resize column
     */ setWorkCell(cell, wholeTable = null) {
        this.wholeTable = wholeTable;
        this.workCell = cell;
        this.workTable = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.up(cell, (elm)=>_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isTag(elm, 'table'), this.j.editor);
    }
    /**
     * Calc helper resize handle position
     */ calcHandlePosition(table, cell, offsetX = 0, delta = 0) {
        const box = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.offset)(cell, this.j, this.j.ed);
        if (offsetX > _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.NEARBY && offsetX < box.width - _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.NEARBY) {
            this.hideResizeHandle();
            return;
        }
        const workplacePosition = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.offset)(this.j.workplace, this.j, this.j.od, true), parentBox = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.offset)(table, this.j, this.j.ed);
        this.resizeHandler.style.left = (offsetX <= _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.NEARBY ? box.left : box.left + box.width) - workplacePosition.left + delta + 'px';
        Object.assign(this.resizeHandler.style, {
            height: parentBox.height + 'px',
            top: parentBox.top - workplacePosition.top + 'px'
        });
        this.showResizeHandle();
        if (offsetX <= _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.NEARBY) {
            const prevTD = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.call)(this.isRTL ? _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.next : _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.prev, cell, _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isCell, cell.parentNode);
            this.setWorkCell(prevTD || cell, prevTD ? null : true);
        } else {
            const nextTD = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.call)(!this.isRTL ? _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.next : _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.prev, cell, _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isCell, cell.parentNode);
            this.setWorkCell(cell, !nextTD ? false : null);
        }
    }
    /** @override */ afterInit(editor) {
        if (!editor.o.tableAllowCellResize) {
            return;
        }
        editor.e.off(this.j.ow, '.resize-cells').off('.resize-cells').on('change.resize-cells afterCommand.resize-cells afterSetMode.resize-cells', ()=>{
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.$$)('table', editor.editor).forEach(this.observe);
        }).on(this.j.ow, 'scroll.resize-cells', ()=>{
            if (!this.drag) {
                return;
            }
            const parent = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.up(this.workCell, (elm)=>_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isTag(elm, 'table'), editor.editor);
            if (parent) {
                const parentBox = parent.getBoundingClientRect();
                this.resizeHandler.style.top = parentBox.top + 'px';
            }
        }).on('beforeSetMode.resize-cells', ()=>{
            const tableModule = this.module;
            tableModule.getAllSelectedCells().forEach((td)=>{
                tableModule.removeSelection(td);
                tableModule.normalizeTable(_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.closest(td, 'table', editor.editor));
            });
        });
    }
    /**
     * Add to every Table listeners
     */ observe(table) {
        if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.dataBind)(table, key)) {
            return;
        }
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.dataBind)(table, key, true);
        this.j.e.on(table, 'mouseleave.resize-cells', (e)=>{
            if (this.resizeHandler && this.resizeHandler !== e.relatedTarget) {
                this.hideResizeHandle();
            }
        }).on(table, 'mousemove.resize-cells touchmove.resize-cells', this.j.async.throttle((event)=>{
            if (this.j.isLocked) {
                return;
            }
            const cell = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.up(event.target, _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isCell, table);
            if (!cell) {
                return;
            }
            this.calcHandlePosition(table, cell, event.offsetX);
        }, {
            timeout: this.j.defaultTimeout
        }));
        this.createResizeHandle();
    }
    beforeDestruct(jodit) {
        if (jodit.events) {
            jodit.e.off(this.j.ow, '.resize-cells');
            jodit.e.off('.resize-cells');
        }
    }
    constructor(){
        super(...arguments);
        this.selectMode = false;
        this.resizeDelta = 0;
        this.createResizeHandle = ()=>{
            if (!this.resizeHandler) {
                this.resizeHandler = this.j.c.div('jodit-table-resizer');
                this.j.e.on(this.resizeHandler, 'mousedown.table touchstart.table', this.onHandleMouseDown).on(this.resizeHandler, 'mouseenter.table', ()=>{
                    this.j.async.clearTimeout(this.hideTimeout);
                });
            }
        };
        this.hideTimeout = 0;
        this.drag = false;
        this.minX = 0;
        this.maxX = 0;
        this.startX = 0;
    }
}
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], resizeCells.prototype, "onHandleMouseDown", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], resizeCells.prototype, "onMouseMove", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], resizeCells.prototype, "onMouseUp", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], resizeCells.prototype, "observe", null);
_core_global_js__WEBPACK_IMPORTED_MODULE_3__/* .pluginSystem */ .fg.add('resizeCells', resizeCells);


/***/ }),

/***/ 56175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ej: function() { return /* reexport safe */ _object_size_js__WEBPACK_IMPORTED_MODULE_3__.E; },
/* harmony export */   G1: function() { return /* reexport safe */ _position_js__WEBPACK_IMPORTED_MODULE_5__.G; },
/* harmony export */   cY: function() { return /* reexport safe */ _offset_js__WEBPACK_IMPORTED_MODULE_4__.c; },
/* harmony export */   mH: function() { return /* reexport safe */ _get_scroll_parent_js__WEBPACK_IMPORTED_MODULE_1__.m; },
/* harmony export */   xM: function() { return /* reexport safe */ _inner_width_js__WEBPACK_IMPORTED_MODULE_2__.x; },
/* harmony export */   y6: function() { return /* reexport safe */ _get_content_width_js__WEBPACK_IMPORTED_MODULE_0__.y; }
/* harmony export */ });
/* harmony import */ var _get_content_width_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44506);
/* harmony import */ var _get_scroll_parent_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16442);
/* harmony import */ var _inner_width_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81630);
/* harmony import */ var _object_size_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21496);
/* harmony import */ var _offset_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81284);
/* harmony import */ var _position_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5700);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/size
 */ 







/***/ }),

/***/ 56825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   f: function() { return /* binding */ checkRemoveUnbreakableElement; }
/* harmony export */ });
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _check_remove_empty_parent_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58940);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/**
 * Check possibility inseparable Element can be removed (img, hr etc.)
 *
 * @example
 * ```html
 * <p>first second <img>| stop</p>
 * ```
 * result
 * ```html
 * <p>first second | stop</p>
 * ```
 *
 * @private
 */ function checkRemoveUnbreakableElement(jodit, fakeNode, backspace) {
    const neighbor = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.findSibling(fakeNode, backspace);
    if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isElement(neighbor) && (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(neighbor, _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INSEPARABLE_TAGS) || _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isEmpty(neighbor))) {
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(neighbor);
        if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(neighbor, 'br') && !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.findNotEmptySibling(fakeNode, false)) {
            _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.after(fakeNode, jodit.createInside.element('br'));
        }
        jodit.s.setCursorBefore(fakeNode);
        if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(neighbor, 'br')) {
            (0,_check_remove_empty_parent_js__WEBPACK_IMPORTED_MODULE_2__/* .checkRemoveEmptyParent */ .C)(jodit, fakeNode, backspace);
        }
        return true;
    }
    return false;
}


/***/ }),

/***/ 56869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   d: function() { return /* binding */ transformWordToHtml; }
/* harmony export */ });
/* harmony import */ var jodit_esm_core_helpers_string_trim__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49055);
/* harmony import */ var jodit_pro_plugins_paste_from_word_cases__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85568);
/* harmony import */ var jodit_pro_plugins_paste_from_word_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31117);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */



function transformWordToHtml(jodit, body, removeStyles, rtf) {
    const ctx = {
        jodit,
        rtf
    };
    body.forEach(function eachElm(elm) {
        if (!elm) {
            return;
        }
        for (const fn of jodit_pro_plugins_paste_from_word_cases__WEBPACK_IMPORTED_MODULE_1__/* .cases */ .C) {
            elm = fn(elm, ctx);
            if (elm == null) {
                break;
            }
        }
        elm?.forEach(eachElm);
    });
    if (removeStyles) {
        body.forEach((elm) => {
            elm.style.clear();
        }, true);
    }
    return (0,jodit_esm_core_helpers_string_trim__WEBPACK_IMPORTED_MODULE_0__/* .trim */ .Bq)((0,jodit_pro_plugins_paste_from_word_element__WEBPACK_IMPORTED_MODULE_2__/* .innerHTML */ .OH)(body, (elm) => !elm.isComment, true, jodit.o.pasteFromWord.allowedStyleProps));
}


/***/ }),

/***/ 56882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    symbols: 'Símbolo'
});


/***/ }),

/***/ 56917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   z: function() { return /* binding */ Popup; }
/* harmony export */ });
/* harmony import */ var _component_component_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4012);
/* harmony import */ var _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2748);
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(580);
/* harmony import */ var _helpers_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21537);
/* harmony import */ var _helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38837);
/* harmony import */ var _element_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48538);
/* harmony import */ var _group_group_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62405);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








const EVENTS_FOR_AUTOCLOSE = [
    'escape',
    'cut',
    'delete',
    'backSpaceAfterDelete',
    'beforeCommandDelete'
];
class Popup extends _group_group_js__WEBPACK_IMPORTED_MODULE_7__/* .UIGroup */ .U {
    className() {
        return 'Popup';
    }
    appendChildToContainer(childContainer) {
        const content = this.getElm('content');
        (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_5__/* .assert */ .v)(content, 'Content element should exist');
        content.appendChild(childContainer);
    }
    updateParentElement(target) {
        if (target !== this && _component_component_js__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .u.isInstanceOf(target, Popup)) {
            this.__childrenPopups.forEach((popup)=>{
                if (!target.closest(popup) && popup.isOpened) {
                    popup.close();
                }
            });
            if (!this.__childrenPopups.has(target)) {
                this.j.e.on(target, 'beforeClose', ()=>{
                    this.__childrenPopups.delete(target);
                });
            }
            this.__childrenPopups.add(target);
        }
        return super.updateParentElement(target);
    }
    /**
     * Set popup content
     */ setContent(content) {
        if (this.allChildren.length) {
            throw new Error('Remove children');
        }
        if (_component_component_js__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .u.isInstanceOf(content, _element_js__WEBPACK_IMPORTED_MODULE_6__/* .UIElement */ .D)) {
            this.append(content);
        } else {
            const elm = (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.isString)(content) ? this.j.c.fromHTML(content) : content;
            this.appendChildToContainer(elm);
        }
        this.updatePosition();
        return this;
    }
    /**
     * Open popup near with some bound
     */ open(getBound, keepPosition = false, parentContainer) {
        (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.markOwner)(this.jodit, this.container);
        this.container.classList.add(`jodit_theme_${this.jodit.o.theme}`);
        this.__calculateZIndex();
        this.isOpened = true;
        this.__addGlobalListeners();
        this.__targetBound = !keepPosition ? getBound : this.getKeepBound(getBound);
        if (parentContainer) {
            parentContainer.appendChild(this.container);
        } else {
            const popupContainer = (0,_global_js__WEBPACK_IMPORTED_MODULE_3__/* .getContainer */ .My)(this.jodit, Popup);
            if (parentContainer !== this.container.parentElement) {
                popupContainer.appendChild(this.container);
            }
        }
        this.updatePosition();
        this.j.e.fire(this, 'afterOpen');
        this.j.e.fire('afterOpenPopup', this);
        return this;
    }
    __calculateZIndex() {
        if (this.container.style.zIndex) {
            return;
        }
        const checkView = (view)=>{
            const zIndex = view.container.style.zIndex || view.o.zIndex;
            if (zIndex) {
                this.setZIndex(1 + parseInt(zIndex.toString(), 10));
                return true;
            }
            return false;
        };
        const { j } = this;
        if (checkView(j)) {
            return;
        }
        let pe = this.parentElement;
        while(pe){
            if (checkView(pe.j)) {
                return;
            }
            if (pe.container.style.zIndex) {
                this.setZIndex(1 + parseInt(pe.container.style.zIndex.toString(), 10));
                return;
            }
            if (!pe.parentElement && pe.container.parentElement) {
                const elm = _element_js__WEBPACK_IMPORTED_MODULE_6__/* .UIElement */ .D.closestElement(pe.container.parentElement, _element_js__WEBPACK_IMPORTED_MODULE_6__/* .UIElement */ .D);
                if (elm) {
                    pe = elm;
                    continue;
                }
            }
            pe = pe.parentElement;
        }
    }
    /**
     * Calculate static bound for point
     */ getKeepBound(getBound) {
        const oldBound = getBound();
        const elmUnderCursor = this.od.elementFromPoint(oldBound.left, oldBound.top);
        if (!elmUnderCursor) {
            return getBound;
        }
        const element = _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isHTMLElement(elmUnderCursor) ? elmUnderCursor : elmUnderCursor.parentElement;
        const oldPos = (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.position)(element, this.j);
        return ()=>{
            const bound = getBound();
            const newPos = (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.position)(element, this.j);
            return {
                ...bound,
                top: bound.top + (newPos.top - oldPos.top),
                left: bound.left + (newPos.left - oldPos.left)
            };
        };
    }
    /**
     * Update container position
     */ updatePosition() {
        if (!this.isOpened) {
            return this;
        }
        const [pos, strategy] = this.__calculatePosition(this.__targetBound(), this.viewBound(), (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.position)(this.container, this.j));
        this.setMod('strategy', strategy);
        (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.css)(this.container, {
            left: pos.left,
            top: pos.top
        });
        this.__childrenPopups.forEach((popup)=>popup.updatePosition());
        return this;
    }
    __throttleUpdatePosition() {
        this.updatePosition();
    }
    /**
     * Calculate start point
     */ __calculatePosition(target, view, container, defaultStrategy = this.strategy) {
        const x = {
            left: target.left,
            right: target.left - (container.width - target.width)
        }, y = {
            bottom: target.top + target.height,
            top: target.top - container.height
        };
        const list = Object.keys(x).reduce((keys, xKey)=>keys.concat(Object.keys(y).map((yKey)=>`${xKey}${(0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.ucfirst)(yKey)}`)), []);
        const getPointByStrategy = (strategy)=>{
            const [xKey, yKey] = (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.kebabCase)(strategy).split('-');
            return {
                left: x[xKey],
                top: y[yKey],
                width: container.width,
                height: container.height
            };
        };
        const getMatchStrategy = (inBox)=>{
            let strategy = null;
            if (Popup.boxInView(getPointByStrategy(defaultStrategy), inBox)) {
                strategy = defaultStrategy;
            } else {
                strategy = list.find((key)=>{
                    if (Popup.boxInView(getPointByStrategy(key), inBox)) {
                        return key;
                    }
                    return;
                }) || null;
            }
            return strategy;
        };
        // Try to find match position inside Jodit.container
        let strategy = getMatchStrategy((0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.position)(this.j.container, this.j));
        // If not found or is not inside window view
        if (!strategy || !Popup.boxInView(getPointByStrategy(strategy), view)) {
            // Find match strategy inside window view
            strategy = getMatchStrategy(view) || strategy || defaultStrategy;
        }
        return [
            getPointByStrategy(strategy),
            strategy
        ];
    }
    /**
     * Check if one box is inside second
     */ static boxInView(box, view) {
        const accuracy = 2;
        return box.top - view.top >= -accuracy && box.left - view.left >= -accuracy && view.top + view.height - (box.top + box.height) >= -accuracy && view.left + view.width - (box.left + box.width) >= -accuracy;
    }
    /**
     * Close popup
     */ close() {
        if (!this.isOpened) {
            return this;
        }
        this.isOpened = false;
        this.__childrenPopups.forEach((popup)=>popup.close());
        this.j.e.fire(this, 'beforeClose');
        this.j.e.fire('beforePopupClose', this);
        this.__removeGlobalListeners();
        _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(this.container);
        return this;
    }
    /**
     * Close popup if click was in outside
     */ __closeOnOutsideClick(e) {
        if (!this.isOpened || this.isOwnClick(e)) {
            return;
        }
        this.close();
    }
    isOwnClick(e) {
        if (!e.target) {
            return false;
        }
        const box = _element_js__WEBPACK_IMPORTED_MODULE_6__/* .UIElement */ .D.closestElement(e.target, Popup);
        return Boolean(box && (this === box || box.closest(this)));
    }
    __addGlobalListeners() {
        const up = this.__throttleUpdatePosition, ow = this.ow;
        _global_js__WEBPACK_IMPORTED_MODULE_3__/* .eventEmitter */ .RR.on('closeAllPopups', this.close);
        if (this.smart) {
            this.j.e.on(EVENTS_FOR_AUTOCLOSE, this.close).on('mousedown touchstart', this.__closeOnOutsideClick).on(ow, 'mousedown touchstart', this.__closeOnOutsideClick);
        }
        this.j.e.on('closeAllPopups', this.close).on('resize', up).on(this.container, 'scroll mousewheel', up).on(ow, 'scroll', up).on(ow, 'resize', up);
        _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.up(this.j.container, (box)=>{
            box && this.j.e.on(box, 'scroll mousewheel', up);
        });
    }
    __removeGlobalListeners() {
        const up = this.__throttleUpdatePosition, ow = this.ow;
        _global_js__WEBPACK_IMPORTED_MODULE_3__/* .eventEmitter */ .RR.off('closeAllPopups', this.close);
        if (this.smart) {
            this.j.e.off(EVENTS_FOR_AUTOCLOSE, this.close).off('mousedown touchstart', this.__closeOnOutsideClick).off(ow, 'mousedown touchstart', this.__closeOnOutsideClick);
        }
        this.j.e.off('closeAllPopups', this.close).off('resize', up).off(this.container, 'scroll mousewheel', up).off(ow, 'scroll', up).off(ow, 'resize', up);
        if (this.j.container.isConnected) {
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.up(this.j.container, (box)=>{
                box && this.j.e.off(box, 'scroll mousewheel', up);
            });
        }
    }
    /**
     * Set ZIndex
     */ setZIndex(index) {
        this.container.style.zIndex = index.toString();
    }
    render() {
        return `<div>
			<div class="&__content"></div>
		</div>`;
    }
    /** @override **/ destruct() {
        this.close();
        return super.destruct();
    }
    constructor(jodit, smart = true){
        super(jodit);
        this.smart = smart;
        this.isOpened = false;
        this.strategy = 'leftBottom';
        this.viewBound = ()=>({
                left: 0,
                top: 0,
                width: this.ow.innerWidth,
                height: this.ow.innerHeight
            });
        this.__childrenPopups = new Set();
        (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.attr)(this.container, 'role', 'popup');
    }
}
__decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], Popup.prototype, "updatePosition", null);
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.throttle)(10),
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], Popup.prototype, "__throttleUpdatePosition", null);
__decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], Popup.prototype, "close", null);
__decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], Popup.prototype, "__closeOnOutsideClick", null);


/***/ }),

/***/ 56967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   R: function() { return /* binding */ i18n; },
/* harmony export */   n: function() { return /* binding */ sprintf; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _checker_is_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70799);
/* harmony import */ var _ucfirst_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36409);
/* harmony import */ var _utils_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43555);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 




/**
 * Simple variant sprintf function
 */ const sprintf = (str, args)=>{
    if (!args || !args.length) {
        return str;
    }
    const reg = /%([sd])/g;
    let fnd = reg.exec(str);
    let res = str, i = 0;
    while(fnd && args[i] !== undefined){
        res = res.replace(fnd[0], args[i].toString());
        i += 1;
        fnd = reg.exec(str);
    }
    return res;
};
/**
 * Internationalization method. Uses Jodit.lang object
 * @example
 * ```javascript
 * var editor = Jodit.make("#redactor", {
 *      language: 'ru'
 * });
 * console.log(editor.i18n('Cancel')) //Отмена;
 *
 * Jodit.defaultOptions.language = 'ru';
 * console.log(Jodit.prototype.i18n('Cancel')) //Отмена
 *
 * Jodit.lang.cs = {
 *    Cancel: 'Zrušit'
 * };
 * Jodit.defaultOptions.language = 'cs';
 * console.log(Jodit.prototype.i18n('Cancel')) //Zrušit
 *
 * Jodit.lang.cs = {
 *    'Hello world': 'Hello \s Good \s'
 * };
 * Jodit.defaultOptions.language = 'cs';
 * console.log(Jodit.prototype.i18n('Hello world', 'mr.Perkins', 'day')) //Hello mr.Perkins Good day
 * ```
 */ function i18n(key, params, options) {
    if (!(0,_checker_is_string_js__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .K)(key)) {
        throw (0,_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .error */ .z3)('i18n: Need string in first argument');
    }
    if (!key.length) {
        return key;
    }
    const debug = Boolean(options === null || options === void 0 ? void 0 : options.debugLanguage);
    let store = {};
    const parse = (value)=>params && params.length ? sprintf(value, params) : value, defaultLanguage = (0,_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .defaultLanguage */ .eG)(_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.defaultOptions.language, _config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.defaultOptions.language), language = (0,_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .defaultLanguage */ .eG)(options === null || options === void 0 ? void 0 : options.language, defaultLanguage), tryGet = (store)=>{
        if (!store) {
            return;
        }
        if ((0,_checker_is_string_js__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .K)(store[key])) {
            return parse(store[key]);
        }
        const lcKey = key.toLowerCase();
        if ((0,_checker_is_string_js__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .K)(store[lcKey])) {
            return parse(store[lcKey]);
        }
        const ucfKey = (0,_ucfirst_js__WEBPACK_IMPORTED_MODULE_4__/* .ucfirst */ .Z)(key);
        if ((0,_checker_is_string_js__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .K)(store[ucfKey])) {
            return parse(store[ucfKey]);
        }
        return;
    };
    if (_constants_js__WEBPACK_IMPORTED_MODULE_0__.lang[language] !== undefined) {
        store = _constants_js__WEBPACK_IMPORTED_MODULE_0__.lang[language];
    } else if (!debug) {
        if (_constants_js__WEBPACK_IMPORTED_MODULE_0__.lang[defaultLanguage] !== undefined) {
            store = _constants_js__WEBPACK_IMPORTED_MODULE_0__.lang[defaultLanguage];
        } else {
            store = _constants_js__WEBPACK_IMPORTED_MODULE_0__.lang.en;
        }
    }
    const i18nOvr = options === null || options === void 0 ? void 0 : options.i18n;
    if (i18nOvr && i18nOvr[language]) {
        const result = tryGet(i18nOvr[language]);
        if (result) {
            return result;
        }
    }
    const result = tryGet(store);
    if (result) {
        return result;
    }
    if (!debug && _constants_js__WEBPACK_IMPORTED_MODULE_0__.lang.en && (0,_checker_is_string_js__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .K)(_constants_js__WEBPACK_IMPORTED_MODULE_0__.lang.en[key]) && _constants_js__WEBPACK_IMPORTED_MODULE_0__.lang.en[key]) {
        return parse(_constants_js__WEBPACK_IMPORTED_MODULE_0__.lang.en[key]);
    }
    if (debug) {
        return '{' + key + '}';
    }
    if (!_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD && language !== 'en') {
        console.warn(`i18n need "${key}" in "${language}"`);
    }
    return parse(key);
}


/***/ }),

/***/ 57034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B: function() { return /* binding */ Stack; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ class Stack {
    get length() {
        return this.commands.length;
    }
    clearRedo() {
        this.commands.length = this.stackPosition + 1;
    }
    clear() {
        this.commands.length = 0;
        this.stackPosition = -1;
    }
    push(command) {
        this.clearRedo();
        this.commands.push(command);
        this.stackPosition += 1;
        if (this.commands.length > this.size) {
            this.commands.shift();
            this.stackPosition -= 1;
        }
    }
    replace(command) {
        this.commands[this.stackPosition] = command;
    }
    current() {
        return this.commands[this.stackPosition];
    }
    undo() {
        if (this.canUndo()) {
            if (this.commands[this.stackPosition]) {
                this.commands[this.stackPosition].undo();
            }
            this.stackPosition -= 1;
            return true;
        }
        return false;
    }
    redo() {
        if (this.canRedo()) {
            this.stackPosition += 1;
            if (this.commands[this.stackPosition]) {
                this.commands[this.stackPosition].redo();
            }
            return true;
        }
        return false;
    }
    canUndo() {
        return this.stackPosition >= 0;
    }
    canRedo() {
        return this.stackPosition < this.commands.length - 1;
    }
    constructor(size){
        this.size = size;
        this.commands = [];
        this.stackPosition = -1;
    }
}


/***/ }),

/***/ 57288:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/limit
 */ 
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.limitWords = false;
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.limitChars = false;
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.limitHTML = false;


/***/ }),

/***/ 57340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   S: function() { return /* binding */ UITooltip; }
/* harmony export */ });
/* harmony import */ var _component_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91907);
/* harmony import */ var _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _dom_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22732);
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(580);
/* harmony import */ var _helpers_size_position_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5700);
/* harmony import */ var _helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43555);
/* harmony import */ var _element_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48538);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var UITooltip_1;







const WINDOW_EVENTS_ON_HIDE = [
    'scroll.tooltip',
    'joditCloseDialog',
    'mouseleave.tooltip'
];
const JODIT_EVENTS_ON_HIDE = [
    'escape.tooltip',
    'change.tooltip',
    'changePlace.tooltip',
    'afterOpenPopup.tooltip',
    'hidePopup.tooltip',
    'beforePopupClose.tooltip',
    'closeAllPopups.tooltip'
];
let UITooltip = UITooltip_1 = class UITooltip extends _element_js__WEBPACK_IMPORTED_MODULE_5__/* .UIElement */ .D {
    className() {
        return 'UITooltip';
    }
    render() {
        return '<div><div class="&__content"></div></div>';
    }
    __onAttach(container) {
        // TODO Move it inside __show method. Now it is here because testcase failed with capturing
        (0,_global_js__WEBPACK_IMPORTED_MODULE_3__/* .getContainer */ .My)(this.j, UITooltip_1).appendChild(this.container);
        this.__attachedContainers.add(container);
        this.__attachedContainers.add(this.j.container);
        this.j.e.on(container, 'mouseenter.tooltip', this.__onMouseEnter, {
            capture: true
        }).on(container, 'mouseleave.tooltip', this.__onMouseLeave, {
            capture: true
        }).on(this.j.container, 'mouseleave.tooltip', this.__onMouseLeave, {
            capture: true
        });
    }
    __addListenersOnEnter() {
        if (this.__listenClose) {
            return;
        }
        this.__listenClose = true;
        const view = this.j;
        view.e.on(view.ow, WINDOW_EVENTS_ON_HIDE, this.__hide).on(JODIT_EVENTS_ON_HIDE, this.__hide);
    }
    __removeListenersOnLeave() {
        if (!this.__listenClose) {
            return;
        }
        this.__listenClose = false;
        const view = this.j;
        view.e.off(view.ow, WINDOW_EVENTS_ON_HIDE, this.__hide).off(JODIT_EVENTS_ON_HIDE, this.__hide);
    }
    __onMouseLeave(e) {
        if (this.__currentTarget === e.target) {
            this.__hideDelay();
            this.__currentTarget = null;
        }
    }
    __onMouseEnter(e) {
        if (!_dom_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isHTMLElement(e.target)) {
            return;
        }
        const tooltip = (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_4__/* .attr */ .CF)(e.target, 'aria-label');
        if (!tooltip) {
            return;
        }
        const disabled = Boolean((0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_4__/* .attr */ .CF)(e.target, 'disabled'));
        if (disabled) {
            return;
        }
        const isOwn = e.target.className.includes('jodit');
        if (!isOwn) {
            return;
        }
        this.__currentTarget = e.target;
        const target = e.target;
        this.__open(()=>{
            const pos = (0,_helpers_size_position_js__WEBPACK_IMPORTED_MODULE_6__/* .position */ .G)(target);
            return {
                x: pos.left + pos.width / 2,
                y: pos.top + pos.height
            };
        }, tooltip);
    }
    __open(getPoint, content) {
        this.__addListenersOnEnter();
        this.__isOpened = true;
        this.j.async.clearTimeout(this.__hideTimeout);
        this.j.async.clearTimeout(this.__delayShowTimeout);
        const to = this.j.o.showTooltipDelay || this.j.defaultTimeout;
        if (!to) {
            this.__show(getPoint, content);
            return;
        }
        this.__delayShowTimeout = this.j.async.setTimeout(()=>this.__show(getPoint, content), to);
    }
    __show(getPoint, content) {
        this.setMod('visible', true);
        this.getElm('content').innerHTML = content;
        const point = getPoint();
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_4__/* .css */ .AH)(this.container, {
            left: point.x,
            top: point.y
        });
    }
    __hide() {
        this.j.async.clearTimeout(this.__delayShowTimeout);
        this.j.async.clearTimeout(this.__hideTimeout);
        this.__removeListenersOnLeave();
        if (this.__isOpened) {
            this.__isOpened = false;
            this.setMod('visible', false);
            this.getElm('content').innerHTML = '';
            (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_4__/* .css */ .AH)(this.container, {
                left: -5000
            });
        }
    }
    __hideDelay() {
        this.j.async.clearTimeout(this.__delayShowTimeout);
        this.j.async.clearTimeout(this.__hideTimeout);
        if (!this.__isOpened) {
            return;
        }
        this.__hideTimeout = this.async.setTimeout(this.__hide, this.j.defaultTimeout);
    }
    destruct() {
        this.__attachedContainers.forEach((container)=>{
            this.j.e.off(container, 'mouseenter.tooltip', this.__onMouseEnter).off(container, 'mouseleave.tooltip', this.__onMouseLeave);
        });
        this.__hide();
        super.destruct();
    }
    constructor(view){
        super(view);
        this.__isOpened = false;
        this.__attachedContainers = new Set();
        this.__listenClose = false;
        this.__currentTarget = null;
        this.__delayShowTimeout = 0;
        this.__hideTimeout = 0;
        if (!view.o.textIcons && view.o.showTooltip && !view.o.useNativeTooltip) {
            this.j.e.on('getContainer', (box)=>{
                this.__onAttach(box);
            });
            view.hookStatus(_component_index_js__WEBPACK_IMPORTED_MODULE_0__/* .STATUSES */ .f.ready, ()=>{
                this.__onAttach(this.j.container);
            });
        }
    }
};
__decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], UITooltip.prototype, "__onMouseLeave", null);
__decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], UITooltip.prototype, "__onMouseEnter", null);
__decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], UITooltip.prototype, "__hide", null);
__decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], UITooltip.prototype, "__hideDelay", null);
UITooltip = UITooltip_1 = __decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.component
], UITooltip);



/***/ }),

/***/ 57380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   d: function() { return /* binding */ Uploader; }
/* harmony export */ });
/* harmony import */ var _core_component_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91907);
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82758);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21537);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6441);
/* harmony import */ var _helpers_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94122);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80536);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 





class Uploader extends _core_component_index_js__WEBPACK_IMPORTED_MODULE_0__/* .ViewComponent */ .vG {
    get j() {
        return this.jodit;
    }
    /** @override */ className() {
        return 'Uploader';
    }
    get o() {
        return this.options;
    }
    /**
     * It sets the path for uploading files
     */ setPath(path) {
        this.path = path;
        return this;
    }
    /**
     * It sets the source for connector
     */ setSource(source) {
        this.source = source;
        return this;
    }
    /**
     * Set the handlers Drag and Drop to `$form`
     *
     * @param form - Form or any Node on which you can drag and drop the file. In addition will be processed
     * <code>&lt;input type="file" &gt;</code>
     * @param handlerSuccess - The function be called when a successful uploading files
     * to the server
     * @param handlerError - The function that will be called during a failed download files a server
     * @example
     * ```javascript
     * var $form = jQuery('<form><input type="text" typpe="file"></form>');
     * jQuery('body').append($form);
     * Jodit.editors.someidfoeditor.uploader.bind($form[0], function (files) {
     *     var i;
     *     for (i = 0; i < data.files.length; i += 1) {
     *         parent.s.insertImage(data.files[i])
     *     }
     * });
     * ```
     */ bind(form, handlerSuccess, handlerError) {
        const onFinally = ()=>{
            form.classList.remove('jodit_drag_hover');
        };
        const self = this, onPaste = (e)=>{
            let i, file, extension;
            const cData = e.clipboardData;
            const processData = (formdata)=>{
                if (file) {
                    formdata.append('extension', extension);
                    formdata.append('mimetype', file.type);
                }
            };
            // send data on server
            if (!_core_constants_js__WEBPACK_IMPORTED_MODULE_1__.IS_IE && (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__/* .hasFiles */ .YQ)(cData)) {
                (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__/* .sendFiles */ ._9)(self, cData.files, handlerSuccess, handlerError).finally(onFinally);
                return false;
            }
            if (_core_constants_js__WEBPACK_IMPORTED_MODULE_1__.IS_IE && !_core_constants_js__WEBPACK_IMPORTED_MODULE_1__.IS_ES_NEXT) {
                return (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__/* .processOldBrowserDrag */ .dT)(self, cData, handlerSuccess, handlerError, onFinally);
            }
            if ((0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__/* .hasItems */ .Pb)(cData)) {
                const { items } = cData;
                for(i = 0; i < items.length; i += 1){
                    if (items[i].kind === 'file' && items[i].type === 'image/png') {
                        file = items[i].getAsFile();
                        if (file) {
                            const mime = file.type.match(/\/([a-z0-9]+)/i);
                            extension = mime[1] ? mime[1].toLowerCase() : '';
                            (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__/* .sendFiles */ ._9)(self, [
                                file
                            ], handlerSuccess, handlerError, processData).finally(onFinally);
                        }
                        e.preventDefault();
                        break;
                    }
                }
            }
        };
        if (self.j && self.j.editor !== form) {
            self.j.e.on(form, 'paste', onPaste);
        } else {
            self.j.e.on('beforePaste', onPaste);
        }
        this.attachEvents(form, handlerSuccess, handlerError, onFinally);
    }
    attachEvents(form, handlerSuccess, handlerError, onFinally) {
        const self = this;
        self.j.e.on(form, 'dragend dragover dragenter dragleave drop', (e)=>{
            e.preventDefault();
        }).on(form, 'dragover', (event)=>{
            if ((0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__/* .hasFiles */ .YQ)(event.dataTransfer) || (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__/* .hasItems */ .Pb)(event.dataTransfer)) {
                form.classList.add('jodit_drag_hover');
                event.preventDefault();
            }
        }).on(form, 'dragend dragleave', (event)=>{
            form.classList.remove('jodit_drag_hover');
            if ((0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__/* .hasFiles */ .YQ)(event.dataTransfer)) {
                event.preventDefault();
            }
        }).on(form, 'drop', (event)=>{
            form.classList.remove('jodit_drag_hover');
            if ((0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__/* .hasFiles */ .YQ)(event.dataTransfer)) {
                event.preventDefault();
                event.stopImmediatePropagation();
                (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__/* .sendFiles */ ._9)(self, event.dataTransfer.files, handlerSuccess, handlerError).finally(onFinally);
            }
        });
        const inputFile = form.querySelector('input[type=file]');
        if (inputFile) {
            self.j.e.on(inputFile, 'change', ()=>{
                (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__/* .sendFiles */ ._9)(self, inputFile.files, handlerSuccess, handlerError).then(()=>{
                    inputFile.value = '';
                    if (!/safari/i.test(navigator.userAgent)) {
                        inputFile.type = '';
                        inputFile.type = 'file';
                    }
                }).finally(onFinally);
            });
        }
    }
    /**
     * Upload images to a server by its URL, making it through the connector server.
     */ uploadRemoteImage(url, handlerSuccess, handlerError) {
        const uploader = this, { o } = uploader;
        const handlerE = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.isFunction)(handlerError) ? handlerError : o.defaultHandlerError;
        (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__/* .send */ .tN)(uploader, {
            action: 'fileUploadRemote',
            url
        }).then((resp)=>{
            if (o.isSuccess.call(uploader, resp)) {
                const handler = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.isFunction)(handlerSuccess) ? handlerSuccess : o.defaultHandlerSuccess;
                handler.call(uploader, o.process.call(uploader, resp));
                return;
            }
            handlerE.call(uploader, (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.error)(o.getMessage.call(uploader, resp)));
        }).catch((e)=>handlerE.call(uploader, e));
    }
    destruct() {
        this.setStatus(_core_component_index_js__WEBPACK_IMPORTED_MODULE_0__/* .STATUSES */ .f.beforeDestruct);
        const instances = _helpers_index_js__WEBPACK_IMPORTED_MODULE_4__/* .ajaxInstances */ .$j.get(this);
        if (instances) {
            instances.forEach((ajax)=>{
                try {
                    ajax.destruct();
                } catch (_a) {}
            });
            instances.clear();
        }
        super.destruct();
    }
    constructor(editor, options){
        super(editor);
        this.path = '';
        this.source = 'default';
        this.options = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.ConfigProto)(options || {}, (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.ConfigProto)(_config_js__WEBPACK_IMPORTED_MODULE_3__/* .Config */ .T.defaultOptions.uploader, (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.isJoditObject)(editor) ? editor.o.uploader : {}));
    }
}


/***/ }),

/***/ 57459:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.defaultAjaxOptions = {
    successStatuses: [
        200,
        201,
        202
    ],
    method: 'GET',
    url: '',
    data: null,
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
    headers: {
        'X-REQUESTED-WITH': 'XMLHttpRequest' // compatible with jQuery
    },
    withCredentials: false,
    xhr () {
        return new XMLHttpRequest();
    }
};


/***/ }),

/***/ 57487:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 16 16\"> <path stroke-width=\"0\" d=\"M16 9v-6h-3v-1c0-0.55-0.45-1-1-1h-11c-0.55 0-1 0.45-1 1v3c0 0.55 0.45 1 1 1h11c0.55 0 1-0.45 1-1v-1h2v4h-9v2h-0.5c-0.276 0-0.5 0.224-0.5 0.5v5c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5v-5c0-0.276-0.224-0.5-0.5-0.5h-0.5v-1h9zM12 3h-11v-1h11v1z\"/> </svg> ");


/***/ }),

/***/ 57855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    symbols: 'символ'
});


/***/ }),

/***/ 57865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: function() { return /* binding */ OptionsError; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/utils
 */ class OptionsError extends TypeError {
    constructor(m){
        super(m);
        Object.setPrototypeOf(this, OptionsError.prototype);
    }
}


/***/ }),

/***/ 57882:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1280q26 0 45 19t19 45zm256-384v128q0 26-19 45t-45 19h-1536q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1536q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-1152q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1152q26 0 45 19t19 45z\"/> </svg> ");


/***/ }),

/***/ 57951:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_helpers_utils_data_bind_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86583);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6441);
/* harmony import */ var _icons_ol_svg_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13465);
/* harmony import */ var _icons_ul_svg_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50267);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 




const memoExec = (jodit, _, { control })=>{
    var _a;
    const key = `button${control.command}`;
    const value = (_a = control.args && control.args[0]) !== null && _a !== void 0 ? _a : (0,_core_helpers_utils_data_bind_js__WEBPACK_IMPORTED_MODULE_0__/* .dataBind */ .m)(jodit, key);
    (0,_core_helpers_utils_data_bind_js__WEBPACK_IMPORTED_MODULE_0__/* .dataBind */ .m)(jodit, key, value);
    jodit.execCommand(control.command, false, value === 'default' ? null : value);
};
_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .I.set('ol', _icons_ol_svg_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A).set('ul', _icons_ul_svg_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A);
_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.controls.ul = {
    command: 'insertUnorderedList',
    tags: [
        'ul'
    ],
    tooltip: 'Insert Unordered List',
    list: {
        default: 'Default',
        circle: 'Circle',
        disc: 'Dot',
        square: 'Quadrate'
    },
    exec: memoExec
};
_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.controls.ol = {
    command: 'insertOrderedList',
    tags: [
        'ol'
    ],
    tooltip: 'Insert Ordered List',
    list: {
        default: 'Default',
        'lower-alpha': 'Lower Alpha',
        'lower-greek': 'Lower Greek',
        'lower-roman': 'Lower Roman',
        'upper-alpha': 'Upper Alpha',
        'upper-roman': 'Upper Roman'
    },
    exec: memoExec
};


/***/ }),

/***/ 58032:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 10 10\"> <path d=\"M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z\"/> </svg> ");


/***/ }),

/***/ 58149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   s: function() { return /* reexport safe */ _color_to_hex_js__WEBPACK_IMPORTED_MODULE_0__.s; }
/* harmony export */ });
/* harmony import */ var _color_to_hex_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35278);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/color
 */ 


/***/ }),

/***/ 58285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    symbols: 'тэмдэгт'
});


/***/ }),

/***/ 58487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ isHTML; }
/* harmony export */ });
/* harmony import */ var _is_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70799);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/checker
 */ 
/**
 * Check if a string is html or not
 */ const isHTML = (str)=>(0,_is_string_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .K)(str) && /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/m.test(str.replace(/[\r\n]/g, ''));


/***/ }),

/***/ 58519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export print */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22732);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_utils_default_language_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96325);
/* harmony import */ var _core_helpers_utils_print_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11628);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6441);
/* harmony import */ var _lib_generate_critical_css_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14625);
/* harmony import */ var _print_svg_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17583);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 








_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_5__/* .Icon */ .I.set('print', _print_svg_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A);
_config_js__WEBPACK_IMPORTED_MODULE_6__/* .Config */ .T.prototype.controls.print = {
    exec: (editor)=>{
        const iframe = editor.create.element('iframe');
        Object.assign(iframe.style, {
            position: 'fixed',
            right: 0,
            bottom: 0,
            width: 0,
            height: 0,
            border: 0
        });
        (0,_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .getContainer */ .My)(editor, _config_js__WEBPACK_IMPORTED_MODULE_6__/* .Config */ .T).appendChild(iframe);
        const afterFinishPrint = ()=>{
            editor.e.off(editor.ow, 'mousemove', afterFinishPrint);
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(iframe);
        };
        const myWindow = iframe.contentWindow;
        if (myWindow) {
            editor.e.on(myWindow, 'onbeforeunload onafterprint', afterFinishPrint).on(editor.ow, 'mousemove', afterFinishPrint);
            if (editor.o.iframe) {
                editor.e.fire('generateDocumentStructure.iframe', myWindow.document, editor);
                myWindow.document.body.innerHTML = editor.value;
            } else {
                myWindow.document.write('<!doctype html><html lang="' + (0,_core_helpers_utils_default_language_js__WEBPACK_IMPORTED_MODULE_3__/* .defaultLanguage */ .e)(editor.o.language) + '"><head><title></title></head><style>' + (0,_lib_generate_critical_css_js__WEBPACK_IMPORTED_MODULE_7__/* .generateCriticalCSS */ .Y)(editor) + '</style><body></body></html>');
                myWindow.document.close();
                (0,_core_helpers_utils_print_js__WEBPACK_IMPORTED_MODULE_4__/* .previewBox */ .u)(editor, undefined, 'px', myWindow.document.body);
            }
            const style = myWindow.document.createElement('style');
            style.innerHTML = `@media print {
					body {
							-webkit-print-color-adjust: exact;
					}
			}`;
            myWindow.document.head.appendChild(style);
            myWindow.focus();
            myWindow.print();
        }
    },
    mode: _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_SOURCE + _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_WYSIWYG,
    tooltip: 'Print'
};
function print(editor) {
    editor.registerButton({
        name: 'print'
    });
}
_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .pluginSystem */ .fg.add('print', print);


/***/ }),

/***/ 58844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   c: function() { return /* binding */ reset; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _checker_is_function_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23282);
/* harmony import */ var _get_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94643);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


const map = {};
/**
 * Reset Vanilla JS native function
 * @example
 * ```js
 * reset('Array.from')(Set([1,2,3])) // [1, 2, 3]
 * ```
 * You must use the function derived from the method immediately as its iframe is being removed
 */ function reset(key) {
    var _a, _b;
    if (!(key in map)) {
        const iframe = _constants_js__WEBPACK_IMPORTED_MODULE_0__.globalDocument.createElement('iframe');
        try {
            iframe.src = 'about:blank';
            _constants_js__WEBPACK_IMPORTED_MODULE_0__.globalDocument.body.appendChild(iframe);
            if (!iframe.contentWindow) {
                return null;
            }
            const func = (0,_get_js__WEBPACK_IMPORTED_MODULE_1__/* .get */ .J)(key, iframe.contentWindow), bind = (0,_get_js__WEBPACK_IMPORTED_MODULE_1__/* .get */ .J)(key.split('.').slice(0, -1).join('.'), iframe.contentWindow);
            if ((0,_checker_is_function_js__WEBPACK_IMPORTED_MODULE_2__/* .isFunction */ .T)(func)) {
                map[key] = func.bind(bind);
            }
        } catch (e) {
            if (!_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD) {
                throw e;
            }
        } finally{
            (_a = iframe.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(iframe);
        }
    }
    return (_b = map[key]) !== null && _b !== void 0 ? _b : null;
}


/***/ }),

/***/ 58908:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"><path d=\"M640 768h512v-192q0-106-75-181t-181-75-181 75-75 181v192zm832 96v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h32v-192q0-184 132-316t316-132 316 132 132 316v192h32q40 0 68 28t28 68z\"/></svg> ");


/***/ }),

/***/ 58940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C: function() { return /* binding */ checkRemoveEmptyParent; }
/* harmony export */ });
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22732);
/* harmony import */ var _check_join_two_lists_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91748);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/**
 * Check if the current empty item can be removed
 *
 * @example
 * ```html
 * <p>first stop</p><p>|<br></p>
 * ```
 * result
 * ```html
 * <p>first stop|</p>
 * ```
 *
 * @private
 */ function checkRemoveEmptyParent(jodit, fakeNode, backspace) {
    let found = false;
    const { setCursorBefore, setCursorIn } = jodit.s;
    let prn = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.closest(fakeNode, _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isElement, jodit.editor);
    if (!prn || !_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isEmpty(prn)) {
        return false;
    }
    const neighbor = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.findNotEmptyNeighbor(fakeNode, backspace, jodit.editor);
    do {
        if (prn && _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isEmpty(prn) && !_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isCell(prn)) {
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.after(prn, fakeNode);
            const tmp = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.closest(prn, (n)=>_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isElement(n) && n !== prn, jodit.editor);
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(prn);
            found = true;
            prn = tmp;
        } else {
            break;
        }
    }while (prn)
    if (found && (0,_check_join_two_lists_js__WEBPACK_IMPORTED_MODULE_2__/* .checkJoinTwoLists */ .a)(jodit, fakeNode, backspace)) {
        return true;
    }
    if (neighbor && !_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isText(neighbor) && !_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(neighbor, _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INSEPARABLE_TAGS)) {
        setCursorIn(neighbor, !backspace);
    } else {
        setCursorBefore(fakeNode);
    }
    return found;
}


/***/ }),

/***/ 59007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   As: function() { return /* reexport safe */ _stringify_js__WEBPACK_IMPORTED_MODULE_4__.A; },
/* harmony export */   Bq: function() { return /* reexport safe */ _trim_js__WEBPACK_IMPORTED_MODULE_5__.Bq; },
/* harmony export */   Gd: function() { return /* reexport safe */ _trim_js__WEBPACK_IMPORTED_MODULE_5__.Gd; },
/* harmony export */   Hp: function() { return /* reexport safe */ _fuzzy_search_index_js__WEBPACK_IMPORTED_MODULE_1__.H; },
/* harmony export */   N: function() { return /* reexport safe */ _kebab_case_js__WEBPACK_IMPORTED_MODULE_3__.N; },
/* harmony export */   Ru: function() { return /* reexport safe */ _i18n_js__WEBPACK_IMPORTED_MODULE_2__.R; },
/* harmony export */   Z2: function() { return /* reexport safe */ _ucfirst_js__WEBPACK_IMPORTED_MODULE_6__.Z; },
/* harmony export */   gj: function() { return /* reexport safe */ _trim_js__WEBPACK_IMPORTED_MODULE_5__.gj; },
/* harmony export */   kW: function() { return /* reexport safe */ _kebab_case_js__WEBPACK_IMPORTED_MODULE_3__.k; },
/* harmony export */   nv: function() { return /* reexport safe */ _i18n_js__WEBPACK_IMPORTED_MODULE_2__.n; },
/* harmony export */   xQ: function() { return /* reexport safe */ _camel_case_js__WEBPACK_IMPORTED_MODULE_0__.x; }
/* harmony export */ });
/* harmony import */ var _camel_case_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87058);
/* harmony import */ var _fuzzy_search_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67477);
/* harmony import */ var _i18n_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56967);
/* harmony import */ var _kebab_case_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12475);
/* harmony import */ var _stringify_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67462);
/* harmony import */ var _trim_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49055);
/* harmony import */ var _ucfirst_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36409);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/string
 */ 








/***/ }),

/***/ 59242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ag: function() { return /* reexport safe */ _style_constants_js__WEBPACK_IMPORTED_MODULE_2__.Ag; },
/* harmony export */   DI: function() { return /* reexport safe */ _style_constants_js__WEBPACK_IMPORTED_MODULE_2__.DI; },
/* harmony export */   LN: function() { return /* reexport safe */ _selection_js__WEBPACK_IMPORTED_MODULE_0__.L; },
/* harmony export */   OJ: function() { return /* reexport safe */ _style_constants_js__WEBPACK_IMPORTED_MODULE_2__.OJ; },
/* harmony export */   PL: function() { return /* reexport safe */ _style_constants_js__WEBPACK_IMPORTED_MODULE_2__.PL; },
/* harmony export */   Zk: function() { return /* reexport safe */ _style_constants_js__WEBPACK_IMPORTED_MODULE_2__.Zk; },
/* harmony export */   dj: function() { return /* reexport safe */ _style_constants_js__WEBPACK_IMPORTED_MODULE_2__.dj; },
/* harmony export */   xk: function() { return /* reexport safe */ _style_commit_style_js__WEBPACK_IMPORTED_MODULE_1__.x; }
/* harmony export */ });
/* harmony import */ var _selection_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79348);
/* harmony import */ var _style_commit_style_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25639);
/* harmony import */ var _style_constants_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77361);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module selection
 */ 




/***/ }),

/***/ 59292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   P: function() { return /* binding */ isFastEqual; },
/* harmony export */   n: function() { return /* binding */ isEqual; }
/* harmony export */ });
/* harmony import */ var _string_stringify_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67462);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/checker
 */ 
/**
 * Check two element are equal
 */ function isEqual(a, b) {
    return a === b || (0,_string_stringify_js__WEBPACK_IMPORTED_MODULE_0__/* .stringify */ .A)(a) === (0,_string_stringify_js__WEBPACK_IMPORTED_MODULE_0__/* .stringify */ .A)(b);
}
function isFastEqual(a, b) {
    return a === b;
}


/***/ }),

/***/ 59302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    newline: 'nouvelle ligne',
    delete: 'supprimer',
    space: 'espace',
    'Speech Recognize': 'Reconnaissance Vocale',
    Sound: 'Son',
    'Interim Results': 'Résultats Intermédiaires'
});


/***/ }),

/***/ 59436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   l: function() { return /* binding */ UIImagePropertiesForm; }
/* harmony export */ });
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65478);
/* harmony import */ var _core_decorators_component_component_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87325);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21537);
/* harmony import */ var _core_ui_group_group_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62405);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12153);
/* harmony import */ var _modules_widget_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92762);
/* harmony import */ var _ui_image_main_tab_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35105);
/* harmony import */ var _ui_image_position_tab_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29827);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








/** @private */ let UIImagePropertiesForm = class UIImagePropertiesForm extends _core_ui_group_group_js__WEBPACK_IMPORTED_MODULE_2__/* .UIGroup */ .U {
    className() {
        return 'UIImagePropertiesForm';
    }
    appendChildToContainer() {}
    getElm(elementName) {
        const selfElm = super.getElm(elementName);
        if (selfElm) {
            return selfElm;
        }
        for (const child of this.elements){
            const elm = child.getElm(elementName);
            if (elm) {
                return elm;
            }
        }
        return null;
    }
    render() {
        return `<form>
		<div class="jodit-grid jodit-grid_xs-column">
			<div class="jodit_col-lg-2-5 jodit_col-xs-5-5">
				<div class="&__view-box">
					<div class="&__imageView">
						<img class="&__imageViewSrc" src="" alt=""/>
					</div>
					<div class="jodit-form__group &__imageSizes">
						<input type="text" class="jodit-input &__imageWidth"/>
						<a class="&__lockSize">${_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .I.get('lock')}</a>
						<input type="text" class="&__imageHeight jodit-input"/>
					</div>
				</div>
			</div>
			<div class="jodit_col-lg-3-5 jodit_col-xs-5-5 &__tabsBox"></div>
		</div>
	</form>`;
    }
    onChangeSizeIsLocked() {
        const lockSize = this.getElm('lockSize');
        const imageWidth = this.getElm('imageWidth');
        lockSize.innerHTML = _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .I.get(this.state.sizeIsLocked ? 'lock' : 'unlock');
        this.setMod('lock-size', this.state.sizeIsLocked);
        this.j.e.fire(imageWidth, 'change');
    }
    onLockSizeClick() {
        this.state.sizeIsLocked = !this.state.sizeIsLocked;
    }
    onStateValuesSizeChange() {
        const imageWidth = this.getElm('imageWidth');
        const imageHeight = this.getElm('imageHeight');
        if (imageWidth !== this.j.od.activeElement) {
            imageWidth.value = this.state.values.imageWidth.toString();
        }
        if (imageHeight !== this.j.od.activeElement) {
            imageHeight.value = this.state.values.imageHeight.toString();
        }
    }
    onImageWidthChange(e) {
        const imageWidth = this.getElm('imageWidth');
        const imageHeight = this.getElm('imageHeight');
        if (!this.state.sizeIsLocked || !(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.isNumeric)(imageWidth.value) || !(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.isNumeric)(imageHeight.value)) {
            this.state.values.imageWidth = imageWidth.value;
            this.state.values.imageHeight = imageHeight.value;
            return;
        }
        const w = parseFloat(imageWidth.value), h = parseFloat(imageHeight.value);
        if (e.target === imageWidth) {
            this.state.values.imageWidth = w;
            this.state.values.imageHeight = Math.round(w / this.state.ratio);
        } else {
            this.state.values.imageWidth = Math.round(h * this.state.ratio);
            this.state.values.imageHeight = h;
        }
    }
    onStateValuesImageSrcChange() {
        const { imageSrc } = this.state.values;
        if (!imageSrc) {
            return;
        }
        const imageViewSrc = this.getElm('imageViewSrc');
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.attr)(imageViewSrc, 'src', imageSrc);
        const image = new Image();
        image.src = imageSrc;
        this.state.image = image;
    }
    hideFieldByOptions() {
        const opt = this.j.o.image;
        [
            [
                'editSize',
                'imageSizes'
            ],
            [
                'showPreview',
                'imageView'
            ]
        ].forEach(([optKey, elmKey])=>{
            const elm = this.getElm(elmKey);
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.css)(elm, 'display', opt[optKey] ? null : 'none');
        });
    }
    constructor(jodit, state, activeTabState, handlers){
        super(jodit);
        this.state = state;
        this.handlers = handlers;
        this.__mainTab = new _ui_image_main_tab_js__WEBPACK_IMPORTED_MODULE_5__/* .UIImageMainTab */ .k(this.jodit, this.state, this.handlers);
        this.__positionTab = new _ui_image_position_tab_js__WEBPACK_IMPORTED_MODULE_6__/* .UIImagePositionTab */ ._(this.jodit, this.state, this.handlers);
        this.getElm('tabsBox').appendChild((0,_modules_widget_index_js__WEBPACK_IMPORTED_MODULE_4__/* .TabsWidget */ .Zg)(jodit, [
            {
                name: 'Image',
                content: this.__mainTab
            },
            {
                name: 'Advanced',
                content: this.__positionTab
            }
        ], activeTabState));
        this.setMod('lock-size', this.state.sizeIsLocked);
        this.append(this.__mainTab).append(this.__positionTab);
    }
};
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.hook)('ready'),
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)('state.sizeIsLocked')
], UIImagePropertiesForm.prototype, "onChangeSizeIsLocked", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)('lockSize:click')
], UIImagePropertiesForm.prototype, "onLockSizeClick", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.hook)('ready'),
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)([
        'state.values.imageWidth',
        'state.values.imageHeight'
    ])
], UIImagePropertiesForm.prototype, "onStateValuesSizeChange", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)([
        'imageWidth:change',
        'imageHeight:change',
        'imageWidth:keydown',
        'imageHeight:keydown',
        'imageWidth:mousedown',
        'imageHeight:mousedown',
        'imageWidth:paste',
        'imageHeight:paste'
    ]),
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.debounce)()
], UIImagePropertiesForm.prototype, "onImageWidthChange", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.hook)('ready'),
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)('state.values.imageSrc')
], UIImagePropertiesForm.prototype, "onStateValuesImageSrcChange", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.hook)('ready')
], UIImagePropertiesForm.prototype, "hideFieldByOptions", null);
UIImagePropertiesForm = __decorate([
    _core_decorators_component_component_js__WEBPACK_IMPORTED_MODULE_7__/* .component */ .s
], UIImagePropertiesForm);



/***/ }),

/***/ 59451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   F: function() { return /* binding */ isEditorEmpty; }
/* harmony export */ });
/* unused harmony export placeholder */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2748);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_checker_is_marker_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78116);
/* harmony import */ var _core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29960);
/* harmony import */ var _core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41180);
/* harmony import */ var _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20356);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61926);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};










/**
 * Check if root node is empty
 * @private
 */ function isEditorEmpty(root) {
    var _a;
    if (!root.firstChild) {
        return true;
    }
    const first = root.firstChild;
    if (_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INSEPARABLE_TAGS.has((_a = first.nodeName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || /^(TABLE)$/i.test(first.nodeName)) {
        return false;
    }
    const next = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.next(first, (node)=>node && !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isEmptyTextNode(node), root);
    if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isText(first) && !next) {
        return _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isEmptyTextNode(first);
    }
    return !next && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.each(first, (elm)=>!(_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isLeaf(elm) || _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isList(elm)) && (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isEmpty(elm) || _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isTag(elm, 'br')));
}
/**
 * Show placeholder inside empty editor
 */ class placeholder extends _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_6__/* .Plugin */ .k {
    afterInit(editor) {
        if (!editor.o.showPlaceholder) {
            return;
        }
        this.placeholderElm = editor.c.fromHTML(`<span data-ref="placeholder" style="display: none;" class="jodit-placeholder">${editor.i18n(editor.o.placeholder)}</span>`);
        if (editor.o.direction === 'rtl') {
            this.placeholderElm.style.right = '0px';
            this.placeholderElm.style.direction = 'rtl';
        }
        editor.e.on('readonly', (isReadOnly)=>{
            if (isReadOnly) {
                this.hide();
            } else {
                this.toggle();
            }
        }).on('changePlace', this.addEvents);
        this.addEvents();
    }
    show() {
        const editor = this.j;
        if (editor.o.readonly) {
            return;
        }
        let marginTop = 0, marginLeft = 0;
        const current = editor.s.current(), wrapper = current && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.closest(current, _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isBlock, editor.editor) || editor.editor;
        const style = editor.ew.getComputedStyle(wrapper);
        const styleEditor = editor.ew.getComputedStyle(editor.editor);
        editor.workplace.appendChild(this.placeholderElm);
        const { firstChild } = editor.editor;
        if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isElement(firstChild) && !(0,_core_helpers_checker_is_marker_js__WEBPACK_IMPORTED_MODULE_4__/* .isMarker */ .r)(firstChild)) {
            const style2 = editor.ew.getComputedStyle(firstChild);
            marginTop = parseInt(style2.getPropertyValue('margin-top'), 10);
            marginLeft = parseInt(style2.getPropertyValue('margin-left'), 10);
            this.placeholderElm.style.fontSize = parseInt(style2.getPropertyValue('font-size'), 10) + 'px';
            this.placeholderElm.style.lineHeight = style2.getPropertyValue('line-height');
        } else {
            this.placeholderElm.style.fontSize = parseInt(style.getPropertyValue('font-size'), 10) + 'px';
            this.placeholderElm.style.lineHeight = style.getPropertyValue('line-height');
        }
        (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_8__/* .css */ .A)(this.placeholderElm, {
            display: 'block',
            textAlign: style.getPropertyValue('text-align'),
            paddingTop: parseInt(styleEditor.paddingTop, 10) + 'px',
            paddingLeft: parseInt(styleEditor.paddingLeft, 10) + 'px',
            paddingRight: parseInt(styleEditor.paddingRight, 10) + 'px',
            marginTop: Math.max(parseInt(style.getPropertyValue('margin-top'), 10), marginTop),
            marginLeft: Math.max(parseInt(style.getPropertyValue('margin-left'), 10), marginLeft)
        });
    }
    hide() {
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(this.placeholderElm);
    }
    toggle() {
        const editor = this.j;
        if (!editor.editor || editor.isInDestruct) {
            return;
        }
        if (editor.getRealMode() !== _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_WYSIWYG) {
            this.hide();
            return;
        }
        if (!isEditorEmpty(editor.editor)) {
            this.hide();
        } else {
            this.show();
        }
    }
    beforeDestruct(jodit) {
        this.hide();
        jodit.e.off('.placeholder').off(window, 'load', this.toggle);
    }
    constructor(){
        super(...arguments);
        this.addNativeListeners = ()=>{
            this.j.e.off(this.j.editor, 'input.placeholder keydown.placeholder').on(this.j.editor, 'input.placeholder keydown.placeholder', this.toggle);
        };
        this.addEvents = ()=>{
            const editor = this.j;
            if (editor.o.useInputsPlaceholder && editor.element.hasAttribute('placeholder')) {
                this.placeholderElm.innerHTML = (0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_5__/* .attr */ .C)(editor.element, 'placeholder') || '';
            }
            editor.e.fire('placeholder', this.placeholderElm.innerHTML);
            editor.e.off('.placeholder').on('changePlace.placeholder', this.addNativeListeners).on('change.placeholder focus.placeholder keyup.placeholder mouseup.placeholder keydown.placeholder ' + 'mousedown.placeholder afterSetMode.placeholder changePlace.placeholder', this.toggle).on(window, 'load', this.toggle);
            this.addNativeListeners();
            this.toggle();
        };
    }
}
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.debounce)((ctx)=>ctx.defaultTimeout / 10, true)
], placeholder.prototype, "toggle", null);
_core_global_js__WEBPACK_IMPORTED_MODULE_3__/* .pluginSystem */ .fg.add('placeholder', placeholder);


/***/ }),

/***/ 59483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export keyArrowOutside */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2748);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(580);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50911);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





/**
 * Allowing to go outside of an inline element if there is no other element after that.
 */ class keyArrowOutside extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Plugin */ .k {
    afterInit(jodit) {}
    beforeDestruct(jodit) {}
    onKeyDownArrow(e) {
        var _a;
        if (e.key !== _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_RIGHT || !this.j.selection.isCollapsed()) {
            return;
        }
        const { endContainer, endOffset } = this.j.selection.range;
        if (!_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isText(endContainer)) {
            return;
        }
        if (((_a = endContainer.nodeValue) === null || _a === void 0 ? void 0 : _a.length) === endOffset) {
            const { parentNode } = endContainer;
            if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isInlineBlock(parentNode) && !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.findNotEmptyNeighbor(parentNode, false, this.j.editor)) {
                _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.after(parentNode, this.j.createInside.text(_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.NBSP_SPACE));
            }
        }
    }
}
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)(':keydown')
], keyArrowOutside.prototype, "onKeyDownArrow", null);
_core_global_js__WEBPACK_IMPORTED_MODULE_3__/* .pluginSystem */ .fg.add('keyArrowOutside', keyArrowOutside);


/***/ }),

/***/ 59495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export symbols */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43555);
/* harmony import */ var _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20356);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87394);
/* harmony import */ var _langs_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32824);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 






/**
 * The plugin inserts characters that are not part of the standard keyboard.
 */ class symbols extends _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_4__/* .Plugin */ .k {
    afterInit(jodit) {
        jodit.e.on('generateSpecialCharactersTable.symbols', ()=>{
            const container = jodit.c.fromHTML(`<div class="jodit-symbols__container">
						<div class="jodit-symbols__container_table">
							<table class="jodit-symbols__table"><tbody></tbody></table>
						</div>
						<div class="jodit-symbols__container_preview">
							<div class="jodit-symbols__preview"></div>
						</div>
					</div>`);
            const preview = container.querySelector('.jodit-symbols__preview');
            const table = container.querySelector('table');
            const body = table.tBodies[0];
            const chars = [];
            for(let i = 0; i < jodit.o.specialCharacters.length;){
                const tr = jodit.c.element('tr');
                for(let j = 0; j < this.__countInRow && i < jodit.o.specialCharacters.length; j += 1, i += 1){
                    const td = jodit.c.element('td'), a = jodit.c.fromHTML(`<a
									data-index="${i}"
									data-index-j="${j}"
									role="option"
									tabindex="-1"
							>${jodit.o.specialCharacters[i]}</a>`);
                    chars.push(a);
                    td.appendChild(a);
                    tr.appendChild(td);
                }
                body.appendChild(tr);
            }
            const self = this;
            jodit.e.on(chars, 'focus', function() {
                preview.innerHTML = this.innerHTML;
            }).on(chars, 'mousedown', function(e) {
                if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(this, 'a')) {
                    jodit.s.focus();
                    jodit.s.insertHTML(this.innerHTML);
                    if (!(e === null || e === void 0 ? void 0 : e.shiftKey)) {
                        jodit.e.fire(this, 'close_dialog');
                    }
                    e && e.preventDefault();
                    e && e.stopImmediatePropagation();
                }
            }).on(chars, 'mouseenter', function() {
                if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(this, 'a')) {
                    this.focus();
                }
            }).on(chars, 'keydown', (e)=>{
                const target = e.target;
                if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(target, 'a')) {
                    const index = parseInt((0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__/* .attr */ .CF)(target, '-index') || '0', 10), jIndex = parseInt((0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__/* .attr */ .CF)(target, 'data-index-j') || '0', 10);
                    let newIndex;
                    switch(e.key){
                        case _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_UP:
                        case _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_DOWN:
                            newIndex = e.key === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_UP ? index - self.__countInRow : index + self.__countInRow;
                            if (chars[newIndex] === undefined) {
                                newIndex = e.key === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_UP ? Math.floor(chars.length / self.__countInRow) * self.__countInRow + jIndex : jIndex;
                                if (newIndex > chars.length - 1) {
                                    newIndex -= self.__countInRow;
                                }
                            }
                            chars[newIndex] && chars[newIndex].focus();
                            break;
                        case _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_RIGHT:
                        case _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_LEFT:
                            newIndex = e.key === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_LEFT ? index - 1 : index + 1;
                            if (chars[newIndex] === undefined) {
                                newIndex = e.key === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_LEFT ? chars.length - 1 : 0;
                            }
                            chars[newIndex] && chars[newIndex].focus();
                            break;
                        case _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_ENTER:
                            jodit.e.fire(target, 'mousedown');
                            e.stopImmediatePropagation();
                            e.preventDefault();
                            break;
                    }
                }
            });
            return container;
        });
    }
    /** @override */ beforeDestruct(jodit) {
        jodit.e.off('generateSpecialCharactersTable.symbols');
    }
    constructor(jodit){
        super(jodit);
        this.buttons = [
            {
                name: 'symbols',
                group: 'insert'
            }
        ];
        this.__countInRow = 17;
        (0,_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .extendLang */ .JW)(_langs_index_js__WEBPACK_IMPORTED_MODULE_6__);
    }
}
_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .pluginSystem */ .fg.add('symbols', symbols);


/***/ }),

/***/ 59498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Zd: function() { return /* reexport safe */ _get_hash_js__WEBPACK_IMPORTED_MODULE_0__.Z; },
/* harmony export */   eZ: function() { return /* reexport safe */ _visitor_visit_node_walker_js__WEBPACK_IMPORTED_MODULE_3__.e; },
/* harmony export */   hk: function() { return /* reexport safe */ _remove_format_remove_format_for_selection_js__WEBPACK_IMPORTED_MODULE_2__.h; },
/* harmony export */   w5: function() { return /* reexport safe */ _remove_format_remove_format_for_collapsed_selection_js__WEBPACK_IMPORTED_MODULE_1__.w; }
/* harmony export */ });
/* harmony import */ var _get_hash_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83447);
/* harmony import */ var _remove_format_remove_format_for_collapsed_selection_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84272);
/* harmony import */ var _remove_format_remove_format_for_selection_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42312);
/* harmony import */ var _visitor_visit_node_walker_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39516);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/clean-html
 */ 





/***/ }),

/***/ 59526:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'Type something': 'Skriv noe',
    'About Jodit': 'Om Jodit',
    'Jodit Editor': 'Jodit-redigerer',
    "Jodit User's Guide": 'Jodit brukerveiledning',
    'contains detailed help for using': 'Inneholder detaljert hjelp for bruk',
    'For information about the license, please go to our website:': 'For informasjon om lisensen, besøk vår nettside:',
    'Buy full version': 'Kjøp fullversjon',
    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.': 'Opphavsrett © XDSoft.net - Chupurnov Valeriy. Alle rettigheter forbeholdt.',
    Anchor: 'Anker',
    'Open in new tab': 'Åpne i ny fane',
    'Open in fullsize': 'Åpne i fullskjerm',
    'Clear Formatting': 'Fjern formatering',
    'Fill color or set the text color': 'Endre bakgrunns- eller tekstfarge',
    Redo: 'Gjør om',
    Undo: 'Angre',
    Bold: 'Fet',
    Italic: 'Kursiv',
    'Insert Unordered List': 'Sett inn punktliste',
    'Insert Ordered List': 'Sett inn nummerert liste',
    'Align Center': 'Midtstill',
    'Align Justify': 'Juster',
    'Align Left': 'Venstrejuster',
    'Align Right': 'Høyrejuster',
    'Insert Horizontal Line': 'Sett inn horisontal linje',
    'Insert Image': 'Sett inn bilde',
    'Insert file': 'Sett inn fil',
    'Insert youtube/vimeo video': 'Sett inn YouTube/Vimeo-video',
    'Insert link': 'Sett inn lenke',
    'Font size': 'Skriftstørrelse',
    'Font family': 'Skriftfamilie',
    'Insert format block': 'Sett inn formateringsblokk',
    Normal: 'Normal',
    'Heading 1': 'Overskrift 1',
    'Heading 2': 'Overskrift 2',
    'Heading 3': 'Overskrift 3',
    'Heading 4': 'Overskrift 4',
    Quote: 'Sitat',
    Code: 'Kode',
    Insert: 'Sett inn',
    'Insert table': 'Sett inn tabell',
    'Decrease Indent': 'Reduser innrykk',
    'Increase Indent': 'Øk innrykk',
    'Select Special Character': 'Velg spesialtegn',
    'Insert Special Character': 'Sett inn spesialtegn',
    'Paint format': 'Kopier format',
    'Change mode': 'Bytt modus (WYSIWYG/HTML)',
    Margins: 'Marger',
    top: 'topp',
    right: 'høyre',
    bottom: 'bunn',
    left: 'venstre',
    Styles: 'Stiler',
    Classes: 'Klasser',
    Align: 'Justering',
    Right: 'Høyre',
    Center: 'Senter',
    Left: 'Venstre',
    '--Not Set--': '--Ikke satt--',
    Src: 'Kilde',
    Title: 'Tittel',
    Alternative: 'Alternativ',
    Filter: 'Filter',
    Link: 'Lenke',
    'Open link in new tab': 'Åpne lenke i ny fane',
    Image: 'Bilde',
    file: 'fil',
    Advanced: 'Avansert',
    'Image properties': 'Bildeegenskaper',
    Cancel: 'Avbryt',
    Ok: 'OK',
    'Your code is similar to HTML. Keep as HTML?': 'Koden din ligner HTML. Beholde som HTML?',
    'Paste as HTML': 'Lim inn som HTML',
    Keep: 'Behold',
    Clean: 'Rens',
    'Insert as Text': 'Lim inn som tekst',
    'Word Paste Detected': 'Word-innliming oppdaget',
    'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?': 'Innholdet du limer inn kommer fra et Microsoft Word/Excel-dokument. Vil du beholde formatet eller rense det?',
    'Insert only Text': 'Lim inn kun tekst',
    'File Browser': 'Filutforsker',
    'Error on load list': 'Feil ved lasting av liste',
    'Error on load folders': 'Feil ved lasting av mapper',
    'Are you sure?': 'Er du sikker?',
    'Enter Directory name': 'Skriv inn mappenavn',
    'Create directory': 'Opprett mappe',
    'type name': 'skriv navn',
    'Drop image': 'Slipp bilde',
    'Drop file': 'Slipp fil',
    'or click': 'eller klikk',
    'Alternative text': 'Alternativ tekst',
    Browse: 'Bla gjennom',
    Upload: 'Last opp',
    Background: 'Bakgrunn',
    Border: 'Kantlinje',
    Text: 'Tekst',
    Top: 'Topp',
    Middle: 'Midt',
    Bottom: 'Bunn',
    'Insert column before': 'Sett inn kolonne før',
    'Insert column after': 'Sett inn kolonne etter',
    'Insert row above': 'Sett inn rad over',
    'Insert row below': 'Sett inn rad under',
    'Delete table': 'Slett tabell',
    'Delete row': 'Slett rad',
    'Delete column': 'Slett kolonne',
    'Empty cell': 'Tøm celle',
    'Chars: %d': 'Tegn: %d',
    'Words: %d': 'Ord: %d',
    Split: 'Del',
    'Split vertical': 'Del vertikalt',
    'Split horizontal': 'Del horisontalt',
    'Strike through': 'Gjennomstreking',
    Underline: 'Understreking',
    superscript: 'hevet skrift',
    subscript: 'senket skrift',
    'Cut selection': 'Klipp ut markering',
    'Select all': 'Velg alt',
    Break: 'Pause',
    'Search for': 'Søk etter',
    'Replace with': 'Erstatt med',
    Replace: 'Erstatt',
    Paste: 'Lim inn',
    'Choose Content to Paste': 'Velg innhold å lime inn',
    source: 'kilde',
    bold: 'fet',
    italic: 'kursiv',
    brush: 'pensel',
    link: 'lenke',
    undo: 'angre',
    redo: 'gjør om',
    table: 'tabell',
    image: 'bilde',
    eraser: 'viskelær',
    paragraph: 'avsnitt',
    fontsize: 'skriftstørrelse',
    video: 'video',
    font: 'skrift',
    about: 'om redigeringsverktøyet',
    print: 'skriv ut',
    underline: 'understreking',
    strikethrough: 'gjennomstreking',
    indent: 'innrykk',
    outdent: 'reduser innrykk',
    fullsize: 'full størrelse',
    shrink: 'krympe',
    hr: 'linje',
    ul: 'punktliste',
    ol: 'nummerert liste',
    cut: 'klipp ut',
    selectall: 'velg alt',
    'Open link': 'Åpne lenke',
    'Edit link': 'Rediger lenke',
    'No follow': 'Ingen oppfølging',
    Unlink: 'Fjern lenke',
    Eye: 'Forhåndsvisning',
    pencil: 'Rediger',
    ' URL': 'URL',
    Reset: 'Tilbakestill',
    Save: 'Lagre',
    'Save as ...': 'Lagre som ...',
    Resize: 'Endre størrelse',
    Crop: 'Beskjær',
    Width: 'Bredde',
    Height: 'Høyde',
    'Keep Aspect Ratio': 'Behold proporsjoner',
    Yes: 'Ja',
    No: 'Nei',
    Remove: 'Fjern',
    Select: 'Velg',
    'Select %s': 'Velg: %s',
    Update: 'Oppdater',
    'Vertical align': 'Vertikal justering',
    Merge: 'Slå sammen',
    'Add column': 'Legg til kolonne',
    'Add row': 'Legg til rad',
    Delete: 'Slett',
    'Horizontal align': 'Horisontal justering',
    'Sort by changed': 'Sorter etter endring',
    'Sort by name': 'Sorter etter navn',
    'Sort by size': 'Sorter etter størrelse',
    'Add folder': 'Legg til mappe',
    palette: 'Palett',
    preview: 'Forhåndsvisning',
    'Line height': 'Linjehøyde',
    'Insert className': 'Sett inn klassenavn',
    apply: 'Bruk',
    edit: 'Rediger',
    'Show all': 'Vis alle',
    sound: 'Lyd',
    'Interim Results': 'Foreløpige resultater',
    default: 'Standard',
    circle: 'Sirkel',
    dot: 'Punkt',
    square: 'Firkant',
    'Press Alt for custom resizing': 'Trykk på Alt for å endre størrelse',
    'Copy selection': 'Kopier utvalg',
    'Paste from clipboard': 'Lim inn fra utklippstavlen',
    Find: 'Finne'
});


/***/ }),

/***/ 60031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   p: function() { return /* binding */ AceEditor; }
/* harmony export */ });
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21537);
/* harmony import */ var _sourceEditor_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23370);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


class AceEditor extends _sourceEditor_js__WEBPACK_IMPORTED_MODULE_2__/* .SourceEditor */ .F {
    aceExists() {
        return this.j.ow.ace !== undefined;
    }
    getLastColumnIndex(row) {
        return this.instance.session.getLine(row).length;
    }
    getLastColumnIndices() {
        const rows = this.instance.session.getLength();
        const lastColumnIndices = [];
        let lastColIndex = 0;
        for(let i = 0; i < rows; i++){
            lastColIndex += this.getLastColumnIndex(i);
            if (i > 0) {
                lastColIndex += 1;
            }
            lastColumnIndices[i] = lastColIndex;
        }
        return lastColumnIndices;
    }
    getRowColumnIndices(characterIndex) {
        const lastColumnIndices = this.getLastColumnIndices();
        if (characterIndex <= lastColumnIndices[0]) {
            return {
                row: 0,
                column: characterIndex
            };
        }
        let row = 1;
        for(let i = 1; i < lastColumnIndices.length; i++){
            if (characterIndex > lastColumnIndices[i]) {
                row = i + 1;
            }
        }
        const column = characterIndex - lastColumnIndices[row - 1] - 1;
        return {
            row,
            column
        };
    }
    setSelectionRangeIndices(start, end) {
        const startRowColumn = this.getRowColumnIndices(start);
        const endRowColumn = this.getRowColumnIndices(end);
        this.instance.getSelection().setSelectionRange({
            start: startRowColumn,
            end: endRowColumn
        });
    }
    getIndexByRowColumn(row, column) {
        const lastColumnIndices = this.getLastColumnIndices();
        return lastColumnIndices[row] - this.getLastColumnIndex(row) + column;
    }
    init(editor) {
        const tryInitAceEditor = ()=>{
            if (this.instance !== undefined || !this.aceExists()) {
                return;
            }
            const fakeMirror = this.j.c.div('jodit-source__mirror-fake');
            this.container.appendChild(fakeMirror);
            const ace = editor.ow.ace;
            this.instance = ace.edit(fakeMirror);
            if (editor.o.direction === 'rtl') {
                this.instance.setOption('rtlText', true);
                this.instance.setOption('rtl', true);
            }
            this.instance.setTheme(editor.o.sourceEditorNativeOptions.theme);
            this.instance.renderer.setShowGutter(editor.o.sourceEditorNativeOptions.showGutter);
            this.instance.getSession().setMode(editor.o.sourceEditorNativeOptions.mode);
            this.instance.setHighlightActiveLine(editor.o.sourceEditorNativeOptions.highlightActiveLine);
            this.instance.getSession().setUseWrapMode(true);
            this.instance.setOption('indentedSoftWrap', false);
            this.instance.setOption('wrap', editor.o.sourceEditorNativeOptions.wrap);
            this.instance.getSession().setUseWorker(false);
            this.instance.$blockScrolling = Infinity;
            this.instance.on('change', this.toWYSIWYG);
            this.instance.on('focus', this.proxyOnFocus);
            this.instance.on('mousedown', this.proxyOnMouseDown);
            this.instance.on('blur', this.proxyOnBlur);
            if (editor.getRealMode() !== _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_WYSIWYG) {
                this.setValue(this.getValue());
            }
            const onResize = this.j.async.throttle(()=>{
                if (editor.isInDestruct || editor.getMode() === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_WYSIWYG) {
                    return;
                }
                const hasFocus = this.instance.isFocused();
                if (editor.o.height !== 'auto') {
                    this.instance.setOption('maxLines', editor.workplace.offsetHeight / this.instance.renderer.lineHeight);
                } else {
                    this.instance.setOption('maxLines', Infinity);
                }
                this.instance.resize();
                hasFocus && this.focus();
            }, this.j.defaultTimeout * 2);
            editor.e.on(editor, 'resize', onResize).on('afterResize afterSetMode', onResize);
            onResize();
            this.onReady();
        };
        editor.e.on('afterSetMode', ()=>{
            if (editor.getRealMode() !== _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_SOURCE && editor.getMode() !== _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_SPLIT) {
                return;
            }
            this.fromWYSIWYG();
            tryInitAceEditor();
        });
        tryInitAceEditor();
        // global add ace editor in browser
        if (!this.aceExists()) {
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.loadNext)(editor, editor.o.sourceEditorCDNUrlsJS).then(()=>{
                if (!editor.isInDestruct) {
                    tryInitAceEditor();
                }
            }).catch(()=>null);
        }
    }
    destruct() {
        var _a, _b;
        this.instance.off('change', this.toWYSIWYG);
        this.instance.off('focus', this.proxyOnFocus);
        this.instance.off('mousedown', this.proxyOnMouseDown);
        this.instance.destroy();
        (_b = (_a = this.j) === null || _a === void 0 ? void 0 : _a.events) === null || _b === void 0 ? void 0 : _b.off('aceInited.source');
    }
    setValue(value) {
        if (!this.j.o.editHTMLDocumentMode && this.j.o.beautifyHTML) {
            const html = this.j.e.fire('beautifyHTML', value);
            if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.isString)(html)) {
                value = html;
            }
        }
        this.instance.setValue(value);
        this.instance.clearSelection();
    }
    getValue() {
        return this.instance.getValue();
    }
    setReadOnly(isReadOnly) {
        this.instance.setReadOnly(isReadOnly);
    }
    get isFocused() {
        return this.instance.isFocused();
    }
    focus() {
        this.instance.container.focus();
        this.instance.focus();
    }
    blur() {
        this.instance.blur();
    }
    getSelectionStart() {
        const range = this.instance.selection.getRange();
        return this.getIndexByRowColumn(range.start.row, range.start.column);
    }
    getSelectionEnd() {
        const range = this.instance.selection.getRange();
        return this.getIndexByRowColumn(range.end.row, range.end.column);
    }
    selectAll() {
        this.instance.selection.selectAll();
    }
    insertRaw(html) {
        const start = this.instance.selection.getCursor(), end = this.instance.session.insert(start, html);
        this.instance.selection.setRange({
            start,
            end
        }, false);
    }
    setSelectionRange(start, end) {
        this.setSelectionRangeIndices(start, end);
    }
    setPlaceHolder(title) {
    // ACE does not support placeholder
    // title
    }
    replaceUndoManager() {
        const { history } = this.jodit;
        this.instance.commands.addCommand({
            name: 'Undo',
            bindKey: {
                win: 'Ctrl-Z',
                mac: 'Command-Z'
            },
            exec: ()=>{
                history.undo();
            }
        });
        this.instance.commands.addCommand({
            name: 'Redo',
            bindKey: {
                win: 'Ctrl-Shift-Z',
                mac: 'Command-Shift-Z'
            },
            exec: ()=>{
                history.redo();
            }
        });
    }
    constructor(){
        super(...arguments);
        this.className = 'jodit_ace_editor';
        /**
         * Proxy Method
         */ this.proxyOnBlur = (e)=>{
            this.j.e.fire('blur', e);
        };
        this.proxyOnFocus = (e)=>{
            this.j.e.fire('focus', e);
        };
        this.proxyOnMouseDown = (e)=>{
            this.j.e.fire('mousedown', e);
        };
    }
}


/***/ }),

/***/ 60097:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1152 512v-472q22 14 36 28l408 408q14 14 28 36h-472zm-128 32q0 40 28 68t68 28h544v1056q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h800v544z\"/> </svg> ");


/***/ }),

/***/ 60132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   kO: function() { return /* binding */ hasContainer; },
/* harmony export */   n4: function() { return /* binding */ isInitable; },
/* harmony export */   pV: function() { return /* binding */ isDestructable; }
/* harmony export */ });
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _is_function_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23282);
/* harmony import */ var _is_void_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86068);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/**
 * Check value has method init
 */ function isInitable(value) {
    return !(0,_is_void_js__WEBPACK_IMPORTED_MODULE_1__/* .isVoid */ .R)(value) && (0,_is_function_js__WEBPACK_IMPORTED_MODULE_2__/* .isFunction */ .T)(value.init);
}
/**
 * Check value has method destruct
 */ function isDestructable(value) {
    return !(0,_is_void_js__WEBPACK_IMPORTED_MODULE_1__/* .isVoid */ .R)(value) && (0,_is_function_js__WEBPACK_IMPORTED_MODULE_2__/* .isFunction */ .T)(value.destruct);
}
/**
 * Check value is instant that implements IContainer
 */ function hasContainer(value) {
    return !(0,_is_void_js__WEBPACK_IMPORTED_MODULE_1__/* .isVoid */ .R)(value) && _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isElement(value.container);
}


/***/ }),

/***/ 60175:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'Type something': '输入一些内容',
    Advanced: '高级',
    'About Jodit': '关于Jodit',
    'Jodit Editor': 'Jodit Editor',
    'Free Non-commercial Version': 'Free Non-commercial Version',
    "Jodit User's Guide": '开发者指南',
    'contains detailed help for using': '使用帮助',
    'For information about the license, please go to our website:': '有关许可证的信息，请访问我们的网站：',
    'Buy full version': '购买完整版本',
    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.': 'Copyright © XDSoft.net - Chupurnov Valeriy. 版权所有',
    Anchor: 'Anchor',
    'Open in new tab': '在新窗口打开',
    'Open in fullsize': '全屏编辑',
    'Clear Formatting': '清除样式',
    'Fill color or set the text color': '颜色',
    Redo: '重做',
    Undo: '撤销',
    Bold: '粗体',
    Italic: '斜体',
    'Insert Unordered List': '符号列表',
    'Insert Ordered List': '编号',
    'Align Center': '居中',
    'Align Justify': '对齐文本',
    'Align Left': '左对齐',
    'Align Right': '右对齐',
    'Insert Horizontal Line': '分割线',
    'Insert Image': '图片',
    'Insert file': '文件',
    'Insert youtube/vimeo video': '视频',
    'Insert link': '链接',
    'Font size': '字号',
    'Font family': '字体',
    'Insert format block': '格式块',
    Normal: '默认',
    'Heading 1': '标题1',
    'Heading 2': '标题2',
    'Heading 3': '标题3',
    'Heading 4': '标题4',
    Quote: '引用',
    Code: '代码',
    Insert: '插入',
    'Insert table': '表格',
    'Decrease Indent': '减少缩进',
    'Increase Indent': '增加缩进',
    'Select Special Character': '选择特殊符号',
    'Insert Special Character': '特殊符号',
    'Paint format': '格式复制',
    'Change mode': '改变模式',
    Margins: '外边距（Margins）',
    top: 'top',
    right: 'right',
    bottom: 'bottom',
    left: 'left',
    Styles: '样式',
    Classes: 'Classes',
    Align: '对齐方式',
    Right: '居右',
    Center: '居中',
    Left: '居左',
    '--Not Set--': '无',
    Src: 'Src',
    Title: 'Title',
    Alternative: 'Alternative',
    Link: 'Link',
    'Open link in new tab': '在新窗口打开链接',
    Image: '图片',
    file: 'file',
    'Image properties': '图片属性',
    Cancel: '取消',
    Ok: '确定',
    'Your code is similar to HTML. Keep as HTML?': '你粘贴的文本是一段html代码，是否保留源格式',
    'Paste as HTML': 'html粘贴',
    Keep: '保留源格式',
    Clean: '匹配目标格式',
    'Insert as Text': '把html代码视为普通文本',
    'Word Paste Detected': '文本粘贴',
    'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?': '正在粘贴 Word/Excel 的文本，是否保留源格式？',
    'Insert only Text': '只保留文本',
    'File Browser': '文件管理',
    'Error on load list': '加载list错误',
    'Error on load folders': '加载folders错误',
    'Are you sure?': '你确定吗？',
    'Enter Directory name': '输入路径',
    'Create directory': '创建路径',
    'type name': 'type name',
    'Drop image': '拖动图片到此',
    'Drop file': '拖动文件到此',
    'or click': '或点击',
    'Alternative text': 'Alternative text',
    Browse: '浏览',
    Upload: '上传',
    Background: '背景色',
    Text: '文字',
    Top: '顶部',
    Middle: '中间',
    Bottom: '底部',
    'Insert column before': '在之前插入列',
    'Insert column after': '在之后插入列',
    'Insert row above': '在之前插入行',
    'Insert row below': '在之后插入行',
    'Delete table': '删除表格',
    'Delete row': '删除行',
    'Delete column': '删除列',
    'Empty cell': '清除内容',
    'Chars: %d': '字符数: %d',
    'Words: %d': '单词数: %d',
    'Strike through': '删除线',
    Underline: '下划线',
    superscript: '上标',
    subscript: '下标',
    'Cut selection': '剪切',
    'Select all': '全选',
    Break: 'Break',
    'Search for': '查找',
    'Replace with': '替换为',
    Replace: '替换',
    Edit: '编辑',
    Paste: '粘贴',
    'Choose Content to Paste': '选择内容并粘贴',
    All: '全部',
    source: '源码',
    bold: '粗体',
    italic: '斜体',
    brush: '颜色',
    link: '链接',
    undo: '撤销',
    redo: '重做',
    table: '表格',
    image: '图片',
    eraser: '橡皮擦',
    paragraph: '段落',
    fontsize: '字号',
    video: '视频',
    font: '字体',
    about: '关于',
    print: '打印',
    underline: '下划线',
    strikethrough: '上出现',
    indent: '增加缩进',
    outdent: '减少缩进',
    fullsize: '全屏',
    shrink: '收缩',
    hr: '分割线',
    ul: '无序列表',
    ol: '顺序列表',
    cut: '剪切',
    selectall: '全选',
    'Open link': '打开链接',
    'Edit link': '编辑链接',
    'No follow': 'No follow',
    Unlink: '取消链接',
    Eye: '预览',
    ' URL': 'URL',
    Reset: '重置',
    Save: '保存',
    'Save as ...': '保存为',
    Resize: '调整大小',
    Crop: '剪切',
    Width: '宽',
    Height: '高',
    'Keep Aspect Ratio': '保持长宽比',
    Yes: '是',
    No: '不',
    Remove: '移除',
    Select: '选择',
    'Select %s': '选择: %s',
    Update: '更新',
    'Vertical align': '垂直对齐',
    Merge: '合并',
    'Add column': '添加列',
    'Add row': '添加行',
    Border: '边框',
    'Embed code': '嵌入代码',
    Delete: '删除',
    'Horizontal align': '水平对齐',
    Filter: '筛选',
    'Sort by changed': '修改时间排序',
    'Sort by name': '名称排序',
    'Sort by size': '大小排序',
    'Add folder': '新建文件夹',
    Split: '拆分',
    'Split vertical': '垂直拆分',
    'Split horizontal': '水平拆分',
    'You can only edit your own images. Download this image on the host?': '你只能编辑你自己的图片。Download this image on the host?',
    'The image has been successfully uploaded to the host!': '图片上传成功',
    palette: '调色板',
    pencil: '铅笔',
    'There are no files': '此目录中沒有文件。',
    Rename: '重命名',
    'Enter new name': '输入新名称',
    preview: '预览',
    download: '下载',
    'Paste from clipboard': '粘贴从剪贴板',
    "Your browser doesn't support direct access to the clipboard.": '你浏览器不支持直接访问的剪贴板。',
    'Copy selection': '复制选中内容',
    copy: '复制',
    'Border radius': '边界半径',
    'Show all': '显示所有',
    Apply: '应用',
    'Please fill out this field': '请填写这个字段',
    'Please enter a web address': '请输入一个网址',
    Default: '默认',
    Circle: '圆圈',
    Dot: '点',
    Quadrate: '方形',
    Find: '搜索',
    'Find Previous': '查找上一个',
    'Find Next': '查找下一个',
    'Insert className': '插入班级名称',
    'Press Alt for custom resizing': '按Alt自定义调整大小'
});


/***/ }),

/***/ 60181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   G: function() { return /* binding */ applyStylesPro; }
/* harmony export */ });
/* harmony import */ var _transform_word_to_html__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56869);
/* harmony import */ var jodit_esm_core_dom_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var jodit_esm_core_helpers_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43555);
/* harmony import */ var jodit_pro_plugins_paste_from_word_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31117);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */




function applyStylesPro(jodit, html, removeStyles, rtf = '') {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    try {
        const doc = iframe.contentDocument ?? iframe.contentWindow?.document;
        if (!doc) {
            return html;
        }
        doc.open();
        doc.write(html);
        doc.close();
        const JDS = 'jd-style';
        for (let i = 0; i < doc.styleSheets.length; i += 1) {
            try {
                const rules = doc.styleSheets[i]
                    .cssRules;
                for (let idx = 0; idx < rules.length; idx += 1) {
                    if (!rules[idx].selectorText) {
                        continue;
                    }
                    (0,jodit_esm_core_helpers_utils__WEBPACK_IMPORTED_MODULE_2__.$$)(rules[idx].selectorText, doc.body).forEach((elm) => {
                        if (!(0,jodit_esm_core_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .attr */ .CF)(elm, JDS)) {
                            (0,jodit_esm_core_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .attr */ .CF)(elm, JDS, (0,jodit_esm_core_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .attr */ .CF)(elm, 'style') || '');
                            (0,jodit_esm_core_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .attr */ .CF)(elm, 'style', '');
                        }
                        (0,jodit_esm_core_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .attr */ .CF)(elm, 'style', `${(0,jodit_esm_core_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .attr */ .CF)(elm, 'style')};${rules[idx].style.cssText}`);
                    });
                }
            }
            catch (e) { }
        }
        (0,jodit_esm_core_helpers_utils__WEBPACK_IMPORTED_MODULE_2__.$$)(`[${JDS}]`, doc.body).forEach((elm) => {
            (0,jodit_esm_core_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .attr */ .CF)(elm, 'style', `${(0,jodit_esm_core_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .attr */ .CF)(elm, 'style')};${(0,jodit_esm_core_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .attr */ .CF)(elm, JDS)}`);
        });
        return (0,_transform_word_to_html__WEBPACK_IMPORTED_MODULE_0__/* .transformWordToHtml */ .d)(jodit, jodit_pro_plugins_paste_from_word_element__WEBPACK_IMPORTED_MODULE_3__/* .JElement */ .Rd.make(doc.body), removeStyles, rtf);
    }
    finally {
        jodit_esm_core_dom_dom__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(iframe);
    }
    return html;
}


/***/ }),

/***/ 60373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    Spellcheck: 'Vérification Orthographique'
});


/***/ }),

/***/ 60629:
/***/ (function(__unused_webpack_module, __webpack_exports__) {


/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'copy-format': 'Копировать формат'
});


/***/ }),

/***/ 61019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export lineHeight */
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21537);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50911);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26295);
/* harmony import */ var _langs_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28143);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







class lineHeight extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Plugin */ .k {
    afterInit(jodit) {
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(jodit.editor, {
            lineHeight: jodit.o.defaultLineHeight
        });
        jodit.registerCommand('applyLineHeight', this.applyLineHeight);
    }
    applyLineHeight(ignore, ignoreA, value) {
        const { s, createInside: c, editor: root, o } = this.j;
        if (!s.isFocused()) {
            s.focus();
        }
        s.save();
        let addStyle;
        const apply = (node)=>{
            let parentBlock = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.closest(node, _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isBlock, root);
            if (!parentBlock) {
                parentBlock = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.wrap(node, o.enter, c);
            }
            const previousValue = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(parentBlock, 'lineHeight');
            if (addStyle === undefined) {
                addStyle = previousValue.toString() !== value.toString();
            }
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(parentBlock, 'lineHeight', addStyle ? value : null);
        };
        try {
            if (s.isCollapsed()) {
                const fake = c.fake();
                s.insertNode(fake, false, false);
                apply(fake);
                _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(fake);
            } else {
                s.eachSelection(apply);
            }
        } finally{
            s.restore();
        }
    }
    beforeDestruct(jodit) {
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(jodit.editor, {
            lineHeight: null
        });
    }
    constructor(jodit){
        super(jodit);
        this.buttons = [
            {
                name: 'lineHeight',
                group: 'font'
            }
        ];
        (0,_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .extendLang */ .JW)(_langs_index_js__WEBPACK_IMPORTED_MODULE_6__);
    }
}
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], lineHeight.prototype, "applyLineHeight", null);
_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .pluginSystem */ .fg.add('lineHeight', lineHeight);


/***/ }),

/***/ 61072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    'Line height': 'גובה שורה'
});


/***/ }),

/***/ 61122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29960);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/* harmony default export */ __webpack_exports__.A = ([
    {
        name: 'eye',
        tooltip: 'Open link',
        exec: (editor, current)=>{
            const href = (0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__/* .attr */ .C)(current, 'href');
            if (current && href) {
                editor.ow.open(href);
            }
        }
    },
    {
        name: 'link',
        tooltip: 'Edit link',
        icon: 'pencil'
    },
    'unlink',
    'brush',
    'file'
]);


/***/ }),

/***/ 61251:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_request_config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57459);
/* harmony import */ var _core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27613);
/* harmony import */ var _core_helpers_utils_human_size_to_bytes_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38420);
/* harmony import */ var _core_ui_form_inputs_file_file_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4242);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 




_config_js__WEBPACK_IMPORTED_MODULE_3__/* .Config */ .T.prototype.filebrowser = {
    namespace: '',
    cache: true,
    extraButtons: [],
    filter (item, search) {
        search = search.toLowerCase();
        if ((0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .Kg)(item)) {
            return item.toLowerCase().indexOf(search) !== -1;
        }
        if ((0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .Kg)(item.name)) {
            return item.name.toLowerCase().indexOf(search) !== -1;
        }
        if ((0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .Kg)(item.file)) {
            return item.file.toLowerCase().indexOf(search) !== -1;
        }
        return true;
    },
    sortBy: 'changed-desc',
    sort (a, b, sortBy) {
        const [sortAttr, arrow] = sortBy.toLowerCase().split('-'), asc = arrow === 'asc';
        const compareStr = (f, s)=>{
            if (f < s) {
                return asc ? -1 : 1;
            }
            if (f > s) {
                return asc ? 1 : -1;
            }
            return 0;
        };
        if ((0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .Kg)(a)) {
            return compareStr(a.toLowerCase(), b.toLowerCase());
        }
        if (a[sortAttr] === undefined || sortAttr === 'name') {
            if ((0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .Kg)(a.name)) {
                return compareStr(a.name.toLowerCase(), b.name.toLowerCase());
            }
            if ((0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .Kg)(a.file)) {
                return compareStr(a.file.toLowerCase(), b.file.toLowerCase());
            }
            return 0;
        }
        switch(sortAttr){
            case 'changed':
                {
                    const f = new Date(a.changed).getTime(), s = new Date(b.changed).getTime();
                    return asc ? f - s : s - f;
                }
            case 'size':
                {
                    const f = (0,_core_helpers_utils_human_size_to_bytes_js__WEBPACK_IMPORTED_MODULE_4__/* .humanSizeToBytes */ .z)(a.size), s = (0,_core_helpers_utils_human_size_to_bytes_js__WEBPACK_IMPORTED_MODULE_4__/* .humanSizeToBytes */ .z)(b.size);
                    return asc ? f - s : s - f;
                }
        }
        return 0;
    },
    editImage: true,
    preview: true,
    showPreviewNavigation: true,
    showSelectButtonInPreview: true,
    contextMenu: true,
    howLongShowMsg: 3000,
    createNewFolder: true,
    deleteFolder: true,
    renameFolder: true,
    moveFolder: true,
    moveFile: true,
    permissionsPresets: {
        allowFileDownload: undefined,
        allowFileMove: undefined,
        allowFileRemove: undefined,
        allowFileRename: undefined,
        allowFileUpload: undefined,
        allowFileUploadRemote: undefined,
        allowFiles: undefined,
        allowFolderCreate: undefined,
        allowFolderMove: undefined,
        allowFolderRemove: undefined,
        allowFolderRename: undefined,
        allowFolderTree: undefined,
        allowFolders: undefined,
        allowGeneratePdf: undefined,
        allowImageCrop: undefined,
        allowImageResize: undefined
    },
    showFoldersPanel: true,
    storeLastOpenedFolder: true,
    width: 859,
    height: 400,
    buttons: [
        'filebrowser.upload',
        'filebrowser.remove',
        'filebrowser.update',
        'filebrowser.select',
        'filebrowser.edit',
        '|',
        'filebrowser.tiles',
        'filebrowser.list',
        '|',
        'filebrowser.filter',
        '|',
        'filebrowser.sort'
    ],
    removeButtons: [],
    fullsize: false,
    showTooltip: true,
    view: null,
    isSuccess (resp) {
        return resp.success;
    },
    getMessage (resp) {
        return resp.data.messages !== undefined && (0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isArray */ .cy)(resp.data.messages) ? resp.data.messages.join(' ') : '';
    },
    showFileName: true,
    showFileSize: true,
    showFileChangeTime: true,
    saveStateInStorage: {
        storeLastOpenedFolder: true,
        storeView: true,
        storeSortBy: true
    },
    pixelOffsetLoadNewChunk: 200,
    getThumbTemplate (item, source, source_name) {
        const opt = this.options, IC = this.files.getFullElName('item'), showName = opt.showFileName, showSize = opt.showFileSize && item.size, showTime = opt.showFileChangeTime && item.time;
        let name = '';
        if (item.file !== undefined) {
            name = item.file;
        }
        const info = `<div class="${IC}-info">${showName ? `<span class="${IC}-info-filename">${name}</span>` : ''}${showSize ? `<span class="${IC}-info-filesize">${item.size}</span>` : ''}${showTime ? `<span class="${IC}-info-filechanged">${showTime}</span>` : ''}</div>`;
        return `<a
			data-jodit-file-browser-item="true"
			data-is-file="${item.isImage ? 0 : 1}"
			draggable="true"
			class="${IC}"
			href="${item.fileURL}"
			data-source="${source_name}"
			data-path="${item.path}"
			data-name="${name}"
			title="${name}"
			data-url="${item.fileURL}">
				<img
					data-is-file="${item.isImage ? 0 : 1}"
					data-src="${item.fileURL}"
					src="${item.imageURL}"
					alt="${name}"
					loading="lazy"
				/>
				${showName || showSize || showTime ? info : ''}
			</a>`;
    },
    ajax: {
        ..._config_js__WEBPACK_IMPORTED_MODULE_3__/* .Config */ .T.prototype.defaultAjaxOptions,
        url: '',
        data: {},
        cache: true,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        method: 'POST',
        processData: true,
        headers: {},
        prepareData (data) {
            return data;
        },
        process (resp) {
            return resp;
        }
    },
    create: {
        data: {
            action: 'folderCreate'
        }
    },
    getLocalFileByUrl: {
        data: {
            action: 'getLocalFileByUrl'
        }
    },
    resize: {
        data: {
            action: 'imageResize'
        }
    },
    crop: {
        data: {
            action: 'imageCrop'
        }
    },
    fileMove: {
        data: {
            action: 'fileMove'
        }
    },
    folderMove: {
        data: {
            action: 'folderMove'
        }
    },
    fileRename: {
        data: {
            action: 'fileRename'
        }
    },
    folderRename: {
        data: {
            action: 'folderRename'
        }
    },
    fileRemove: {
        data: {
            action: 'fileRemove'
        }
    },
    folderRemove: {
        data: {
            action: 'folderRemove'
        }
    },
    items: {
        data: {
            action: 'files'
        }
    },
    folder: {
        data: {
            action: 'folders'
        }
    },
    permissions: {
        data: {
            action: 'permissions'
        }
    }
};
_config_js__WEBPACK_IMPORTED_MODULE_3__/* .Config */ .T.prototype.controls.filebrowser = {
    upload: {
        icon: 'plus',
        tooltip: 'Upload file',
        isInput: true,
        isDisabled: (browser)=>!browser.dataProvider.canI('FileUpload'),
        getContent: (filebrowser, btnInt)=>{
            const btn = new _core_ui_form_inputs_file_file_js__WEBPACK_IMPORTED_MODULE_2__/* .UIFileInput */ .n(filebrowser, {
                tooltip: btnInt.control.tooltip,
                onlyImages: filebrowser.state.onlyImages
            });
            filebrowser.e.fire('bindUploader.filebrowser', btn.container);
            return btn.container;
        }
    },
    remove: {
        icon: 'bin',
        tooltip: 'Remove file',
        isDisabled: (browser)=>{
            return !browser.state.activeElements.length || !browser.dataProvider.canI('FileRemove');
        },
        exec: (editor)=>{
            editor.e.fire('fileRemove.filebrowser');
        }
    },
    update: {
        tooltip: 'Update file list',
        exec: (editor)=>{
            editor.e.fire('update.filebrowser');
        }
    },
    select: {
        tooltip: 'Select file',
        icon: 'check',
        isDisabled: (browser)=>!browser.state.activeElements.length,
        exec: (editor)=>{
            editor.e.fire('select.filebrowser');
        }
    },
    edit: {
        tooltip: 'Edit image',
        icon: 'pencil',
        isDisabled: (browser)=>{
            const selected = browser.state.activeElements;
            return selected.length !== 1 || !selected[0].isImage || !(browser.dataProvider.canI('ImageCrop') || browser.dataProvider.canI('ImageResize'));
        },
        exec: (editor)=>{
            editor.e.fire('edit.filebrowser');
        }
    },
    tiles: {
        tooltip: 'Tiles view',
        icon: 'th',
        isActive: (filebrowser)=>filebrowser.state.view === 'tiles',
        exec: (filebrowser)=>{
            filebrowser.e.fire('view.filebrowser', 'tiles');
        }
    },
    list: {
        tooltip: 'List view',
        icon: 'th-list',
        isActive: (filebrowser)=>filebrowser.state.view === 'list',
        exec: (filebrowser)=>{
            filebrowser.e.fire('view.filebrowser', 'list');
        }
    },
    filter: {
        isInput: true,
        getContent: (filebrowser, b)=>{
            const oldInput = b.container.querySelector('.jodit-input');
            if (oldInput) {
                return oldInput;
            }
            const input = filebrowser.c.element('input', {
                class: 'jodit-input',
                placeholder: filebrowser.i18n('Filter')
            });
            input.value = filebrowser.state.filterWord;
            filebrowser.e.on(input, 'keydown mousedown', filebrowser.async.debounce(()=>{
                filebrowser.e.fire('filter.filebrowser', input.value);
            }, filebrowser.defaultTimeout));
            return input;
        }
    },
    sort: {
        isInput: true,
        getContent: (fb)=>{
            const select = fb.c.fromHTML('<select class="jodit-input jodit-select">' + `<option value="changed-asc">${fb.i18n('Sort by changed')} (⬆)</option>` + `<option value="changed-desc">${fb.i18n('Sort by changed')} (⬇)</option>` + `<option value="name-asc">${fb.i18n('Sort by name')} (⬆)</option>` + `<option value="name-desc">${fb.i18n('Sort by name')} (⬇)</option>` + `<option value="size-asc">${fb.i18n('Sort by size')} (⬆)</option>` + `<option value="size-desc">${fb.i18n('Sort by size')} (⬇)</option>` + '</select>');
            select.value = fb.state.sortBy;
            fb.e.on('sort.filebrowser', (value)=>{
                if (select.value !== value) {
                    select.value = value;
                }
            }).on(select, 'change', ()=>{
                fb.e.fire('sort.filebrowser', select.value);
            });
            return select;
        }
    }
};


/***/ }),

/***/ 61259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   z: function() { return /* reexport safe */ _popup_js__WEBPACK_IMPORTED_MODULE_0__.z; }
/* harmony export */ });
/* harmony import */ var _popup_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56917);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module ui/popup
 */ 


/***/ }),

/***/ 61323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export clipboard */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_decorators_cache_cache_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33433);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21537);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79419);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 




/**
 * Clipboard plugin - cut and copy functionality
 */ class clipboard {
    init(editor) {
        var _a;
        (_a = this.buttons) === null || _a === void 0 ? void 0 : _a.forEach((btn)=>editor.registerButton(btn));
        editor.e.off(`copy.${_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.CLIPBOARD_ID} cut.${_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.CLIPBOARD_ID}`).on(`copy.${_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.CLIPBOARD_ID} cut.${_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.CLIPBOARD_ID}`, (event)=>{
            var _a;
            const selectedText = editor.s.html;
            const clipboardData = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.getDataTransfer)(event) || (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.getDataTransfer)(editor.ew) || (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.getDataTransfer)(event.originalEvent);
            if (clipboardData) {
                clipboardData.setData(_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.TEXT_PLAIN, (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.stripTags)(selectedText));
                clipboardData.setData(_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.TEXT_HTML, selectedText);
            }
            editor.buffer.set(_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.CLIPBOARD_ID, selectedText);
            editor.e.fire('pasteStack', {
                html: selectedText,
                action: editor.o.defaultActionOnPaste || _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INSERT_AS_HTML
            });
            if (event.type === 'cut') {
                editor.s.remove();
                editor.s.focus();
            }
            event.preventDefault();
            (_a = editor === null || editor === void 0 ? void 0 : editor.events) === null || _a === void 0 ? void 0 : _a.fire('afterCopy', selectedText);
        });
    }
    /** @override */ destruct(editor) {
        var _a, _b;
        (_a = (0,_core_decorators_cache_cache_js__WEBPACK_IMPORTED_MODULE_1__/* .cached */ .PO)(editor, 'buffer')) === null || _a === void 0 ? void 0 : _a.set(_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.CLIPBOARD_ID, '');
        (_b = editor === null || editor === void 0 ? void 0 : editor.events) === null || _b === void 0 ? void 0 : _b.off('.' + _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.CLIPBOARD_ID);
    }
    constructor(){
        /** @override */ this.buttons = [
            {
                name: 'cut',
                group: 'clipboard'
            },
            {
                name: 'copy',
                group: 'clipboard'
            },
            {
                name: 'paste',
                group: 'clipboard'
            },
            {
                name: 'selectall',
                group: 'clipboard'
            }
        ];
    }
}
_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .pluginSystem */ .fg.add('clipboard', clipboard);


/***/ }),

/***/ 61388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   j: function() { return /* binding */ removeWidthFromTableCell; }
/* harmony export */ });
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */
const removeWidthFromTableCell = (elm) => {
    if (elm.attributes.width && (elm.name === 'th' || elm.name === 'td')) {
        elm.attributes.width = null;
    }
    return elm;
};


/***/ }),

/***/ 61926:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/placeholder
 */ 
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.showPlaceholder = true;
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.placeholder = 'Type something';
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.useInputsPlaceholder = true;


/***/ }),

/***/ 61991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   b: function() { return /* binding */ checkUnsplittableBox; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/**
 * Inside quote/tables cell, etc. you can't split so just add br
 * @private
 */ function checkUnsplittableBox(fake, jodit, currentBox) {
    if (!_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.canSplitBlock(currentBox)) {
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.before(fake, jodit.createInside.element('br'));
        return false;
    }
    return true;
}


/***/ }),

/***/ 62000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27613);
/* harmony import */ var _core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41180);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

const cmd = (control)=>control.args && (0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .Kg)(control.args[0]) ? control.args[0].toLowerCase() : '';
/* harmony default export */ __webpack_exports__.A = ([
    'brushCell',
    {
        name: 'valign',
        list: [
            'Top',
            'Middle',
            'Bottom',
            'Normal'
        ],
        childTemplate: (_, __, value)=>value,
        exec: (editor, table, { control })=>{
            const command = cmd(control);
            editor.getInstance('Table', editor.o).getAllSelectedCells().forEach((cell)=>{
                (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_1__/* .css */ .A)(cell, 'vertical-align', command === 'normal' ? '' : command);
            });
        },
        tooltip: 'Vertical align'
    },
    {
        name: 'splitv',
        list: {
            tablesplitv: 'Split vertical',
            tablesplitg: 'Split horizontal'
        },
        tooltip: 'Split'
    },
    {
        name: 'align',
        icon: 'left'
    },
    '\n',
    {
        name: 'merge',
        command: 'tablemerge',
        tooltip: 'Merge'
    },
    {
        name: 'addcolumn',
        list: {
            tableaddcolumnbefore: 'Insert column before',
            tableaddcolumnafter: 'Insert column after'
        },
        exec: (editor, table, { control })=>{
            if (!(0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_0__/* .isJoditObject */ .y0)(editor)) {
                return;
            }
            if (!control.args) {
                return false;
            }
            const command = cmd(control);
            editor.execCommand(command, false, table);
        },
        tooltip: 'Add column'
    },
    {
        name: 'addrow',
        list: {
            tableaddrowbefore: 'Insert row above',
            tableaddrowafter: 'Insert row below'
        },
        exec: (editor, table, { control })=>{
            if (!(0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_0__/* .isJoditObject */ .y0)(editor)) {
                return;
            }
            if (!control.args) {
                return false;
            }
            const command = cmd(control);
            editor.execCommand(command, false, table);
        },
        tooltip: 'Add row'
    },
    {
        name: 'delete',
        icon: 'bin',
        list: {
            tablebin: 'Delete table',
            tablebinrow: 'Delete row',
            tablebincolumn: 'Delete column',
            tableempty: 'Empty cell'
        },
        exec: (editor, table, { control })=>{
            if (!(0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_0__/* .isJoditObject */ .y0)(editor)) {
                return;
            }
            if (!control.args) {
                return false;
            }
            const command = cmd(control);
            editor.execCommand(command, false, table);
            editor.e.fire('hidePopup');
        },
        tooltip: 'Delete'
    }
]);


/***/ }),

/***/ 62232:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'Type something': 'Scrivi qualcosa...',
    Advanced: 'Avanzato',
    'About Jodit': 'A proposito di Jodit',
    'Jodit Editor': 'Jodit Editor',
    "Jodit User's Guide": 'Guida utente di Jodit',
    'contains detailed help for using': "contiene una guida dettagliata per l'uso.",
    'For information about the license, please go to our website:': 'Per informazioni sulla licenza, si prega di visitare il nostro sito web:',
    'Buy full version': 'Acquista la versione completa',
    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.': 'Copyright © XDSoft.net - Chupurnov Valeriy. Tutti i diritti riservati.',
    Anchor: 'Link',
    'Open in new tab': 'Apri in una nuova scheda',
    'Open in fullsize': "Apri l'editor a schermo intero",
    'Clear Formatting': 'Pulisci Formattazione',
    'Fill color or set the text color': 'Colore di sfondo o del testo',
    Redo: 'Ripristina',
    Undo: 'Annulla',
    Bold: 'Grassetto',
    Italic: 'Corsivo',
    'Insert Unordered List': 'Inserisci lista non ordinata',
    'Insert Ordered List': 'Inserisci lista ordinata',
    'Align Center': 'Allinea al centro',
    'Align Justify': 'Allineamento Giustificato',
    'Align Left': 'Allinea a Sinistra',
    'Align Right': 'Allinea a Destra',
    'Insert Horizontal Line': 'Inserisci una linea orizzontale',
    'Insert Image': 'Inserisci immagine',
    'Insert file': 'Inserisci un file',
    'Insert youtube/vimeo video': 'Inserisci video Youtube/Vimeo',
    'Insert link': 'Inserisci link',
    'Font size': 'Dimensione carattere',
    'Font family': 'Tipo di font',
    'Insert format block': 'Inserisci blocco',
    Normal: 'Normale',
    'Heading 1': 'Intestazione 1',
    'Heading 2': 'Intestazione 2',
    'Heading 3': 'Intestazione 3',
    'Heading 4': 'Intestazione 4',
    Quote: 'Citazione',
    Code: 'Codice',
    Insert: 'Inserisci',
    'Insert table': 'Inserisci tabella',
    'Decrease Indent': 'Riduci il rientro',
    'Increase Indent': 'Aumenta il rientro',
    'Select Special Character': 'Seleziona un carattere speciale',
    'Insert Special Character': 'Inserisci un carattere speciale',
    'Paint format': 'Copia formato',
    'Change mode': "Cambia modalita'",
    Margins: 'Margini',
    top: 'su',
    right: 'destra',
    bottom: 'giù',
    left: 'sinistra',
    Styles: 'Stili CSS',
    Classes: 'Classi CSS',
    Align: 'Allinea',
    Right: 'Destra',
    Center: 'Centro',
    Left: 'Sinistra',
    '--Not Set--': '--Non Impostato--',
    Src: 'Fonte',
    Title: 'Titolo',
    Alternative: 'Testo Alternativo',
    Link: 'Link',
    'Open link in new tab': 'Apri il link in una nuova scheda',
    Image: 'Immagine',
    file: 'Archivio',
    'Image properties': "Proprietà dell'immagine",
    Cancel: 'Annulla',
    Ok: 'Accetta',
    'Your code is similar to HTML. Keep as HTML?': "Il codice è simile all'HTML. Mantieni come HTML?",
    'Paste as HTML': 'Incolla come HTML',
    Keep: 'Mantieni',
    Clean: 'Pulisci',
    'Insert as Text': 'Inserisci come testo',
    'Word Paste Detected': 'Incolla testo da Word rilevato',
    'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?': 'Il contenuto incollato proviene da un documento Microsoft Word / Excel. Vuoi mantenere il formato o pulirlo?',
    'Insert only Text': 'Inserisci solo il testo',
    'File Browser': 'Cerca file',
    'Error on load list': "Errore durante il caricamento dell'elenco",
    'Error on load folders': 'Errore durante il caricamento delle cartelle',
    'Are you sure?': 'Sei sicuro?',
    'Enter Directory name': 'Inserisci il nome della cartella',
    'Create directory': 'Crea cartella',
    'type name': 'Digita il nome',
    'Drop image': 'Cancella immagine',
    'Drop file': 'Cancella file',
    'or click': 'o clicca',
    'Alternative text': 'Testo alternativo',
    Browse: 'Sfoglia',
    Upload: 'Carica',
    Background: 'Sfondo',
    Text: 'Testo',
    Top: 'Su',
    Middle: 'Centro',
    Bottom: 'Sotto',
    'Insert column before': 'Inserisci la colonna prima',
    'Insert column after': 'Inserisci la colonna dopo',
    'Insert row above': 'Inserisci la riga sopra',
    'Insert row below': 'Inserisci la riga sotto',
    'Delete table': 'Elimina tabella',
    'Delete row': 'Elimina riga',
    'Delete column': 'Elimina colonna',
    'Empty cell': 'Cella vuota',
    Delete: 'Cancella',
    'Strike through': 'Barrato',
    Underline: 'Sottolineato',
    Break: 'Pausa',
    'Search for': 'Cerca per',
    'Replace with': 'Sostituisci con',
    Replace: 'Sostituisci',
    Edit: 'Modifica',
    'Vertical align': 'Allineamento verticala',
    'Horizontal align': 'Allineamento orizzontale',
    Filter: 'Filtro',
    'Sort by changed': 'Ordina per data di modifica',
    'Sort by name': 'Ordina per nome',
    'Sort by size': 'Ordina per dimensione',
    'Add folder': 'Aggiungi cartella',
    Split: 'Dividi',
    'Split vertical': 'Dividi verticalmente',
    'Split horizontal': 'Dividi orizzontale',
    Merge: 'Fondi',
    'Add column': 'Aggiungi colonna',
    'Add row': 'Aggiungi riga',
    Border: 'Bordo',
    'Embed code': 'Includi codice',
    Update: 'Aggiorna',
    superscript: 'indice',
    subscript: 'pedice',
    'Cut selection': 'Taglia selezione',
    Paste: 'Incolla',
    'Choose Content to Paste': 'Seleziona il contenuto da incollare',
    'Chars: %d': 'Caratteri: %d',
    'Words: %d': 'Parole: %d',
    All: 'Tutto',
    'Select %s': 'Seleziona: %s',
    'Select all': 'Seleziona tutto',
    source: 'risorsa',
    bold: 'Grassetto',
    italic: 'Corsivo',
    brush: 'Pennello',
    link: 'Link',
    undo: 'Annulla',
    redo: 'Ripristina',
    table: 'Tabella',
    image: 'Immagine',
    eraser: 'Gomma',
    paragraph: 'Paragrafo',
    fontsize: 'Dimensione del carattere',
    video: 'Video',
    font: 'Font',
    about: 'Approposito di',
    print: 'Stampa',
    underline: 'Sottolineato',
    strikethrough: 'Barrato',
    indent: 'aumenta rientro',
    outdent: 'riduci rientro',
    fullsize: 'espandi',
    shrink: 'comprimi',
    hr: 'linea orizzontale',
    ul: 'lista non ordinata',
    ol: 'lista ordinata',
    cut: 'Taglia',
    selectall: 'Seleziona tutto',
    'Open link': 'Apri link',
    'Edit link': 'Modifica link',
    'No follow': 'Non seguire',
    Unlink: 'Rimuovi link',
    Eye: 'Recensione',
    pencil: 'Per modificare',
    ' URL': ' URL',
    Reset: 'Reset',
    Save: 'Salva',
    'Save as ...': 'Salva con nome...',
    Resize: 'Ridimensiona',
    Crop: 'Ritaglia',
    Width: 'Larghezza',
    Height: 'Altezza',
    'Keep Aspect Ratio': 'Mantieni le proporzioni',
    Yes: 'Si',
    No: 'No',
    Remove: 'Rimuovi',
    Select: 'Seleziona',
    'You can only edit your own images. Download this image on the host?': 'Puoi modificare solo le tue immagini. Vuoi scaricare questa immagine dal server?',
    'The image has been successfully uploaded to the host!': "L'immagine è stata caricata correttamente sul server!",
    palette: 'tavolozza',
    'There are no files': 'Non ci sono file in questa directory.',
    Rename: 'Rinomina',
    'Enter new name': 'Inserisci un nuovo nome',
    preview: 'anteprima',
    download: 'Scarica',
    'Paste from clipboard': 'Incolla dagli appunti',
    "Your browser doesn't support direct access to the clipboard.": "Il tuo browser non supporta l'accesso diretto agli appunti.",
    'Copy selection': 'Copia selezione',
    copy: 'copia',
    'Border radius': 'Border radius',
    'Show all': 'Mostra tutti',
    Apply: 'Applica',
    'Please fill out this field': 'Si prega di compilare questo campo',
    'Please enter a web address': 'Si prega di inserire un indirizzo web',
    Default: 'Default',
    Circle: 'Cerchio',
    Dot: 'Punto',
    Quadrate: 'Quadrato',
    'Lower Alpha': 'Lettera Minuscola',
    'Lower Greek': 'Lettera Greca Minuscola',
    'Lower Roman': 'Numero Romano Minuscolo',
    'Upper Alpha': 'Lettera Maiuscola',
    'Upper Roman': 'Numero Romano Maiuscolo',
    Find: 'Trova',
    'Find Previous': 'Trova Precedente',
    'Find Next': 'Trova Successivo',
    'Insert className': 'Inserisci il nome della classe',
    'Press Alt for custom resizing': 'Premere Alt per il ridimensionamento personalizzato'
});


/***/ }),

/***/ 62395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    newline: 'nuova riga',
    delete: 'eliminare',
    space: 'spazio',
    'Speech Recognize': 'Discorso Riconoscere',
    Sound: 'Suono',
    'Interim Results': 'Risultati intermedi'
});


/***/ }),

/***/ 62405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   U: function() { return /* binding */ UIGroup; }
/* harmony export */ });
/* harmony import */ var _component_component_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4012);
/* harmony import */ var _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2748);
/* harmony import */ var _helpers_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21537);
/* harmony import */ var _helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38837);
/* harmony import */ var _element_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48538);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var UIGroup_1;






let UIGroup = UIGroup_1 = class UIGroup extends _element_js__WEBPACK_IMPORTED_MODULE_5__/* .UIElement */ .D {
    className() {
        return 'UIGroup';
    }
    /**
     * All group children
     */ get allChildren() {
        const result = [];
        const stack = [
            ...this.elements
        ];
        while(stack.length){
            const elm = stack.shift();
            if ((0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isArray)(elm)) {
                stack.push(...elm);
            } else if (_component_component_js__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .u.isInstanceOf(elm, UIGroup_1)) {
                stack.push(...elm.elements);
            } else {
                elm && result.push(elm);
            }
        }
        return result;
    }
    /**
     * Update all children
     */ update() {
        this.elements.forEach((elm)=>elm.update());
        this.setMod('size', this.buttonSize);
    }
    /**
     * Append new element into group
     */ append(elm, distElement) {
        if ((0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isArray)(elm)) {
            elm.forEach((item)=>this.append(item, distElement));
            return this;
        }
        this.elements.push(elm);
        if (elm.name) {
            elm.container.classList.add(this.getFullElName(elm.name));
        }
        if (distElement) {
            const distElm = this.getElm(distElement);
            (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_4__/* .assert */ .v)(distElm != null, 'Element does not exist');
            distElm.appendChild(elm.container);
        } else {
            this.appendChildToContainer(elm.container);
        }
        elm.parentElement = this;
        return this;
    }
    /** @override */ afterSetMod(name, value) {
        if (this.syncMod) {
            this.elements.forEach((elm)=>elm.setMod(name, value));
        }
    }
    /**
     * Allow set another container for the box of all children
     */ appendChildToContainer(childContainer) {
        this.container.appendChild(childContainer);
    }
    /**
     * Remove element from group
     */ remove(elm) {
        const index = this.elements.indexOf(elm);
        if (index !== -1) {
            this.elements.splice(index, 1);
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(elm.container);
            elm.parentElement = null;
        }
        return this;
    }
    /**
     * Clear group
     */ clear() {
        this.elements.forEach((elm)=>elm.destruct());
        this.elements.length = 0;
        return this;
    }
    /** @override */ destruct() {
        this.clear();
        return super.destruct();
    }
    /**
     * @param elements - Items of group
     */ constructor(jodit, elements, options){
        super(jodit, options);
        this.options = options;
        /**
         * Synchronize mods to all children
         */ this.syncMod = false;
        this.elements = [];
        this.buttonSize = 'middle';
        elements === null || elements === void 0 ? void 0 : elements.forEach((elm)=>elm && this.append(elm));
        if (options === null || options === void 0 ? void 0 : options.name) {
            this.name = options.name;
        }
    }
};
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)('buttonSize')
], UIGroup.prototype, "update", null);
UIGroup = UIGroup_1 = __decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.component
], UIGroup);



/***/ }),

/***/ 62489:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6441);
/* harmony import */ var _icons_crop_svg_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49922);
/* harmony import */ var _icons_resize_svg_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72144);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.imageeditor = {
    min_width: 20,
    min_height: 20,
    closeAfterSave: false,
    width: '85%',
    height: '85%',
    crop: true,
    resize: true,
    resizeUseRatio: true,
    resizeMinWidth: 20,
    resizeMinHeight: 20,
    cropUseRatio: true,
    cropDefaultWidth: '70%',
    cropDefaultHeight: '70%'
};
_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_0__/* .Icon */ .I.set('crop', _icons_crop_svg_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A).set('resize', _icons_resize_svg_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A);


/***/ }),

/***/ 62700:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'Type something': 'なにかタイプしてください',
    Advanced: '高度な設定',
    'About Jodit': 'Joditについて',
    'Jodit Editor': 'Jodit Editor',
    "Jodit User's Guide": 'Jodit ユーザーズ・ガイド',
    'contains detailed help for using': '詳しい使い方',
    'For information about the license, please go to our website:': 'ライセンス詳細についてはJodit Webサイトを確認ください：',
    'Buy full version': 'フルバージョンを購入',
    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.': 'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.',
    Anchor: 'Anchor',
    'Open in new tab': '新しいタブで開く',
    'Open in fullsize': 'エディターのサイズ（フル/ノーマル）',
    'Clear Formatting': '書式をクリア',
    'Fill color or set the text color': 'テキストの色',
    Redo: 'やり直し',
    Undo: '元に戻す',
    Bold: '太字',
    Italic: '斜体',
    'Insert Unordered List': '箇条書き',
    'Insert Ordered List': '番号付きリスト',
    'Align Center': '中央揃え',
    'Align Justify': '両端揃え',
    'Align Left': '左揃え',
    'Align Right': '右揃え',
    'Insert Horizontal Line': '区切り線を挿入',
    'Insert Image': '画像を挿入',
    'Insert file': 'ファイルを挿入',
    'Insert youtube/vimeo video': 'Youtube/Vimeo 動画',
    'Insert link': 'リンクを挿入',
    'Font size': 'フォントサイズ',
    'Font family': 'フォント',
    'Insert format block': 'テキストのスタイル',
    Normal: '指定なし',
    'Heading 1': 'タイトル1',
    'Heading 2': 'タイトル2',
    'Heading 3': 'タイトル3',
    'Heading 4': 'タイトル4',
    Quote: '引用',
    Code: 'コード',
    Insert: '挿入',
    'Insert table': '表を挿入',
    'Decrease Indent': 'インデント減',
    'Increase Indent': 'インデント増',
    'Select Special Character': '特殊文字を選択',
    'Insert Special Character': '特殊文字を挿入',
    'Paint format': '書式を貼付け',
    'Change mode': '編集モード切替え',
    Margins: 'マージン',
    top: '上',
    right: '右',
    bottom: '下',
    left: '左',
    Styles: 'スタイル',
    Classes: 'クラス',
    Align: '配置',
    Right: '右寄せ',
    Center: '中央寄せ',
    Left: '左寄せ',
    '--Not Set--': '指定なし',
    Src: 'ソース',
    Title: 'タイトル',
    Alternative: '代替テキスト',
    Link: 'リンク',
    'Open link in new tab': '新しいタブで開く',
    Image: '画像',
    file: 'ファイル',
    'Image properties': '画像のプロパティー',
    Cancel: 'キャンセル',
    Ok: '確定',
    'Your code is similar to HTML. Keep as HTML?': 'HTMLコードを保持しますか？',
    'Paste as HTML': 'HTMLで貼付け',
    Keep: 'HTMLを保持',
    Clean: 'Clean',
    'Insert as Text': 'HTMLをテキストにする',
    'Word Paste Detected': 'Word Paste Detected',
    'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?': 'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?',
    'Insert only Text': 'テキストだけ',
    'File Browser': 'File Browser',
    'Error on load list': 'Error on load list',
    'Error on load folders': 'Error on load folders',
    'Are you sure?': 'Are you sure?',
    'Enter Directory name': 'Enter Directory name',
    'Create directory': 'Create directory',
    'type name': 'type name',
    'Drop image': 'ここに画像をドロップ',
    'Drop file': 'ここにファイルをドロップ',
    'or click': 'or クリック',
    'Alternative text': '代替テキスト',
    Browse: 'ブラウズ',
    Upload: 'アップロード',
    Background: '背景',
    Text: '文字',
    Top: '上',
    Middle: '中央',
    Bottom: '下',
    'Insert column before': '左に列を挿入',
    'Insert column after': '右に列を挿入',
    'Insert row above': '上に行を挿入',
    'Insert row below': '下に行を挿入',
    'Delete table': '表を削除',
    'Delete row': '行を削除',
    'Delete column': '列を削除',
    'Empty cell': 'セルを空にする',
    'Chars: %d': '文字数: %d',
    'Words: %d': '単語数: %d',
    'Strike through': '取り消し線',
    Underline: '下線',
    superscript: '上付き文字',
    subscript: '下付き文字',
    'Cut selection': '切り取り',
    'Select all': 'すべて選択',
    Break: 'Pause',
    'Search for': '検索',
    'Replace with': '置換',
    Replace: '交換',
    Paste: '貼付け',
    'Choose Content to Paste': '選択した内容を貼付け',
    All: '全部',
    source: 'source',
    bold: 'bold',
    italic: 'italic',
    brush: 'brush',
    link: 'link',
    undo: 'undo',
    redo: 'redo',
    table: 'table',
    image: 'image',
    eraser: 'eraser',
    paragraph: 'paragraph',
    fontsize: 'fontsize',
    video: 'video',
    font: 'font',
    about: 'about',
    print: 'print',
    underline: 'underline',
    strikethrough: 'strikethrough',
    indent: 'indent',
    outdent: 'outdent',
    fullsize: 'fullsize',
    shrink: 'shrink',
    hr: '分割線',
    ul: '箇条書き',
    ol: '番号付きリスト',
    cut: '切り取り',
    selectall: 'すべて選択',
    'Open link': 'リンクを開く',
    'Edit link': 'リンクを編集',
    'No follow': 'No follow',
    Unlink: 'リンク解除',
    Eye: 'サイトを確認',
    ' URL': 'URL',
    Reset: 'リセット',
    Save: '保存',
    'Save as ...': 'Save as ...',
    Resize: 'リサイズ',
    Crop: 'Crop',
    Width: '幅',
    Height: '高さ',
    'Keep Aspect Ratio': '縦横比を保持',
    Yes: 'はい',
    No: 'いいえ',
    Remove: '移除',
    Select: '選択',
    'Select %s': '選択: %s',
    Update: '更新',
    'Vertical align': '垂直方向の配置',
    Merge: 'セルの結合',
    'Add column': '列を追加',
    'Add row': '行を追加',
    Border: '境界線',
    'Embed code': '埋め込みコード',
    Delete: '削除',
    Edit: '編集',
    'Horizontal align': '水平方向の配置',
    Filter: 'Filter',
    'Sort by changed': 'Sort by changed',
    'Sort by name': 'Sort by name',
    'Sort by size': 'Sort by size',
    'Add folder': 'Add folder',
    Split: '分割',
    'Split vertical': 'セルの分割（垂直方向）',
    'Split horizontal': 'セルの分割（水平方向）',
    'You can only edit your own images. Download this image on the host?': 'You can only edit your own images. Download this image on the host?',
    'The image has been successfully uploaded to the host!': 'The image has been successfully uploaded to the host!',
    palette: 'パレット',
    pencil: '鉛筆',
    'There are no files': 'There are no files',
    Rename: 'Rename',
    'Enter new name': 'Enter new name',
    preview: 'プレビュー',
    download: 'ダウンロード',
    'Paste from clipboard': '貼り付け',
    "Your browser doesn't support direct access to the clipboard.": 'お使いのブラウザはクリップボードを使用できません',
    'Copy selection': 'コピー',
    copy: 'copy',
    'Border radius': '角の丸み',
    'Show all': '全て表示',
    Apply: '適用',
    'Please fill out this field': 'まだこの分野',
    'Please enter a web address': 'を入力してくださいウェブアドレス',
    Default: 'デフォルト',
    Circle: '白丸',
    Dot: '黒丸',
    Quadrate: '四角',
    Find: '見',
    'Find Previous': '探前',
    'Find Next': '由来',
    'Lower Alpha': '英小文字',
    'Lower Greek': 'ギリシャ文字',
    'Lower Roman': 'ローマ数字小文字',
    'Upper Alpha': '英大文字',
    'Upper Roman': 'ローマ数字大文字',
    'Insert className': 'クラス名を挿入',
    'Press Alt for custom resizing': 'カスタムサイズ変更のためのAltキーを押します'
});


/***/ }),

/***/ 62770:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'Type something': 'Bitte geben Sie einen Text ein',
    Advanced: 'Fortgeschritten',
    'About Jodit': 'Über Jodit',
    'Jodit Editor': 'Jodit Editor',
    "Jodit User's Guide": 'Das Jodit Benutzerhandbuch',
    'contains detailed help for using': 'beinhaltet ausführliche Informationen wie Sie den Editor verwenden können.',
    'For information about the license, please go to our website:': 'Für Informationen zur Lizenz, besuchen Sie bitte unsere Web-Präsenz:',
    'Buy full version': 'Vollversion kaufen',
    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.': 'Copyright © XDSoft.net - Chupurnov Valeriy. Alle Rechte vorbehalten.',
    Anchor: 'Anker',
    'Open in new tab': 'In neuer Registerkarte öffnen',
    'Open in fullsize': 'Editor in voller Größe öffnen',
    'Clear Formatting': 'Formatierung löschen',
    'Fill color or set the text color': 'Füllfarbe oder Textfarbe ändern',
    Redo: 'Wiederholen',
    Undo: 'Rückgängig machen',
    Bold: 'Fett',
    Italic: 'Kursiv',
    'Insert Unordered List': 'Unsortierte Liste einfügen',
    'Insert Ordered List': 'Nummerierte Liste einfügen',
    'Align Center': 'Mittig ausrichten',
    'Align Justify': 'Blocksatz',
    'Align Left': 'Links ausrichten',
    'Align Right': 'Rechts ausrichten',
    'Insert Horizontal Line': 'Horizontale Linie einfügen',
    'Insert Image': 'Bild einfügen',
    'Insert file': 'Datei einfügen',
    'Insert youtube/vimeo video': 'Youtube/vimeo Video einfügen',
    'Insert link': 'Link einfügen',
    'Font size': 'Schriftgröße',
    'Font family': 'Schriftfamilie',
    'Insert format block': 'Formatblock einfügen',
    Normal: 'Normal',
    'Heading 1': 'Überschrift 1',
    'Heading 2': 'Überschrift 2',
    'Heading 3': 'Überschrift 3',
    'Heading 4': 'Überschrift 4',
    Quote: 'Zitat',
    Code: 'Code',
    Insert: 'Einfügen',
    'Insert table': 'Tabelle einfügen',
    'Decrease Indent': 'Einzug verkleinern',
    'Increase Indent': 'Einzug vergrößern',
    'Select Special Character': 'Sonderzeichen auswählen',
    'Insert Special Character': 'Sonderzeichen einfügen',
    'Paint format': 'Format kopieren',
    'Change mode': 'Änderungsmodus',
    Margins: 'Ränder',
    top: 'Oben',
    right: 'Rechts',
    bottom: 'Unten',
    left: 'Links',
    Styles: 'CSS Stil',
    Classes: 'CSS Klassen',
    Align: 'Ausrichtung',
    Right: 'Rechts',
    Center: 'Zentriert',
    Left: 'Links',
    '--Not Set--': 'Keine',
    Src: 'Pfad',
    Title: 'Titel',
    Alternative: 'Alternativer Text',
    Link: 'Link',
    'Open link in new tab': 'Link in neuem Tab öffnen',
    Image: 'Bild',
    file: 'Datei',
    'Image properties': 'Bildeigenschaften',
    Cancel: 'Abbrechen',
    Ok: 'OK',
    'Your code is similar to HTML. Keep as HTML?': 'Ihr Text ähnelt HTML-Code. Als HTML beibehalten?',
    'Paste as HTML': 'Als HTML einfügen?',
    Keep: 'Original speichern',
    Clean: 'Säubern',
    'Insert as Text': 'Als Text einfügen',
    'Word Paste Detected': 'In Word formatierter Text erkannt',
    'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?': 'Der Inhalt, den Sie einfügen, stammt aus einem Microsoft Word / Excel-Dokument. Möchten Sie das Format erhalten oder bereinigen?',
    'Insert only Text': 'Nur Text einfügen',
    'File Browser': 'Dateibrowser',
    'Error on load list': 'Fehler beim Laden der Liste',
    'Error on load folders': 'Fehler beim Laden der Ordner',
    'Are you sure?': 'Sind Sie sicher?',
    'Enter Directory name': 'Geben Sie den Verzeichnisnamen ein',
    'Create directory': 'Verzeichnis erstellen',
    'type name': 'Typname',
    'Drop image': 'Bild hier hinziehen',
    'Drop file': 'Datei löschen',
    'or click': 'oder hier klicken',
    'Alternative text': 'Alternativtext',
    Browse: 'Auswählen',
    Upload: 'Hochladen',
    Background: 'Hintergrund',
    Text: 'Text',
    Top: 'Oben',
    Middle: 'Mittig',
    Bottom: 'Unten',
    'Insert column before': 'Spalte davor einfügen',
    'Insert column after': 'Spalte danach einfügen',
    'Insert row above': 'Zeile oberhalb einfügen',
    'Insert row below': 'Zeile unterhalb einfügen',
    'Delete table': 'Tabelle löschen',
    'Delete row': 'Zeile löschen',
    'Delete column': 'Spalte löschen',
    'Empty cell': 'Zelle leeren',
    Delete: 'Löschen',
    'Strike through': 'Durchstreichen',
    Underline: 'Unterstreichen',
    Break: 'Pause',
    'Search for': 'Suche nach',
    'Replace with': 'Ersetzen durch',
    Replace: 'Ersetzen',
    Edit: 'Bearbeiten',
    'Vertical align': 'Vertikale Ausrichtung',
    'Horizontal align': 'Horizontale Ausrichtung',
    Filter: 'Filter',
    'Sort by changed': 'Sortieren nach geändert',
    'Sort by name': 'Nach Name sortieren',
    'Sort by size': 'Nach Größe sortiert',
    'Add folder': 'Ordner hinzufügen',
    'Split vertical': 'Vertikal unterteilen',
    'Split horizontal': 'Horizontal unterteilen',
    Split: 'Unterteilen',
    Merge: 'Vereinen',
    'Add column': 'Spalte hinzufügen',
    'Add row': 'Zeile hinzufügen',
    Border: 'Rand',
    'Embed code': 'Code einbetten',
    Update: 'Aktualisieren',
    superscript: 'Hochstellen',
    subscript: 'Tiefstellen',
    'Cut selection': 'Auswahl ausschneiden',
    Paste: 'Einfügen',
    'Choose Content to Paste': 'Wählen Sie den Inhalt zum Einfügen aus',
    'Chars: %d': 'Zeichen: %d',
    'Words: %d': 'Wörter: %d',
    All: 'Alles markieren',
    'Select %s': 'Markieren: %s',
    'Select all': 'Alles markieren',
    source: 'HTML',
    bold: 'Fett gedruckt',
    italic: 'Kursiv',
    brush: 'Bürste',
    link: 'Verknüpfung',
    undo: 'Rückgängig machen',
    redo: 'Wiederholen',
    table: 'Tabelle',
    image: 'Bild',
    eraser: 'Radiergummi',
    paragraph: 'Absatz',
    fontsize: 'Schriftgröße',
    video: 'Video',
    font: 'Schriftart',
    about: 'Über',
    print: 'Drucken',
    underline: 'Unterstreichen',
    strikethrough: 'Durchstreichen',
    indent: 'Einzug',
    outdent: 'Herausstellen',
    fullsize: 'Vollgröße',
    shrink: 'Schrumpfen',
    hr: 'die Linie',
    ul: 'Liste von',
    ol: 'Nummerierte Liste',
    'Lower Alpha': 'Standard, Alphabet (klein)',
    'Upper Alpha': 'Standard, Alphabet (gross)',
    'Lower Roman': 'Römisch (klein)',
    'Upper Roman': 'Römisch (gross)',
    'Lower Greek': 'Griechisch',
    cut: 'Schneiden',
    selectall: 'Wählen Sie Alle aus',
    'Open link': 'Link öffnen',
    'Edit link': 'Link bearbeiten',
    'No follow': 'Nofollow-Attribut',
    Unlink: 'Link entfernen',
    Eye: 'Ansehen',
    pencil: 'Bearbeiten',
    ' URL': 'URL',
    Reset: 'Wiederherstellen',
    Save: 'Speichern',
    'Save as ...': 'Speichern als',
    Resize: 'Größe ändern',
    Crop: 'Größe anpassen',
    Width: 'Breite',
    Height: 'Höhe',
    'Keep Aspect Ratio': 'Seitenverhältnis beibehalten',
    Yes: 'Ja',
    No: 'Nein',
    Remove: 'Entfernen',
    Select: 'Markieren',
    'You can only edit your own images. Download this image on the host?': 'Sie können nur Ihre eigenen Bilder bearbeiten. Dieses Bild auf den Host herunterladen?',
    'The image has been successfully uploaded to the host!': 'Das Bild wurde erfolgreich auf den Server hochgeladen!',
    palette: 'Palette',
    'There are no files': 'In diesem Verzeichnis befinden sich keine Dateien.',
    Rename: 'Umbenennen',
    'Enter new name': 'Geben Sie einen neuen Namen ein',
    preview: 'Vorschau',
    download: 'Herunterladen',
    'Paste from clipboard': 'Aus Zwischenablage einfügen',
    "Your browser doesn't support direct access to the clipboard.": 'Ihr Browser unterstützt keinen direkten Zugriff auf die Zwischenablage.',
    'Copy selection': 'Auswahl kopieren',
    copy: 'Kopieren',
    'Border radius': 'Radius für abgerundete Ecken',
    'Show all': 'Alle anzeigen',
    Apply: 'Anwenden',
    'Please fill out this field': 'Bitte füllen Sie dieses Feld aus',
    'Please enter a web address': 'Bitte geben Sie eine Web-Adresse ein',
    Default: 'Standard',
    Circle: 'Kreis',
    Dot: 'Punkte',
    Quadrate: 'Quadrate',
    Find: 'Suchen',
    'Find Previous': 'Suche vorherige',
    'Find Next': 'Weitersuchen',
    'Insert className': 'className (CSS) einfügen',
    'Press Alt for custom resizing': 'Drücken Sie Alt für benutzerdefinierte Größenanpassung'
});


/***/ }),

/***/ 62843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $n: function() { return /* reexport safe */ _button_button_js__WEBPACK_IMPORTED_MODULE_0__.$n; },
/* harmony export */   SB: function() { return /* reexport safe */ _tooltip_tooltip_js__WEBPACK_IMPORTED_MODULE_2__.S; },
/* harmony export */   lD: function() { return /* reexport safe */ _button_button_js__WEBPACK_IMPORTED_MODULE_0__.lD; },
/* harmony export */   ss: function() { return /* reexport safe */ _group_group_js__WEBPACK_IMPORTED_MODULE_1__.s; },
/* harmony export */   ue: function() { return /* reexport safe */ _button_button_js__WEBPACK_IMPORTED_MODULE_0__.ue; }
/* harmony export */ });
/* harmony import */ var _button_button_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10830);
/* harmony import */ var _group_group_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71916);
/* harmony import */ var _tooltip_tooltip_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57340);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * [[include:core/ui/button/README.md]]
 * @packageDocumentation
 * @module ui/button
 */ 




/***/ }),

/***/ 62845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   E: function() { return /* binding */ checkJoinNeighbors; }
/* harmony export */ });
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63785);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/**
 * Check if two separate elements can be connected
 * @private
 */ function checkJoinNeighbors(jodit, fakeNode, backspace) {
    let nextBox = fakeNode, mainClosestBox = nextBox;
    // Find the main big closest element
    while(nextBox && !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.findNotEmptySibling(nextBox, backspace) && nextBox.parentElement !== jodit.editor){
        nextBox = nextBox.parentElement;
        mainClosestBox = nextBox;
    }
    if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isElement(mainClosestBox) && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isContentEditable(mainClosestBox, jodit.editor)) {
        const sibling = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.findNotEmptySibling(mainClosestBox, backspace);
        if (sibling && (checkMoveListContent(jodit, mainClosestBox, sibling, backspace) || moveContentAndRemoveEmpty(jodit, mainClosestBox, sibling, backspace))) {
            jodit.s.setCursorBefore(fakeNode);
            return true;
        }
    }
    return false;
}
function checkMoveListContent(jodit, mainClosestBox, sibling, backspace) {
    // Process UL/LI/OL cases
    const siblingIsList = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(sibling, _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.LIST_TAGS);
    const boxIsList = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(mainClosestBox, _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.LIST_TAGS);
    const elementChild = (elm, side)=>side ? elm.firstElementChild : elm.lastElementChild;
    if (boxIsList) {
        sibling = jodit.createInside.element(jodit.o.enterBlock);
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.before(mainClosestBox, sibling);
        return moveContentAndRemoveEmpty(jodit, elementChild(mainClosestBox, backspace), sibling, backspace);
    }
    if (sibling && siblingIsList && !boxIsList) {
        return moveContentAndRemoveEmpty(jodit, mainClosestBox, elementChild(sibling, !backspace), backspace);
    }
    return false;
}
function moveContentAndRemoveEmpty(jodit, mainClosestBox, sibling, backspace) {
    // Move content and remove empty nodes
    if (mainClosestBox && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isElement(sibling)) {
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.moveContent(mainClosestBox, sibling, !backspace, (0,_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .getMoveFilter */ .g)(jodit));
        let remove = mainClosestBox;
        while(remove && remove !== jodit.editor && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isEmpty(remove)){
            const parent = remove.parentElement;
            _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(remove);
            remove = parent;
        }
        return true;
    }
    return false;
}


/***/ }),

/***/ 63134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    newline: 'nueva línea',
    delete: 'eliminar',
    space: 'espacio',
    'Speech Recognize': 'Reconocimiento de Voz',
    Sound: 'Sonido',
    'Interim Results': 'Resultados Provisionales'
});


/***/ }),

/***/ 63195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    Spellcheck: '拼写检查'
});


/***/ }),

/***/ 63399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   S: function() { return /* binding */ makeDataProvider; },
/* harmony export */   V: function() { return /* binding */ makeContextMenu; }
/* harmony export */ });
/* harmony import */ var _context_menu_context_menu_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80870);
/* harmony import */ var _data_provider_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11787);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

function makeDataProvider(parent, options) {
    return new _data_provider_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A(parent, options);
}
function makeContextMenu(parent) {
    return new _context_menu_context_menu_js__WEBPACK_IMPORTED_MODULE_0__/* .ContextMenu */ .t(parent);
}


/***/ }),

/***/ 63687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $s: function() { return /* reexport safe */ _is_suit_element_js__WEBPACK_IMPORTED_MODULE_8__.$s; },
/* harmony export */   AS: function() { return /* reexport safe */ _get_suit_parent_js__WEBPACK_IMPORTED_MODULE_3__.A; },
/* harmony export */   Dd: function() { return /* reexport safe */ _is_same_attributes_js__WEBPACK_IMPORTED_MODULE_7__.D; },
/* harmony export */   EF: function() { return /* reexport safe */ _finite_state_machine_js__WEBPACK_IMPORTED_MODULE_1__.E; },
/* harmony export */   G6: function() { return /* reexport safe */ _get_suit_child_js__WEBPACK_IMPORTED_MODULE_2__.G; },
/* harmony export */   LV: function() { return /* reexport safe */ _wrap_js__WEBPACK_IMPORTED_MODULE_13__.L; },
/* harmony export */   M6: function() { return /* reexport safe */ _is_same_attributes_js__WEBPACK_IMPORTED_MODULE_7__.M; },
/* harmony export */   Yx: function() { return /* reexport safe */ _toggle_attributes_js__WEBPACK_IMPORTED_MODULE_11__.Y; },
/* harmony export */   iu: function() { return /* reexport safe */ _is_inside_invisible_element_js__WEBPACK_IMPORTED_MODULE_5__.i; },
/* harmony export */   ks: function() { return /* reexport safe */ _list_toggle_ordered_list_js__WEBPACK_IMPORTED_MODULE_9__.k; },
/* harmony export */   tm: function() { return /* reexport safe */ _unwrap_children_js__WEBPACK_IMPORTED_MODULE_12__.t; },
/* harmony export */   yP: function() { return /* reexport safe */ _extract_js__WEBPACK_IMPORTED_MODULE_0__.y; }
/* harmony export */ });
/* harmony import */ var _extract_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32526);
/* harmony import */ var _finite_state_machine_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49996);
/* harmony import */ var _get_suit_child_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23738);
/* harmony import */ var _get_suit_parent_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44602);
/* harmony import */ var _has_same_style_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22030);
/* harmony import */ var _is_inside_invisible_element_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64291);
/* harmony import */ var _is_normal_node_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29136);
/* harmony import */ var _is_same_attributes_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94466);
/* harmony import */ var _is_suit_element_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97380);
/* harmony import */ var _list_toggle_ordered_list_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(20199);
/* harmony import */ var _list_wrap_list_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(82515);
/* harmony import */ var _toggle_attributes_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(44253);
/* harmony import */ var _unwrap_children_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(75882);
/* harmony import */ var _wrap_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(19263);
/* harmony import */ var _wrap_unwrapped_text_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(6980);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
















/***/ }),

/***/ 63785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   g: function() { return /* binding */ getMoveFilter; },
/* harmony export */   s: function() { return /* binding */ findMostNestedNeighbor; }
/* harmony export */ });
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22732);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/**
 * Finds the nearest neighbor that would be in the maximum nesting depth.
 * Ie if neighbor `<DIV><SPAN>Text` then return Text node.
 * @private
 */ function findMostNestedNeighbor(node, right, root, onlyInlide = false) {
    const nextChild = (node)=>right ? node.firstChild : node.lastChild;
    let next = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.findNotEmptyNeighbor(node, !right, root);
    if (onlyInlide && _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isElement(next) && !_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isInlineBlock(next)) {
        return null;
    }
    if (next) {
        do {
            if (nextChild(next)) {
                next = nextChild(next);
            } else {
                return next;
            }
        }while (next)
    }
    return null;
}
/**
 * @private
 */ function getMoveFilter(jodit) {
    return (node)=>jodit.e.fire('backSpaceIsMovedIgnore', node) !== true;
}


/***/ }),

/***/ 63799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EW: function() { return /* binding */ alreadyLoadedList; },
/* harmony export */   Qt: function() { return /* binding */ loadNext; },
/* harmony export */   S5: function() { return /* binding */ appendStyleAsync; },
/* harmony export */   w4: function() { return /* binding */ appendScriptAsync; },
/* harmony export */   x_: function() { return /* binding */ loadNextStyle; }
/* harmony export */ });
/* harmony import */ var _checker_is_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70799);
/* harmony import */ var _complete_url_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66292);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

const alreadyLoadedList = new Map();
const cacheLoaders = (loader)=>{
    return (jodit, url)=>{
        if (alreadyLoadedList.has(url)) {
            return alreadyLoadedList.get(url);
        }
        const promise = loader(jodit, url);
        alreadyLoadedList.set(url, promise);
        return promise;
    };
};
/**
 * Load script and return promise
 */ const appendScriptAsync = cacheLoaders((jodit, url)=>{
    return jodit.async.promise((resolve, reject)=>{
        if (jodit.isInDestruct) {
            return reject();
        }
        const script = jodit.c.element('script', {
            type: 'text/javascript',
            crossorigin: 'anonymous',
            referrerpolicy: 'no-referrer',
            async: true,
            src: (0,_complete_url_js__WEBPACK_IMPORTED_MODULE_0__/* .completeUrl */ .X)(url)
        });
        jodit.e.one(script, 'error', reject).one(script, 'load', resolve);
        jodit.od.body.appendChild(script);
    });
});
/**
 * Download CSS style script
 */ const appendStyleAsync = cacheLoaders((jodit, url)=>{
    return jodit.async.promise((resolve, reject)=>{
        if (jodit.isInDestruct) {
            return reject();
        }
        const link = jodit.c.element('link');
        link.rel = 'stylesheet';
        link.media = 'all';
        link.crossOrigin = 'anonymous';
        const callback = ()=>resolve(link);
        !jodit.isInDestruct && jodit.e.on(link, 'load', callback).on(link, 'error', reject);
        link.href = (0,_complete_url_js__WEBPACK_IMPORTED_MODULE_0__/* .completeUrl */ .X)(url);
        if (jodit.o.shadowRoot) {
            jodit.o.shadowRoot.appendChild(link);
        } else {
            jodit.od.body.appendChild(link);
        }
    });
});
function loadNext(jodit, urls, i = 0) {
    if (!(0,_checker_is_string_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .K)(urls[i])) {
        return Promise.resolve();
    }
    return appendScriptAsync(jodit, urls[i]).then(()=>loadNext(jodit, urls, i + 1));
}
function loadNextStyle(jodit, urls, i = 0) {
    if (!(0,_checker_is_string_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .K)(urls[i])) {
        return Promise.resolve();
    }
    return appendStyleAsync(jodit, urls[i]).then(()=>loadNextStyle(jodit, urls, i + 1));
}


/***/ }),

/***/ 63819:
/***/ (function(__unused_webpack_module, __webpack_exports__) {


/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'copy-format': 'نسخ التنسيق'
});


/***/ }),

/***/ 64291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   i: function() { return /* binding */ isInsideInvisibleElement; }
/* harmony export */ });
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/**
 * Check if FONT inside STYLE or SCRIPT element
 * @private
 */ function isInsideInvisibleElement(font, root) {
    return Boolean(_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(font, [
        'style',
        'script'
    ], root));
}


/***/ }),

/***/ 64310:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var jodit_esm_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */

jodit_esm_config__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.pasteFromWord = {
    enable: false,
    convertUnitsToPixel: false,
    allowedStyleProps: [
        'background',
        'background-color',
        'border',
        'border-.*',
        'color',
        'float',
        'font-family',
        'font-size',
        'font-style',
        'font-weight',
        'height',
        'line-height',
        'list-style-type',
        'margin',
        'margin-bottom',
        'margin-left',
        'margin-right',
        'margin-top',
        'padding',
        'text-align',
        'text-justify',
        'text-decoration',
        'text-indent',
        'vertical-align',
        'width'
    ]
};


/***/ }),

/***/ 64488:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 270 270\"> <path d=\"M 255.9537,58.150081 237.69527,40.997278 c -1.49414,-1.375593 -3.43653,-2.077427 -5.37891,-2.077427 -1.94239,0 -3.88478,0.701834 -5.37892,2.077427 L 29.919751,226.1128 c -2.988286,2.77926 -2.988286,7.32714 0,10.13447 L 48.148295,253.372 c 1.46426,1.37559 3.406646,2.1055 5.378915,2.1055 1.972268,0 3.884771,-0.72991 5.378914,-2.1055 L 221.34935,100.73732 255.9537,68.284552 c 2.9584,-2.807333 2.9584,-7.355212 0,-10.134471 z M 251.17244,63.79282 221.34935,91.781927 201.89561,73.506191 231.68882,45.48901 c 0.20918,-0.140367 0.38847,-0.224587 0.62754,-0.224587 0.23906,0 0.44824,0.08422 0.59765,0.224587 l 18.25843,17.152803 c 0,0 0.23906,0.33688 0.23906,0.561467 0,0.224586 -0.0896,0.4211 -0.23906,0.58954 z\" style=\"stroke-width:2.8964;stroke-opacity:1\" /> <path d=\"m 48.626421,116.87948 10.578532,23.10435 c 0.83672,1.82477 3.615826,1.85284 4.452546,0 l 10.937126,-23.52545 c 2.629692,-5.69888 7.470715,-10.24676 13.536935,-12.71722 l 25.07172,-10.274833 c 1.94239,-0.786053 1.94239,-3.396873 0,-4.182926 L 88.13156,79.008563 C 82.06534,76.53811 77.224317,71.990231 74.594625,66.291346 L 63.657499,42.737824 c -0.83672,-1.824766 -3.615826,-1.824766 -4.452546,0 L 48.267826,66.291346 C 45.638135,71.990231 40.797112,76.53811 34.730891,79.008563 L 9.6292894,89.311474 c -1.9423859,0.786054 -1.9423859,3.3688 0,4.182926 l 25.5498446,10.61172 c 6.036338,2.49852 10.847478,7.07448 13.477169,12.77336 z\" style=\"stroke-width:2.8964;fill-opacity:1;stroke-opacity:1\" /> <path d=\"m 111.79878,33.136746 13.56682,5.642739 c 3.19747,1.319446 5.76739,3.761826 7.14201,6.793745 l 5.61797,12.268044 c 0.44825,0.982567 1.91251,0.982567 2.36075,0 l 5.79727,-12.492631 c 1.4045,-3.031919 3.97442,-5.446225 7.20177,-6.765672 l 13.29788,-5.446225 c 1.0459,-0.4211 1.0459,-1.796693 0,-2.217793 l -13.29788,-5.446225 c -3.22735,-1.319447 -5.79727,-3.733753 -7.20177,-6.765672 L 140.48633,6.2144248 c -0.44824,-0.9825664 -1.9125,-0.9825664 -2.36075,0 l -5.79727,12.4926312 c -1.4045,3.031919 -3.97442,5.446225 -7.20177,6.765672 l -13.32776,5.474298 c -1.01601,0.4211 -1.0459,1.796693 0,2.217793 z\" style=\"stroke-width:2.8964;fill-opacity:1\" /> <path d=\"m 233.09331,192.98627 -14.13459,-5.7831 c -3.40665,-1.40367 -6.12599,-3.95834 -7.62013,-7.1587 l -6.15587,-13.27868 c -0.47813,-1.03872 -2.03203,-1.03872 -2.51016,0 l -6.15587,13.27868 c -1.49414,3.20036 -4.21348,5.75503 -7.62013,7.1587 l -14.13459,5.81118 c -1.10567,0.44917 -1.10567,1.90898 0,2.35816 l 14.40354,5.97961 c 3.40664,1.40367 6.12598,3.98642 7.59024,7.21485 l 5.97658,13.02602 c 0.47812,1.03872 2.03203,1.03872 2.51016,0 l 6.15586,-13.25061 c 1.49415,-3.20036 4.21349,-5.75503 7.62013,-7.1587 l 14.1346,-5.7831 c 1.10566,-0.44917 1.10566,-1.90899 0,-2.35816 z\" style=\"stroke-width:2.8964;stroke-opacity:1\" /> </svg> ");


/***/ }),

/***/ 64489:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1664 896q0 156-61 298t-164 245-245 164-298 61q-172 0-327-72.5t-264-204.5q-7-10-6.5-22.5t8.5-20.5l137-138q10-9 25-9 16 2 23 12 73 95 179 147t225 52q104 0 198.5-40.5t163.5-109.5 109.5-163.5 40.5-198.5-40.5-198.5-109.5-163.5-163.5-109.5-198.5-40.5q-98 0-188 35.5t-160 101.5l137 138q31 30 14 69-17 40-59 40h-448q-26 0-45-19t-19-45v-448q0-42 40-59 39-17 69 14l130 129q107-101 244.5-156.5t284.5-55.5q156 0 298 61t245 164 164 245 61 298z\"/> </svg> ");


/***/ }),

/***/ 64837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export orderedList */
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65478);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(580);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50911);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57951);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




/**
 * Process commands insertOrderedList and insertUnOrderedList
 */ class orderedList extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Plugin */ .k {
    afterInit(jodit) {
        jodit.registerCommand('insertUnorderedList', this.onCommand).registerCommand('insertOrderedList', this.onCommand);
    }
    onCommand(command, _, type) {
        this.jodit.s.commitStyle({
            element: command === 'insertunorderedlist' ? 'ul' : 'ol',
            attributes: {
                style: {
                    listStyleType: type !== null && type !== void 0 ? type : null
                }
            }
        });
        this.jodit.synchronizeValues();
        return false;
    }
    beforeDestruct(jodit) {}
    constructor(){
        super(...arguments);
        this.buttons = [
            {
                name: 'ul',
                group: 'list'
            },
            {
                name: 'ol',
                group: 'list'
            }
        ];
    }
}
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], orderedList.prototype, "onCommand", null);
_core_global_js__WEBPACK_IMPORTED_MODULE_1__/* .pluginSystem */ .fg.add('orderedList', orderedList);


/***/ }),

/***/ 65140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    Spellcheck: 'Проверка орфографии'
});


/***/ }),

/***/ 65181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   c: function() { return /* binding */ processEmptyLILeaf; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _core_helpers_utils_selector_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76078);
/* harmony import */ var _insert_paragraph_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44245);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/**
 * Handles pressing the Enter key inside an empty LI inside a list
 * @private
 */ function processEmptyLILeaf(fake, jodit, li) {
    const list = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(li, [
        'ol',
        'ul'
    ], jodit.editor);
    if (!list) {
        return;
    }
    const parentLi = list.parentElement, listInsideLeaf = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isLeaf(parentLi);
    const container = listInsideLeaf ? parentLi : list;
    // Empty element in the middle of the list
    const leftRange = jodit.s.createRange();
    leftRange.setStartAfter(li);
    leftRange.setEndAfter(list);
    const rightPart = leftRange.extractContents();
    _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.after(container, fake);
    _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(li);
    if (!(0,_core_helpers_utils_selector_js__WEBPACK_IMPORTED_MODULE_1__.$$)('li', list).length) {
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(list);
    }
    const newLi = (0,_insert_paragraph_js__WEBPACK_IMPORTED_MODULE_2__/* .insertParagraph */ .y)(fake, jodit, listInsideLeaf ? 'li' : jodit.o.enter);
    if (!rightPart.querySelector('li')) {
        return;
    }
    if (listInsideLeaf) {
        newLi.appendChild(rightPart);
    } else {
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.after(newLi, rightPart);
    }
}


/***/ }),

/***/ 65478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   autobind: function() { return /* reexport safe */ _autobind_autobind_js__WEBPACK_IMPORTED_MODULE_0__.d; },
/* harmony export */   cache: function() { return /* reexport safe */ _cache_cache_js__WEBPACK_IMPORTED_MODULE_1__.PP; },
/* harmony export */   cacheHTML: function() { return /* reexport safe */ _cache_cache_js__WEBPACK_IMPORTED_MODULE_1__.OK; },
/* harmony export */   cached: function() { return /* reexport safe */ _cache_cache_js__WEBPACK_IMPORTED_MODULE_1__.PO; },
/* harmony export */   component: function() { return /* reexport safe */ _component_component_js__WEBPACK_IMPORTED_MODULE_2__.s; },
/* harmony export */   debounce: function() { return /* reexport safe */ _debounce_debounce_js__WEBPACK_IMPORTED_MODULE_3__.s; },
/* harmony export */   derive: function() { return /* reexport safe */ _derive_derive_js__WEBPACK_IMPORTED_MODULE_4__.C; },
/* harmony export */   getPropertyDescriptor: function() { return /* reexport safe */ _watch_watch_js__WEBPACK_IMPORTED_MODULE_10__.N; },
/* harmony export */   hook: function() { return /* reexport safe */ _hook_hook_js__WEBPACK_IMPORTED_MODULE_5__.A; },
/* harmony export */   idle: function() { return /* reexport safe */ _idle_idle_js__WEBPACK_IMPORTED_MODULE_6__.N; },
/* harmony export */   nonenumerable: function() { return /* reexport safe */ _nonenumerable_nonenumerable_js__WEBPACK_IMPORTED_MODULE_7__.m; },
/* harmony export */   persistent: function() { return /* reexport safe */ _persistent_persistent_js__WEBPACK_IMPORTED_MODULE_8__.y; },
/* harmony export */   throttle: function() { return /* reexport safe */ _debounce_debounce_js__WEBPACK_IMPORTED_MODULE_3__.n; },
/* harmony export */   wait: function() { return /* reexport safe */ _wait_wait_js__WEBPACK_IMPORTED_MODULE_9__.u; },
/* harmony export */   watch: function() { return /* reexport safe */ _watch_watch_js__WEBPACK_IMPORTED_MODULE_10__.w; }
/* harmony export */ });
/* harmony import */ var _autobind_autobind_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45219);
/* harmony import */ var _cache_cache_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33433);
/* harmony import */ var _component_component_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87325);
/* harmony import */ var _debounce_debounce_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81577);
/* harmony import */ var _derive_derive_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55153);
/* harmony import */ var _hook_hook_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97357);
/* harmony import */ var _idle_idle_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78927);
/* harmony import */ var _nonenumerable_nonenumerable_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31589);
/* harmony import */ var _persistent_persistent_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53213);
/* harmony import */ var _wait_wait_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13525);
/* harmony import */ var _watch_watch_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(37133);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * [[include:core/decorators/README.md]]
 * @packageDocumentation
 * @module decorators
 */ 












/***/ }),

/***/ 65517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export link */
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22732);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21537);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50911);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5827);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






/**
 * Process link. Insert, dblclick or remove format
 */ class link extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Plugin */ .k {
    /** @override */ afterInit(jodit) {
        if (jodit.o.link.followOnDblClick) {
            jodit.e.on('dblclick.link', this.__onDblClickOnLink);
        }
        jodit.e.on(jodit.editor, 'click.link', this.__onClickReadOnlyLink);
        if (jodit.o.link.processPastedLink) {
            jodit.e.on('processPaste.link', this.onProcessPasteLink);
        }
        jodit.e.on('generateLinkForm.link', this.__generateForm);
        jodit.registerCommand('openLinkDialog', {
            exec: ()=>{
                const dialog = jodit.dlg({
                    resizable: false
                });
                const htmlForm = this.__generateForm(jodit.s.current(), ()=>{
                    dialog.close();
                });
                htmlForm.container.classList.add('jodit-dialog_alert');
                dialog.setContent(htmlForm);
                dialog.open();
                jodit.async.requestIdleCallback(()=>{
                    const { url_input } = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.refs)(htmlForm.container);
                    url_input === null || url_input === void 0 ? void 0 : url_input.focus();
                });
            },
            hotkeys: jodit.o.link.hotkeys
        });
    }
    __onDblClickOnLink(e) {
        if (!_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(e.target, 'a')) {
            return;
        }
        const href = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(e.target, 'href');
        if (href) {
            location.href = href;
            e.preventDefault();
        }
    }
    onProcessPasteLink(ignore, html) {
        var _a, _b, _c, _d;
        const { jodit } = this;
        if (!(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isURL)(html) || !jodit.o.link.processPastedLink) {
            return;
        }
        jodit.e.stopPropagation('processPaste');
        if (jodit.o.link.processVideoLink) {
            const embed = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.call)((_b = (_a = jodit.o.video) === null || _a === void 0 ? void 0 : _a.parseUrlToVideoEmbed) !== null && _b !== void 0 ? _b : _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.convertMediaUrlToVideoEmbed, html, {
                width: (_c = jodit.o.video) === null || _c === void 0 ? void 0 : _c.defaultWidth,
                height: (_d = jodit.o.video) === null || _d === void 0 ? void 0 : _d.defaultHeight
            });
            if (embed !== html) {
                return jodit.createInside.fromHTML(embed);
            }
        }
        if (jodit.s.isCollapsed()) {
            const a = jodit.createInside.element('a');
            a.setAttribute('href', html);
            a.textContent = html;
            jodit.e.fire('applyLink', jodit, a, null);
            return a;
        }
        jodit.s.commitStyle({
            element: 'a',
            attributes: {
                href: html
            }
        });
        return true;
    }
    __generateForm(current, close) {
        const { jodit } = this;
        const i18n = jodit.i18n.bind(jodit), { openInNewTabCheckbox, noFollowCheckbox, formTemplate, formClassName, modeClassName } = jodit.o.link;
        const html = formTemplate(jodit);
        const form = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isString)(html) ? jodit.c.fromHTML(html, {
            target_checkbox_box: openInNewTabCheckbox,
            nofollow_checkbox_box: noFollowCheckbox
        }) : html;
        const htmlForm = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isElement(form) ? form : form.container;
        const elements = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.refs)(htmlForm);
        const { insert, unlink, content_input_box } = elements;
        const { target_checkbox, nofollow_checkbox, url_input } = elements;
        const currentElement = current;
        const isImageContent = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isImage(currentElement);
        let { content_input } = elements;
        const { className_input } = elements, { className_select } = elements;
        if (!content_input) {
            content_input = jodit.c.element('input', {
                type: 'hidden',
                ref: 'content_input'
            });
        }
        if (formClassName) {
            htmlForm.classList.add(formClassName);
        }
        if (isImageContent) {
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.hide(content_input_box);
        }
        let link;
        const getSelectionText = ()=>link ? link.innerText : (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.stripTags)(jodit.s.range.cloneContents(), jodit.ed);
        if (current && _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.closest(current, 'a', jodit.editor)) {
            link = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.closest(current, 'a', jodit.editor);
        } else {
            link = false;
        }
        if (!isImageContent && current) {
            content_input.value = getSelectionText();
        }
        if (link) {
            url_input.value = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(link, 'href') || '';
            if (modeClassName) {
                readClassnames(modeClassName, className_input, link, className_select);
            }
            if (openInNewTabCheckbox && target_checkbox) {
                target_checkbox.checked = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(link, 'target') === '_blank';
            }
            if (noFollowCheckbox && nofollow_checkbox) {
                nofollow_checkbox.checked = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(link, 'rel') === 'nofollow';
            }
            insert.textContent = i18n('Update');
        } else {
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.hide(unlink);
        }
        jodit.editor.normalize();
        const snapshot = jodit.history.snapshot.make();
        if (unlink) {
            jodit.e.on(unlink, 'click', (e)=>{
                jodit.s.restore();
                jodit.history.snapshot.restore(snapshot);
                if (link) {
                    _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.unwrap(link);
                }
                jodit.synchronizeValues();
                close();
                e.preventDefault();
            });
        }
        const onSubmit = ()=>{
            if (!url_input.value.trim().length) {
                url_input.focus();
                url_input.classList.add('jodit_error');
                return false;
            }
            let links;
            jodit.s.restore();
            jodit.s.removeMarkers();
            jodit.editor.normalize();
            jodit.history.snapshot.restore(snapshot);
            const textWasChanged = getSelectionText() !== content_input.value.trim();
            const ci = jodit.createInside;
            if (!link || !_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isOrContains(jodit.editor, link)) {
                if (!jodit.s.isCollapsed()) {
                    const node = jodit.s.current();
                    if (_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(node, 'img')) {
                        links = [
                            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.wrap(node, 'a', ci)
                        ];
                    } else {
                        links = jodit.s.wrapInTag('a');
                    }
                } else {
                    const a = ci.element('a');
                    jodit.s.insertNode(a, false, false);
                    links = [
                        a
                    ];
                }
                links.forEach((link)=>jodit.s.select(link));
            } else {
                links = [
                    link
                ];
            }
            links.forEach((a)=>{
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(a, 'href', url_input.value);
                writeClasses(modeClassName, className_input, className_select, a);
                if (!isImageContent) {
                    writeImage(a, content_input, textWasChanged, url_input);
                }
                if (openInNewTabCheckbox && target_checkbox) {
                    (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(a, 'target', target_checkbox.checked ? '_blank' : null);
                }
                if (noFollowCheckbox && nofollow_checkbox) {
                    (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(a, 'rel', nofollow_checkbox.checked ? 'nofollow' : null);
                }
                jodit.e.fire('applyLink', jodit, a, form);
            });
            jodit.synchronizeValues();
            close();
            return false;
        };
        if (_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isElement(form)) {
            jodit.e.on(form, 'submit', (event)=>{
                event.preventDefault();
                event.stopImmediatePropagation();
                onSubmit();
                return false;
            });
        } else {
            form.onSubmit(onSubmit);
        }
        return form;
    }
    /** @override */ beforeDestruct(jodit) {
        jodit.e.off('generateLinkForm.link', this.__generateForm).off('dblclick.link', this.__onDblClickOnLink).off(jodit.editor, 'click.link', this.__onClickReadOnlyLink).off('processPaste.link', this.onProcessPasteLink);
    }
    __onClickReadOnlyLink(e) {
        const { jodit } = this;
        if (jodit.o.readonly && jodit.o.link.preventReadOnlyNavigation && _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(e.target, 'a')) {
            e.preventDefault();
        }
    }
    constructor(){
        super(...arguments);
        /** @override */ this.buttons = [
            {
                name: 'link',
                group: 'insert'
            }
        ];
    }
}
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], link.prototype, "__onDblClickOnLink", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], link.prototype, "onProcessPasteLink", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], link.prototype, "__generateForm", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], link.prototype, "__onClickReadOnlyLink", null);
_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .pluginSystem */ .fg.add('link', link);
function writeClasses(modeClassName, className_input, className_select, a) {
    var _a;
    if (modeClassName && (className_input !== null && className_input !== void 0 ? className_input : className_select)) {
        if (modeClassName === 'input') {
            if (className_input.value === '' && a.hasAttribute('class')) {
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(a, 'class', null);
            }
            if (className_input.value !== '') {
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(a, 'class', className_input.value);
            }
        } else if (modeClassName === 'select') {
            if (a.hasAttribute('class')) {
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(a, 'class', null);
            }
            for(let i = 0; i < className_select.selectedOptions.length; i++){
                const className = (_a = className_select.selectedOptions.item(i)) === null || _a === void 0 ? void 0 : _a.value;
                if (className) {
                    a.classList.add(className);
                }
            }
        }
    }
}
function readClassnames(modeClassName, className_input, link, className_select) {
    switch(modeClassName){
        case 'input':
            if (className_input) {
                className_input.value = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(link, 'class') || '';
            }
            break;
        case 'select':
            if (className_select) {
                for(let i = 0; i < className_select.selectedOptions.length; i++){
                    const option = className_select.options.item(i);
                    if (option) {
                        option.selected = false;
                    }
                }
                const classNames = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(link, 'class') || '';
                classNames.split(' ').forEach((className)=>{
                    if (className) {
                        for(let i = 0; i < className_select.options.length; i++){
                            const option = className_select.options.item(i);
                            if ((option === null || option === void 0 ? void 0 : option.value) && option.value === className) {
                                option.selected = true;
                            }
                        }
                    }
                });
            }
            break;
    }
}
function writeImage(a, content_input, textWasChanged, url_input) {
    let newContent = a.textContent;
    if (content_input.value.trim().length) {
        if (textWasChanged) {
            newContent = content_input.value;
        }
    } else {
        newContent = url_input.value;
    }
    const content = a.textContent;
    if (newContent !== content) {
        a.textContent = newContent;
    }
}


/***/ }),

/***/ 65638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   I: function() { return /* binding */ canUsePersistentStorage; },
/* harmony export */   O: function() { return /* binding */ LocalStorageProvider; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * Check if user disable local storages/cookie etc.
 */ const canUsePersistentStorage = (()=>{
    const canUse = ()=>{
        const tmpKey = '___Jodit___' + Math.random().toString();
        try {
            localStorage.setItem(tmpKey, '1');
            const result = localStorage.getItem(tmpKey) === '1';
            localStorage.removeItem(tmpKey);
            return result;
        } catch (_a) {}
        return false;
    };
    let result;
    return ()=>{
        if (result === undefined) {
            result = canUse();
        }
        return result;
    };
})();
/**
 * Persistent storage in localStorage
 */ class LocalStorageProvider {
    set(key, value) {
        try {
            const buffer = localStorage.getItem(this.rootKey);
            const json = buffer ? JSON.parse(buffer) : {};
            json[key] = value;
            localStorage.setItem(this.rootKey, JSON.stringify(json));
        } catch (_a) {}
        return this;
    }
    delete(key) {
        try {
            localStorage.removeItem(this.rootKey);
        } catch (_a) {}
        return this;
    }
    get(key) {
        try {
            const buffer = localStorage.getItem(this.rootKey);
            const json = buffer ? JSON.parse(buffer) : {};
            return json[key] !== undefined ? json[key] : undefined;
        } catch (_a) {}
    }
    exists(key) {
        return this.get(key) != null;
    }
    clear() {
        try {
            localStorage.removeItem(this.rootKey);
        } catch (_a) {}
        return this;
    }
    constructor(rootKey){
        this.rootKey = rootKey;
    }
}


/***/ }),

/***/ 65735:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37133);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(580);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50911);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9045);
/* harmony import */ var _after_insert_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46124);
/* harmony import */ var _before_insert_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43267);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






class dtd extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Plugin */ .k {
    afterInit(jodit) {}
    beforeDestruct(jodit) {}
    __onBeforeInsertNode(node) {
        const casesKeys = Object.keys(_before_insert_index_js__WEBPACK_IMPORTED_MODULE_5__);
        casesKeys.forEach((key)=>{
            _before_insert_index_js__WEBPACK_IMPORTED_MODULE_5__[key](this.j, node);
        });
    }
    __onAfterInsertNode(node) {
        const casesKeys = Object.keys(_after_insert_index_js__WEBPACK_IMPORTED_MODULE_4__);
        casesKeys.forEach((key)=>{
            _after_insert_index_js__WEBPACK_IMPORTED_MODULE_4__[key](this.j, node);
        });
    }
}
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_0__/* .watch */ .w)(':beforeInsertNode')
], dtd.prototype, "__onBeforeInsertNode", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_0__/* .watch */ .w)(':afterInsertNode')
], dtd.prototype, "__onAfterInsertNode", null);
_core_global_js__WEBPACK_IMPORTED_MODULE_1__/* .pluginSystem */ .fg.add('dtd', dtd);


/***/ }),

/***/ 65917:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var jodit_esm_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */

jodit_esm_config__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.controls.font.list = {
    "'Andale mono', monospace'": 'Andale Mono',
    'Arial, Helvetica, sans-serif': 'Arial',
    "'Arial black', sans-serif": 'Arial Black',
    "'Book antiqua', palatino, serif": 'Book Antiqua',
    "'Comic Sans MS', sans-serif": 'Comic Sans MS',
    "'Courier new', Courier, monospace": 'Courier New',
    'Georgia, Palatino, serif': 'Georgia',
    'Helvetica, Arial, sans-serif': 'Helvetica',
    'Impact, Charcoal, sans-serif': 'Impact',
    'Symbol, sans-serif': 'Symbol',
    'Tahoma, Arial, Helvetica, sans-serif': 'Tahoma',
    'Terminal, Monaco, monospace': 'Terminal',
    "'Times new roman', Times, serif": 'Times New Roman',
    "'Trebuchet ms', Geneva, sans-serif": 'Trebuchet MS',
    'Verdana, Geneva, sans-serif': 'Verdana',
    Webdings: 'Webdings',
    "Wingdings, 'Zapf dingbats'": 'Wingdings'
};
jodit_esm_config__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.loadExternalConfig = true;


/***/ }),

/***/ 66288:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/tab
 */ 
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.tab = {
    tabInsideLiInsertNewList: true
};


/***/ }),

/***/ 66292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   X: function() { return /* binding */ completeUrl; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/utils
 */ 
const completeUrl = (url)=>{
    if (_constants_js__WEBPACK_IMPORTED_MODULE_0__.globalWindow.location.protocol === 'file:' && /^\/\//.test(url)) {
        url = 'https:' + url;
    }
    return url;
};


/***/ }),

/***/ 66434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    symbols: '符號'
});


/***/ }),

/***/ 66465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   m: function() { return /* binding */ required; }
/* harmony export */ });
/* harmony import */ var _helpers_string_trim_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49055);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/**
 * Select is required
 */ const required = function(select) {
    if (!(0,_helpers_string_trim_js__WEBPACK_IMPORTED_MODULE_0__/* .trim */ .Bq)(select.value).length) {
        select.error = 'Please fill out this field';
        return false;
    }
    return true;
};


/***/ }),

/***/ 66707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export deleteCommand */
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22732);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21537);
/* harmony import */ var _core_helpers_string_trim_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49055);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50911);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 





class deleteCommand extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Plugin */ .k {
    afterInit(jodit) {
        jodit.e.on('afterCommand.delete', (command)=>{
            if (command === 'delete') {
                this.__afterDeleteCommand();
            }
        });
        jodit.registerCommand('delete', {
            exec: this.__onDeleteCommand.bind(this)
        }, {
            stopPropagation: false
        });
    }
    beforeDestruct(jodit) {
        jodit.e.off('afterCommand.delete');
    }
    /**
     * After Delete command remove extra BR
     */ __afterDeleteCommand() {
        const jodit = this.j;
        const current = jodit.s.current();
        if (current && _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(current.firstChild, 'br')) {
            jodit.s.removeNode(current.firstChild);
        }
        if (!(0,_core_helpers_string_trim_js__WEBPACK_IMPORTED_MODULE_3__/* .trim */ .Bq)(jodit.editor.textContent || '') && !jodit.editor.querySelector('img,table,jodit,iframe,hr') && (!current || !_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(current, 'table', jodit.editor))) {
            jodit.editor.innerHTML = '';
            const node = jodit.s.setCursorIn(jodit.editor);
            jodit.s.removeNode(node);
        }
    }
    __onDeleteCommand() {
        const { jodit } = this;
        if (jodit.s.isCollapsed()) {
            return;
        }
        jodit.s.expandSelection();
        const range = jodit.s.range;
        range.deleteContents();
        const fake = jodit.createInside.fake();
        range.insertNode(fake);
        const leftSibling = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.findSibling(fake, true);
        const rightSibling = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.findSibling(fake, false);
        this.__moveContentInLeftSibling(fake, leftSibling, rightSibling);
        range.setStartBefore(fake);
        range.collapse(true);
        this.__moveCursorInEditableSibling(jodit, leftSibling, fake, range);
        this.__addBrInEmptyBlock(fake, rightSibling, range);
        _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(fake);
        jodit.s.selectRange(range);
        return false;
    }
    __moveContentInLeftSibling(fake, leftSibling, rightSibling) {
        leftSibling = this.__defineRightLeftBox(leftSibling);
        if (!_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isList(rightSibling) && !_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(rightSibling, 'table') && _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isBlock(rightSibling) && _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isBlock(leftSibling)) {
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.append(leftSibling, fake);
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.moveContent(rightSibling, leftSibling);
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(rightSibling);
        }
        // Remove empty right LI
        if (_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isList(rightSibling) && _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isLeaf(rightSibling.firstElementChild) && _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isEmpty(rightSibling.firstElementChild)) {
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(rightSibling.firstElementChild);
        }
    }
    /**
     * If left sibling is list - return last leaf
     */ __defineRightLeftBox(leftSibling) {
        if (!_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isList(leftSibling)) {
            return leftSibling;
        }
        let lastLeaf = leftSibling.lastElementChild;
        if (!_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isLeaf(lastLeaf)) {
            lastLeaf = this.j.createInside.element('li');
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.append(leftSibling, lastLeaf);
        }
        return lastLeaf;
    }
    /**
     * Add BR in empty blocks left and right(for table cell)
     */ __addBrInEmptyBlock(fake, rightSibling, range) {
        const jodit = this.j;
        if (fake.isConnected && _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isBlock(fake.parentNode) && !fake.nextSibling && !fake.previousSibling) {
            const br = jodit.createInside.element('br');
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.after(fake, br);
            range.setStartBefore(br);
            range.collapse(true);
        }
        // Add BR in the right empty table cell
        if (_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(rightSibling, 'table')) {
            const firstCell = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.$$)('td,th', rightSibling).shift();
            if (_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isCell(firstCell) && _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isEmpty(firstCell)) {
                _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.append(firstCell, jodit.createInside.element('br'));
            }
        }
    }
    __moveCursorInEditableSibling(jodit, leftSibling, fake, range) {
        var _a;
        if (!leftSibling || !_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isText(leftSibling)) {
            const root = (_a = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(fake, _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isBlock, jodit.editor)) !== null && _a !== void 0 ? _a : jodit.editor;
            const leftText = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.prev(fake, _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isText, root);
            if (leftText) {
                range.setStartAfter(leftText);
                range.collapse(true);
                _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(fake);
            }
        }
    }
}
deleteCommand.requires = [
    'backspace'
];
_core_global_js__WEBPACK_IMPORTED_MODULE_1__/* .pluginSystem */ .fg.add('deleteCommand', deleteCommand);


/***/ }),

/***/ 66789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _img_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20882);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/* harmony default export */ __webpack_exports__.A = ([
    {
        name: 'bin',
        tooltip: 'Delete',
        exec: (editor, image)=>{
            image && editor.s.removeNode(image);
        }
    },
    _img_js__WEBPACK_IMPORTED_MODULE_0__/* .align */ .M
]);


/***/ }),

/***/ 66835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    newline: 'خط جدید',
    delete: 'حذف',
    space: 'فضا',
    'Speech Recognize': 'گفتار را تشخیص دهید',
    Sound: 'صدا',
    'Interim Results': 'نتایج موقت'
});


/***/ }),

/***/ 66863:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1664 256v448q0 26-19 45t-45 19h-448q-42 0-59-40-17-39 14-69l138-138q-148-137-349-137-104 0-198.5 40.5t-163.5 109.5-109.5 163.5-40.5 198.5 40.5 198.5 109.5 163.5 163.5 109.5 198.5 40.5q119 0 225-52t179-147q7-10 23-12 14 0 25 9l137 138q9 8 9.5 20.5t-7.5 22.5q-109 132-264 204.5t-327 72.5q-156 0-298-61t-245-164-164-245-61-298 61-298 164-245 245-164 298-61q147 0 284.5 55.5t244.5 156.5l130-129q29-31 70-14 39 17 39 59z\"/> </svg> ");


/***/ }),

/***/ 67078:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'Type something': 'Írjon be valamit',
    Advanced: 'Haladó',
    'About Jodit': 'Joditról',
    'Jodit Editor': 'Jodit Editor',
    'Free Non-commercial Version': 'Ingyenes változat',
    "Jodit User's Guide": 'Jodit útmutató',
    'contains detailed help for using': 'további segítséget tartalmaz',
    'For information about the license, please go to our website:': 'További licence információkért látogassa meg a weboldalunkat:',
    'Buy full version': 'Teljes verzió megvásárlása',
    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.': 'Copyright © XDSoft.net - Chupurnov Valeriy. Minden jog fenntartva.',
    Anchor: 'Horgony',
    'Open in new tab': 'Megnyitás új lapon',
    'Open in fullsize': 'Megnyitás teljes méretben',
    'Clear Formatting': 'Formázás törlése',
    'Fill color or set the text color': 'Háttér/szöveg szín',
    Redo: 'Újra',
    Undo: 'Visszavon',
    Bold: 'Félkövér',
    Italic: 'Dőlt',
    'Insert Unordered List': 'Pontozott lista',
    'Insert Ordered List': 'Számozott lista',
    'Align Center': 'Középre zárt',
    'Align Justify': 'Sorkizárt',
    'Align Left': 'Balra zárt',
    'Align Right': 'Jobbra zárt',
    'Insert Horizontal Line': 'Vízszintes vonal beszúrása',
    'Insert Image': 'Kép beszúrás',
    'Insert file': 'Fájl beszúrás',
    'Insert youtube/vimeo video': 'Youtube videó beszúrása',
    'Insert link': 'Link beszúrás',
    'Font size': 'Betűméret',
    'Font family': 'Betűtípus',
    'Insert format block': 'Formázott blokk beszúrása',
    Normal: 'Normál',
    'Heading 1': 'Fejléc 1',
    'Heading 2': 'Fejléc 2',
    'Heading 3': 'Fejléc 3',
    'Heading 4': 'Fejléc 4',
    Quote: 'Idézet',
    Code: 'Kód',
    Insert: 'Beszúr',
    'Insert table': 'Táblázat beszúrása',
    'Decrease Indent': 'Behúzás csökkentése',
    'Increase Indent': 'Behúzás növelése',
    'Select Special Character': 'Speciális karakter kiválasztása',
    'Insert Special Character': 'Speciális karakter beszúrása',
    'Paint format': 'Kép formázása',
    'Change mode': 'Nézet váltása',
    Print: 'Nyomtatás',
    Margins: 'Szegélyek',
    top: 'felső',
    right: 'jobb',
    bottom: 'alsó',
    left: 'bal',
    Styles: 'CSS stílusok',
    Classes: 'CSS osztályok',
    Align: 'Igazítás',
    Right: 'Jobbra',
    Center: 'Középre',
    Left: 'Balra',
    '--Not Set--': 'Nincs',
    Src: 'Forrás',
    Title: 'Cím',
    Alternative: 'Helyettesítő szöveg',
    Link: 'Link',
    'Open link in new tab': 'Link megnyitása új lapon',
    Image: 'Kép',
    file: 'Fájl',
    'Image properties': 'Kép tulajdonságai',
    Cancel: 'Mégsem',
    Ok: 'OK',
    'Your code is similar to HTML. Keep as HTML?': 'A beillesztett szöveg HTML-nek tűnik. Megtartsuk HTML-ként?',
    'Paste as HTML': 'Beszúrás HTML-ként',
    Keep: 'Megtartás',
    Clean: 'Elvetés',
    'Insert as Text': 'Beszúrás szövegként',
    'Word Paste Detected': 'Word-ből másolt szöveg',
    'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?': 'A beillesztett tartalom Microsoft Word/Excel dokumentumból származik. Meg szeretné tartani a formátumát?',
    'Insert only Text': 'Csak szöveg beillesztése',
    'File Browser': 'Fájl tallózó',
    'Error on load list': 'Hiba a lista betöltése közben',
    'Error on load folders': 'Hiba a mappák betöltése közben',
    'Are you sure?': 'Biztosan ezt szeretné?',
    'Enter Directory name': 'Írjon be egy mappanevet',
    'Create directory': 'Mappa létrehozása',
    'type name': 'írjon be bevet',
    'Drop image': 'Húzza ide a képet',
    'Drop file': 'Húzza ide a fájlt',
    'or click': 'vagy kattintson',
    'Alternative text': 'Helyettesítő szöveg',
    Browse: 'Tallóz',
    Upload: 'Feltölt',
    Background: 'Háttér',
    Text: 'Szöveg',
    Top: 'Fent',
    Middle: 'Középen',
    Bottom: 'Lent',
    'Insert column before': 'Oszlop beszúrás elé',
    'Insert column after': 'Oszlop beszúrás utána',
    'Insert row above': 'Sor beszúrás fölé',
    'Insert row below': 'Sor beszúrás alá',
    'Delete table': 'Táblázat törlése',
    'Delete row': 'Sor törlése',
    'Delete column': 'Oszlop törlése',
    'Empty cell': 'Cella tartalmának törlése',
    Delete: 'Törlés',
    'Strike through': 'Áthúzott',
    Underline: 'Aláhúzott',
    Break: 'Szünet',
    'Search for': 'Keresés',
    'Replace with': 'Csere erre',
    Replace: 'Cserélje ki',
    Edit: 'Szerkeszt',
    'Vertical align': 'Függőleges igazítás',
    'Horizontal align': 'Vízszintes igazítás',
    Filter: 'Szűrő',
    'Sort by changed': 'Rendezés módosítás szerint',
    'Sort by name': 'Rendezés név szerint',
    'Sort by size': 'Rendezés méret szerint',
    'Add folder': 'Mappa hozzáadás',
    'Split vertical': 'Függőleges felosztás',
    'Split horizontal': 'Vízszintes felosztás',
    Merge: 'Összevonás',
    'Add column': 'Oszlop hozzáadás',
    'Add row': 'Sor hozzáadás',
    Border: 'Szegély',
    'Embed code': 'Beágyazott kód',
    Update: 'Frissít',
    superscript: 'Felső index',
    subscript: 'Alsó index',
    'Cut selection': 'Kivágás',
    Paste: 'Beillesztés',
    'Choose Content to Paste': 'Válasszon tartalmat a beillesztéshez',
    Split: 'Felosztás',
    'Chars: %d': 'Karakterek száma: %d',
    'Words: %d': 'Szavak száma: %d',
    All: 'Összes',
    'Select %s': 'Kijelöl: %s',
    'Select all': 'Összes kijelölése',
    source: 'HTML',
    bold: 'Félkövér',
    italic: 'Dőlt',
    brush: 'Ecset',
    link: 'Link',
    undo: 'Visszavon',
    redo: 'Újra',
    table: 'Táblázat',
    image: 'Kép',
    eraser: 'Törlés',
    paragraph: 'Paragráfus',
    fontsize: 'Betűméret',
    video: 'Videó',
    font: 'Betű',
    about: 'Rólunk',
    print: 'Nyomtat',
    underline: 'Aláhúzott',
    strikethrough: 'Áthúzott',
    indent: 'Behúzás',
    outdent: 'Aussenseiter',
    fullsize: 'Teljes méret',
    shrink: 'Összenyom',
    hr: 'Egyenes vonal',
    ul: 'Lista',
    ol: 'Számozott lista',
    cut: 'Kivág',
    selectall: 'Összes kijelölése',
    'Open link': 'Link megnyitása',
    'Edit link': 'Link szerkesztése',
    'No follow': 'Nincs követés',
    Unlink: 'Link leválasztása',
    Eye: 'felülvizsgálat',
    pencil: 'Szerkesztés',
    ' URL': 'URL',
    Reset: 'Visszaállít',
    Save: 'Mentés',
    'Save as ...': 'Mentés másként...',
    Resize: 'Átméretezés',
    Crop: 'Kivág',
    Width: 'Szélesség',
    Height: 'Magasság',
    'Keep Aspect Ratio': 'Képarány megtartása',
    Yes: 'Igen',
    No: 'Nem',
    Remove: 'Eltávolít',
    Select: 'Kijelöl',
    'You can only edit your own images. Download this image on the host?': 'Csak a saját képeit tudja szerkeszteni. Letölti ezt a képet?',
    'The image has been successfully uploaded to the host!': 'Kép sikeresen feltöltve!',
    palette: 'Palette',
    'There are no files': 'Er zijn geen bestanden in deze map.',
    Rename: 'átnevezés',
    'Enter new name': 'Adja meg az új nevet',
    preview: 'előnézet',
    download: 'Letöltés',
    'Paste from clipboard': 'Illessze be a vágólap',
    "Your browser doesn't support direct access to the clipboard.": 'A böngésző nem támogatja a közvetlen hozzáférést biztosít a vágólapra.',
    'Copy selection': 'Másolás kiválasztása',
    copy: 'másolás',
    'Border radius': 'Határ sugár',
    'Show all': 'Összes',
    Apply: 'Alkalmazni',
    'Please fill out this field': 'Kérjük, töltse ki ezt a mezőt,',
    'Please enter a web address': 'Kérjük, írja be a webcímet',
    Default: 'Alapértelmezett',
    Circle: 'Kör',
    Dot: 'Pont',
    Quadrate: 'Quadrate',
    Find: 'Találni',
    'Find Previous': 'Megtalálja Előző',
    'Find Next': 'Következő Keresése',
    'Insert className': 'Helyezze be az osztály nevét',
    'Press Alt for custom resizing': 'Nyomja meg az Alt egyéni átméretezés'
});


/***/ }),

/***/ 67206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    'Line height': 'Rivin korkeus'
});


/***/ }),

/***/ 67215:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/select
 */ 
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.select = {
    normalizeSelectionBeforeCutAndCopy: false,
    normalizeTripleClick: true
};


/***/ }),

/***/ 67290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CP: function() { return /* reexport safe */ _separator_js__WEBPACK_IMPORTED_MODULE_2__.C; },
/* harmony export */   Ue: function() { return /* reexport safe */ _group_js__WEBPACK_IMPORTED_MODULE_0__.U; },
/* harmony export */   bk: function() { return /* reexport safe */ _spacer_js__WEBPACK_IMPORTED_MODULE_3__.b; },
/* harmony export */   z4: function() { return /* reexport safe */ _list_js__WEBPACK_IMPORTED_MODULE_1__.z; }
/* harmony export */ });
/* harmony import */ var _group_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62405);
/* harmony import */ var _list_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24536);
/* harmony import */ var _separator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92113);
/* harmony import */ var _spacer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34244);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module ui/group
 */ 





/***/ }),

/***/ 67462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ stringify; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * Safe stringify circular object
 */ function stringify(value, options = {}) {
    if (typeof value !== 'object') {
        return String(value);
    }
    const excludeKeys = new Set(options.excludeKeys);
    const map = new WeakMap();
    const r = (k, v)=>{
        if (excludeKeys.has(k)) {
            return;
        }
        if (typeof v === 'object' && v != null) {
            if (map.get(v)) {
                return '[refObject]';
            }
            map.set(v, true);
        }
        return v;
    };
    return JSON.stringify(value, r, options.prettify);
}


/***/ }),

/***/ 67477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   H: function() { return /* binding */ fuzzySearchIndex; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/string
 */ 
/**
 * Finds the position of the substring in the string, if any, and returns the length of the found subsequence.
 * Unlike `indexOf` ignores INVISIBLE_SPACE and may fail at `maxDistance` characters
 */ function fuzzySearchIndex(needle, haystack, offset = 0, maxDistance = 1) {
    let i = 0, j = 0, startIndex = -1, len = 0, errorDistance = 0;
    for(j = offset; i < needle.length && j < haystack.length;){
        if (needle[i].toLowerCase() === haystack[j].toLowerCase()) {
            i++;
            len++;
            errorDistance = 0;
            if (startIndex === -1) {
                startIndex = j;
            }
        } else if (i > 0) {
            if (errorDistance >= maxDistance && haystack[j] !== _constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE) {
                i = 0;
                startIndex = -1;
                len = 0;
                errorDistance = 0;
                j--;
            } else {
                errorDistance++;
                len++;
            }
        }
        j++;
    }
    return i === needle.length ? [
        startIndex,
        len
    ] : [
        -1,
        0
    ];
}


/***/ }),

/***/ 67510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $6: function() { return /* reexport safe */ _form_index_js__WEBPACK_IMPORTED_MODULE_2__.$6; },
/* harmony export */   $n: function() { return /* reexport safe */ _button_index_js__WEBPACK_IMPORTED_MODULE_0__.$n; },
/* harmony export */   CP: function() { return /* reexport safe */ _group_index_js__WEBPACK_IMPORTED_MODULE_3__.CP; },
/* harmony export */   D$: function() { return /* reexport safe */ _element_js__WEBPACK_IMPORTED_MODULE_1__.D; },
/* harmony export */   F0: function() { return /* reexport safe */ _form_index_js__WEBPACK_IMPORTED_MODULE_2__.F0; },
/* harmony export */   In: function() { return /* reexport safe */ _icon_js__WEBPACK_IMPORTED_MODULE_4__.I; },
/* harmony export */   SB: function() { return /* reexport safe */ _button_index_js__WEBPACK_IMPORTED_MODULE_0__.SB; },
/* harmony export */   Ue: function() { return /* reexport safe */ _group_index_js__WEBPACK_IMPORTED_MODULE_3__.Ue; },
/* harmony export */   XV: function() { return /* reexport safe */ _form_index_js__WEBPACK_IMPORTED_MODULE_2__.XV; },
/* harmony export */   Yh: function() { return /* reexport safe */ _form_index_js__WEBPACK_IMPORTED_MODULE_2__.Yh; },
/* harmony export */   bk: function() { return /* reexport safe */ _group_index_js__WEBPACK_IMPORTED_MODULE_3__.bk; },
/* harmony export */   cY: function() { return /* reexport safe */ _form_index_js__WEBPACK_IMPORTED_MODULE_2__.cY; },
/* harmony export */   lD: function() { return /* reexport safe */ _button_index_js__WEBPACK_IMPORTED_MODULE_0__.lD; },
/* harmony export */   nE: function() { return /* reexport safe */ _form_index_js__WEBPACK_IMPORTED_MODULE_2__.nE; },
/* harmony export */   ss: function() { return /* reexport safe */ _button_index_js__WEBPACK_IMPORTED_MODULE_0__.ss; },
/* harmony export */   tS: function() { return /* reexport safe */ _form_index_js__WEBPACK_IMPORTED_MODULE_2__.tS; },
/* harmony export */   ue: function() { return /* reexport safe */ _button_index_js__WEBPACK_IMPORTED_MODULE_0__.ue; },
/* harmony export */   z2: function() { return /* reexport safe */ _progress_bar_progress_bar_js__WEBPACK_IMPORTED_MODULE_6__.z; },
/* harmony export */   z4: function() { return /* reexport safe */ _group_index_js__WEBPACK_IMPORTED_MODULE_3__.z4; },
/* harmony export */   zD: function() { return /* reexport safe */ _popup_index_js__WEBPACK_IMPORTED_MODULE_5__.z; }
/* harmony export */ });
/* harmony import */ var _button_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62843);
/* harmony import */ var _element_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48538);
/* harmony import */ var _form_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2525);
/* harmony import */ var _group_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67290);
/* harmony import */ var _icon_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12153);
/* harmony import */ var _popup_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61259);
/* harmony import */ var _progress_bar_progress_bar_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23769);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * [[include:core/ui/README.md]]
 * @packageDocumentation
 * @module ui
 */ 








/***/ }),

/***/ 68034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B: function() { return /* binding */ checkUnwrapFirstListItem; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43555);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/**
 * For the first item in a list on backspace, try to move his content in new P
 *
 * @example
 * ```html
 * <ul><li>|first</li><li>second</li></ul>
 * ```
 * Result
 * ```html
 * <p>|first</p><ul><li>second</li></ul>
 * ```
 *
 * @private
 */ function checkUnwrapFirstListItem(jodit, fakeNode, backspace) {
    var _a;
    const li = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(fakeNode, _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isElement, jodit.editor);
    const { s } = jodit;
    if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isLeaf(li) && ((_a = li === null || li === void 0 ? void 0 : li.parentElement) === null || _a === void 0 ? void 0 : _a[backspace ? 'firstElementChild' : 'lastElementChild']) === li && s.cursorInTheEdge(backspace, li)) {
        const ul = li.parentElement;
        const p = jodit.createInside.element(jodit.o.enterBlock);
        (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .call */ .T1)(backspace ? _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.before : _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.after, ul, p);
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.moveContent(li, p);
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(li);
        if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isEmpty(ul)) {
            _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(ul);
        }
        (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .call */ .T1)(backspace ? s.setCursorBefore : s.setCursorAfter, fakeNode);
        return true;
    }
    return false;
}


/***/ }),

/***/ 68252:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/resize-handler
 */ 
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.allowResizeX = false;
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.allowResizeY = true;


/***/ }),

/***/ 68278:
/***/ (function(__unused_webpack_module, __webpack_exports__) {


/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'copy-format': 'Kopyalama Biçimi'
});


/***/ }),

/***/ 68345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   c: function() { return /* binding */ isArray; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/checker
 */ /**
 * Check if element is array
 */ function isArray(elm) {
    return Array.isArray(elm);
}


/***/ }),

/***/ 68389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C: function() { return /* binding */ UIMessage; }
/* harmony export */ });
/* harmony import */ var _core_decorators_component_component_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87325);
/* harmony import */ var _core_ui_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67510);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let UIMessage = class UIMessage extends _core_ui_index_js__WEBPACK_IMPORTED_MODULE_0__/* .UIElement */ .D$ {
    className() {
        return 'UIMessage';
    }
    constructor(jodit, options){
        super(jodit);
        this.setMod('active', true);
        this.setMod('variant', options.variant);
        this.container.textContent = options.text;
    }
};
UIMessage = __decorate([
    _core_decorators_component_component_js__WEBPACK_IMPORTED_MODULE_1__/* .component */ .s
], UIMessage);



/***/ }),

/***/ 68687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export sticky */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2748);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21537);
/* harmony import */ var _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20356);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48038);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







const NEED_DUMMY_BOX = !_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_ES_NEXT && _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_IE;
class sticky extends _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_5__/* .Plugin */ .k {
    afterInit(jodit) {
        jodit.e.on(jodit.ow, 'scroll.sticky wheel.sticky mousewheel.sticky resize.sticky', this.__onScroll).on('getStickyState.sticky', ()=>this.__isToolbarStuck);
    }
    /**
     * Scroll handler
     */ __onScroll() {
        const { jodit } = this;
        if (!jodit.o.toolbarSticky || !jodit.o.toolbar) {
            return;
        }
        const scrollWindowTop = jodit.ow.pageYOffset || jodit.od.documentElement && jodit.od.documentElement.scrollTop || 0;
        const offsetEditor = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.offset)(jodit.container, jodit, jodit.od, true);
        const doSticky = jodit.getMode() === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_WYSIWYG && scrollWindowTop + jodit.o.toolbarStickyOffset > offsetEditor.top && scrollWindowTop + jodit.o.toolbarStickyOffset < offsetEditor.top + offsetEditor.height && !(jodit.o.toolbarDisableStickyForMobile && this.__isMobile());
        if (this.__isToolbarStuck === doSticky) {
            return;
        }
        const container = jodit.toolbarContainer;
        if (container) {
            doSticky ? this.addSticky(container) : this.removeSticky(container);
        }
        jodit.e.fire('toggleSticky', doSticky);
    }
    /**
     * Is mobile device
     */ __isMobile() {
        const { j } = this;
        return j && j.options && j.container && j.options.sizeSM >= j.container.offsetWidth;
    }
    beforeDestruct(jodit) {
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(this.__dummyBox);
        jodit.e.off(jodit.ow, 'scroll.sticky wheel.sticky mousewheel.sticky resize.sticky', this.__onScroll).off('.sticky');
    }
    constructor(){
        super(...arguments);
        this.__isToolbarStuck = false;
        this.__createDummy = (toolbar)=>{
            this.__dummyBox = this.j.c.div();
            this.__dummyBox.classList.add('jodit_sticky-dummy_toolbar');
            this.j.container.insertBefore(this.__dummyBox, toolbar);
        };
        /**
         * Add sticky
         */ this.addSticky = (toolbar)=>{
            if (!this.__isToolbarStuck) {
                if (NEED_DUMMY_BOX && !this.__dummyBox) {
                    this.__createDummy(toolbar);
                }
                this.j.container.classList.add('jodit_sticky');
                this.__isToolbarStuck = true;
            }
            // on resize, it should work always
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.css)(toolbar, {
                top: this.j.o.toolbarStickyOffset || null,
                width: this.j.container.offsetWidth - 2
            });
            this.__dummyBox && (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.css)(this.__dummyBox, {
                height: toolbar.offsetHeight
            });
        };
        /**
         * Remove sticky behaviour
         */ this.removeSticky = (toolbar)=>{
            if (!this.__isToolbarStuck) {
                return;
            }
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.css)(toolbar, {
                width: '',
                top: ''
            });
            this.j.container.classList.remove('jodit_sticky');
            this.__isToolbarStuck = false;
        };
    }
}
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.throttle)()
], sticky.prototype, "__onScroll", null);
_core_global_js__WEBPACK_IMPORTED_MODULE_3__/* .pluginSystem */ .fg.add('sticky', sticky);


/***/ }),

/***/ 68846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   F: function() { return /* binding */ convertStyleUnitToPixels; }
/* harmony export */ });
/* harmony import */ var jodit_pro_plugins_paste_from_word_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46788);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */

const convertStyleUnitToPixels = (elm, { jodit }) => {
    if (!jodit.o.pasteFromWord.convertUnitsToPixel) {
        return elm;
    }
    const { style } = elm;
    style.forEach((key) => {
        const v = style.get(key);
        if (v) {
            style.set(key, v
                .toString()
                .replace(/\d+(\.\d+)?(pt|cm)/g, (match) => (0,jodit_pro_plugins_paste_from_word_helpers__WEBPACK_IMPORTED_MODULE_0__/* .convertUnitToPx */ .Bj)(match) + 'px'));
        }
    });
    return elm;
};


/***/ }),

/***/ 68891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    Spellcheck: 'Перевірка орфографії'
});


/***/ }),

/***/ 68934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   VL: function() { return /* binding */ ConfigFlatten; },
/* harmony export */   pi: function() { return /* binding */ ConfigDeepFlatten; },
/* harmony export */   tb: function() { return /* binding */ ConfigProto; }
/* harmony export */ });
/* harmony import */ var _checker_is_array_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68345);
/* harmony import */ var _checker_is_plain_object_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72430);
/* harmony import */ var _checker_is_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70799);
/* harmony import */ var _checker_is_void_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86068);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/* harmony import */ var _extend_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97735);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37790);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 






/**
 * @example
 * ```js
 * const defaultConfig = {
 *   a: {
 *     b: {
 *       c: 2
 *     },
 *     e: 5
 *   },
 *   d: {
 *     g: 7
 *   }
 * };
 *
 * const options = ConfigProto({a: {
 *   b: {
 *     c: 1
 *   }
 * }}, defaultConfig);
 *
 * console.log(options.a.b.c); // 1
 * console.log(options.a.e); // 5
 * console.log(options.d.g); // 7
 *
 * defaultConfig.d.g  = 8;
 * console.log(options.d.g); // 8
 *
 * ```
 */ function ConfigProto(options, proto, deep = 0) {
    // Already prototyped object should not be prototyped again
    if (Object.getPrototypeOf(options) !== Object.prototype) {
        return options;
    }
    const def = _config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.defaultOptions;
    if ((0,_checker_is_string_js__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .K)(options.preset)) {
        if (def.presets[options.preset] !== undefined) {
            const preset = def.presets[options.preset];
            Object.keys(preset).forEach((subKey)=>{
                if ((0,_checker_is_void_js__WEBPACK_IMPORTED_MODULE_3__/* .isVoid */ .R)(options[subKey])) {
                    options[subKey] = preset[subKey];
                }
            });
        }
        delete options.preset;
    }
    const newOpt = {};
    Object.keys(options).forEach((key)=>{
        const opt = options[key], protoKey = proto ? proto[key] : null;
        if ((0,_checker_is_plain_object_js__WEBPACK_IMPORTED_MODULE_4__/* .isPlainObject */ .Q)(opt) && (0,_checker_is_plain_object_js__WEBPACK_IMPORTED_MODULE_4__/* .isPlainObject */ .Q)(protoKey) && !(0,_extend_js__WEBPACK_IMPORTED_MODULE_5__/* .isAtom */ .mA)(opt)) {
            newOpt[key] = ConfigProto(opt, protoKey, deep + 1);
            return;
        }
        // On the first level all arrays are atomic
        if (deep !== 0 && (0,_checker_is_array_js__WEBPACK_IMPORTED_MODULE_6__/* .isArray */ .c)(opt) && !(0,_extend_js__WEBPACK_IMPORTED_MODULE_5__/* .isAtom */ .mA)(opt) && (0,_checker_is_array_js__WEBPACK_IMPORTED_MODULE_6__/* .isArray */ .c)(protoKey)) {
            newOpt[key] = [
                ...opt,
                ...protoKey.slice(opt.length)
            ];
            return;
        }
        newOpt[key] = opt;
    });
    Object.setPrototypeOf(newOpt, proto);
    return newOpt;
}
function ConfigFlatten(obj) {
    return (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .keys */ .HP)(obj, false).reduce((app, key)=>{
        app[key] = obj[key];
        return app;
    }, {});
}
/**
 * Returns a plain object from a prototype-based object.
 * ```typescript
 * const editor = Jodit.make('#editor', {
 *   image: {
 *     dialogWidth: 500
 *   }
 * });
 *
 * console.log(editor.o.image.openOnDblClick) // true
 * // But you can't get all options in plain object
 * console.log(JSON.stringify(editor.o.image)); // {"dialogWidth":500}
 *
 * const plain = Jodit.modules.Helpers.ConfigDeepFlatten(editor.o.image);
 * console.log(JSON.stringify(plain)); // {"dialogWidth":500, "openOnDblClick": true, "editSrc": true, ...}
 * ```
 */ function ConfigDeepFlatten(obj) {
    return (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .keys */ .HP)(obj, false).reduce((app, key)=>{
        app[key] = (0,_checker_is_plain_object_js__WEBPACK_IMPORTED_MODULE_4__/* .isPlainObject */ .Q)(obj[key]) ? ConfigDeepFlatten(obj[key]) : obj[key];
        return app;
    }, {});
}


/***/ }),

/***/ 69159:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'Type something': '輸入一些內容',
    Advanced: '進階',
    'About Jodit': '關於Jodit',
    'Jodit Editor': 'Jodit Editor',
    "Jodit User's Guide": '開發者指南',
    'contains detailed help for using': '使用幫助',
    'For information about the license, please go to our website:': '相關授權條款資訊，請造訪我們的網站：',
    'Buy full version': '購買完整版本',
    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.': 'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.',
    Anchor: '錨點',
    'Open in new tab': '在新分頁開啟',
    'Open in fullsize': '全螢幕編輯',
    'Clear Formatting': '清除樣式',
    'Fill color or set the text color': '顏色',
    Redo: '取消復原',
    Undo: '復原',
    Bold: '粗體',
    Italic: '斜體',
    'Insert Unordered List': '項目符號清單',
    'Insert Ordered List': '編號清單',
    'Align Center': '置中',
    'Align Justify': '文字對齊',
    'Align Left': '靠左',
    'Align Right': '靠右',
    'Insert Horizontal Line': '分割線',
    'Insert Image': '圖片',
    'Insert file': '檔案',
    'Insert youtube/vimeo video': '插入 youtube/vimeo 影片',
    'Insert link': '插入連結',
    'Font size': '文字大小',
    'Font family': '字型',
    'Insert format block': '格式化區塊',
    Normal: '內文',
    'Heading 1': '標題1',
    'Heading 2': '標題2',
    'Heading 3': '標題3',
    'Heading 4': '標題4',
    Quote: '引文',
    Code: '程式碼',
    Insert: '插入',
    'Insert table': '表格',
    'Decrease Indent': '減少縮排',
    'Increase Indent': '增加縮排',
    'Select Special Character': '選擇特殊符號',
    'Insert Special Character': '特殊符號',
    'Paint format': '格式複製',
    'Change mode': '檢視原始碼',
    Margins: '邊距',
    top: '上',
    right: '右',
    bottom: '下',
    left: '左',
    Styles: '樣式',
    Classes: 'Classes',
    Align: '對齊方式',
    Right: '靠右',
    Center: '置中',
    Left: '靠左',
    '--Not Set--': '無',
    Src: 'Src',
    Title: 'Title',
    Alternative: '替代',
    Link: 'Link',
    'Open link in new tab': '在新分頁開啟連結',
    Image: '圖片',
    file: '檔案',
    'Image properties': '圖片屬性',
    Cancel: '取消',
    Ok: '確定',
    'Your code is similar to HTML. Keep as HTML?': '您的程式碼與 HTML 類似，是否貼上 HTML 格式？',
    'Paste as HTML': '貼上 HTML',
    Keep: '保留原始格式',
    Clean: '清除格式',
    'Insert as Text': '以純文字貼上',
    'Word Paste Detected': '貼上 Word 格式',
    'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?': '正在貼上 Word/Excel 文件的內容，是否保留原始格式？',
    'Insert only Text': '僅貼上內文',
    'File Browser': '檔案瀏覽',
    'Error on load list': '清單載入錯誤',
    'Error on load folders': '資料夾載入錯誤',
    'Are you sure?': '您確定嗎？',
    'Enter Directory name': '輸入路徑',
    'Create directory': '創建路徑',
    'type name': 'type name',
    'Drop image': '拖曳圖片至此',
    'Drop file': '拖曳檔案至此',
    'or click': '或點擊',
    'Alternative text': '替代文字',
    Browse: '瀏覽',
    Upload: '上傳',
    Background: '背景色',
    Text: '文字',
    Top: '頂部',
    Middle: '中間',
    Bottom: '底部',
    'Insert column before': '插入左方欄',
    'Insert column after': '插入右方欄',
    'Insert row above': '插入上方列',
    'Insert row below': '插入下方列',
    'Delete table': '刪除表格',
    'Delete row': '刪除整列',
    'Delete column': '刪除整欄',
    'Empty cell': '清除內容',
    'Chars: %d': '字元數: %d',
    'Words: %d': '單字數: %d',
    'Strike through': '刪除線',
    Underline: '底線',
    superscript: '上標',
    subscript: '下標',
    'Cut selection': '剪下',
    'Select all': '全選',
    Break: '斷行',
    'Search for': '尋找',
    'Replace with': '取代為',
    Replace: '取代',
    Paste: '貼上',
    'Choose Content to Paste': '選擇內容並貼上',
    All: '全部',
    source: '原始碼',
    bold: '粗體',
    italic: '斜體',
    brush: '顏色',
    link: '連結',
    undo: '復原',
    redo: '取消復原',
    table: '表格',
    image: '圖片',
    eraser: '橡皮擦',
    paragraph: '段落',
    fontsize: '文字大小',
    video: '影片',
    font: '字型',
    about: '關於',
    print: '列印',
    underline: '底線',
    strikethrough: '刪除線',
    indent: '增加縮排',
    outdent: '減少縮排',
    fullsize: '全螢幕',
    shrink: '縮減',
    hr: '分隔線',
    ul: '項目符號清單',
    ol: '編號清單',
    cut: '剪下',
    selectall: '全選',
    'Open link': '打開連結',
    'Edit link': '編輯連結',
    'No follow': 'No follow',
    Unlink: '取消連結',
    Eye: '查看',
    ' URL': 'URL',
    Reset: '重設',
    Save: '儲存',
    'Save as ...': '另存為...',
    Resize: '調整大小',
    Crop: '裁切',
    Width: '寬',
    Height: '高',
    'Keep Aspect Ratio': '維持長寬比',
    Yes: '是',
    No: '否',
    Remove: '移除',
    Select: '選擇',
    'Select %s': '選擇: %s',
    Update: '更新',
    'Vertical align': '垂直對齊',
    Merge: '合併',
    'Add column': '新增欄',
    'Add row': '新增列',
    Border: '邊框',
    'Embed code': '嵌入程式碼',
    Delete: '刪除',
    'Horizontal align': '水平對齊',
    Filter: '篩選',
    'Sort by changed': '修改時間排序',
    'Sort by name': '名稱排序',
    'Sort by size': '大小排序',
    'Add folder': '新增資料夾',
    Split: '分割',
    'Split vertical': '垂直分割',
    'Split horizontal': '水平分割',
    'You can only edit your own images. Download this image on the host?': '您只能編輯您自己的圖片。是否下載此圖片?',
    'The image has been successfully uploaded to the host!': '圖片上傳成功',
    palette: '調色盤',
    pencil: '鉛筆',
    'There are no files': '沒有檔案',
    Rename: '重新命名',
    'Enter new name': '輸入新名稱',
    preview: '預覽',
    download: '下載',
    'Paste from clipboard': '從剪貼簿貼上',
    "Your browser doesn't support direct access to the clipboard.": '瀏覽器無法存取剪貼簿。',
    'Copy selection': '複製已選取項目',
    copy: '複製',
    'Border radius': '邊框圓角',
    'Show all': '顯示全部',
    Apply: '應用',
    'Please fill out this field': '請輸入此欄位',
    'Please enter a web address': '請輸入網址',
    Default: '預設',
    Circle: '圓圈',
    Dot: '點',
    Quadrate: '方形',
    Find: '尋找',
    'Find Previous': '尋找上一個',
    'Find Next': '尋找下一個',
    'Insert className': '插入 class 名稱',
    'Press Alt for custom resizing': '按住 Alt 以調整自訂大小'
});


/***/ }),

/***/ 69625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    'Line height': 'Висота лінії'
});


/***/ }),

/***/ 69874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    newline: '新行',
    delete: '删除',
    space: '空间',
    'Speech Recognize': '言语识别',
    Sound: '声音',
    'Interim Results': '中期业绩'
});


/***/ }),

/***/ 70022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   b: function() { return /* binding */ createSourceEditor; }
/* harmony export */ });
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21537);
/* harmony import */ var _engines_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52968);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

function createSourceEditor(type, editor, container, toWYSIWYG, fromWYSIWYG) {
    let sourceEditor;
    if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.isFunction)(type)) {
        sourceEditor = type(editor);
    } else {
        switch(type){
            case 'ace':
                if (!editor.o.shadowRoot) {
                    sourceEditor = new _engines_index_js__WEBPACK_IMPORTED_MODULE_1__/* .AceEditor */ .p(editor, container, toWYSIWYG, fromWYSIWYG);
                    break;
                }
            default:
                sourceEditor = new _engines_index_js__WEBPACK_IMPORTED_MODULE_1__/* .TextAreaEditor */ .S(editor, container, toWYSIWYG, fromWYSIWYG);
        }
    }
    sourceEditor.init(editor);
    sourceEditor.onReadyAlways(()=>{
        sourceEditor.setReadOnly(editor.o.readonly);
    });
    return sourceEditor;
}


/***/ }),

/***/ 70045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export indent */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22732);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43555);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54389);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(302);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 





const applyIndentToBox = (processedElements, currentBox, editor, command)=>{
    if (!currentBox) {
        return;
    }
    if (processedElements.has(currentBox)) {
        return;
    }
    const key = (0,_helpers_js__WEBPACK_IMPORTED_MODULE_5__/* .getKey */ .i)(editor.o.direction, currentBox);
    processedElements.add(currentBox);
    let value = currentBox.style[key] ? parseInt(currentBox.style[key], 10) : 0;
    value += editor.o.indentMargin * (command === 'outdent' ? -1 : 1);
    currentBox.style[key] = value > 0 ? value + 'px' : '';
    if (!(0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__/* .attr */ .CF)(currentBox, 'style')) {
        (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__/* .attr */ .CF)(currentBox, 'style', null);
    }
};
/**
 * Indents the line containing the selection or insertion point.
 */ function indent(editor) {
    editor.registerButton({
        name: 'indent',
        group: 'indent'
    }).registerButton({
        name: 'outdent',
        group: 'indent'
    });
    const indentCommand = (command)=>{
        const processedElements = new Set();
        const { enter, enterBlock } = editor.o;
        const isBrMode = enter.toLowerCase() === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.BR;
        const current = editor.s.current();
        if (isBrMode && editor.s.isCollapsed()) {
            if (current) {
                const box = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.wrapNextInline(current, enterBlock, editor);
                applyIndentToBox(processedElements, box, editor, command);
                return false;
            }
        }
        editor.s.eachSelection((current)=>{
            editor.s.save();
            let currentBox = current ? _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.up(current, _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isBlock, editor.editor) : false;
            if (!currentBox && current) {
                currentBox = (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__/* .call */ .T1)(!isBrMode ? _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.wrapInline : _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.wrapNextInline, current, !isBrMode ? enter.toLowerCase() : enterBlock, editor);
            }
            if (!currentBox) {
                editor.s.restore();
                return false;
            }
            applyIndentToBox(processedElements, currentBox, editor, command);
            editor.s.restore();
        });
        editor.synchronizeValues();
        return false;
    };
    editor.registerCommand('indent', {
        exec: indentCommand,
        hotkeys: [
            'ctrl+]',
            'cmd+]'
        ]
    });
    editor.registerCommand('outdent', {
        exec: indentCommand,
        hotkeys: [
            'ctrl+[',
            'cmd+['
        ]
    });
}
_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .pluginSystem */ .fg.add('indent', indent);


/***/ }),

/***/ 70071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   p: function() { return /* binding */ LazyWalker; }
/* harmony export */ });
/* harmony import */ var _decorators_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65478);
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _event_emitter_eventify_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72757);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



class LazyWalker extends _event_emitter_eventify_js__WEBPACK_IMPORTED_MODULE_2__/* .Eventify */ .h {
    setWork(root) {
        if (this.isWorked) {
            this.break();
        }
        this.workNodes = _dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.eachGen(root, !this.options.reverse);
        this.isFinished = false;
        this._requestStarting();
        return this;
    }
    _requestStarting() {
        this.__schedulerController = new AbortController();
        this.async.schedulerPostTask(this.__workPerform, {
            delay: this.options.timeout,
            signal: this.__schedulerController.signal
        }).catch(()=>null);
    }
    break(reason) {
        if (this.isWorked) {
            this.stop();
            this.emit('break', reason);
        }
    }
    end() {
        if (this.isWorked) {
            this.stop();
            this.emit('end', this.hadAffect);
            this.hadAffect = false;
        }
    }
    stop() {
        this.isWorked = false;
        this.isFinished = true;
        this.workNodes = null;
        this.async.cancelIdleCallback(this.idleId);
    }
    destruct() {
        super.destruct();
        this.stop();
    }
    __workPerform() {
        var _a;
        if (this.workNodes) {
            this.isWorked = true;
            let count = 0;
            const chunkSize = (_a = this.options.timeoutChunkSize) !== null && _a !== void 0 ? _a : 50;
            while(!this.isFinished && count <= chunkSize){
                const item = this.workNodes.next();
                count += 1;
                if (this.visitNode(item.value)) {
                    this.hadAffect = true;
                }
                if (item.done) {
                    this.end();
                    return;
                }
            }
        } else {
            this.end();
        }
        if (!this.isFinished) {
            this._requestStarting();
        }
    }
    visitNode(nodeElm) {
        var _a;
        if (!nodeElm || this.options.whatToShow !== undefined && nodeElm.nodeType !== this.options.whatToShow) {
            return false;
        }
        return (_a = this.emit('visit', nodeElm)) !== null && _a !== void 0 ? _a : false;
    }
    constructor(async, options = {}){
        super();
        this.async = async;
        this.options = options;
        this.workNodes = null;
        this.hadAffect = false;
        this.isWorked = false;
        this.isFinished = false;
        this.idleId = 0;
        this.__schedulerController = null;
    }
}
__decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], LazyWalker.prototype, "__workPerform", null);


/***/ }),

/***/ 70091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   V: function() { return /* binding */ normalizeRelativePath; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/normalize
 */ const normalizeRelativePath = (path)=>{
    const sections = path.split('/'), builder = sections.reduce((builder, section)=>{
        switch(section){
            case '':
                {
                    break;
                }
            case '.':
                {
                    break;
                }
            case '..':
                {
                    builder.pop();
                    break;
                }
            default:
                {
                    builder.push(section);
                    break;
                }
        }
        return builder;
    }, []);
    return builder.join('/') + (path.endsWith('/') ? '/' : '');
};


/***/ }),

/***/ 70190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    'Line height': 'ارتفاع خط'
});


/***/ }),

/***/ 70231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   z: function() { return /* binding */ Dlgs; }
/* harmony export */ });
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(580);
/* harmony import */ var _helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27613);
/* harmony import */ var _helpers_utils_utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37790);
/* harmony import */ var _modules_dialog_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(638);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



class Dlgs {
    dlg(options) {
        const popupRoot = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getPopupViewRoot */ .ef)(this.o, this.container, this.od.body);
        const dialog = new _modules_dialog_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Dialog */ .lG({
            language: this.o.language,
            shadowRoot: this.o.shadowRoot,
            popupRoot,
            ownerWindow: this.o.ownerWindow,
            defaultTimeout: this.o.defaultTimeout,
            direction: this.o.direction,
            theme: this.o.theme,
            globalFullSize: this.o.globalFullSize,
            ...options
        });
        (0,_helpers_utils_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .markOwner */ .b_)(this, dialog.container);
        dialog.parent = this;
        return dialog.bindDestruct(this);
    }
    confirm(msg, title, callback) {
        msg = processTitle(msg, this);
        title = processTitle(title, this);
        return _modules_dialog_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Confirm */ .pT.call(this.dlg({
            closeOnClickOverlay: true
        }), msg, title, callback);
    }
    prompt(msg, title, callback, placeholder, defaultValue) {
        msg = processTitle(msg, this);
        title = processTitle(title, this);
        placeholder = processTitle(placeholder, this);
        return _modules_dialog_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Prompt */ .XG.call(this.dlg({
            closeOnClickOverlay: true
        }), msg, title, callback, placeholder, defaultValue);
    }
    alert(msg, title, callback, className) {
        msg = processTitle(msg, this);
        title = processTitle(title, this);
        return _modules_dialog_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Alert */ .Fc.call(this.dlg({
            closeOnClickOverlay: true
        }), msg, title, callback, className);
    }
}
function processTitle(title, self) {
    if ((0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .Kg)(title) && !(0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isHTML */ .AH)(title)) {
        title = self.i18n(title);
    }
    return title;
}


/***/ }),

/***/ 70722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   a: function() { return /* binding */ isNativeFunction; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/checker
 */ /**
 * Check if function or method was not replaced on some custom implementation
 */ function isNativeFunction(f) {
    return Boolean(f) && (typeof f).toLowerCase() === 'function' && (f === Function.prototype || /^\s*function\s*(\b[a-z$_][a-z0-9$_]*\b)*\s*\((|([a-z$_][a-z0-9$_]*)(\s*,[a-z$_][a-z0-9$_]*)*)\)\s*{\s*\[native code]\s*}\s*$/i.test(String(f)));
}


/***/ }),

/***/ 70799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B: function() { return /* binding */ isStringArray; },
/* harmony export */   K: function() { return /* binding */ isString; }
/* harmony export */ });
/* harmony import */ var _is_array_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68345);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/checker
 */ 
/**
 * Check value is String
 */ function isString(value) {
    return typeof value === 'string';
}
/**
 * Check value is Array of String
 */ function isStringArray(value) {
    return (0,_is_array_js__WEBPACK_IMPORTED_MODULE_0__/* .isArray */ .c)(value) && isString(value[0]);
}


/***/ }),

/***/ 70824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    Spellcheck: 'Verificação ortográfica'
});


/***/ }),

/***/ 70945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    symbols: 'תו מיוחד'
});


/***/ }),

/***/ 71042:
/***/ (function(__unused_webpack_module, __webpack_exports__) {


/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'copy-format': 'opmaak kopiëren'
});


/***/ }),

/***/ 71255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export classSpan */
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_utils_utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37790);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50911);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6441);
/* harmony import */ var _class_span_svg_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31151);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 






_config_js__WEBPACK_IMPORTED_MODULE_5__/* .Config */ .T.prototype.controls.classSpan = {
    command: 'applyClassName',
    exec: _core_helpers_utils_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .memorizeExec */ .qN,
    list: [
        'enabled',
        'disabled',
        'activated',
        'text-left',
        'text-center',
        'text-right',
        'warning',
        'error'
    ],
    isChildActive: (editor, button)=>{
        const current = editor.s.current();
        if (current) {
            const currentBpx = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(current, _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isElement, editor.editor) || editor.editor;
            return Boolean(button.control.args && currentBpx.classList.contains(button.control.args[0].toString()));
        }
        return false;
    },
    isActive: (editor, btn)=>{
        const current = editor.s.current();
        if (current) {
            const currentBpx = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(current, _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isElement, editor.editor) || editor.editor;
            let present = false;
            btn.control.list && Object.keys(btn.control.list).forEach((className)=>{
                if (currentBpx.classList.contains(className)) {
                    present = true;
                }
            });
            return Boolean(currentBpx && currentBpx !== editor.editor && btn.control.list !== undefined && present);
        }
        return false;
    },
    childTemplate: (e, key, value)=>`<span class="${key}">${e.i18n(value)}</span>`,
    tooltip: 'Insert className'
};
/**
 * Applying some className to selected text.
 * @example
 * ```js
 * const editor = Jodit.make('#editor', {
 *	controls: {
 *		classSpan: {
 *			list: {
 *				class1: 'Classe 1',
 *				class2: 'Classe 2',
 *				class3: 'Classe 3',
 *				class4: 'Classe 4',
 *				class5: 'Classe 5'
 *			}
 *		}
 *	}
 * });
 * ```
 */ class classSpan extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Plugin */ .k {
    /** @override */ afterInit(jodit) {
        jodit.registerCommand('applyClassName', (command, second, third)=>{
            jodit.s.commitStyle({
                attributes: {
                    ['class']: third
                }
            });
            return false;
        });
    }
    /** @override */ beforeDestruct() {}
    constructor(){
        super(...arguments);
        /** @override */ this.buttons = [
            {
                name: 'classSpan',
                group: 'script'
            }
        ];
    }
}
_core_global_js__WEBPACK_IMPORTED_MODULE_1__/* .pluginSystem */ .fg.add('classSpan', classSpan);
_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .I.set('class-span', _class_span_svg_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A);


/***/ }),

/***/ 71262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Q: function() { return /* binding */ getStrongControlTypes; }
/* harmony export */ });
/* harmony import */ var _helpers_checker_is_array_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68345);
/* harmony import */ var _helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43555);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6441);
/* harmony import */ var _get_control_type_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72157);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



/**
 * @private
 */ function getStrongControlTypes(items, controls) {
    const elements = (0,_helpers_checker_is_array_js__WEBPACK_IMPORTED_MODULE_3__/* .isArray */ .c)(items) ? items : (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_0__/* .keys */ .HP)(items, false).map((key)=>{
        const value = items[key] || {};
        return (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_0__/* .ConfigProto */ .tb)({
            name: key
        }, value);
    });
    return elements.map((item)=>(0,_get_control_type_js__WEBPACK_IMPORTED_MODULE_2__/* .getControlType */ .U)(item, controls || _config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.defaultOptions.controls));
}


/***/ }),

/***/ 71521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $2: function() { return /* reexport safe */ _normalize_color_js__WEBPACK_IMPORTED_MODULE_0__.$; },
/* harmony export */   Fd: function() { return /* reexport safe */ _normalize_path_js__WEBPACK_IMPORTED_MODULE_4__.F; },
/* harmony export */   Vd: function() { return /* reexport safe */ _normalize_relative_path_js__WEBPACK_IMPORTED_MODULE_5__.V; },
/* harmony export */   b$: function() { return /* reexport safe */ _normalize_css_value_js__WEBPACK_IMPORTED_MODULE_1__.b$; },
/* harmony export */   f: function() { return /* reexport safe */ _normalize_license_js__WEBPACK_IMPORTED_MODULE_3__.f; },
/* harmony export */   iy: function() { return /* reexport safe */ _normalize_css_value_js__WEBPACK_IMPORTED_MODULE_1__.iy; },
/* harmony export */   jB: function() { return /* reexport safe */ _normalize_key_aliases_js__WEBPACK_IMPORTED_MODULE_2__.j; },
/* harmony export */   l2: function() { return /* reexport safe */ _normalize_url_js__WEBPACK_IMPORTED_MODULE_7__.l; },
/* harmony export */   n8: function() { return /* reexport safe */ _normalize_css_value_js__WEBPACK_IMPORTED_MODULE_1__.n8; },
/* harmony export */   rn: function() { return /* reexport safe */ _normalize_size_js__WEBPACK_IMPORTED_MODULE_6__.r; }
/* harmony export */ });
/* harmony import */ var _normalize_color_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21224);
/* harmony import */ var _normalize_css_value_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3760);
/* harmony import */ var _normalize_key_aliases_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49033);
/* harmony import */ var _normalize_license_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12972);
/* harmony import */ var _normalize_path_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9992);
/* harmony import */ var _normalize_relative_path_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70091);
/* harmony import */ var _normalize_size_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46334);
/* harmony import */ var _normalize_url_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37406);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/normalize
 */ 









/***/ }),

/***/ 71568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   F: function() { return /* binding */ Alert; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _core_helpers_array_as_array_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29999);
/* harmony import */ var _core_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23282);
/* harmony import */ var _core_ui_button_button_button_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10830);
/* harmony import */ var _dialog_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78584);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 




/**
 * Show `alert` dialog. Work without Jodit object
 * @example
 * ```javascript
 * Jodit.Alert("File was uploaded");
 * Jodit.Alert("File was uploaded", "Message");
 * Jodit.Alert("File was uploaded", function() {
 *    $('form').hide();
 * });
 * Jodit.Alert("File wasn't uploaded", "Error", function() {
 *    $('form').hide();
 * });
 * ```
 */ function Alert(msg, title, callback, className = 'jodit-dialog_alert') {
    if ((0,_core_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_3__/* .isFunction */ .T)(title)) {
        callback = title;
        title = undefined;
    }
    const dialog = this instanceof _dialog_js__WEBPACK_IMPORTED_MODULE_2__/* .Dialog */ .l ? this : new _dialog_js__WEBPACK_IMPORTED_MODULE_2__/* .Dialog */ .l({
        closeOnClickOverlay: true
    }), container = dialog.c.div(className), okButton = (0,_core_ui_button_button_button_js__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .$n)(dialog, 'ok', 'Ok');
    (0,_core_helpers_array_as_array_js__WEBPACK_IMPORTED_MODULE_4__/* .asArray */ ._)(msg).forEach((oneMessage)=>{
        container.appendChild(_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isNode(oneMessage) ? oneMessage : dialog.c.fromHTML(oneMessage));
    });
    okButton.onAction(()=>{
        if (!callback || !(0,_core_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_3__/* .isFunction */ .T)(callback) || callback(dialog) !== false) {
            dialog.close();
        }
    });
    dialog.setFooter([
        okButton
    ]);
    dialog.open(container, title || '&nbsp;', true, true);
    okButton.focus();
    return dialog;
}


/***/ }),

/***/ 71675:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.allowResizeTags = new Set([
    'img',
    'iframe',
    'table',
    'jodit'
]);
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.resizer = {
    showSize: true,
    hideSizeTimeout: 1000,
    forImageChangeAttributes: true,
    min_width: 10,
    min_height: 10,
    useAspectRatio: new Set([
        'img'
    ])
};


/***/ }),

/***/ 71686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $: function() { return /* binding */ ajaxInstances; },
/* harmony export */   t: function() { return /* binding */ send; }
/* harmony export */ });
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21537);
/* harmony import */ var _core_request_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41601);
/* harmony import */ var _build_data_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83987);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


const ajaxInstances = new WeakMap();
function send(uploader, data) {
    const requestData = (0,_build_data_js__WEBPACK_IMPORTED_MODULE_2__/* .buildData */ .$)(uploader, data);
    const sendData = (request)=>{
        const ajax = new _core_request_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Ajax */ .d({
            xhr: ()=>{
                const xhr = new XMLHttpRequest();
                if (uploader.j.ow.FormData !== undefined && xhr.upload) {
                    uploader.j.progressbar.show().progress(10);
                    xhr.upload.addEventListener('progress', (evt)=>{
                        if (evt.lengthComputable) {
                            let percentComplete = evt.loaded / evt.total;
                            percentComplete *= 100;
                            uploader.j.progressbar.show().progress(percentComplete);
                            if (percentComplete >= 100) {
                                uploader.j.progressbar.hide();
                            }
                        }
                    }, false);
                } else {
                    uploader.j.progressbar.hide();
                }
                return xhr;
            },
            method: uploader.o.method || 'POST',
            data: request,
            url: (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.isFunction)(uploader.o.url) ? uploader.o.url(request) : uploader.o.url,
            headers: uploader.o.headers,
            queryBuild: uploader.o.queryBuild,
            contentType: uploader.o.contentType.call(uploader, request),
            withCredentials: uploader.o.withCredentials || false
        });
        let instances = ajaxInstances.get(uploader);
        if (!instances) {
            instances = new Set();
            ajaxInstances.set(uploader, instances);
        }
        instances.add(ajax);
        uploader.j.e.one('beforeDestruct', ajax.destruct);
        return ajax.send().then((resp)=>resp.json()).catch((error)=>{
            return {
                success: false,
                data: {
                    messages: [
                        error
                    ]
                }
            };
        }).finally(()=>{
            ajax.destruct();
            instances === null || instances === void 0 ? void 0 : instances.delete(ajax);
        });
    };
    if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.isPromise)(requestData)) {
        return requestData.then(sendData).catch((error)=>{
            uploader.o.error.call(uploader, error);
        });
    }
    return sendData(requestData);
}


/***/ }),

/***/ 71705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    newline: 'الخط الجديد',
    delete: 'حذف',
    space: 'الفضاء',
    'Speech Recognize': 'التعرف على الكلام',
    Sound: 'الصوت',
    'Interim Results': 'النتائج المؤقتة'
});


/***/ }),

/***/ 71724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    'Line height': 'Zeilenhöhe'
});


/***/ }),

/***/ 71842:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.askBeforePasteFromWord = true;
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.processPasteFromWord = true;
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.defaultActionOnPasteFromWord = null;
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.pasteFromWordActionList = [
    {
        value: _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INSERT_AS_HTML,
        text: 'Keep'
    },
    {
        value: _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INSERT_AS_TEXT,
        text: 'Clean'
    },
    {
        value: _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INSERT_ONLY_TEXT,
        text: 'Insert only Text'
    }
];


/***/ }),

/***/ 71916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   s: function() { return /* binding */ UIButtonGroup; }
/* harmony export */ });
/* harmony import */ var _decorators_component_component_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87325);
/* harmony import */ var _helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38837);
/* harmony import */ var _button_button_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10830);
/* harmony import */ var _group_group_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62405);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let UIButtonGroup = class UIButtonGroup extends _group_group_js__WEBPACK_IMPORTED_MODULE_2__/* .UIGroup */ .U {
    /** @override */ className() {
        return 'UIButtonGroup';
    }
    /** @override */ render(options) {
        return `<div>
			<div class="&__label">~${options.label}~</div>
			<div class="&__options"></div>
		</div>`;
    }
    /** @override */ appendChildToContainer(childContainer) {
        const options = this.getElm('options');
        (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_0__/* .assert */ .v)(options != null, 'Options does not exist');
        options.appendChild(childContainer);
    }
    select(indexOrValue) {
        var _a, _b;
        this.elements.forEach((elm, index)=>{
            if (index === indexOrValue || elm.state.value === indexOrValue) {
                elm.state.activated = true;
            } else if (this.options.radio) {
                elm.state.activated = false;
            }
        });
        const result = this.elements.filter((elm)=>elm.state.activated).map((elm)=>({
                text: elm.state.text,
                value: elm.state.value
            }));
        this.jodit.e.fire(this, 'select', result);
        (_b = (_a = this.options).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, result);
    }
    constructor(jodit, options = {
        radio: true
    }){
        var _a, _b;
        super(jodit, (_a = options.options) === null || _a === void 0 ? void 0 : _a.map((opt)=>{
            const btn = new _button_button_js__WEBPACK_IMPORTED_MODULE_1__/* .UIButton */ .lD(jodit, {
                text: opt.text,
                value: opt.value,
                variant: 'primary'
            });
            btn.onAction(()=>{
                this.select(opt.value);
            });
            return btn;
        }), options);
        this.options = options;
        this.select((_b = options.value) !== null && _b !== void 0 ? _b : 0);
    }
};
UIButtonGroup = __decorate([
    _decorators_component_component_js__WEBPACK_IMPORTED_MODULE_3__/* .component */ .s
], UIButtonGroup);



/***/ }),

/***/ 72144:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 24 24\"> <g transform=\"translate(-251.000000, -443.000000)\"> <g transform=\"translate(215.000000, 119.000000)\"/> <path d=\"M252,448 L256,448 L256,444 L252,444 L252,448 Z M257,448 L269,448 L269,446 L257,446 L257,448 Z M257,464 L269,464 L269,462 L257,462 L257,464 Z M270,444 L270,448 L274,448 L274,444 L270,444 Z M252,462 L252,466 L256,466 L256,462 L252,462 Z M270,462 L270,466 L274,466 L274,462 L270,462 Z M254,461 L256,461 L256,449 L254,449 L254,461 Z M270,461 L272,461 L272,449 L270,449 L270,461 Z\"/> </g> </svg> ");


/***/ }),

/***/ 72157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   U: function() { return /* binding */ getControlType; },
/* harmony export */   x: function() { return /* binding */ findControlType; }
/* harmony export */ });
/* harmony import */ var _helpers_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21537);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/**
 * Get control for button name
 * @private
 */ function getControlType(button, controls) {
    let buttonControl;
    if (!controls) {
        controls = _config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.defaultOptions.controls;
    }
    if (!(0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.isString)(button)) {
        buttonControl = {
            name: 'empty',
            ...(0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.ConfigFlatten)(button)
        };
        if (controls[buttonControl.name] !== undefined) {
            buttonControl = {
                ...(0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.ConfigFlatten)(controls[buttonControl.name]),
                ...(0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.ConfigFlatten)(buttonControl)
            };
        }
    } else {
        buttonControl = findControlType(button, controls) || {
            name: button,
            command: button,
            tooltip: button
        };
    }
    return buttonControl;
}
/**
 * @private
 */ function findControlType(path, controls) {
    // eslint-disable-next-line prefer-const
    let [namespaceOrKey, key] = path.split(/\./);
    let store = controls;
    if (key != null) {
        if (controls[namespaceOrKey] !== undefined) {
            store = controls[namespaceOrKey];
        }
    } else {
        key = namespaceOrKey;
    }
    // const list = store[key]?.list;
    return store[key] ? {
        name: key,
        ...(0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.ConfigFlatten)(store[key])
    } : undefined;
}


/***/ }),

/***/ 72253:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22732);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70799);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50911);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96967);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






/**
 * Wrap single text nodes in block wrapper
 */ class wrapNodes extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Plugin */ .k {
    /** @override **/ afterInit(jodit) {
        if (jodit.o.enter.toLowerCase() === 'br') {
            return;
        }
        jodit.e.on('drop.wtn focus.wtn keydown.wtn mousedown.wtn afterInit.wtn backSpaceAfterDelete.wtn', this.preprocessInput, {
            top: true
        }).on('afterInit.wtn postProcessSetEditorValue.wtn afterCommitStyle.wtn backSpaceAfterDelete.wtn', this.postProcessSetEditorValue);
    }
    /** @override **/ beforeDestruct(jodit) {
        jodit.e.off('.wtn');
    }
    /**
     * Process changed value
     */ postProcessSetEditorValue() {
        const { jodit } = this;
        if (!jodit.isEditorMode()) {
            return;
        }
        let child = jodit.editor.firstChild, isChanged = false;
        while(child){
            child = checkAloneListLeaf(child, jodit);
            if (this.isSuitableStart(child)) {
                if (!isChanged) {
                    jodit.s.save();
                }
                isChanged = true;
                const box = jodit.createInside.element(jodit.o.enter);
                _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.before(child, box);
                while(child && this.isSuitable(child)){
                    const next = child.nextSibling;
                    box.appendChild(child);
                    child = next;
                }
                box.normalize();
                child = box;
            }
            child = child && child.nextSibling;
        }
        if (isChanged) {
            jodit.s.restore();
            if (jodit.e.current === 'afterInit') {
                jodit.e.fire('internalChange');
            }
        }
    }
    /**
     * Process input without parent box
     */ preprocessInput() {
        const { jodit } = this, isAfterInitEvent = jodit.e.current === 'afterInit';
        if (!jodit.isEditorMode() || jodit.editor.firstChild || !jodit.o.wrapNodes.emptyBlockAfterInit && isAfterInitEvent) {
            return;
        }
        const box = jodit.createInside.element(jodit.o.enter);
        const br = jodit.createInside.element('br');
        _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.append(box, br);
        _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.append(jodit.editor, box);
        jodit.s.isFocused() && jodit.s.setCursorBefore(br);
        jodit.e.fire('internalChange');
    }
    constructor(){
        super(...arguments);
        /**
         * Found Node which should be wrapped
         */ this.isSuitableStart = (n)=>{
            var _a;
            return _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isText(n) && (0,_core_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_5__/* .isString */ .K)(n.nodeValue) && (/[^\s]/.test(n.nodeValue) || ((_a = n.parentNode) === null || _a === void 0 ? void 0 : _a.firstChild) === n && this.isSuitable(n.nextSibling)) || this.isNotWrapped(n) && !_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTemporary(n);
        };
        /**
         * Node should add in a block element
         */ this.isSuitable = (n)=>_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isText(n) || this.isNotWrapped(n);
        /**
         * Some element which needs to append in block
         */ this.isNotWrapped = (n)=>_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isElement(n) && !(_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isBlock(n) || _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(n, this.j.o.wrapNodes.exclude));
    }
}
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], wrapNodes.prototype, "postProcessSetEditorValue", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], wrapNodes.prototype, "preprocessInput", null);
function checkAloneListLeaf(child, jodit) {
    let result = child;
    let next = child;
    do {
        if (_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isElement(next) && _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isLeaf(next) && !_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isList(next.parentElement)) {
            const nextChild = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.findNotEmptySibling(next, false);
            if (_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(result, 'ul')) {
                result.appendChild(next);
            } else {
                result = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.wrap(next, 'ul', jodit.createInside);
            }
            next = nextChild;
        } else {
            break;
        }
    }while (next)
    return result;
}
_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .pluginSystem */ .fg.add('wrapNodes', wrapNodes);


/***/ }),

/***/ 72337:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1600 736v192q0 40-28 68t-68 28h-1216q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h1216q40 0 68 28t28 68z\"/> </svg> ");


/***/ }),

/***/ 72392:
/***/ (function(__unused_webpack_module, __webpack_exports__) {


/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'copy-format': 'Kopírovat formát'
});


/***/ }),

/***/ 72430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Q: function() { return /* binding */ isPlainObject; }
/* harmony export */ });
/* harmony import */ var _is_window_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52742);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/**
 * Check if element is simple plaint object
 */ function isPlainObject(obj) {
    if (!obj || typeof obj !== 'object' || obj.nodeType || (0,_is_window_js__WEBPACK_IMPORTED_MODULE_0__/* .isWindow */ .l)(obj)) {
        return false;
    }
    return !(obj.constructor && !({}).hasOwnProperty.call(obj.constructor.prototype, 'isPrototypeOf'));
}


/***/ }),

/***/ 72439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export tableKeyboardNavigation */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21537);
/* harmony import */ var _modules_table_table_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76014);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 




const WORK_KEYS = new Set([
    _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_TAB,
    _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_LEFT,
    _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_RIGHT,
    _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_UP,
    _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_DOWN
]);
/**
 * Process navigates key pressing in table cell
 */ function tableKeyboardNavigation(editor) {
    editor.e.off('.tableKeyboardNavigation').on('keydown.tableKeyboardNavigation', (event)=>{
        const { key } = event;
        const cell = findCell(editor, key);
        if (!cell) {
            return;
        }
        const tableModule = editor.getInstance(_modules_table_table_js__WEBPACK_IMPORTED_MODULE_4__/* .Table */ .X, editor.o);
        const table = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.closest(cell, 'table', editor.editor);
        let next = null;
        const isPrev = key === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_LEFT || event.shiftKey;
        const getNextCell = ()=>(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.call)(isPrev ? _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.prev : _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.next, cell, _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isCell, table);
        switch(key){
            case _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_TAB:
            case _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_LEFT:
                {
                    next = getNextCell();
                    if (!next) {
                        tableModule.appendRow(table, !isPrev ? false : table.querySelector('tr'), !isPrev);
                        next = getNextCell();
                    }
                    break;
                }
            case _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_UP:
            case _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_DOWN:
                {
                    const matrix = tableModule.formalMatrix(table);
                    const [row, column] = tableModule.formalCoordinate(table, cell);
                    if (key === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_UP) {
                        if (matrix[row - 1] !== undefined) {
                            next = matrix[row - 1][column];
                        }
                    } else {
                        if (matrix[row + 1] !== undefined) {
                            next = matrix[row + 1][column];
                        }
                    }
                }
                break;
        }
        if (!next) {
            return;
        }
        editor.e.fire('hidePopup hideResizer');
        if (!next.firstChild) {
            const first = editor.createInside.element('br');
            next.appendChild(first);
            editor.s.setCursorBefore(first);
        } else {
            if (key === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_TAB) {
                editor.s.select(next, true);
            } else {
                editor.s.setCursorIn(next, key === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_RIGHT || key === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_DOWN);
            }
        }
        editor.synchronizeValues();
        return false;
    });
}
_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .pluginSystem */ .fg.add('tableKeyboardNavigation', tableKeyboardNavigation);
function findCell(editor, key) {
    if (!WORK_KEYS.has(key)) {
        return;
    }
    const current = editor.s.current();
    if (!current) {
        return;
    }
    const cell = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.up(current, _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isCell, editor.editor);
    if (!cell) {
        return;
    }
    const { range } = editor.s;
    if (key !== _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_TAB && current !== cell) {
        const isNextDirection = key === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_RIGHT || key === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_DOWN;
        const hasNext = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.call)(!isNextDirection ? _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.prev : _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.next, current, (elm)=>key === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_UP || key === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_DOWN ? _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(elm, 'br') : Boolean(elm), cell);
        if (!isNextDirection && (hasNext || key !== _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_UP && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isText(current) && range.startOffset !== 0) || isNextDirection && (hasNext || key !== _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_DOWN && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isText(current) && current.nodeValue && range.startOffset !== current.nodeValue.length)) {
            return;
        }
    }
    return cell;
}


/***/ }),

/***/ 72757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   h: function() { return /* binding */ Eventify; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * Class for adding event handling capability
 *
 * ```ts
 * class SomeClass extends Eventify<{ start: (node: Node) => boolean; }> {
 * 	constructor() {
 * 		super();
 * 		setTimeout(() => {
 * 			if (this.emit('start', document.body)) {
 * 				console.log('yes');
 * 			};
 * 		}, 100);
 * 	}
 * }
 *
 * const sm = new SomeClass();
 * sm.on('start', (node) => {
 * 	console.log(node);
 * 	return true;
 * })
 * ```
 */ class Eventify {
    on(name, func) {
        var _a;
        if (!this.__map.has(name)) {
            this.__map.set(name, new Set());
        }
        (_a = this.__map.get(name)) === null || _a === void 0 ? void 0 : _a.add(func);
        return this;
    }
    off(name, func) {
        var _a;
        if (this.__map.has(name)) {
            (_a = this.__map.get(name)) === null || _a === void 0 ? void 0 : _a.delete(func);
        }
        return this;
    }
    destruct() {
        this.__map.clear();
    }
    emit(name, ...args) {
        var _a;
        let result;
        if (this.__map.has(name)) {
            (_a = this.__map.get(name)) === null || _a === void 0 ? void 0 : _a.forEach((cb)=>{
                result = cb(...args);
            });
        }
        return result;
    }
    constructor(){
        this.__map = new Map();
    }
}


/***/ }),

/***/ 72913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   E: function() { return /* binding */ isInt; }
/* harmony export */ });
/* harmony import */ var _is_numeric_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29807);
/* harmony import */ var _is_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70799);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/checker
 */ 

/**
 * Check value is Int
 */ function isInt(value) {
    if ((0,_is_string_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .K)(value) && (0,_is_numeric_js__WEBPACK_IMPORTED_MODULE_1__/* .isNumeric */ .k)(value)) {
        value = parseFloat(value);
    }
    return typeof value === 'number' && Number.isFinite(value) && !(value % 1);
}


/***/ }),

/***/ 73026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   s: function() { return /* binding */ observable; }
/* harmony export */ });
/* harmony import */ var _decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37133);
/* harmony import */ var _helpers_checker_is_array_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68345);
/* harmony import */ var _helpers_checker_is_equal_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59292);
/* harmony import */ var _helpers_checker_is_plain_object_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72430);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



const OBSERVABLE_OBJECT = Symbol('observable-object');
function isObservableObject(obj) {
    return obj[OBSERVABLE_OBJECT] !== undefined;
}
/**
 * Makes any object an observable object
 * @example
 * ```js
 * const obj = {
 *   a: 1,
 *   b: {
 *     c: 5
 *   }
 * }
 *
 * const obsObj = Jodit.modules.observable(obj);
 * console.log(obj === obsObj); // true
 * obsObj.on('change', () => {
 *   console.log('Object changed');
 * });
 * obsObj.on('change.a', () => {
 *   console.log('Key a changed');
 * });
 * obsObj.on('change.b.c', () => {
 *   console.log('Key b.c changed');
 * });
 *
 * obj.a = 6;
 * // Object changed
 * // Key a changed
 *
 * obj.b = {c: 6}
 * // Object changed
 *
 * obj.b.c = 8
 * // Object changed
 * // Key b.c changed
 * ```
 */ function observable(obj) {
    if (isObservableObject(obj)) {
        return obj;
    }
    const __lockEvent = {};
    const __onEvents = {};
    const on = (event, callback)=>{
        if ((0,_helpers_checker_is_array_js__WEBPACK_IMPORTED_MODULE_1__/* .isArray */ .c)(event)) {
            event.map((e)=>on(e, callback));
            return obj;
        }
        if (!__onEvents[event]) {
            __onEvents[event] = [];
        }
        __onEvents[event].push(callback);
        return obj;
    };
    const fire = (event, ...attr)=>{
        if ((0,_helpers_checker_is_array_js__WEBPACK_IMPORTED_MODULE_1__/* .isArray */ .c)(event)) {
            event.map((e)=>fire(e, ...attr));
            return;
        }
        try {
            if (!__lockEvent[event] && __onEvents[event]) {
                __lockEvent[event] = true;
                __onEvents[event].forEach((clb)=>clb.call(obj, ...attr));
            }
        } finally{
            __lockEvent[event] = false;
        }
    };
    const initAccessors = (dict, prefixes = [])=>{
        const store = {};
        if (isObservableObject(dict)) {
            return;
        }
        Object.defineProperty(dict, OBSERVABLE_OBJECT, {
            enumerable: false,
            value: true
        });
        Object.keys(dict).forEach((_key)=>{
            const key = _key;
            const prefix = prefixes.concat(key).filter((a)=>a.length);
            store[key] = dict[key];
            const descriptor = (0,_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_0__/* .getPropertyDescriptor */ .N)(dict, key);
            Object.defineProperty(dict, key, {
                set: (value)=>{
                    const oldValue = store[key];
                    if (!(0,_helpers_checker_is_equal_js__WEBPACK_IMPORTED_MODULE_2__/* .isFastEqual */ .P)(store[key], value)) {
                        fire([
                            'beforeChange',
                            `beforeChange.${prefix.join('.')}`
                        ], key, value);
                        if ((0,_helpers_checker_is_plain_object_js__WEBPACK_IMPORTED_MODULE_3__/* .isPlainObject */ .Q)(value)) {
                            initAccessors(value, prefix);
                        }
                        if (descriptor && descriptor.set) {
                            descriptor.set.call(obj, value);
                        } else {
                            store[key] = value;
                        }
                        const sum = [];
                        fire([
                            'change',
                            ...prefix.reduce((rs, p)=>{
                                sum.push(p);
                                rs.push(`change.${sum.join('.')}`);
                                return rs;
                            }, [])
                        ], prefix.join('.'), oldValue, (value === null || value === void 0 ? void 0 : value.valueOf) ? value.valueOf() : value);
                    }
                },
                get: ()=>{
                    if (descriptor && descriptor.get) {
                        return descriptor.get.call(obj);
                    }
                    return store[key];
                },
                enumerable: true,
                configurable: true
            });
            if ((0,_helpers_checker_is_plain_object_js__WEBPACK_IMPORTED_MODULE_3__/* .isPlainObject */ .Q)(store[key])) {
                initAccessors(store[key], prefix);
            }
        });
        Object.defineProperty(obj, 'on', {
            value: on
        });
    };
    initAccessors(obj);
    return obj;
}


/***/ }),

/***/ 73220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    Spellcheck: 'Controllo ortografico'
});


/***/ }),

/***/ 73391:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21537);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6441);
/* harmony import */ var _about_svg_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49399);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 






_config_js__WEBPACK_IMPORTED_MODULE_4__/* .Config */ .T.prototype.controls.about = {
    exec: (editor)=>{
        const dialog = editor.dlg({
            closeOnClickOverlay: true
        }), i = editor.i18n.bind(editor);
        dialog.setMod('theme', editor.o.theme).setHeader(i('About Jodit')).setContent(`<div class="jodit-about">
					<div>${i('Jodit Editor')} v.${editor.getVersion()}</div>
					<div>${i('License: %s', !(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.isLicense)(editor.o.license) ? 'MIT' : (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.normalizeLicense)(editor.o.license))}</div>
					<div>
						<a href="${_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.HOMEPAGE}" target="_blank">${_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.HOMEPAGE}</a>
					</div>
					<div>
						<a href="https://xdsoft.net/jodit/docs/" target="_blank">${i("Jodit User's Guide")}</a>
						${i('contains detailed help for using')}
					</div>
					<div>${i('Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.')}</div>
				</div>`);
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.css)(dialog.dialog, {
            minHeight: 200,
            minWidth: 420
        });
        dialog.open(true, true);
    },
    tooltip: 'About Jodit',
    mode: _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_SOURCE + _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_WYSIWYG
};
function about(editor) {
    editor.registerButton({
        name: 'about',
        group: 'info'
    });
}
_core_global_js__WEBPACK_IMPORTED_MODULE_1__/* .pluginSystem */ .fg.add('about', about);
_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .I.set('about', _about_svg_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A);


/***/ }),

/***/ 73674:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.controls.subscript = {
    tags: [
        'sub'
    ],
    tooltip: 'subscript'
};
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.controls.superscript = {
    tags: [
        'sup'
    ],
    tooltip: 'superscript'
};
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.controls.bold = {
    tagRegExp: /^(strong|b)$/i,
    tags: [
        'strong',
        'b'
    ],
    css: {
        'font-weight': [
            'bold',
            '700'
        ]
    },
    tooltip: 'Bold'
};
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.controls.italic = {
    tagRegExp: /^(em|i)$/i,
    tags: [
        'em',
        'i'
    ],
    css: {
        'font-style': 'italic'
    },
    tooltip: 'Italic'
};
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.controls.underline = {
    tagRegExp: /^(u)$/i,
    tags: [
        'u'
    ],
    css: {
        'text-decoration-line': 'underline'
    },
    tooltip: 'Underline'
};
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.controls.strikethrough = {
    tagRegExp: /^(s)$/i,
    tags: [
        's'
    ],
    css: {
        'text-decoration-line': 'line-through'
    },
    tooltip: 'Strike through'
};


/***/ }),

/***/ 73792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   H: function() { return /* binding */ checkRemoveChar; }
/* harmony export */ });
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22732);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21537);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63785);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



/**
 * Check possibility the char can be removed
 *
 * @example
 * ```html
 * te|st
 * ```
 * result
 * ```html
 * t|st
 * ```
 * @private
 */ // eslint-disable-next-line complexity
function checkRemoveChar(jodit, fakeNode, backspace, mode) {
    var _a, _b;
    const step = backspace ? -1 : 1;
    const anotherSibling = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.sibling(fakeNode, !backspace);
    let sibling = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.sibling(fakeNode, backspace);
    let removeNeighbor = null;
    let charRemoved = false;
    let removed;
    if (!sibling) {
        sibling = getNextInlineSibling(fakeNode, backspace, jodit.editor);
    }
    while(sibling && (_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isText(sibling) || _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isInlineBlock(sibling))){
        while(_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isInlineBlock(sibling)){
            sibling = backspace ? sibling === null || sibling === void 0 ? void 0 : sibling.lastChild : sibling === null || sibling === void 0 ? void 0 : sibling.firstChild;
        }
        if (!sibling) {
            break;
        }
        if ((_a = sibling.nodeValue) === null || _a === void 0 ? void 0 : _a.length) {
            removed = tryRemoveChar(sibling, backspace, step, anotherSibling);
            if (!sibling.nodeValue.length && _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isInlineBlock(sibling.parentNode)) {
                sibling.nodeValue = _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE;
            }
        }
        if (!((_b = sibling.nodeValue) === null || _b === void 0 ? void 0 : _b.length)) {
            removeNeighbor = sibling;
        }
        if (!(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.isVoid)(removed) && removed !== _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE) {
            checkRepeatRemoveCharAction(backspace, sibling, fakeNode, mode, removed, jodit);
            charRemoved = true;
            break;
        }
        const nextSibling = getNextInlineSibling(sibling, backspace, jodit.editor);
        if (removeNeighbor) {
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(removeNeighbor);
            removeNeighbor = null;
        }
        sibling = nextSibling;
    }
    if (removeNeighbor) {
        _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(removeNeighbor);
        removeNeighbor = null;
    }
    if (charRemoved) {
        removeEmptyForParent(fakeNode, 'a');
        addBRInsideEmptyBlock(jodit, fakeNode);
        jodit.s.setCursorBefore(fakeNode);
        if (_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(fakeNode.previousSibling, 'br') && !_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.findNotEmptySibling(fakeNode, false)) {
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.after(fakeNode, jodit.createInside.element('br'));
        }
    }
    return charRemoved;
}
function getNextInlineSibling(sibling, backspace, root) {
    let nextSibling = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.sibling(sibling, backspace);
    if (!nextSibling && sibling.parentNode && sibling.parentNode !== root) {
        nextSibling = (0,_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .findMostNestedNeighbor */ .s)(sibling, !backspace, root, true);
    }
    return nextSibling;
}
/**
 * Helper removes all empty inline parents
 */ function removeEmptyForParent(node, tags) {
    let parent = node.parentElement;
    while(parent && _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isInlineBlock(parent) && _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(parent, tags)){
        const p = parent.parentElement;
        if (_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isEmpty(parent)) {
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.after(parent, node);
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(parent);
        }
        parent = p;
    }
}
/**
 * Helper add BR element inside empty block element
 */ function addBRInsideEmptyBlock(jodit, node) {
    if (node.parentElement !== jodit.editor && _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isBlock(node.parentElement) && _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.each(node.parentElement, _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isEmptyTextNode)) {
        _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.after(node, jodit.createInside.element('br'));
    }
}
function tryRemoveChar(sibling, backspace, step, anotherSibling) {
    // For Unicode escapes
    let value = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.toArray)(sibling.nodeValue);
    const length = value.length;
    let index = backspace ? length - 1 : 0;
    if (value[index] === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE) {
        while(value[index] === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE){
            index += step;
        }
    }
    const removed = value[index];
    if (value[index + step] === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE) {
        index += step;
        while(value[index] === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE){
            index += step;
        }
        index += backspace ? 1 : -1;
    }
    if (backspace && index < 0) {
        value = [];
    } else {
        value = value.slice(backspace ? 0 : index + 1, backspace ? index : length);
    }
    replaceSpaceOnNBSP(anotherSibling, backspace, value);
    sibling.nodeValue = value.join('');
    return removed;
}
function replaceSpaceOnNBSP(anotherSibling, backspace, value) {
    var _a;
    if (!anotherSibling || !_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isText(anotherSibling) || (!backspace ? / $/ : /^ /).test((_a = anotherSibling.nodeValue) !== null && _a !== void 0 ? _a : '') || !(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.trimInv)(anotherSibling.nodeValue || '').length) {
        for(let i = backspace ? value.length - 1 : 0; backspace ? i >= 0 : i < value.length; i += backspace ? -1 : 1){
            if (value[i] === ' ') {
                value[i] = _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.NBSP_SPACE;
            } else {
                break;
            }
        }
    }
}
function checkRepeatRemoveCharAction(backspace, sibling, fakeNode, mode, removed, jodit) {
    (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.call)(backspace ? _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.after : _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.before, sibling, fakeNode);
    if (mode === 'sentence' || mode === 'word' && removed !== ' ' && removed !== _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.NBSP_SPACE) {
        checkRemoveChar(jodit, fakeNode, backspace, mode);
    }
}


/***/ }),

/***/ 73948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Gq: function() { return /* binding */ getItem; },
/* harmony export */   PZ: function() { return /* binding */ elementToItem; },
/* harmony export */   nW: function() { return /* binding */ nativeListeners; }
/* harmony export */ });
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22732);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21537);
/* harmony import */ var _builders_context_menu_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41457);
/* harmony import */ var _builders_elements_map_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32118);
/* harmony import */ var _fetch_load_tree_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20201);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 




/**
 * @private
 */ const getItem = (node, root, tag = 'a')=>_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(node, (elm)=>_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(elm, tag), root);
/**
 * @private
 */ const elementToItem = (elm, elementsMap)=>{
    const { key } = elm.dataset, { item } = elementsMap[key || ''];
    return item;
};
/**
 * @private
 */ function nativeListeners() {
    let dragElement = false;
    const elmMap = (0,_builders_elements_map_js__WEBPACK_IMPORTED_MODULE_3__/* .elementsMap */ .a)(this);
    const self = this;
    self.e.on(self.tree.container, 'dragstart', (e)=>{
        const a = getItem(e.target, self.container);
        if (!a) {
            return;
        }
        if (self.o.moveFolder) {
            dragElement = a;
        }
    }).on(self.tree.container, 'drop', (e)=>{
        if ((self.o.moveFile || self.o.moveFolder) && dragElement) {
            let path = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.attr)(dragElement, '-path') || '';
            // move folder
            if (!self.o.moveFolder && dragElement.classList.contains(this.tree.getFullElName('item'))) {
                return false;
            }
            // move file
            if (dragElement.classList.contains(this.files.getFullElName('item'))) {
                path += (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.attr)(dragElement, '-name');
                if (!self.o.moveFile) {
                    return false;
                }
            }
            const a = getItem(e.target, self.container);
            if (!a) {
                return;
            }
            self.dataProvider.move(path, (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.attr)(a, '-path') || '', (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.attr)(a, '-source') || '', dragElement.classList.contains(this.files.getFullElName('item'))).then(()=>(0,_fetch_load_tree_js__WEBPACK_IMPORTED_MODULE_4__/* .loadTree */ .r)(this)).catch(self.status);
            dragElement = false;
        }
    }).on(self.files.container, 'contextmenu', (0,_builders_context_menu_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(self)).on(self.files.container, 'click', (e)=>{
        if (!(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.ctrlKey)(e)) {
            this.state.activeElements = [];
        }
    }).on(self.files.container, 'click', (e)=>{
        const a = getItem(e.target, self.container);
        if (!a) {
            return;
        }
        const item = elementToItem(a, elmMap);
        if (!item) {
            return;
        }
        if (!(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.ctrlKey)(e)) {
            self.state.activeElements = [
                item
            ];
        } else {
            self.state.activeElements = [
                ...self.state.activeElements,
                item
            ];
        }
        e.stopPropagation();
        return false;
    }).on(self.files.container, 'dragstart', (e)=>{
        if (self.o.moveFile) {
            const a = getItem(e.target, self.container);
            if (!a) {
                return;
            }
            dragElement = a;
        }
    }).on(self.container, 'drop', (e)=>e.preventDefault());
}


/***/ }),

/***/ 74551:
/***/ (function(__unused_webpack_module, __webpack_exports__) {


/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'copy-format': 'Format kopierenт'
});


/***/ }),

/***/ 74569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   z: function() { return /* binding */ dataURItoBlob; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module modules/uploader
 */ /**
 * Convert dataURI to Blob
 */ function dataURItoBlob(dataURI) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    const byteString = atob(dataURI.split(',')[1]), // separate out the mime component
    mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0], // write the bytes of the string to an ArrayBuffer
    ab = new ArrayBuffer(byteString.length), ia = new Uint8Array(ab);
    for(let i = 0; i < byteString.length; i += 1){
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([
        ia
    ], {
        type: mimeString
    });
}


/***/ }),

/***/ 75259:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg viewBox=\"0 0 16 16\" xml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M8,11c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3S5,1.343,5,3v5C5,9.657,6.343,11,8,11z\"/> <path d=\"M13,8V6h-1l0,1.844c0,1.92-1.282,3.688-3.164,4.071C6.266,12.438,4,10.479,4,8V6H3v2c0,2.414,1.721,4.434,4,4.899V15H5v1h6 v-1H9v-2.101C11.279,12.434,13,10.414,13,8z\"/> </svg> ");


/***/ }),

/***/ 75275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Gq: function() { return /* reexport safe */ _htmlspecialchars_js__WEBPACK_IMPORTED_MODULE_2__.G; },
/* harmony export */   HA: function() { return /* reexport safe */ _nl2br_js__WEBPACK_IMPORTED_MODULE_3__.H; },
/* harmony export */   Kq: function() { return /* reexport safe */ _strip_tags_js__WEBPACK_IMPORTED_MODULE_5__.K; },
/* harmony export */   ZM: function() { return /* reexport safe */ _apply_styles_js__WEBPACK_IMPORTED_MODULE_0__.Z; },
/* harmony export */   t_: function() { return /* reexport safe */ _safe_html_js__WEBPACK_IMPORTED_MODULE_4__.t; },
/* harmony export */   vn: function() { return /* reexport safe */ _safe_html_js__WEBPACK_IMPORTED_MODULE_4__.v; },
/* harmony export */   wE: function() { return /* reexport safe */ _clean_from_word_js__WEBPACK_IMPORTED_MODULE_1__.w; }
/* harmony export */ });
/* harmony import */ var _apply_styles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32574);
/* harmony import */ var _clean_from_word_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53212);
/* harmony import */ var _htmlspecialchars_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53326);
/* harmony import */ var _nl2br_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45971);
/* harmony import */ var _safe_html_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86518);
/* harmony import */ var _strip_tags_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91003);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/html
 */ 







/***/ }),

/***/ 75330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   V: function() { return /* binding */ FileBrowser; }
/* harmony export */ });
/* harmony import */ var _core_component_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91907);
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82758);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65478);
/* harmony import */ var _core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37133);
/* harmony import */ var _core_event_emitter_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3827);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21537);
/* harmony import */ var _core_storage_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12081);
/* harmony import */ var _core_traits_dlgs_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70231);
/* harmony import */ var _core_view_view_with_toolbar_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84075);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6441);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61251);
/* harmony import */ var _fetch_load_items_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(30465);
/* harmony import */ var _fetch_load_tree_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20201);
/* harmony import */ var _listeners_native_listeners_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(73948);
/* harmony import */ var _listeners_self_listeners_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(33281);
/* harmony import */ var _listeners_state_listeners_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(94538);
/* harmony import */ var _data_provider_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(11787);
/* harmony import */ var _factories_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(63399);
/* harmony import */ var _ui_index_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(8172);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




















let FileBrowser = class FileBrowser extends _core_view_view_with_toolbar_js__WEBPACK_IMPORTED_MODULE_8__/* .ViewWithToolbar */ .T {
    /** @override */ className() {
        return 'FileBrowser';
    }
    get dataProvider() {
        return (0,_factories_js__WEBPACK_IMPORTED_MODULE_16__/* .makeDataProvider */ .S)(this, this.options);
    }
    onSelect(callback) {
        return ()=>{
            if (this.state.activeElements.length) {
                const files = [];
                const isImages = [];
                this.state.activeElements.forEach((elm)=>{
                    const url = elm.fileURL;
                    if (url) {
                        files.push(url);
                        isImages.push(elm.isImage || false);
                    }
                });
                this.close();
                const data = {
                    baseurl: '',
                    files,
                    isImages
                };
                if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.isFunction)(callback)) {
                    callback(data);
                }
                this.close();
            }
            return false;
        };
    }
    get _dialog() {
        var _a;
        const dialog = this.dlg({
            minWidth: Math.min(700, screen.width),
            minHeight: 300,
            buttons: (_a = this.o.headerButtons) !== null && _a !== void 0 ? _a : [
                'fullsize',
                'dialog.close'
            ]
        });
        [
            'beforeClose',
            'afterClose',
            'beforeOpen'
        ].forEach((proxyEvent)=>dialog.events.on(dialog, proxyEvent, ()=>this.e.fire(proxyEvent)));
        dialog.setSize(this.o.width, this.o.height);
        return dialog;
    }
    /**
     * Container for set/get value
     */ get storage() {
        return _core_storage_index_js__WEBPACK_IMPORTED_MODULE_6__/* .Storage */ .wc.makeStorage(Boolean(this.o.saveStateInStorage), this.componentName);
    }
    get isOpened() {
        return this._dialog.isOpened && this.browser.style.display !== 'none';
    }
    /**
     * It displays a message in the status bar of filebrowser
     *
     * @param message - The message that will be displayed
     * @param success - true It will be shown a message light . If no option is specified ,
     * ßan error will be shown the red
     * @example
     * ```javascript
     * parent.filebrowser.status('There was an error uploading file', false);
     * ```
     */ status(message, success) {
        if (!message || (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.isAbortError)(message)) {
            return;
        }
        if (!(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.isString)(message)) {
            message = message.message;
        }
        if (!(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.isString)(message) || !(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.trim)(message).length) {
            return;
        }
        this.message.message(message, success ? 'success' : 'error', this.o.howLongShowMsg);
    }
    /**
     * It opens a web browser window
     *
     * @param callback - The function that will be called after the file selection in the browser
     * @param onlyImages - Show only images
     * @example
     * ```javascript
     * var fb = new Jodit.modules.FileBrowser(parent);
     * fb.open(function (data) {
     *     var i;
     *     for (i = 0;i < data.files.length; i += 1) {
     *         parent.s.insertImage(data.baseurl + data.files[i]);
     *     }
     * });
     * ```
     */ open(callback = this.o.defaultCallback, onlyImages = false) {
        this.state.onlyImages = onlyImages;
        return this.async.promise((resolve, reject)=>{
            var _a;
            if (!this.o.items || !this.o.items.url) {
                throw (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.error)('Need set options.filebrowser.ajax.url');
            }
            let localTimeout = 0;
            this.e.off(this.files.container, 'dblclick').on(this.files.container, 'dblclick', this.onSelect(callback)).on(this.files.container, 'touchstart', ()=>{
                const now = new Date().getTime();
                if (now - localTimeout < _core_constants_js__WEBPACK_IMPORTED_MODULE_1__.EMULATE_DBLCLICK_TIMEOUT) {
                    this.onSelect(callback)();
                }
                localTimeout = now;
            }).off('select.filebrowser').on('select.filebrowser', this.onSelect(callback));
            const header = this.c.div();
            (_a = this.toolbar) === null || _a === void 0 ? void 0 : _a.appendTo(header);
            this.__updateToolbarButtons();
            this._dialog.open(this.browser, header);
            this.e.fire('sort.filebrowser', this.state.sortBy);
            (0,_fetch_load_tree_js__WEBPACK_IMPORTED_MODULE_11__/* .loadTree */ .r)(this).then(resolve, reject).finally(()=>{
                var _a;
                if (this.isInDestruct) {
                    return;
                }
                (_a = this === null || this === void 0 ? void 0 : this.e) === null || _a === void 0 ? void 0 : _a.fire('fileBrowserReady.filebrowser');
            });
        }).catch((e)=>{
            if (!(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.isAbortError)(e) && !_core_constants_js__WEBPACK_IMPORTED_MODULE_1__.IS_PROD) {
                throw e;
            }
        });
    }
    __getButtons() {
        var _a;
        const options = (_a = this.o.buttons) !== null && _a !== void 0 ? _a : [];
        return options.filter((btn)=>{
            if (!(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.isString)(btn)) {
                return true;
            }
            switch(btn){
                case 'filebrowser.upload':
                    return this.dataProvider.canI('FileUpload');
                case 'filebrowser.edit':
                    return this.dataProvider.canI('ImageResize') || this.dataProvider.canI('ImageCrop');
                case 'filebrowser.remove':
                    return this.dataProvider.canI('FileRemove');
            }
            return true;
        });
    }
    initUploader(editor) {
        var _a;
        const self = this, options = (_a = editor === null || editor === void 0 ? void 0 : editor.options) === null || _a === void 0 ? void 0 : _a.uploader, uploaderOptions = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.ConfigProto)(options || {}, _config_js__WEBPACK_IMPORTED_MODULE_9__/* .Config */ .T.defaultOptions.uploader);
        const uploadHandler = ()=>(0,_fetch_load_items_js__WEBPACK_IMPORTED_MODULE_18__/* .loadItems */ .f)(this);
        self.uploader = self.getInstance('Uploader', uploaderOptions);
        self.uploader.setPath(self.state.currentPath).setSource(self.state.currentSource).bind(self.browser, uploadHandler, self.errorHandler);
        this.state.on([
            'change.currentPath',
            'change.currentSource'
        ], ()=>{
            this.uploader.setPath(this.state.currentPath).setSource(this.state.currentSource);
        });
        self.e.on('bindUploader.filebrowser', (button)=>{
            self.uploader.bind(button, uploadHandler, self.errorHandler);
        });
    }
    destruct() {
        var _a;
        if (this.isInDestruct) {
            return;
        }
        (_a = (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_2__.cached)(this, '_dialog')) === null || _a === void 0 ? void 0 : _a.destruct();
        super.destruct();
        this.events && this.e.off('.filebrowser');
        this.uploader && this.uploader.destruct();
    }
    __updateToolbarButtons() {
        var _a;
        const buttons = this.__getButtons();
        if (isEqualButtonList(this.__prevButtons, buttons)) {
            return;
        }
        this.__prevButtons = buttons;
        (_a = this.toolbar) === null || _a === void 0 ? void 0 : _a.build(buttons);
    }
    constructor(options){
        super(options);
        this.browser = this.c.div(this.componentName);
        this.status_line = this.c.div(this.getFullElName('status'));
        this.tree = new _ui_index_js__WEBPACK_IMPORTED_MODULE_17__/* .FileBrowserTree */ .V(this);
        this.files = new _ui_index_js__WEBPACK_IMPORTED_MODULE_17__/* .FileBrowserFiles */ .Q(this);
        this.state = (0,_core_event_emitter_index_js__WEBPACK_IMPORTED_MODULE_4__/* .observable */ .sH)({
            currentPath: '',
            currentSource: _data_provider_js__WEBPACK_IMPORTED_MODULE_15__/* .DEFAULT_SOURCE_NAME */ .o,
            currentBaseUrl: '',
            activeElements: [],
            elements: [],
            sources: [],
            view: 'tiles',
            sortBy: 'changed-desc',
            filterWord: '',
            onlyImages: false
        });
        this.errorHandler = (resp)=>{
            if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.isAbortError)(resp)) {
                return;
            }
            if (resp instanceof Error) {
                this.status(this.i18n(resp.message));
            } else {
                this.status(this.dataProvider.getMessage(resp));
            }
        };
        /**
         * Close dialog
         */ this.close = ()=>{
            this._dialog.close();
        };
        this.__prevButtons = [];
        this.attachEvents(options);
        const self = this;
        self.options = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.ConfigProto)(options || {}, _config_js__WEBPACK_IMPORTED_MODULE_9__/* .Config */ .T.defaultOptions.filebrowser);
        self.browser.component = this;
        self.container = self.browser;
        if (self.o.showFoldersPanel) {
            self.browser.appendChild(self.tree.container);
        }
        self.browser.appendChild(self.files.container);
        self.browser.appendChild(self.status_line);
        _listeners_self_listeners_js__WEBPACK_IMPORTED_MODULE_13__/* .selfListeners */ .c.call(self);
        _listeners_native_listeners_js__WEBPACK_IMPORTED_MODULE_12__/* .nativeListeners */ .nW.call(self);
        _listeners_state_listeners_js__WEBPACK_IMPORTED_MODULE_14__/* .stateListeners */ .r.call(self);
        const keys = [
            'getLocalFileByUrl',
            'crop',
            'resize',
            'create',
            'fileMove',
            'folderMove',
            'fileRename',
            'folderRename',
            'fileRemove',
            'folderRemove',
            'folder',
            'items',
            'permissions'
        ];
        keys.forEach((key)=>{
            if (this.options[key] != null) {
                this.options[key] = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.ConfigProto)(this.options[key], this.o.ajax);
            }
        });
        const { storeView, storeSortBy, storeLastOpenedFolder } = this.o.saveStateInStorage || {
            storeLastOpenedFolder: false,
            storeView: false,
            storeSortBy: false
        };
        const view = storeView && this.storage.get('view');
        if (view && this.o.view == null) {
            self.state.view = view === 'list' ? 'list' : 'tiles';
        } else {
            self.state.view = self.o.view === 'list' ? 'list' : 'tiles';
        }
        self.files.setMod('view', self.state.view);
        const sortBy = storeSortBy && self.storage.get('sortBy');
        if (sortBy) {
            const parts = sortBy.split('-');
            self.state.sortBy = [
                'changed',
                'name',
                'size'
            ].includes(parts[0]) ? sortBy : 'changed-desc';
        } else {
            self.state.sortBy = self.o.sortBy || 'changed-desc';
        }
        if (storeLastOpenedFolder) {
            const currentPath = self.storage.get('currentPath'), currentSource = self.storage.get('currentSource');
            self.state.currentPath = currentPath !== null && currentPath !== void 0 ? currentPath : '';
            self.state.currentSource = currentSource !== null && currentSource !== void 0 ? currentSource : '';
        }
        self.initUploader(self);
        self.setStatus(_core_component_index_js__WEBPACK_IMPORTED_MODULE_0__/* .STATUSES */ .f.ready);
    }
};
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_2__.cache
], FileBrowser.prototype, "dataProvider", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_2__.cache
], FileBrowser.prototype, "_dialog", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_2__.cache
], FileBrowser.prototype, "storage", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_2__.autobind
], FileBrowser.prototype, "status", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_2__.autobind
], FileBrowser.prototype, "open", null);
__decorate([
    (0,_core_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_3__/* .watch */ .w)('dataProvider:changePermissions')
], FileBrowser.prototype, "__updateToolbarButtons", null);
FileBrowser = __decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_2__.derive)(_core_traits_dlgs_js__WEBPACK_IMPORTED_MODULE_7__/* .Dlgs */ .z)
], FileBrowser);

function isEqualButtonList(prevButtons, buttons) {
    if (prevButtons.length !== buttons.length) {
        return false;
    }
    for(let i = 0; i < prevButtons.length; i++){
        if (prevButtons[i] !== buttons[i]) {
            return false;
        }
    }
    return true;
}


/***/ }),

/***/ 75393:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 432 432\"> <g> <polygon points=\"203.688,96 0,96 0,144 155.688,144 \"/> <polygon points=\"155.719,288 0,288 0,336 203.719,336 \"/> <path d=\"M97.844,230.125c-3.701-3.703-5.856-8.906-5.856-14.141s2.154-10.438,5.856-14.141l9.844-9.844H0v48h107.719 L97.844,230.125z\"/> <polygon points=\"232,176 232,96 112,216 232,336 232,256 432,256 432,176\"/> </g> </svg> ");


/***/ }),

/***/ 75445:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({});


/***/ }),

/***/ 75595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   X: function() { return /* binding */ readLink; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29960);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/** @private */ function readLink(state, j, values) {
    const a = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(state.sourceImage, 'a', j.editor);
    if (a) {
        values.imageLink = (0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .C)(a, 'href') || '';
        values.imageLinkOpenInNewTab = (0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .C)(a, 'target') === '_blank';
    } else {
        values.imageLink = '';
        values.imageLinkOpenInNewTab = false;
    }
}


/***/ }),

/***/ 75703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    symbols: 'سمبل'
});


/***/ }),

/***/ 75882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   t: function() { return /* binding */ unwrapChildren; }
/* harmony export */ });
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43555);
/* harmony import */ var _has_same_style_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22030);
/* harmony import */ var _is_suit_element_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97380);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



/**
 * Unwrap all suit elements inside
 * @private
 */ function unwrapChildren(style, font) {
    var _a;
    const needUnwrap = [];
    const needChangeStyle = [];
    let firstElementSuit;
    const cssStyle = (_a = style.options.attributes) === null || _a === void 0 ? void 0 : _a.style;
    if (font.firstChild) {
        const gen = _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.eachGen(font);
        let item = gen.next();
        while(!item.done){
            const elm = item.value;
            if ((0,_is_suit_element_js__WEBPACK_IMPORTED_MODULE_3__/* .isSuitElement */ .sz)(style, elm, true) && (!cssStyle || (0,_has_same_style_js__WEBPACK_IMPORTED_MODULE_2__/* .hasSameStyleKeys */ .Y)(elm, cssStyle))) {
                if (firstElementSuit === undefined) {
                    firstElementSuit = true;
                }
                needUnwrap.push(elm);
            } else if (cssStyle && (0,_is_suit_element_js__WEBPACK_IMPORTED_MODULE_3__/* .isSameStyleChild */ .Wv)(style, elm)) {
                if (firstElementSuit === undefined) {
                    firstElementSuit = false;
                }
                needChangeStyle.push(()=>{
                    (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .css */ .AH)(elm, Object.keys(cssStyle).reduce((acc, key)=>{
                        acc[key] = null;
                        return acc;
                    }, {}));
                    if (!(0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .CF)(elm, 'style')) {
                        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .CF)(elm, 'style', null);
                    }
                    if (!(0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .CF)(elm, 'style') && elm.nodeName.toLowerCase() === style.element) {
                        needUnwrap.push(elm);
                    }
                });
            } else if (!_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isEmptyTextNode(elm)) {
                if (firstElementSuit === undefined) {
                    firstElementSuit = false;
                }
            }
            item = gen.next();
        }
    }
    needChangeStyle.forEach((clb)=>clb());
    needUnwrap.forEach(_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.unwrap);
    return Boolean(firstElementSuit);
}


/***/ }),

/***/ 76014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   X: function() { return /* binding */ Table; }
/* harmony export */ });
/* harmony import */ var _core_component_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91907);
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82758);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22732);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21537);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






const markedValue = new WeakMap();
class Table extends _core_component_index_js__WEBPACK_IMPORTED_MODULE_0__/* .ViewComponent */ .vG {
    /** @override */ className() {
        return 'Table';
    }
    __recalculateStyles() {
        const style = (0,_core_global_js__WEBPACK_IMPORTED_MODULE_4__/* .getContainer */ .My)(this.j, Table, 'style', true);
        const selectors = [];
        this.selected.forEach((td)=>{
            const selector = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.cssPath)(td);
            selector && selectors.push(selector);
        });
        style.innerHTML = selectors.length ? selectors.join(',') + `{${this.jodit.options.table.selectionCellStyle}}` : '';
    }
    addSelection(td) {
        this.selected.add(td);
        this.__recalculateStyles();
        const table = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Dom */ .J.closest(td, 'table', this.j.editor);
        if (table) {
            const cells = Table.__selectedByTable.get(table) || new Set();
            cells.add(td);
            Table.__selectedByTable.set(table, cells);
        }
    }
    removeSelection(td) {
        this.selected.delete(td);
        this.__recalculateStyles();
        const table = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Dom */ .J.closest(td, 'table', this.j.editor);
        if (table) {
            const cells = Table.__selectedByTable.get(table);
            if (cells) {
                cells.delete(td);
                if (!cells.size) {
                    Table.__selectedByTable.delete(table);
                }
            }
        }
    }
    /**
     * Returns array of selected cells
     */ getAllSelectedCells() {
        return (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.toArray)(this.selected);
    }
    static __getSelectedCellsByTable(table) {
        const cells = Table.__selectedByTable.get(table);
        return cells ? (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.toArray)(cells) : [];
    }
    /** @override **/ destruct() {
        this.selected.clear();
        return super.destruct();
    }
    static __getRowsCount(table) {
        return table.rows.length;
    }
    /**
     * Returns rows count in the table
     */ getRowsCount(table) {
        return Table.__getRowsCount(table);
    }
    static __getColumnsCount(table) {
        const matrix = Table.__formalMatrix(table);
        return matrix.reduce((max_count, cells)=>Math.max(max_count, cells.length), 0);
    }
    /**
     * Returns columns count in the table
     */ getColumnsCount(table) {
        return Table.__getColumnsCount(table);
    }
    static __formalMatrix(table, callback) {
        const matrix = [
            []
        ];
        const rows = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.toArray)(table.rows);
        const setCell = (cell, i)=>{
            if (matrix[i] === undefined) {
                matrix[i] = [];
            }
            const colSpan = cell.colSpan, rowSpan = cell.rowSpan;
            let column, row, currentColumn = 0;
            while(matrix[i][currentColumn]){
                currentColumn += 1;
            }
            for(row = 0; row < rowSpan; row += 1){
                for(column = 0; column < colSpan; column += 1){
                    if (matrix[i + row] === undefined) {
                        matrix[i + row] = [];
                    }
                    if (callback && callback(cell, i + row, currentColumn + column, colSpan, rowSpan) === false) {
                        return false;
                    }
                    matrix[i + row][currentColumn + column] = cell;
                }
            }
        };
        for(let i = 0; i < rows.length; i += 1){
            const cells = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.toArray)(rows[i].cells);
            for(let j = 0; j < cells.length; j += 1){
                if (setCell(cells[j], i) === false) {
                    return matrix;
                }
            }
        }
        return matrix;
    }
    /**
     * Generate formal table martix columns*rows
     * @param table - Working table
     * @param callback - if return false cycle break
     */ formalMatrix(table, callback) {
        return Table.__formalMatrix(table, callback);
    }
    static __formalCoordinate(table, cell, max = false) {
        let i = 0, j = 0, width = 1, height = 1;
        Table.__formalMatrix(table, (td, ii, jj, colSpan, rowSpan)=>{
            if (cell === td) {
                i = ii;
                j = jj;
                width = colSpan || 1;
                height = rowSpan || 1;
                if (max) {
                    j += (colSpan || 1) - 1;
                    i += (rowSpan || 1) - 1;
                }
                return false;
            }
        });
        return [
            i,
            j,
            width,
            height
        ];
    }
    /**
     * Get cell coordinate in formal table (without colspan and rowspan)
     */ formalCoordinate(table, cell, max = false) {
        return Table.__formalCoordinate(table, cell, max);
    }
    static __appendRow(table, line, after, create) {
        var _a;
        let row;
        if (!line) {
            const columnsCount = Table.__getColumnsCount(table);
            row = create.element('tr');
            for(let j = 0; j < columnsCount; j += 1){
                row.appendChild(create.element('td'));
            }
        } else {
            row = line.cloneNode(true);
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.$$)('td,th', line).forEach((cell)=>{
                const rowspan = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.attr)(cell, 'rowspan');
                if (rowspan && parseInt(rowspan, 10) > 1) {
                    const newRowSpan = parseInt(rowspan, 10) - 1;
                    (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.attr)(cell, 'rowspan', newRowSpan > 1 ? newRowSpan : null);
                }
            });
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.$$)('td,th', row).forEach((cell)=>{
                cell.innerHTML = '';
            });
        }
        if (after && line && line.nextSibling) {
            line.parentNode && line.parentNode.insertBefore(row, line.nextSibling);
        } else if (!after && line) {
            line.parentNode && line.parentNode.insertBefore(row, line);
        } else {
            (((_a = table.getElementsByTagName('tbody')) === null || _a === void 0 ? void 0 : _a[0]) || table).appendChild(row);
        }
    }
    /**
     * Inserts a new line after row what contains the selected cell
     *
     * @param table - Working table
     * @param line - Insert a new line after/before this
     * line contains the selected cell
     * @param after - Insert a new line after line contains the selected cell
     */ appendRow(table, line, after) {
        return Table.__appendRow(table, line, after, this.j.createInside);
    }
    static __removeRow(table, rowIndex) {
        const box = Table.__formalMatrix(table);
        let dec;
        const row = table.rows[rowIndex];
        box[rowIndex].forEach((cell, j)=>{
            dec = false;
            if (rowIndex - 1 >= 0 && box[rowIndex - 1][j] === cell) {
                dec = true;
            } else if (box[rowIndex + 1] && box[rowIndex + 1][j] === cell) {
                if (cell.parentNode === row && cell.parentNode.nextSibling) {
                    dec = true;
                    let nextCell = j + 1;
                    while(box[rowIndex + 1][nextCell] === cell){
                        nextCell += 1;
                    }
                    const nextRow = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Dom */ .J.next(cell.parentNode, (elm)=>_core_dom_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Dom */ .J.isTag(elm, 'tr'), table);
                    if (nextRow) {
                        if (box[rowIndex + 1][nextCell]) {
                            nextRow.insertBefore(cell, box[rowIndex + 1][nextCell]);
                        } else {
                            nextRow.appendChild(cell);
                        }
                    }
                }
            } else {
                _core_dom_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Dom */ .J.safeRemove(cell);
            }
            if (dec && (cell.parentNode === row || cell !== box[rowIndex][j - 1])) {
                const rowSpan = cell.rowSpan;
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.attr)(cell, 'rowspan', rowSpan - 1 > 1 ? rowSpan - 1 : null);
            }
        });
        _core_dom_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Dom */ .J.safeRemove(row);
    }
    /**
     * Remove row
     */ removeRow(table, rowIndex) {
        return Table.__removeRow(table, rowIndex);
    }
    /**
     * Insert column before / after all the columns containing the selected cells
     */ appendColumn(table, selectedCell, insertAfter = true) {
        const box = Table.__formalMatrix(table);
        if (!insertAfter && _core_dom_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Dom */ .J.isCell(selectedCell.previousElementSibling)) {
            return this.appendColumn(table, selectedCell.previousElementSibling, true);
        }
        const columnIndex = insertAfter ? selectedCell.cellIndex + ((selectedCell.colSpan || 1) - 1) : selectedCell.cellIndex;
        const newColumnIndex = insertAfter ? columnIndex + 1 : columnIndex;
        for(let i = 0; i < box.length;){
            const cells = box[i];
            if (cells[columnIndex] !== cells[newColumnIndex] || columnIndex === newColumnIndex) {
                const cell = this.j.createInside.element('td');
                if (insertAfter) {
                    _core_dom_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Dom */ .J.after(cells[columnIndex], cell);
                } else {
                    _core_dom_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Dom */ .J.before(cells[columnIndex], cell);
                }
                if (cells[columnIndex].rowSpan > 1) {
                    cell.rowSpan = cells[columnIndex].rowSpan;
                }
            } else {
                cells[columnIndex].colSpan += 1;
            }
            i += cells[columnIndex].rowSpan || 1;
        }
    }
    static __removeColumn(table, j) {
        const box = Table.__formalMatrix(table);
        let dec;
        box.forEach((cells, i)=>{
            const td = cells[j];
            dec = false;
            if (j - 1 >= 0 && box[i][j - 1] === td) {
                dec = true;
            } else if (j + 1 < cells.length && box[i][j + 1] === td) {
                dec = true;
            } else {
                _core_dom_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Dom */ .J.safeRemove(td);
            }
            if (dec && (i - 1 < 0 || td !== box[i - 1][j])) {
                const colSpan = td.colSpan;
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.attr)(td, 'colspan', colSpan - 1 > 1 ? (colSpan - 1).toString() : null);
            }
        });
    }
    /**
     * Remove column by index
     */ removeColumn(table, j) {
        return Table.__removeColumn(table, j);
    }
    static __getSelectedBound(table, selectedCells) {
        const bound = [
            [
                Infinity,
                Infinity
            ],
            [
                0,
                0
            ]
        ];
        const box = Table.__formalMatrix(table);
        let i, j, k;
        for(i = 0; i < box.length; i += 1){
            for(j = 0; box[i] && j < box[i].length; j += 1){
                if (selectedCells.includes(box[i][j])) {
                    bound[0][0] = Math.min(i, bound[0][0]);
                    bound[0][1] = Math.min(j, bound[0][1]);
                    bound[1][0] = Math.max(i, bound[1][0]);
                    bound[1][1] = Math.max(j, bound[1][1]);
                }
            }
        }
        for(i = bound[0][0]; i <= bound[1][0]; i += 1){
            for(k = 1, j = bound[0][1]; j <= bound[1][1]; j += 1){
                while(box[i] && box[i][j - k] && box[i][j] === box[i][j - k]){
                    bound[0][1] = Math.min(j - k, bound[0][1]);
                    bound[1][1] = Math.max(j - k, bound[1][1]);
                    k += 1;
                }
                k = 1;
                while(box[i] && box[i][j + k] && box[i][j] === box[i][j + k]){
                    bound[0][1] = Math.min(j + k, bound[0][1]);
                    bound[1][1] = Math.max(j + k, bound[1][1]);
                    k += 1;
                }
                k = 1;
                while(box[i - k] && box[i][j] === box[i - k][j]){
                    bound[0][0] = Math.min(i - k, bound[0][0]);
                    bound[1][0] = Math.max(i - k, bound[1][0]);
                    k += 1;
                }
                k = 1;
                while(box[i + k] && box[i][j] === box[i + k][j]){
                    bound[0][0] = Math.min(i + k, bound[0][0]);
                    bound[1][0] = Math.max(i + k, bound[1][0]);
                    k += 1;
                }
            }
        }
        return bound;
    }
    /**
     * Define bound for selected cells
     */ getSelectedBound(table, selectedCells) {
        return Table.__getSelectedBound(table, selectedCells);
    }
    static __normalizeTable(table) {
        const __marked = [], box = Table.__formalMatrix(table);
        Table.__removeExtraColspans(box, __marked);
        Table.__removeExtraRowspans(box, __marked);
        // remove rowspans and colspans equal 1 and empty class
        for(let i = 0; i < box.length; i += 1){
            for(let j = 0; j < box[i].length; j += 1){
                if (box[i][j] === undefined) {
                    continue; // broken table
                }
                if (box[i][j].hasAttribute('rowspan') && box[i][j].rowSpan === 1) {
                    (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.attr)(box[i][j], 'rowspan', null);
                }
                if (box[i][j].hasAttribute('colspan') && box[i][j].colSpan === 1) {
                    (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.attr)(box[i][j], 'colspan', null);
                }
                if (box[i][j].hasAttribute('class') && !(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.attr)(box[i][j], 'class')) {
                    (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.attr)(box[i][j], 'class', null);
                }
            }
        }
        Table.__unmark(__marked);
    }
    static __removeExtraColspans(box, __marked) {
        for(let j = 0; j < box[0].length; j += 1){
            let min = 1000000;
            let not = false;
            for(let i = 0; i < box.length; i += 1){
                if (box[i][j] === undefined) {
                    continue; // broken table
                }
                if (box[i][j].colSpan < 2) {
                    not = true;
                    break;
                }
                min = Math.min(min, box[i][j].colSpan);
            }
            if (!not) {
                for(let i = 0; i < box.length; i += 1){
                    if (box[i][j] === undefined) {
                        continue; // broken table
                    }
                    Table.__mark(box[i][j], 'colspan', box[i][j].colSpan - min + 1, __marked);
                }
            }
        }
    }
    static __removeExtraRowspans(box, marked) {
        let i = 0;
        let j = 0;
        for(i = 0; i < box.length; i += 1){
            let min = 1000000;
            let not = false;
            for(j = 0; j < box[i].length; j += 1){
                if (box[i][j] === undefined) {
                    continue; // broken table
                }
                if (box[i][j].rowSpan < 2) {
                    not = true;
                    break;
                }
                min = Math.min(min, box[i][j].rowSpan);
            }
            if (!not) {
                for(j = 0; j < box[i].length; j += 1){
                    if (box[i][j] === undefined) {
                        continue; // broken table
                    }
                    Table.__mark(box[i][j], 'rowspan', box[i][j].rowSpan - min + 1, marked);
                }
            }
        }
    }
    /**
     * Try recalculate all coluns and rows after change
     */ normalizeTable(table) {
        return Table.__normalizeTable(table);
    }
    static __mergeSelected(table, jodit) {
        const html = [], bound = Table.__getSelectedBound(table, Table.__getSelectedCellsByTable(table));
        let w = 0, first = null, first_j = 0, td, cols = 0, rows = 0;
        const alreadyMerged = new Set(), __marked = [];
        if (bound && (bound[0][0] - bound[1][0] || bound[0][1] - bound[1][1])) {
            Table.__formalMatrix(table, (cell, i, j, cs, rs)=>{
                if (i >= bound[0][0] && i <= bound[1][0]) {
                    if (j >= bound[0][1] && j <= bound[1][1]) {
                        td = cell;
                        if (alreadyMerged.has(td)) {
                            return;
                        }
                        alreadyMerged.add(td);
                        if (i === bound[0][0] && td.style.width) {
                            w += td.offsetWidth;
                        }
                        if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.trim)(cell.innerHTML.replace(/<br(\/)?>/g, '')) !== '') {
                            html.push(cell.innerHTML);
                        }
                        if (cs > 1) {
                            cols += cs - 1;
                        }
                        if (rs > 1) {
                            rows += rs - 1;
                        }
                        if (!first) {
                            first = cell;
                            first_j = j;
                        } else {
                            Table.__mark(td, 'remove', 1, __marked);
                            instance(jodit).removeSelection(td);
                        }
                    }
                }
            });
            cols = bound[1][1] - bound[0][1] + 1;
            rows = bound[1][0] - bound[0][0] + 1;
            if (first) {
                if (cols > 1) {
                    Table.__mark(first, 'colspan', cols, __marked);
                }
                if (rows > 1) {
                    Table.__mark(first, 'rowspan', rows, __marked);
                }
                if (w) {
                    Table.__mark(first, 'width', (w / table.offsetWidth * 100).toFixed(_core_constants_js__WEBPACK_IMPORTED_MODULE_1__.ACCURACY) + '%', __marked);
                    if (first_j) {
                        Table.__setColumnWidthByDelta(table, first_j, 0, true, __marked);
                    }
                }
                first.innerHTML = html.join('<br/>');
                instance(jodit).addSelection(first);
                alreadyMerged.delete(first);
                Table.__unmark(__marked);
                Table.__normalizeTable(table);
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.toArray)(table.rows).forEach((tr)=>{
                    if (!tr.cells.length) {
                        _core_dom_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Dom */ .J.safeRemove(tr);
                    }
                });
            }
        }
    }
    /**
     * It combines all the selected cells into one. The contents of the cells will also be combined
     */ mergeSelected(table) {
        return Table.__mergeSelected(table, this.j);
    }
    static __splitHorizontal(table, jodit) {
        let coord, td, tr, parent, after;
        const __marked = [];
        Table.__getSelectedCellsByTable(table).forEach((cell)=>{
            td = jodit.createInside.element('td');
            td.appendChild(jodit.createInside.element('br'));
            tr = jodit.createInside.element('tr');
            coord = Table.__formalCoordinate(table, cell);
            if (cell.rowSpan < 2) {
                Table.__formalMatrix(table, (tdElm, i, j)=>{
                    if (coord[0] === i && coord[1] !== j && tdElm !== cell) {
                        Table.__mark(tdElm, 'rowspan', tdElm.rowSpan + 1, __marked);
                    }
                });
                _core_dom_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Dom */ .J.after(_core_dom_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Dom */ .J.closest(cell, 'tr', table), tr);
                tr.appendChild(td);
            } else {
                Table.__mark(cell, 'rowspan', cell.rowSpan - 1, __marked);
                Table.__formalMatrix(table, (tdElm, i, j)=>{
                    if (i > coord[0] && i < coord[0] + cell.rowSpan && coord[1] > j && tdElm.parentNode.rowIndex === i) {
                        after = tdElm;
                    }
                    if (coord[0] < i && tdElm === cell) {
                        parent = table.rows[i];
                    }
                });
                if (after) {
                    _core_dom_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Dom */ .J.after(after, td);
                } else {
                    parent.insertBefore(td, parent.firstChild);
                }
            }
            if (cell.colSpan > 1) {
                Table.__mark(td, 'colspan', cell.colSpan, __marked);
            }
            Table.__unmark(__marked);
            instance(jodit).removeSelection(cell);
        });
        this.__normalizeTable(table);
    }
    /**
     * Divides all selected by `jodit_focused_cell` class table cell in 2 parts vertical. Those division into 2 columns
     */ splitHorizontal(table) {
        return Table.__splitHorizontal(table, this.j);
    }
    static __splitVertical(table, jodit) {
        let coord, td, percentage;
        const __marked = [];
        Table.__getSelectedCellsByTable(table).forEach((cell)=>{
            coord = Table.__formalCoordinate(table, cell);
            if (cell.colSpan < 2) {
                Table.__formalMatrix(table, (tdElm, i, j)=>{
                    if (coord[1] === j && coord[0] !== i && tdElm !== cell) {
                        Table.__mark(tdElm, 'colspan', tdElm.colSpan + 1, __marked);
                    }
                });
            } else {
                Table.__mark(cell, 'colspan', cell.colSpan - 1, __marked);
            }
            td = jodit.createInside.element('td');
            td.appendChild(jodit.createInside.element('br'));
            if (cell.rowSpan > 1) {
                Table.__mark(td, 'rowspan', cell.rowSpan, __marked);
            }
            const oldWidth = cell.offsetWidth; // get old width
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Dom */ .J.after(cell, td);
            percentage = oldWidth / table.offsetWidth / 2;
            Table.__mark(cell, 'width', (percentage * 100).toFixed(_core_constants_js__WEBPACK_IMPORTED_MODULE_1__.ACCURACY) + '%', __marked);
            Table.__mark(td, 'width', (percentage * 100).toFixed(_core_constants_js__WEBPACK_IMPORTED_MODULE_1__.ACCURACY) + '%', __marked);
            Table.__unmark(__marked);
            instance(jodit).removeSelection(cell);
        });
        Table.__normalizeTable(table);
    }
    /**
     * It splits all the selected cells into 2 parts horizontally. Those. are added new row
     */ splitVertical(table) {
        return Table.__splitVertical(table, this.j);
    }
    static __setColumnWidthByDelta(table, column, delta, noUnmark, marked) {
        const box = Table.__formalMatrix(table);
        let clearWidthIndex = 0;
        for(let i = 0; i < box.length; i += 1){
            const cell = box[i][column];
            if (cell.colSpan > 1 && box.length > 1) {
                continue;
            }
            const w = cell.offsetWidth;
            const percent = (w + delta) / table.offsetWidth * 100;
            Table.__mark(cell, 'width', percent.toFixed(_core_constants_js__WEBPACK_IMPORTED_MODULE_1__.ACCURACY) + '%', marked);
            clearWidthIndex = i;
            break;
        }
        for(let i = clearWidthIndex + 1; i < box.length; i += 1){
            const cell = box[i][column];
            Table.__mark(cell, 'width', null, marked);
        }
        if (!noUnmark) {
            Table.__unmark(marked);
        }
    }
    /**
     * Set column width used delta value
     */ setColumnWidthByDelta(table, column, delta, noUnmark, marked) {
        return Table.__setColumnWidthByDelta(table, column, delta, noUnmark, marked);
    }
    static __mark(cell, key, value, marked) {
        var _a;
        marked.push(cell);
        const dict = (_a = markedValue.get(cell)) !== null && _a !== void 0 ? _a : {};
        dict[key] = value === undefined ? 1 : value;
        markedValue.set(cell, dict);
    }
    static __unmark(marked) {
        marked.forEach((cell)=>{
            const dict = markedValue.get(cell);
            if (dict) {
                Object.keys(dict).forEach((key)=>{
                    const value = dict[key];
                    switch(key){
                        case 'remove':
                            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Dom */ .J.safeRemove(cell);
                            break;
                        case 'rowspan':
                            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.attr)(cell, 'rowspan', (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.isNumber)(value) && value > 1 ? value : null);
                            break;
                        case 'colspan':
                            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.attr)(cell, 'colspan', (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.isNumber)(value) && value > 1 ? value : null);
                            break;
                        case 'width':
                            if (value == null) {
                                cell.style.removeProperty('width');
                                if (!(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.attr)(cell, 'style')) {
                                    (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_5__.attr)(cell, 'style', null);
                                }
                            } else {
                                cell.style.width = value.toString();
                            }
                            break;
                    }
                    delete dict[key];
                });
                markedValue.delete(cell);
            }
        });
    }
    constructor(){
        super(...arguments);
        this.selected = new Set();
    }
}
Table.__selectedByTable = new WeakMap();
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_2__.debounce)()
], Table.prototype, "__recalculateStyles", null);
const instance = (j)=>j.getInstance('Table', j.o);


/***/ }),

/***/ 76078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $$: function() { return /* binding */ $$; },
/* harmony export */   DY: function() { return /* binding */ refs; },
/* harmony export */   bE: function() { return /* binding */ cssPath; },
/* harmony export */   fz: function() { return /* binding */ getXPathByElement; },
/* harmony export */   tI: function() { return /* binding */ resolveElement; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _array_to_array_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4510);
/* harmony import */ var _checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70799);
/* harmony import */ var _string_camel_case_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87058);
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43555);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 





let temp = 1;
const $$temp = ()=>{
    temp++;
    return temp;
};
/**
 * @deprecated Do not use it in new code
 */ function $$(selector, root) {
    let result;
    if (!_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_ES_NEXT && /:scope/.test(selector) && _constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_IE && !(root && root.nodeType === Node.DOCUMENT_NODE)) {
        const id = root.id, temp_id = id || '_selector_id_' + String(Math.random()).slice(2) + $$temp();
        selector = selector.replace(/:scope/g, '#' + temp_id);
        !id && root.setAttribute('id', temp_id);
        result = root.parentNode.querySelectorAll(selector);
        if (!id) {
            root.removeAttribute('id');
        }
    } else {
        result = root.querySelectorAll(selector);
    }
    return [].slice.call(result);
}
/**
 * Calculate XPath selector
 */ const getXPathByElement = (element, root)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) {
        return '';
    }
    if (!element.parentNode || root === element) {
        return '';
    }
    if (element.id) {
        return "//*[@id='" + element.id + "']";
    }
    const sames = [].filter.call(element.parentNode.childNodes, (x)=>x.nodeName === element.nodeName);
    return getXPathByElement(element.parentNode, root) + '/' + element.nodeName.toLowerCase() + (sames.length > 1 ? '[' + ((0,_array_to_array_js__WEBPACK_IMPORTED_MODULE_2__/* .toArray */ .$)(sames).indexOf(element) + 1) + ']' : '');
};
/**
 * Find all `ref` or `data-ref` elements inside HTMLElement
 */ const refs = (root)=>{
    if ('container' in root) {
        root = root.container;
    }
    return $$('[ref],[data-ref]', root).reduce((def, child)=>{
        const key = (0,_index_js__WEBPACK_IMPORTED_MODULE_3__/* .attr */ .CF)(child, '-ref');
        if (key && (0,_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__/* .isString */ .K)(key)) {
            def[(0,_string_camel_case_js__WEBPACK_IMPORTED_MODULE_5__/* .camelCase */ .x)(key)] = child;
            def[key] = child;
        }
        return def;
    }, {});
};
/**
 * Calculate full CSS selector
 */ const cssPath = (el)=>{
    if (!_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isElement(el)) {
        return null;
    }
    const path = [];
    let start = el;
    while(start && start.nodeType === Node.ELEMENT_NODE){
        let selector = start.nodeName.toLowerCase();
        if (start.id) {
            selector += '#' + start.id;
            path.unshift(selector);
            break;
        } else {
            let sib = start, nth = 1;
            do {
                sib = sib.previousElementSibling;
                if (sib && sib.nodeName.toLowerCase() === selector) {
                    nth++;
                }
            }while (sib)
            selector += ':nth-of-type(' + nth + ')';
        }
        path.unshift(selector);
        start = start.parentNode;
    }
    return path.join(' > ');
};
/**
 * Try to find element by selector
 */ function resolveElement(element, od) {
    let resolved = element;
    if ((0,_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__/* .isString */ .K)(element)) {
        try {
            resolved = od.querySelector(element);
        } catch (_a) {
            throw (0,_index_js__WEBPACK_IMPORTED_MODULE_3__/* .error */ .z3)('String "' + element + '" should be valid HTML selector');
        }
    }
    // Duck checking
    if (!resolved || typeof resolved !== 'object' || !_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isElement(resolved) || !resolved.cloneNode) {
        throw (0,_index_js__WEBPACK_IMPORTED_MODULE_3__/* .error */ .z3)('Element "' + element + '" should be string or HTMLElement instance');
    }
    return resolved;
}


/***/ }),

/***/ 76295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export justify */
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21537);
/* harmony import */ var _core_helpers_utils_align_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25726);
/* harmony import */ var _core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41180);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6441);
/* harmony import */ var _justify_svg_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5567);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 







_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .I.set('justify', _justify_svg_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A);
_config_js__WEBPACK_IMPORTED_MODULE_5__/* .Config */ .T.prototype.controls.align = {
    name: 'left',
    tooltip: 'Align',
    update (editor, button) {
        const control = button.control, current = editor.s.current();
        if (current) {
            const currentBox = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(current, _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isBlock, editor.editor) || editor.editor;
            let currentValue = (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_7__/* .css */ .A)(currentBox, 'text-align').toString();
            if (control.defaultValue && control.defaultValue.indexOf(currentValue) !== -1) {
                currentValue = 'left';
            }
            const { list, data } = control;
            if (data && data.currentValue !== currentValue && list && ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.isPlainObject)(list) ? list[currentValue] : list.includes(currentValue))) {
                if (editor.o.textIcons || control.component === 'select') {
                    button.state.text = currentValue;
                } else {
                    button.state.icon.name = currentValue;
                }
                data.currentValue = currentValue;
            }
        }
    },
    isActive: (editor, btn)=>{
        const current = editor.s.current();
        if (!current || !btn.control.defaultValue) {
            return false;
        }
        const currentBox = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(current, _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isBlock, editor.editor) || editor.editor;
        return btn.control.defaultValue.indexOf((0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_7__/* .css */ .A)(currentBox, 'text-align').toString()) === -1;
    },
    defaultValue: [
        'left',
        'start',
        'inherit'
    ],
    data: {
        currentValue: 'left'
    },
    list: [
        'center',
        'left',
        'right',
        'justify'
    ]
};
_config_js__WEBPACK_IMPORTED_MODULE_5__/* .Config */ .T.prototype.controls.center = {
    command: 'justifyCenter',
    css: {
        'text-align': 'center'
    },
    tooltip: 'Align Center'
};
_config_js__WEBPACK_IMPORTED_MODULE_5__/* .Config */ .T.prototype.controls.justify = {
    command: 'justifyFull',
    css: {
        'text-align': 'justify'
    },
    tooltip: 'Align Justify'
};
_config_js__WEBPACK_IMPORTED_MODULE_5__/* .Config */ .T.prototype.controls.left = {
    command: 'justifyLeft',
    css: {
        'text-align': 'left'
    },
    tooltip: 'Align Left'
};
_config_js__WEBPACK_IMPORTED_MODULE_5__/* .Config */ .T.prototype.controls.right = {
    command: 'justifyRight',
    css: {
        'text-align': 'right'
    },
    tooltip: 'Align Right'
};
/**
 * Process commands: `justifyfull`, `justifyleft`, `justifyright`, `justifycenter`
 */ function justify(editor) {
    editor.registerButton({
        name: 'align',
        group: 'indent'
    });
    const callback = (command)=>{
        editor.s.focus();
        editor.s.eachSelection((current)=>{
            if (!current) {
                return;
            }
            let currentBox = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.up(current, _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isBlock, editor.editor);
            if (!currentBox) {
                currentBox = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.wrapInline(current, editor.o.enterBlock, editor);
            }
            (0,_core_helpers_utils_align_js__WEBPACK_IMPORTED_MODULE_3__/* .alignElement */ .Op)(command, currentBox);
        });
        return false;
    };
    editor.registerCommand('justifyfull', callback);
    editor.registerCommand('justifyright', callback);
    editor.registerCommand('justifyleft', callback);
    editor.registerCommand('justifycenter', callback);
}
_core_global_js__WEBPACK_IMPORTED_MODULE_1__/* .pluginSystem */ .fg.add('justify', justify);


/***/ }),

/***/ 76725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    'Line height': 'Výška čáry'
});


/***/ }),

/***/ 76855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $r: function() { return /* reexport safe */ _to_array_js__WEBPACK_IMPORTED_MODULE_2__.$; },
/* harmony export */   _j: function() { return /* reexport safe */ _as_array_js__WEBPACK_IMPORTED_MODULE_0__._; },
/* harmony export */   uM: function() { return /* reexport safe */ _split_array_js__WEBPACK_IMPORTED_MODULE_1__.u; }
/* harmony export */ });
/* harmony import */ var _as_array_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29999);
/* harmony import */ var _split_array_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46559);
/* harmony import */ var _to_array_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4510);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/array
 */ 




/***/ }),

/***/ 77183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   S: function() { return /* binding */ removeExtraTags; }
/* harmony export */ });
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */
const extraTags = new Set([
    'o:p',
    'xml',
    'script',
    'meta',
    'link',
    'v:imagedata',
    'style'
]);
function removeExtraTags(elm) {
    // Remove invisible
    if (elm.style.get('display') === 'none') {
        elm.remove();
        return null;
    }
    // Remove empty tag
    if (elm.length === 0 && elm.name === 'span') {
        elm.remove();
        return null;
    }
    // Remove invalid tags
    if (extraTags.has(elm.name)) {
        elm.remove();
        return null;
    }
    return elm;
}


/***/ }),

/***/ 77361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ag: function() { return /* binding */ UNSET; },
/* harmony export */   DI: function() { return /* binding */ INITIAL; },
/* harmony export */   OJ: function() { return /* binding */ UNWRAP; },
/* harmony export */   PL: function() { return /* binding */ CHANGE; },
/* harmony export */   Zk: function() { return /* binding */ WRAP; },
/* harmony export */   ar: function() { return /* binding */ _PREFIX; },
/* harmony export */   dj: function() { return /* binding */ REPLACE; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module selection
 */ /** @internal */ const WRAP = 'wrap';
/** @internal */ const UNWRAP = 'unwrap';
/** @internal */ const CHANGE = 'change';
/** @internal */ const UNSET = 'unset';
/** @internal */ const INITIAL = 'initial';
/** @internal */ const REPLACE = 'replace';
/** @internal */ const _PREFIX = 'commitStyle';


/***/ }),

/***/ 77469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export iframe */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21537);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50963);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 




/**
 * Iframe plugin - use `iframe` instead of DIV in editor. It can be need when you want to attach custom styles in editor
 * in backend of you system
 */ function iframe(editor) {
    const opt = editor.options;
    editor.e.on('afterSetMode', ()=>{
        if (editor.isEditorMode()) {
            editor.s.focus();
        }
    }).on('generateDocumentStructure.iframe', (__doc, jodit)=>{
        const doc = __doc || jodit.iframe.contentWindow.document;
        doc.open();
        doc.write(opt.iframeDoctype + `<html dir="${opt.direction}" class="jodit" lang="${(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.defaultLanguage)(opt.language)}">` + '<head>' + `<title>${opt.iframeTitle}</title>` + (opt.iframeBaseUrl ? `<base href="${opt.iframeBaseUrl}"/>` : '') + '</head>' + '<body class="jodit-wysiwyg"></body>' + '</html>');
        doc.close();
        if (opt.iframeCSSLinks) {
            opt.iframeCSSLinks.forEach((href)=>{
                const link = doc.createElement('link');
                link.setAttribute('rel', 'stylesheet');
                link.setAttribute('href', href);
                doc.head && doc.head.appendChild(link);
            });
        }
        if (opt.iframeStyle) {
            const style = doc.createElement('style');
            style.innerHTML = opt.iframeStyle;
            doc.head && doc.head.appendChild(style);
        }
    }).on('createEditor', ()=>{
        if (!opt.iframe) {
            return;
        }
        const iframe = editor.c.element('iframe');
        iframe.style.display = 'block';
        iframe.src = 'about:blank';
        iframe.className = 'jodit-wysiwyg_iframe';
        iframe.setAttribute('allowtransparency', 'true');
        iframe.setAttribute('tabindex', opt.tabIndex.toString());
        iframe.setAttribute('frameborder', '0');
        if (opt.iframeSandbox != null) {
            iframe.setAttribute('sandbox', opt.iframeSandbox);
        }
        editor.workplace.appendChild(iframe);
        editor.iframe = iframe;
        const result = editor.e.fire('generateDocumentStructure.iframe', null, editor);
        const init = ()=>{
            if (!editor.iframe) {
                return false;
            }
            const doc = editor.iframe.contentWindow.document;
            editor.editorWindow = editor.iframe.contentWindow;
            const docMode = opt.editHTMLDocumentMode;
            const toggleEditable = ()=>{
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.attr)(doc.body, 'contenteditable', editor.getMode() !== _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_SOURCE && !editor.getReadOnly() || null);
            };
            const clearMarkers = (html)=>{
                const bodyReg = /<body.*<\/body>/im, bodyMarker = '{%%BODY%%}', body = bodyReg.exec(html);
                if (body) {
                    // remove markers
                    html = html.replace(bodyReg, bodyMarker).replace(/<span([^>]*?)>(.*?)<\/span>/gim, '').replace(/&lt;span([^&]*?)&gt;(.*?)&lt;\/span&gt;/gim, '').replace(bodyMarker, body[0].replace(/(<body[^>]+?)min-height["'\s]*:[\s"']*[0-9]+(px|%)/im, '$1').replace(/(<body[^>]+?)([\s]*["'])?contenteditable["'\s]*=[\s"']*true["']?/im, '$1').replace(/<(style|script|span)[^>]+jodit[^>]+>.*?<\/\1>/g, '')).replace(/(class\s*=\s*)(['"])([^"']*)(jodit-wysiwyg|jodit)([^"']*\2)/g, '$1$2$3$5').replace(/(<[^<]+?)\sclass="[\s]*"/gim, '$1').replace(/(<[^<]+?)\sstyle="[\s;]*"/gim, '$1').replace(/(<[^<]+?)\sdir="[\s]*"/gim, '$1');
                }
                return html;
            };
            if (docMode) {
                const tag = editor.element.tagName;
                if (tag !== 'TEXTAREA' && tag !== 'INPUT') {
                    throw (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.error)('If enable `editHTMLDocumentMode` - source element should be INPUT or TEXTAREA');
                }
                editor.e.on('beforeGetNativeEditorValue', ()=>clearMarkers(editor.o.iframeDoctype + doc.documentElement.outerHTML)).on('beforeSetNativeEditorValue', ({ value })=>{
                    if (editor.isLocked) {
                        return false;
                    }
                    if (/<(html|body)/i.test(value)) {
                        const old = doc.documentElement.outerHTML;
                        if (clearMarkers(old) !== clearMarkers(value)) {
                            doc.open();
                            doc.write(editor.o.iframeDoctype + clearMarkers(value));
                            doc.close();
                            editor.editor = doc.body;
                            editor.e.fire('safeHTML', editor.editor);
                            toggleEditable();
                            editor.e.fire('prepareWYSIWYGEditor');
                            editor.e.stopPropagation('beforeSetNativeEditorValue');
                        }
                    } else {
                        doc.body.innerHTML = value;
                    }
                    return true;
                }, {
                    top: true
                });
            }
            editor.editor = doc.body;
            editor.e.on('afterSetMode afterInit afterAddPlace', toggleEditable);
            if (opt.height === 'auto') {
                doc.documentElement && (doc.documentElement.style.overflowY = 'hidden');
                const resizeIframe = editor.async.throttle((...args)=>{
                    editor.async.requestAnimationFrame(()=>{
                        if (editor.editor && editor.iframe && opt.height === 'auto') {
                            const style = editor.ew.getComputedStyle(editor.editor), marginOffset = parseInt(style.marginTop || '0', 10) + parseInt(style.marginBottom || '0', 10);
                            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.css)(editor.iframe, 'height', editor.editor.offsetHeight + marginOffset);
                        }
                    });
                }, editor.defaultTimeout / 2);
                editor.e.on('change afterInit afterSetMode resize', resizeIframe).on([
                    editor.iframe,
                    editor.ew,
                    doc.documentElement
                ], 'load', resizeIframe).on(doc, 'readystatechange DOMContentLoaded', resizeIframe);
                if (typeof ResizeObserver === 'function') {
                    const resizeObserver = new ResizeObserver(resizeIframe);
                    resizeObserver.observe(doc.body);
                    editor.e.on('beforeDestruct', ()=>{
                        resizeObserver.disconnect();
                    });
                }
            }
            // throw events in our world
            if (doc.documentElement) {
                editor.e.on(doc.documentElement, 'mousedown touchend', ()=>{
                    if (!editor.s.isFocused()) {
                        editor.s.focus();
                        if (editor.editor === doc.body) {
                            editor.s.setCursorIn(doc.body);
                        }
                    }
                }).on(editor.ew, 'mousedown touchstart keydown keyup touchend click mouseup mousemove scroll', (e)=>{
                    var _a;
                    (_a = editor.events) === null || _a === void 0 ? void 0 : _a.fire(editor.ow, e);
                });
            }
            return false;
        };
        return (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.callPromise)(result, init);
    });
}
_core_global_js__WEBPACK_IMPORTED_MODULE_1__/* .pluginSystem */ .fg.add('iframe', iframe);


/***/ }),

/***/ 77725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    Spellcheck: 'Corrección ortográfica'
});


/***/ }),

/***/ 78116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   r: function() { return /* binding */ isMarker; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/**
 * Define element is selection helper
 */ function isMarker(elm) {
    return _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isNode(elm) && _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(elm, 'span') && elm.hasAttribute('data-' + _constants_js__WEBPACK_IMPORTED_MODULE_0__.MARKER_CLASS);
}


/***/ }),

/***/ 78173:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1395 736q0 13-10 23l-466 466q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l393 393 393-393q10-10 23-10t23 10l50 50q10 10 10 23z\"/> </svg> ");


/***/ }),

/***/ 78213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   f: function() { return /* binding */ STATUSES; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module component
 */ const STATUSES = {
    beforeInit: 'beforeInit',
    ready: 'ready',
    beforeDestruct: 'beforeDestruct',
    destructed: 'destructed'
};


/***/ }),

/***/ 78284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   v: function() { return /* binding */ normalizeImageProps; }
/* harmony export */ });
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */
const normalizeImageProps = (elm) => {
    if (!elm.isElement) {
        return elm;
    }
    if (elm.name === 'img') {
        if (elm.attributes.align) {
            elm.style.add('float', elm.attributes.align);
            elm.attributes.align = null;
        }
        if (elm.attributes.hspace) {
            elm.style.add('marginLeft', elm.attributes.hspace + 'px');
            elm.style.add('marginRight', elm.attributes.hspace + 'px');
            elm.attributes.hspace = null;
        }
    }
    return elm;
};


/***/ }),

/***/ 78513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   V: function() { return /* reexport safe */ _file_browser_js__WEBPACK_IMPORTED_MODULE_0__.V; }
/* harmony export */ });
/* harmony import */ var _file_browser_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75330);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * [[include:modules/file-browser/README.md]]
 * @packageDocumentation
 * @module modules/file-browser
 */ 


/***/ }),

/***/ 78524:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.commandToHotkeys = {
    removeFormat: [
        'ctrl+shift+m',
        'cmd+shift+m'
    ],
    insertOrderedList: [
        'ctrl+shift+7',
        'cmd+shift+7'
    ],
    insertUnorderedList: [
        'ctrl+shift+8, cmd+shift+8'
    ],
    selectall: [
        'ctrl+a',
        'cmd+a'
    ]
};


/***/ }),

/***/ 78547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Gb: function() { return /* binding */ STYLE_CSS_KEY; },
/* harmony export */   fB: function() { return /* binding */ LEVEL_KEY; },
/* harmony export */   lA: function() { return /* binding */ TYPE_KEY; },
/* harmony export */   pz: function() { return /* binding */ STYLE_VALID_KEY; },
/* harmony export */   wD: function() { return /* binding */ listStyleMap; },
/* harmony export */   yL: function() { return /* binding */ STYLE_KEY; }
/* harmony export */ });
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */
const LEVEL_KEY = 'jd-list-level';
const TYPE_KEY = 'jd-list-type';
const STYLE_KEY = 'jd-list-style-type';
const STYLE_VALID_KEY = 'data-list-style-type';
const STYLE_CSS_KEY = 'list-style-type';
const listStyleMap = {
    '·': 'disc',
    o: 'circle',
    '§': 'square',
    '[ivx]': 'lower-roman',
    '[IVX]': 'upper-roman',
    '[a-z]': 'lower-alpha',
    '[A-Z]': 'upper-alpha',
    '\\d': 'decimal'
};


/***/ }),

/***/ 78584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   l: function() { return /* binding */ Dialog; }
/* harmony export */ });
/* harmony import */ var _core_component_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91907);
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82758);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2748);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_array_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76855);
/* harmony import */ var _core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27613);
/* harmony import */ var _core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43555);
/* harmony import */ var _core_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(38837);
/* harmony import */ var _core_ui_index_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67510);
/* harmony import */ var _core_view_view_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35608);
/* harmony import */ var _core_view_view_with_toolbar_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(84075);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Dialog_1;













_config_js__WEBPACK_IMPORTED_MODULE_12__/* .Config */ .T.prototype.dialog = {
    namespace: '',
    extraButtons: [],
    /**
     * This dialog can resize by trigger
     */ resizable: true,
    /**
     * This dialog can move by header
     */ draggable: true,
    buttons: [
        'dialog.close'
    ],
    removeButtons: [],
    toolbarButtonSize: 'middle',
    zIndex: 'inherit'
};
_config_js__WEBPACK_IMPORTED_MODULE_12__/* .Config */ .T.prototype.controls.dialog = {
    close: {
        icon: 'cancel',
        exec: (dialog)=>{
            dialog.close();
        }
    }
};
/**
 * Module to generate dialog windows
 */ let Dialog = Dialog_1 = class Dialog extends _core_view_view_with_toolbar_js__WEBPACK_IMPORTED_MODULE_11__/* .ViewWithToolbar */ .T {
    /** @override */ className() {
        return 'Dialog';
    }
    get destination() {
        const { popupRoot, shadowRoot } = this.o;
        if (popupRoot) {
            return popupRoot;
        }
        if (shadowRoot) {
            return shadowRoot;
        }
        return this.od.body;
    }
    setElements(root, elements) {
        const elements_list = [];
        (0,_core_helpers_array_index_js__WEBPACK_IMPORTED_MODULE_5__/* .asArray */ ._j)(elements).forEach((elm)=>{
            if ((0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_6__/* .isArray */ .cy)(elm)) {
                const div = this.c.div(this.getFullElName('column'));
                elements_list.push(div);
                root.appendChild(div);
                return this.setElements(div, elm);
            }
            let element;
            if ((0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_6__/* .isString */ .Kg)(elm)) {
                element = this.c.fromHTML(elm);
            } else {
                element = (0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_6__/* .hasContainer */ .kO)(elm) ? elm.container : elm;
            }
            elements_list.push(element);
            if (element.parentNode !== root) {
                root.appendChild(element);
            }
        });
        (0,_core_helpers_array_index_js__WEBPACK_IMPORTED_MODULE_5__/* .toArray */ .$r)(root.childNodes).forEach((elm)=>{
            if (elements_list.indexOf(elm) === -1) {
                root.removeChild(elm);
            }
        });
    }
    __onMouseUp() {
        if (this.draggable || this.resizable) {
            this.__removeGlobalResizeListeners();
            this.draggable = false;
            this.resizable = false;
            this.unlockSelect();
            if (this.e) {
                this.__removeGlobalResizeListeners();
                /**
                 * Fired when the dialog box is finished to resizing
                 */ this.e.fire(this, 'endResize endMove');
            }
        }
    }
    /**
     *
     */ __onHeaderMouseDown(e) {
        const target = e.target;
        if (!this.o.draggable || target && target.nodeName.match(/^(INPUT|SELECT)$/)) {
            return;
        }
        this.draggable = true;
        this.startX = e.clientX;
        this.startY = e.clientY;
        this.startPoint.x = (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_7__/* .css */ .AH)(this.dialog, 'left');
        this.startPoint.y = (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_7__/* .css */ .AH)(this.dialog, 'top');
        this.setMaxZIndex();
        if (e.cancelable) {
            e.preventDefault();
        }
        this.lockSelect();
        this.__addGlobalResizeListeners();
        if (this.e) {
            /**
             * Fired when dialog box is started moving
             */ this.e.fire(this, 'startMove');
            this.e.fire('closeAllPopups');
        }
    }
    __onMouseMove(e) {
        if (this.draggable && this.o.draggable) {
            this.setPosition(this.startPoint.x + e.clientX - this.startX, this.startPoint.y + e.clientY - this.startY);
            if (this.e) {
                /**
                 * Fired when dialog box is moved
                 */ this.e.fire(this, 'move', e.clientX - this.startX, e.clientY - this.startY);
            }
            e.stopImmediatePropagation();
        }
        if (this.resizable && this.o.resizable) {
            this.setSize(this.startPoint.w + e.clientX - this.startX, this.startPoint.h + e.clientY - this.startY);
            if (this.e) {
                /**
                 * Fired when dialog box is resized
                 */ this.e.fire(this, 'resizeDialog', e.clientX - this.startX, e.clientY - this.startY);
            }
        }
    }
    __onEsc(e) {
        if (!this.o.closeOnEsc) {
            return;
        }
        if (this.isOpened && e.key === _core_constants_js__WEBPACK_IMPORTED_MODULE_1__.KEY_ESC && this.getMod('static') !== true) {
            const me = this.getMaxZIndexDialog();
            if (me) {
                me.close();
            } else {
                this.close();
            }
            e.stopImmediatePropagation();
        }
    }
    __onResizerMouseDown(e) {
        this.resizable = true;
        this.startX = e.clientX;
        this.startY = e.clientY;
        this.startPoint.w = this.dialog.offsetWidth;
        this.startPoint.h = this.dialog.offsetHeight;
        this.lockSelect();
        this.__addGlobalResizeListeners();
        if (this.e) {
            /**
             * Fired when dialog box is started resizing
             */ this.e.fire(this, 'startResize');
        }
    }
    __addGlobalResizeListeners() {
        const self1 = this;
        self1.e.on(self1.ow, 'pointermove touchmove', self1.__onMouseMove).on(self1.ow, 'pointerup touchend', self1.__onMouseUp);
    }
    __removeGlobalResizeListeners() {
        const self1 = this;
        self1.e.off(self1.ow, 'mousemove pointermove', self1.__onMouseMove).off(self1.ow, 'mouseup pointerup', self1.__onMouseUp);
    }
    /**
     * Specifies the size of the window
     *
     * @param w - The width of the window
     * @param h - The height of the window
     */ setSize(w, h) {
        if (w == null) {
            w = this.dialog.offsetWidth;
        }
        if (h == null) {
            h = this.dialog.offsetHeight;
        }
        (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_7__/* .css */ .AH)(this.dialog, {
            width: w,
            height: h
        });
        return this;
    }
    /**
     * Recalculate auto sizes
     */ calcAutoSize() {
        this.setSize('auto', 'auto');
        this.setSize();
        return this;
    }
    /**
     * Specifies the position of the upper left corner of the window . If x and y are specified,
     * the window is centered on the center of the screen
     *
     * @param x - Position px Horizontal
     * @param y - Position px Vertical
     */ setPosition(x, y) {
        const w = this.ow.innerWidth, h = this.ow.innerHeight;
        let left = w / 2 - this.dialog.offsetWidth / 2, top = h / 2 - this.dialog.offsetHeight / 2;
        if (left < 0) {
            left = 0;
        }
        if (top < 0) {
            top = 0;
        }
        if (x !== undefined && y !== undefined) {
            this.offsetX = x;
            this.offsetY = y;
            this.moved = Math.abs(x - left) > 100 || Math.abs(y - top) > 100;
        }
        this.dialog.style.left = (x || left) + 'px';
        this.dialog.style.top = (y || top) + 'px';
        return this;
    }
    /**
     * Specifies the dialog box title . It can take a string and an array of objects
     *
     * @param content - A string or an HTML element ,
     * or an array of strings and elements
     * @example
     * ```javascript
     * var dialog = new Jodi.modules.Dialog(parent);
     * dialog.setHeader('Hello world');
     * dialog.setHeader(['Hello world', '<button>OK</button>', $('<div>some</div>')]);
     * dialog.open();
     * ```
     */ setHeader(content) {
        this.setElements(this.dialogbox_header, content);
        return this;
    }
    /**
     * It specifies the contents of the dialog box. It can take a string and an array of objects
     *
     * @param content - A string or an HTML element ,
     * or an array of strings and elements
     * @example
     * ```javascript
     * var dialog = new Jodi.modules.Dialog(parent);
     * dialog.setHeader('Hello world');
     * dialog.setContent('<form onsubmit="alert(1);"><input type="text" /></form>');
     * dialog.open();
     * ```
     */ setContent(content) {
        this.setElements(this.dialogbox_content, content);
        return this;
    }
    /**
     * Sets the bottom of the dialog. It can take a string and an array of objects
     *
     * @param content - A string or an HTML element ,
     * or an array of strings and elements
     * @example
     * ```javascript
     * var dialog = new Jodi.modules.Dialog(parent);
     * dialog.setHeader('Hello world');
     * dialog.setContent('<form><input id="someText" type="text" /></form>');
     * dialog.setFooter([
     *  $('<a class="jodit-button">OK</a>').click(function () {
     *      alert($('someText').val())
     *      dialog.close();
     *  })
     * ]);
     * dialog.open();
     * ```
     */ setFooter(content) {
        this.setElements(this.dialogbox_footer, content);
        this.setMod('footer', Boolean(content));
        return this;
    }
    /**
     * Get zIndex from dialog
     */ getZIndex() {
        return parseInt((0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_7__/* .css */ .AH)(this.container, 'zIndex'), 10) || 0;
    }
    /**
     * Get dialog instance with maximum z-index displaying it on top of all the dialog boxes
     */ getMaxZIndexDialog() {
        let maxZi = 0, dlg, zIndex, res = this;
        (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_7__.$$)('.jodit-dialog', this.destination).forEach((dialog)=>{
            dlg = dialog.component;
            zIndex = parseInt((0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_7__/* .css */ .AH)(dialog, 'zIndex'), 10);
            if (dlg.isOpened && !isNaN(zIndex) && zIndex > maxZi) {
                res = dlg;
                maxZi = zIndex;
            }
        });
        return res;
    }
    /**
     * Sets the maximum z-index dialog box, displaying it on top of all the dialog boxes
     */ setMaxZIndex() {
        if (this.getMod('static')) return;
        let maxZIndex = 20000004, zIndex = 0;
        (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_7__.$$)('.jodit-dialog', this.destination).forEach((dialog)=>{
            zIndex = parseInt((0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_7__/* .css */ .AH)(dialog, 'zIndex'), 10);
            maxZIndex = Math.max(isNaN(zIndex) ? 0 : zIndex, maxZIndex);
        });
        this.container.style.zIndex = (maxZIndex + 1).toString();
    }
    /**
     * Expands the dialog on full browser window
     */ toggleFullSize(isFullSize) {
        if ((0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_6__/* .isVoid */ .Rd)(isFullSize)) {
            isFullSize = !this.getMod('fullsize');
        }
        this.setMod('fullsize', isFullSize);
        super.toggleFullSize(isFullSize);
    }
    /**
     * It opens a dialog box to center it, and causes the two event.
     *
     * @param contentOrClose - specifies the contents of the dialog box.
     * Can be false or undefined. see [[Dialog.setContent]]
     * @param title - specifies the title of the dialog box, @see setHeader
     * @param destroyAfterClose - true - After closing the window , the destructor will be called.
     * @param modal - true window will be opened in modal mode
     */ open(contentOrClose, titleOrModal, destroyAfterClose, modal) {
        _core_global_js__WEBPACK_IMPORTED_MODULE_4__/* .eventEmitter */ .RR.fire('closeAllPopups hideHelpers');
        /**
         * Called before the opening of the dialog box
         */ if (this.e.fire(this, 'beforeOpen') === false) {
            return this;
        }
        if ((0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_6__/* .isBoolean */ .Lm)(contentOrClose)) {
            destroyAfterClose = contentOrClose;
        }
        if ((0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_6__/* .isBoolean */ .Lm)(titleOrModal)) {
            modal = titleOrModal;
        }
        this.destroyAfterClose = destroyAfterClose === true;
        const content = (0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_6__/* .isBoolean */ .Lm)(contentOrClose) ? undefined : contentOrClose;
        const title = (0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_6__/* .isBoolean */ .Lm)(titleOrModal) ? undefined : titleOrModal;
        if (title !== undefined) {
            this.setHeader(title);
        }
        if (content) {
            this.setContent(content);
        }
        this.setMod('active', true);
        this.isOpened = true;
        this.setModal(modal);
        this.destination.appendChild(this.container);
        if (this.getMod('static') !== true) {
            this.setPosition(this.offsetX, this.offsetY);
            this.setMaxZIndex();
        } else {
            this.container.style.removeProperty('z-index');
        }
        if (this.o.fullsize) {
            this.toggleFullSize(true);
        }
        /**
         * Called after the opening of the dialog box
         */ this.e.fire('afterOpen', this);
        return this;
    }
    /**
     * Set modal mode
     */ setModal(modal) {
        this.isModal = Boolean(modal);
        this.setMod('modal', this.isModal);
        return this;
    }
    /****
     * Closes the dialog box , if you want to call the method `destruct`
     *
     * @see destroy
     * @example
     * ```javascript
     * //You can close dialog two ways
     * var dialog = new Jodit.modules.Dialog();
     * dialog.open('Hello world!', 'Title');
     * var $close = dialog.create.fromHTML('<a href="#" style="float:left;" class="jodit-button">
     *     <i class="icon icon-check"></i>&nbsp;' + Jodit.prototype.i18n('Ok') + '</a>');
     * $close.addEventListener('click', function () {
     *     dialog.close();
     * });
     * dialog.setFooter($close);
     * // and second way, you can close dialog from content
     * dialog.open('<a onclick="var event = doc.createEvent('HTMLEvents'); event.initEvent('close_dialog', true, true);
     * this.dispatchEvent(event)">Close</a>', 'Title');
     * ```
     */ close() {
        if (this.isDestructed || !this.isOpened || this.getMod('static') === true) {
            return this;
        }
        const { e } = this;
        /**
         * Called up to close the window
         */ if (e.fire(this, 'beforeClose') === false || e.fire('beforeClose', this) === false) {
            return this;
        }
        this.setMod('active', false);
        this.isOpened = false;
        if (this.isFullSize) {
            this.toggleFullSize(false);
        }
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_3__/* .Dom */ .J.safeRemove(this.container);
        this.__removeGlobalResizeListeners();
        /**
         * It called after the window is closed
         */ e.fire(this, 'afterClose');
        e.fire(this.ow, 'joditCloseDialog');
        if (this.destroyAfterClose) {
            this.destruct();
        }
        return this;
    }
    /**
     * Build toolbar after ready
     */ buildToolbar() {
        this.o.buttons && this.toolbar.build((0,_core_helpers_array_index_js__WEBPACK_IMPORTED_MODULE_5__/* .splitArray */ .uM)(this.o.buttons)).setMod('mode', 'header').appendTo(this.dialogbox_toolbar);
    }
    /**
     * It destroys all objects created for the windows and also includes all the handlers for the window object
     */ destruct() {
        if (this.isInDestruct) {
            return;
        }
        this.setStatus(_core_component_index_js__WEBPACK_IMPORTED_MODULE_0__/* .STATUSES */ .f.beforeDestruct);
        if (this.isOpened) {
            this.close();
        }
        if (this.events) {
            this.__removeGlobalResizeListeners();
            this.events.off(this.container, 'close_dialog', self.close).off(this.ow, 'keydown', this.__onEsc).off(this.ow, 'resize', this.__onResize);
        }
        super.destruct();
    }
    constructor(options = {}){
        super(options);
        this.destroyAfterClose = false;
        this.moved = false;
        this.resizable = false;
        this.draggable = false;
        this.startX = 0;
        this.startY = 0;
        this.startPoint = {
            x: 0,
            y: 0,
            w: 0,
            h: 0
        };
        this.lockSelect = ()=>{
            this.setMod('moved', true);
        };
        this.unlockSelect = ()=>{
            this.setMod('moved', false);
        };
        this.__onResize = ()=>{
            if (this.options && this.o.resizable && !this.moved && this.isOpened && !this.offsetX && !this.offsetY) {
                this.setPosition();
            }
        };
        this.isModal = false;
        /**
         * True, if dialog was opened
         */ this.isOpened = false;
        const self1 = this;
        self1.options = (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_7__/* .ConfigProto */ .tb)(options, (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_7__/* .ConfigProto */ .tb)(_config_js__WEBPACK_IMPORTED_MODULE_12__/* .Config */ .T.prototype.dialog, Dialog_1.defaultOptions));
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_3__/* .Dom */ .J.safeRemove(self1.container);
        const n = this.getFullElName.bind(this);
        self1.container = this.c.fromHTML(`<div class="jodit jodit-dialog ${this.componentName}">
				<div class="${n('overlay')}"></div>
				<div class="${this.getFullElName('panel')}">
					<div class="${n('header')}">
						<div class="${n('header-title')}"></div>
						<div class="${n('header-toolbar')}"></div>
					</div>
					<div class="${n('content')}"></div>
					<div class="${n('footer')}"></div>
					<div class="${n('resizer')}">${_core_ui_index_js__WEBPACK_IMPORTED_MODULE_9__/* .Icon */ .In.get('resize_handler')}</div>
				</div>
			</div>`);
        if (self1.options.direction === 'rtl') {
            self1.container.style.direction = 'rtl';
            self1.container.setAttribute('dir', 'rtl');
        }
        if (this.o.zIndex) {
            this.container.style.zIndex = this.o.zIndex.toString();
        }
        (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_7__/* .attr */ .CF)(self1.container, 'role', 'dialog');
        Object.defineProperty(self1.container, 'component', {
            value: this
        });
        self1.setMod('theme', self1.o.theme || 'default').setMod('resizable', Boolean(self1.o.resizable));
        const dialog = self1.getElm('panel');
        (0,_core_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_8__/* .assert */ .v)(dialog != null, 'Panel element does not exist');
        const resizer = self1.getElm('resizer');
        (0,_core_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_8__/* .assert */ .v)(resizer != null, 'Resizer element does not exist');
        const dialogbox_header = self1.getElm('header-title');
        (0,_core_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_8__/* .assert */ .v)(dialogbox_header != null, 'header-title element does not exist');
        const dialogbox_content = self1.getElm('content');
        (0,_core_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_8__/* .assert */ .v)(dialogbox_content != null, 'Content element does not exist');
        const dialogbox_footer = self1.getElm('footer');
        (0,_core_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_8__/* .assert */ .v)(dialogbox_footer != null, 'Footer element does not exist');
        const dialogbox_toolbar = self1.getElm('header-toolbar');
        (0,_core_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_8__/* .assert */ .v)(dialogbox_toolbar != null, 'header-toolbar element does not exist');
        this.dialog = dialog;
        this.resizer = resizer;
        this.dialogbox_header = dialogbox_header;
        this.dialogbox_content = dialogbox_content;
        this.dialogbox_footer = dialogbox_footer;
        this.dialogbox_toolbar = dialogbox_toolbar;
        (0,_core_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_7__/* .css */ .AH)(self1.dialog, {
            maxWidth: self1.options.maxWidth,
            minHeight: self1.options.minHeight,
            minWidth: self1.options.minWidth
        });
        const headerBox = self1.getElm('header');
        headerBox && self1.e.on(headerBox, 'pointerdown touchstart', self1.__onHeaderMouseDown);
        self1.e.on(self1.resizer, 'mousedown touchstart', self1.__onResizerMouseDown);
        const fullSize = _core_global_js__WEBPACK_IMPORTED_MODULE_4__/* .pluginSystem */ .fg.get('fullsize');
        (0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_6__/* .isFunction */ .Tn)(fullSize) && fullSize(self1);
        this.e.on(self1.container, 'close_dialog', self1.close).on(this.ow, 'keydown', this.__onEsc).on(this.ow, 'resize', this.__onResize);
        if (this.o.closeOnClickOverlay) {
            const overlay = self1.getElm('overlay');
            (0,_core_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_8__/* .assert */ .v)(overlay != null, 'Overlay element does not exist');
            this.e.on(overlay, 'click', self1.close);
        }
    }
};
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_2__.autobind
], Dialog.prototype, "__onMouseUp", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_2__.autobind
], Dialog.prototype, "__onHeaderMouseDown", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_2__.autobind
], Dialog.prototype, "__onMouseMove", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_2__.autobind
], Dialog.prototype, "__onEsc", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_2__.autobind
], Dialog.prototype, "__onResizerMouseDown", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_2__.autobind
], Dialog.prototype, "close", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_2__.hook)('ready')
], Dialog.prototype, "buildToolbar", null);
Dialog = Dialog_1 = __decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_2__.component
], Dialog);

Dialog.defaultOptions = {
    ..._core_view_view_js__WEBPACK_IMPORTED_MODULE_10__/* .View */ .S.defaultOptions,
    closeOnClickOverlay: false,
    closeOnEsc: true
};


/***/ }),

/***/ 78614:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M352 832q0 14-9 23l-288 288q-9 9-23 9-13 0-22.5-9.5t-9.5-22.5v-576q0-13 9.5-22.5t22.5-9.5q14 0 23 9l288 288q9 9 9 23zm1440 480v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5z\"/> </svg> ");


/***/ }),

/***/ 78630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   j: function() { return /* binding */ Autocomplete; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31635);
/* harmony import */ var _item__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53253);
/* harmony import */ var jodit_esm_core_decorators__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var jodit_esm_core_ui_group_group__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62405);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */





let Autocomplete = class Autocomplete extends jodit_esm_core_ui_group_group__WEBPACK_IMPORTED_MODULE_2__/* .UIGroup */ .U {
    constructor() {
        super(...arguments);
        this.elements = [];
        this.currentSelection = -1;
    }
    /** @override */
    className() {
        return 'Autocomplete';
    }
    onChangeSelection(_, previous) {
        previous != null && this.elements[previous]?.setMod('active', false);
        this.elements[this.currentSelection].setMod('active', true);
        this.elements[this.currentSelection].container.scrollIntoView(false);
    }
    build(list) {
        this.clear();
        list.forEach((elm, index) => {
            const item = new _item__WEBPACK_IMPORTED_MODULE_0__/* .AutocompleteItem */ .K(this.jodit, elm);
            this.j.e
                .on(item.container, 'mousedown touchstart', (e) => {
                e.preventDefault();
            })
                .on(item.container, 'click', () => {
                this.currentSelection = index;
                this.select();
            });
            this.append(item);
        });
        this.currentSelection = 0;
        this.onChangeSelection();
    }
    selectNext() {
        if (this.currentSelection + 1 <= this.elements.length - 1) {
            this.currentSelection += 1;
        }
        else {
            this.currentSelection = 0;
        }
    }
    selectPrevious() {
        if (this.currentSelection - 1 >= 0) {
            this.currentSelection -= 1;
        }
        else {
            this.currentSelection = this.elements.length - 1;
        }
    }
    select() {
        this.j.e.fire('select.autocomplete', this.elements[this.currentSelection].item);
    }
};
(0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__decorate */ .Cg)([
    (0,jodit_esm_core_decorators__WEBPACK_IMPORTED_MODULE_1__.watch)('currentSelection')
], Autocomplete.prototype, "onChangeSelection", null);
Autocomplete = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__decorate */ .Cg)([
    jodit_esm_core_decorators__WEBPACK_IMPORTED_MODULE_1__.component
], Autocomplete);



/***/ }),

/***/ 78644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   I: function() { return /* binding */ ToolbarButton; }
/* harmony export */ });
/* harmony import */ var _core_component_statuses_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78213);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22732);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21537);
/* harmony import */ var _core_ui_button_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62843);
/* harmony import */ var _core_ui_helpers_get_control_type_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72157);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12153);
/* harmony import */ var _core_ui_popup_popup_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56917);
/* harmony import */ var _collection_collection_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11676);
/* harmony import */ var _factory_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21491);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};










let ToolbarButton = class ToolbarButton extends _core_ui_button_index_js__WEBPACK_IMPORTED_MODULE_4__/* .UIButton */ .lD {
    /** @override */ className() {
        return 'ToolbarButton';
    }
    /**
     * Get parent toolbar
     */ get toolbar() {
        return this.closest(_collection_collection_js__WEBPACK_IMPORTED_MODULE_8__/* .ToolbarCollection */ .Q);
    }
    /** @override **/ update() {
        var _a, _b;
        const { control, state } = this, tc = this.closest(_collection_collection_js__WEBPACK_IMPORTED_MODULE_8__/* .ToolbarCollection */ .Q);
        if (!tc) {
            return;
        }
        const value = (_a = control.value) === null || _a === void 0 ? void 0 : _a.call(control, tc.jodit, this);
        if (value !== undefined) {
            state.value = value;
        }
        state.disabled = this.__calculateDisabledStatus(tc);
        state.activated = this.__calculateActivatedStatus(tc);
        (_b = control.update) === null || _b === void 0 ? void 0 : _b.call(control, tc.jodit, this);
    }
    /**
     * Calculates whether the button is active
     */ __calculateActivatedStatus(tc) {
        var _a, _b;
        if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isJoditObject)(this.j) && !this.j.editorIsActive) {
            return false;
        }
        if ((_b = (_a = this.control).isActive) === null || _b === void 0 ? void 0 : _b.call(_a, this.j, this)) {
            return true;
        }
        return Boolean(tc && tc.shouldBeActive(this));
    }
    /**
     * Calculates whether an element is blocked for the user
     */ __calculateDisabledStatus(tc) {
        var _a, _b;
        if (this.j.o.disabled) {
            return true;
        }
        if (this.j.o.readonly && (!this.j.o.activeButtonsInReadOnly || !this.j.o.activeButtonsInReadOnly.includes(this.control.name))) {
            return true;
        }
        if ((_b = (_a = this.control).isDisabled) === null || _b === void 0 ? void 0 : _b.call(_a, this.j, this)) {
            return true;
        }
        return Boolean(tc && tc.shouldBeDisabled(this));
    }
    /** @override */ onChangeActivated() {
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(this.button, 'aria-pressed', this.state.activated);
        super.onChangeActivated();
    }
    /** @override */ onChangeText() {
        if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isFunction)(this.control.template)) {
            this.text.innerHTML = this.control.template(this.j, this.control.name, this.j.i18n(this.state.text));
        } else {
            super.onChangeText();
        }
        this.setMod('text-icons', Boolean(this.text.innerText.trim().length));
    }
    /** @override */ onChangeTabIndex() {
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(this.button, 'tabindex', this.state.tabIndex);
    }
    createContainer() {
        const cn = this.componentName;
        const container = this.j.c.span(cn);
        const button = super.createContainer();
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(container, 'role', 'listitem');
        button.classList.remove(cn);
        button.classList.add(cn + '__button');
        Object.defineProperty(button, 'component', {
            value: this
        });
        container.appendChild(button);
        const trigger = this.j.c.fromHTML(`<span role="trigger" class="${cn}__trigger">${_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .I.get('chevron')}</span>`);
        // For caching
        button.appendChild(trigger);
        return container;
    }
    /** @override */ focus() {
        var _a;
        (_a = this.container.querySelector('button')) === null || _a === void 0 ? void 0 : _a.focus();
    }
    onChangeHasTrigger() {
        if (this.state.hasTrigger) {
            this.container.appendChild(this.trigger);
        } else {
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(this.trigger);
        }
        this.setMod('with-trigger', this.state.hasTrigger || null);
    }
    /** @override */ onChangeDisabled() {
        const disabled = this.state.disabled ? 'disabled' : null;
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(this.trigger, 'disabled', disabled);
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(this.button, 'disabled', disabled);
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(this.container, 'disabled', disabled);
    }
    /**
     * Init constant data from control
     */ __initFromControl() {
        var _a;
        const { control: ctr, state } = this;
        this.updateSize();
        state.name = ctr.name;
        const { textIcons } = this.j.o;
        if (textIcons === true || (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isFunction)(textIcons) && textIcons(ctr.name) || ctr.template) {
            state.icon = (0,_core_ui_button_index_js__WEBPACK_IMPORTED_MODULE_4__/* .UIButtonState */ .ue)().icon;
            state.text = ctr.text || ctr.name;
        } else {
            if (ctr.iconURL) {
                state.icon.iconURL = ctr.iconURL;
            } else {
                const name = ctr.icon || ctr.name;
                state.icon.name = _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .I.exists(name) || ((_a = this.j.o.extraIcons) === null || _a === void 0 ? void 0 : _a[name]) ? name : '';
            }
            if (!ctr.iconURL && !state.icon.name) {
                state.text = ctr.text || ctr.name;
            }
        }
        if (ctr.tooltip) {
            state.tooltip = this.j.i18n((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isFunction)(ctr.tooltip) ? ctr.tooltip(this.j, ctr, this) : ctr.tooltip);
        }
        state.hasTrigger = Boolean(ctr.list || ctr.popup && ctr.exec);
    }
    /**
     * Click on trigger button
     */ onTriggerClick(e) {
        var _a, _b, _c;
        if (this.openedPopup) {
            this.__closePopup();
            return;
        }
        const { control: ctr } = this;
        e.buffer = {
            actionTrigger: this
        };
        if (ctr.list) {
            return this.__openControlList(ctr);
        }
        if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isFunction)(ctr.popup)) {
            const popup = this.openPopup();
            popup.parentElement = this;
            try {
                if (this.j.e.fire((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.camelCase)(`before-${ctr.name}-open-popup`), this.target, ctr, popup) !== false) {
                    const target = (_c = (_b = (_a = this.toolbar) === null || _a === void 0 ? void 0 : _a.getTarget(this)) !== null && _b !== void 0 ? _b : this.target) !== null && _c !== void 0 ? _c : null;
                    const elm = ctr.popup(this.j, target, this.__closePopup, this);
                    if (elm) {
                        popup.setContent((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isString)(elm) ? this.j.c.fromHTML(elm) : elm).open(()=>(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.position)(this.container), false, this.j.o.allowTabNavigation ? this.container : undefined);
                    } else {
                        this.__closePopup();
                    }
                }
            } catch (e) {
                this.__closePopup();
                throw e;
            }
            /**
             * Fired after the popup was opened for some control button
             */ /**
             * Close all opened popups
             */ this.j.e.fire((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.camelCase)(`after-${ctr.name}-open-popup`), popup.container);
        }
    }
    /**
     * Create an open popup list
     */ __openControlList(control) {
        var _a;
        const controls = (_a = this.jodit.options.controls) !== null && _a !== void 0 ? _a : {}, getControl = (key)=>(0,_core_ui_helpers_get_control_type_js__WEBPACK_IMPORTED_MODULE_5__/* .findControlType */ .x)(key, controls);
        const list = control.list, menu = this.openPopup(), toolbar = (0,_factory_js__WEBPACK_IMPORTED_MODULE_9__/* .makeCollection */ .$K)(this.j);
        menu.parentElement = this;
        toolbar.parentElement = menu;
        toolbar.mode = 'vertical';
        const isListItem = (key)=>(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isPlainObject)(key) && 'title' in key && 'value' in key;
        const getButton = (key, value)=>{
            if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isString)(value) && getControl(value)) {
                return {
                    name: value.toString(),
                    ...getControl(value)
                };
            }
            if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isString)(key) && getControl(key)) {
                return {
                    name: key.toString(),
                    ...getControl(key),
                    ...typeof value === 'object' ? value : {}
                };
            }
            if (isListItem(key)) {
                value = key.value;
                key = key.title;
            }
            const { childTemplate } = control;
            const childControl = {
                name: key.toString(),
                template: childTemplate && ((j, k, v)=>childTemplate(j, k, v, this)),
                exec: control.childExec ? (view, current, options)=>{
                    var _a;
                    return (_a = control.childExec) === null || _a === void 0 ? void 0 : _a.call(control, view, current, {
                        ...options,
                        parentControl: control
                    });
                } : control.exec,
                data: control.data,
                command: control.command,
                isActive: control.isChildActive,
                value: control.value,
                isDisabled: control.isChildDisabled,
                mode: control.mode,
                args: [
                    ...control.args ? control.args : [],
                    key,
                    value
                ]
            };
            if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isString)(value)) {
                childControl.text = value;
            }
            return childControl;
        };
        toolbar.build((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isArray)(list) ? list.map(getButton) : (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.keys)(list, false).map((key)=>getButton(key, list[key])), this.target);
        menu.setContent(toolbar).open(()=>(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.position)(this.container), false, this.j.o.allowTabNavigation ? this.container : undefined);
        this.state.activated = true;
    }
    onOutsideClick(e) {
        if (!this.openedPopup) {
            return;
        }
        if (!e || !_core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isNode(e.target) || !_core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isOrContains(this.container, e.target) && !this.openedPopup.isOwnClick(e)) {
            this.__closePopup();
        }
    }
    openPopup() {
        this.__closePopup();
        this.openedPopup = new _core_ui_popup_popup_js__WEBPACK_IMPORTED_MODULE_7__/* .Popup */ .z(this.j, false);
        this.j.e.on(this.ow, 'mousedown touchstart', this.onOutsideClick).on('escape closeAllPopups', this.onOutsideClick);
        return this.openedPopup;
    }
    __closePopup() {
        if (this.openedPopup) {
            this.j.e.off(this.ow, 'mousedown touchstart', this.onOutsideClick).off('escape closeAllPopups', this.onOutsideClick);
            this.state.activated = false;
            this.openedPopup.close();
            this.openedPopup.destruct();
            this.openedPopup = null;
        }
    }
    /**
     * Click handler
     */ onClick(originalEvent) {
        var _a, _b, _c, _d, _e, _f, _g;
        const { control: ctr } = this;
        if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isFunction)(ctr.exec)) {
            const target = (_c = (_b = (_a = this.toolbar) === null || _a === void 0 ? void 0 : _a.getTarget(this)) !== null && _b !== void 0 ? _b : this.target) !== null && _c !== void 0 ? _c : null;
            const result = ctr.exec(this.j, target, {
                control: ctr,
                originalEvent,
                button: this
            });
            // For memorise exec
            if (result !== false && result !== true) {
                (_e = (_d = this.j) === null || _d === void 0 ? void 0 : _d.e) === null || _e === void 0 ? void 0 : _e.fire('synchro');
                if (this.parentElement) {
                    this.parentElement.update();
                }
                /**
                 * Fired after calling `button.exec` function
                 */ (_g = (_f = this.j) === null || _f === void 0 ? void 0 : _f.e) === null || _g === void 0 ? void 0 : _g.fire('closeAllPopups afterExec');
            }
            if (result !== false) {
                return;
            }
        }
        if (ctr.list) {
            return this.__openControlList(ctr);
        }
        if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isFunction)(ctr.popup)) {
            return this.onTriggerClick(originalEvent);
        }
        if (ctr.command || ctr.name) {
            (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.call)((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isJoditObject)(this.j) ? this.j.execCommand.bind(this.j) : this.j.od.execCommand.bind(this.j.od), ctr.command || ctr.name, false, ctr.args && ctr.args[0]);
            this.j.e.fire('closeAllPopups');
        }
    }
    destruct() {
        this.__closePopup();
        return super.destruct();
    }
    constructor(jodit, control, target = null){
        super(jodit);
        this.control = control;
        this.target = target;
        this.state = {
            ...(0,_core_ui_button_index_js__WEBPACK_IMPORTED_MODULE_4__/* .UIButtonState */ .ue)(),
            theme: 'toolbar',
            currentValue: '',
            hasTrigger: false
        };
        this.openedPopup = null;
        const button = this.getElm('button');
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.assert)(button, 'Element button should exists');
        this.button = button;
        Object.defineProperty(button, 'component', {
            value: this,
            configurable: true
        });
        const trigger = this.getElm('trigger');
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.assert)(trigger, 'Element trigger should exists');
        this.trigger = trigger;
        trigger.remove();
        // Prevent lost focus
        jodit.e.on([
            this.button,
            this.trigger
        ], 'mousedown', (e)=>e.preventDefault());
        this.onAction(this.onClick);
        this.hookStatus(_core_component_statuses_js__WEBPACK_IMPORTED_MODULE_0__/* .STATUSES */ .f.ready, ()=>{
            this.__initFromControl();
            this.update();
        });
        if (control.mods) {
            Object.keys(control.mods).forEach((mod)=>{
                control.mods && this.setMod(mod, control.mods[mod]);
            });
        }
    }
};
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.cacheHTML
], ToolbarButton.prototype, "createContainer", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)('state.hasTrigger', {
        immediately: false
    })
], ToolbarButton.prototype, "onChangeHasTrigger", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)('trigger:click')
], ToolbarButton.prototype, "onTriggerClick", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], ToolbarButton.prototype, "onOutsideClick", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], ToolbarButton.prototype, "__closePopup", null);
ToolbarButton = __decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.component
], ToolbarButton);



/***/ }),

/***/ 78720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   o: function() { return /* binding */ checkBlockNesting; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/**
 * Checks whether the insertion of an element at the current location is allowed,
 * if it is not allowed, it deletes an empty block element or moves the cursor after it
 * @internal
 */ function checkBlockNesting(jodit, node) {
    if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isFragment(node)) {
        node = node.firstChild;
    }
    if (jodit.o.dtd.checkBlockNesting && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isBlock(node)) {
        const parent = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.furthest(jodit.s.current(), _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isBlock, jodit.editor);
        if (parent && !jodit.o.dtd.blockLimits[parent.tagName.toLowerCase()]) {
            jodit.s.setCursorAfter(parent);
            if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isEmpty(parent)) {
                _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(parent);
            }
        }
    }
}


/***/ }),

/***/ 78818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B: function() { return /* binding */ History; }
/* harmony export */ });
/* harmony import */ var _core_component_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91907);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6441);
/* harmony import */ var _command_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92643);
/* harmony import */ var _snapshot_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52604);
/* harmony import */ var _stack_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57034);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.history = {
    enable: true,
    maxHistoryLength: Infinity,
    timeout: 1000
};
/**
 * The module monitors the status of the editor and creates / deletes the required number of Undo / Redo shots .
 */ class History extends _core_component_index_js__WEBPACK_IMPORTED_MODULE_0__/* .ViewComponent */ .vG {
    /** @override */ className() {
        return 'History';
    }
    /**
     * Return state of the WYSIWYG editor to step back
     */ redo() {
        if (this.__stack.redo()) {
            this.startValue = this.snapshot.make();
            this.fireChangeStack();
        }
    }
    canRedo() {
        return this.__stack.canRedo();
    }
    /**
     * Return the state of the WYSIWYG editor to step forward
     */ undo() {
        if (this.__stack.undo()) {
            this.startValue = this.snapshot.make();
            this.fireChangeStack();
        }
    }
    canUndo() {
        return this.__stack.canUndo();
    }
    clear() {
        this.startValue = this.snapshot.make();
        this.__stack.clear();
        this.fireChangeStack();
    }
    get length() {
        return this.__stack.length;
    }
    get startValue() {
        return this.__startValue;
    }
    set startValue(value) {
        this.__startValue = value;
    }
    /**
     * Update change counter
     * @internal
     */ __upTick() {
        this.updateTick += 1;
    }
    /**
     * Push new command in stack on some changes
     */ onChange() {
        this.__processChanges();
    }
    /**
     * @internal
     */ __processChanges() {
        if (this.snapshot.isBlocked || !this.j.o.history.enable) {
            return;
        }
        this.updateStack();
    }
    /**
     * Update history stack
     */ updateStack(replace = false) {
        const newValue = this.snapshot.make();
        if (!_snapshot_js__WEBPACK_IMPORTED_MODULE_3__/* .Snapshot */ .F.equal(newValue, this.startValue)) {
            const newCommand = new _command_js__WEBPACK_IMPORTED_MODULE_4__/* .Command */ .u(this.startValue, newValue, this, this.updateTick);
            if (replace) {
                const command = this.__stack.current();
                if (command && this.updateTick === command.tick) {
                    this.__stack.replace(newCommand);
                }
            } else {
                this.__stack.push(newCommand);
            }
            this.startValue = newValue;
            this.fireChangeStack();
        }
    }
    fireChangeStack() {
        var _a;
        this.j && !this.j.isInDestruct && ((_a = this.j.events) === null || _a === void 0 ? void 0 : _a.fire('changeStack'));
    }
    destruct() {
        if (this.isInDestruct) {
            return;
        }
        if (this.j.events) {
            this.j.e.off('.history');
        }
        this.snapshot.destruct();
        super.destruct();
    }
    constructor(editor, stack = new _stack_js__WEBPACK_IMPORTED_MODULE_5__/* .Stack */ .B(editor.o.history.maxHistoryLength), snapshot = new _snapshot_js__WEBPACK_IMPORTED_MODULE_3__/* .Snapshot */ .F(editor)){
        super(editor);
        this.updateTick = 0;
        this.__stack = stack;
        this.snapshot = snapshot;
        if (editor.o.history.enable) {
            editor.e.on('afterAddPlace.history', ()=>{
                if (this.isInDestruct) {
                    return;
                }
                this.startValue = this.snapshot.make();
                editor.events// save selection
                .on('internalChange internalUpdate', ()=>{
                    this.startValue = this.snapshot.make();
                }).on(editor.editor, [
                    'changeSelection',
                    'selectionstart',
                    'selectionchange',
                    'mousedown',
                    'mouseup',
                    'keydown',
                    'keyup'
                ].map((f)=>f + '.history').join(' '), ()=>{
                    if (this.startValue.html === this.j.getNativeEditorValue()) {
                        this.startValue = this.snapshot.make();
                    }
                }).on(this, 'change.history', this.onChange);
            });
        }
    }
}
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.debounce)()
], History.prototype, "onChange", null);


/***/ }),

/***/ 78927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   N: function() { return /* binding */ idle; }
/* harmony export */ });
/* harmony import */ var _component_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91907);
/* harmony import */ var _helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23282);
/* harmony import */ var _helpers_utils_error_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89890);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


function idle() {
    return (target, propertyKey)=>{
        if (!(0,_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_2__/* .isFunction */ .T)(target[propertyKey])) {
            throw (0,_helpers_utils_error_index_js__WEBPACK_IMPORTED_MODULE_1__/* .error */ .z3)('Handler must be a Function');
        }
        target.hookStatus(_component_index_js__WEBPACK_IMPORTED_MODULE_0__/* .STATUSES */ .f.ready, (component)=>{
            const { async } = component;
            const originalMethod = component[propertyKey];
            component[propertyKey] = (...args)=>async.requestIdleCallback(originalMethod.bind(component, ...args));
        });
    };
}


/***/ }),

/***/ 79348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   L: function() { return /* binding */ Selection; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2748);
/* harmony import */ var _helpers_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21537);
/* harmony import */ var _helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27613);
/* harmony import */ var _helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38837);
/* harmony import */ var _helpers_move_the_node_along_the_edge_outward_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43463);
/* harmony import */ var _style_commit_style_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25639);
/* harmony import */ var _helpers_index_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45124);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};











class Selection {
    /**
     * Short alias for this.jodit
     */ get j() {
        return this.jodit;
    }
    /**
     * Throw Error exception if parameter is not Node
     */ errorNode(node) {
        if (!_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isNode(node)) {
            throw (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.error)('Parameter node must be instance of Node');
        }
    }
    /**
     * Return current work place - for Jodit is Editor
     */ get area() {
        return this.j.editor;
    }
    /**
     * Editor Window - it can be different for iframe mode
     */ get win() {
        return this.j.ew;
    }
    /**
     * Current jodit editor doc
     */ get doc() {
        return this.j.ed;
    }
    /**
     * Return current selection object
     */ get sel() {
        if (this.j.o.shadowRoot && (0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_4__/* .isFunction */ .Tn)(this.j.o.shadowRoot.getSelection)) {
            return this.j.o.shadowRoot.getSelection();
        }
        return this.win.getSelection();
    }
    /**
     * Return first selected range or create new
     */ get range() {
        const sel = this.sel;
        return sel && sel.rangeCount ? sel.getRangeAt(0) : this.createRange();
    }
    /**
     * Checks if the selected text is currently inside the editor
     */ get isInsideArea() {
        const { sel } = this;
        const range = (sel === null || sel === void 0 ? void 0 : sel.rangeCount) ? sel.getRangeAt(0) : null;
        return !(!range || !_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isOrContains(this.area, range.startContainer));
    }
    /**
     * Return current selection object
     * @param select - Immediately add in selection
     */ createRange(select = false) {
        const range = this.doc.createRange();
        if (select) {
            this.selectRange(range);
        }
        return range;
    }
    /**
     * Remove all selected content
     */ remove() {
        const sel = this.sel, current = this.current();
        if (sel && current) {
            for(let i = 0; i < sel.rangeCount; i += 1){
                sel.getRangeAt(i).deleteContents();
                sel.getRangeAt(i).collapse(true);
            }
        }
    }
    /**
     * Clear all selection
     */ clear() {
        var _a, _b;
        if ((_a = this.sel) === null || _a === void 0 ? void 0 : _a.rangeCount) {
            (_b = this.sel) === null || _b === void 0 ? void 0 : _b.removeAllRanges();
        }
    }
    /**
     * Remove node element from editor
     */ removeNode(node) {
        if (!_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isOrContains(this.j.editor, node, true)) {
            throw (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.error)("Selection.removeNode can remove only editor's children");
        }
        _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(node);
        this.j.e.fire('afterRemoveNode', node);
    }
    /**
     * Insert the cursor to any point x, y
     *
     * @param x - Coordinate by horizontal
     * @param y - Coordinate by vertical
     * @returns false - Something went wrong
     */ insertCursorAtPoint(x, y) {
        this.removeMarkers();
        try {
            const rng = this.createRange();
            (()=>{
                if (this.doc.caretPositionFromPoint) {
                    const caret = this.doc.caretPositionFromPoint(x, y);
                    if (caret) {
                        rng.setStart(caret.offsetNode, caret.offset);
                        return;
                    }
                }
                if (this.doc.caretRangeFromPoint) {
                    const caret = this.doc.caretRangeFromPoint(x, y);
                    (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_5__/* .assert */ .v)(caret, 'Incorrect caretRangeFromPoint behaviour');
                    rng.setStart(caret.startContainer, caret.startOffset);
                }
            })();
            rng.collapse(true);
            this.selectRange(rng);
            return true;
        } catch (_a) {}
        return false;
    }
    /**
     * Check if editor has selection markers
     */ get hasMarkers() {
        return Boolean(this.markers.length);
    }
    /**
     * Check if editor has selection markers
     */ get markers() {
        return (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.$$)('span[data-' + _constants_js__WEBPACK_IMPORTED_MODULE_0__.MARKER_CLASS + ']', this.area);
    }
    /**
     * Remove all markers
     */ removeMarkers() {
        _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove.apply(null, this.markers);
    }
    /**
     * Create marker element
     */ marker(atStart = false, range) {
        let newRange = null;
        if (range) {
            newRange = range.cloneRange();
            newRange.collapse(atStart);
        }
        const marker = this.j.createInside.span();
        marker.id = _constants_js__WEBPACK_IMPORTED_MODULE_0__.MARKER_CLASS + '_' + Number(new Date()) + '_' + String(Math.random()).slice(2);
        marker.style.lineHeight = '0';
        marker.style.display = 'none';
        _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.markTemporary(marker);
        (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(marker, 'data-' + _constants_js__WEBPACK_IMPORTED_MODULE_0__.MARKER_CLASS, atStart ? 'start' : 'end');
        marker.appendChild(this.j.createInside.text(_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE));
        if (newRange) {
            if (_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isOrContains(this.area, atStart ? newRange.startContainer : newRange.endContainer)) {
                // Here need do unsafe inserting
                // Deny Dom.safeInsertNode(newRange, marker);
                // Apply style -> Test Style module -> Base apply -> For selection <p><strong>|test|</strong></p> apply style {"element":"em","style":{"fontStyle":"italic"}}
                newRange.insertNode(marker);
            }
        }
        return marker;
    }
    /**
     * Restores user selections using marker invisible elements in the DOM.
     */ restore() {
        let range = false;
        const markAttr = (start)=>`span[data-${_constants_js__WEBPACK_IMPORTED_MODULE_0__.MARKER_CLASS}=${start ? 'start' : 'end'}]`;
        const start = this.area.querySelector(markAttr(true)), end = this.area.querySelector(markAttr(false));
        if (!start) {
            return;
        }
        range = this.createRange();
        if (!end) {
            const previousNode = start.previousSibling;
            if (_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isText(previousNode)) {
                range.setStart(previousNode, previousNode.nodeValue ? previousNode.nodeValue.length : 0);
            } else {
                range.setStartBefore(start);
            }
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(start);
            range.collapse(true);
        } else {
            range.setStartAfter(start);
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(start);
            range.setEndBefore(end);
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(end);
        }
        if (range) {
            this.selectRange(range);
        }
    }
    fakes() {
        const sel = this.sel;
        if (!sel || !sel.rangeCount) {
            return [];
        }
        const range = sel.getRangeAt(0);
        (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_5__/* .assert */ .v)(range, 'Range is null');
        const left = range.cloneRange();
        left.collapse(true);
        const fakeLeft = this.j.createInside.fake();
        _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeInsertNode(left, fakeLeft);
        range.setStartBefore(fakeLeft);
        const result = [
            fakeLeft
        ];
        if (!range.collapsed) {
            const right = range.cloneRange();
            right.collapse(false);
            const fakeRight = this.j.createInside.fake();
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeInsertNode(right, fakeRight);
            range.setEndAfter(fakeRight);
            result.push(fakeRight);
        }
        this.selectRange(range);
        return result;
    }
    restoreFakes(fakes) {
        var _a, _b, _c, _d;
        const nodes = fakes.filter((n)=>n.isConnected);
        if (!nodes.length) {
            return;
        }
        const [fakeLeft, fakeRight] = nodes;
        const range = this.createRange();
        range.setStartAfter(fakeLeft);
        if (fakeRight) {
            range.setEndBefore(fakeRight);
        }
        this.selectRange(range);
        if (((_a = fakeLeft.parentNode) === null || _a === void 0 ? void 0 : _a.firstChild) !== ((_b = fakeLeft.parentNode) === null || _b === void 0 ? void 0 : _b.lastChild)) {
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(fakeLeft);
        }
        if (((_c = fakeRight === null || fakeRight === void 0 ? void 0 : fakeRight.parentNode) === null || _c === void 0 ? void 0 : _c.firstChild) !== ((_d = fakeRight === null || fakeRight === void 0 ? void 0 : fakeRight.parentNode) === null || _d === void 0 ? void 0 : _d.lastChild)) {
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(fakeRight);
        }
    }
    /**
     * Saves selections using marker invisible elements in the DOM.
     * @param silent - Do not change current range
     */ save(silent = false) {
        if (this.hasMarkers) {
            return [];
        }
        const sel = this.sel;
        if (!sel || !sel.rangeCount) {
            return [];
        }
        const info = [], length = sel.rangeCount, ranges = [];
        for(let i = 0; i < length; i += 1){
            ranges[i] = sel.getRangeAt(i);
            if (ranges[i].collapsed) {
                const start = this.marker(true, ranges[i]);
                info[i] = {
                    startId: start.id,
                    collapsed: true,
                    startMarker: start.outerHTML
                };
            } else {
                const start = this.marker(true, ranges[i]);
                const end = this.marker(false, ranges[i]);
                info[i] = {
                    startId: start.id,
                    endId: end.id,
                    collapsed: false,
                    startMarker: start.outerHTML,
                    endMarker: end.outerHTML
                };
            }
        }
        if (!silent) {
            sel.removeAllRanges();
            for(let i = length - 1; i >= 0; --i){
                const startElm = this.doc.getElementById(info[i].startId);
                if (!startElm) {
                    continue;
                }
                if (info[i].collapsed) {
                    ranges[i].setStartAfter(startElm);
                    ranges[i].collapse(true);
                } else {
                    ranges[i].setStartBefore(startElm);
                    if (info[i].endId) {
                        const endElm = this.doc.getElementById(info[i].endId);
                        if (endElm) {
                            ranges[i].setEndAfter(endElm);
                        }
                    }
                }
                try {
                    sel.addRange(ranges[i].cloneRange());
                } catch (_a) {}
            }
        }
        return info;
    }
    /**
     * Set focus in editor
     */ focus(options = {
        preventScroll: true
    }) {
        var _a, _b;
        if (!this.isFocused()) {
            const scrollParent = (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.getScrollParent)(this.j.container), scrollTop = scrollParent === null || scrollParent === void 0 ? void 0 : scrollParent.scrollTop;
            if (this.j.iframe) {
                if (this.doc.readyState === 'complete') {
                    this.j.iframe.focus(options);
                }
            }
            this.win.focus();
            this.area.focus(options);
            if (scrollTop && (scrollParent === null || scrollParent === void 0 ? void 0 : scrollParent.scrollTo)) {
                scrollParent.scrollTo(0, scrollTop);
            }
            const sel = this.sel, range = (sel === null || sel === void 0 ? void 0 : sel.rangeCount) ? sel === null || sel === void 0 ? void 0 : sel.getRangeAt(0) : null;
            if (!range || !_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isOrContains(this.area, range.startContainer)) {
                const range = this.createRange();
                range.setStart(this.area, 0);
                range.collapse(true);
                this.selectRange(range, false);
            }
            if (!this.j.editorIsActive) {
                (_b = (_a = this.j) === null || _a === void 0 ? void 0 : _a.events) === null || _b === void 0 ? void 0 : _b.fire('focus');
            }
            return true;
        }
        return false;
    }
    /**
     * Checks whether the current selection is something or just set the cursor is
     * @returns true Selection does't have content
     */ isCollapsed() {
        const sel = this.sel;
        for(let r = 0; sel && r < sel.rangeCount; r += 1){
            if (!sel.getRangeAt(r).collapsed) {
                return false;
            }
        }
        return true;
    }
    /**
     * Checks whether the editor currently in focus
     */ isFocused() {
        return this.doc.hasFocus && this.doc.hasFocus() && this.area === this.doc.activeElement;
    }
    /**
     * Returns the current element under the cursor inside editor
     */ current(checkChild = true) {
        if (this.j.getRealMode() !== _constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_WYSIWYG) {
            return null;
        }
        const sel = this.sel;
        if (!sel || sel.rangeCount === 0) {
            return null;
        }
        const range = sel.getRangeAt(0);
        let node = range.startContainer;
        let rightMode = false;
        const child = (nd)=>rightMode ? nd.lastChild : nd.firstChild;
        if (_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isTag(node, 'br') && sel.isCollapsed) {
            return node;
        }
        if (!_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isText(node)) {
            const ret = (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_8__/* .findCorrectCurrentNode */ .dY)(node, range, rightMode, sel.isCollapsed, checkChild, child);
            node = ret.node;
            rightMode = ret.rightMode;
        }
        // check - cursor inside editor
        if (node && _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isOrContains(this.area, node)) {
            return node;
        }
        return null;
    }
    /**
     * Insert element in editor
     *
     * @param node - Node for insert
     * @param insertCursorAfter - After insert, cursor will move after element
     * @param fireChange - After insert, editor fire change event. You can prevent this behavior
     */ insertNode(node, insertCursorAfter = true, fireChange = true) {
        this.errorNode(node);
        const child = _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isFragment(node) ? node.lastChild : node;
        this.j.e.fire('safeHTML', node);
        if (!this.isFocused() && this.j.isEditorMode()) {
            this.focus();
            this.restore();
        }
        const sel = this.sel;
        this.j.history.snapshot.transaction(()=>{
            if (!this.isCollapsed()) {
                this.j.execCommand('Delete');
            }
            this.j.e.fire('beforeInsertNode', node);
            if (sel && sel.rangeCount) {
                const range = sel.getRangeAt(0);
                if (_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isOrContains(this.area, range.commonAncestorContainer)) {
                    _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeInsertNode(range, node);
                } else {
                    this.area.appendChild(node);
                }
            } else {
                this.area.appendChild(node);
            }
            const setCursor = (node)=>{
                if (_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isBlock(node)) {
                    const child = node.lastChild;
                    if (child) {
                        return setCursor(child);
                    }
                }
                this.setCursorAfter(node);
            };
            if (insertCursorAfter) {
                if (_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isFragment(node)) {
                    child && setCursor(child);
                } else {
                    setCursor(node);
                }
            }
            if (this.j.o.scrollToPastedContent) {
                (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.scrollIntoViewIfNeeded)(child !== null && child !== void 0 ? child : node, this.j.editor, this.doc);
            }
        });
        if (fireChange && this.j.events) {
            this.j.__imdSynchronizeValues();
        }
        if (this.j.events) {
            this.j.e.fire('afterInsertNode', _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isFragment(node) ? child : node);
        }
    }
    /**
     * Inserts in the current cursor position some HTML snippet
     *
     * @param html - HTML The text to be inserted into the document
     * @param insertCursorAfter - After insert, cursor will move after element
     * @example
     * ```javascript
     * parent.s.insertHTML('<img src="image.png"/>');
     * ```
     */ insertHTML(html, insertCursorAfter = true) {
        if (html === '') {
            return;
        }
        const node = this.j.createInside.div();
        const fragment = this.j.createInside.fragment();
        let lastChild;
        if (!this.isFocused() && this.j.isEditorMode()) {
            this.focus();
            this.restore();
        }
        if (!_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isNode(html)) {
            node.innerHTML = html.toString();
        } else {
            node.appendChild(html);
        }
        if (!this.j.isEditorMode() && this.j.e.fire('insertHTML', node.innerHTML) === false) {
            return;
        }
        lastChild = node.lastChild;
        if (!lastChild) {
            return;
        }
        while(node.firstChild){
            lastChild = node.firstChild;
            fragment.appendChild(node.firstChild);
        }
        this.insertNode(fragment, insertCursorAfter, false);
        // There is no need to use synchronizeValues because you need to apply the changes immediately
        this.j.__imdSynchronizeValues();
    }
    /**
     * Insert image in editor
     *
     * @param url - URL for image, or HTMLImageElement
     * @param styles - If specified, it will be applied <code>$(image).css(styles)</code>
     * @param defaultWidth - If specified, it will be applied <code>css('width', defaultWidth)</code>
     */ insertImage(url, styles = null, defaultWidth = null) {
        const image = (0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_4__/* .isString */ .Kg)(url) ? this.j.createInside.element('img') : url;
        if ((0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_4__/* .isString */ .Kg)(url)) {
            image.setAttribute('src', url);
        }
        if (defaultWidth != null) {
            let dw = defaultWidth.toString();
            if (dw && 'auto' !== dw && String(dw).indexOf('px') < 0 && String(dw).indexOf('%') < 0) {
                dw += 'px';
            }
            (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(image, 'width', dw);
        }
        if (styles && typeof styles === 'object') {
            (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(image, styles);
        }
        const onload = ()=>{
            if (image.naturalHeight < image.offsetHeight || image.naturalWidth < image.offsetWidth) {
                image.style.width = '';
                image.style.height = '';
            }
            image.removeEventListener('load', onload);
        };
        this.j.e.on(image, 'load', onload);
        if (image.complete) {
            onload();
        }
        this.insertNode(image);
        /**
         * Triggered after image was inserted [[Select.insertImage]]. This method can executed from
         * [[FileBrowser]] or [[Uploader]]
         * @example
         * ```javascript
         * const editor = Jodit.make("#redactor");
         * editor.e.on('afterInsertImage', function (image) {
         *     image.className = 'bloghead4';
         * });
         * ```
         */ this.j.e.fire('afterInsertImage', image);
    }
    /**
     * Call callback for all selection node
     */ // eslint-disable-next-line complexity
    eachSelection(callback) {
        var _a;
        const sel = this.sel;
        if (!sel || !sel.rangeCount) {
            return;
        }
        const range = sel.getRangeAt(0);
        let root = range.commonAncestorContainer;
        if (!_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isHTMLElement(root)) {
            root = root.parentElement;
        }
        const nodes = [];
        const startOffset = range.startOffset;
        const length = root.childNodes.length;
        const elementOffset = startOffset < length ? startOffset : length - 1;
        let start = range.startContainer === this.area ? root.childNodes[elementOffset] : range.startContainer;
        let end = range.endContainer === this.area ? root.childNodes[range.endOffset - 1] : range.endContainer;
        if (_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isText(start) && start === range.startContainer && range.startOffset === ((_a = start.nodeValue) === null || _a === void 0 ? void 0 : _a.length) && start.nextSibling) {
            start = start.nextSibling;
        }
        if (_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isText(end) && end === range.endContainer && range.endOffset === 0 && end.previousSibling) {
            end = end.previousSibling;
        }
        const checkElm = (node)=>{
            if (node && node !== root && !_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isEmptyTextNode(node) && !(0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_4__/* .isMarker */ .rg)(node)) {
                nodes.push(node);
            }
        };
        checkElm(start);
        if (start !== end && _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isOrContains(root, start, true)) {
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.find(start, (node)=>{
                checkElm(node);
                // checks parentElement as well because partial selections are not equal to entire element
                return node === end || node && node.contains && node.contains(end);
            }, root, true, false);
        }
        const forEvery = (current)=>{
            if (!_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isOrContains(this.j.editor, current, true)) {
                return;
            }
            if (current.nodeName.match(/^(UL|OL)$/)) {
                return (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.toArray)(current.childNodes).forEach(forEvery);
            }
            if (_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isTag(current, 'li')) {
                if (current.firstChild) {
                    current = current.firstChild;
                } else {
                    const currentB = this.j.createInside.text(_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE);
                    current.appendChild(currentB);
                    current = currentB;
                }
            }
            callback(current);
        };
        if (nodes.length === 0) {
            if (_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isEmptyTextNode(start)) {
                nodes.push(start);
            }
            if (start.firstChild) {
                nodes.push(start.firstChild);
            }
        }
        nodes.forEach(forEvery);
    }
    /**
     * Checks if the cursor is at the end(start) block
     *
     * @param  start - true - check whether the cursor is at the start block
     * @param parentBlock - Find in this
     * @param fake - Node for cursor position
     *
     * @returns true - the cursor is at the end(start) block, null - cursor somewhere outside
     */ cursorInTheEdge(start, parentBlock, fake = null) {
        var _a;
        const end = !start, range = (_a = this.sel) === null || _a === void 0 ? void 0 : _a.getRangeAt(0);
        fake !== null && fake !== void 0 ? fake : fake = this.current(false);
        if (!range || !fake || !_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isOrContains(parentBlock, fake, true)) {
            return null;
        }
        const container = start ? range.startContainer : range.endContainer;
        const offset = start ? range.startOffset : range.endOffset;
        const isSignificant = (elm)=>Boolean(elm && !_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isTag(elm, 'br') && !_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isEmptyTextNode(elm) && !_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isTemporary(elm) && !(_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isElement(elm) && this.j.e.fire('isInvisibleForCursor', elm) === true));
        // check right offset
        if (_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isText(container)) {
            if ((0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_8__/* .cursorInTheEdgeOfString */ .Qe)(container, offset, start, end)) {
                return false;
            }
        } else {
            const children = (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.toArray)(container.childNodes);
            if (end) {
                if (children.slice(offset).some(isSignificant)) {
                    return false;
                }
            } else {
                if (children.slice(0, offset).some(isSignificant)) {
                    return false;
                }
            }
        }
        let next = fake;
        while(next && next !== parentBlock){
            const nextOne = _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.sibling(next, start);
            if (!nextOne) {
                next = next.parentNode;
                continue;
            }
            next = nextOne;
            if (next && isSignificant(next)) {
                return false;
            }
        }
        return true;
    }
    /**
     * Wrapper for cursorInTheEdge
     */ cursorOnTheLeft(parentBlock, fake) {
        return this.cursorInTheEdge(true, parentBlock, fake);
    }
    /**
     * Wrapper for cursorInTheEdge
     */ cursorOnTheRight(parentBlock, fake) {
        return this.cursorInTheEdge(false, parentBlock, fake);
    }
    /**
     * Set cursor after the node
     * @returns fake invisible textnode. After insert it can be removed
     */ setCursorAfter(node) {
        return this.setCursorNearWith(node, false);
    }
    /**
     * Set cursor before the node
     * @returns fake invisible textnode. After insert it can be removed
     */ setCursorBefore(node) {
        return this.setCursorNearWith(node, true);
    }
    /**
     * Add fake node for new cursor position
     */ setCursorNearWith(node, inStart) {
        var _a, _b;
        this.errorNode(node);
        if (!_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.up(node, (elm)=>elm === this.area || elm && elm.parentNode === this.area, this.area)) {
            throw (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.error)('Node element must be in editor');
        }
        const range = this.createRange();
        let fakeNode = null;
        if (!_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isText(node)) {
            fakeNode = this.j.createInside.fake();
            inStart ? range.setStartBefore(node) : range.setEndAfter(node);
            range.collapse(inStart);
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeInsertNode(range, fakeNode);
            range.selectNode(fakeNode);
        } else {
            if (inStart) {
                range.setStart(node, 0);
            } else {
                range.setEnd(node, (_b = (_a = node.nodeValue) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0);
            }
        }
        range.collapse(inStart);
        this.selectRange(range);
        return fakeNode;
    }
    /**
     * Set cursor in the node
     * @param node - Node element
     * @param inStart - set cursor in start of element
     */ setCursorIn(node, inStart = false) {
        this.errorNode(node);
        if (!_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.up(node, (elm)=>elm === this.area || elm && elm.parentNode === this.area, this.area)) {
            throw (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.error)('Node element must be in editor');
        }
        const range = this.createRange();
        let start = node, last = node;
        do {
            if (_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isText(start) || _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isTag(start, _constants_js__WEBPACK_IMPORTED_MODULE_0__.INSEPARABLE_TAGS)) {
                break;
            }
            last = start;
            start = inStart ? start.firstChild : start.lastChild;
        }while (start)
        if (!start) {
            const fakeNode = this.j.createInside.text(_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE);
            if (!_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isTag(last, _constants_js__WEBPACK_IMPORTED_MODULE_0__.INSEPARABLE_TAGS)) {
                last.appendChild(fakeNode);
                last = fakeNode;
            } else {
                start = last;
            }
        }
        const workElm = start || last;
        if (!_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isTag(workElm, _constants_js__WEBPACK_IMPORTED_MODULE_0__.INSEPARABLE_TAGS)) {
            range.selectNodeContents(workElm);
            range.collapse(inStart);
        } else {
            inStart || _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isTag(workElm, 'br') ? range.setStartBefore(workElm) : range.setEndAfter(workElm);
            range.collapse(inStart);
        }
        this.selectRange(range);
        return last;
    }
    /**
     * Set range selection
     */ selectRange(range, focus = true) {
        const sel = this.sel;
        if (focus && !this.isFocused()) {
            this.focus();
        }
        if (sel) {
            sel.removeAllRanges();
            sel.addRange(range);
        }
        /**
         * Fired after change selection
         */ this.j.e.fire('changeSelection');
        return this;
    }
    /**
     * Select node
     * @param node - Node element
     * @param inward - select all inside
     */ select(node, inward = false) {
        this.errorNode(node);
        if (!_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.up(node, (elm)=>elm === this.area || elm && elm.parentNode === this.area, this.area)) {
            throw (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.error)('Node element must be in editor');
        }
        const range = this.createRange();
        range[inward ? 'selectNodeContents' : 'selectNode'](node);
        return this.selectRange(range);
    }
    /**
     * Return current selected HTML
     * @example
     * ```javascript
     * const editor = Jodit.make();
     * console.log(editor.s.html); // html
     * console.log(Jodit.modules.Helpers.stripTags(editor.s.html)); // plain text
     * ```
     */ get html() {
        const sel = this.sel;
        if (sel && sel.rangeCount > 0) {
            const range = sel.getRangeAt(0);
            const clonedSelection = range.cloneContents();
            const div = this.j.createInside.div();
            div.appendChild(clonedSelection);
            return div.innerHTML;
        }
        return '';
    }
    /**
     * Wrap all selected fragments inside Tag or apply some callback
     */ *wrapInTagGen(fakes) {
        if (this.isCollapsed()) {
            const font = this.jodit.createInside.element('font', _constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE);
            this.insertNode(font, false, false);
            if (fakes && fakes[0]) {
                font.appendChild(fakes[0]);
            }
            yield font;
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.unwrap(font);
            return;
        }
        // fix issue https://github.com/xdan/jodit/issues/65
        (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.$$)('*[style*=font-size]', this.area).forEach((elm)=>{
            (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(elm, 'data-font-size', elm.style.fontSize.toString());
            elm.style.removeProperty('font-size');
        });
        this.j.nativeExecCommand('fontsize', false, '7');
        (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.$$)('*[data-font-size]', this.area).forEach((elm)=>{
            const fontSize = (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(elm, 'data-font-size');
            if (fontSize) {
                elm.style.fontSize = fontSize;
                (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(elm, 'data-font-size', null);
            }
        });
        const elms = (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.$$)('font[size="7"]', this.area);
        for (const font of elms){
            const { firstChild, lastChild } = font;
            if (firstChild && firstChild === lastChild && (0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_4__/* .isMarker */ .rg)(firstChild)) {
                _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.unwrap(font);
                continue;
            }
            if (firstChild && (0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_4__/* .isMarker */ .rg)(firstChild)) {
                _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.before(font, firstChild);
            }
            if (lastChild && (0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_4__/* .isMarker */ .rg)(lastChild)) {
                _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.after(font, lastChild);
            }
            yield font;
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.unwrap(font);
        }
        return;
    }
    /**
     * Wrap all selected fragments inside Tag or apply some callback
     */ wrapInTag(tagOrCallback) {
        const result = [];
        for (const font of this.wrapInTagGen()){
            try {
                if (font.firstChild && font.firstChild === font.lastChild && (0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_4__/* .isMarker */ .rg)(font.firstChild)) {
                    continue;
                }
                if ((0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_4__/* .isFunction */ .Tn)(tagOrCallback)) {
                    tagOrCallback(font);
                } else {
                    result.push(_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.replace(font, tagOrCallback, this.j.createInside));
                }
            } finally{
                const pn = font.parentNode;
                if (pn) {
                    _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.unwrap(font);
                    if (_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isEmpty(pn)) {
                        _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.unwrap(pn);
                    }
                }
            }
        }
        return result;
    }
    /**
     * Apply some css rules for all selections. It method wraps selections in nodeName tag.
     * @example
     * ```js
     * const editor = Jodit.make('#editor');
     * editor.value = 'test';
     * editor.execCommand('selectall');
     *
     * editor.s.commitStyle({
     * 	style: {color: 'red'}
     * }) // will wrap `text` in `span` and add style `color:red`
     * editor.s.commitStyle({
     * 	style: {color: 'red'}
     * }) // will remove `color:red` from `span`
     * ```
     */ commitStyle(options) {
        (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_5__/* .assert */ .v)((0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.size)(options) > 0, 'Need to pass at least one option');
        const styleElm = new _style_commit_style_js__WEBPACK_IMPORTED_MODULE_7__/* .CommitStyle */ .x(options);
        styleElm.apply(this.j);
    }
    /**
     * Split selection on two parts: left and right
     */ splitSelection(currentBox, edge) {
        if (!this.isCollapsed()) {
            return null;
        }
        const leftRange = this.createRange();
        const range = this.range;
        leftRange.setStartBefore(currentBox);
        const cursorOnTheRight = this.cursorOnTheRight(currentBox, edge);
        const cursorOnTheLeft = this.cursorOnTheLeft(currentBox, edge);
        const br = this.j.createInside.element('br'), prevFake = this.j.createInside.fake(), nextFake = prevFake.cloneNode();
        try {
            if (cursorOnTheRight || cursorOnTheLeft) {
                if (edge) {
                    _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.before(edge, br);
                } else {
                    _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeInsertNode(range, br);
                }
                const clearBR = (start, getNext)=>{
                    let next = getNext(start);
                    while(next){
                        const nextSib = getNext(next);
                        if (next && (_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isTag(next, 'br') || _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isEmptyTextNode(next))) {
                            _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(next);
                        } else {
                            break;
                        }
                        next = nextSib;
                    }
                };
                clearBR(br, (n)=>n.nextSibling);
                clearBR(br, (n)=>n.previousSibling);
                _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.after(br, nextFake);
                _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.before(br, prevFake);
                if (cursorOnTheRight) {
                    leftRange.setEndBefore(br);
                    range.setEndBefore(br);
                } else {
                    leftRange.setEndAfter(br);
                    range.setEndAfter(br);
                }
            } else {
                leftRange.setEnd(range.startContainer, range.startOffset);
            }
            const fragment = leftRange.extractContents();
            const clearEmpties = (node)=>_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.each(node, (node)=>_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isEmptyTextNode(node) && _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(node));
            (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_5__/* .assert */ .v)(currentBox.parentNode, 'Splitting fails');
            try {
                clearEmpties(fragment);
                clearEmpties(currentBox);
                currentBox.parentNode.insertBefore(fragment, currentBox);
                if (!edge && cursorOnTheRight && (br === null || br === void 0 ? void 0 : br.parentNode)) {
                    const range = this.createRange();
                    range.setStartBefore(br);
                    this.selectRange(range);
                }
            } catch (e) {
                if (!_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD) {
                    throw e;
                }
            }
            // After splitting some part can be empty
            const fillFakeParent = (fake)=>{
                var _a, _b, _c;
                if (((_a = fake === null || fake === void 0 ? void 0 : fake.parentNode) === null || _a === void 0 ? void 0 : _a.firstChild) === ((_b = fake === null || fake === void 0 ? void 0 : fake.parentNode) === null || _b === void 0 ? void 0 : _b.lastChild)) {
                    (_c = fake === null || fake === void 0 ? void 0 : fake.parentNode) === null || _c === void 0 ? void 0 : _c.appendChild(br.cloneNode());
                }
            };
            fillFakeParent(prevFake);
            fillFakeParent(nextFake);
        } finally{
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(prevFake);
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(nextFake);
        }
        return currentBox.previousElementSibling;
    }
    expandSelection() {
        if (this.isCollapsed()) {
            return this;
        }
        const { range } = this;
        const c = range.cloneRange();
        if (!_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isOrContains(this.j.editor, range.commonAncestorContainer, true)) {
            return this;
        }
        const moveMaxEdgeFake = (start)=>{
            const fake = this.j.createInside.fake();
            const r = range.cloneRange();
            r.collapse(start);
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeInsertNode(r, fake);
            (0,_helpers_move_the_node_along_the_edge_outward_js__WEBPACK_IMPORTED_MODULE_6__/* .moveTheNodeAlongTheEdgeOutward */ .G)(fake, start, this.j.editor);
            return fake;
        };
        const leftFake = moveMaxEdgeFake(true);
        const rightFake = moveMaxEdgeFake(false);
        c.setStartAfter(leftFake);
        c.setEndBefore(rightFake);
        const leftBox = _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.findSibling(leftFake, false);
        const rightBox = _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.findSibling(rightFake, true);
        if (leftBox !== rightBox) {
            const rightInsideLeft = _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isElement(leftBox) && _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isOrContains(leftBox, rightFake);
            const leftInsideRight = !rightInsideLeft && _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isElement(rightBox) && _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isOrContains(rightBox, leftFake);
            if (rightInsideLeft || leftInsideRight) {
                let child = rightInsideLeft ? leftBox : rightBox, container = child;
                while(_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isElement(child)){
                    child = rightInsideLeft ? child.firstElementChild : child.lastElementChild;
                    if (child) {
                        const isInside = rightInsideLeft ? _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isOrContains(child, rightFake) : _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isOrContains(child, leftFake);
                        if (isInside) {
                            container = child;
                        }
                    }
                }
                if (rightInsideLeft) {
                    c.setStart(container, 0);
                } else {
                    c.setEnd(container, container.childNodes.length);
                }
            }
        }
        this.selectRange(c);
        _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(leftFake, rightFake);
        if (this.isCollapsed()) {
            throw (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.error)('Selection is collapsed');
        }
        return this;
    }
    constructor(jodit){
        this.jodit = jodit;
        jodit.e.on('removeMarkers', ()=>{
            this.removeMarkers();
        });
    }
}
__decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], Selection.prototype, "createRange", null);
__decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], Selection.prototype, "focus", null);
__decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], Selection.prototype, "setCursorAfter", null);
__decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], Selection.prototype, "setCursorBefore", null);
__decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], Selection.prototype, "setCursorIn", null);


/***/ }),

/***/ 79419:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6441);
/* harmony import */ var _icons_copy_svg_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94775);
/* harmony import */ var _icons_cut_svg_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23140);
/* harmony import */ var _icons_paste_svg_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92699);
/* harmony import */ var _icons_select_all_svg_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10052);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 





_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.controls.cut = {
    command: 'cut',
    isDisabled: (editor)=>editor.s.isCollapsed(),
    tooltip: 'Cut selection'
};
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.controls.copy = {
    command: 'copy',
    isDisabled: (editor)=>editor.s.isCollapsed(),
    tooltip: 'Copy selection'
};
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.controls.selectall = {
    icon: 'select-all',
    command: 'selectall',
    tooltip: 'Select all'
};
_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_0__/* .Icon */ .I.set('copy', _icons_copy_svg_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A).set('cut', _icons_cut_svg_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A).set('paste', _icons_paste_svg_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A).set('select-all', _icons_select_all_svg_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A);


/***/ }),

/***/ 79799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export paste */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2748);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21537);
/* harmony import */ var _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20356);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84380);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(117);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








/**
 * Ask before paste HTML source
 */ class paste extends _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_5__/* .Plugin */ .k {
    /** @override **/ afterInit(jodit) {
        jodit.e.on('paste.paste', this.onPaste).on('pasteStack.paste', (item)=>this.pasteStack.push(item));
        if (jodit.o.nl2brInPlainText) {
            this.j.e.on('processPaste.paste', this.onProcessPasteReplaceNl2Br);
        }
    }
    /** @override **/ beforeDestruct(jodit) {
        jodit.e.off('paste.paste', this.onPaste).off('processPaste.paste', this.onProcessPasteReplaceNl2Br).off('.paste');
    }
    /**
     * Paste event handler
     */ onPaste(e) {
        try {
            if (this.customPasteProcess(e) === false || this.j.e.fire('beforePaste', e) === false) {
                e.preventDefault();
                return false;
            }
            this.defaultPasteProcess(e);
        } finally{
            this.j.e.fire('afterPaste', e);
        }
    }
    /**
     * Process before paste
     */ customPasteProcess(e) {
        if (!this.j.o.processPasteHTML) {
            return;
        }
        const dt = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.getDataTransfer)(e), texts = [
            dt === null || dt === void 0 ? void 0 : dt.getData(_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.TEXT_PLAIN),
            dt === null || dt === void 0 ? void 0 : dt.getData(_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.TEXT_HTML),
            dt === null || dt === void 0 ? void 0 : dt.getData(_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.TEXT_RTF)
        ];
        for (const value of texts){
            if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.isHTML)(value) && (this.j.e.fire('processHTML', e, value, {
                plain: texts[0],
                html: texts[1],
                rtf: texts[2]
            }) || this.processHTML(e, value))) {
                return false;
            }
        }
    }
    /**
     * Default paster process
     */ defaultPasteProcess(e) {
        const dt = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.getDataTransfer)(e);
        let text = (dt === null || dt === void 0 ? void 0 : dt.getData(_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.TEXT_HTML)) || (dt === null || dt === void 0 ? void 0 : dt.getData(_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.TEXT_PLAIN));
        if (dt && text && (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.trim)(text) !== '') {
            const result = this.j.e.fire('processPaste', e, text, (0,_helpers_js__WEBPACK_IMPORTED_MODULE_7__/* .getAllTypes */ .DI)(dt));
            if (result !== undefined) {
                text = result;
            }
            if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.isString)(text) || _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isNode(text)) {
                this.__insertByType(e, text, this.j.o.defaultActionOnPaste);
            }
            e.preventDefault();
            e.stopPropagation();
        }
    }
    /**
     * Process usual HTML text fragment
     */ processHTML(e, html) {
        if (!this.j.o.askBeforePasteHTML) {
            return false;
        }
        if (this.j.o.memorizeChoiceWhenPasteFragment) {
            const cached = this.pasteStack.find((cachedItem)=>cachedItem.html === html);
            if (cached) {
                this.__insertByType(e, html, cached.action || this.j.o.defaultActionOnPaste);
                return true;
            }
        }
        if (this._isDialogOpened) {
            return true;
        }
        const dialog = (0,_helpers_js__WEBPACK_IMPORTED_MODULE_7__/* .askInsertTypeDialog */ .PU)(this.j, 'Your code is similar to HTML. Keep as HTML?', 'Paste as HTML', (insertType)=>{
            this._isDialogOpened = false;
            this.__insertByType(e, html, insertType);
        }, this.j.o.pasteHTMLActionList);
        if (dialog) {
            this._isDialogOpened = true;
            dialog.e.on('beforeClose', ()=>{
                this._isDialogOpened = false;
            });
        }
        return true;
    }
    /**
     * Insert HTML by option type
     */ __insertByType(e, html, action) {
        this.pasteStack.push({
            html,
            action
        });
        if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.isString)(html)) {
            this.j.buffer.set(_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.CLIPBOARD_ID, html);
            switch(action){
                case _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INSERT_CLEAR_HTML:
                    html = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.cleanFromWord)(html);
                    break;
                case _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INSERT_ONLY_TEXT:
                    html = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.stripTags)(html, this.j.ed, new Set(this.j.o.pasteExcludeStripTags));
                    break;
                case _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INSERT_AS_TEXT:
                    html = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.htmlspecialchars)(html);
                    break;
                default:
                    {
                        const newHTML = this.j.e.fire('onCustomPasteHTMLOption', action, html, e);
                        if (typeof newHTML === 'string') {
                            html = newHTML;
                        }
                    }
            }
        }
        (0,_helpers_js__WEBPACK_IMPORTED_MODULE_7__/* .pasteInsertHtml */ .sX)(e, this.j, html);
    }
    /**
     * Replace all \\n chars in plain text to br
     */ onProcessPasteReplaceNl2Br(ignore, text, type) {
        if (type === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.TEXT_PLAIN + ';' && !(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.isHTML)(text)) {
            return (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.nl2br)(text);
        }
    }
    constructor(){
        super(...arguments);
        this.pasteStack = new _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__.LimitedStack(20);
        /**
         * The dialog box was already open
         */ this._isDialogOpened = false;
    }
}
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], paste.prototype, "onPaste", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], paste.prototype, "onProcessPasteReplaceNl2Br", null);
_core_global_js__WEBPACK_IMPORTED_MODULE_3__/* .pluginSystem */ .fg.add('paste', paste);


/***/ }),

/***/ 79910:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'Type something': 'إبدأ في الكتابة...',
    'About Jodit': 'حول جوديت',
    'Jodit Editor': 'محرر جوديت',
    "Jodit User's Guide": 'دليل مستخدم جوديت',
    'contains detailed help for using': 'يحتوي على مساعدة مفصلة للاستخدام',
    'For information about the license, please go to our website:': 'للحصول على معلومات حول الترخيص، يرجى الذهاب لموقعنا:',
    'Buy full version': 'شراء النسخة الكاملة',
    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.': 'حقوق الطبع والنشر © XDSoft.net - Chupurnov Valeriy. كل الحقوق محفوظة.',
    Anchor: 'مِرْساة',
    'Open in new tab': 'فتح في نافذة جديدة',
    'Open in fullsize': 'فتح المحرر في الحجم الكامل',
    'Clear Formatting': 'مسح التنسيق',
    'Fill color or set the text color': 'ملء اللون أو تعيين لون النص',
    Redo: 'إعادة',
    Undo: 'تراجع',
    Bold: 'عريض',
    Italic: 'مائل',
    'Insert Unordered List': 'إدراج قائمة غير مرتبة',
    'Insert Ordered List': 'إدراج قائمة مرتبة',
    'Align Center': 'محاذاة للوسط',
    'Align Justify': 'محاذاة مثبتة',
    'Align Left': 'محاذاة لليسار',
    'Align Right': 'محاذاة لليمين',
    'Insert Horizontal Line': 'إدراج خط أفقي',
    'Insert Image': 'إدراج صورة',
    'Insert file': 'ادخال الملف',
    'Insert youtube/vimeo video': 'إدراج فيديو يوتيوب/فيميو ',
    'Insert link': 'إدراج رابط',
    'Font size': 'حجم الخط',
    'Font family': 'نوع الخط',
    'Insert format block': 'إدراج كتلة تنسيق',
    Normal: 'عادي',
    'Heading 1': 'عنوان 1',
    'Heading 2': 'عنوان 2',
    'Heading 3': 'عنوان 3',
    'Heading 4': 'عنوان 4',
    Quote: 'إقتباس',
    Code: 'كود',
    Insert: 'إدراج',
    'Insert table': 'إدراج جدول',
    'Decrease Indent': 'تقليل المسافة البادئة',
    'Increase Indent': 'زيادة المسافة البادئة',
    'Select Special Character': 'تحديد أحرف خاصة',
    'Insert Special Character': 'إدراج حرف خاص',
    'Paint format': 'تنسيق الرسم',
    'Change mode': 'تغيير الوضع',
    Margins: 'هوامش',
    top: 'أعلى',
    right: 'يمين',
    bottom: 'أسفل',
    left: 'يسار',
    Styles: 'الأنماط',
    Classes: 'الطبقات',
    Align: 'محاذاة',
    Right: 'اليمين',
    Center: 'الوسط',
    Left: 'اليسار',
    '--Not Set--': '--غير مضبوط--',
    Src: 'Src',
    Title: 'العنوان',
    Alternative: 'العنوان البديل',
    Link: 'الرابط',
    'Open link in new tab': 'افتح الرابط في نافذة جديدة',
    Image: 'الصورة',
    file: 'ملف',
    Advanced: 'متقدم',
    'Image properties': 'خصائص الصورة',
    Cancel: 'إلغاء',
    Ok: 'حسنا',
    'File Browser': 'متصفح الملفات',
    'Error on load list': 'حدث خطأ في تحميل القائمة ',
    'Error on load folders': 'حدث خطأ في تحميل المجلدات',
    'Are you sure?': 'هل أنت واثق؟',
    'Enter Directory name': 'أدخل اسم المجلد',
    'Create directory': 'إنشاء مجلد',
    'type name': 'أكتب إسم',
    'Drop image': 'إسقاط صورة',
    'Drop file': 'إسقاط الملف',
    'or click': 'أو أنقر',
    'Alternative text': 'النص البديل',
    Upload: 'رفع',
    Browse: 'تصفح',
    Background: 'الخلفية',
    Text: 'نص',
    Top: 'أعلى',
    Middle: 'الوسط',
    Bottom: 'الأسفل',
    'Insert column before': 'إدراج عمود قبل',
    'Insert column after': 'إدراج عمود بعد',
    'Insert row above': 'إدراج صف أعلى',
    'Insert row below': 'إدراج صف أسفل',
    'Delete table': 'حذف الجدول',
    'Delete row': 'حذف الصف',
    'Delete column': 'حذف العمود',
    'Empty cell': 'خلية فارغة',
    'Chars: %d': '%d حرف',
    'Words: %d': '%d كلام',
    'Strike through': 'اضرب من خلال',
    Underline: 'أكد',
    superscript: 'حرف فوقي',
    subscript: 'مخطوطة',
    'Cut selection': 'قطع الاختيار',
    'Select all': 'اختر الكل',
    Break: 'استراحة',
    'Search for': 'البحث عن',
    'Replace with': 'استبدل ب',
    Replace: 'محل',
    Paste: 'معجون',
    'Choose Content to Paste': 'اختر محتوى للصق',
    source: 'مصدر',
    bold: 'بالخط العريض',
    italic: 'مائل',
    brush: 'شغل',
    link: 'صلة',
    undo: 'إلغاء',
    redo: 'كرر',
    table: 'طاولة',
    image: 'صورة',
    eraser: 'نظيف',
    paragraph: 'فقرة',
    fontsize: 'حجم الخط',
    video: 'فيديو',
    font: 'الخط',
    about: 'حول المحرر',
    print: 'طباعة',
    underline: 'أكد',
    strikethrough: 'شطب',
    indent: 'المسافة البادئة',
    outdent: 'نتوء',
    fullsize: 'ملء الشاشة',
    shrink: 'الحجم التقليدي',
    hr: 'الخط',
    ul: 'قائمة',
    ol: 'قائمة مرقمة',
    cut: 'قطع',
    selectall: 'اختر الكل',
    'Embed code': 'قانون',
    'Open link': 'فتح الرابط',
    'Edit link': 'تعديل الرابط',
    'No follow': 'سمة Nofollow',
    Unlink: 'إزالة الرابط',
    Update: 'تحديث',
    pencil: 'لتحرير',
    Eye: 'مراجعة',
    ' URL': 'URL',
    Edit: 'تحرير',
    'Horizontal align': 'محاذاة أفقية',
    Filter: 'فلتر',
    'Sort by changed': 'عن طريق التغيير',
    'Sort by name': 'بالاسم',
    'Sort by size': 'حسب الحجم',
    'Add folder': 'إضافة مجلد',
    Reset: 'إعادة',
    Save: 'احتفظ',
    'Save as ...': 'حفظ باسم',
    Resize: 'تغيير الحجم',
    Crop: 'حجم القطع',
    Width: 'عرض',
    Height: 'ارتفاع',
    'Keep Aspect Ratio': 'حافظ على النسب',
    Yes: 'أن',
    No: 'لا',
    Remove: 'حذف',
    Select: 'تميز',
    'Select %s': 'تميز %s',
    'Vertical align': 'محاذاة عمودية',
    Split: 'انشق، مزق',
    Merge: 'اذهب',
    'Add column': 'أضف العمود',
    'Add row': 'اضف سطر',
    'License: %s': 'رخصة %s',
    Delete: 'حذف',
    'Split vertical': 'انقسام عمودي',
    'Split horizontal': 'تقسيم أفقي',
    Border: 'الحدود',
    'Your code is similar to HTML. Keep as HTML?': 'يشبه الكود الخاص بك HTML. تبقي كما HTML؟',
    'Paste as HTML': 'الصق ك HTML',
    Keep: 'احتفظ',
    'Insert as Text': 'إدراج كنص',
    'Insert only Text': 'إدراج النص فقط',
    'You can only edit your own images. Download this image on the host?': 'يمكنك فقط تحرير صورك الخاصة. تحميل هذه الصورة على المضيف؟',
    'The image has been successfully uploaded to the host!': 'تم تحميل الصورة بنجاح على الخادم!',
    palette: 'لوحة',
    'There are no files': 'لا توجد ملفات في هذا الدليل.',
    Rename: 'إعادة تسمية',
    'Enter new name': 'أدخل اسم جديد',
    preview: 'معاينة',
    download: 'تحميل',
    'Paste from clipboard': 'لصق من الحافظة',
    "Your browser doesn't support direct access to the clipboard.": 'متصفحك لا يدعم إمكانية الوصول المباشر إلى الحافظة.',
    'Copy selection': 'نسخ التحديد',
    copy: 'نسخ',
    'Border radius': 'دائرة نصف قطرها الحدود',
    'Show all': 'عرض كل',
    Apply: 'تطبيق',
    'Please fill out this field': 'يرجى ملء هذا المجال',
    'Please enter a web address': 'يرجى إدخال عنوان ويب',
    Default: 'الافتراضي',
    Circle: 'دائرة',
    Dot: 'نقطة',
    Quadrate: 'المربعة',
    Find: 'البحث',
    'Find Previous': 'تجد السابقة',
    'Find Next': 'تجد التالي',
    'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?': 'للصق المحتوى قادم من Microsoft Word/Excel الوثيقة. هل تريد أن تبقي شكل أو تنظيفه ؟ ',
    'Word Paste Detected': 'كلمة لصق الكشف عن',
    Clean: 'نظيفة',
    'Insert className': 'أدخل اسم الفصل',
    'Press Alt for custom resizing': 'اضغط البديل لتغيير حجم مخصص',
    'Line height': 'ارتفاع الخط',
    spellcheck: 'التدقيق الإملائي',
    'Speech Recognize': 'التعرف على الكلام'
});


/***/ }),

/***/ 80020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   _: function() { return /* binding */ sendFiles; }
/* harmony export */ });
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21537);
/* harmony import */ var _send_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71686);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/**
 * Send files to server
 */ function sendFiles(uploader, files, handlerSuccess, handlerError, process) {
    if (!files) {
        return Promise.reject((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.error)('Need files'));
    }
    const { o } = uploader;
    let fileList = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.toArray)(files);
    if (!fileList.length) {
        return Promise.reject((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.error)('Need files'));
    }
    const promises = [];
    if (o.insertImageAsBase64URI) {
        readImagesWithReader(fileList, o.imagesExtensions, promises, uploader, handlerSuccess, o.defaultHandlerSuccess);
    }
    fileList = fileList.filter((a)=>a);
    if (fileList.length) {
        const form = new FormData();
        form.append(o.pathVariableName, uploader.path);
        form.append('source', uploader.source);
        let file;
        for(let i = 0; i < fileList.length; i += 1){
            file = fileList[i];
            if (file) {
                const hasRealExtension = /\.\w+$/.test(file.name);
                const mime = file.type.match(/\/([a-z0-9]+)/i);
                const extension = mime && mime[1] ? mime[1].toLowerCase() : '';
                let newName = fileList[i].name || Math.random().toString().replace('.', '');
                if (!hasRealExtension && extension) {
                    let extForReg = extension;
                    if ([
                        'jpeg',
                        'jpg'
                    ].includes(extForReg)) {
                        extForReg = 'jpeg|jpg';
                    }
                    const reEnd = new RegExp('.(' + extForReg + ')$', 'i');
                    if (!reEnd.test(newName)) {
                        newName += '.' + extension;
                    }
                }
                const [key, iFile, name] = o.processFileName.call(uploader, o.filesVariableName(i), fileList[i], newName);
                form.append(key, iFile, name);
            }
        }
        if (process) {
            process(form);
        }
        if (o.data && (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.isPlainObject)(o.data)) {
            Object.keys(o.data).forEach((key)=>{
                form.append(key, o.data[key]);
            });
        }
        o.prepareData.call(uploader, form);
        promises.push((0,_send_js__WEBPACK_IMPORTED_MODULE_1__/* .send */ .t)(uploader, form).then((resp)=>{
            if (o.isSuccess.call(uploader, resp)) {
                const handler = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.isFunction)(handlerSuccess) ? handlerSuccess : o.defaultHandlerSuccess;
                handler.call(uploader, o.process.call(uploader, resp));
                return resp;
            }
            const handler = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.isFunction)(handlerError) ? handlerError : o.defaultHandlerError;
            handler.call(uploader, (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.error)(o.getMessage.call(uploader, resp)));
            return resp;
        }).then(()=>{
            uploader.j.events && uploader.j.e.fire('filesWereUploaded');
        }));
    }
    return Promise.all(promises);
}
function readImagesWithReader(fileList, imagesExtensions, promises, uploader, handlerSuccess, defaultHandlerSuccess) {
    let file, i;
    for(i = 0; i < fileList.length; i += 1){
        file = fileList[i];
        if (file && file.type) {
            const mime = file.type.match(/\/([a-z0-9]+)/i);
            const extension = mime[1] ? mime[1].toLowerCase() : '';
            if (!imagesExtensions.includes(extension)) {
                continue;
            }
            const reader = new FileReader();
            promises.push(uploader.j.async.promise((resolve, reject)=>{
                reader.onerror = reject;
                reader.onloadend = ()=>{
                    const resp = {
                        baseurl: '',
                        files: [
                            reader.result
                        ],
                        isImages: [
                            true
                        ]
                    };
                    const handler = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.isFunction)(handlerSuccess) ? handlerSuccess : defaultHandlerSuccess;
                    handler.call(uploader, resp);
                    resolve(resp);
                };
                reader.readAsDataURL(file);
            }));
            fileList[i] = null;
        }
    }
}


/***/ }),

/***/ 80084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    'Line height': 'ارتفاع الخط'
});


/***/ }),

/***/ 80105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    'Line height': '선 높이'
});


/***/ }),

/***/ 80152:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1216 320q0 26-19 45t-45 19h-128v1024h128q26 0 45 19t19 45-19 45l-256 256q-19 19-45 19t-45-19l-256-256q-19-19-19-45t19-45 45-19h128v-1024h-128q-26 0-45-19t-19-45 19-45l256-256q19-19 45-19t45 19l256 256q19 19 19 45z\"/> </svg> ");


/***/ }),

/***/ 80256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   t: function() { return /* binding */ UIInput; }
/* harmony export */ });
/* harmony import */ var _decorators_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65478);
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _helpers_array_to_array_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4510);
/* harmony import */ var _helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43555);
/* harmony import */ var _element_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48538);
/* harmony import */ var _validators_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30389);
/* harmony import */ var _icon_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12153);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var UIInput_1;







let UIInput = UIInput_1 = class UIInput extends _element_js__WEBPACK_IMPORTED_MODULE_4__/* .UIElement */ .D {
    /** @override */ className() {
        return 'UIInput';
    }
    onChangeClear() {
        if (this.state.clearButton) {
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.after(this.nativeInput, this.clearButton);
        } else {
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(this.clearButton);
        }
    }
    onChangeClassName(ignore, oldClassName) {
        oldClassName && this.container.classList.remove(oldClassName);
        this.state.className && this.container.classList.add(this.state.className);
    }
    onChangeState() {
        this.name = this.state.name;
        const input = this.nativeInput, { name, icon, type, ref, required, placeholder, autocomplete, label } = this.state;
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__/* .attr */ .CF)(input, 'name', name);
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__/* .attr */ .CF)(input, 'type', type);
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__/* .attr */ .CF)(input, 'data-ref', ref || name);
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__/* .attr */ .CF)(input, 'ref', ref || name);
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__/* .attr */ .CF)(input, 'required', required || null);
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__/* .attr */ .CF)(input, 'autocomplete', !autocomplete ? 'off' : null);
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__/* .attr */ .CF)(input, 'placeholder', placeholder ? this.j.i18n(placeholder) : '');
        if (icon && _icon_js__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .I.exists(icon)) {
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.before(input, this.icon);
            this.icon.innerHTML = _icon_js__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .I.get(icon);
        } else {
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(this.icon);
        }
        if (label) {
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.before(this.wrapper, this.label);
            this.label.innerText = this.j.i18n(label);
        } else {
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(this.label);
        }
        this.updateValidators();
    }
    updateValidators() {
        var _a;
        this.validators.clear();
        if (this.state.required) {
            this.validators.add(_validators_index_js__WEBPACK_IMPORTED_MODULE_5__/* .inputValidators.required */ .O.required);
        }
        (_a = this.state.validators) === null || _a === void 0 ? void 0 : _a.forEach((name)=>{
            const validator = _validators_index_js__WEBPACK_IMPORTED_MODULE_5__/* .inputValidators */ .O[name];
            validator && this.validators.add(validator);
        });
    }
    set error(value) {
        this.setMod('has-error', Boolean(value));
        if (!value) {
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(this.__errorBox);
        } else {
            this.__errorBox.innerText = this.j.i18n(value, this.j.i18n(this.state.label || ''));
            this.container.appendChild(this.__errorBox);
        }
    }
    get value() {
        return this.nativeInput.value;
    }
    set value(value) {
        if (this.value !== value) {
            this.nativeInput.value = value;
            this.onChangeValue();
        }
    }
    /**
     * Call on every state value changed
     */ onChangeStateValue() {
        const value = this.state.value.toString();
        if (value !== this.value) {
            this.value = value;
        }
    }
    /**
     * Call on every native value changed
     */ onChangeValue() {
        var _a, _b;
        const { value } = this;
        if (this.state.value !== value) {
            this.state.value = value;
            this.j.e.fire(this, 'change', value);
            (_b = (_a = this.state).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, value);
        }
    }
    validate() {
        this.error = '';
        const validate = (0,_helpers_array_to_array_js__WEBPACK_IMPORTED_MODULE_2__/* .toArray */ .$)(this.validators).every((validator)=>validator(this));
        this.__markInputInvalid();
        return validate;
    }
    __markInputInvalid() {
        var _a, _b, _c, _d;
        if (this.error) {
            this.nativeInput.setAttribute('aria-invalid', 'true');
            (_b = (_a = this.nativeInput).setCustomValidity) === null || _b === void 0 ? void 0 : _b.call(_a, this.error);
        } else {
            this.nativeInput.removeAttribute('aria-invalid');
            (_d = (_c = this.nativeInput).setCustomValidity) === null || _d === void 0 ? void 0 : _d.call(_c, '');
        }
    }
    /** @override **/ createContainer(options) {
        const container = super.createContainer();
        this.wrapper = this.j.c.div(this.getFullElName('wrapper'));
        if (!this.nativeInput) {
            this.nativeInput = this.createNativeInput();
        }
        const { nativeInput } = this;
        nativeInput.classList.add(this.getFullElName('input'));
        this.wrapper.appendChild(nativeInput);
        container.appendChild(this.wrapper);
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_3__/* .attr */ .CF)(nativeInput, 'dir', this.j.o.direction || 'auto');
        return container;
    }
    /**
     * Create native input element
     */ createNativeInput(options) {
        return this.j.create.element('input');
    }
    focus() {
        this.nativeInput.focus();
    }
    get isFocused() {
        return this.nativeInput === this.j.od.activeElement;
    }
    /**
     * Set `focused` mod on change focus
     */ onChangeFocus() {
        this.setMod('focused', this.isFocused);
    }
    /** @override **/ constructor(jodit, options){
        super(jodit, options);
        this.label = this.j.c.span(this.getFullElName('label'));
        this.icon = this.j.c.span(this.getFullElName('icon'));
        this.clearButton = this.j.c.span(this.getFullElName('clear'), _icon_js__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .I.get('cancel'));
        this.state = {
            ...UIInput_1.defaultState
        };
        this.__errorBox = this.j.c.span(this.getFullElName('error'));
        this.validators = new Set([]);
        if ((options === null || options === void 0 ? void 0 : options.value) !== undefined) {
            options.value = options.value.toString();
        }
        Object.assign(this.state, options);
        if (this.state.clearButton !== undefined) {
            this.j.e.on(this.clearButton, 'click', (e)=>{
                e.preventDefault();
                this.nativeInput.value = '';
                this.j.e.fire(this.nativeInput, 'input');
                this.focus();
            }).on(this.nativeInput, 'input', ()=>{
                this.state.clearButton = Boolean(this.value.length);
            });
            this.state.clearButton = Boolean(this.value.length);
        }
        this.j.e.on(this.nativeInput, 'focus blur', ()=>{
            this.onChangeFocus();
        }).on(this.nativeInput, 'input change', this.onChangeValue);
        this.onChangeState();
        this.onChangeClassName();
        this.onChangeStateValue();
    }
};
UIInput.defaultState = {
    className: '',
    autocomplete: true,
    name: '',
    value: '',
    icon: '',
    label: '',
    ref: '',
    type: 'text',
    placeholder: '',
    required: false,
    validators: []
};
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)('state.clearButton')
], UIInput.prototype, "onChangeClear", null);
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)('state.className')
], UIInput.prototype, "onChangeClassName", null);
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)([
        'state.name',
        'state.type',
        'state.label',
        'state.placeholder',
        'state.autocomplete',
        'state.icon'
    ], {
        immediately: false
    }),
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.debounce)()
], UIInput.prototype, "onChangeState", null);
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)('state.value')
], UIInput.prototype, "onChangeStateValue", null);
__decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], UIInput.prototype, "onChangeValue", null);
UIInput = UIInput_1 = __decorate([
    _decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.component
], UIInput);



/***/ }),

/***/ 80319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   P: function() { return /* binding */ ToolbarContent; }
/* harmony export */ });
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22732);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21537);
/* harmony import */ var _core_ui_button_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62843);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let ToolbarContent = class ToolbarContent extends _core_ui_button_index_js__WEBPACK_IMPORTED_MODULE_3__/* .UIButton */ .lD {
    /** @override */ className() {
        return 'ToolbarContent';
    }
    /** @override */ update() {
        const content = this.control.getContent(this.j, this);
        if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.isString)(content) || content.parentNode !== this.container) {
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.detach(this.container);
            this.container.appendChild((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.isString)(content) ? this.j.create.fromHTML(content) : content);
        }
        super.update();
    }
    /** @override */ createContainer() {
        return this.j.c.span(this.componentName);
    }
    constructor(jodit, control, target = null){
        super(jodit);
        this.control = control;
        this.target = target;
        this.container.classList.add(`${this.componentName}_${this.clearName(control.name)}`);
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__.attr)(this.container, 'role', 'content');
    }
};
ToolbarContent = __decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.component
], ToolbarContent);



/***/ }),

/***/ 80480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   v: function() { return /* binding */ ViewComponent; }
/* harmony export */ });
/* harmony import */ var _component_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4012);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
class ViewComponent extends _component_js__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .u {
    /**
     * Shortcut for `this.jodit`
     */ get j() {
        return this.jodit;
    }
    get defaultTimeout() {
        return this.j.defaultTimeout;
    }
    i18n(text, ...params) {
        return this.j.i18n(text, ...params);
    }
    /**
     * Attach component to View
     */ setParentView(jodit) {
        this.jodit = jodit;
        jodit.components.add(this);
        return this;
    }
    /** @override */ destruct() {
        this.j.components.delete(this);
        return super.destruct();
    }
    constructor(jodit){
        super();
        this.setParentView(jodit);
    }
}


/***/ }),

/***/ 80536:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_helpers_checker_is_array_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68345);
/* harmony import */ var _core_helpers_checker_is_jodit_object_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19306);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/**
 * Module for processing download documents and images by Drag and Drop
 * Drag and Drop files
 */ _config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.enableDragAndDropFileToEditor = true;
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.uploader = {
    url: '',
    insertImageAsBase64URI: false,
    imagesExtensions: [
        'jpg',
        'png',
        'jpeg',
        'gif'
    ],
    headers: null,
    data: null,
    filesVariableName (i) {
        return `files[${i}]`;
    },
    withCredentials: false,
    pathVariableName: 'path',
    format: 'json',
    method: 'POST',
    prepareData (formData) {
        return formData;
    },
    isSuccess (resp) {
        return resp.success;
    },
    getMessage (resp) {
        return resp.data.messages !== undefined && (0,_core_helpers_checker_is_array_js__WEBPACK_IMPORTED_MODULE_1__/* .isArray */ .c)(resp.data.messages) ? resp.data.messages.join(' ') : '';
    },
    /**
     * @see [[IUploader.processFileName]]
     */ processFileName (key, file, name) {
        return [
            key,
            file,
            name
        ];
    },
    process (resp) {
        return resp.data;
    },
    error (e) {
        this.j.message.error(e.message, 4000);
    },
    getDisplayName (baseurl, filename) {
        return baseurl + filename;
    },
    defaultHandlerSuccess (resp) {
        const j = this.j || this;
        if (!(0,_core_helpers_checker_is_jodit_object_js__WEBPACK_IMPORTED_MODULE_2__/* .isJoditObject */ .y)(j)) {
            return;
        }
        if (resp.files && resp.files.length) {
            resp.files.forEach((filename, index)=>{
                const [tagName, attr] = resp.isImages && resp.isImages[index] ? [
                    'img',
                    'src'
                ] : [
                    'a',
                    'href'
                ];
                const elm = j.createInside.element(tagName);
                elm.setAttribute(attr, resp.baseurl + filename);
                if (tagName === 'a') {
                    elm.textContent = j.o.uploader.getDisplayName.call(this, resp.baseurl, filename);
                }
                if (tagName === 'img') {
                    j.s.insertImage(elm, null, j.o.imageDefaultWidth);
                } else {
                    j.s.insertNode(elm);
                }
            });
        }
    },
    defaultHandlerError (e) {
        this.j.message.error(e.message);
    },
    contentType (requestData) {
        return this.ow.FormData !== undefined && typeof requestData !== 'string' ? false : 'application/x-www-form-urlencoded; charset=UTF-8';
    }
};


/***/ }),

/***/ 80568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   M: function() { return /* binding */ keepNames; },
/* harmony export */   u: function() { return /* binding */ getClassName; }
/* harmony export */ });
/* harmony import */ var _checker_is_function_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23282);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
const keepNames = new Map();
const getClassName = (obj)=>{
    var _a;
    if ((0,_checker_is_function_js__WEBPACK_IMPORTED_MODULE_0__/* .isFunction */ .T)(obj.className)) {
        return obj.className();
    }
    const constructor = ((_a = obj.constructor) === null || _a === void 0 ? void 0 : _a.originalConstructor) || obj.constructor;
    if (keepNames.has(constructor)) {
        return keepNames.get(constructor);
    }
    if (constructor.name) {
        return constructor.name;
    }
    const regex = new RegExp(/^\s*function\s*(\S*)\s*\(/);
    const res = constructor.toString().match(regex);
    return res ? res[1] : '';
};


/***/ }),

/***/ 80651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    newline: 'newline',
    delete: 'Hapus',
    space: 'ruang',
    'Speech Recognize': 'Pidato Mengenali',
    Sound: 'Suara',
    'Interim Results': 'Hasil Sementara'
});


/***/ }),

/***/ 80763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export imageProcessor */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21537);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50911);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85745);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






const JODIT_IMAGE_PROCESSOR_BINDED = '__jodit_imageprocessor_binded';
const JODIT_IMAGE_BLOB_ID = JODIT_IMAGE_PROCESSOR_BINDED + 'blob-id';
/**
 * Change editor's size after load all images
 */ class imageProcessor extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Plugin */ .k {
    afterInit(jodit) {}
    beforeDestruct(jodit) {
        const buffer = (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.cached)(jodit, 'buffer');
        const list = buffer === null || buffer === void 0 ? void 0 : buffer.get(JODIT_IMAGE_BLOB_ID);
        if (buffer && list) {
            const keys = Object.keys(list);
            for (const uri of keys){
                URL.revokeObjectURL(uri);
            }
            buffer.delete(JODIT_IMAGE_BLOB_ID);
        }
    }
    onAfterGetValueFromEditor(data, consumer) {
        if (consumer !== _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.SOURCE_CONSUMER) {
            return this.onBeforeSetElementValue(data);
        }
    }
    onBeforeSetElementValue(data) {
        const { jodit: editor } = this;
        if (!editor.o.imageProcessor.replaceDataURIToBlobIdInView) {
            return;
        }
        const list = editor.buffer.get(JODIT_IMAGE_BLOB_ID);
        if (list) {
            const keys = Object.keys(list);
            for (const uri of keys){
                while(data.value.includes(uri)){
                    data.value = data.value.replace(uri, list[uri]);
                }
            }
        }
    }
    async afterChange(data) {
        const { jodit: editor } = this;
        if (!editor.editor) {
            return;
        }
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.$$)('img', editor.editor).forEach((elm)=>{
            if (!(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.dataBind)(elm, JODIT_IMAGE_PROCESSOR_BINDED)) {
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.dataBind)(elm, JODIT_IMAGE_PROCESSOR_BINDED, true);
                if (!elm.complete) {
                    editor.e.on(elm, 'load', function ElementOnLoad() {
                        var _a;
                        !editor.isInDestruct && ((_a = editor.e) === null || _a === void 0 ? void 0 : _a.fire('resize'));
                        editor.e.off(elm, 'load', ElementOnLoad);
                    });
                }
                if (elm.src && /^data:/.test(elm.src)) {
                    replaceDataURIToBlobUUID(editor, elm);
                }
                editor.e.on(elm, 'mousedown touchstart', ()=>{
                    editor.s.select(elm);
                });
            }
        });
    }
}
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)(':afterGetValueFromEditor')
], imageProcessor.prototype, "onAfterGetValueFromEditor", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)(':beforeSetElementValue')
], imageProcessor.prototype, "onBeforeSetElementValue", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)([
        ':change',
        ':afterInit',
        ':changePlace'
    ]),
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.debounce)()
], imageProcessor.prototype, "afterChange", null);
function replaceDataURIToBlobUUID(editor, elm) {
    if (!editor.o.imageProcessor.replaceDataURIToBlobIdInView) {
        return;
    }
    if (typeof ArrayBuffer === 'undefined' || typeof URL === 'undefined') {
        return;
    }
    const dataUri = elm.src, blob = dataURItoBlob(dataUri);
    elm.src = URL.createObjectURL(blob);
    editor.e.fire('internalUpdate');
    const { buffer } = editor;
    const list = buffer.get(JODIT_IMAGE_BLOB_ID) || {};
    list[elm.src] = dataUri;
    editor.buffer.set(JODIT_IMAGE_BLOB_ID, list);
}
// https://stackoverflow.com/a/12300351
function dataURItoBlob(dataURI) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    const byteString = atob(dataURI.split(',')[1]);
    // separate out the mime component
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    // write the bytes of the string to an ArrayBuffer
    const ab = new ArrayBuffer(byteString.length);
    // create a view into the buffer
    const ia = new Uint8Array(ab);
    // set the bytes of the buffer to the correct values
    for(let i = 0; i < byteString.length; i++){
        ia[i] = byteString.charCodeAt(i);
    }
    // write the ArrayBuffer to a blob, and you're done
    return new Blob([
        ab
    ], {
        type: mimeString
    });
}
_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .pluginSystem */ .fg.add('imageProcessor', imageProcessor);


/***/ }),

/***/ 80792:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/size
 */ 
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.minWidth = 200;
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.maxWidth = '100%';
/**
 * Editor's min-height
 *
 * @example
 * ```javascript
 * Jodit.make('.editor', {
 *    minHeight: '30%' //min-height: 30%
 * })
 * ```
 * @example
 * ```javascript
 * Jodit.make('.editor', {
 *    minHeight: 200 //min-height: 200px
 * })
 * ```
 */ _config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.minHeight = 200;
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.maxHeight = 'auto';
/**
 * if set true and height !== auto then after reload editor will have the latest height
 */ _config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.saveHeightInStorage = false;


/***/ }),

/***/ 80870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   t: function() { return /* binding */ ContextMenu; }
/* harmony export */ });
/* harmony import */ var _core_decorators_component_component_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87325);
/* harmony import */ var _core_helpers_checker_is_array_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68345);
/* harmony import */ var _core_ui_button_button_button_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10830);
/* harmony import */ var _core_ui_popup_popup_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56917);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




/**
 * Module to generate context menu
 */ let ContextMenu = class ContextMenu extends _core_ui_popup_popup_js__WEBPACK_IMPORTED_MODULE_1__/* .Popup */ .z {
    /** @override */ className() {
        return 'ContextMenu';
    }
    /**
     * Generate and show context menu
     *
     * @param x - Global coordinate by X
     * @param y - Global coordinate by Y
     * @param actions - Array with plain objects `{icon: 'bin', title: 'Delete', exec: function () {}}`
     * @example
     * ```javascript
     * parent.show(e.clientX, e.clientY, [{icon: 'bin', title: 'Delete', exec: function () { alert(1) }}]);
     * ```
     */ show(x, y, actions) {
        const self = this;
        self.clear();
        if (!(0,_core_helpers_checker_is_array_js__WEBPACK_IMPORTED_MODULE_2__/* .isArray */ .c)(actions)) {
            return;
        }
        actions.forEach((item)=>{
            if (!item) {
                return;
            }
            const action = (0,_core_ui_button_button_button_js__WEBPACK_IMPORTED_MODULE_0__/* .Button */ .$n)(this.jodit, item.icon || 'empty', item.title);
            this.jodit && action.setParentView(this.jodit);
            action.setMod('context', 'menu');
            action.onAction((e)=>{
                var _a;
                (_a = item.exec) === null || _a === void 0 ? void 0 : _a.call(self, e);
                self.clear();
                self.close();
                return false;
            });
            this.append(action);
        });
        this.open(()=>({
                left: x,
                top: y,
                width: 0,
                height: 0
            }), true);
    }
};
ContextMenu = __decorate([
    _core_decorators_component_component_js__WEBPACK_IMPORTED_MODULE_3__/* .component */ .s
], ContextMenu);



/***/ }),

/***/ 80926:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'Type something': 'Бичээд үзээрэй',
    Advanced: 'Дэвшилтэт',
    'About Jodit': 'Jodit-ын талаар ',
    'Jodit Editor': 'Jodit програм',
    "Jodit User's Guide": 'Jodit гарын авлага',
    'contains detailed help for using': 'хэрэглээний талаар дэлгэрэнгүй мэдээллийг агуулна',
    'For information about the license, please go to our website:': 'Лицензийн мэдээллийг манай вэб хуудаснаас авна уу:',
    'Buy full version': 'Бүрэн хувилбар худалдан авах',
    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.': 'Зохиогчийн эрх хамгаалагдсан © XDSoft.net - Chupurnov Valeriy. Бүх эрхийг эзэмшинэ.',
    Anchor: 'Холбоо барих',
    'Open in new tab': 'Шинэ табаар нээх',
    'Open in fullsize': 'Бүтэн дэлгэцээр нээх',
    'Clear Formatting': 'Форматыг арилгах',
    'Fill color or set the text color': 'Өнгөөр будах эсвэл текстийн өнгө сонгох',
    Redo: 'Дахих',
    Undo: 'Буцаах',
    Bold: 'Тод',
    Italic: 'Налуу',
    'Insert Unordered List': 'Тэмдэгт жагсаалт нэмэх',
    'Insert Ordered List': 'Дугаарт жагсаалт нэмэх',
    'Align Center': 'Голлож байрлуулах',
    'Align Justify': 'Тэгшитгэн байрлуулах',
    'Align Left': 'Зүүнд байрлуулах',
    'Align Right': 'Баруунд байрлуулах',
    'Insert Horizontal Line': 'Хэвтээ зураас нэмэх',
    'Insert Image': 'Зураг нэмэх',
    'Insert file': 'Файл нэмэх',
    'Insert youtube/vimeo video': 'Youtube/Vimeo видео нэмэх',
    'Insert link': 'Холбоос нэмэх',
    'Font size': 'Фонтын хэмжээ',
    'Font family': 'Фонтын бүл',
    'Insert format block': 'Блок нэмэх',
    Normal: 'Хэвийн',
    'Heading 1': 'Гарчиг 1',
    'Heading 2': 'Гарчиг 2',
    'Heading 3': 'Гарчиг 3',
    'Heading 4': 'Гарчиг 4',
    Quote: 'Ишлэл',
    Code: 'Код',
    Insert: 'Оруулах',
    'Insert table': 'Хүснэгт оруулах',
    'Decrease Indent': 'Доголын зай хасах',
    'Increase Indent': 'Доголын зай нэмэх',
    'Select Special Character': 'Тусгай тэмдэгт сонгох',
    'Insert Special Character': 'Тусгай тэмдэгт нэмэх',
    'Paint format': 'Зургийн формат',
    'Change mode': 'Горим өөрчлөх',
    Margins: 'Цаасны зай',
    top: 'Дээрээс',
    right: 'Баруунаас',
    bottom: 'Доороос',
    left: 'Зүүнээс',
    Styles: 'CSS стиль',
    Classes: 'CSS анги',
    Align: 'Байрлуулах',
    Right: 'Баруун',
    Center: 'Төв',
    Left: 'Зүүн',
    '--Not Set--': '--Тодорхойгүй--',
    Src: 'Эх үүсвэр',
    Title: 'Гарчиг',
    Alternative: 'Алтернатив текст',
    Link: 'Холбоос',
    'Open link in new tab': 'Холбоосыг шинэ хавтсанд нээх',
    Image: 'Зураг',
    file: 'Файл',
    'Image properties': 'Зургийн үзүүлэлт',
    Cancel: 'Цуцлах',
    Ok: 'Ok',
    'Your code is similar to HTML. Keep as HTML?': 'Таны код HTML кодтой адил байна. HTML форматаар үргэлжлүүлэх үү?',
    'Paste as HTML': 'HTML байдлаар буулгах',
    Keep: 'Хадгалах',
    Clean: 'Цэвэрлэх',
    'Insert as Text': 'Текст байдлаар нэмэх',
    'Word Paste Detected': 'Word байдлаар буулгасан байна',
    'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?': 'Буулгасан агуулга Microsoft Word/Excel форматтай байна. Энэ форматыг хэвээр хадгалах уу эсвэл арилгах уу?',
    'Insert only Text': 'Зөвхөн текст оруулах',
    'File Browser': 'Файлын цонх',
    'Error on load list': 'Жагсаалт татах үед алдаа гарлаа',
    'Error on load folders': 'Хавтас татах үед алдаа гарлаа',
    'Are you sure?': 'Итгэлтэй байна уу?',
    'Enter Directory name': 'Хавтсын нэр оруулах',
    'Create directory': 'Хавтас үүсгэх',
    'type name': 'Нэр бичих',
    'Drop image': 'Зураг буулгах',
    'Drop file': 'Файл буулгах',
    'or click': 'эсвэл товш',
    'Alternative text': 'Алтернатив текст',
    Browse: 'Үзэх',
    Upload: 'Байршуулах',
    Background: 'Арын зураг',
    Text: 'Текст',
    Top: 'Дээр',
    Middle: 'Дунд',
    Bottom: 'Доор',
    'Insert column before': 'Урд нь багана нэмэх',
    'Insert column after': 'Ард нь багана нэмэх',
    'Insert row above': 'Дээр нь мөр нэмэх',
    'Insert row below': 'Доор нь мөр нэмэх',
    'Delete table': 'Хүснэгт устгах',
    'Delete row': 'Мөр устгах',
    'Delete column': 'Багана устгах',
    'Empty cell': 'Нүд цэвэрлэх',
    Delete: 'Устгах',
    'Strike through': 'Дээгүүр зураас',
    Underline: 'Доогуур зураас',
    Break: 'Мөрийг таслах',
    'Search for': 'Хайх',
    'Replace with': 'Үүгээр солих',
    Replace: 'Солих',
    Edit: 'Засах',
    'Vertical align': 'Босоо эгнүүлэх',
    'Horizontal align': 'Хэвтээ эгнүүлэх',
    Filter: 'Шүүх',
    'Sort by changed': 'Сүүлд өөрчлөгдсөнөөр жагсаах',
    'Sort by name': 'Нэрээр жагсаах',
    'Sort by size': 'Хэмжээгээр жагсаах',
    'Add folder': 'Хавтас нэмэх',
    Split: 'Задлах',
    'Split vertical': 'Баганаар задлах',
    'Split horizontal': 'Мөрөөр задлах',
    Merge: 'Нэгтгэх',
    'Add column': 'Багана нэмэх',
    'Add row': 'Мөр нэмэх',
    Border: 'Хүрээ',
    'Embed code': 'Код оруулах',
    Update: 'Шинэчлэх',
    superscript: 'Дээд индекс',
    subscript: 'Доод индекс',
    'Cut selection': 'Сонголтыг таслах',
    Paste: 'Буулгах',
    'Choose Content to Paste': 'Буулгах агуулгаа сонгоно уу',
    'Chars: %d': 'Тэмдэгт: %d',
    'Words: %d': 'Үг: %d',
    All: 'Бүгдийг',
    'Select %s': 'Сонго: %s',
    'Select all': 'Бүгдийг сонго',
    source: 'Эх үүсвэр',
    bold: 'Тод',
    italic: 'Налуу',
    brush: 'Будах',
    link: 'Холбоос',
    undo: 'Буцаах',
    redo: 'Дахих',
    table: 'Хүснэгт',
    image: 'Зураг',
    eraser: 'Баллуур',
    paragraph: 'Параграф',
    fontsize: 'Фонтын хэмжээ',
    video: 'Видео',
    font: 'Фонт',
    about: 'Тухай',
    print: 'Хэвлэх',
    underline: 'Доогуур зураас',
    strikethrough: 'Дээгүүр зураас',
    indent: 'Догол нэмэх',
    outdent: 'Догол багасгах',
    fullsize: 'Бүтэн дэлгэц',
    shrink: 'Багасга',
    hr: 'Хаалт',
    ul: 'Тэмдэгт жагсаалт',
    ol: 'Дугаарласан жагсаалт',
    cut: 'Таслах',
    selectall: 'Бүгдийг сонго',
    'Open link': 'Холбоос нээх',
    'Edit link': 'Холбоос засах',
    'No follow': 'Nofollow özelliği',
    Unlink: 'Холбоос салгах',
    Eye: 'Нүд',
    pencil: 'Засах',
    ' URL': 'URL',
    Reset: 'Буцаах',
    Save: 'Хадгалах',
    'Save as ...': 'Өөрөөр хадгалах',
    Resize: 'Хэмжээг өөрчил',
    Crop: 'Тайрах',
    Width: 'Өргөн',
    Height: 'Өндөр',
    'Keep Aspect Ratio': 'Харьцааг хадгал',
    Yes: 'Тийм',
    No: 'Үгүй',
    Remove: 'Арилга',
    Select: 'Сонго',
    'You can only edit your own images. Download this image on the host?': 'Та зөвхөн өөрийн зургуудаа янзлах боломжтой. Энэ зургийг өөр лүүгээ татмаар байна уу?',
    'The image has been successfully uploaded to the host!': 'Зургийг хост руу амжилттай хадгалсан',
    palette: 'Палет',
    'There are no files': 'Энд ямар нэг файл алга',
    Rename: 'Шинээр нэрлэх',
    'Enter new name': 'Шинэ нэр оруулна уу',
    preview: 'Урьдчилан харах',
    download: 'Татах',
    'Paste from clipboard': 'Самбараас хуулах ',
    "Your browser doesn't support direct access to the clipboard.": 'Энэ вэб хөтчөөс самбарт хандах эрх алга.',
    'Copy selection': 'Сонголтыг хуул',
    copy: 'Хуулах',
    'Border radius': 'Хүрээний радиус',
    'Show all': 'Бүгдийг харуулах',
    Apply: 'Хэрэгжүүл',
    'Please fill out this field': 'Энэ талбарыг бөглөнө үү',
    'Please enter a web address': 'Вэб хаягаа оруулна уу',
    Default: 'Үндсэн',
    Circle: 'Дугуй',
    Dot: 'Цэг',
    Quadrate: 'Дөрвөлжин',
    Find: 'Хайх',
    'Find Previous': 'Өмнөхийг ол',
    'Find Next': 'Дараагийнхийг ол',
    'Insert className': 'Бүлгийн нэрээ оруулна уу',
    'Press Alt for custom resizing': 'Хэмжээсийг шинээр өөчрлөхийн тулд Alt товчин дээр дарна уу'
});


/***/ }),

/***/ 80973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   H: function() { return /* binding */ replaceOldTags; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/**
 * @private
 */ function replaceOldTags(jodit, nodeElm, hadEffect) {
    const newNodeElm = replaceIfMatched(jodit, nodeElm, jodit.o.cleanHTML.replaceOldTags);
    if (nodeElm !== newNodeElm) {
        nodeElm = newNodeElm;
        return true;
    }
    return hadEffect;
}
/**
 * Replaces an element with a newer one if specified in the configuration match
 * @private
 */ function replaceIfMatched(jodit, oldParent, list) {
    if (!list || !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isHTMLElement(oldParent)) {
        return oldParent;
    }
    const tagName = list[oldParent.nodeName.toLowerCase()] || list[oldParent.nodeName];
    if (tagName) {
        return _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.replace(oldParent, tagName, jodit.createInside, true, false);
    }
    return oldParent;
}


/***/ }),

/***/ 81284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   c: function() { return /* binding */ offset; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ const offset = (elm, jodit, doc, recurse = false)=>{
    let rect;
    try {
        rect = elm.getBoundingClientRect();
    } catch (e) {
        rect = {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            width: 0,
            height: 0
        };
    }
    const body = doc.body, docElem = doc.documentElement || {
        clientTop: 0,
        clientLeft: 0,
        scrollTop: 0,
        scrollLeft: 0
    }, win = doc.defaultView || doc.parentWindow, scrollTop = win.pageYOffset || docElem.scrollTop || body.scrollTop, scrollLeft = win.pageXOffset || docElem.scrollLeft || body.scrollLeft, clientTop = docElem.clientTop || body.clientTop || 0, clientLeft = docElem.clientLeft || body.clientLeft || 0;
    let topValue, leftValue;
    const iframe = jodit.iframe;
    if (!recurse && jodit && jodit.options && jodit.o.iframe && iframe) {
        const { top, left } = offset(iframe, jodit, jodit.od, true);
        topValue = rect.top + top;
        leftValue = rect.left + left;
    } else {
        topValue = rect.top + scrollTop - clientTop;
        leftValue = rect.left + scrollLeft - clientLeft;
    }
    return {
        top: Math.round(topValue),
        left: Math.round(leftValue),
        width: rect.width,
        height: rect.height
    };
};


/***/ }),

/***/ 81577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   n: function() { return /* binding */ throttle; },
/* harmony export */   s: function() { return /* binding */ debounce; }
/* harmony export */ });
/* harmony import */ var _component_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91907);
/* harmony import */ var _helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27613);
/* harmony import */ var _helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38837);
/* harmony import */ var _helpers_utils_error_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89890);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



function debounce(timeout, firstCallImmediately = false, method = 'debounce') {
    return (target, propertyKey)=>{
        const fn = target[propertyKey];
        if (!(0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isFunction */ .Tn)(fn)) {
            throw (0,_helpers_utils_error_index_js__WEBPACK_IMPORTED_MODULE_3__/* .error */ .z3)('Handler must be a Function');
        }
        target.hookStatus(_component_index_js__WEBPACK_IMPORTED_MODULE_0__/* .STATUSES */ .f.ready, (component)=>{
            const { async } = component;
            (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_2__/* .assert */ .v)(async != null, `Component ${component.componentName || component.constructor.name} should have "async:IAsync" field`);
            const propTimeout = (0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isFunction */ .Tn)(timeout) ? timeout(component) : timeout;
            const realTimout = (0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNumber */ .Et)(propTimeout) || (0,_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .Qd)(propTimeout) ? propTimeout : component.defaultTimeout;
            Object.defineProperty(component, propertyKey, {
                configurable: true,
                value: async[method](component[propertyKey].bind(component), realTimout, firstCallImmediately)
            });
        });
        return {
            configurable: true,
            get () {
                return fn.bind(this);
            }
        };
    };
}
/**
 * Wrap function in throttle wrapper
 */ function throttle(timeout, firstCallImmediately = false) {
    return debounce(timeout, firstCallImmediately, 'throttle');
}


/***/ }),

/***/ 81630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   x: function() { return /* binding */ innerWidth; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/size
 */ const innerWidth = (element, win)=>{
    const computedStyle = win.getComputedStyle(element);
    let elementWidth = element.clientWidth; // width with padding
    elementWidth -= parseFloat(computedStyle.paddingLeft || '0') + parseFloat(computedStyle.paddingRight || '0');
    return elementWidth;
};


/***/ }),

/***/ 82168:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'Type something': 'Kirjoita jotain...',
    Advanced: 'Avanzado',
    'About Jodit': 'Tietoja Jodit:ista',
    'Jodit Editor': 'Jodit Editor',
    "Jodit User's Guide": 'Jodit käyttäjän ohje',
    'contains detailed help for using': 'sisältää tarkempaa tietoa käyttämiseen',
    'For information about the license, please go to our website:': 'Tietoa lisensoinnista, vieraile verkkosivuillamme:',
    'Buy full version': 'Osta täysi versio',
    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.': 'Copyright © XDSoft.net - Chupurnov Valeriy. Kaikki oikeudet pidätetään.',
    Anchor: 'Ankkuri',
    'Open in new tab': 'Avaa uudessa välilehdessä',
    'Open in fullsize': 'Avaa täysikokoisena',
    'Clear Formatting': 'Poista muotoilu',
    'Fill color or set the text color': 'Täytä värillä tai aseta tekstin väri',
    Redo: 'Tee uudelleen',
    Undo: 'Peruuta',
    Bold: 'Lihavoitu',
    Italic: 'Kursiivi',
    'Insert Unordered List': 'Lisää järjestämätön lista',
    'Insert Ordered List': 'Lisää järjestetty lista',
    'Align Center': 'Asemoi keskelle',
    'Align Justify': 'Asemoi tasavälein',
    'Align Left': 'Asemoi vasemmalle',
    'Align Right': 'Asemoi oikealle',
    'Insert Horizontal Line': 'Lisää vaakasuuntainen viiva',
    'Insert Image': 'Lisää kuva',
    'Insert file': 'Lisää tiedosto',
    'Insert youtube/vimeo video': 'Lisää Youtube-/vimeo- video',
    'Insert link': 'Lisää linkki',
    'Font size': 'Kirjasimen koko',
    'Font family': 'Kirjasimen nimi',
    'Insert format block': 'Lisää muotoilualue',
    Normal: 'Normaali',
    'Heading 1': 'Otsikko 1',
    'Heading 2': 'Otsikko 2',
    'Heading 3': 'Otsikko 3',
    'Heading 4': 'Otsikko 4',
    Quote: 'Lainaus',
    Code: 'Koodi',
    Insert: 'Lisää',
    'Insert table': 'Lisää taulukko',
    'Decrease Indent': 'Pienennä sisennystä',
    'Increase Indent': 'Lisää sisennystä',
    'Select Special Character': 'Valitse erikoismerkki',
    'Insert Special Character': 'Lisää erikoismerkki',
    'Paint format': 'Maalaa muotoilu',
    'Change mode': 'Vaihda tilaa',
    Margins: 'Marginaalit',
    top: 'ylös',
    right: 'oikealle',
    bottom: 'alas',
    left: 'vasemmalle',
    Styles: 'CSS-tyylit',
    Classes: 'CSS-luokat',
    Align: 'Asemointi',
    Right: 'Oikea',
    Center: 'Keskellä',
    Left: 'Vasen',
    '--Not Set--': '--Ei asetettu--',
    Src: 'Fuente',
    Title: 'Otsikko',
    Alternative: 'Vaihtoehtoinen teksti',
    Filter: 'Suodatin',
    Link: 'Linkki',
    'Open link in new tab': 'Avaa uudessa välilehdessä',
    Image: 'Kuva',
    file: 'Tiedosto',
    'Image properties': 'Kuvan ominaisuudet',
    Cancel: 'Peruuta',
    Ok: 'Ok',
    'Your code is similar to HTML. Keep as HTML?': 'Koodi on HTML:n tapaista. Säilytetäänkö HTML?',
    'Paste as HTML': 'Liitä HTML:nä?',
    Keep: 'Säilytä',
    Clean: 'Tyhjennä',
    'Insert as Text': 'Lisää tekstinä',
    'Word Paste Detected': 'Word liittäminen havaittu',
    'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?': 'Liitetty sisältö tulee Microsoft Word-/Excel- tiedostosta. Haluatko säilyttää muotoilun vai poistaa sen?',
    'Insert only Text': 'Lisää vain teksti',
    'File Browser': 'Tiedostoselain',
    'Error on load list': 'Virhe listan latauksessa',
    'Error on load folders': 'Virhe kansioiden latauksessa',
    'Are you sure?': 'Oletko varma?',
    'Enter Directory name': 'Syötä hakemiston nimi',
    'Create directory': 'Luo hakemisto',
    'type name': 'Syötä nimi',
    'Drop image': 'Pudota kuva',
    'Drop file': 'Pudota tiedosto',
    'or click': 'tai klikkaa',
    'Alternative text': 'Vaihtoehtoinen teksti',
    Browse: 'Selaa',
    Upload: 'Lataa',
    Background: 'Tausta',
    Text: 'Teksti',
    Top: 'Ylös',
    Middle: 'Keskelle',
    Bottom: 'Alas',
    'Insert column before': 'Lisää sarake ennen',
    'Insert column after': 'Lisää sarake jälkeen',
    'Insert row above': 'Lisää rivi ylös',
    'Insert row below': 'Lisää rivi alle',
    'Delete table': 'Poista taulukko',
    'Delete row': 'Poista rivi',
    'Delete column': 'Poista sarake',
    'Empty cell': 'Tyhjennä solu',
    Delete: 'Poista',
    'Strike through': 'Yliviivaus',
    Underline: 'Alleviivaus',
    Break: 'Vaihto',
    'Search for': 'Etsi arvoa',
    'Replace with': 'Korvaa arvolla',
    Replace: 'Korvaa',
    Edit: 'Muokkaa',
    'Vertical align': 'Pystyasemointi',
    'Horizontal align': 'Vaaka-asemointi',
    'Sort by changed': 'Järjestä muuttuneilla',
    'Sort by name': 'Järjestä nimellä',
    'Sort by size': 'Järjestä koolla',
    'Add folder': 'Lisää kansio',
    Split: 'Jaa',
    'Split vertical': 'Jaa pystysuuntaisesti',
    'Split horizontal': 'Jaa vaakasuuntaisesti',
    Merge: 'Yhdistä',
    'Add column': 'Lisää sarake',
    'Add row': 'Lisää rivi',
    Border: 'Reuna',
    'Embed code': 'Sisällytä koodi',
    Update: 'Päivitä',
    superscript: 'yläviite',
    subscript: 'alaviite',
    'Cut selection': 'Leikkaa valinta',
    Paste: 'Liitä',
    'Choose Content to Paste': 'Valitse liitettävä sisältö',
    'Chars: %d': 'Merkit: %d',
    'Words: %d': 'Sanat: %d',
    All: 'Kaikki',
    'Select %s': 'Valitse: %s',
    'Select all': 'Valitse kaikki',
    source: 'HTML',
    bold: 'lihavoitu',
    italic: 'kursiivi',
    brush: 'sivellin',
    link: 'linkki',
    undo: 'peruuta',
    redo: 'tee uudelleen',
    table: 'taulukko',
    image: 'kuva',
    eraser: 'pyyhekumi',
    paragraph: 'kappale',
    fontsize: 'tekstin koko',
    video: 'video',
    font: 'kirjasin',
    about: 'tietoja',
    print: 'tulosta',
    underline: 'alleviivaa',
    strikethrough: 'yliviivaa',
    indent: 'sisennä',
    outdent: 'pienennä sisennystä',
    fullsize: 'täysikokoinen',
    shrink: 'pienennä',
    hr: 'vaakaviiva',
    ul: 'järjestetty lista',
    ol: 'järjestämätön lista',
    cut: 'leikkaa',
    selectall: 'valitse kaikki',
    'Open link': 'Avaa linkki',
    'Edit link': 'Muokkaa linkkiä',
    'No follow': 'Älä seuraa',
    Unlink: 'Pura linkki',
    Eye: 'Ver',
    pencil: 'Muokkaa',
    ' URL': 'URL',
    Reset: 'Nollaa',
    Save: 'Tallenna',
    'Save as ...': 'Tallenna nimellä ...',
    Resize: 'Muuta kokoa',
    Crop: 'Rajaa',
    Width: 'Leveys',
    Height: 'Korkeus',
    'Keep Aspect Ratio': 'Säilytä kuvasuhde',
    Yes: 'Kyllä',
    No: 'Ei',
    Remove: 'Poista',
    Select: 'Valitse',
    'You can only edit your own images. Download this image on the host?': 'Voit muokata vain omia kuvia. Lataa tämä kuva palvelimelle?',
    'The image has been successfully uploaded to the host!': 'Kuva on onnistuneesti ladattu palvelimelle!',
    palette: 'paletti',
    'There are no files': 'Tiedostoja ei ole',
    Rename: 'Nimeä uudelleen',
    'Enter new name': 'Syötä uusi nimi',
    preview: 'esikatselu',
    download: 'Lataa',
    'Paste from clipboard': 'Liitä leikepöydältä',
    "Your browser doesn't support direct access to the clipboard.": 'Selaimesi ei tue suoraa pääsyä leikepöydälle.',
    'Copy selection': 'Kopioi valinta',
    copy: 'kopioi',
    'Border radius': 'Reunan pyöristys',
    'Show all': 'Näytä kaikki',
    Apply: 'Käytä',
    'Please fill out this field': 'Täytä tämä kenttä',
    'Please enter a web address': 'Annan web-osoite',
    Default: 'Oletus',
    Circle: 'Ympyrä',
    Dot: 'Piste',
    Quadrate: 'Neliö',
    'Lower Alpha': 'Pieni aakkosellinen',
    'Lower Greek': 'Pieni kreikkalainen',
    'Lower Roman': 'Pieni roomalainen',
    'Upper Alpha': 'Suuri aakkosellinen',
    'Upper Roman': 'Suuri roomalainen',
    Find: 'Hae',
    'Find Previous': 'Hae edellinen',
    'Find Next': 'Hae seuraava',
    'Insert className': 'Lisää luokkanimi',
    'Press Alt for custom resizing': 'Paina Alt muokattuun koon muuttamiseen',
    'Class name': 'Luokan nimi'
});


/***/ }),

/***/ 82439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export cleanHtml */
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _core_dom_lazy_walker_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70071);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_html_safe_html_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86518);
/* harmony import */ var _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20356);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46776);
/* harmony import */ var _helpers_index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59498);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








/**
 * Clean HTML after removeFormat and insertHorizontalRule command
 */ class cleanHtml extends _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_5__/* .Plugin */ .k {
    /** @override */ afterInit(jodit) {}
    get isEditMode() {
        return !(this.j.isInDestruct || !this.j.isEditorMode() || this.j.getReadOnly());
    }
    /**
     * Clean HTML code on every change
     */ onChangeCleanHTML() {
        if (!this.isEditMode) {
            return;
        }
        const editor = this.j;
        this.walker.setWork(editor.editor);
        this.currentSelectionNode = editor.s.current();
    }
    startWalker() {
        const { jodit } = this;
        const allow = (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_7__/* .getHash */ .Zd)(this.j.o.cleanHTML.allowTags);
        const deny = (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_7__/* .getHash */ .Zd)(this.j.o.cleanHTML.denyTags);
        this.walker.on('visit', (node)=>(0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_7__/* .visitNodeWalker */ .eZ)(jodit, node, allow, deny, this.currentSelectionNode)).on('end', (affected)=>{
            this.j.e.fire(affected ? 'internalChange finishedCleanHTMLWorker' : 'finishedCleanHTMLWorker');
        });
    }
    beforeCommand(command) {
        if (command.toLowerCase() === 'removeformat') {
            if (this.j.s.isCollapsed()) {
                (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_7__/* .removeFormatForCollapsedSelection */ .w5)(this.j);
            } else {
                (0,_helpers_index_js__WEBPACK_IMPORTED_MODULE_7__/* .removeFormatForSelection */ .hk)(this.j);
            }
            return false;
        }
    }
    /**
     * Event handler when manually assigning a value to the HTML editor.
     */ onBeforeSetNativeEditorValue(data) {
        const [sandBox, iframe] = this.j.o.cleanHTML.useIframeSandbox ? this.j.createInside.sandbox() : [
            this.j.createInside.div()
        ];
        sandBox.innerHTML = data.value;
        this.onSafeHTML(sandBox);
        data.value = sandBox.innerHTML;
        (0,_core_helpers_html_safe_html_js__WEBPACK_IMPORTED_MODULE_4__/* .safeHTML */ .t)(sandBox, {
            safeJavaScriptLink: true,
            removeOnError: true
        });
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(iframe);
        return false;
    }
    onSafeHTML(sandBox) {
        (0,_core_helpers_html_safe_html_js__WEBPACK_IMPORTED_MODULE_4__/* .safeHTML */ .t)(sandBox, this.j.o.cleanHTML);
    }
    /** @override */ beforeDestruct() {
        this.walker.destruct();
    }
    constructor(){
        super(...arguments);
        /** @override */ this.buttons = [
            {
                name: 'eraser',
                group: 'font-style'
            }
        ];
        this.currentSelectionNode = null;
        this.walker = new _core_dom_lazy_walker_js__WEBPACK_IMPORTED_MODULE_2__/* .LazyWalker */ .p(this.j.async, {
            timeout: this.j.o.cleanHTML.timeout
        });
    }
}
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)([
        ':change',
        ':afterSetMode',
        ':afterInit',
        ':mousedown',
        ':keydown'
    ])
], cleanHtml.prototype, "onChangeCleanHTML", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.hook)('ready')
], cleanHtml.prototype, "startWalker", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)(':beforeCommand')
], cleanHtml.prototype, "beforeCommand", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)(':beforeSetNativeEditorValue')
], cleanHtml.prototype, "onBeforeSetNativeEditorValue", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)(':safeHTML')
], cleanHtml.prototype, "onSafeHTML", null);
_core_global_js__WEBPACK_IMPORTED_MODULE_3__/* .pluginSystem */ .fg.add('cleanHtml', cleanHtml);


/***/ }),

/***/ 82501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   m: function() { return /* binding */ parseQuery; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * Parse query string
 */ const parseQuery = (queryString)=>{
    const query = {}, a = queryString.substring(1).split('&');
    for(let i = 0; i < a.length; i += 1){
        const keyValue = a[i].split('=');
        query[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1] || '');
    }
    return query;
};


/***/ }),

/***/ 82515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   z: function() { return /* binding */ wrapList; }
/* harmony export */ });
/* harmony import */ var _dom_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22732);
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63687);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77361);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/**
 * Replaces non-leaf items with leaf items and either creates a new list or
 * adds a new item to the nearest old list
 * @private
 */ function wrapList(commitStyle, wrapper, jodit) {
    const result = jodit.e.fire(`${_constants_js__WEBPACK_IMPORTED_MODULE_2__/* ._PREFIX */ .ar}BeforeWrapList`, _constants_js__WEBPACK_IMPORTED_MODULE_2__/* .REPLACE */ .dj, wrapper, commitStyle);
    const newWrapper = result !== null && result !== void 0 ? result : _dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.replace(wrapper, 'li', jodit.createInside);
    const prev = newWrapper.previousElementSibling;
    const next = newWrapper.nextElementSibling;
    let list = _dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(prev, commitStyle.element) ? prev : null;
    list !== null && list !== void 0 ? list : list = _dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(next, commitStyle.element) ? next : null;
    if (!_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isList(list) || !(0,_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isSameAttributes */ .M6)(list, commitStyle.options.attributes)) {
        list = jodit.createInside.element(commitStyle.element);
        (0,_index_js__WEBPACK_IMPORTED_MODULE_1__/* .toggleAttributes */ .Yx)(commitStyle, list, jodit, _constants_js__WEBPACK_IMPORTED_MODULE_2__/* .INITIAL */ .DI);
        _dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.before(newWrapper, list);
    }
    if (prev === list) {
        _dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.append(list, newWrapper);
    } else {
        _dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.prepend(list, newWrapper);
    }
    if (_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(list.nextElementSibling, commitStyle.element) && (0,_index_js__WEBPACK_IMPORTED_MODULE_1__/* .elementsEqualAttributes */ .Dd)(list, list.nextElementSibling)) {
        _dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.append(list, Array.from(list.nextElementSibling.childNodes));
        _dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(list.nextElementSibling);
    }
    jodit.e.fire(`${_constants_js__WEBPACK_IMPORTED_MODULE_2__/* ._PREFIX */ .ar}AfterWrapList`, _constants_js__WEBPACK_IMPORTED_MODULE_2__/* .WRAP */ .Zk, list, commitStyle);
    return list;
}


/***/ }),

/***/ 82558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   f: function() { return /* binding */ allowAttributes; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/**
 * @private
 */ function allowAttributes(jodit, nodeElm, hadEffect, allow) {
    if (allow && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isElement(nodeElm) && allow[nodeElm.nodeName] !== true) {
        const attrs = nodeElm.attributes;
        if (attrs && attrs.length) {
            const removeAttrs = [];
            for(let i = 0; i < attrs.length; i += 1){
                const attr = allow[nodeElm.nodeName][attrs[i].name];
                if (!attr || attr !== true && attr !== attrs[i].value) {
                    removeAttrs.push(attrs[i].name);
                }
            }
            if (removeAttrs.length) {
                hadEffect = true;
            }
            removeAttrs.forEach((attr)=>{
                nodeElm.removeAttribute(attr);
            });
        }
    }
    return hadEffect;
}


/***/ }),

/***/ 82758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ACCURACY: function() { return /* binding */ ACCURACY; },
/* harmony export */   APP_VERSION: function() { return /* binding */ APP_VERSION; },
/* harmony export */   BASE_PATH: function() { return /* binding */ BASE_PATH; },
/* harmony export */   BASE_PATH_IS_MIN: function() { return /* binding */ BASE_PATH_IS_MIN; },
/* harmony export */   BR: function() { return /* binding */ BR; },
/* harmony export */   CLIPBOARD_ID: function() { return /* binding */ CLIPBOARD_ID; },
/* harmony export */   COMMAND_KEYS: function() { return /* binding */ COMMAND_KEYS; },
/* harmony export */   EMULATE_DBLCLICK_TIMEOUT: function() { return /* binding */ EMULATE_DBLCLICK_TIMEOUT; },
/* harmony export */   ES: function() { return /* binding */ ES; },
/* harmony export */   FAT_MODE: function() { return /* binding */ FAT_MODE; },
/* harmony export */   HOMEPAGE: function() { return /* binding */ HOMEPAGE; },
/* harmony export */   INSEPARABLE_TAGS: function() { return /* binding */ INSEPARABLE_TAGS; },
/* harmony export */   INSERT_AS_HTML: function() { return /* binding */ INSERT_AS_HTML; },
/* harmony export */   INSERT_AS_TEXT: function() { return /* binding */ INSERT_AS_TEXT; },
/* harmony export */   INSERT_CLEAR_HTML: function() { return /* binding */ INSERT_CLEAR_HTML; },
/* harmony export */   INSERT_ONLY_TEXT: function() { return /* binding */ INSERT_ONLY_TEXT; },
/* harmony export */   INVISIBLE_SPACE: function() { return /* binding */ INVISIBLE_SPACE; },
/* harmony export */   INVISIBLE_SPACE_REG_EXP: function() { return /* binding */ INVISIBLE_SPACE_REG_EXP; },
/* harmony export */   INVISIBLE_SPACE_REG_EXP_END: function() { return /* binding */ INVISIBLE_SPACE_REG_EXP_END; },
/* harmony export */   INVISIBLE_SPACE_REG_EXP_START: function() { return /* binding */ INVISIBLE_SPACE_REG_EXP_START; },
/* harmony export */   IS_BLOCK: function() { return /* binding */ IS_BLOCK; },
/* harmony export */   IS_ES_MODERN: function() { return /* binding */ IS_ES_MODERN; },
/* harmony export */   IS_ES_NEXT: function() { return /* binding */ IS_ES_NEXT; },
/* harmony export */   IS_IE: function() { return /* binding */ IS_IE; },
/* harmony export */   IS_INLINE: function() { return /* binding */ IS_INLINE; },
/* harmony export */   IS_MAC: function() { return /* binding */ IS_MAC; },
/* harmony export */   IS_PROD: function() { return /* binding */ IS_PROD; },
/* harmony export */   IS_TEST: function() { return /* binding */ IS_TEST; },
/* harmony export */   KEY_ALIASES: function() { return /* binding */ KEY_ALIASES; },
/* harmony export */   KEY_ALT: function() { return /* binding */ KEY_ALT; },
/* harmony export */   KEY_BACKSPACE: function() { return /* binding */ KEY_BACKSPACE; },
/* harmony export */   KEY_DELETE: function() { return /* binding */ KEY_DELETE; },
/* harmony export */   KEY_DOWN: function() { return /* binding */ KEY_DOWN; },
/* harmony export */   KEY_ENTER: function() { return /* binding */ KEY_ENTER; },
/* harmony export */   KEY_ESC: function() { return /* binding */ KEY_ESC; },
/* harmony export */   KEY_F3: function() { return /* binding */ KEY_F3; },
/* harmony export */   KEY_LEFT: function() { return /* binding */ KEY_LEFT; },
/* harmony export */   KEY_META: function() { return /* binding */ KEY_META; },
/* harmony export */   KEY_RIGHT: function() { return /* binding */ KEY_RIGHT; },
/* harmony export */   KEY_SPACE: function() { return /* binding */ KEY_SPACE; },
/* harmony export */   KEY_TAB: function() { return /* binding */ KEY_TAB; },
/* harmony export */   KEY_UP: function() { return /* binding */ KEY_UP; },
/* harmony export */   LIST_TAGS: function() { return /* binding */ LIST_TAGS; },
/* harmony export */   MARKER_CLASS: function() { return /* binding */ MARKER_CLASS; },
/* harmony export */   MODE_SOURCE: function() { return /* binding */ MODE_SOURCE; },
/* harmony export */   MODE_SPLIT: function() { return /* binding */ MODE_SPLIT; },
/* harmony export */   MODE_WYSIWYG: function() { return /* binding */ MODE_WYSIWYG; },
/* harmony export */   NBSP_SPACE: function() { return /* binding */ NBSP_SPACE; },
/* harmony export */   NEARBY: function() { return /* binding */ NEARBY; },
/* harmony export */   NO_EMPTY_TAGS: function() { return /* binding */ NO_EMPTY_TAGS; },
/* harmony export */   PARAGRAPH: function() { return /* binding */ PARAGRAPH; },
/* harmony export */   PASSIVE_EVENTS: function() { return /* binding */ PASSIVE_EVENTS; },
/* harmony export */   SAFE_COUNT_CHANGE_CALL: function() { return /* binding */ SAFE_COUNT_CHANGE_CALL; },
/* harmony export */   SET_TEST: function() { return /* binding */ SET_TEST; },
/* harmony export */   SOURCE_CONSUMER: function() { return /* binding */ SOURCE_CONSUMER; },
/* harmony export */   SPACE_REG_EXP: function() { return /* binding */ SPACE_REG_EXP; },
/* harmony export */   SPACE_REG_EXP_END: function() { return /* binding */ SPACE_REG_EXP_END; },
/* harmony export */   SPACE_REG_EXP_START: function() { return /* binding */ SPACE_REG_EXP_START; },
/* harmony export */   TEMP_ATTR: function() { return /* binding */ TEMP_ATTR; },
/* harmony export */   TEXT_HTML: function() { return /* binding */ TEXT_HTML; },
/* harmony export */   TEXT_PLAIN: function() { return /* binding */ TEXT_PLAIN; },
/* harmony export */   TEXT_RTF: function() { return /* binding */ TEXT_RTF; },
/* harmony export */   TOKENS: function() { return /* binding */ TOKENS; },
/* harmony export */   globalDocument: function() { return /* binding */ globalDocument; },
/* harmony export */   globalWindow: function() { return /* binding */ globalWindow; },
/* harmony export */   lang: function() { return /* binding */ lang; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * You can use Jodit constants in your code
 * ```javascript
 * import { Jodit } from 'jodit';
 * console.log(Jodit.constants.IS_IE);
 * console.log(Jodit.constants.APP_VERSION);
 * ```
 * @packageDocumentation
 * @module constants
 */ const APP_VERSION = "4.6.9";
// prettier-ignore
const ES = "es2021";
const IS_ES_MODERN = true;
const IS_ES_NEXT = true;
const IS_PROD = true;
let IS_TEST = false;
const FAT_MODE = false;
const HOMEPAGE = "https://xdsoft.net/jodit/pro/";
const SET_TEST = ()=>IS_TEST = true;
const TOKENS = {};
const INVISIBLE_SPACE = '\uFEFF';
const NBSP_SPACE = '\u00A0';
const INVISIBLE_SPACE_REG_EXP = ()=>/[\uFEFF]/g;
const INVISIBLE_SPACE_REG_EXP_END = ()=>/[\uFEFF]+$/g;
const INVISIBLE_SPACE_REG_EXP_START = ()=>/^[\uFEFF]+/g;
const SPACE_REG_EXP = ()=>/[\s\n\t\r\uFEFF\u200b]+/g;
const SPACE_REG_EXP_START = ()=>/^[\s\n\t\r\uFEFF\u200b]+/g;
const SPACE_REG_EXP_END = ()=>/[\s\n\t\r\uFEFF\u200b]+$/g;
const globalWindow = typeof window !== 'undefined' ? window : undefined;
const globalDocument = typeof document !== 'undefined' ? document : undefined;
const IS_BLOCK = /^(ADDRESS|ARTICLE|ASIDE|BLOCKQUOTE|CANVAS|DD|DFN|DIV|DL|DT|FIELDSET|FIGCAPTION|FIGURE|FOOTER|FORM|H[1-6]|HEADER|HGROUP|HR|LI|MAIN|NAV|NOSCRIPT|OUTPUT|P|PRE|RUBY|SCRIPT|STYLE|OBJECT|OL|SECTION|IFRAME|JODIT|JODIT-MEDIA|UL|TR|TD|TH|TBODY|THEAD|TFOOT|TABLE|BODY|HTML|VIDEO)$/i;
const IS_INLINE = /^(STRONG|SPAN|I|EM|B|SUP|SUB|A|U)$/i;
const LIST_TAGS = new Set([
    'ul',
    'ol'
]);
const __UNSEPARABLE_TAGS = [
    'img',
    'video',
    'svg',
    'iframe',
    'script',
    'input',
    'textarea',
    'link',
    'jodit',
    'jodit-media'
];
const INSEPARABLE_TAGS = new Set([
    ...__UNSEPARABLE_TAGS,
    'br',
    'hr'
]);
const NO_EMPTY_TAGS = new Set(__UNSEPARABLE_TAGS);
const KEY_META = 'Meta';
const KEY_BACKSPACE = 'Backspace';
const KEY_TAB = 'Tab';
const KEY_ENTER = 'Enter';
const KEY_ESC = 'Escape';
const KEY_ALT = 'Alt';
const KEY_LEFT = 'ArrowLeft';
const KEY_UP = 'ArrowUp';
const KEY_RIGHT = 'ArrowRight';
const KEY_DOWN = 'ArrowDown';
const KEY_SPACE = 'Space';
const KEY_DELETE = 'Delete';
const KEY_F3 = 'F3';
const NEARBY = 5;
const ACCURACY = 10;
const COMMAND_KEYS = [
    KEY_META,
    KEY_BACKSPACE,
    KEY_DELETE,
    KEY_UP,
    KEY_DOWN,
    KEY_RIGHT,
    KEY_LEFT,
    KEY_ENTER,
    KEY_ESC,
    KEY_F3,
    KEY_TAB
];
const BR = 'br';
const PARAGRAPH = 'p';
/**
 * WYSIWYG editor mode
 */ const MODE_WYSIWYG = 1;
/**
 * html editor mode
 */ const MODE_SOURCE = 2;
/**
 * Source code editor and HTML editor both like
 * @see http://getuikit.com/docs/htmleditor.html|this
 */ const MODE_SPLIT = 3;
/**
 * Is Internet Explorer
 */ const IS_IE = typeof navigator !== 'undefined' && (navigator.userAgent.indexOf('MSIE') !== -1 || /rv:11.0/i.test(navigator.userAgent));
/**
 * For IE11 it will be 'text'. Need for dataTransfer.setData
 */ const TEXT_PLAIN = IS_IE ? 'text' : 'text/plain';
const TEXT_HTML = IS_IE ? 'html' : 'text/html';
const TEXT_RTF = IS_IE ? 'rtf' : 'text/rtf';
const MARKER_CLASS = 'jodit-selection_marker';
const EMULATE_DBLCLICK_TIMEOUT = 300;
/**
 * Paste the copied text as HTML, all content will be pasted exactly as it was on the clipboard.
 * So how would you copy its code directly into the source document.
 * ```
 * <h1 style="color:red">test</h1>
 * ```
 * Will be inserted into the document as
 * ```
 * <h1 style="color:red">test</h1>
 * ```
 */ const INSERT_AS_HTML = 'insert_as_html';
/**
 * Same as [[INSERT_AS_HTML]], but content will be stripped of extra styles and empty tags
 * ```html
 * <h1 style="color:red">test</h1>
 * ```
 * Will be inserted into the document as
 * ```html
 * <h1>test</h1>
 * ```
 */ const INSERT_CLEAR_HTML = 'insert_clear_html';
/**
 * The contents of the clipboard will be pasted into the document as plain text, i.e. all tags will be displayed as text.
 * ```html
 * <h1>test</h1>
 * ```
 * Will be inserted into the document as
 * ```html
 * &gt;&lt;h1&gt;test&lt;/h1&gt;
 * ```
 */ const INSERT_AS_TEXT = 'insert_as_text';
/**
 * All tags will be stripped:
 * ```html
 * <h1>test</h1>
 * ```
 * Will be inserted into the document as
 * ```html
 * test
 * ```
 */ const INSERT_ONLY_TEXT = 'insert_only_text';
const SAFE_COUNT_CHANGE_CALL = 10;
const IS_MAC = typeof globalWindow !== 'undefined' && /Mac|iPod|iPhone|iPad/.test(globalWindow.navigator.platform);
const KEY_ALIASES = {
    add: '+',
    break: 'pause',
    cmd: 'meta',
    command: 'meta',
    ctl: 'control',
    ctrl: 'control',
    del: 'delete',
    down: 'arrowdown',
    esc: 'escape',
    ins: 'insert',
    left: 'arrowleft',
    mod: IS_MAC ? 'meta' : 'control',
    opt: 'alt',
    option: 'alt',
    return: 'enter',
    right: 'arrowright',
    space: 'space',
    spacebar: 'space',
    up: 'arrowup',
    win: 'meta',
    windows: 'meta'
};
const removeScriptName = (src)=>{
    const parts = src.split('/');
    const isMin =  true ? false : 0;
    if (/\.js/.test(parts[parts.length - 1])) {
        return {
            basePath: parts.slice(0, parts.length - 1).join('/') + '/',
            isMin
        };
    }
    return {
        basePath: src,
        isMin
    };
};
const { basePath, isMin } = (()=>{
    if (typeof document === 'undefined') {
        return {
            basePath: '',
            isMin: Boolean(false)
        };
    }
    const script = globalDocument.currentScript;
    if (script) {
        return removeScriptName(script.src);
    }
    const scripts = globalDocument.querySelectorAll('script[src]');
    if (scripts && scripts.length) {
        return removeScriptName(scripts[scripts.length - 1].src);
    }
    return removeScriptName(globalWindow.location.href);
})();
/**
 * Path to the current script
 */ const BASE_PATH = basePath;
/**
 * Current script is minified
 */ const BASE_PATH_IS_MIN = isMin;
const TEMP_ATTR = 'data-jodit-temp';
const lang = {};
const CLIPBOARD_ID = 'clipboard';
const SOURCE_CONSUMER = 'source-consumer';
const PASSIVE_EVENTS = new Set([
    'touchstart',
    'touchend',
    'scroll',
    'mousewheel',
    'mousemove',
    'touchmove'
]);


/***/ }),

/***/ 82760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FI: function() { return /* binding */ connection; },
/* harmony export */   fF: function() { return /* binding */ options; },
/* harmony export */   z3: function() { return /* binding */ error; }
/* harmony export */ });
/* harmony import */ var _errors_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32880);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/utils
 */ 
/**
 * Helper for create Error object
 */ function error(message) {
    return new TypeError(message);
}
function connection(message) {
    return new _errors_index_js__WEBPACK_IMPORTED_MODULE_0__/* .ConnectionError */ .Rc(message);
}
function options(message) {
    return new _errors_index_js__WEBPACK_IMPORTED_MODULE_0__/* .OptionsError */ .ZW(message);
}


/***/ }),

/***/ 83059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    symbols: 'symbol'
});


/***/ }),

/***/ 83111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   q: function() { return /* binding */ ToolbarSelect; }
/* harmony export */ });
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65478);
/* harmony import */ var _core_helpers_checker_is_plain_object_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72430);
/* harmony import */ var _core_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70799);
/* harmony import */ var _button_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78644);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let ToolbarSelect = class ToolbarSelect extends _button_js__WEBPACK_IMPORTED_MODULE_1__/* .ToolbarButton */ .I {
    className() {
        return 'ToolbarSelect';
    }
    update() {
        var _a, _b, _c;
        super.update();
        this.state.icon.name = '';
        const { list, data } = this.control;
        if (list) {
            let key = this.state.value || (data && (0,_core_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .K)(data.currentValue) ? data.currentValue : undefined);
            if (!key) {
                const keys = Object.keys(list);
                key = keys[0];
            }
            const text = ((0,_core_helpers_checker_is_plain_object_js__WEBPACK_IMPORTED_MODULE_3__/* .isPlainObject */ .Q)(list) ? list[key.toString()] || key : key).toString();
            this.state.text = (_c = (_b = (_a = this.control).textTemplate) === null || _b === void 0 ? void 0 : _b.call(_a, this.jodit, text)) !== null && _c !== void 0 ? _c : text;
        }
    }
};
ToolbarSelect = __decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.component
], ToolbarSelect);



/***/ }),

/***/ 83160:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'Type something': 'Напишите что-либо',
    'About Jodit': 'О Jodit',
    'Jodit Editor': 'Редактор Jodit',
    "Jodit User's Guide": 'Jodit Руководство пользователя',
    'contains detailed help for using': 'содержит детальную информацию по использованию',
    'For information about the license, please go to our website:': 'Для получения сведений о лицензии , пожалуйста, перейдите на наш сайт:',
    'Buy full version': 'Купить полную версию',
    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.': 'Авторские права © XDSoft.net - Чупурнов Валерий. Все права защищены.',
    Anchor: 'Анкор',
    'Open in new tab': 'Открывать ссылку в новой вкладке',
    'Open in fullsize': 'Открыть редактор в полном размере',
    'Clear Formatting': 'Очистить форматирование',
    'Fill color or set the text color': 'Цвет заливки или цвет текста',
    Redo: 'Повтор',
    Undo: 'Отмена',
    Bold: 'Жирный',
    Italic: 'Наклонный',
    'Insert Unordered List': 'Вставка маркированного списка',
    'Insert Ordered List': 'Вставить нумерованный список',
    'Align Center': 'Выровнять по центру',
    'Align Justify': 'Выровнять по ширине',
    'Align Left': 'Выровнять по левому краю',
    'Align Right': 'Выровнять по правому краю',
    'Insert Horizontal Line': 'Вставить горизонтальную линию',
    'Insert Image': 'Вставить изображение',
    'Insert file': 'Вставить файл',
    'Insert youtube/vimeo video': 'Вставьте видео',
    'Insert link': 'Вставить ссылку',
    'Font size': 'Размер шрифта',
    'Font family': 'Шрифт',
    'Insert format block': 'Вставить блочный элемент',
    Normal: 'Нормальный текст',
    'Heading 1': 'Заголовок 1',
    'Heading 2': 'Заголовок 2',
    'Heading 3': 'Заголовок 3',
    'Heading 4': 'Заголовок 4',
    Quote: 'Цитата',
    Code: 'Код',
    Insert: 'Вставить',
    'Insert table': 'Вставить таблицу',
    'Decrease Indent': 'Уменьшить отступ',
    'Increase Indent': 'Увеличить отступ',
    'Select Special Character': 'Выберите специальный символ',
    'Insert Special Character': 'Вставить специальный символ',
    'Paint format': 'Формат краски',
    'Change mode': 'Источник',
    Margins: 'Отступы',
    top: 'сверху',
    right: 'справа',
    bottom: 'снизу',
    left: 'слева',
    Styles: 'Стили',
    Classes: 'Классы',
    Align: 'Выравнивание',
    Right: 'По правому краю',
    Center: 'По центру',
    Left: 'По левому краю',
    '--Not Set--': '--не устанавливать--',
    Src: 'src',
    Title: 'Заголовок',
    Alternative: 'Альтернативный текст (alt)',
    Link: 'Ссылка',
    'Open link in new tab': 'Открывать ссылку в новом окне',
    file: 'Файл',
    Advanced: 'Расширенные',
    'Image properties': 'Свойства изображения',
    Cancel: 'Отмена',
    Ok: 'Ок',
    'Your code is similar to HTML. Keep as HTML?': 'Ваш текст, который вы пытаетесь вставить похож на HTML. Вставить его как HTML?',
    'Paste as HTML': 'Вставить как HTML?',
    Keep: 'Сохранить оригинал',
    Clean: 'Почистить',
    'Insert as Text': 'Вставить как текст',
    'Insert only Text': 'Вставить только текст',
    'Word Paste Detected': 'Возможно это фрагмент Word или Excel',
    'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?': 'Контент который вы вставляете поступает из документа Microsoft Word / Excel. Вы хотите сохранить формат или очистить его?',
    'File Browser': 'Браузер файлов',
    'Error on load list': 'Ошибка при загрузке списка изображений',
    'Error on load folders': 'Ошибка при загрузке списка директорий',
    'Are you sure?': 'Вы уверены?',
    'Enter Directory name': 'Введите название директории',
    'Create directory': 'Создать директорию',
    'type name': 'введите название',
    'Drop image': 'Перетащите сюда изображение',
    'Drop file': 'Перетащите сюда файл',
    'or click': 'или нажмите',
    'Alternative text': 'Альтернативный текст',
    Browse: 'Сервер',
    Upload: 'Загрузка',
    Background: 'Фон',
    Text: 'Текст',
    Top: ' К верху',
    Middle: 'По середине',
    Bottom: 'К низу',
    'Insert column before': 'Вставить столбец до',
    'Insert column after': 'Вставить столбец после',
    'Insert row above': 'Вставить ряд выше',
    'Insert row below': 'Вставить ряд ниже',
    'Delete table': 'Удалить таблицу',
    'Delete row': 'Удалять ряд',
    'Delete column': 'Удалить столбец',
    'Empty cell': 'Очистить ячейку',
    source: 'HTML',
    bold: 'жирный',
    italic: 'курсив',
    brush: 'заливка',
    link: 'ссылка',
    undo: 'отменить',
    redo: 'повторить',
    table: 'таблица',
    image: 'Изображение',
    eraser: 'очистить',
    paragraph: 'параграф',
    fontsize: 'размер шрифта',
    video: 'видео',
    font: 'шрифт',
    about: 'о редакторе',
    print: 'печать',
    underline: 'подчеркнутый',
    strikethrough: 'перечеркнутый',
    indent: 'отступ',
    outdent: 'выступ',
    fullsize: 'во весь экран',
    shrink: 'обычный размер',
    hr: 'линия',
    ul: 'Список',
    ol: 'Нумерованный список',
    cut: 'Вырезать',
    selectall: 'Выделить все',
    'Embed code': 'Код',
    'Open link': 'Открыть ссылку',
    'Edit link': 'Редактировать ссылку',
    'No follow': 'Атрибут nofollow',
    Unlink: 'Убрать ссылку',
    Eye: 'Просмотр',
    pencil: 'Редактировать',
    Update: 'Обновить',
    ' URL': 'URL',
    Edit: 'Редактировать',
    'Horizontal align': 'Горизонтальное выравнивание',
    Filter: 'Фильтр',
    'Sort by changed': 'По изменению',
    'Sort by name': 'По имени',
    'Sort by size': 'По размеру',
    'Add folder': 'Добавить папку',
    Reset: 'Восстановить',
    Save: 'Сохранить',
    'Save as ...': 'Сохранить как',
    Resize: 'Изменить размер',
    Crop: 'Обрезать размер',
    Width: 'Ширина',
    Height: 'Высота',
    'Keep Aspect Ratio': 'Сохранять пропорции',
    Yes: 'Да',
    No: 'Нет',
    Remove: 'Удалить',
    Select: 'Выделить',
    'Chars: %d': 'Символов: %d',
    'Words: %d': 'Слов: %d',
    All: 'Выделить все',
    'Select %s': 'Выделить: %s',
    'Select all': 'Выделить все',
    'Vertical align': 'Вертикальное выравнивание',
    Split: 'Разделить',
    'Split vertical': 'Разделить по вертикали',
    'Split horizontal': 'Разделить по горизонтали',
    Merge: 'Объединить в одну',
    'Add column': 'Добавить столбец',
    'Add row': 'Добавить строку',
    Delete: 'Удалить',
    Border: 'Рамка',
    'License: %s': 'Лицензия: %s',
    'Strike through': 'Перечеркнуть',
    Underline: 'Подчеркивание',
    superscript: 'верхний индекс',
    subscript: 'индекс',
    'Cut selection': 'Вырезать',
    Break: 'Разделитель',
    'Search for': 'Найти',
    'Replace with': 'Заменить на',
    Replace: 'Заменить',
    Paste: 'Вставить',
    'Choose Content to Paste': 'Выбрать контент для вставки',
    'You can only edit your own images. Download this image on the host?': 'Вы можете редактировать только свои собственные изображения. Загрузить это изображение на ваш сервер?',
    'The image has been successfully uploaded to the host!': 'Изображение успешно загружено на сервер!',
    palette: 'палитра',
    'There are no files': 'В данном каталоге нет файлов',
    Rename: 'Переименовать',
    'Enter new name': 'Введите новое имя',
    preview: 'Предпросмотр',
    download: 'Скачать',
    'Paste from clipboard': 'Вставить из буфера обмена',
    "Your browser doesn't support direct access to the clipboard.": 'Ваш браузер не поддерживает прямой доступ к буферу обмена.',
    'Copy selection': 'Скопировать выделенное',
    copy: 'копия',
    'Border radius': 'Радиус границы',
    'Show all': 'Показать все',
    Apply: 'Применить',
    'Please fill out this field': 'Пожалуйста, заполните это поле',
    'Please enter a web address': 'Пожалуйста, введите веб-адрес',
    Default: 'По умолчанию',
    Circle: 'Круг',
    Dot: 'Точка',
    Quadrate: 'Квадрат',
    Find: 'Найти',
    'Find Previous': 'Найти Предыдущие',
    'Find Next': 'Найти Далее',
    'Insert className': 'Вставить название класса',
    'Press Alt for custom resizing': 'Нажмите Alt для изменения пользовательского размера'
});


/***/ }),

/***/ 83447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: function() { return /* binding */ getHash; }
/* harmony export */ });
/* harmony import */ var _core_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70799);
/* harmony import */ var _core_helpers_string_trim_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49055);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/**
 * @private
 */ function getHash(tags) {
    const attributesReg = /([^[]*)\[([^\]]+)]/;
    const separator = /[\s]*,[\s]*/, attrReg = /^(.*)[\s]*=[\s]*(.*)$/;
    const tagsHash = {};
    if ((0,_core_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .K)(tags)) {
        tags.split(separator).map((elm)=>{
            elm = (0,_core_helpers_string_trim_js__WEBPACK_IMPORTED_MODULE_0__/* .trim */ .Bq)(elm);
            const attr = attributesReg.exec(elm), allowAttributes = {}, attributeMap = (attrName)=>{
                attrName = (0,_core_helpers_string_trim_js__WEBPACK_IMPORTED_MODULE_0__/* .trim */ .Bq)(attrName);
                const val = attrReg.exec(attrName);
                if (val) {
                    allowAttributes[val[1]] = val[2];
                } else {
                    allowAttributes[attrName] = true;
                }
            };
            if (attr) {
                const attr2 = attr[2].split(separator);
                if (attr[1]) {
                    attr2.forEach(attributeMap);
                    tagsHash[attr[1].toUpperCase()] = allowAttributes;
                }
            } else {
                tagsHash[elm.toUpperCase()] = true;
            }
        });
        return tagsHash;
    }
    if (tags) {
        Object.keys(tags).forEach((tagName)=>{
            tagsHash[tagName.toUpperCase()] = tags[tagName];
        });
        return tagsHash;
    }
    return false;
}


/***/ }),

/***/ 83632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   O: function() { return /* binding */ ApplyStyle; }
/* harmony export */ });
/* harmony import */ var _api_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63687);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77361);
/* harmony import */ var _transactions_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55307);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/** @internal */ function ApplyStyle(jodit, cs) {
    var _a;
    const { s: sel, editor } = jodit;
    // sel.save();
    (_a = editor.firstChild) === null || _a === void 0 ? void 0 : _a.normalize(); // FF fix for test "commandsTest - Exec command "bold"
    const fakes = sel.fakes();
    const gen = jodit.s.wrapInTagGen(fakes);
    let font = gen.next();
    if (font.done) {
        return;
    }
    let state = {
        collapsed: sel.isCollapsed(),
        mode: _constants_js__WEBPACK_IMPORTED_MODULE_2__/* .INITIAL */ .DI,
        element: font.value,
        next: _transactions_js__WEBPACK_IMPORTED_MODULE_1__/* .states */ .x.START,
        jodit,
        style: cs
    };
    while(font && !font.done){
        const machine = new _api_index_js__WEBPACK_IMPORTED_MODULE_0__/* .FiniteStateMachine */ .EF(_transactions_js__WEBPACK_IMPORTED_MODULE_1__/* .states */ .x.START, _transactions_js__WEBPACK_IMPORTED_MODULE_1__/* .transactions */ .g);
        state.element = font.value;
        // machine.disableSilent();
        while(machine.getState() !== _transactions_js__WEBPACK_IMPORTED_MODULE_1__/* .states */ .x.END){
            // console.log(machine.getState(), state);
            state = machine.dispatch('exec', state);
        }
        // console.log('-------------------');
        font = gen.next();
    }
    // sel.restore();
    sel.restoreFakes(fakes);
}


/***/ }),

/***/ 83671:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22732);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21537);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50911);
/* harmony import */ var _modules_context_menu_context_menu_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80870);
/* harmony import */ var _modules_toolbar_factory_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21491);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86012);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 







/**
 * Show a path to a current element in status bar
 */ class xpath extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Plugin */ .k {
    afterInit() {
        if (this.j.o.showXPathInStatusbar) {
            this.container = this.j.c.div('jodit-xpath');
            this.j.e.off('.xpath').on('mouseup.xpath change.xpath keydown.xpath changeSelection.xpath', this.calcPath).on('afterSetMode.xpath afterInit.xpath changePlace.xpath', ()=>{
                if (!this.j.o.showXPathInStatusbar || !this.container) {
                    return;
                }
                this.j.statusbar.append(this.container);
                if (this.j.getRealMode() === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_WYSIWYG) {
                    this.calcPath();
                } else {
                    if (this.container) {
                        this.container.innerHTML = _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE;
                    }
                    this.appendSelectAll();
                }
            });
            this.calcPath();
        }
    }
    beforeDestruct() {
        if (this.j && this.j.events) {
            this.j.e.off('.xpath');
        }
        this.removeSelectAll();
        this.menu && this.menu.destruct();
        _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(this.container);
        delete this.menu;
        delete this.container;
    }
    constructor(){
        super(...arguments);
        this.onContext = (bindElement, event)=>{
            if (!this.menu) {
                this.menu = new _modules_context_menu_context_menu_js__WEBPACK_IMPORTED_MODULE_5__/* .ContextMenu */ .t(this.j);
            }
            this.menu.show(event.clientX, event.clientY, [
                {
                    icon: 'bin',
                    title: bindElement === this.j.editor ? 'Clear' : 'Remove',
                    exec: ()=>{
                        if (bindElement !== this.j.editor) {
                            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(bindElement);
                        } else {
                            this.j.value = '';
                        }
                        this.j.synchronizeValues();
                    }
                },
                {
                    icon: 'select-all',
                    title: 'Select',
                    exec: ()=>{
                        this.j.s.select(bindElement);
                    }
                }
            ]);
            return false;
        };
        this.onSelectPath = (bindElement, event)=>{
            this.j.s.focus();
            const path = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(event.target, '-path') || '/';
            if (path === '/') {
                this.j.execCommand('selectall');
                return false;
            }
            try {
                const elm = this.j.ed.evaluate(path, this.j.editor, null, XPathResult.ANY_TYPE, null).iterateNext();
                if (elm) {
                    this.j.s.select(elm);
                    return false;
                }
            } catch (_a) {}
            this.j.s.select(bindElement);
            return false;
        };
        this.tpl = (bindElement, path, name, title)=>{
            const item = this.j.c.fromHTML(`<span class="jodit-xpath__item"><a role="button" data-path="${path}" title="${title}" tabindex="-1"'>${(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.trim)(name)}</a></span>`);
            const a = item.firstChild;
            this.j.e.on(a, 'click', this.onSelectPath.bind(this, bindElement)).on(a, 'contextmenu', this.onContext.bind(this, bindElement));
            return item;
        };
        this.removeSelectAll = ()=>{
            if (this.selectAllButton) {
                this.selectAllButton.destruct();
                delete this.selectAllButton;
            }
        };
        this.appendSelectAll = ()=>{
            this.removeSelectAll();
            this.selectAllButton = (0,_modules_toolbar_factory_js__WEBPACK_IMPORTED_MODULE_6__/* .makeButton */ .BJ)(this.j, {
                name: 'selectall',
                ...this.j.o.controls.selectall
            });
            this.selectAllButton.state.size = 'tiny';
            this.container && this.container.insertBefore(this.selectAllButton.container, this.container.firstChild);
        };
        this.calcPathImd = ()=>{
            if (this.isDestructed) {
                return;
            }
            const current = this.j.s.current();
            if (this.container) {
                this.container.innerHTML = _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE;
            }
            if (current) {
                let name, xpth, li;
                _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.up(current, (elm)=>{
                    if (elm && this.j.editor !== elm && !_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isText(elm) && !_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isComment(elm)) {
                        name = elm.nodeName.toLowerCase();
                        xpth = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.getXPathByElement)(elm, this.j.editor).replace(/^\//, '');
                        li = this.tpl(elm, xpth, name, this.j.i18n('Select %s', name));
                        this.container && this.container.insertBefore(li, this.container.firstChild);
                    }
                }, this.j.editor);
            }
            this.appendSelectAll();
        };
        this.calcPath = this.j.async.debounce(this.calcPathImd, this.j.defaultTimeout * 2);
    }
}
_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .pluginSystem */ .fg.add('xpath', xpath);


/***/ }),

/***/ 83709:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1744 1408q33 0 42 18.5t-11 44.5l-126 162q-20 26-49 26t-49-26l-126-162q-20-26-11-44.5t42-18.5h80v-1024h-80q-33 0-42-18.5t11-44.5l126-162q20-26 49-26t49 26l126 162q20 26 11 44.5t-42 18.5h-80v1024h80zm-1663-1279l54 27q12 5 211 5 44 0 132-2t132-2q36 0 107.5.5t107.5.5h293q6 0 21 .5t20.5 0 16-3 17.5-9 15-17.5l42-1q4 0 14 .5t14 .5q2 112 2 336 0 80-5 109-39 14-68 18-25-44-54-128-3-9-11-48t-14.5-73.5-7.5-35.5q-6-8-12-12.5t-15.5-6-13-2.5-18-.5-16.5.5q-17 0-66.5-.5t-74.5-.5-64 2-71 6q-9 81-8 136 0 94 2 388t2 455q0 16-2.5 71.5t0 91.5 12.5 69q40 21 124 42.5t120 37.5q5 40 5 50 0 14-3 29l-34 1q-76 2-218-8t-207-10q-50 0-151 9t-152 9q-3-51-3-52v-9q17-27 61.5-43t98.5-29 78-27q19-42 19-383 0-101-3-303t-3-303v-117q0-2 .5-15.5t.5-25-1-25.5-3-24-5-14q-11-12-162-12-33 0-93 12t-80 26q-19 13-34 72.5t-31.5 111-42.5 53.5q-42-26-56-44v-383z\"/> </svg> ");


/***/ }),

/***/ 83987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $: function() { return /* binding */ buildData; }
/* harmony export */ });
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21537);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
function buildData(uploader, data) {
    if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.isFunction)(uploader.o.buildData)) {
        return uploader.o.buildData.call(uploader, data);
    }
    const FD = uploader.ow.FormData;
    if (FD !== undefined) {
        if (data instanceof FD) {
            return data;
        }
        if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_0__.isString)(data)) {
            return data;
        }
        const newData = new FD();
        const dict = data;
        Object.keys(dict).forEach((key)=>{
            newData.append(key, dict[key]);
        });
        return newData;
    }
    return data;
}


/***/ }),

/***/ 84075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   T: function() { return /* binding */ ViewWithToolbar; }
/* harmony export */ });
/* harmony import */ var _component_statuses_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78213);
/* harmony import */ var _decorators_autobind_autobind_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(40401);
/* harmony import */ var _decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37133);
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2748);
/* harmony import */ var _helpers_array_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76855);
/* harmony import */ var _helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70799);
/* harmony import */ var _helpers_utils_selector_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76078);
/* harmony import */ var _ui_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67510);
/* harmony import */ var _ui_helpers_buttons_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43649);
/* harmony import */ var _view_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35608);
/* harmony import */ var _modules_toolbar_factory_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21491);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};











class ViewWithToolbar extends _view_js__WEBPACK_IMPORTED_MODULE_6__/* .View */ .S {
    /**
     * Container for toolbar
     */ get toolbarContainer() {
        if (!this.o.fullsize && ((0,_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_8__/* .isString */ .K)(this.o.toolbar) || _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.isHTMLElement(this.o.toolbar))) {
            return (0,_helpers_utils_selector_js__WEBPACK_IMPORTED_MODULE_4__/* .resolveElement */ .tI)(this.o.toolbar, this.o.shadowRoot || this.od);
        }
        this.o.toolbar && _dom_dom_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.appendChildFirst(this.container, this.__defaultToolbarContainer);
        return this.__defaultToolbarContainer;
    }
    /**
     * Change panel container
     */ setPanel(element) {
        this.o.toolbar = element;
        this.buildToolbar();
    }
    /**
     * Helper for appended toolbar in its place
     */ buildToolbar() {
        var _a;
        if (!this.o.toolbar) {
            return;
        }
        const buttons = this.o.buttons ? (0,_helpers_array_index_js__WEBPACK_IMPORTED_MODULE_3__/* .splitArray */ .uM)(this.o.buttons) : [];
        (_a = this.toolbar) === null || _a === void 0 ? void 0 : _a.setRemoveButtons(this.o.removeButtons).build(buttons.concat(this.o.extraButtons || [])).appendTo(this.toolbarContainer);
    }
    getRegisteredButtonGroups() {
        return this.groupToButtons;
    }
    /**
     * Register button for a group
     */ registerButton(btn) {
        var _a;
        this.registeredButtons.add(btn);
        const group = (_a = btn.group) !== null && _a !== void 0 ? _a : 'other';
        if (!this.groupToButtons[group]) {
            this.groupToButtons[group] = [];
        }
        if (btn.position != null) {
            this.groupToButtons[group][btn.position] = btn.name;
        } else {
            this.groupToButtons[group].push(btn.name);
        }
        return this;
    }
    /**
     * Remove button from a group
     */ unregisterButton(btn) {
        var _a;
        this.registeredButtons.delete(btn);
        const groupName = (_a = btn.group) !== null && _a !== void 0 ? _a : 'other', group = this.groupToButtons[groupName];
        if (group) {
            const index = group.indexOf(btn.name);
            if (index !== -1) {
                group.splice(index, 1);
            }
            if (group.length === 0) {
                delete this.groupToButtons[groupName];
            }
        }
        return this;
    }
    /**
     * Prepare toolbar items and append buttons in groups
     */ beforeToolbarBuild(items) {
        if (Object.keys(this.groupToButtons).length) {
            return items.map((item)=>{
                if ((0,_ui_helpers_buttons_js__WEBPACK_IMPORTED_MODULE_9__/* .isButtonGroup */ .i)(item) && item.group && this.groupToButtons[item.group]) {
                    return {
                        group: item.group,
                        buttons: [
                            ...item.buttons,
                            ...this.groupToButtons[item.group]
                        ]
                    };
                }
                return item;
            });
        }
    }
    destruct() {
        if (this.isDestructed) {
            return;
        }
        this.setStatus(_component_statuses_js__WEBPACK_IMPORTED_MODULE_0__/* .STATUSES */ .f.beforeDestruct);
        this.e.off('beforeToolbarBuild', this.beforeToolbarBuild);
        this.__tooltip.destruct();
        this.toolbar.destruct();
        // @ts-ignore After destruct, we are not responsible for anything
        this.toolbar = undefined;
        super.destruct();
    }
    /** @override **/ constructor(options, isJodit = false){
        super(options, isJodit);
        this.toolbar = (0,_modules_toolbar_factory_js__WEBPACK_IMPORTED_MODULE_7__/* .makeCollection */ .$K)(this);
        this.__defaultToolbarContainer = this.c.div('jodit-toolbar__box');
        this.registeredButtons = new Set();
        this.groupToButtons = {};
        this.isJodit = false;
        this.__tooltip = new _ui_index_js__WEBPACK_IMPORTED_MODULE_5__/* .UITooltip */ .SB(this);
        this.isJodit = isJodit;
        this.e.on('beforeToolbarBuild', this.beforeToolbarBuild);
    }
}
__decorate([
    (0,_decorators_watch_watch_js__WEBPACK_IMPORTED_MODULE_1__/* .watch */ .w)(':rebuildToolbar')
], ViewWithToolbar.prototype, "buildToolbar", null);
__decorate([
    _decorators_autobind_autobind_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Ay
], ViewWithToolbar.prototype, "beforeToolbarBuild", null);


/***/ }),

/***/ 84272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   D: function() { return /* binding */ isInlineBlock; },
/* harmony export */   w: function() { return /* binding */ removeFormatForCollapsedSelection; }
/* harmony export */ });
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/**
 * For collapsed selection move cursor outside or split inline block
 * @private
 */ function removeFormatForCollapsedSelection(jodit, fake) {
    const { s } = jodit;
    let fakeNode = fake;
    if (!fakeNode) {
        fakeNode = jodit.createInside.fake();
        const { range } = s;
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeInsertNode(range, fakeNode);
        range.collapse();
    }
    const mainInline = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.furthest(fakeNode, isInlineBlock, jodit.editor);
    if (mainInline) {
        if (s.cursorOnTheLeft(mainInline)) {
            _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.before(mainInline, fakeNode);
        } else if (s.cursorOnTheRight(mainInline)) {
            _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.after(mainInline, fakeNode);
        } else {
            const leftHand = s.splitSelection(mainInline);
            leftHand && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.after(leftHand, fakeNode);
        }
    }
    if (!fake) {
        s.setCursorBefore(fakeNode);
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(fakeNode);
    }
}
/**
 * Element has inline display mode
 * @private
 */ function isInlineBlock(node) {
    return _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isInlineBlock(node) && !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(node, _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INSEPARABLE_TAGS);
}


/***/ }),

/***/ 84380:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6441);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(117);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.askBeforePasteHTML = true;
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.processPasteHTML = true;
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.scrollToPastedContent = true;
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.pasteExcludeStripTags = [
    'br',
    'hr'
];
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.pasteHTMLActionList = [
    {
        value: _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INSERT_AS_HTML,
        text: 'Keep'
    },
    {
        value: _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INSERT_AS_TEXT,
        text: 'Insert as Text'
    },
    {
        value: _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INSERT_ONLY_TEXT,
        text: 'Insert only Text'
    }
];
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.memorizeChoiceWhenPasteFragment = false;
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.nl2brInPlainText = true;
const psKey = 'pasteStorage';
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.controls.paste = {
    tooltip: 'Paste from clipboard',
    async exec (editor, _, { control }) {
        if (control.name === psKey) {
            editor.execCommand('showPasteStorage');
            return;
        }
        editor.s.focus();
        let text = '', error = true;
        if (navigator.clipboard) {
            try {
                const items = await navigator.clipboard.read();
                if (items && items.length) {
                    const textBlob = await items[0].getType(_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.TEXT_PLAIN);
                    text = await new Response(textBlob).text();
                }
                error = false;
            } catch (e) {
                if (!_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD) {
                    // eslint-disable-next-line no-console
                    console.log(e);
                }
            }
            if (error) {
                try {
                    text = await navigator.clipboard.readText();
                    error = false;
                } catch (e) {
                    if (!_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD) {
                        // eslint-disable-next-line no-console
                        console.log(e);
                    }
                }
            }
        }
        if (error) {
            text = editor.buffer.get(_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.CLIPBOARD_ID) || '';
            error = text.length === 0;
        }
        const value = editor.value;
        if (error) {
            editor.ed.execCommand('paste');
            error = value === editor.value;
            !error && editor.e.fire('afterPaste');
        } else if (text.length) {
            (0,_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .pasteInsertHtml */ .sX)(null, editor, text);
            editor.e.fire('afterPaste');
        } else {
            if (error) {
                editor.alert("Your browser doesn't support direct access to the clipboard.", ()=>void editor.s.focus());
            }
        }
    },
    list: {
        [psKey]: 'Paste Storage'
    },
    isChildDisabled (j) {
        return j.e.fire('pasteStorageList') < 2;
    }
};


/***/ }),

/***/ 84591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ removeInsideComment; }
/* harmony export */ });
/* harmony import */ var jodit_pro_plugins_paste_from_word_element_render__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90129);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */

let inComment = 0;
function removeInsideComment(elm) {
    if (elm.isComment && /\[if.*(supportLists|gte vml).*]/.test((0,jodit_pro_plugins_paste_from_word_element_render__WEBPACK_IMPORTED_MODULE_0__/* .html */ .q)(elm))) {
        inComment++;
        elm.remove();
    }
    if (elm.isComment && inComment > 0 && (0,jodit_pro_plugins_paste_from_word_element_render__WEBPACK_IMPORTED_MODULE_0__/* .html */ .q)(elm).includes('[endif]')) {
        inComment = inComment > 0 ? inComment - 1 : 0;
        elm.remove();
    }
    if (inComment) {
        if (elm.isText ||
            (elm.name === 'img' &&
                (!elm.attributes.src || /^file:/.test(elm.attributes.src)))) {
            elm.remove();
            return null;
        }
    }
    return elm;
}


/***/ }),

/***/ 84661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   LE: function() { return /* binding */ isSameType; },
/* harmony export */   Lv: function() { return /* binding */ isList; },
/* harmony export */   hJ: function() { return /* binding */ isPseudoLeaf; },
/* harmony export */   xe: function() { return /* binding */ isLeaf; }
/* harmony export */ });
/* harmony import */ var _render__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90129);
/* harmony import */ var jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78547);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */


function isList(elm) {
    return Boolean(elm && (elm.name === 'ol' || elm.name === 'ul'));
}
function isLeaf(elm) {
    return Boolean(elm && elm.name === 'li');
}
function isPseudoLeaf(elm) {
    return ((elm.name !== 'li' &&
        /mso-list:\s*l\d+ level\d+ lfo\d+/i.test(elm.attributes.style)) ||
        (/msolistparagraph/i.test(elm.attributes.class) &&
            Boolean(elm.find((c) => c.isComment && (0,_render__WEBPACK_IMPORTED_MODULE_0__/* .html */ .q)(c).includes('supportLists'))
                .length)));
}
function isSameType(leaf, list) {
    const listType = leaf.attributes[jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .TYPE_KEY */ .lA];
    const listStyle = leaf.attributes[jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .STYLE_KEY */ .yL];
    return !(list.name !== listType ||
        list.attributes[jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .STYLE_KEY */ .yL] !== listStyle ||
        leaf.attributes[jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .LEVEL_KEY */ .fB] !== list.attributes[jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .LEVEL_KEY */ .fB]);
}


/***/ }),

/***/ 84767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   E: function() { return /* binding */ isNumber; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/checker
 */ /**
 * Check value is a number
 */ function isNumber(value) {
    return typeof value === 'number' && !isNaN(value) && isFinite(value);
}


/***/ }),

/***/ 84858:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg viewBox=\"0 0 13 13\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M5.9814 11.8049C5.59087 11.4144 5.59087 10.7812 5.9814 10.3907L10.224 6.14806C10.6146 5.75754 11.2477 5.75754 11.6383 6.14806C12.0288 6.53859 12.0288 7.17175 11.6383 7.56228L7.39561 11.8049C7.00509 12.1954 6.37192 12.1954 5.9814 11.8049Z\"/> <path d=\"M0.707107 12.0208C0.316582 11.6303 0.316582 10.9971 0.707107 10.6066L10.6066 0.707121C10.9971 0.316597 11.6303 0.316596 12.0208 0.707121C12.4113 1.09764 12.4113 1.73081 12.0208 2.12133L2.12132 12.0208C1.7308 12.4114 1.09763 12.4114 0.707107 12.0208Z\"/> </svg> ");


/***/ }),

/***/ 85017:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'Type something': 'Ecrivez ici',
    'About Jodit': 'A propos de Jodit',
    'Jodit Editor': 'Editeur Jodit',
    "Jodit User's Guide": "Guide de l'utilisateur",
    'contains detailed help for using': "Aide détaillée à l'utilisation",
    'For information about the license, please go to our website:': 'Consulter la licence sur notre site web:',
    'Buy full version': 'Acheter la version complète',
    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.': 'Copyright © XDSoft.net - Chupurnov Valeriy. Tous droits réservés.',
    Anchor: 'Ancre',
    'Open in new tab': 'Ouvrir dans un nouvel onglet',
    'Open in fullsize': "Ouvrir l'éditeur en pleine page",
    'Clear Formatting': 'Supprimer le formattage',
    'Fill color or set the text color': 'Modifier la couleur du fond ou du texte',
    Redo: 'Refaire',
    Undo: 'Défaire',
    Bold: 'Gras',
    Italic: 'Italique',
    'Insert Unordered List': 'Liste non ordonnée',
    'Insert Ordered List': 'Liste ordonnée',
    'Align Center': 'Centrer',
    'Align Justify': 'Justifier',
    'Align Left': 'Aligner à gauche ',
    'Align Right': 'Aligner à droite',
    'Insert Horizontal Line': 'Insérer une ligne horizontale',
    'Insert Image': 'Insérer une image',
    'Insert file': 'Insérer un fichier',
    'Insert youtube/vimeo video': 'Insérer une vidéo',
    'Insert link': 'Insérer un lien',
    'Font size': 'Taille des caractères',
    'Font family': 'Famille des caractères',
    'Insert format block': 'Bloc formatté',
    Normal: 'Normal',
    'Heading 1': 'Titre 1',
    'Heading 2': 'Titre 2',
    'Heading 3': 'Titre 3',
    'Heading 4': 'Titre 4',
    Quote: 'Citation',
    Code: 'Code',
    Insert: 'Insérer',
    'Insert table': 'Insérer un tableau',
    'Decrease Indent': 'Diminuer le retrait',
    'Increase Indent': 'Retrait plus',
    'Select Special Character': 'Sélectionnez un caractère spécial',
    'Insert Special Character': 'Insérer un caractère spécial',
    'Paint format': 'Cloner le format',
    'Change mode': 'Mode wysiwyg <-> code html',
    Margins: 'Marges',
    top: 'haut',
    right: 'droite',
    bottom: 'Bas',
    left: 'gauche',
    Styles: 'Styles',
    Classes: 'Classes',
    Align: 'Alignement',
    Right: 'Droite',
    Center: 'Centre',
    Left: 'Gauche',
    '--Not Set--': '--Non disponible--',
    Src: 'Source',
    Title: 'Titre',
    Alternative: 'Alternative',
    Filter: 'Filtre',
    Link: 'Lien',
    'Open link in new tab': 'Ouvrir le lien dans un nouvel onglet',
    Image: 'Image',
    file: 'fichier',
    Advanced: 'Avancé',
    'Image properties': "Propriétés de l'image",
    Cancel: 'Annuler',
    Ok: 'OK',
    'Your code is similar to HTML. Keep as HTML?': 'Votre texte que vous essayez de coller est similaire au HTML. Collez-le en HTML?',
    'Paste as HTML': 'Coller en HTML?',
    Keep: "Sauvegarder l'original",
    Clean: 'Nettoyer',
    'Insert as Text': 'Coller en tant que texte',
    'Word Paste Detected': "C'est peut-être un fragment de Word ou Excel",
    'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?': "Le contenu que vous insérez provient d'un document Microsoft Word / Excel. Voulez-vous enregistrer le format ou l'effacer?",
    'Insert only Text': 'Coller le texte seulement',
    'File Browser': 'Explorateur de fichiers',
    'Error on load list': 'Erreur de liste de chargement',
    'Error on load folders': 'Erreur de dossier de chargement',
    'Are you sure?': 'Etes-vous sûrs ?',
    'Enter Directory name': 'Entrer le nom de dossier',
    'Create directory': 'Créer un dossier',
    'type name': 'type de fichier',
    'Drop image': 'Coller une image',
    'Drop file': 'Déposer un fichier',
    'or click': 'ou cliquer',
    'Alternative text': 'Texte de remplacemement',
    Browse: 'Chercher',
    Upload: 'Charger',
    Background: 'Arrière-plan',
    Border: 'Bordure',
    Text: 'Texte',
    Top: 'Haut',
    Middle: 'Milieu',
    Bottom: 'Bas',
    'Insert column before': 'Insérer une colonne avant',
    'Insert column after': 'Insérer une colonne après',
    'Insert row above': 'Insérer une ligne au dessus',
    'Insert row below': 'Insérer une ligne en dessous',
    'Delete table': 'Supprimer le tableau',
    'Delete row': 'Supprimer la ligne',
    'Delete column': 'Supprimer la colonne',
    'Empty cell': 'Vider la cellule',
    'Chars: %d': 'Symboles: %d',
    'Words: %d': 'Mots: %d',
    Split: 'Split',
    'Split vertical': 'Split vertical',
    'Split horizontal': 'Split horizontal',
    'Strike through': 'Barrer',
    Underline: 'Souligner',
    superscript: 'exposant',
    subscript: 'indice',
    'Cut selection': 'Couper la sélection',
    'Select all': 'Tout sélectionner',
    Break: 'Pause',
    'Search for': 'Rechercher',
    'Replace with': 'Remplacer par',
    Replace: 'Remplacer',
    Paste: 'Coller',
    'Choose Content to Paste': 'Choisissez le contenu à coller',
    source: 'la source',
    bold: 'gras',
    italic: 'italique',
    brush: 'pinceau',
    link: 'lien',
    undo: 'annuler',
    redo: 'refaire',
    table: 'tableau',
    image: 'image',
    eraser: 'gomme',
    paragraph: 'clause',
    fontsize: 'taille de police',
    video: 'Video',
    font: 'police',
    about: "à propos de l'éditeur",
    print: 'impression',
    underline: 'souligné',
    strikethrough: 'barré',
    indent: 'indentation',
    outdent: 'retrait',
    fullsize: 'taille réelle',
    shrink: 'taille conventionnelle',
    hr: 'la ligne',
    ul: 'Liste',
    ol: 'Liste numérotée',
    cut: 'Couper',
    selectall: 'Sélectionner tout',
    'Open link': 'Ouvrir le lien',
    'Edit link': 'Modifier le lien',
    'No follow': 'Attribut Nofollow',
    Unlink: 'Supprimer le lien',
    Eye: 'Voir',
    pencil: 'Pour éditer',
    ' URL': 'URL',
    Reset: 'Restaurer',
    Save: 'Sauvegarder',
    'Save as ...': 'Enregistrer sous',
    Resize: 'Changer la taille',
    Crop: 'Taille de garniture',
    Width: 'Largeur',
    Height: 'Hauteur',
    'Keep Aspect Ratio': 'Garder les proportions',
    Yes: 'Oui',
    No: 'Non',
    Remove: 'Supprimer',
    Select: 'Mettre en évidence',
    'Select %s': 'Mettre en évidence: %s',
    Update: 'Mettre à jour',
    'Vertical align': 'Alignement vertical',
    Merge: 'aller',
    'Add column': 'Ajouter une colonne',
    'Add row': 'Ajouter une rangée',
    Delete: 'Effacer',
    'Horizontal align': 'Alignement horizontal',
    'Sort by changed': 'Trier par modification',
    'Sort by name': 'Trier par nom',
    'Sort by size': 'Trier par taille',
    'Add folder': 'Créer le dossier',
    'You can only edit your own images. Download this image on the host?': "Vous ne pouvez éditer que vos propres images. Téléchargez cette image sur l'hôte?",
    'The image has been successfully uploaded to the host!': "L'image a été téléchargée avec succès sur le serveur!",
    palette: 'Palette',
    'There are no files': "Il n'y a aucun fichier dans ce répertoire.",
    Rename: 'renommer',
    'Enter new name': 'Entrez un nouveau nom',
    preview: 'Aperçu',
    download: 'Télécharger',
    'Paste from clipboard': 'Coller à partir du presse-papiers',
    "Your browser doesn't support direct access to the clipboard.": "Votre navigateur ne prend pas en charge l'accès direct au presse-papiers.",
    'Copy selection': 'Copier la sélection',
    copy: 'copie',
    'Border radius': 'Rayon des bordures',
    'Show all': 'Afficher tous',
    Apply: 'Appliquer',
    'Please fill out this field': 'Veuillez remplir ce champ',
    'Please enter a web address': 'Veuillez entrer une adresse web',
    Default: 'Par défaut',
    Circle: 'Cercle',
    Dot: 'Point',
    Quadrate: 'Quadratique',
    Find: 'Trouver',
    'Find Previous': 'Précédent',
    'Find Next': 'Suivant',
    'Insert className': 'Insérer un nom de classe',
    'Press Alt for custom resizing': 'Appuyez sur Alt pour un redimensionnement personnalisé'
});


/***/ }),

/***/ 85120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   F: function() { return /* binding */ UITextArea; }
/* harmony export */ });
/* harmony import */ var _decorators_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65478);
/* harmony import */ var _decorators_component_component_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87325);
/* harmony import */ var _input_input_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80256);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var UITextArea_1;



let UITextArea = UITextArea_1 = class UITextArea extends _input_input_js__WEBPACK_IMPORTED_MODULE_1__/* .UIInput */ .t {
    /** @override */ className() {
        return 'UITextArea';
    }
    createNativeInput(options) {
        return this.j.create.element('textarea');
    }
    onChangeStateSize() {
        const { size, resizable } = this.state;
        this.nativeInput.style.resize = resizable ? 'auto' : 'none';
        this.nativeInput.rows = size !== null && size !== void 0 ? size : 5;
    }
    constructor(jodit, state){
        super(jodit, state);
        /** @override */ this.state = {
            ...UITextArea_1.defaultState
        };
        Object.assign(this.state, state);
        if (this.state.resizable === false) {
            this.nativeInput.style.resize = 'none';
        }
    }
};
/** @override */ UITextArea.defaultState = {
    ..._input_input_js__WEBPACK_IMPORTED_MODULE_1__/* .UIInput */ .t.defaultState,
    size: 5,
    resizable: true
};
__decorate([
    (0,_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)([
        'state.size',
        'state.resizable'
    ])
], UITextArea.prototype, "onChangeStateSize", null);
UITextArea = UITextArea_1 = __decorate([
    _decorators_component_component_js__WEBPACK_IMPORTED_MODULE_2__/* .component */ .s
], UITextArea);



/***/ }),

/***/ 85407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export pasteStorage */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2748);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21537);
/* harmony import */ var _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20356);
/* harmony import */ var _core_ui_button_button_button_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10830);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 





/**
 * Show dialog choose content to paste
 */ class pasteStorage extends _core_plugin_plugin_js__WEBPACK_IMPORTED_MODULE_4__/* .Plugin */ .k {
    createDialog() {
        this.dialog = this.j.dlg();
        const pasteButton = (0,_core_ui_button_button_button_js__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .$n)(this.j, 'paste', 'Paste', 'primary');
        pasteButton.onAction(this.paste);
        const cancelButton = (0,_core_ui_button_button_button_js__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .$n)(this.j, '', 'Cancel');
        cancelButton.onAction(this.dialog.close);
        this.container = this.j.c.div();
        this.container.classList.add('jodit-paste-storage');
        this.listBox = this.j.c.div();
        this.previewBox = this.j.c.div();
        this.container.appendChild(this.listBox);
        this.container.appendChild(this.previewBox);
        this.dialog.setHeader(this.j.i18n('Choose Content to Paste'));
        this.dialog.setContent(this.container);
        this.dialog.setFooter([
            pasteButton,
            cancelButton
        ]);
        this.j.e.on(this.listBox, 'click dblclick', (e)=>{
            const a = e.target;
            if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(a, 'a') && a.hasAttribute('data-index')) {
                this.selectIndex(parseInt((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(a, '-index') || '0', 10));
            }
            if (e.type === 'dblclick') {
                this.paste();
            }
            return false;
        });
    }
    afterInit() {
        this.j.e.off('afterCopy.paste-storage').on('pasteStorageList.paste-storage', ()=>this.list.length).on('afterCopy.paste-storage', (html)=>{
            if (this.list.indexOf(html) !== -1) {
                this.list.splice(this.list.indexOf(html), 1);
            }
            this.list.unshift(html);
            if (this.list.length > 5) {
                this.list.length = 5;
            }
        });
        this.j.registerCommand('showPasteStorage', {
            exec: this.showDialog,
            hotkeys: [
                'ctrl+shift+v',
                'cmd+shift+v'
            ]
        });
    }
    beforeDestruct() {
        this.dialog && this.dialog.destruct();
        this.j.e.off('.paste-storage');
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(this.previewBox);
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(this.listBox);
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(this.container);
        this.container = null;
        this.listBox = null;
        this.previewBox = null;
        this.dialog = null;
        this.list = [];
    }
    constructor(){
        super(...arguments);
        this.currentIndex = 0;
        this.list = [];
        this.container = null;
        this.listBox = null;
        this.previewBox = null;
        this.dialog = null;
        this.paste = ()=>{
            this.j.s.focus();
            this.j.s.insertHTML(this.list[this.currentIndex]);
            if (this.currentIndex !== 0) {
                const buffer = this.list[0];
                this.list[0] = this.list[this.currentIndex];
                this.list[this.currentIndex] = buffer;
            }
            this.dialog && this.dialog.close();
            this.j.synchronizeValues();
            this.j.e.fire('afterPaste');
        };
        this.onKeyDown = (e)=>{
            let index = this.currentIndex;
            if ([
                _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_UP,
                _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_DOWN,
                _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_ENTER
            ].indexOf(e.key) === -1) {
                return;
            }
            if (e.key === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_UP) {
                if (index === 0) {
                    index = this.list.length - 1;
                } else {
                    index -= 1;
                }
            }
            if (e.key === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_DOWN) {
                if (index === this.list.length - 1) {
                    index = 0;
                } else {
                    index += 1;
                }
            }
            if (e.key === _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_ENTER) {
                this.paste();
                return;
            }
            if (index !== this.currentIndex) {
                this.selectIndex(index);
            }
            e.stopImmediatePropagation();
            e.preventDefault();
        };
        this.selectIndex = (index)=>{
            if (this.listBox) {
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.toArray)(this.listBox.childNodes).forEach((a, i)=>{
                    a.classList.remove('jodit_active');
                    if (index === i && this.previewBox) {
                        a.classList.add('jodit_active');
                        this.previewBox.innerHTML = this.list[index];
                        a.focus();
                    }
                });
            }
            this.currentIndex = index;
        };
        this.showDialog = ()=>{
            if (this.list.length < 2) {
                return;
            }
            this.dialog || this.createDialog();
            if (this.listBox) {
                this.listBox.innerHTML = '';
            }
            if (this.previewBox) {
                this.previewBox.innerHTML = '';
            }
            this.list.forEach((html, index)=>{
                const a = this.j.c.element('a');
                a.textContent = index + 1 + '. ' + html.replace((0,_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.SPACE_REG_EXP)(), '');
                this.j.e.on(a, 'keydown', this.onKeyDown);
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(a, 'href', '#');
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(a, 'data-index', index.toString());
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.attr)(a, 'tab-index', '-1');
                this.listBox && this.listBox.appendChild(a);
            });
            this.dialog && this.dialog.open();
            this.j.async.setTimeout(()=>{
                this.selectIndex(0);
            }, 100);
        };
    }
}
_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .pluginSystem */ .fg.add('pasteStorage', pasteStorage);


/***/ }),

/***/ 85567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   N: function() { return /* binding */ PII; },
/* harmony export */   Z: function() { return /* binding */ WARN; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/speech-recognize
 * @internal
 */ const PII = 440;
const WARN = 940;


/***/ }),

/***/ 85568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C: function() { return /* binding */ cases; }
/* harmony export */ });
/* harmony import */ var _clean_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42640);
/* harmony import */ var _clear_attributes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11991);
/* harmony import */ var _clear_class_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5986);
/* harmony import */ var _convert_style_unit_to_pixels__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68846);
/* harmony import */ var _convert_to_list__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96958);
/* harmony import */ var _mark_page_break__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29345);
/* harmony import */ var _normalize_image_props__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(78284);
/* harmony import */ var _process_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31461);
/* harmony import */ var _process_links__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(21473);
/* harmony import */ var _remove_extra_tags__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77183);
/* harmony import */ var _remove_inside_comment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84591);
/* harmony import */ var _replace_old_tags__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17096);
/* harmony import */ var _table__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(61388);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */













const cases = [
    _process_image__WEBPACK_IMPORTED_MODULE_4__/* .processImage */ .J,
    _mark_page_break__WEBPACK_IMPORTED_MODULE_8__/* .markPageBreakElements */ .f,
    _remove_extra_tags__WEBPACK_IMPORTED_MODULE_5__/* .removeExtraTags */ .S,
    _replace_old_tags__WEBPACK_IMPORTED_MODULE_7__/* .replaceOldTags */ .H,
    _clear_attributes__WEBPACK_IMPORTED_MODULE_9__/* .clearAttributes */ .f,
    _convert_to_list__WEBPACK_IMPORTED_MODULE_3__/* .convertToList */ .z,
    _process_links__WEBPACK_IMPORTED_MODULE_10__/* .processLinks */ .N,
    _remove_inside_comment__WEBPACK_IMPORTED_MODULE_6__/* .removeInsideComment */ .A,
    _convert_style_unit_to_pixels__WEBPACK_IMPORTED_MODULE_2__/* .convertStyleUnitToPixels */ .F,
    _clear_class_name__WEBPACK_IMPORTED_MODULE_1__/* .clearClassName */ .l,
    _normalize_image_props__WEBPACK_IMPORTED_MODULE_11__/* .normalizeImageProps */ .v,
    _table__WEBPACK_IMPORTED_MODULE_12__/* .removeWidthFromTableCell */ .j,
    _clean_styles__WEBPACK_IMPORTED_MODULE_0__/* .cleanStyles */ .Q
];


/***/ }),

/***/ 85723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    'Line height': 'Hauteur de ligne'
});


/***/ }),

/***/ 85745:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/image-processor
 */ 
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.imageProcessor = {
    replaceDataURIToBlobIdInView: true
};


/***/ }),

/***/ 86012:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/xpath
 */ 
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.showXPathInStatusbar = true;


/***/ }),

/***/ 86019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   x: function() { return /* reexport safe */ _jodit_js__WEBPACK_IMPORTED_MODULE_0__.x; }
/* harmony export */ });
/* unused harmony export CommitMode */
/* harmony import */ var _jodit_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2303);
/* harmony import */ var _core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27613);
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82758);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65478);
/* harmony import */ var _modules_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41409);
/* harmony import */ var _styles_icons_index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17555);
/* harmony import */ var _languages_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26152);
/* harmony import */ var _plugins_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46448);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * [[include:README.md]]
 * @packageDocumentation
 * @module jodit
 */ // eslint-disable-next-line simple-import-sort/imports








// copy constants in Jodit
Object.keys(_core_constants_js__WEBPACK_IMPORTED_MODULE_2__).forEach((key)=>{
    _jodit_js__WEBPACK_IMPORTED_MODULE_0__/* .Jodit */ .x[key] = _core_constants_js__WEBPACK_IMPORTED_MODULE_2__[key];
});
const esFilter = (key)=>key !== '__esModule';
// Icons
Object.keys(_styles_icons_index_js__WEBPACK_IMPORTED_MODULE_7__).filter(esFilter).forEach((key)=>{
    _modules_index_js__WEBPACK_IMPORTED_MODULE_4__.Icon.set(key.replace('_', '-'), _styles_icons_index_js__WEBPACK_IMPORTED_MODULE_7__[key]);
});
// Modules
Object.keys(_modules_index_js__WEBPACK_IMPORTED_MODULE_4__).filter(esFilter).forEach((key)=>{
    var _a;
    // @ts-ignore
    const module = _modules_index_js__WEBPACK_IMPORTED_MODULE_4__[key];
    const name = (0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isFunction */ .Tn)((_a = module.prototype) === null || _a === void 0 ? void 0 : _a.className) ? module.prototype.className() : key;
    if (!(0,_core_helpers_checker_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .Kg)(name)) {
        console.warn('Module name must be a string', key);
        return;
    }
    // @ts-ignore
    _jodit_js__WEBPACK_IMPORTED_MODULE_0__/* .Jodit */ .x.modules[name] = module;
});
// Decorators
Object.keys(_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_3__).filter(esFilter).forEach((key)=>{
    // @ts-ignore
    _jodit_js__WEBPACK_IMPORTED_MODULE_0__/* .Jodit */ .x.decorators[key] = _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_3__[key];
});
[
    'Confirm',
    'Alert',
    'Prompt'
].forEach((key)=>{
    // @ts-ignore
    _jodit_js__WEBPACK_IMPORTED_MODULE_0__/* .Jodit */ .x[key] = _modules_index_js__WEBPACK_IMPORTED_MODULE_4__[key];
});
// Languages
Object.keys(_languages_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A).filter(esFilter).forEach((key)=>{
    _jodit_js__WEBPACK_IMPORTED_MODULE_0__/* .Jodit */ .x.lang[key] = _languages_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A[key];
});

class CommitMode {
}


/***/ }),

/***/ 86068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   R: function() { return /* binding */ isVoid; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/checker
 */ /**
 * Check value is undefined or null
 */ function isVoid(value) {
    // eslint-disable-next-line eqeqeq
    return value === undefined || value === null;
}


/***/ }),

/***/ 86273:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'Type something': 'Escriba algo...',
    Advanced: 'Avanzado',
    'About Jodit': 'Acerca de Jodit',
    'Jodit Editor': 'Jodit Editor',
    "Jodit User's Guide": 'Guía de usuario Jodit',
    'contains detailed help for using': 'contiene ayuda detallada para el uso.',
    'For information about the license, please go to our website:': 'Para información sobre la licencia, por favor visite nuestro sitio:',
    'Buy full version': 'Compre la versión completa',
    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.': 'Copyright © XDSoft.net - Chupurnov Valeriy. Todos los derechos reservados.',
    Anchor: 'Anclar',
    'Open in new tab': 'Abrir en nueva pestaña',
    'Open in fullsize': 'Abrir editor en pantalla completa',
    'Clear Formatting': 'Limpiar formato',
    'Fill color or set the text color': 'Color de relleno o de letra',
    Redo: 'Rehacer',
    Undo: 'Deshacer',
    Bold: 'Negrita',
    Italic: 'Cursiva',
    'Insert Unordered List': 'Insertar lista no ordenada',
    'Insert Ordered List': 'Insertar lista ordenada',
    'Align Center': 'Alinear Centrado',
    'Align Justify': 'Alinear Justificado',
    'Align Left': 'Alinear Izquierda',
    'Align Right': 'Alinear Derecha',
    'Insert Horizontal Line': 'Insertar línea horizontal',
    'Insert Image': 'Insertar imagen',
    'Insert file': 'Insertar archivo',
    'Insert youtube/vimeo video': 'Insertar video de Youtube/vimeo',
    'Insert link': 'Insertar vínculo',
    'Font size': 'Tamaño de letra',
    'Font family': 'Familia de letra',
    'Insert format block': 'Insertar bloque',
    Normal: 'Normal',
    'Heading 1': 'Encabezado 1',
    'Heading 2': 'Encabezado 2',
    'Heading 3': 'Encabezado 3',
    'Heading 4': 'Encabezado 4',
    Quote: 'Cita',
    Code: 'Código',
    Insert: 'Insertar',
    'Insert table': 'Insertar tabla',
    'Decrease Indent': 'Disminuir sangría',
    'Increase Indent': 'Aumentar sangría',
    'Select Special Character': 'Seleccionar caracter especial',
    'Insert Special Character': 'Insertar caracter especial',
    'Paint format': 'Copiar formato',
    'Change mode': 'Cambiar modo',
    Margins: 'Márgenes',
    top: 'arriba',
    right: 'derecha',
    bottom: 'abajo',
    left: 'izquierda',
    Styles: 'Estilos CSS',
    Classes: 'Clases CSS',
    Align: 'Alinear',
    Right: 'Derecha',
    Center: 'Centrado',
    Left: 'Izquierda',
    '--Not Set--': '--No Establecido--',
    Src: 'Fuente',
    Title: 'Título',
    Alternative: 'Texto Alternativo',
    Filter: 'Filtrar',
    Link: 'Vínculo',
    'Open link in new tab': 'Abrir vínculo en nueva pestaña',
    Image: 'Imagen',
    file: 'Archivo',
    'Image properties': 'Propiedades de imagen',
    Cancel: 'Cancelar',
    Ok: 'Aceptar',
    'Your code is similar to HTML. Keep as HTML?': 'El código es similar a HTML. ¿Mantener como HTML?',
    'Paste as HTML': 'Pegar como HTML?',
    Keep: 'Mantener',
    Clean: 'Limpiar',
    'Insert as Text': 'Insertar como texto',
    'Word Paste Detected': 'Pegado desde Word detectado',
    'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?': 'El contenido pegado proviene de un documento de Microsoft Word/Excel. ¿Desea mantener el formato o limpiarlo?',
    'Insert only Text': 'Insertar solo texto',
    'File Browser': 'Buscar archivo',
    'Error on load list': 'Error al cargar la lista',
    'Error on load folders': 'Error al cargar las carpetas',
    'Are you sure?': '¿Está seguro?',
    'Enter Directory name': 'Entre nombre de carpeta',
    'Create directory': 'Crear carpeta',
    'type name': 'Entre el nombre',
    'Drop image': 'Soltar imagen',
    'Drop file': 'Soltar archivo',
    'or click': 'o click',
    'Alternative text': 'Texto alternativo',
    Browse: 'Buscar',
    Upload: 'Subir',
    Background: 'Fondo',
    Text: 'Texto',
    Top: 'Arriba',
    Middle: 'Centro',
    Bottom: 'Abajo',
    'Insert column before': 'Insertar columna antes',
    'Insert column after': 'Interar columna después',
    'Insert row above': 'Insertar fila arriba',
    'Insert row below': 'Insertar fila debajo',
    'Delete table': 'Borrar tabla',
    'Delete row': 'Borrar fila',
    'Delete column': 'Borrar columna',
    'Empty cell': 'Vaciar celda',
    Delete: 'Borrar',
    'Strike through': 'Tachado',
    Underline: 'Subrayado',
    Break: 'Pausa',
    'Search for': 'Buscar',
    'Replace with': 'Reemplazar con',
    Replace: 'Reemplazar',
    Edit: 'Editar',
    'Vertical align': 'Alineación vertical',
    'Horizontal align': 'Alineación horizontal',
    'Sort by changed': 'Ordenar por fecha modificación',
    'Sort by name': 'Ordenar por nombre',
    'Sort by size': 'Ordenar por tamaño',
    'Add folder': 'Agregar carpeta',
    Split: 'Dividir',
    'Split vertical': 'Dividir vertical',
    'Split horizontal': 'Dividir horizontal',
    Merge: 'Mezclar',
    'Add column': 'Agregar columna',
    'Add row': 'Agregar fila',
    Border: 'Borde',
    'Embed code': 'Incluir código',
    Update: 'Actualizar',
    superscript: 'superíndice',
    subscript: 'subíndice',
    'Cut selection': 'Cortar selección',
    Paste: 'Pegar',
    'Choose Content to Paste': 'Seleccionar contenido para pegar',
    'Chars: %d': 'Caracteres: %d',
    'Words: %d': 'Palabras: %d',
    All: 'Todo',
    'Select %s': 'Seleccionar: %s',
    'Select all': 'Seleccionar todo',
    source: 'HTML',
    bold: 'negrita',
    italic: 'cursiva',
    brush: 'Brocha',
    link: 'Vínculo',
    undo: 'deshacer',
    redo: 'rehacer',
    table: 'Tabla',
    image: 'Imagen',
    eraser: 'Borrar',
    paragraph: 'Párrafo',
    fontsize: 'Tamaño de letra',
    video: 'Video',
    font: 'Letra',
    about: 'Acerca de',
    print: 'Imprimir',
    underline: 'subrayar',
    strikethrough: 'tachar',
    indent: 'sangría',
    outdent: 'quitar sangría',
    fullsize: 'Tamaño completo',
    shrink: 'encoger',
    hr: 'línea horizontal',
    ul: 'lista sin ordenar',
    ol: 'lista ordenada',
    cut: 'Cortar',
    selectall: 'Seleccionar todo',
    'Open link': 'Abrir vínculo',
    'Edit link': 'Editar vínculo',
    'No follow': 'No seguir',
    Unlink: 'Desvincular',
    Eye: 'Ver',
    pencil: 'Para editar',
    ' URL': 'URL',
    Reset: 'Resetear',
    Save: 'Guardar',
    'Save as ...': 'Guardar como...',
    Resize: 'Redimensionar',
    Crop: 'Recortar',
    Width: 'Ancho',
    Height: 'Alto',
    'Keep Aspect Ratio': 'Mantener relación de aspecto',
    Yes: 'Si',
    No: 'No',
    Remove: 'Quitar',
    Select: 'Seleccionar',
    'You can only edit your own images. Download this image on the host?': 'Solo puedes editar tus propias imágenes. ¿Descargar esta imagen en el servidor?',
    'The image has been successfully uploaded to the host!': '¡La imagen se ha subido correctamente al servidor!',
    palette: 'paleta',
    'There are no files': 'No hay archivos en este directorio.',
    Rename: 'renombrar',
    'Enter new name': 'Ingresa un nuevo nombre',
    preview: 'avance',
    download: 'Descargar',
    'Paste from clipboard': 'Pegar desde el portapapeles',
    "Your browser doesn't support direct access to the clipboard.": 'Su navegador no soporta el acceso directo en el portapapeles.',
    'Copy selection': 'Selección de copia',
    copy: 'copia',
    'Border radius': 'Radio frontera',
    'Show all': 'Mostrar todos los',
    Apply: 'Aplicar',
    'Please fill out this field': 'Por favor, rellene este campo',
    'Please enter a web address': 'Por favor, introduzca una dirección web',
    Default: 'Predeterminado',
    Circle: 'Círculo',
    Dot: 'Punto',
    Quadrate: 'Cuadro',
    'Lower Alpha': 'Letra Minúscula',
    'Lower Greek': 'Griego Minúscula',
    'Lower Roman': 'Romano Minúscula',
    'Upper Alpha': 'Letra Mayúscula',
    'Upper Roman': 'Romano Mayúscula',
    Find: 'Encontrar',
    'Find Previous': 'Buscar Anterior',
    'Find Next': 'Buscar Siguiente',
    'Insert className': 'Insertar nombre de clase',
    'Press Alt for custom resizing': 'Presione Alt para cambiar el tamaño personalizado'
});


/***/ }),

/***/ 86327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   X: function() { return /* binding */ UIForm; }
/* harmony export */ });
/* harmony import */ var _component_component_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4012);
/* harmony import */ var _decorators_component_component_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87325);
/* harmony import */ var _helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43555);
/* harmony import */ var _inputs_input_input_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80256);
/* harmony import */ var _inputs_select_select_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12234);
/* harmony import */ var _group_group_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62405);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






let UIForm = class UIForm extends _group_group_js__WEBPACK_IMPORTED_MODULE_4__/* .UIGroup */ .U {
    /** @override */ className() {
        return 'UIForm';
    }
    submit() {
        this.j.e.fire(this.container, 'submit');
    }
    validate() {
        const inputs = this.allChildren.filter((elm)=>_component_component_js__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .u.isInstanceOf(elm, _inputs_input_input_js__WEBPACK_IMPORTED_MODULE_2__/* .UIInput */ .t));
        for (const input of inputs){
            if (!input.validate()) {
                return false;
            }
        }
        const selects = this.allChildren.filter((elm)=>_component_component_js__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .u.isInstanceOf(elm, _inputs_select_select_js__WEBPACK_IMPORTED_MODULE_3__/* .UISelect */ .$));
        for (const select of selects){
            if (!select.validate()) {
                return false;
            }
        }
        return true;
    }
    onSubmit(handler) {
        this.j.e.on(this.container, 'submit', ()=>{
            const inputs = this.allChildren.filter((elm)=>_component_component_js__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .u.isInstanceOf(elm, _inputs_input_input_js__WEBPACK_IMPORTED_MODULE_2__/* .UIInput */ .t));
            if (!this.validate()) {
                return false;
            }
            handler(inputs.reduce((res, item)=>{
                res[item.state.name] = item.value;
                return res;
            }, {}));
            return false;
        });
        return this;
    }
    /** @override */ createContainer() {
        const form = this.j.c.element('form');
        form.classList.add(this.componentName);
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .CF)(form, 'dir', this.j.o.direction || 'auto');
        (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .CF)(form, 'novalidate', '');
        return form;
    }
    constructor(...args){
        var _a, _b;
        super(...args);
        if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.className) {
            this.container.classList.add((_b = this.options) === null || _b === void 0 ? void 0 : _b.className);
        }
    }
};
UIForm = __decorate([
    _decorators_component_component_js__WEBPACK_IMPORTED_MODULE_5__/* .component */ .s
], UIForm);



/***/ }),

/***/ 86397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   R: function() { return /* binding */ ConnectionError; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/utils
 */ class ConnectionError extends Error {
    constructor(m){
        super(m);
        Object.setPrototypeOf(this, ConnectionError.prototype);
    }
}


/***/ }),

/***/ 86518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   t: function() { return /* binding */ safeHTML; },
/* harmony export */   v: function() { return /* binding */ sanitizeHTMLElement; }
/* harmony export */ });
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _utils_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43555);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/html
 */ 

/**
 * Removes dangerous constructs from HTML
 */ function safeHTML(box, options) {
    if (!_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isElement(box) && !_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isFragment(box)) {
        return;
    }
    if (options.removeOnError) {
        sanitizeHTMLElement(box);
        (0,_utils_index_js__WEBPACK_IMPORTED_MODULE_1__.$$)('[onerror]', box).forEach((elm)=>sanitizeHTMLElement(elm, options));
    }
    if (options.safeJavaScriptLink) {
        sanitizeHTMLElement(box);
        (0,_utils_index_js__WEBPACK_IMPORTED_MODULE_1__.$$)('a[href^="javascript"]', box).forEach((elm)=>sanitizeHTMLElement(elm, options));
    }
}
function sanitizeHTMLElement(elm, { safeJavaScriptLink, removeOnError } = {
    safeJavaScriptLink: true,
    removeOnError: true
}) {
    if (!_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isElement(elm)) {
        return false;
    }
    let effected = false;
    if (removeOnError && elm.hasAttribute('onerror')) {
        (0,_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .CF)(elm, 'onerror', null);
        effected = true;
    }
    const href = elm.getAttribute('href');
    if (safeJavaScriptLink && href && href.trim().indexOf('javascript') === 0) {
        (0,_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .CF)(elm, 'href', location.protocol + '//' + href);
        effected = true;
    }
    return effected;
}


/***/ }),

/***/ 86583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   m: function() { return /* binding */ dataBind; }
/* harmony export */ });
/* harmony import */ var _checker_is_view_object_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39955);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
const store = new WeakMap();
const dataBind = (elm, key, value)=>{
    let itemStore = store.get(elm);
    if (!itemStore) {
        itemStore = {};
        store.set(elm, itemStore);
        let e = null;
        if ((0,_checker_is_view_object_js__WEBPACK_IMPORTED_MODULE_0__/* .isViewObject */ .h)(elm.j)) {
            e = elm.j.e;
        }
        if ((0,_checker_is_view_object_js__WEBPACK_IMPORTED_MODULE_0__/* .isViewObject */ .h)(elm)) {
            e = elm.e;
        }
        e && e.on('beforeDestruct', ()=>{
            store.delete(elm);
        });
    }
    if (value === undefined) {
        return itemStore[key];
    }
    itemStore[key] = value;
    return value;
};


/***/ }),

/***/ 86835:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M384 544v576q0 13-9.5 22.5t-22.5 9.5q-14 0-23-9l-288-288q-9-9-9-23t9-23l288-288q9-9 23-9 13 0 22.5 9.5t9.5 22.5zm1408 768v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5z\"/> </svg> ");


/***/ }),

/***/ 87058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   x: function() { return /* binding */ camelCase; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/string
 */ /**
 * Convert (kebab-case or snake_case) to camelCase
 */ const camelCase = (key)=>{
    return key.replace(/([-_])(.)/g, (m, code, letter)=>{
        return letter.toUpperCase();
    });
};


/***/ }),

/***/ 87325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   s: function() { return /* binding */ component; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * Decorate components and set status isReady after constructor
 * @param constructorFunction - Component constructor class
 */ function component(constructorFunction) {
    class newConstructorFunction extends constructorFunction {
        constructor(...args){
            super(...args);
            const isRootConstructor = this.constructor === newConstructorFunction;
            // We can add a decorator to multiple classes in a chain.
            // Status should be set only as root
            if (isRootConstructor) {
                // In some es/minimizer builds, JS instantiates the original class rather than the new constructor
                if (!(this instanceof newConstructorFunction)) {
                    Object.setPrototypeOf(this, newConstructorFunction.prototype);
                }
                this.setStatus('ready');
            }
        }
    }
    return newConstructorFunction;
}


/***/ }),

/***/ 87394:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6441);
/* harmony import */ var _symbols_svg_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5119);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.usePopupForSpecialCharacters = false;
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.specialCharacters = [
    '!',
    '&quot;',
    '#',
    '$',
    '%',
    '&amp;',
    "'",
    '(',
    ')',
    '*',
    '+',
    '-',
    '.',
    '/',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    ':',
    ';',
    '&lt;',
    '=',
    '&gt;',
    '?',
    '@',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    '[',
    ']',
    '^',
    '_',
    '`',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    '{',
    '|',
    '}',
    '~',
    '&euro;',
    '&lsquo;',
    '&rsquo;',
    '&ldquo;',
    '&rdquo;',
    '&ndash;',
    '&mdash;',
    '&iexcl;',
    '&cent;',
    '&pound;',
    '&curren;',
    '&yen;',
    '&brvbar;',
    '&sect;',
    '&uml;',
    '&copy;',
    '&ordf;',
    '&laquo;',
    '&raquo;',
    '&not;',
    '&reg;',
    '&macr;',
    '&deg;',
    '&sup2;',
    '&sup3;',
    '&acute;',
    '&micro;',
    '&para;',
    '&middot;',
    '&cedil;',
    '&sup1;',
    '&ordm;',
    '&frac14;',
    '&frac12;',
    '&frac34;',
    '&iquest;',
    '&Agrave;',
    '&Aacute;',
    '&Acirc;',
    '&Atilde;',
    '&Auml;',
    '&Aring;',
    '&AElig;',
    '&Ccedil;',
    '&Egrave;',
    '&Eacute;',
    '&Ecirc;',
    '&Euml;',
    '&Igrave;',
    '&Iacute;',
    '&Icirc;',
    '&Iuml;',
    '&ETH;',
    '&Ntilde;',
    '&Ograve;',
    '&Oacute;',
    '&Ocirc;',
    '&Otilde;',
    '&Ouml;',
    '&times;',
    '&Oslash;',
    '&Ugrave;',
    '&Uacute;',
    '&Ucirc;',
    '&Uuml;',
    '&Yacute;',
    '&THORN;',
    '&szlig;',
    '&agrave;',
    '&aacute;',
    '&acirc;',
    '&atilde;',
    '&auml;',
    '&aring;',
    '&aelig;',
    '&ccedil;',
    '&egrave;',
    '&eacute;',
    '&ecirc;',
    '&euml;',
    '&igrave;',
    '&iacute;',
    '&icirc;',
    '&iuml;',
    '&eth;',
    '&ntilde;',
    '&ograve;',
    '&oacute;',
    '&ocirc;',
    '&otilde;',
    '&ouml;',
    '&divide;',
    '&oslash;',
    '&ugrave;',
    '&uacute;',
    '&ucirc;',
    '&uuml;',
    '&yacute;',
    '&thorn;',
    '&yuml;',
    '&OElig;',
    '&oelig;',
    '&#372;',
    '&#374',
    '&#373',
    '&#375;',
    '&sbquo;',
    '&#8219;',
    '&bdquo;',
    '&hellip;',
    '&trade;',
    '&#9658;',
    '&bull;',
    '&rarr;',
    '&rArr;',
    '&hArr;',
    '&diams;',
    '&asymp;'
];
_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_0__/* .Icon */ .I.set('symbols', _symbols_svg_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A);
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.controls.symbols = {
    hotkeys: [
        'ctrl+shift+i',
        'cmd+shift+i'
    ],
    tooltip: 'Insert Special Character',
    popup: (editor, current, close)=>{
        const container = editor.e.fire('generateSpecialCharactersTable.symbols');
        if (container) {
            if (editor.o.usePopupForSpecialCharacters) {
                const box = editor.c.div();
                box.classList.add('jodit-symbols');
                box.appendChild(container);
                editor.e.on(container, 'close_dialog', close);
                return box;
            }
            editor.alert(container, 'Select Special Character', undefined, 'jodit-symbols').bindDestruct(editor);
            const a = container.querySelector('a');
            a && a.focus();
        }
        return;
    }
};


/***/ }),

/***/ 87536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   V: function() { return /* binding */ checkRemoveContentNotEditable; }
/* harmony export */ });
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22732);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21537);
/* harmony import */ var _core_selection_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45124);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/**
 * Checks if a non-editable element can be deleted
 * @private
 */ function checkRemoveContentNotEditable(jodit, fakeNode, backspace) {
    let neighbor = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.findSibling(fakeNode, backspace);
    if (!neighbor && fakeNode.parentElement && fakeNode.parentElement !== jodit.editor) {
        neighbor = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.findSibling(fakeNode.parentElement, backspace);
    }
    if (_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isElement(neighbor) && !_core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isContentEditable(neighbor, jodit.editor)) {
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.call)(backspace ? _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.before : _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.after, neighbor, fakeNode);
        _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(neighbor);
        (0,_core_selection_helpers_index_js__WEBPACK_IMPORTED_MODULE_2__/* .moveNodeInsideStart */ .W8)(jodit, fakeNode, backspace);
        (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.call)(backspace ? jodit.s.setCursorBefore : jodit.s.setCursorAfter, fakeNode);
        return true;
    }
    return false;
}


/***/ }),

/***/ 87602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   q: function() { return /* binding */ applySize; }
/* harmony export */ });
/* harmony import */ var _core_helpers_checker_is_numeric_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29807);
/* harmony import */ var _core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29960);
/* harmony import */ var _core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41180);
/* harmony import */ var _utils_utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14415);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/image-properties
 */ 



/** @private */ function applySize(image, imageWidth, imageHeight, sizeIsLocked) {
    // Size
    if (imageWidth !== image.offsetWidth || imageHeight !== image.offsetHeight) {
        const updatedWidth = imageWidth ? (0,_utils_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .normalSizeToString */ .n)(imageWidth) : null;
        let updatedHeight = imageHeight ? (0,_utils_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .normalSizeToString */ .n)(imageHeight) : null;
        (0,_core_helpers_utils_css_js__WEBPACK_IMPORTED_MODULE_2__/* .css */ .A)(image, {
            width: updatedWidth,
            height: updatedWidth && sizeIsLocked ? null : updatedHeight
        });
        (0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__/* .attr */ .C)(image, 'width', updatedWidth && (0,_core_helpers_checker_is_numeric_js__WEBPACK_IMPORTED_MODULE_3__/* .isNumeric */ .k)(imageWidth) && (0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__/* .attr */ .C)(image, 'width') ? updatedWidth : null);
        if (!(0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__/* .attr */ .C)(image, 'width') || sizeIsLocked) {
            updatedHeight = null;
        }
        (0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__/* .attr */ .C)(image, 'height', updatedHeight);
    }
}


/***/ }),

/***/ 87612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   L: function() { return /* binding */ isBoolean; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/checker
 */ function isBoolean(elm) {
    return typeof elm === 'boolean';
}


/***/ }),

/***/ 88774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    newline: '換行',
    delete: '刪除',
    space: '空白',
    'Speech Recognize': '語音辨識',
    Sound: '聲音',
    'Interim Results': '階段性辨識結果'
});


/***/ }),

/***/ 89194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    'Line height': 'Tinggi baris'
});


/***/ }),

/***/ 89377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   autocomplete: function() { return /* binding */ autocomplete; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31635);
/* harmony import */ var _ui_autocomplete__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78630);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91876);
/* harmony import */ var jodit_esm_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6441);
/* harmony import */ var jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82758);
/* harmony import */ var jodit_esm_core_decorators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65478);
/* harmony import */ var jodit_esm_core_dom_dom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2748);
/* harmony import */ var jodit_esm_core_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21537);
/* harmony import */ var jodit_esm_core_plugin__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50911);
/* harmony import */ var jodit_esm_core_ui_popup_popup__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56917);
/* harmony import */ var jodit_pro_jodit_pro__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34013);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */











jodit_esm_config__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.autocomplete = {
    sources: [],
    maxItems: 50,
    isMatchedQuery: (query, value) => value.toLowerCase().indexOf(query.toLowerCase()) === 0,
    itemRenderer: (item) => item.title ?? item.value,
    insertValueRenderer: (item) => item.value + '&nbsp;'
};
class autocomplete extends jodit_esm_core_plugin__WEBPACK_IMPORTED_MODULE_7__/* .Plugin */ .k {
    constructor(jodit) {
        super(jodit);
        /** @override */
        this.hasStyle = !jodit_pro_jodit_pro__WEBPACK_IMPORTED_MODULE_9__/* .JoditPro */ .A.fatMode;
        this.sources = [];
    }
    /** @override */
    afterInit(jodit) {
        this.popup = new jodit_esm_core_ui_popup_popup__WEBPACK_IMPORTED_MODULE_8__/* .Popup */ .z(jodit);
        this.popup.setMod('padding', false);
        this.list = new _ui_autocomplete__WEBPACK_IMPORTED_MODULE_0__/* .Autocomplete */ .j(jodit);
        this.popup.setContent(this.list.container);
        jodit.e
            .on('select.autocomplete', (item) => {
            let insertValue = item.value;
            if ((0,jodit_esm_core_helpers__WEBPACK_IMPORTED_MODULE_6__.isFunction)(item.insertValueRenderer)) {
                insertValue = item.insertValueRenderer(item);
            }
            if (!jodit_esm_core_dom_dom__WEBPACK_IMPORTED_MODULE_5__/* .Dom */ .J.isNode(insertValue)) {
                insertValue = jodit.createInside.fromHTML(insertValue);
            }
            (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .replaceTextLeftOfCursorAfterSpace */ .s)(jodit.s.range, insertValue);
            this.j.s.setCursorAfter(insertValue);
            this.j.synchronizeValues();
            this.popup.close();
        })
            .on('keydown.autocomplete', this.onKeyDown)
            .on('keydown.autocomplete', this.onKeyControlDown, {
            top: true
        })
            .on('beforeEnter.autocomplete', this.onEnter, { top: true })
            .on('autocomplete.autocomplete', this.onAutoComplete)
            .on('registerAutocompleteSource.autocomplete', this.registerAutocompleteSource);
    }
    registerAutocompleteSource(source) {
        this.sources.push(source);
    }
    static isControlKey(key) {
        return (key === jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_3__.KEY_DOWN ||
            key === jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_3__.KEY_UP ||
            key === jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_3__.KEY_ENTER ||
            key === jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_3__.KEY_TAB);
    }
    async onKeyDown(e) {
        if (e.key === jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_3__.KEY_ESC) {
            this.popup.isOpened && this.popup.close();
            return;
        }
        const { s } = this.j;
        if (autocomplete.isControlKey(e.key) ||
            !s.isInsideArea ||
            !s.isCollapsed) {
            return;
        }
        const range = this.j.s.sel?.rangeCount
            ? this.j.s.sel?.getRangeAt(0)
            : null;
        const query = range && (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .getTextLeftOfCursor */ .I)(range).split(' ').pop();
        if (query && (0,jodit_esm_core_helpers__WEBPACK_IMPORTED_MODULE_6__.trim)(query).length) {
            const result = await this.onAutoComplete(query);
            if (result.length) {
                return this.openPopup(result);
            }
        }
        if (this.popup.isOpened) {
            this.popup.close();
        }
    }
    onKeyControlDown(e) {
        if (this.popup.isOpened && autocomplete.isControlKey(e.key)) {
            switch (e.key) {
                case jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_3__.KEY_DOWN:
                    this.list.selectNext();
                    break;
                case jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_3__.KEY_UP:
                    this.list.selectPrevious();
                    break;
                case jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_3__.KEY_TAB:
                    this.list.select();
                    break;
            }
            this.j.e.stopPropagation(e.type);
            return false;
        }
    }
    onEnter() {
        if (this.popup.isOpened) {
            this.list.select();
            return false;
        }
    }
    async onAutoComplete(query) {
        const result = [];
        await Promise.all(this.sources
            .concat(this.j.o.autocomplete.sources)
            .map(async (source) => {
            result.push(...(await this.resolveFeed(query, source)));
        }));
        return result;
    }
    async resolveFeed(query, feed, baseSource) {
        let parts;
        if ((0,jodit_esm_core_helpers__WEBPACK_IMPORTED_MODULE_6__.isPromise)(feed)) {
            feed = await feed;
        }
        if ((0,jodit_esm_core_helpers__WEBPACK_IMPORTED_MODULE_6__.isFunction)(feed)) {
            parts = await feed(query);
        }
        else if ((0,jodit_esm_core_helpers__WEBPACK_IMPORTED_MODULE_6__.isArray)(feed)) {
            const arrayFeed = feed, { isMatchedQuery } = this.j.o.autocomplete;
            parts = arrayFeed
                .filter((item) => {
                if ((0,jodit_esm_core_helpers__WEBPACK_IMPORTED_MODULE_6__.isString)(item)) {
                    return isMatchedQuery(query, item);
                }
                return isMatchedQuery(query, item.value);
            })
                .map((item) => {
                if ((0,jodit_esm_core_helpers__WEBPACK_IMPORTED_MODULE_6__.isString)(item)) {
                    return { title: item, value: item };
                }
                return item;
            });
        }
        else {
            parts = await this.resolveFeed(query, feed.feed, feed);
        }
        if (this.j.isDestructed) {
            return [];
        }
        if (parts && (0,jodit_esm_core_helpers__WEBPACK_IMPORTED_MODULE_6__.isArray)(parts)) {
            const { itemRenderer, insertValueRenderer, maxItems } = this.j.o.autocomplete;
            parts = parts.map((item) => ({
                itemRenderer: baseSource?.itemRenderer ?? itemRenderer,
                insertValueRenderer: baseSource?.insertValueRenderer ?? insertValueRenderer,
                ...item
            }));
            return parts.slice(0, maxItems);
        }
        return [];
    }
    openPopup(result) {
        this.list.build(result);
        this.popup.open(() => {
            const { j } = this;
            const rect = j.s.range.getBoundingClientRect();
            const bound = {
                left: rect.left,
                top: rect.top,
                height: rect.height,
                width: rect.width
            };
            if (j.o.iframe && j.iframe) {
                const pos = (0,jodit_esm_core_helpers__WEBPACK_IMPORTED_MODULE_6__.position)(j.iframe, j);
                bound.top += pos.top;
                bound.left += pos.left;
            }
            return bound;
        });
    }
    /** @override */
    beforeDestruct(jodit) {
        jodit.e
            .off(this.list)
            .off('keydown.autocomplete', this.onKeyDown)
            .off('autocomplete.autocomplete', this.onAutoComplete)
            .off('.autocomplete');
        this.list.destruct();
        this.popup.destruct();
    }
}
/** @override */
autocomplete.requires = ['enter', 'license'];
(0,tslib__WEBPACK_IMPORTED_MODULE_10__/* .__decorate */ .Cg)([
    jodit_esm_core_decorators__WEBPACK_IMPORTED_MODULE_4__.autobind
], autocomplete.prototype, "registerAutocompleteSource", null);
(0,tslib__WEBPACK_IMPORTED_MODULE_10__/* .__decorate */ .Cg)([
    (0,jodit_esm_core_decorators__WEBPACK_IMPORTED_MODULE_4__.debounce)()
], autocomplete.prototype, "onKeyDown", null);
(0,tslib__WEBPACK_IMPORTED_MODULE_10__/* .__decorate */ .Cg)([
    jodit_esm_core_decorators__WEBPACK_IMPORTED_MODULE_4__.autobind
], autocomplete.prototype, "onKeyControlDown", null);
(0,tslib__WEBPACK_IMPORTED_MODULE_10__/* .__decorate */ .Cg)([
    jodit_esm_core_decorators__WEBPACK_IMPORTED_MODULE_4__.autobind
], autocomplete.prototype, "onEnter", null);
(0,tslib__WEBPACK_IMPORTED_MODULE_10__/* .__decorate */ .Cg)([
    jodit_esm_core_decorators__WEBPACK_IMPORTED_MODULE_4__.autobind
], autocomplete.prototype, "onAutoComplete", null);
(0,tslib__WEBPACK_IMPORTED_MODULE_10__/* .__decorate */ .Cg)([
    jodit_esm_core_decorators__WEBPACK_IMPORTED_MODULE_4__.autobind
], autocomplete.prototype, "resolveFeed", null);
jodit_pro_jodit_pro__WEBPACK_IMPORTED_MODULE_9__/* .JoditPro */ .A.plugins.add('autocomplete', autocomplete);


/***/ }),

/***/ 89672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   P: function() { return /* binding */ normalizeName; }
/* harmony export */ });
/* harmony import */ var _helpers_string_kebab_case_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12475);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugin
 */ 
/**
 * @private
 */ function normalizeName(name) {
    return (0,_helpers_string_kebab_case_js__WEBPACK_IMPORTED_MODULE_0__/* .kebabCase */ .k)(name).toLowerCase();
}


/***/ }),

/***/ 89702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    symbols: '符号'
});


/***/ }),

/***/ 89758:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1025 1369v167h-248l-159-252-24-42q-8-9-11-21h-3l-9 21q-10 20-25 44l-155 250h-258v-167h128l197-291-185-272h-137v-168h276l139 228q2 4 23 42 8 9 11 21h3q3-9 11-21l25-42 140-228h257v168h-125l-184 267 204 296h109zm639 217v206h-514l-4-27q-3-45-3-46 0-64 26-117t65-86.5 84-65 84-54.5 65-54 26-64q0-38-29.5-62.5t-70.5-24.5q-51 0-97 39-14 11-36 38l-105-92q26-37 63-66 80-65 188-65 110 0 178 59.5t68 158.5q0 66-34.5 118.5t-84 86-99.5 62.5-87 63-41 73h232v-80h126z\"/> </svg> ");


/***/ }),

/***/ 89816:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"><path d=\"M1534 189v73q0 29-18.5 61t-42.5 32q-50 0-54 1-26 6-32 31-3 11-3 64v1152q0 25-18 43t-43 18h-108q-25 0-43-18t-18-43v-1218h-143v1218q0 25-17.5 43t-43.5 18h-108q-26 0-43.5-18t-17.5-43v-496q-147-12-245-59-126-58-192-179-64-117-64-259 0-166 88-286 88-118 209-159 111-37 417-37h479q25 0 43 18t18 43z\"/></svg> ");


/***/ }),

/***/ 89890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FI: function() { return /* reexport safe */ _error_js__WEBPACK_IMPORTED_MODULE_0__.FI; },
/* harmony export */   Rc: function() { return /* reexport safe */ _errors_index_js__WEBPACK_IMPORTED_MODULE_1__.Rc; },
/* harmony export */   ZW: function() { return /* reexport safe */ _errors_index_js__WEBPACK_IMPORTED_MODULE_1__.ZW; },
/* harmony export */   fF: function() { return /* reexport safe */ _error_js__WEBPACK_IMPORTED_MODULE_0__.fF; },
/* harmony export */   h2: function() { return /* reexport safe */ _errors_index_js__WEBPACK_IMPORTED_MODULE_1__.h2; },
/* harmony export */   rV: function() { return /* reexport safe */ _errors_index_js__WEBPACK_IMPORTED_MODULE_1__.rV; },
/* harmony export */   z3: function() { return /* reexport safe */ _error_js__WEBPACK_IMPORTED_MODULE_0__.z3; }
/* harmony export */ });
/* harmony import */ var _error_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82760);
/* harmony import */ var _errors_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32880);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/utils
 */ 



/***/ }),

/***/ 89930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    newline: 'řádek',
    delete: 'odstranit',
    space: 'prostora',
    'Speech Recognize': 'Rozpoznání Řeči',
    Sound: 'Zvuk',
    'Interim Results': 'Průběžné Výsledky'
});


/***/ }),

/***/ 90129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   O: function() { return /* binding */ innerHTML; },
/* harmony export */   q: function() { return /* binding */ html; }
/* harmony export */ });
/* harmony import */ var jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var jodit_esm_core_helpers_checker_is_boolean__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87612);
/* harmony import */ var jodit_esm_core_helpers_string_trim__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49055);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */



function html(elm, filter = () => true, removeEmpty = true, allowedStyleProps) {
    switch (true) {
        case elm.isComment:
        case elm.isText: {
            if (!filter(elm)) {
                return '';
            }
            const { nodeValue } = elm.attributes;
            return elm.isComment ? `<!--${nodeValue}-->` : nodeValue;
        }
        case elm.isElement: {
            const { attributes } = elm, innerContent = innerHTML(elm, filter, removeEmpty, allowedStyleProps);
            // remove empty tag with attributes
            if (!elm.attributes['jd-safe'] &&
                removeEmpty &&
                innerContent.replace(/[\n\t]/g, '').length === 0 &&
                !elm.isSingle) {
                return '';
            }
            const attrsList = Object.keys(attributes)
                .map((key) => {
                if (key === 'style' ||
                    attributes[key] == null ||
                    /^jd-/.test(key)) {
                    return '';
                }
                return `${key}="${htmlEntity(attributes[key])}"`;
            })
                .filter(Boolean);
            const { str: styleStr } = elm.style;
            const styles = htmlEntity(styleStr((key) => keyInList(key, allowedStyleProps)));
            if (styles) {
                attrsList.push(`style="${styles}"`);
            }
            // unwrap empty tag without attributes
            if (removeEmpty &&
                attrsList.length === 0 &&
                ['span', 'a'].includes(elm.name)) {
                return innerContent;
            }
            const attrs = attrsList.length ? ' ' + attrsList.join(' ') : '';
            if (!filter(elm)) {
                return innerContent;
            }
            return elm.isSingle
                ? `<${elm.name}${attrs}/>`
                : `<${elm.name}${attrs}>${innerContent}</${elm.name}>`;
        }
        default:
            if (!jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_0__.IS_PROD) {
                throw Error('Need implementation for this type');
            }
    }
    return '';
}
function keyInList(key, list) {
    if (!list) {
        return true;
    }
    if (keyInList.cache.has(list)) {
        const isAllow = keyInList.cache.get(list)?.get(key);
        if ((0,jodit_esm_core_helpers_checker_is_boolean__WEBPACK_IMPORTED_MODULE_2__/* .isBoolean */ .L)(isAllow)) {
            return isAllow;
        }
    }
    const isAllow = list.some((allow) => new RegExp(allow).test(key));
    const map = keyInList.cache.get(list) || new Map();
    map.set(key, isAllow);
    keyInList.cache.set(list, map);
    return isAllow;
}
keyInList.cache = new WeakMap();
function innerHTML(elm, filter = () => true, removeEmpty = true, allowedStyleProps) {
    let result = elm
        .map((e) => html(e, filter, removeEmpty, allowedStyleProps))
        .join('');
    if (elm.name === 'p' && (0,jodit_esm_core_helpers_string_trim__WEBPACK_IMPORTED_MODULE_1__/* .trim */ .Bq)(result).length === 0) {
        result = '&nbsp;';
    }
    return result;
}
function htmlEntity(str) {
    return str.toString().replace(/"/g, '&quot;');
}


/***/ }),

/***/ 90240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   R: function() { return /* binding */ checkTableCell; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/**
 * Inside the CELL table - nothing to do
 *
 * @example
 * ```html
 * <table><tr><td>|test</td></tr></table>
 * ```
 * result
 * ```html
 * <table><tr><td>|test</td></tr></table>
 * ```
 *
 * @private
 */ function checkTableCell(jodit, fakeNode) {
    const cell = fakeNode.parentElement;
    if (_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isCell(cell)) {
        return true;
    }
    return false;
}


/***/ }),

/***/ 90492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ar: function() { return /* reexport module object */ _ar_js__WEBPACK_IMPORTED_MODULE_0__; },
/* harmony export */   cs_cz: function() { return /* reexport module object */ _cs_cz_js__WEBPACK_IMPORTED_MODULE_1__; },
/* harmony export */   de: function() { return /* reexport module object */ _de_js__WEBPACK_IMPORTED_MODULE_2__; },
/* harmony export */   es: function() { return /* reexport module object */ _es_js__WEBPACK_IMPORTED_MODULE_3__; },
/* harmony export */   fa: function() { return /* reexport module object */ _fa_js__WEBPACK_IMPORTED_MODULE_4__; },
/* harmony export */   fi: function() { return /* reexport module object */ _fi_js__WEBPACK_IMPORTED_MODULE_5__; },
/* harmony export */   fr: function() { return /* reexport module object */ _fr_js__WEBPACK_IMPORTED_MODULE_6__; },
/* harmony export */   he: function() { return /* reexport module object */ _he_js__WEBPACK_IMPORTED_MODULE_7__; },
/* harmony export */   hu: function() { return /* reexport module object */ _hu_js__WEBPACK_IMPORTED_MODULE_8__; },
/* harmony export */   id: function() { return /* reexport module object */ _id_js__WEBPACK_IMPORTED_MODULE_9__; },
/* harmony export */   it: function() { return /* reexport module object */ _it_js__WEBPACK_IMPORTED_MODULE_10__; },
/* harmony export */   ja: function() { return /* reexport module object */ _ja_js__WEBPACK_IMPORTED_MODULE_11__; },
/* harmony export */   ko: function() { return /* reexport module object */ _ko_js__WEBPACK_IMPORTED_MODULE_12__; },
/* harmony export */   mn: function() { return /* reexport module object */ _mn_js__WEBPACK_IMPORTED_MODULE_13__; },
/* harmony export */   nl: function() { return /* reexport module object */ _nl_js__WEBPACK_IMPORTED_MODULE_14__; },
/* harmony export */   no: function() { return /* reexport module object */ _no_js__WEBPACK_IMPORTED_MODULE_15__; },
/* harmony export */   pl: function() { return /* reexport module object */ _pl_js__WEBPACK_IMPORTED_MODULE_16__; },
/* harmony export */   pt_br: function() { return /* reexport module object */ _pt_br_js__WEBPACK_IMPORTED_MODULE_17__; },
/* harmony export */   ru: function() { return /* reexport module object */ _ru_js__WEBPACK_IMPORTED_MODULE_18__; },
/* harmony export */   tr: function() { return /* reexport module object */ _tr_js__WEBPACK_IMPORTED_MODULE_19__; },
/* harmony export */   ua: function() { return /* reexport module object */ _ua_js__WEBPACK_IMPORTED_MODULE_20__; },
/* harmony export */   zh_cn: function() { return /* reexport module object */ _zh_cn_js__WEBPACK_IMPORTED_MODULE_21__; },
/* harmony export */   zh_tw: function() { return /* reexport module object */ _zh_tw_js__WEBPACK_IMPORTED_MODULE_22__; }
/* harmony export */ });
/* harmony import */ var _ar_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71705);
/* harmony import */ var _cs_cz_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89930);
/* harmony import */ var _de_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34945);
/* harmony import */ var _es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63134);
/* harmony import */ var _fa_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66835);
/* harmony import */ var _fi_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1115);
/* harmony import */ var _fr_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59302);
/* harmony import */ var _he_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94141);
/* harmony import */ var _hu_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24877);
/* harmony import */ var _id_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80651);
/* harmony import */ var _it_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62395);
/* harmony import */ var _ja_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(16407);
/* harmony import */ var _ko_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(37272);
/* harmony import */ var _mn_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(22113);
/* harmony import */ var _nl_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(22432);
/* harmony import */ var _no_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(17081);
/* harmony import */ var _pl_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(30798);
/* harmony import */ var _pt_br_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(8661);
/* harmony import */ var _ru_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(19147);
/* harmony import */ var _tr_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(93620);
/* harmony import */ var _ua_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(40372);
/* harmony import */ var _zh_cn_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(69874);
/* harmony import */ var _zh_tw_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(88774);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ // @ts-nocheck


























/***/ }),

/***/ 91003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K: function() { return /* binding */ stripTags; }
/* harmony export */ });
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _checker_is_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70799);
/* harmony import */ var _string_trim_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49055);
/* harmony import */ var _utils_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43555);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



const NEW_LINE_TAGS = new Set([
    'div',
    'p',
    'br',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'hr'
]);
const INVISIBLE_TAGS = new Set([
    'script',
    'style'
]);
const ALONE_TAGS = new Set([
    'br',
    'hr',
    'input'
]);
/**
 * Extract plain text from HTML text
 */ function stripTags(html, doc = document, exclude = null) {
    const tmp = doc.createElement('div');
    if ((0,_checker_is_string_js__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .K)(html)) {
        tmp.innerHTML = html;
    } else {
        tmp.appendChild(html);
    }
    (0,_utils_index_js__WEBPACK_IMPORTED_MODULE_2__.$$)('*', tmp).forEach((p)=>{
        const pr = p.parentNode;
        if (!pr) {
            return;
        }
        if (exclude && _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(p, exclude)) {
            const tag = p.nodeName.toLowerCase();
            const text = !_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(p, ALONE_TAGS) ? `%%%jodit-${tag}%%%${stripTags(p.innerHTML, doc, exclude)}%%%/jodit-${tag}%%%` : `%%%jodit-single-${tag}%%%`;
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.before(p, doc.createTextNode(text));
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(p);
            return;
        }
        if (_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(p, INVISIBLE_TAGS)) {
            _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(p);
            return;
        }
        if (!_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(p, NEW_LINE_TAGS)) {
            return;
        }
        const nx = p.nextSibling;
        if (_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isText(nx) && /^\s/.test(nx.nodeValue || '')) {
            return;
        }
        if (nx) {
            pr.insertBefore(doc.createTextNode(' '), nx);
        }
    });
    return restoreTags((0,_string_trim_js__WEBPACK_IMPORTED_MODULE_1__/* .trim */ .Bq)(tmp.innerText));
}
function restoreTags(content) {
    return content.replace(/%%%(\/)?jodit(-single)?-([\w\n]+)%%%/g, (_, isClosed, isSingle, tag)=>`<${isClosed ? '/' : ''}${tag}>`);
}


/***/ }),

/***/ 91071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export limit */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50911);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57288);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





/**
 * Plugin control for chars or words count
 */ class limit extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Plugin */ .k {
    /** @override **/ afterInit(jodit) {
        const { limitWords, limitChars } = jodit.o;
        if (jodit && (limitWords || limitChars)) {
            let snapshot = null;
            jodit.e.off('.limit').on('beforePaste.limit', ()=>{
                snapshot = jodit.history.snapshot.make();
            }).on('keydown.limit keyup.limit beforeEnter.limit', this.checkPreventKeyPressOrPaste).on('change.limit', this.checkPreventChanging).on('afterPaste.limit', ()=>{
                if (this.__shouldDenyInput(true) && snapshot) {
                    jodit.history.snapshot.restore(snapshot);
                    jodit.e.fire('denyPaste.limit');
                    return false;
                }
            });
        }
    }
    /**
     * Action should be prevented
     */ shouldPreventInsertHTML(event) {
        if (event && (_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.COMMAND_KEYS.includes(event.key) || event.ctrlKey || event.metaKey)) {
            return false;
        }
        return this.__shouldDenyInput(false);
    }
    __shouldDenyInput(strict) {
        const { jodit } = this;
        const { limitWords, limitChars } = jodit.o;
        const text = jodit.o.limitHTML ? jodit.value : jodit.text;
        const words = this.__splitWords(text);
        if (limitWords && isGt(words.length, limitWords, strict)) {
            jodit.e.fire('denyWords.limit limit.limit');
            return true;
        }
        const should = Boolean(limitChars && isGt(words.join('').length, limitChars, strict));
        if (should) {
            jodit.e.fire('denyChars.limit limit.limit');
        }
        return should;
    }
    /**
     * Check if some keypress or paste should be prevented
     */ checkPreventKeyPressOrPaste(event) {
        if (this.shouldPreventInsertHTML(event)) {
            return false;
        }
    }
    /**
     * Check if some external changing should be prevented
     */ checkPreventChanging(newValue, oldValue) {
        const { jodit } = this;
        if (this.__shouldDenyInput(true)) {
            jodit.value = oldValue;
        }
    }
    /**
     * Split text on words without technical characters
     */ __splitWords(text) {
        return text.replace((0,_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE_REG_EXP)(), '').split((0,_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.SPACE_REG_EXP)()).filter((e)=>e.length);
    }
    /** @override **/ beforeDestruct(jodit) {
        jodit.e.off('.limit');
    }
}
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], limit.prototype, "checkPreventKeyPressOrPaste", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], limit.prototype, "checkPreventChanging", null);
function isGt(a, b, strict) {
    return strict ? a > b : a >= b;
}
_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .pluginSystem */ .fg.add('limit', limit);


/***/ }),

/***/ 91080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    symbols: 'символ'
});


/***/ }),

/***/ 91126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   l: function() { return /* binding */ calcListLevels; }
/* harmony export */ });
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48430);
/* harmony import */ var jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78547);
/* harmony import */ var jodit_pro_plugins_paste_from_word_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31117);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */



function calcListLevels(item) {
    if (item.attributes[jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_0__/* .LEVEL_KEY */ .fB] !== undefined) {
        return;
    }
    const indents = [(0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .realPixelIndent */ .x0)(item)], items = [item];
    let next = item.next;
    while (next) {
        if (next.isElement &&
            !next.attributes[jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_0__/* .LEVEL_KEY */ .fB] &&
            (0,jodit_pro_plugins_paste_from_word_element__WEBPACK_IMPORTED_MODULE_1__/* .isPseudoLeaf */ .hJ)(next)) {
            const indent = (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .realPixelIndent */ .x0)(next);
            if (indent) {
                indents.push(indent);
                items.push(next);
            }
        }
        next = next.next;
    }
    const minIndent = Math.min(...indents.filter((val) => val > 0));
    let levels = indents.map((val) => Math.ceil(val / 10));
    if (levels.indexOf(0) !== -1) {
        levels = levels.map((val) => val + 1);
    }
    items.forEach((curItem, index) => {
        curItem.attributes[jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_0__/* .LEVEL_KEY */ .fB] = levels[index];
        curItem.style.add('margin-left', `${Math.max((0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .realPixelIndent */ .x0)(curItem) -
            ((levels[index] * 10) / minIndent) * 40, 0)}px`);
    });
}


/***/ }),

/***/ 91388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   M: function() { return /* binding */ moveCursorOutFromSpecialTags; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
/**
 * Checks if the cursor is on the edge of a special tag and exits if so
 * @private
 */ function moveCursorOutFromSpecialTags(jodit, fake, tags) {
    const { s } = jodit;
    const link = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(fake, tags, jodit.editor);
    if (link) {
        if (s.cursorOnTheRight(link, fake)) {
            _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.after(link, fake);
        } else if (s.cursorOnTheLeft(link, fake)) {
            _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.before(link, fake);
        }
    }
}


/***/ }),

/***/ 91748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   a: function() { return /* binding */ checkJoinTwoLists; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _core_helpers_utils_utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37790);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63785);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/**
 * Try join two UL elements
 *
 * @example
 * ```html
 * <ul><li>one</li></ul>|<ol><li>two</li></ol>
 * ```
 * Result
 * ```html
 * <ul><li>one|</li><li>two</li></ul>
 * ```
 * @private
 */ function checkJoinTwoLists(jodit, fakeNode, backspace) {
    const next = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.findSibling(fakeNode, backspace), prev = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.findSibling(fakeNode, !backspace);
    if (!_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(fakeNode, _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isElement, jodit.editor) && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isList(next) && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isList(prev) && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(next.lastElementChild, 'li') && _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(prev.firstElementChild, 'li')) {
        const { setCursorBefore, setCursorAfter } = jodit.s;
        const target = next.lastElementChild, second = prev.firstElementChild;
        (0,_core_helpers_utils_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .call */ .T1)(!backspace ? _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.append : _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.prepend, second, fakeNode);
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.moveContent(prev, next, !backspace, (0,_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .getMoveFilter */ .g)(jodit));
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(prev);
        (0,_core_helpers_utils_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .call */ .T1)(backspace ? _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.append : _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.prepend, target, fakeNode);
        (0,_core_helpers_utils_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .call */ .T1)(backspace ? setCursorBefore : setCursorAfter, fakeNode);
        return true;
    }
    return false;
}


/***/ }),

/***/ 91876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   I: function() { return /* binding */ getTextLeftOfCursor; },
/* harmony export */   s: function() { return /* binding */ replaceTextLeftOfCursorAfterSpace; }
/* harmony export */ });
/* harmony import */ var jodit_esm_core_dom_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */

/**
 * For collapsed selection return left text value before cursor
 * @example
 * ```
 * <p><string>test</strong>pop|</p> => pop
 * <p><string>test|</strong>pop</p> => test
 * <p><string>te|st</strong>pop</p> => te
 * ```
 */
function getTextLeftOfCursor(range) {
    const { startContainer, startOffset } = range;
    if (jodit_esm_core_dom_dom__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isText(startContainer)) {
        return startContainer.nodeValue?.substr(0, startOffset) ?? '';
    }
    const node = startContainer.childNodes[startOffset];
    if (!node) {
        return '';
    }
    if (jodit_esm_core_dom_dom__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isText(node)) {
        return node.nodeValue ?? '';
    }
    const previous = jodit_esm_core_dom_dom__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.findNotEmptyNeighbor(node, true, startContainer);
    if (jodit_esm_core_dom_dom__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isText(previous)) {
        return node.nodeValue ?? '';
    }
    return '';
}
/**
 * For collapsed selection replace part of left text value before cursor but started after space
 * @example
 * ```
 * <p><string>test</strong>pap|</p> + pappy = <p><string>test</strong>pappy|</p>
 * <p><string>test</strong>pap| test</p> + pappy = <p><string>test</strong>pappy| test</p>
 * <p><string>test</strong>stat pap| test</p> + pappy = <p><string>test</strong>stat pappy| test</p>
 * ```
 */
function replaceTextLeftOfCursorAfterSpace(range, elm) {
    let { startContainer, startOffset } = range;
    if (!jodit_esm_core_dom_dom__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isText(startContainer)) {
        startContainer = startContainer.childNodes[startOffset - 1];
        if (jodit_esm_core_dom_dom__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isText(startContainer)) {
            startOffset = startContainer.nodeValue?.length ?? 0;
        }
    }
    if (jodit_esm_core_dom_dom__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isText(startContainer)) {
        const value = startContainer.nodeValue ?? '', leftSide = value.substring(0, startOffset), rightSide = value.substring(startOffset);
        const words = leftSide.split(' ');
        words[words.length - 1] = '';
        const newLeftSide = words.join(' ');
        startContainer.nodeValue = newLeftSide + rightSide;
        range.setStart(startContainer, newLeftSide.length);
        range.insertNode(elm);
        return;
    }
}


/***/ }),

/***/ 91898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   D: function() { return /* reexport safe */ _set_timeout_js__WEBPACK_IMPORTED_MODULE_0__.D; },
/* harmony export */   w: function() { return /* reexport safe */ _set_timeout_js__WEBPACK_IMPORTED_MODULE_0__.w; }
/* harmony export */ });
/* harmony import */ var _set_timeout_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13252);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/async
 */ 


/***/ }),

/***/ 91907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   f: function() { return /* reexport safe */ _statuses_js__WEBPACK_IMPORTED_MODULE_1__.f; },
/* harmony export */   uA: function() { return /* reexport safe */ _component_js__WEBPACK_IMPORTED_MODULE_0__.u; },
/* harmony export */   vG: function() { return /* reexport safe */ _view_component_js__WEBPACK_IMPORTED_MODULE_2__.v; }
/* harmony export */ });
/* harmony import */ var _component_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4012);
/* harmony import */ var _statuses_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78213);
/* harmony import */ var _view_component_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80480);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module component
 */ 




/***/ }),

/***/ 92113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C: function() { return /* binding */ UISeparator; }
/* harmony export */ });
/* harmony import */ var _decorators_component_component_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87325);
/* harmony import */ var _element_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48538);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * @module ui/group
 */ 

let UISeparator = class UISeparator extends _element_js__WEBPACK_IMPORTED_MODULE_0__/* .UIElement */ .D {
    className() {
        return 'UISeparator';
    }
};
UISeparator = __decorate([
    _decorators_component_component_js__WEBPACK_IMPORTED_MODULE_1__/* .component */ .s
], UISeparator);



/***/ }),

/***/ 92278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   F: function() { return /* binding */ UISearch; }
/* harmony export */ });
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22732);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21537);
/* harmony import */ var _core_ui_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67510);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






let UISearch = class UISearch extends _core_ui_index_js__WEBPACK_IMPORTED_MODULE_4__/* .UIElement */ .D$ {
    className() {
        return 'UISearch';
    }
    render() {
        return `<div>
			<div class="&__box">
				<div class="&__inputs">
					<input data-ref="query" tabindex="0" placeholder="~Search for~" type="text"/>
					<input data-ref="replace" tabindex="0" placeholder="~Replace with~" type="text"/>
				</div>
				<div class="&__counts">
					<span data-ref="counter-box">
						<span data-ref="current">0</span><span>/</span><span data-ref="count">0</span>
					</span>
				</div>
				<div class="&__buttons">
					<button data-ref="next" tabindex="0" type="button">${_core_ui_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .In.get('angle-down')}</button>
					<button data-ref="prev" tabindex="0" type="button">${_core_ui_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .In.get('angle-up')}</button>
					<button data-ref="cancel" tabindex="0" type="button">${_core_ui_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .In.get('cancel')}</button>
					<button data-ref="replace-btn" tabindex="0" type="button" class="jodit-ui-button">~Replace~</button>
				</div>
			</div>
		</div>`;
    }
    get currentIndex() {
        return this._currentIndex;
    }
    set currentIndex(value) {
        this._currentIndex = value;
        this.currentBox.innerText = value.toString();
    }
    set count(value) {
        this.countBox.innerText = value.toString();
    }
    get query() {
        return this.queryInput.value;
    }
    get replace() {
        return this.replaceInput.value;
    }
    onEditorKeyDown(e) {
        if (!this.isOpened) {
            return;
        }
        const { j } = this;
        if (j.getRealMode() !== _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_WYSIWYG) {
            return;
        }
        switch(e.key){
            case _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_ESC:
                this.close();
                break;
            case _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_F3:
                if (this.queryInput.value) {
                    j.e.fire(!e.shiftKey ? 'searchNext' : 'searchPrevious');
                    e.preventDefault();
                }
                break;
        }
    }
    open(query, replace, searchAndReplace = false) {
        if (!this.isOpened) {
            this.j.workplace.appendChild(this.container);
            this.isOpened = true;
        }
        this.calcSticky(this.j.e.fire('getStickyState.sticky') || false);
        this.j.e.fire('hidePopup');
        this.setMod('replace', searchAndReplace);
        // this.current = this.j.s.current();
        const selStr = query !== null && query !== void 0 ? query : (this.j.s.sel || '').toString();
        if (selStr) {
            this.queryInput.value = selStr;
        }
        if (replace) {
            this.replaceInput.value = replace;
        }
        this.setMod('empty-query', !selStr.length);
        this.j.e.fire(this, 'needUpdateCounters');
        if (selStr) {
            this.queryInput.select();
        } else {
            this.queryInput.focus();
        }
    }
    close() {
        if (!this.isOpened) {
            return;
        }
        this.j.s.restore();
        _core_dom_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Dom */ .J.safeRemove(this.container);
        this.isOpened = false;
        this.j.e.fire(this, 'afterClose');
    }
    /**
     * Calculate position if sticky is enabled
     */ calcSticky(enabled) {
        if (this.isOpened) {
            this.setMod('sticky', enabled);
            if (enabled) {
                const pos = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.position)(this.j.toolbarContainer);
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(this.container, {
                    top: pos.top + pos.height,
                    left: pos.left + pos.width
                });
            } else {
                (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.css)(this.container, {
                    top: null,
                    left: null
                });
            }
        }
    }
    constructor(jodit){
        super(jodit);
        this.selInfo = null;
        this._currentIndex = 0;
        this.isOpened = false;
        const { query, replace, cancel, next, prev, replaceBtn, current, count } = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.refs)(this.container);
        this.queryInput = query;
        this.replaceInput = replace;
        this.closeButton = cancel;
        this.replaceButton = replaceBtn;
        this.currentBox = current;
        this.countBox = count;
        jodit.e.on(this.closeButton, 'pointerdown', ()=>{
            this.close();
            return false;
        }).on(this.queryInput, 'input', ()=>{
            this.currentIndex = 0;
        }).on(this.queryInput, 'pointerdown', ()=>{
            if (jodit.s.isFocused()) {
                jodit.s.removeMarkers();
                this.selInfo = jodit.s.save();
            }
        }).on(this.replaceButton, 'pointerdown', ()=>{
            jodit.e.fire(this, 'pressReplaceButton');
            return false;
        }).on(next, 'pointerdown', ()=>{
            void jodit.e.fire('searchNext');
            return false;
        }).on(prev, 'pointerdown', ()=>{
            jodit.e.fire('searchPrevious');
            return false;
        }).on(this.queryInput, 'input', ()=>{
            this.setMod('empty-query', !(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.trim)(this.queryInput.value).length);
        }).on(this.queryInput, 'keydown', this.j.async.debounce(async (e)=>{
            switch(e.key){
                case _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.KEY_ENTER:
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    if (await jodit.e.fire('searchNext')) {
                        this.close();
                    }
                    break;
                default:
                    jodit.e.fire(this, 'needUpdateCounters');
                    break;
            }
        }, this.j.defaultTimeout));
    }
};
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)([
        ':keydown',
        'queryInput:keydown'
    ])
], UISearch.prototype, "onEditorKeyDown", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], UISearch.prototype, "open", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.autobind
], UISearch.prototype, "close", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.watch)(':toggleSticky')
], UISearch.prototype, "calcSticky", null);
UISearch = __decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_1__.component
], UISearch);



/***/ }),

/***/ 92643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   u: function() { return /* binding */ Command; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ class Command {
    undo() {
        this.history.snapshot.restore(this.oldValue);
    }
    redo() {
        this.history.snapshot.restore(this.newValue);
    }
    constructor(oldValue, newValue, history, tick){
        this.oldValue = oldValue;
        this.newValue = newValue;
        this.history = history;
        this.tick = tick;
    }
}


/***/ }),

/***/ 92648:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'Type something': 'Ketik sesuatu',
    'About Jodit': 'Tentang Jodit',
    'Jodit Editor': 'Editor Jodit',
    'Free Non-commercial Version': 'Versi Bebas Non-komersil',
    "Jodit User's Guide": 'Panduan Pengguna Jodit',
    'contains detailed help for using': 'mencakup detail bantuan penggunaan',
    'For information about the license, please go to our website:': 'Untuk informasi tentang lisensi, silakan kunjungi website:',
    'Buy full version': 'Beli versi lengkap',
    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.': 'Hak Cipta © XDSoft.net - Chupurnov Valeriy. Hak cipta dilindungi undang-undang.',
    Anchor: 'Tautan',
    'Open in new tab': 'Buka di tab baru',
    'Open in fullsize': 'Buka editor dalam ukuran penuh',
    'Clear Formatting': 'Hapus Pemformatan',
    'Fill color or set the text color': 'Isi warna atau atur warna teks',
    Redo: 'Ulangi',
    Undo: 'Batalkan',
    Bold: 'Tebal',
    Italic: 'Miring',
    'Insert Unordered List': 'Sisipkan Daftar Tidak Berurut',
    'Insert Ordered List': 'Sisipkan Daftar Berurut',
    'Align Center': 'Tengah',
    'Align Justify': 'Penuh',
    'Align Left': 'Kiri',
    'Align Right': 'Kanan',
    'Insert Horizontal Line': 'Sisipkan Garis Horizontal',
    'Insert Image': 'Sisipkan Gambar',
    'Insert file': 'Sisipkan Berkas',
    'Insert youtube/vimeo video': 'Sisipkan video youtube/vimeo',
    'Insert link': 'Sisipkan tautan',
    'Font size': 'Ukuran font',
    'Font family': 'Keluarga font',
    'Insert format block': 'Sisipkan blok format',
    Normal: 'Normal',
    'Heading 1': 'Heading 1',
    'Heading 2': 'Heading 2',
    'Heading 3': 'Heading 3',
    'Heading 4': 'Heading 4',
    Quote: 'Kutip',
    Code: 'Kode',
    Insert: 'Sisipkan',
    'Insert table': 'Sisipkan tabel',
    'Decrease Indent': 'Kurangi Indentasi',
    'Increase Indent': 'Tambah Indentasi',
    'Select Special Character': 'Pilih Karakter Spesial',
    'Insert Special Character': 'Sisipkan Karakter Spesial',
    'Paint format': 'Formar warna',
    'Change mode': 'Ubah mode',
    Margins: 'Batas',
    top: 'atas',
    right: 'kanan',
    bottom: 'bawah',
    left: 'kiri',
    Styles: 'Gaya',
    Classes: 'Class',
    Align: 'Rata',
    Right: 'Kanan',
    Center: 'Tengah',
    Left: 'Kiri',
    '--Not Set--': '--Tidak diset--',
    Src: 'Src',
    Title: 'Judul',
    Alternative: 'Teks alternatif',
    Link: 'Tautan',
    'Open link in new tab': 'Buka tautan di tab baru',
    Image: 'Gambar',
    file: 'berkas',
    Advanced: 'Lanjutan',
    'Image properties': 'Properti gambar',
    Cancel: 'Batal',
    Ok: 'Ya',
    'Your code is similar to HTML. Keep as HTML?': 'Kode Anda cenderung ke HTML. Biarkan sebagai HTML?',
    'Paste as HTML': 'Paste sebagai HTML',
    Keep: 'Jaga',
    Clean: 'Bersih',
    'Insert as Text': 'Sisipkan sebagai teks',
    'Insert only Text': 'Sisipkan hanya teks',
    'Word Paste Detected': 'Terdeteksi paste dari Word',
    'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?': 'Konten dipaste dari dokumen Microsoft Word/Excel. Apakah Anda ingin tetap menjaga format atau membersihkannya?',
    'File Browser': 'Penjelajah Berkas',
    'Error on load list': 'Error ketika memuat list',
    'Error on load folders': 'Error ketika memuat folder',
    'Are you sure?': 'Apakah Anda yakin?',
    'Enter Directory name': 'Masukkan nama Direktori',
    'Create directory': 'Buat direktori',
    'type name': 'ketik nama',
    'Drop image': 'Letakkan gambar',
    'Drop file': 'Letakkan berkas',
    'or click': 'atau klik',
    'Alternative text': 'Teks alternatif',
    Browse: 'Jelajahi',
    Upload: 'Unggah',
    Background: 'Latar Belakang',
    Text: 'Teks',
    Top: 'Atas',
    Middle: 'Tengah',
    Bottom: 'Bawah',
    'Insert column before': 'Sisipkan kolom sebelumnya',
    'Insert column after': 'Sisipkan kolom setelahnya',
    'Insert row above': 'Sisipkan baris di atasnya',
    'Insert row below': 'Sisipkan baris di bawahnya',
    'Delete table': 'Hapus tabel',
    'Delete row': 'Hapus baris',
    'Delete column': 'Hapus kolom',
    'Empty cell': 'Kosongkan cell',
    source: 'sumber',
    bold: 'tebal',
    italic: 'miring',
    brush: 'sikat',
    link: 'tautan',
    undo: 'batalkan',
    redo: 'ulangi',
    table: 'tabel',
    image: 'gambar',
    eraser: 'penghapus',
    paragraph: 'paragraf',
    fontsize: 'ukuran font',
    video: 'video',
    font: 'font',
    about: 'tentang',
    print: 'cetak',
    underline: 'garis bawah',
    strikethrough: 'coret',
    indent: 'menjorok ke dalam',
    outdent: 'menjorok ke luar',
    fullsize: 'ukuran penuh',
    shrink: 'menyusut',
    hr: 'hr',
    ul: 'ul',
    ol: 'ol',
    cut: 'potong',
    selectall: 'Pilih semua',
    'Embed code': 'Kode embed',
    'Open link': 'Buka tautan',
    'Edit link': 'Edit tautan',
    'No follow': 'No follow',
    Unlink: 'Hapus tautan',
    Eye: 'Mata',
    pencil: 'pensil',
    Update: 'Perbarui',
    ' URL': 'URL',
    Edit: 'Edit',
    'Horizontal align': 'Perataan horizontal',
    Filter: 'Filter',
    'Sort by changed': 'Urutkan berdasarkan perubahan',
    'Sort by name': 'Urutkan berdasarkan nama',
    'Sort by size': 'Urutkan berdasarkan ukuran',
    'Add folder': 'Tambah folder',
    Reset: 'Reset',
    Save: 'Simpan',
    'Save as ...': 'Simpan sebagai...',
    Resize: 'Ubah ukuran',
    Crop: 'Crop',
    Width: 'Lebar',
    Height: 'Tinggi',
    'Keep Aspect Ratio': 'Jaga aspek rasio',
    Yes: 'Ya',
    No: 'Tidak',
    Remove: 'Copot',
    Select: 'Pilih',
    'Chars: %d': 'Karakter: %d',
    'Words: %d': 'Kata: %d',
    All: 'Semua',
    'Select %s': 'Pilih %s',
    'Select all': 'Pilih semua',
    'Vertical align': 'Rata vertikal',
    Split: 'Bagi',
    'Split vertical': 'Bagi secara vertikal',
    'Split horizontal': 'Bagi secara horizontal',
    Merge: 'Gabungkan',
    'Add column': 'Tambah kolom',
    'Add row': 'tambah baris',
    Delete: 'Hapus',
    Border: 'Bingkai',
    'License: %s': 'Lisensi: %s',
    'Strike through': 'Coret',
    Underline: 'Garis Bawah',
    superscript: 'Superskrip',
    subscript: 'Subskrip',
    'Cut selection': 'Potong pilihan',
    Break: 'Berhenti',
    'Search for': 'Mencari',
    'Replace with': 'Ganti dengan',
    Replace: 'Mengganti',
    Paste: 'Paste',
    'Choose Content to Paste': 'Pilih konten untuk dipaste',
    'You can only edit your own images. Download this image on the host?': 'Anda hanya dapat mengedit gambar Anda sendiri. Unduh gambar ini di host?',
    'The image has been successfully uploaded to the host!': 'Gambar telah sukses diunggah ke host!',
    palette: 'palet',
    'There are no files': 'Tidak ada berkas',
    Rename: 'ganti nama',
    'Enter new name': 'Masukkan nama baru',
    preview: 'pratinjau',
    download: 'Unduh',
    'Paste from clipboard': 'Paste dari clipboard',
    "Your browser doesn't support direct access to the clipboard.": 'Browser anda tidak mendukung akses langsung ke clipboard.',
    'Copy selection': 'Copy seleksi',
    copy: 'copy',
    'Border radius': 'Border radius',
    'Show all': 'Tampilkan semua',
    Apply: 'Menerapkan',
    'Please fill out this field': 'Silahkan mengisi kolom ini',
    'Please enter a web address': 'Silahkan masukkan alamat web',
    Default: 'Default',
    Circle: 'Lingkaran',
    Dot: 'Dot',
    Quadrate: 'Kuadrat',
    Find: 'Menemukan',
    'Find Previous': 'Menemukan Sebelumnya',
    'Find Next': 'Menemukan Berikutnya',
    'Insert className': 'Masukkan nama kelas',
    'Press Alt for custom resizing': 'Tekan Alt untuk mengubah ukuran kustom'
});


/***/ }),

/***/ 92699:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"> <path stroke-width=\"0\" d=\"M10.5 20H2a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h1V3l2.03-.4a3 3 0 0 1 5.94 0L13 3v1h1a2 2 0 0 1 2 2v1h-2V6h-1v1H3V6H2v12h5v2h3.5zM8 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm2 4h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8c0-1.1.9-2 2-2zm0 2v8h8v-8h-8z\"/> </svg> ");


/***/ }),

/***/ 92762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Kn: function() { return /* reexport safe */ _color_picker_color_picker_js__WEBPACK_IMPORTED_MODULE_0__.K; },
/* harmony export */   Zg: function() { return /* reexport safe */ _tabs_tabs_js__WEBPACK_IMPORTED_MODULE_2__.Z; },
/* harmony export */   kG: function() { return /* reexport safe */ _file_selector_file_selector_js__WEBPACK_IMPORTED_MODULE_1__.k; }
/* harmony export */ });
/* harmony import */ var _color_picker_color_picker_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22859);
/* harmony import */ var _file_selector_file_selector_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34793);
/* harmony import */ var _tabs_tabs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38927);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * [[include:modules/widget/README.md]]
 * @packageDocumentation
 * @module modules/widget
 */ 




/***/ }),

/***/ 93079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export color */
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21537);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21988);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


/**
 * Process commands `background` and `forecolor`
 */ function color(editor) {
    editor.registerButton({
        name: 'brush',
        group: 'color'
    });
    const callback = (command, second, third)=>{
        const colorHEX = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_1__.normalizeColor)(third);
        switch(command){
            case 'background':
                editor.s.commitStyle({
                    attributes: {
                        style: {
                            backgroundColor: !colorHEX ? '' : colorHEX
                        }
                    }
                });
                break;
            case 'forecolor':
                editor.s.commitStyle({
                    attributes: {
                        style: {
                            color: !colorHEX ? '' : colorHEX
                        }
                    }
                });
                break;
        }
        editor.synchronizeValues();
        return false;
    };
    editor.registerCommand('forecolor', callback).registerCommand('background', callback);
}
_core_global_js__WEBPACK_IMPORTED_MODULE_0__/* .pluginSystem */ .fg.add('color', color);


/***/ }),

/***/ 93119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Q: function() { return /* binding */ SentenceFinder; }
/* harmony export */ });
/* harmony import */ var _core_helpers_string_fuzzy_search_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67477);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
class SentenceFinder {
    add(node) {
        var _a;
        const value = ((_a = node.nodeValue) !== null && _a !== void 0 ? _a : '').toLowerCase();
        if (!value.length) {
            return;
        }
        const index = this.value.length;
        this.queue.push({
            startIndex: index,
            endIndex: index + value.length,
            node
        });
        this.value += value;
    }
    ranges(needle, position = 0) {
        const results = [];
        let index = position, len = 0, startQueueIndex = 0;
        // Find all ranges in substring
        do {
            [index, len] = this.searchIndex(needle, this.value, index);
            if (index !== -1) {
                let startContainer, startOffset = 0, endContainer, endOffset = 0;
                for(let i = startQueueIndex; i < this.queue.length; i += 1){
                    if (!startContainer && this.queue[i].endIndex > index) {
                        startContainer = this.queue[i].node;
                        startOffset = index - this.queue[i].startIndex;
                    }
                    if (startContainer && this.queue[i].endIndex >= index + len) {
                        endContainer = this.queue[i].node;
                        endOffset = index + len - this.queue[i].startIndex;
                        startQueueIndex = i;
                        break;
                    }
                }
                if (startContainer && endContainer) {
                    results.push({
                        startContainer,
                        startOffset,
                        endContainer,
                        endOffset
                    });
                }
                index += len;
            }
        }while (index !== -1)
        return results.length === 0 ? null : results;
    }
    constructor(searchIndex = _core_helpers_string_fuzzy_search_index_js__WEBPACK_IMPORTED_MODULE_0__/* .fuzzySearchIndex */ .H){
        this.searchIndex = searchIndex;
        this.queue = [];
        this.value = '';
    }
}


/***/ }),

/***/ 93183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export backspace */
/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22732);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23282);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50911);
/* harmony import */ var _core_selection_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45124);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32496);
/* harmony import */ var _cases_check_not_collapsed_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11338);
/* harmony import */ var _cases_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14630);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 








class backspace extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_3__/* .Plugin */ .k {
    afterInit(jodit) {
        jodit.registerCommand('deleteButton', {
            exec: ()=>this.onDelete(false),
            hotkeys: jodit.o.delete.hotkeys.delete
        }, {
            stopPropagation: false
        }).registerCommand('backspaceButton', {
            exec: ()=>this.onDelete(true),
            hotkeys: jodit.o.delete.hotkeys.backspace
        }, {
            stopPropagation: false
        }).registerCommand('deleteWordButton', {
            exec: ()=>this.onDelete(false, 'word'),
            hotkeys: jodit.o.delete.hotkeys.deleteWord
        }).registerCommand('backspaceWordButton', {
            exec: ()=>this.onDelete(true, 'word'),
            hotkeys: jodit.o.delete.hotkeys.backspaceWord
        }).registerCommand('deleteSentenceButton', {
            exec: ()=>this.onDelete(false, 'sentence'),
            hotkeys: jodit.o.delete.hotkeys.deleteSentence
        }).registerCommand('backspaceSentenceButton', {
            exec: ()=>this.onDelete(true, 'sentence'),
            hotkeys: jodit.o.delete.hotkeys.backspaceSentence
        });
    }
    beforeDestruct(jodit) {
        jodit.e.off('afterCommand.delete');
    }
    /**
     * Listener BackSpace or Delete button
     */ onDelete(backspace, mode = 'char') {
        const jodit = this.j;
        const sel = jodit.selection;
        if (!sel.isFocused()) {
            sel.focus();
        }
        if ((0,_cases_check_not_collapsed_js__WEBPACK_IMPORTED_MODULE_7__/* .checkNotCollapsed */ .L)(jodit)) {
            return false;
        }
        const range = sel.range;
        const fakeNode = jodit.createInside.text(_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.INVISIBLE_SPACE);
        try {
            _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeInsertNode(range, fakeNode);
            if (!_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isOrContains(jodit.editor, fakeNode)) {
                return;
            }
            if (jodit.e.fire('backSpaceBeforeCases', backspace, fakeNode)) {
                return false;
            }
            (0,_core_selection_helpers_index_js__WEBPACK_IMPORTED_MODULE_4__/* .moveNodeInsideStart */ .W8)(jodit, fakeNode, backspace);
            if (_cases_index_js__WEBPACK_IMPORTED_MODULE_6__/* .cases */ .C.some((func)=>{
                if ((0,_core_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_8__/* .isFunction */ .T)(func) && func(jodit, fakeNode, backspace, mode)) {
                    if (!_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD) {
                        console.info('Remove case:', func.name);
                    }
                    return true;
                }
            })) {
                return false;
            }
        } catch (e) {
            if (!_core_constants_js__WEBPACK_IMPORTED_MODULE_0__.IS_PROD) {
                console.error(e);
            }
            throw e;
        } finally{
            jodit.e.fire('backSpaceAfterDelete', backspace, fakeNode);
            this.safeRemoveEmptyNode(fakeNode);
        }
        return false;
    }
    /**
     * Remove node and replace cursor position out of it
     */ safeRemoveEmptyNode(fakeNode) {
        var _a, _b;
        const { range } = this.j.s;
        if (range.startContainer === fakeNode) {
            if (fakeNode.previousSibling) {
                if (_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isText(fakeNode.previousSibling)) {
                    range.setStart(fakeNode.previousSibling, (_b = (_a = fakeNode.previousSibling.nodeValue) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0);
                } else {
                    range.setStartAfter(fakeNode.previousSibling);
                }
            } else if (fakeNode.nextSibling) {
                if (_core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isText(fakeNode.nextSibling)) {
                    range.setStart(fakeNode.nextSibling, 0);
                } else {
                    range.setStartBefore(fakeNode.nextSibling);
                }
            }
            range.collapse(true);
            this.j.s.selectRange(range);
        }
        _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.safeRemove(fakeNode);
    }
}
backspace.requires = [
    'hotkeys'
];
_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .pluginSystem */ .fg.add('backspace', backspace);


/***/ }),

/***/ 93401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export inlinePopup */
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65478);
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22732);
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580);
/* harmony import */ var _core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21537);
/* harmony import */ var _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50911);
/* harmony import */ var _core_ui_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67510);
/* harmony import */ var _core_ui_popup_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61259);
/* harmony import */ var _modules_toolbar_factory_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21491);
/* harmony import */ var _config_config_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24526);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









/**
 * Plugin for show inline popup dialog
 */ class inlinePopup extends _core_plugin_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Plugin */ .k {
    get popup() {
        return new _core_ui_popup_index_js__WEBPACK_IMPORTED_MODULE_6__/* .Popup */ .z(this.jodit, false);
    }
    get toolbar() {
        return (0,_modules_toolbar_factory_js__WEBPACK_IMPORTED_MODULE_7__/* .makeCollection */ .$K)(this.jodit, this.popup);
    }
    onClick(node) {
        const elements = this.elmsList, target = _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(node, 'img') ? node : _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.closest(node, elements, this.j.editor);
        if (target && this.canShowPopupForType(target.nodeName.toLowerCase())) {
            this.showPopup(()=>(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.position)(target, this.j), target.nodeName.toLowerCase(), target);
            return false;
        }
    }
    /**
     * Show inline popup with some toolbar
     *
     * @param type - selection, img, a etc.
     */ showPopup(rect, type, target) {
        type = type.toLowerCase();
        if (!this.canShowPopupForType(type)) {
            return false;
        }
        if (this.type !== type || target !== this.previousTarget) {
            this.previousTarget = target;
            const data = this.j.o.popup[type];
            let content;
            if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isFunction)(data)) {
                content = data(this.j, target, this.popup.close);
            } else {
                content = data;
            }
            if ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isArray)(content)) {
                this.toolbar.build(content, target);
                this.toolbar.buttonSize = this.j.o.toolbarButtonSize;
                content = this.toolbar.container;
            }
            this.popup.setContent(content);
            this.type = type;
        }
        this.popup.open(rect);
        return true;
    }
    /**
     * Hide opened popup
     */ hidePopup(type) {
        if (this.popup.isOpened && (!(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isString)(type) || type === this.type)) {
            this.popup.close();
        }
    }
    onOutsideClick() {
        this.popup.close();
    }
    /**
     * Can show popup for this type
     */ canShowPopupForType(type) {
        const data = this.j.o.popup[type.toLowerCase()];
        if (this.j.o.readonly || !this.j.o.toolbarInline || !data) {
            return false;
        }
        return !this.isExcludedTarget(type);
    }
    /**
     * For some elements do not show popup
     */ isExcludedTarget(type) {
        return (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.splitArray)(this.j.o.toolbarInlineDisableFor).map((a)=>a.toLowerCase()).includes(type.toLowerCase());
    }
    /** @override **/ afterInit(jodit) {
        this.j.e.on('getDiffButtons.mobile', (toolbar)=>{
            if (this.toolbar === toolbar) {
                const names = this.toolbar.getButtonsNames();
                return (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.toArray)(jodit.registeredButtons).filter((btn)=>!this.j.o.toolbarInlineDisabledButtons.includes(btn.name)).filter((item)=>{
                    const name = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isString)(item) ? item : item.name;
                    return name && name !== '|' && name !== '\n' && !names.includes(name);
                });
            }
        }).on('hidePopup', this.hidePopup).on('showInlineToolbar', this.showInlineToolbar).on('showPopup', (elm, rect, type)=>{
            this.showPopup(rect, type || ((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isString)(elm) ? elm : elm.nodeName), (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.isString)(elm) ? undefined : elm);
        }).on('mousedown keydown', this.onSelectionStart).on('change', ()=>{
            if (this.popup.isOpened && this.previousTarget && !this.previousTarget.parentNode) {
                this.hidePopup();
                this.previousTarget = undefined;
            }
        }).on([
            this.j.ew,
            this.j.ow
        ], 'mouseup keyup', this.onSelectionEnd);
        this.addListenersForElements();
    }
    onSelectionStart() {
        this.snapRange = this.j.s.range.cloneRange();
    }
    onSelectionEnd(e) {
        if (e && e.target && _core_ui_index_js__WEBPACK_IMPORTED_MODULE_5__/* .UIElement */ .D$.closestElement(e.target, _core_ui_popup_index_js__WEBPACK_IMPORTED_MODULE_6__/* .Popup */ .z)) {
            return;
        }
        const { snapRange } = this, { range } = this.j.s;
        if (!snapRange || range.collapsed || range.startContainer !== snapRange.startContainer || range.startOffset !== snapRange.startOffset || range.endContainer !== snapRange.endContainer || range.endOffset !== snapRange.endOffset) {
            this.onSelectionChange();
        }
    }
    /**
     * Selection change handler
     */ onSelectionChange() {
        if (!this.j.o.toolbarInlineForSelection) {
            return;
        }
        const type = 'selection';
        const sel = this.j.s.sel;
        const range = this.j.s.range;
        if ((sel === null || sel === void 0 ? void 0 : sel.isCollapsed) || this.isSelectedTarget(range)) {
            if (this.type === type && this.popup.isOpened) {
                this.hidePopup();
            }
            return;
        }
        const node = this.j.s.current();
        if (!node) {
            return;
        }
        this.showPopup(()=>range.getBoundingClientRect(), type);
    }
    /**
     * In not collapsed selection - only one image
     */ isSelectedTarget(r) {
        const sc = r.startContainer;
        return _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isElement(sc) && sc === r.endContainer && _core_dom_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Dom */ .J.isTag(sc.childNodes[r.startOffset], new Set((0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.keys)(this.j.o.popup, false))) && r.startOffset === r.endOffset - 1;
    }
    /**
     * Shortcut for Table module
     */ // private get tableModule(): Table {
    // 	return this.j.getInstance<Table>('Table', this.j.o);
    // }
    /** @override **/ beforeDestruct(jodit) {
        jodit.e.off('showPopup').off([
            this.j.ew,
            this.j.ow
        ], 'mouseup keyup', this.onSelectionEnd);
        this.removeListenersForElements();
    }
    _eventsList() {
        const el = this.elmsList;
        return el.map((e)=>(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.camelCase)(`click_${e}`)).concat(el.map((e)=>(0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.camelCase)(`touchstart_${e}`))).join(' ');
    }
    addListenersForElements() {
        this.j.e.on(this._eventsList(), this.onClick);
    }
    removeListenersForElements() {
        this.j.e.off(this._eventsList(), this.onClick);
    }
    /**
     * Show the inline WYSIWYG toolbar editor.
     */ showInlineToolbar(bound) {
        this.showPopup(()=>{
            if (bound) {
                return bound;
            }
            const { range } = this.j.s;
            return range.getBoundingClientRect();
        }, 'toolbar');
    }
    constructor(){
        super(...arguments);
        this.type = null;
        this.snapRange = null;
        this.elmsList = (0,_core_helpers_index_js__WEBPACK_IMPORTED_MODULE_3__.keys)(this.j.o.popup, false).filter((s)=>!this.isExcludedTarget(s));
    }
}
inlinePopup.requires = [
    'select'
];
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.cache
], inlinePopup.prototype, "popup", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.cache
], inlinePopup.prototype, "toolbar", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], inlinePopup.prototype, "onClick", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.wait)((ctx)=>!ctx.j.isLocked)
], inlinePopup.prototype, "showPopup", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)([
        ':clickEditor',
        ':beforeCommandDelete',
        ':backSpaceAfterDelete'
    ]),
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], inlinePopup.prototype, "hidePopup", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.watch)(':outsideClick')
], inlinePopup.prototype, "onOutsideClick", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], inlinePopup.prototype, "onSelectionStart", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], inlinePopup.prototype, "onSelectionEnd", null);
__decorate([
    (0,_core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.debounce)((ctx)=>ctx.defaultTimeout)
], inlinePopup.prototype, "onSelectionChange", null);
__decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], inlinePopup.prototype, "showInlineToolbar", null);
_core_global_js__WEBPACK_IMPORTED_MODULE_2__/* .pluginSystem */ .fg.add('inlinePopup', inlinePopup);


/***/ }),

/***/ 93602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   g: function() { return /* binding */ RecognizeManager; }
/* harmony export */ });
/* harmony import */ var _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65478);
/* harmony import */ var _core_event_emitter_eventify_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72757);
/* harmony import */ var _sound_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37643);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85567);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var RecognizeManager_1;




let RecognizeManager = RecognizeManager_1 = class RecognizeManager extends _core_event_emitter_eventify_js__WEBPACK_IMPORTED_MODULE_2__/* .Eventify */ .h {
    set lang(v) {
        this._lang = v;
        this._api.lang = v;
    }
    get lang() {
        return this._lang;
    }
    set continuous(v) {
        this._continuous = v;
        this._api.continuous = v;
    }
    get continuous() {
        return this._continuous;
    }
    set interimResults(v) {
        this._interimResults = v;
        this._api.interimResults = v;
    }
    get interimResults() {
        return this._interimResults;
    }
    destruct() {
        this.stop();
        RecognizeManager_1._instances.delete(this);
        super.destruct();
    }
    get isEnabled() {
        return this._isEnabled;
    }
    start() {
        if (this._isEnabled) {
            return;
        }
        this._isEnabled = true;
        RecognizeManager_1._instances.forEach((instance)=>{
            if (instance !== this) {
                instance.stop();
            }
        });
        try {
            this._api.start();
        } catch (e) {
            this._onError(e);
            this.stop();
            return;
        }
        this.__on('speechstart', this._onSpeechStart).__on('error', this._onError).__on('result', this._onProgress).__on('end', this._onResults);
    }
    stop() {
        if (!this._isEnabled) {
            return;
        }
        this._api.abort();
        this._api.stop();
        this.__off('speechstart', this._onSpeechStart).__off('error', this._onError).__off('result', this._onProgress).__off('end', this._onResults);
        this.async.clearTimeout(this._restartTimeout);
        this._isEnabled = false;
        this.emit('pulse', false);
    }
    toggle() {
        if (!this._isEnabled) {
            this.start();
        } else {
            this.stop();
        }
    }
    restart() {
        this.stop();
        this.start();
    }
    __on(event, callback) {
        this._api.addEventListener(event, callback);
        return this;
    }
    __off(event, callback) {
        this._api.removeEventListener(event, callback);
        return this;
    }
    _onResults(e) {
        this.emit('pulse', false);
        this.emit('result', this.__interimResults);
        this.__interimResults = '';
        this._makeSound(_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .PII */ .N);
        this.restart();
    }
    _onProgress(e) {
        if (!this._isEnabled) {
            return;
        }
        this.__interimResults = '';
        if (!e.results) {
            return;
        }
        for(let i = 0; i < e.results.length; i++){
            const resultItem = e.results.item(i);
            if (resultItem.length) {
                const { transcript } = resultItem.item(0);
                this.__interimResults += transcript;
            }
        }
        if (this.__interimResults) {
            this.emit('progress', this.__interimResults);
        }
    }
    _onError(e) {
        if (e.error === 'voice-unavailable') {
            this.emit('error', 'Voice unavailable');
        }
        if (e.error === 'not-allowed') {
            this.emit('error', 'Not allowed');
        }
        if (e.error === 'language-unavailable' || // @ts-ignore
        e.error === 'language-not-supported') {
            this.emit('error', 'Language unavailable');
        }
        this._makeSound(_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .WARN */ .Z);
        this.emit('pulse', false);
        this.stop();
    }
    _makeSound(frequency) {
        if (this.sound) {
            (0,_sound_js__WEBPACK_IMPORTED_MODULE_1__/* .sound */ .s)({
                frequency
            });
        }
    }
    constructor(async, api){
        super();
        this.async = async;
        this._continuous = false;
        this._interimResults = false;
        this.sound = true;
        this._isEnabled = false;
        this._restartTimeout = 0;
        this._onSpeechStart = (e)=>{
            if (!this._isEnabled) {
                return;
            }
            this.async.clearTimeout(this._restartTimeout);
            this._restartTimeout = this.async.setTimeout(()=>{
                this.restart();
                this.emit('pulse', false);
                this._makeSound(_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .WARN */ .Z);
            }, 5000);
            this.emit('pulse', true);
        };
        this.__interimResults = '';
        this._api = api;
        RecognizeManager_1._instances.add(this);
    }
};
RecognizeManager._instances = new Set();
RecognizeManager = RecognizeManager_1 = __decorate([
    _core_decorators_index_js__WEBPACK_IMPORTED_MODULE_0__.autobind
], RecognizeManager);



/***/ }),

/***/ 93620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    newline: 'yeni satır',
    delete: 'silmek',
    space: 'uzay',
    'Speech Recognize': 'Konuşma Tanıma',
    Sound: 'Ses',
    'Interim Results': 'Ara Sonuçlar'
});


/***/ }),

/***/ 93661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   h: function() { return /* binding */ abort; },
/* harmony export */   r: function() { return /* binding */ isAbort; }
/* harmony export */ });
/* harmony import */ var _checker_is_abort_error_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12045);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/utils
 */ 
function abort(message = 'Aborted') {
    return new DOMException(message, 'AbortError');
}
/**
 * @deprecated use `isAbortError` instead
 */ const isAbort = _checker_is_abort_error_js__WEBPACK_IMPORTED_MODULE_0__/* .isAbortError */ .z;


/***/ }),

/***/ 94122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $j: function() { return /* reexport safe */ _send_js__WEBPACK_IMPORTED_MODULE_2__.$; },
/* harmony export */   Pb: function() { return /* binding */ hasItems; },
/* harmony export */   YQ: function() { return /* binding */ hasFiles; },
/* harmony export */   _9: function() { return /* reexport safe */ _send_files_js__WEBPACK_IMPORTED_MODULE_3__._; },
/* harmony export */   dT: function() { return /* reexport safe */ _process_old_browser_drag_js__WEBPACK_IMPORTED_MODULE_1__.d; },
/* harmony export */   tN: function() { return /* reexport safe */ _send_js__WEBPACK_IMPORTED_MODULE_2__.t; }
/* harmony export */ });
/* harmony import */ var _build_data_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83987);
/* harmony import */ var _process_old_browser_drag_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50373);
/* harmony import */ var _send_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71686);
/* harmony import */ var _send_files_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80020);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 




function hasFiles(data) {
    return Boolean(data && data.files && data.files.length > 0);
}
function hasItems(data) {
    return Boolean(data && data.items && data.items.length > 0);
}


/***/ }),

/***/ 94141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    newline: 'חדשות',
    delete: 'מחק',
    space: 'שטח',
    'Speech Recognize': 'דיבור מזהה',
    Sound: 'קול',
    'Interim Results': 'תוצאות ביניים'
});


/***/ }),

/***/ 94466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   D: function() { return /* binding */ elementsEqualAttributes; },
/* harmony export */   M: function() { return /* binding */ isSameAttributes; }
/* harmony export */ });
/* harmony import */ var _helpers_size_object_size_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21496);
/* harmony import */ var _helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43555);
/* harmony import */ var _helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38837);
/* harmony import */ var _has_same_style_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22030);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 



/**
 * Compares whether the given attributes match the element's own attributes
 * @private
 */ function isSameAttributes(elm, attrs) {
    if (!elm.attributes.length && !(0,_helpers_size_object_size_js__WEBPACK_IMPORTED_MODULE_0__/* .size */ .E)(attrs)) {
        return true;
    }
    if (!(0,_helpers_size_object_size_js__WEBPACK_IMPORTED_MODULE_0__/* .size */ .E)(attrs)) {
        return true;
    }
    (0,_helpers_utils_assert_js__WEBPACK_IMPORTED_MODULE_2__/* .assert */ .v)(attrs, 'Attrs must be a non-empty object');
    return Object.keys(attrs).every((key)=>{
        if (key === 'class' || key === 'className') {
            return elm.classList.contains(attrs[key]);
        }
        if (key === 'style') {
            return (0,_has_same_style_js__WEBPACK_IMPORTED_MODULE_3__/* .hasSameStyle */ .g)(elm, attrs[key]);
        }
        return (0,_helpers_utils_index_js__WEBPACK_IMPORTED_MODULE_1__/* .attr */ .CF)(elm, key) === attrs[key];
    });
}
function elementsEqualAttributes(elm1, elm2) {
    return elm1.attributes.length === elm2.attributes.length && Array.from(elm1.attributes).every((attr)=>elm2.hasAttribute(attr.name) && elm2.getAttribute(attr.name) === attr.value);
}


/***/ }),

/***/ 94538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   r: function() { return /* binding */ stateListeners; }
/* harmony export */ });
/* harmony import */ var _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22732);
/* harmony import */ var _core_helpers_normalize_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71521);
/* harmony import */ var _core_ui_button_button_button_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10830);
/* harmony import */ var _builders_elements_map_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32118);
/* harmony import */ var _fetch_load_tree_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20201);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 




const DEFAULT_SOURCE_NAME = 'default';
/**
 * Convert state to view
 * @private
 */ function stateListeners() {
    const elmMap = (0,_builders_elements_map_js__WEBPACK_IMPORTED_MODULE_3__/* .elementsMap */ .a)(this);
    const { state, files, create, options } = this, getDomElement = (item)=>{
        const key = item.uniqueHashKey;
        if (elmMap[key]) {
            return elmMap[key].elm;
        }
        const elm = create.fromHTML(options.getThumbTemplate.call(this, item, item.source, item.sourceName.toString()));
        elm.dataset.key = key;
        elmMap[key] = {
            item,
            elm
        };
        return elmMap[key].elm;
    };
    state.on([
        'change.currentPath',
        'change.currentSource'
    ], this.async.debounce(()=>{
        if (this.o.saveStateInStorage && this.o.saveStateInStorage.storeLastOpenedFolder) {
            this.storage.set('currentPath', this.state.currentPath).set('currentSource', this.state.currentSource);
        }
        (0,_fetch_load_tree_js__WEBPACK_IMPORTED_MODULE_4__/* .loadTree */ .r)(this).catch(this.status);
    }, this.defaultTimeout)).on('beforeChange.activeElements', ()=>{
        state.activeElements.forEach((item)=>{
            const key = item.uniqueHashKey, { elm } = elmMap[key];
            elm && elm.classList.remove(files.getFullElName('item', 'active', true));
        });
    }).on('change.activeElements', ()=>{
        this.e.fire('changeSelection');
        state.activeElements.forEach((item)=>{
            const key = item.uniqueHashKey, { elm } = elmMap[key];
            elm && elm.classList.add(files.getFullElName('item', 'active', true));
        });
    }).on('change.view', ()=>{
        files.setMod('view', state.view);
        if (this.o.saveStateInStorage && this.o.saveStateInStorage.storeView) {
            this.storage.set('view', state.view);
        }
    }).on('change.sortBy', ()=>{
        if (this.o.saveStateInStorage && this.o.saveStateInStorage.storeSortBy) {
            this.storage.set('sortBy', state.sortBy);
        }
    }).on('change.elements', this.async.debounce(()=>{
        _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.detach(files.container);
        if (state.elements.length) {
            state.elements.forEach((item)=>{
                this.files.container.appendChild(getDomElement(item));
            });
        } else {
            files.container.appendChild(create.div(this.componentName + '_no-files_true', this.i18n('There are no files')));
        }
    }, this.defaultTimeout)).on('change.sources', this.async.debounce(()=>{
        _core_dom_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.detach(this.tree.container);
        state.sources.forEach((source)=>{
            const sourceName = source.name;
            if (sourceName && sourceName !== DEFAULT_SOURCE_NAME) {
                this.tree.container.appendChild(create.div(this.tree.getFullElName('source-title'), sourceName));
            }
            source.folders.forEach((name)=>{
                const folderElm = create.a(this.tree.getFullElName('item'), {
                    draggable: 'draggable',
                    href: '#',
                    'data-path': (0,_core_helpers_normalize_index_js__WEBPACK_IMPORTED_MODULE_1__/* .normalizePath */ .Fd)(source.path, name + '/'),
                    'data-name': name,
                    'data-source': sourceName,
                    'data-source-path': source.path
                }, create.span(this.tree.getFullElName('item-title'), name));
                const action = (actionName)=>(e)=>{
                        this.e.fire(`${actionName}.filebrowser`, {
                            name,
                            path: (0,_core_helpers_normalize_index_js__WEBPACK_IMPORTED_MODULE_1__/* .normalizePath */ .Fd)(source.path + '/'),
                            source: sourceName
                        });
                        e.stopPropagation();
                        e.preventDefault();
                    };
                this.e.on(folderElm, 'click', action('openFolder'));
                this.tree.container.appendChild(folderElm);
                if (name === '..' || name === '.') {
                    return;
                }
                if (options.renameFolder && this.dataProvider.canI('FolderRename')) {
                    const btn = (0,_core_ui_button_button_button_js__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .$n)(this, {
                        icon: {
                            name: 'pencil'
                        },
                        name: 'rename',
                        tooltip: 'Rename',
                        size: 'tiny'
                    });
                    btn.onAction(action('renameFolder'));
                    folderElm.appendChild(btn.container);
                }
                if (options.deleteFolder && this.dataProvider.canI('FolderRemove')) {
                    const btn = (0,_core_ui_button_button_button_js__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .$n)(this, {
                        icon: {
                            name: 'cancel'
                        },
                        name: 'remove',
                        tooltip: 'Delete',
                        size: 'tiny'
                    });
                    btn.onAction(action('removeFolder'));
                    folderElm.appendChild(btn.container);
                }
            });
            if (options.createNewFolder && this.dataProvider.canI('FolderCreate')) {
                const button = (0,_core_ui_button_button_button_js__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .$n)(this, 'plus', 'Add folder', 'secondary');
                button.onAction(()=>{
                    this.e.fire('addFolder', {
                        path: (0,_core_helpers_normalize_index_js__WEBPACK_IMPORTED_MODULE_1__/* .normalizePath */ .Fd)(source.path + '/'),
                        source: sourceName
                    });
                });
                this.tree.append(button);
            }
        });
    }, this.defaultTimeout));
}


/***/ }),

/***/ 94575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   U: function() { return /* binding */ readValuesFromImage; }
/* harmony export */ });
/* harmony import */ var _core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29960);
/* harmony import */ var _align_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51642);
/* harmony import */ var _link_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75595);
/* harmony import */ var _margin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47749);
/* harmony import */ var _size_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32566);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 




/**
 * Read values from image and set it to state
 * @private
 */ async function readValuesFromImage(j, state) {
    const { sourceImage: image, values } = state;
    (0,_align_js__WEBPACK_IMPORTED_MODULE_3__/* .readAlign */ .g)(image, values);
    // Border radius
    values.borderRadius = parseInt(image.style.borderRadius || '0', 10) || 0;
    // Id
    values.id = (0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__/* .attr */ .C)(image, 'id') || '';
    // Title
    values.imageTitle = (0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__/* .attr */ .C)(image, 'title') || '';
    // Alt
    values.imageAlt = (0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__/* .attr */ .C)(image, 'alt') || '';
    // Style
    values.style = (0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__/* .attr */ .C)(image, 'style') || '';
    // Classes
    values.classes = ((0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__/* .attr */ .C)(image, 'class') || '').replace(/jodit_focused_image[\s]*/, '');
    // Margins
    (0,_margin_js__WEBPACK_IMPORTED_MODULE_4__/* .readMargins */ .E)(image, values, state);
    // Link
    (0,_link_js__WEBPACK_IMPORTED_MODULE_1__/* .readLink */ .X)(state, j, values);
    // Src
    values.imageSrc = (0,_core_helpers_utils_attr_js__WEBPACK_IMPORTED_MODULE_0__/* .attr */ .C)(image, 'src') || '';
    // Image size
    return (0,_size_js__WEBPACK_IMPORTED_MODULE_2__/* .readSizes */ .P)(image, values, state);
}


/***/ }),

/***/ 94643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   J: function() { return /* binding */ get; }
/* harmony export */ });
/* harmony import */ var _checker_is_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70799);
/* harmony import */ var _checker_is_void_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86068);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/**
 * Safe access in tree object
 *
 * @example
 * ```js
 * const obj = {
 *   a: {
 *     b: {
 *       c: {
 *         e: false
 *       }
 *     }
 *   }
 * };
 *
 * console.log(Jodit.modules.Helpers.get('a.b.c.d.e', obj) === false); // true
 * console.log(Jodit.modules.Helpers.get('a.b.a.d.e', obj) === null); // false
 * ```
 */ function get(chain, obj) {
    if (!(0,_checker_is_string_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .K)(chain) || !chain.length) {
        return null;
    }
    const parts = chain.split('.');
    let result = obj;
    try {
        for (const part of parts){
            if ((0,_checker_is_void_js__WEBPACK_IMPORTED_MODULE_1__/* .isVoid */ .R)(result[part])) {
                return null;
            }
            result = result[part];
        }
    } catch (_a) {
        return null; // permission denied ore another access exception
    }
    if ((0,_checker_is_void_js__WEBPACK_IMPORTED_MODULE_1__/* .isVoid */ .R)(result)) {
        return null;
    }
    return result;
}


/***/ }),

/***/ 94775:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M24.89,6.61H22.31V4.47A2.47,2.47,0,0,0,19.84,2H6.78A2.47,2.47,0,0,0,4.31,4.47V22.92a2.47,2.47,0,0,0,2.47,2.47H9.69V27.2a2.8,2.8,0,0,0,2.8,2.8h12.4a2.8,2.8,0,0,0,2.8-2.8V9.41A2.8,2.8,0,0,0,24.89,6.61ZM6.78,23.52a.61.61,0,0,1-.61-.6V4.47a.61.61,0,0,1,.61-.6H19.84a.61.61,0,0,1,.61.6V6.61h-8a2.8,2.8,0,0,0-2.8,2.8V23.52Zm19,3.68a.94.94,0,0,1-.94.93H12.49a.94.94,0,0,1-.94-.93V9.41a.94.94,0,0,1,.94-.93h12.4a.94.94,0,0,1,.94.93Z\"/> <path d=\"M23.49,13.53h-9.6a.94.94,0,1,0,0,1.87h9.6a.94.94,0,1,0,0-1.87Z\"/> <path d=\"M23.49,17.37h-9.6a.94.94,0,1,0,0,1.87h9.6a.94.94,0,1,0,0-1.87Z\"/> <path d=\"M23.49,21.22h-9.6a.93.93,0,1,0,0,1.86h9.6a.93.93,0,1,0,0-1.86Z\"/> </svg> ");


/***/ }),

/***/ 94870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   z: function() { return /* binding */ removeExtraBr; }
/* harmony export */ });
/* harmony import */ var _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
const brBoxes = new Set([
    'table',
    'pre',
    'blockquote',
    'code'
]);
/**
 * Checks if there is a tag in the block element after the inserted br node,
 * if so, removes it
 * @internal
 */ function removeExtraBr(jodit, node) {
    if (!jodit.o.dtd.removeExtraBr || _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(node, 'br')) {
        return;
    }
    const parent = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.furthest(node, _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isBlock, jodit.editor);
    if (parent && !_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(parent, brBoxes)) {
        const br = _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(node, 'br') ? node : _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.findNotEmptySibling(node, false);
        if (!_core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(br, 'br')) {
            return;
        }
        jodit.s.setCursorBefore(br);
        _core_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.safeRemove(br);
    }
}


/***/ }),

/***/ 95942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B: function() { return /* binding */ markDeprecated; },
/* harmony export */   f: function() { return /* binding */ cns; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/utils
 */ /**
 * By default, terser will remove all `console.*` but
 * if you use this object it will not be
 */ const cns = console;
/**
 * Mark function as deprecated
 */ function markDeprecated(method, names = [
    ''
], ctx = null) {
    return (...args)=>{
        cns.warn(`Method "${names[0]}" deprecated.` + (names[1] ? ` Use "${names[1]}" instead` : ''));
        return method.call(ctx, ...args);
    };
}


/***/ }),

/***/ 96111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export formatBlock */
/* harmony import */ var _core_global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(580);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24630);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/**
 * Process command - `formatblock`
 */ function formatBlock(editor) {
    editor.registerButton({
        name: 'paragraph',
        group: 'font'
    });
    editor.registerCommand('formatblock', (command, second, third)=>{
        editor.s.commitStyle({
            element: third
        });
        editor.synchronizeValues();
        return false;
    });
}
_core_global_js__WEBPACK_IMPORTED_MODULE_0__/* .pluginSystem */ .fg.add('formatBlock', formatBlock);


/***/ }),

/***/ 96257:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 48 48\"> <path d=\"M6 42h4v-4h-4v4zm4-28h-4v4h4v-4zm-4 20h4v-4h-4v4zm8 8h4v-4h-4v4zm-4-36h-4v4h4v-4zm8 0h-4v4h4v-4zm16 0h-4v4h4v-4zm-8 8h-4v4h4v-4zm0-8h-4v4h4v-4zm12 28h4v-4h-4v4zm-16 8h4v-4h-4v4zm-16-16h36v-4h-36v4zm32-20v4h4v-4h-4zm0 12h4v-4h-4v4zm-16 16h4v-4h-4v4zm8 8h4v-4h-4v4zm8 0h4v-4h-4v4z\"/> <path d=\"M0 0h48v48h-48z\" fill=\"none\"/> </svg> ");


/***/ }),

/***/ 96325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   e: function() { return /* binding */ defaultLanguage; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _checker_is_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70799);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/utils
 */ 

/**
 * Try define user language
 */ const defaultLanguage = (language, defaultLanguage = 'en')=>{
    if (language !== 'auto' && (0,_checker_is_string_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .K)(language)) {
        return language;
    }
    if (_constants_js__WEBPACK_IMPORTED_MODULE_0__.globalDocument.documentElement && _constants_js__WEBPACK_IMPORTED_MODULE_0__.globalDocument.documentElement.lang) {
        return _constants_js__WEBPACK_IMPORTED_MODULE_0__.globalDocument.documentElement.lang;
    }
    if (navigator.language) {
        return navigator.language.substring(0, 2);
    }
    return defaultLanguage;
};


/***/ }),

/***/ 96457:
/***/ (function(__unused_webpack_module, __webpack_exports__) {


/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'copy-format': 'salin format'
});


/***/ }),

/***/ 96545:
/***/ (function(__unused_webpack_module, __webpack_exports__) {


/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'copy-format': 'copyformat'
});


/***/ }),

/***/ 96958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   z: function() { return /* binding */ convertToList; }
/* harmony export */ });
/* unused harmony export removeRedundancyStyle */
/* harmony import */ var jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78547);
/* harmony import */ var jodit_pro_plugins_paste_from_word_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31117);
/* harmony import */ var jodit_pro_plugins_paste_from_word_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46788);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */




function convertToList(elm) {
    if ((0,jodit_pro_plugins_paste_from_word_element__WEBPACK_IMPORTED_MODULE_2__/* .isPseudoLeaf */ .hJ)(elm)) {
        elm.name = 'li';
        elm.style.set('text-indent', null);
        const symbol = getSymbol(elm), listType = /[\da-np-zA-NP-Z].?/.test(symbol) ? 'ol' : 'ul', listStyle = defineOrderedListStyle(symbol, listType);
        elm.attributes[jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .TYPE_KEY */ .lA] = listType;
        elm.attributes[jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .STYLE_KEY */ .yL] = listStyle;
        (0,jodit_pro_plugins_paste_from_word_helpers__WEBPACK_IMPORTED_MODULE_3__/* .calcListLevels */ .lT)(elm);
        moveUp(elm);
        const { parent } = elm;
        // After move up we inside List or Leaf
        if (!(0,jodit_pro_plugins_paste_from_word_element__WEBPACK_IMPORTED_MODULE_2__/* .isList */ .Lv)(parent) || !(0,jodit_pro_plugins_paste_from_word_element__WEBPACK_IMPORTED_MODULE_2__/* .isSameType */ .LE)(elm, parent)) {
            const newList = wrapInNewList(elm, listType, symbol, listStyle);
            if ((0,jodit_pro_plugins_paste_from_word_element__WEBPACK_IMPORTED_MODULE_2__/* .isList */ .Lv)(parent)) {
                newList.remove(); // Not to add to oneself
                parent.lastElement?.append(newList);
            }
            return elm;
        }
    }
    return elm;
}
function moveUp(leaf) {
    while (leaf) {
        const prev = leaf.previousElement;
        // Leaf after P
        if (!((0,jodit_pro_plugins_paste_from_word_element__WEBPACK_IMPORTED_MODULE_2__/* .isLeaf */ .xe)(prev) || (0,jodit_pro_plugins_paste_from_word_element__WEBPACK_IMPORTED_MODULE_2__/* .isList */ .Lv)(prev))) {
            break;
        }
        // Leaf after Leaf
        if ((0,jodit_pro_plugins_paste_from_word_element__WEBPACK_IMPORTED_MODULE_2__/* .isLeaf */ .xe)(prev)) {
            if (leaf.attributes[jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .LEVEL_KEY */ .fB] < prev.attributes[jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .LEVEL_KEY */ .fB]) {
                break;
            }
            // Leaf after leaf with same level and inside the right list
            if (leaf.attributes[jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .LEVEL_KEY */ .fB] === prev.attributes[jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .LEVEL_KEY */ .fB] &&
                leaf.parent &&
                (0,jodit_pro_plugins_paste_from_word_element__WEBPACK_IMPORTED_MODULE_2__/* .isSameType */ .LE)(leaf, leaf.parent)) {
                break;
            }
            prev.append(leaf);
            continue;
        }
        const list = prev;
        // Leaf after list with more level
        if (leaf.attributes[jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .LEVEL_KEY */ .fB] < list.attributes[jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .LEVEL_KEY */ .fB]) {
            break;
        }
        if (leaf.attributes[jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .LEVEL_KEY */ .fB] === list.attributes[jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .LEVEL_KEY */ .fB] &&
            !(0,jodit_pro_plugins_paste_from_word_element__WEBPACK_IMPORTED_MODULE_2__/* .isSameType */ .LE)(leaf, list)) {
            break;
        }
        list.append(leaf);
    }
}
/**
 * Remove redundancy default list styles.
 */
function removeRedundancyStyle(newList) {
    if ((0,jodit_pro_plugins_paste_from_word_element__WEBPACK_IMPORTED_MODULE_2__/* .isList */ .Lv)(newList) &&
        newList.parent?.name !== 'li' &&
        (newList.style.get(jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .STYLE_CSS_KEY */ .Gb) === 'disc' ||
            newList.style.get(jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .STYLE_CSS_KEY */ .Gb) === 'decimal')) {
        newList.style.set(jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .STYLE_CSS_KEY */ .Gb, null);
    }
}
function defineOrderedListStyle(symbol, listType) {
    for (const reg in jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .listStyleMap */ .wD) {
        if (RegExp(reg).test(symbol)) {
            return jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .listStyleMap */ .wD[reg];
        }
    }
    return listType === 'ol' ? 'decimal' : 'disc';
}
const getSymbol = (elm) => elm
    .textBetween((n) => n.isComment && /\[if.*supportLists.*]/.test((0,jodit_pro_plugins_paste_from_word_element__WEBPACK_IMPORTED_MODULE_2__/* .html */ .qy)(n)), (n) => n.isComment && /\[endif]/.test((0,jodit_pro_plugins_paste_from_word_element__WEBPACK_IMPORTED_MODULE_2__/* .html */ .qy)(n)))
    .replace(/&nbsp;/g, '')
    .replace((0,jodit_esm_core_constants__WEBPACK_IMPORTED_MODULE_0__.SPACE_REG_EXP)(), '');
function wrapInNewList(elm, listType, symbol, listStyle) {
    const newList = elm.wrap(listType);
    newList.attributes['start'] = (0,jodit_pro_plugins_paste_from_word_helpers__WEBPACK_IMPORTED_MODULE_3__/* .calcStartBySymbol */ .jh)(symbol);
    newList.attributes[jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .LEVEL_KEY */ .fB] = elm.attributes[jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .LEVEL_KEY */ .fB];
    newList.attributes[jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .STYLE_KEY */ .yL] = elm.attributes[jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .STYLE_KEY */ .yL];
    newList.attributes[jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .STYLE_VALID_KEY */ .pz] = elm.attributes[jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .STYLE_KEY */ .yL];
    newList.style.set(jodit_pro_plugins_paste_from_word_constants__WEBPACK_IMPORTED_MODULE_1__/* .STYLE_CSS_KEY */ .Gb, listStyle);
    removeRedundancyStyle(newList);
    return newList;
}


/***/ }),

/***/ 96967:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.wrapNodes = {
    exclude: new Set([
        'hr',
        'style',
        'br'
    ]),
    emptyBlockAfterInit: true
};


/***/ }),

/***/ 97357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ hook; }
/* harmony export */ });
/* harmony import */ var _helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23282);
/* harmony import */ var _helpers_utils_error_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89890);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 

/**
 * Call on some component status
 */ function hook(status) {
    return (target, propertyKey)=>{
        if (!(0,_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_1__/* .isFunction */ .T)(target[propertyKey])) {
            throw (0,_helpers_utils_error_index_js__WEBPACK_IMPORTED_MODULE_0__/* .error */ .z3)('Handler must be a Function');
        }
        target.hookStatus(status, (component)=>{
            component[propertyKey].call(component);
        });
    };
}


/***/ }),

/***/ 97379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Q: function() { return /* binding */ FileBrowserFiles; }
/* harmony export */ });
/* harmony import */ var _core_ui_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67510);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
class FileBrowserFiles extends _core_ui_index_js__WEBPACK_IMPORTED_MODULE_0__/* .UIGroup */ .Ue {
    className() {
        return 'FileBrowserFiles';
    }
}


/***/ }),

/***/ 97380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $s: function() { return /* binding */ suitableClosest; },
/* harmony export */   Wv: function() { return /* binding */ isSameStyleChild; },
/* harmony export */   sz: function() { return /* binding */ isSuitElement; }
/* harmony export */ });
/* harmony import */ var _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2748);
/* harmony import */ var _has_same_style_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22030);
/* harmony import */ var _is_normal_node_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29136);



/**
 * Checks if an item is suitable for applying a commit. The element suits us if it
 *  - has the same styles as in the commit (commitStyle.options.style)
 *  - has the same tag as in the commit (commitStyle.options.element)
 *
 * @param commitStyle - style commit
 * @param elm - checked item
 * @param strict - strict mode - false - the default tag is suitable for us if it is also in the commit
 * @param strictStyle - strict style mode - true - the element has the same style keys as in the commit, but not their values
 * @private
 */ function isSuitElement(commitStyle, elm, strict, strictStyle = true) {
    var _a;
    if (!elm || !(0,_is_normal_node_js__WEBPACK_IMPORTED_MODULE_2__/* .isNormalNode */ ._)(elm)) {
        return false;
    }
    const { element, elementIsDefault, options } = commitStyle;
    if (_dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isList(elm) && commitStyle.elementIsList) {
        return true;
    }
    const elmIsSame = _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isTag(elm, element);
    if (elmIsSame && !(elementIsDefault && strict)) {
        return true;
    }
    const elmHasSameStyle = Boolean(((_a = options.attributes) === null || _a === void 0 ? void 0 : _a.style) && (strictStyle ? (0,_has_same_style_js__WEBPACK_IMPORTED_MODULE_1__/* .hasSameStyle */ .g)(elm, options.attributes.style) : (0,_has_same_style_js__WEBPACK_IMPORTED_MODULE_1__/* .hasSameStyleKeys */ .Y)(elm, options.attributes.style)));
    if (elmHasSameStyle && !commitStyle.elementIsList) {
        return true;
    }
    return !elmIsSame && !strict && elementIsDefault && _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.isInlineBlock(elm);
}
/**
 * @private
 */ function suitableClosest(commitStyle, element, root) {
    return _dom_dom_js__WEBPACK_IMPORTED_MODULE_0__/* .Dom */ .J.closest(element, (node)=>isSuitElement(commitStyle, node, true, false), root);
}
/**
 * Inside the parent element there is a block with the same styles
 * @example
 * For selection:
 * ```html
 * <p>|test<strong>test</strong>|</p>
 * ```
 * Apply `{element:'strong'}`
 * @private
 */ function isSameStyleChild(commitStyle, elm) {
    var _a, _b;
    const { element, options } = commitStyle;
    if (!elm || !(0,_is_normal_node_js__WEBPACK_IMPORTED_MODULE_2__/* .isNormalNode */ ._)(elm)) {
        return false;
    }
    const elmIsSame = elm.nodeName.toLowerCase() === element;
    const elmHasSameStyle = Boolean(((_a = options.attributes) === null || _a === void 0 ? void 0 : _a.style) && (0,_has_same_style_js__WEBPACK_IMPORTED_MODULE_1__/* .hasSameStyleKeys */ .Y)(elm, (_b = options.attributes) === null || _b === void 0 ? void 0 : _b.style));
    return elmIsSame && elmHasSameStyle;
}


/***/ }),

/***/ 97519:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'Type something': '무엇이든 입력하세요',
    'About Jodit': 'Jodit에 대하여',
    'Jodit Editor': 'Jodit Editor',
    "Jodit User's Guide": 'Jodit 사용자 안내서',
    'contains detailed help for using': '자세한 도움말이 들어있어요',
    'For information about the license, please go to our website:': '라이센스에 관해서는 Jodit 웹 사이트를 방문해주세요：',
    'Buy full version': '풀 버전 구입하기',
    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.': '© XDSoft.net - Chupurnov Valeriy. 에게 저작권과 모든 권리가 있습니다.',
    Anchor: 'Anchor',
    'Open in new tab': '새 탭에서 열기',
    'Open in fullsize': '전체 크기로 보기',
    'Clear Formatting': '서식 지우기',
    'Fill color or set the text color': '글씨 색상',
    Redo: '재실행',
    Undo: '실행 취소',
    Bold: '굵게',
    Italic: '기울임',
    'Insert Unordered List': '글머리 목록',
    'Insert Ordered List': '번호 목록',
    'Align Center': '가운데 정렬',
    'Align Justify': '양쪽 정렬',
    'Align Left': '왼쪽 정렬',
    'Align Right': '오른쪽 정렬',
    'Insert Horizontal Line': '수평 구분선 넣기',
    'Insert Image': '이미지 넣기',
    'Insert file': '파일 넣기',
    'Insert youtube/vimeo video': 'Youtube/Vimeo 동영상',
    'Insert link': '링크 넣기',
    'Font size': '글꼴 크기',
    'Font family': '글꼴',
    'Insert format block': '블록 요소 넣기',
    Normal: '일반 텍스트',
    'Heading 1': '제목 1',
    'Heading 2': '제목 2',
    'Heading 3': '제목 3',
    'Heading 4': '제목 4',
    Quote: '인용',
    Code: '코드',
    Insert: '붙여 넣기',
    'Insert table': '테이블',
    'Decrease Indent': '들여쓰기 감소',
    'Increase Indent': '들여쓰기 증가',
    'Select Special Character': '특수문자 선택',
    'Insert Special Character': '특수문자 입력',
    'Paint format': '페인트 형식',
    'Change mode': '편집모드 변경',
    Margins: '마진',
    top: '위',
    right: '오른쪽',
    bottom: '아래',
    left: '왼쪽',
    Styles: '스타일',
    Classes: '클래스',
    Align: '정렬',
    Right: '오른쪽으로',
    Center: '가운데로',
    Left: '왼쪽으로',
    '--Not Set--': '--지정 안 함--',
    Src: '경로(src)',
    Title: '제목',
    Alternative: '대체 텍스트(alt)',
    Link: '링크',
    'Open link in new tab': '새 탭에서 열기',
    file: '파일',
    Advanced: '고급',
    'Image properties': '이미지 속성',
    Cancel: '취소',
    Ok: '확인',
    'Your code is similar to HTML. Keep as HTML?': 'HTML 코드로 감지했어요. 코드인채로 붙여넣을까요?',
    'Paste as HTML': 'HTML로 붙여넣기',
    Keep: '원본 유지',
    Clean: '지우기',
    'Insert as Text': '텍스트로 넣기',
    'Insert only Text': '텍스트만 넣기',
    'Word Paste Detected': 'Word 붙여넣기 감지',
    'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?': 'Microsoft Word/Excel 문서로 감지했어요. 서식을 유지한채로 붙여넣을까요?',
    'File Browser': '파일 탐색기',
    'Error on load list': '목록 불러오기 에러',
    'Error on load folders': '폴더 불러오기',
    'Are you sure?': '정말 진행할까요?',
    'Enter Directory name': '디렉토리 이름 입력',
    'Create directory': '디렉토리 생성',
    'type name': '이름 입력',
    'Drop image': '이미지 드래그',
    'Drop file': '파일 드래그',
    'or click': '혹은 클릭',
    'Alternative text': '대체 텍스트',
    Browse: '탐색',
    Upload: '업로드',
    Background: '배경',
    Text: '텍스트',
    Top: '위',
    Middle: '중앙',
    Bottom: '아래',
    'Insert column before': '이전 열에 삽입',
    'Insert column after': '다음 열에 삽입',
    'Insert row above': '위 행에 삽입',
    'Insert row below': '아래 행에 삽입',
    'Delete table': '테이블 삭제',
    'Delete row': '행 삭제',
    'Delete column': '열 삭제',
    'Empty cell': '빈 셀',
    source: 'HTML 소스',
    bold: '볼드',
    italic: '이탤릭',
    brush: '브러시',
    link: '링크',
    undo: '실행 취소',
    redo: '재실행',
    table: '테이블',
    image: '이미지',
    eraser: '지우개',
    paragraph: '문단',
    fontsize: '글꼴 크기',
    video: '비디오',
    font: '글꼴',
    about: '편집기 정보',
    print: '프린트',
    underline: '밑줄',
    strikethrough: '취소선',
    indent: '들여쓰기',
    outdent: '내어쓰기',
    fullsize: '전체 화면',
    shrink: '일반 화면',
    hr: '구분선',
    ul: '글머리 목록',
    ol: '번호 목록',
    cut: '잘라내기',
    selectall: '모두 선택',
    'Embed code': 'Embed 코드',
    'Open link': '링크 열기',
    'Edit link': '링크 편집',
    'No follow': 'No follow',
    Unlink: '링크 제거',
    Eye: '사이트 확인',
    pencil: '연필',
    Update: '갱신',
    ' URL': 'URL',
    Edit: '편집',
    'Horizontal align': '수평 정렬',
    Filter: '필터',
    'Sort by changed': '변경일 정렬',
    'Sort by name': '이름 정렬',
    'Sort by size': '크기 정렬',
    'Add folder': '새 폴더',
    Reset: '초기화',
    Save: '저장',
    'Save as ...': '새로 저장하기 ...',
    Resize: '리사이즈',
    Crop: '크롭',
    Width: '가로 길이',
    Height: '세로 높이',
    'Keep Aspect Ratio': '비율 유지하기',
    Yes: '네',
    No: '아니오',
    Remove: '제거',
    Select: '선택',
    'Chars: %d': '문자수: %d',
    'Words: %d': '단어수: %d',
    All: '모두',
    'Select all': '모두 선택',
    'Select %s': '선택: %s',
    'Vertical align': '수직 정렬',
    Split: '분할',
    'Split vertical': '세로 셀 분할',
    'Split horizontal': '가로 셀 분할',
    Merge: '셀 병합',
    'Add column': '열 추가',
    'Add row': '행 추가',
    Delete: '삭제',
    Border: '외곽선',
    'License: %s': '라이센스: %s',
    'Strike through': '취소선',
    Underline: '밑줄',
    superscript: '윗첨자',
    subscript: '아래첨자',
    'Cut selection': '선택 잘라내기',
    Break: '구분자',
    'Search for': '검색',
    'Replace with': '대체하기',
    Replace: '대체',
    Paste: '붙여넣기',
    'Choose Content to Paste': '붙여넣을 내용 선택',
    'You can only edit your own images. Download this image on the host?': '외부 이미지는 편집할 수 없어요. 외부 이미지를 다운로드 할까요?',
    'The image has been successfully uploaded to the host!': '이미지를 무사히 업로드 했어요!',
    palette: '팔레트',
    'There are no files': '파일이 없어요',
    Rename: '이름 변경',
    'Enter new name': '새 이름 입력',
    preview: '미리보기',
    download: '다운로드',
    'Paste from clipboard': '클립보드 붙여넣기',
    "Your browser doesn't support direct access to the clipboard.": '사용중인 브라우저가 클립보드 접근을 지원하지 않아요.',
    'Copy selection': '선택 복사',
    copy: '복사',
    'Border radius': '둥근 테두리',
    'Show all': '모두 보기',
    Apply: '적용',
    'Please fill out this field': '이 항목을 입력해주세요!',
    'Please enter a web address': '웹 URL을 입력해주세요.',
    Default: '기본',
    Circle: '원',
    Dot: '점',
    Quadrate: '정사각형',
    Find: '찾기',
    'Find Previous': '이전 찾기',
    'Find Next': '다음 찾기',
    'Insert className': 'className 입력',
    'Press Alt for custom resizing': '사용자 지정 크기 조정에 대 한 고도 누르십시오'
});


/***/ }),

/***/ 97536:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.image = {
    dialogWidth: 600,
    openOnDblClick: true,
    editSrc: true,
    useImageEditor: true,
    editTitle: true,
    editAlt: true,
    editLink: true,
    editSize: true,
    editBorderRadius: true,
    editMargins: true,
    editClass: true,
    availableClasses: [],
    editStyle: true,
    editId: true,
    editAlign: true,
    showPreview: true,
    selectImageAfterClose: true
};


/***/ }),

/***/ 97639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   T: function() { return /* binding */ browser; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/utils
 */ /**
 * Module returns method that is used to determine the browser
 * @example
 * ```javascript
 * console.log(Jodit.modules.Helpers.browser('mse'));
 * console.log(Jodit.modules.Helpers.browser('chrome'));
 * console.log($Jodit.modules.Helpers.browser('opera'));
 * console.log(Jodit.modules.Helpers.browser('firefox'));
 * console.log(Jodit.modules.Helpers.browser('mse') && Jodit.modules.Helpers.browser('version') > 10);
 * ```
 */ const browser = (browser)=>{
    const ua = navigator.userAgent.toLowerCase(), match = /(firefox)[\s/]([\w.]+)/.exec(ua) || /(chrome)[\s/]([\w.]+)/.exec(ua) || /(webkit)[\s/]([\w.]+)/.exec(ua) || /(opera)(?:.*version)[\s/]([\w.]+)/.exec(ua) || /(msie)[\s]([\w.]+)/.exec(ua) || /(trident)\/([\w.]+)/.exec(ua) || ua.indexOf('compatible') < 0 || [];
    if (browser === 'version') {
        return match[2];
    }
    if (browser === 'webkit') {
        return match[1] === 'chrome' || match[1] === 'webkit';
    }
    if (browser === 'ff') {
        return match[1] === 'firefox';
    }
    if (browser === 'msie') {
        return match[1] === 'trident' || match[1] === 'msie';
    }
    return match[1] === browser;
};


/***/ }),

/***/ 97735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Hp: function() { return /* binding */ markAsAtomic; },
/* harmony export */   mA: function() { return /* binding */ isAtom; },
/* harmony export */   y6: function() { return /* binding */ fastClone; }
/* harmony export */ });
/* harmony import */ var _string_stringify_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67462);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module helpers/utils
 */ 
function isAtom(obj) {
    return obj && obj.isAtom;
}
function markAsAtomic(obj) {
    Object.defineProperty(obj, 'isAtom', {
        enumerable: false,
        value: true,
        configurable: false
    });
    return obj;
}
function fastClone(object) {
    return JSON.parse((0,_string_stringify_js__WEBPACK_IMPORTED_MODULE_0__/* .stringify */ .A)(object));
}


/***/ }),

/***/ 98019:
/***/ (function(__unused_webpack_module, __webpack_exports__) {


/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__.A = ({
    'copy-format': 'Formátum másolás'
});


/***/ }),

/***/ 98220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   b: function() { return /* binding */ EventEmitter; }
/* harmony export */ });
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _helpers_array_split_array_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46559);
/* harmony import */ var _helpers_checker_is_array_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68345);
/* harmony import */ var _helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23282);
/* harmony import */ var _helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70799);
/* harmony import */ var _helpers_utils_error_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89890);
/* harmony import */ var _store_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15738);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 






/**
 * The module editor's event manager
 */ class EventEmitter {
    mute(event) {
        this.__mutedEvents.add(event !== null && event !== void 0 ? event : '*');
        return this;
    }
    isMuted(event) {
        if (event && this.__mutedEvents.has(event)) {
            return true;
        }
        return this.__mutedEvents.has('*');
    }
    unmute(event) {
        this.__mutedEvents.delete(event !== null && event !== void 0 ? event : '*');
        return this;
    }
    __eachEvent(events, callback) {
        const eventParts = (0,_helpers_array_split_array_js__WEBPACK_IMPORTED_MODULE_3__/* .splitArray */ .u)(events).map((e)=>e.trim());
        eventParts.forEach((eventNameSpace)=>{
            const eventAndNameSpace = eventNameSpace.split('.');
            const namespace = eventAndNameSpace[1] || _store_js__WEBPACK_IMPORTED_MODULE_2__/* .defaultNameSpace */ .X;
            callback.call(this, eventAndNameSpace[0], namespace);
        });
    }
    __getStore(subject) {
        if (!subject) {
            throw (0,_helpers_utils_error_index_js__WEBPACK_IMPORTED_MODULE_1__/* .error */ .z3)('Need subject');
        }
        if (subject[this.__key] === undefined) {
            const store = new _store_js__WEBPACK_IMPORTED_MODULE_2__/* .EventHandlersStore */ .d();
            Object.defineProperty(subject, this.__key, {
                enumerable: false,
                configurable: true,
                writable: true,
                value: store
            });
        }
        return subject[this.__key];
    }
    __removeStoreFromSubject(subject) {
        if (subject[this.__key] !== undefined) {
            Object.defineProperty(subject, this.__key, {
                enumerable: false,
                configurable: true,
                writable: true,
                value: undefined
            });
        }
    }
    __triggerNativeEvent(element, event) {
        const evt = this.__doc.createEvent('HTMLEvents');
        if ((0,_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__/* .isString */ .K)(event)) {
            evt.initEvent(event, true, true);
        } else {
            evt.initEvent(event.type, event.bubbles, event.cancelable);
            [
                'screenX',
                'screenY',
                'clientX',
                'clientY',
                'target',
                'srcElement',
                'currentTarget',
                'timeStamp',
                'which',
                'keyCode'
            ].forEach((property)=>{
                Object.defineProperty(evt, property, {
                    value: event[property],
                    enumerable: true
                });
            });
            Object.defineProperty(evt, 'originalEvent', {
                value: event,
                enumerable: true
            });
        }
        element.dispatchEvent(evt);
    }
    /**
     * Get current event name
     *
     * @example
     * ```javascript
     * parent.e.on('openDialog closeDialog', function () {
     *     if (parent.e.current === 'closeDialog') {
     *         alert('Dialog was closed');
     *     } else {
     *         alert('Dialog was opened');
     *     }
     * });
     * ```
     */ get current() {
        return this.currents[this.currents.length - 1];
    }
    on(eventsOrSubjects, callbackOrEvents, optionsOrCallback, opts) {
        let subjects;
        let events;
        let callback;
        let options;
        if ((0,_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__/* .isString */ .K)(eventsOrSubjects) || (0,_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__/* .isStringArray */ .B)(eventsOrSubjects)) {
            subjects = this;
            events = eventsOrSubjects;
            callback = callbackOrEvents;
            options = optionsOrCallback;
        } else {
            subjects = eventsOrSubjects;
            events = callbackOrEvents;
            callback = optionsOrCallback;
            options = opts;
        }
        if (!((0,_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__/* .isString */ .K)(events) || (0,_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__/* .isStringArray */ .B)(events)) || events.length === 0) {
            throw (0,_helpers_utils_error_index_js__WEBPACK_IMPORTED_MODULE_1__/* .error */ .z3)('Need events names');
        }
        if (!(0,_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_5__/* .isFunction */ .T)(callback)) {
            throw (0,_helpers_utils_error_index_js__WEBPACK_IMPORTED_MODULE_1__/* .error */ .z3)('Need event handler');
        }
        if ((0,_helpers_checker_is_array_js__WEBPACK_IMPORTED_MODULE_6__/* .isArray */ .c)(subjects)) {
            subjects.forEach((subj)=>{
                this.on(subj, events, callback, options);
            });
            return this;
        }
        const subject = subjects;
        const store = this.__getStore(subject);
        const self = this;
        let syntheticCallback = function(event, ...args) {
            if (self.isMuted(event)) {
                return;
            }
            return callback && callback.call(this, ...args);
        };
        if (isDOMElement(subject)) {
            syntheticCallback = function(event) {
                if (self.isMuted(event.type)) {
                    return;
                }
                self.__prepareEvent(event);
                if (callback && callback.call(this, event) === false) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    return false;
                }
                return;
            };
        }
        this.__eachEvent(events, (event, namespace)=>{
            var _a, _b;
            if (event.length === 0) {
                throw (0,_helpers_utils_error_index_js__WEBPACK_IMPORTED_MODULE_1__/* .error */ .z3)('Need event name');
            }
            if (store.indexOf(event, namespace, callback) === false) {
                const block = {
                    event,
                    originalCallback: callback,
                    syntheticCallback
                };
                store.set(event, namespace, block, options === null || options === void 0 ? void 0 : options.top);
                if (isDOMElement(subject)) {
                    const eOpts = _constants_js__WEBPACK_IMPORTED_MODULE_0__.PASSIVE_EVENTS.has(event) ? {
                        passive: true,
                        capture: (_a = options === null || options === void 0 ? void 0 : options.capture) !== null && _a !== void 0 ? _a : false
                    } : (_b = options === null || options === void 0 ? void 0 : options.capture) !== null && _b !== void 0 ? _b : false;
                    syntheticCallback.options = eOpts;
                    subject.addEventListener(event, syntheticCallback, eOpts);
                    this.__memoryDOMSubjectToHandler(subject, syntheticCallback);
                }
            }
        });
        return this;
    }
    __memoryDOMSubjectToHandler(subject, syntheticCallback) {
        const callbackStore = this.__domEventsMap.get(subject) || new Set();
        callbackStore.add(syntheticCallback);
        this.__domEventsMap.set(subject, callbackStore);
    }
    __unmemoryDOMSubjectToHandler(subject, syntheticCallback) {
        const m = this.__domEventsMap;
        const callbackStore = m.get(subject) || new Set();
        callbackStore.delete(syntheticCallback);
        if (callbackStore.size) {
            m.set(subject, callbackStore);
        } else {
            m.delete(subject);
        }
    }
    one(eventsOrSubjects, callbackOrEvents, optionsOrCallback, opts) {
        let subjects;
        let events;
        let callback;
        let options;
        if ((0,_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__/* .isString */ .K)(eventsOrSubjects) || (0,_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__/* .isStringArray */ .B)(eventsOrSubjects)) {
            subjects = this;
            events = eventsOrSubjects;
            callback = callbackOrEvents;
            options = optionsOrCallback;
        } else {
            subjects = eventsOrSubjects;
            events = callbackOrEvents;
            callback = optionsOrCallback;
            options = opts;
        }
        const newCallback = (...args)=>{
            this.off(subjects, events, newCallback);
            return callback(...args);
        };
        this.on(subjects, events, newCallback, options);
        return this;
    }
    off(eventsOrSubjects, callbackOrEvents, handler) {
        let subjects;
        let events;
        let callback;
        if ((0,_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__/* .isString */ .K)(eventsOrSubjects) || (0,_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__/* .isStringArray */ .B)(eventsOrSubjects)) {
            subjects = this;
            events = eventsOrSubjects;
            callback = callbackOrEvents;
        } else {
            subjects = eventsOrSubjects;
            events = callbackOrEvents;
            callback = handler;
        }
        if ((0,_helpers_checker_is_array_js__WEBPACK_IMPORTED_MODULE_6__/* .isArray */ .c)(subjects)) {
            subjects.forEach((subj)=>{
                this.off(subj, events, callback);
            });
            return this;
        }
        const subject = subjects;
        const store = this.__getStore(subject);
        if (!((0,_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__/* .isString */ .K)(events) || (0,_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__/* .isStringArray */ .B)(events)) || events.length === 0) {
            store.namespaces().forEach((namespace)=>{
                this.off(subject, '.' + namespace);
            });
            this.__removeStoreFromSubject(subject);
            return this;
        }
        const removeEventListener = (block)=>{
            var _a;
            if (isDOMElement(subject)) {
                subject.removeEventListener(block.event, block.syntheticCallback, (_a = block.syntheticCallback.options) !== null && _a !== void 0 ? _a : false);
                this.__unmemoryDOMSubjectToHandler(subject, block.syntheticCallback);
            }
        }, removeCallbackFromNameSpace = (event, namespace)=>{
            if (event === '') {
                store.events(namespace).forEach((eventName)=>{
                    if (eventName !== '') {
                        removeCallbackFromNameSpace(eventName, namespace);
                    }
                });
                return;
            }
            const blocks = store.get(event, namespace);
            if (!blocks || !blocks.length) {
                return;
            }
            if (!(0,_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_5__/* .isFunction */ .T)(callback)) {
                blocks.forEach(removeEventListener);
                blocks.length = 0;
                store.clearEvents(namespace, event);
            } else {
                const index = store.indexOf(event, namespace, callback);
                if (index !== false) {
                    removeEventListener(blocks[index]);
                    blocks.splice(index, 1);
                    if (!blocks.length) {
                        store.clearEvents(namespace, event);
                    }
                }
            }
        };
        this.__eachEvent(events, (event, namespace)=>{
            if (namespace === _store_js__WEBPACK_IMPORTED_MODULE_2__/* .defaultNameSpace */ .X) {
                store.namespaces().forEach((namespace)=>{
                    removeCallbackFromNameSpace(event, namespace);
                });
            } else {
                removeCallbackFromNameSpace(event, namespace);
            }
        });
        if (store.isEmpty()) {
            this.__removeStoreFromSubject(subject);
        }
        return this;
    }
    stopPropagation(subjectOrEvents, eventsList) {
        const subject = (0,_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__/* .isString */ .K)(subjectOrEvents) ? this : subjectOrEvents;
        const events = (0,_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__/* .isString */ .K)(subjectOrEvents) ? subjectOrEvents : eventsList;
        if (typeof events !== 'string') {
            throw (0,_helpers_utils_error_index_js__WEBPACK_IMPORTED_MODULE_1__/* .error */ .z3)('Need event names');
        }
        const store = this.__getStore(subject);
        this.__eachEvent(events, (event, namespace)=>{
            const blocks = store.get(event, namespace);
            if (blocks) {
                this.__stopped.push(blocks);
            }
            if (namespace === _store_js__WEBPACK_IMPORTED_MODULE_2__/* .defaultNameSpace */ .X) {
                store.namespaces(true).forEach((ns)=>this.stopPropagation(subject, event + '.' + ns));
            }
        });
    }
    __removeStop(currentBlocks) {
        if (currentBlocks) {
            const index = this.__stopped.indexOf(currentBlocks);
            index !== -1 && this.__stopped.splice(0, index + 1);
        }
    }
    __isStopped(currentBlocks) {
        return currentBlocks !== undefined && this.__stopped.indexOf(currentBlocks) !== -1;
    }
    fire(subjectOrEvents, eventsList, ...args) {
        let result, result_value;
        const subject = (0,_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__/* .isString */ .K)(subjectOrEvents) ? this : subjectOrEvents;
        const events = (0,_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__/* .isString */ .K)(subjectOrEvents) ? subjectOrEvents : eventsList;
        const argumentsList = (0,_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__/* .isString */ .K)(subjectOrEvents) ? [
            eventsList,
            ...args
        ] : args;
        if (!isDOMElement(subject) && !(0,_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__/* .isString */ .K)(events)) {
            throw (0,_helpers_utils_error_index_js__WEBPACK_IMPORTED_MODULE_1__/* .error */ .z3)('Need events names');
        }
        const store = this.__getStore(subject);
        if (!(0,_helpers_checker_is_string_js__WEBPACK_IMPORTED_MODULE_4__/* .isString */ .K)(events) && isDOMElement(subject)) {
            this.__triggerNativeEvent(subject, eventsList);
        } else {
            this.__eachEvent(events, (event, namespace)=>{
                if (isDOMElement(subject)) {
                    this.__triggerNativeEvent(subject, event);
                } else {
                    const blocks = store.get(event, namespace);
                    if (blocks) {
                        try {
                            [
                                ...blocks
                            ].every((block)=>{
                                if (this.__isStopped(blocks)) {
                                    return false;
                                }
                                this.currents.push(event);
                                result_value = block.syntheticCallback.call(subject, event, ...argumentsList);
                                this.currents.pop();
                                if (result_value !== undefined) {
                                    result = result_value;
                                }
                                return true;
                            });
                        } finally{
                            this.__removeStop(blocks);
                        }
                    }
                    if (namespace === _store_js__WEBPACK_IMPORTED_MODULE_2__/* .defaultNameSpace */ .X && !isDOMElement(subject)) {
                        store.namespaces().filter((ns)=>ns !== namespace).forEach((ns)=>{
                            const result_second = this.fire.apply(this, [
                                subject,
                                event + '.' + ns,
                                ...argumentsList
                            ]);
                            if (result_second !== undefined) {
                                result = result_second;
                            }
                        });
                    }
                }
            });
        }
        return result;
    }
    destruct() {
        if (this.__isDestructed) {
            return;
        }
        this.__isDestructed = true;
        this.__domEventsMap.forEach((set, elm)=>{
            this.off(elm);
        });
        this.__domEventsMap.clear();
        this.__mutedEvents.clear();
        this.currents.length = 0;
        this.__stopped.length = 0;
        this.off(this);
        this.__getStore(this).clear();
        this.__removeStoreFromSubject(this);
    }
    constructor(doc){
        this.__domEventsMap = new Map();
        this.__mutedEvents = new Set();
        this.__key = '__JoditEventEmitterNamespaces';
        this.__doc = _constants_js__WEBPACK_IMPORTED_MODULE_0__.globalDocument;
        this.__prepareEvent = (e)=>{
            if (e.cancelBubble) {
                return;
            }
            // for Shadow Dom
            if (e.composed && (0,_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_5__/* .isFunction */ .T)(e.composedPath) && e.composedPath()[0]) {
                Object.defineProperty(e, 'target', {
                    value: e.composedPath()[0],
                    configurable: true,
                    enumerable: true
                });
            }
            if (e.type.match(/^touch/) && e.changedTouches && e.changedTouches.length) {
                [
                    'clientX',
                    'clientY',
                    'pageX',
                    'pageY'
                ].forEach((key)=>{
                    Object.defineProperty(e, key, {
                        value: e.changedTouches[0][key],
                        configurable: true,
                        enumerable: true
                    });
                });
            }
            if (!e.originalEvent) {
                e.originalEvent = e;
            }
            if (e.type === 'paste' && e.clipboardData === undefined && this.__doc.defaultView.clipboardData) {
                Object.defineProperty(e, 'clipboardData', {
                    get: ()=>{
                        return this.__doc.defaultView.clipboardData;
                    },
                    configurable: true,
                    enumerable: true
                });
            }
        };
        this.currents = [];
        this.__stopped = [];
        this.__isDestructed = false;
        if (doc) {
            this.__doc = doc;
        }
        this.__key += new Date().getTime();
    }
}
function isDOMElement(subject) {
    return (0,_helpers_checker_is_function_js__WEBPACK_IMPORTED_MODULE_5__/* .isFunction */ .T)(subject.addEventListener);
}


/***/ }),

/***/ 98370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    Spellcheck: 'בדיקת איות'
});


/***/ }),

/***/ 98527:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1025 1369v167h-248l-159-252-24-42q-8-9-11-21h-3l-9 21q-10 20-25 44l-155 250h-258v-167h128l197-291-185-272h-137v-168h276l139 228q2 4 23 42 8 9 11 21h3q3-9 11-21l25-42 140-228h257v168h-125l-184 267 204 296h109zm637-679v206h-514l-3-27q-4-28-4-46 0-64 26-117t65-86.5 84-65 84-54.5 65-54 26-64q0-38-29.5-62.5t-70.5-24.5q-51 0-97 39-14 11-36 38l-105-92q26-37 63-66 83-65 188-65 110 0 178 59.5t68 158.5q0 56-24.5 103t-62 76.5-81.5 58.5-82 50.5-65.5 51.5-30.5 63h232v-80h126z\"/> </svg> ");


/***/ }),

/***/ 98582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Y: function() { return /* binding */ Response; }
/* harmony export */ });
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ class Response {
    get url() {
        return this.request.url;
    }
    async json() {
        return JSON.parse(this.body);
    }
    text() {
        return Promise.resolve(this.body);
    }
    async blob() {
        return this.body;
    }
    constructor(request, status, statusText, body){
        this.request = request;
        this.status = status;
        this.statusText = statusText;
        this.body = body;
    }
}


/***/ }),

/***/ 98689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);

/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /* harmony default export */ __webpack_exports__["default"] = ({
    'Line height': 'Lijnhoogte'
});


/***/ }),

/***/ 99085:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6441);
/* harmony import */ var _spellcheck_svg_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10937);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 


_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.spellcheck = false;
_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_0__/* .Icon */ .I.set('spellcheck', _spellcheck_svg_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A);
_config_js__WEBPACK_IMPORTED_MODULE_1__/* .Config */ .T.prototype.controls.spellcheck = {
    isActive (e) {
        return e.o.spellcheck;
    },
    icon: _spellcheck_svg_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A,
    name: 'spellcheck',
    command: 'toggleSpellcheck',
    tooltip: 'Spellcheck'
};


/***/ }),

/***/ 99649:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6441);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ /**
 * @module plugins/stat
 */ 
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.showCharsCounter = true;
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.countHTMLChars = false;
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.countTextSpaces = false;
_config_js__WEBPACK_IMPORTED_MODULE_0__/* .Config */ .T.prototype.showWordsCounter = true;


/***/ }),

/***/ 99762:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__.A = ("<svg xmlns='http://www.w3.org/2000/svg' viewBox=\"0 0 1792 1792\"> <path d=\"M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h896q26 0 45 19t19 45zm256-384v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-640q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h640q26 0 45 19t19 45z\"/> </svg> ");


/***/ }),

/***/ 99823:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _core_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82758);
/* harmony import */ var _core_ui_icon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12153);
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6441);
/* harmony import */ var _icons_fullsize_svg_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6950);
/* harmony import */ var _icons_shrink_svg_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28911);
/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */ 




_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.fullsize = false;
_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.globalFullSize = true;
_core_ui_icon_js__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .I.set('fullsize', _icons_fullsize_svg_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A).set('shrink', _icons_shrink_svg_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A);
_config_js__WEBPACK_IMPORTED_MODULE_2__/* .Config */ .T.prototype.controls.fullsize = {
    exec: (editor)=>{
        editor.toggleFullSize();
    },
    update (editor, button) {
        const mode = editor.isFullSize ? 'shrink' : 'fullsize';
        button.state.activated = editor.isFullSize;
        if (editor.o.textIcons) {
            button.state.text = mode;
        } else {
            button.state.icon.name = mode;
        }
    },
    tooltip: 'Open in fullsize',
    mode: _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_SOURCE + _core_constants_js__WEBPACK_IMPORTED_MODULE_0__.MODE_WYSIWYG
};


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	!function() {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = function(result, chunkIds, fn, priority) {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var chunkIds = deferred[i][0];
/******/ 				var fn = deferred[i][1];
/******/ 				var priority = deferred[i][2];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every(function(key) { return __webpack_require__.O[key](chunkIds[j]); })) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	!function() {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			521: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = function(chunkId) { return installedChunks[chunkId] === 0; };
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
/******/ 			var chunkIds = data[0];
/******/ 			var moreModules = data[1];
/******/ 			var runtime = data[2];
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkjodit_pro"] = self["webpackChunkjodit_pro"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Jodit: function() { return /* reexport safe */ _jodit_pro__WEBPACK_IMPORTED_MODULE_1__.A; }
/* harmony export */ });
/* harmony import */ var _plugins_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1596);
/* harmony import */ var _jodit_pro__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34013);
/*!
 * Jodit Editor PRO (https://xdsoft.net/jodit/)
 * See LICENSE.md in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net/jodit/pro/
 */



// Disable CopyRight
function poweredByJodit() { }
_jodit_pro__WEBPACK_IMPORTED_MODULE_1__/* .JoditPro */ .A.plugins.add('poweredByJodit', poweredByJodit);

__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	return __webpack_exports__;
/******/ })()
;
});